
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea1b3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea1b3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $fO90s.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $8coUR({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $8coUR({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $8coUR({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $8coUR({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $8coUR({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $8coUR({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $8coUR({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $8coUR({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $8coUR({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $8coUR({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $8coUR({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $8coUR({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $fO90s.unstable_runWithPriority, Of = $fO90s.unstable_scheduleCallback, Pf = $fO90s.unstable_cancelCallback, Qf = $fO90s.unstable_shouldYield, Rf = $fO90s.unstable_requestPaint, Sf = $fO90s.unstable_now, Tf = $fO90s.unstable_getCurrentPriorityLevel, Uf = $fO90s.unstable_ImmediatePriority, Vf = $fO90s.unstable_UserBlockingPriority, Wf = $fO90s.unstable_NormalPriority, Xf = $fO90s.unstable_LowPriority, Yf = $fO90s.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $acw62.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("3OBZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("kjyEk"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("dOqqi", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("dCBbD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("WS9F7", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRegister("6gSsW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("33Dov", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("laOt8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f6a1ae3267718cab$export$2e2bcd8739ae039);
function $f6a1ae3267718cab$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("7we3r", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance($lk5EI(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($blSvA);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (parcelRequire("dIGMp"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));

$57966c7e0affc4cb$var$axios.VERSION = (parcelRequire("35BUy")).version;

$57966c7e0affc4cb$var$axios.toFormData = (parcelRequire("jOwpo"));

// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (parcelRequire("6HVMZ"));
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
"use strict";

var $jJbMR = parcelRequire("jJbMR");
// utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $c319b2c832c2914a$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $c319b2c832c2914a$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $c319b2c832c2914a$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$toString.call(thing) === pattern || $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $c319b2c832c2914a$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $c319b2c832c2914a$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $c319b2c832c2914a$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($c319b2c832c2914a$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $c319b2c832c2914a$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList
};

});
parcelRegister("jJbMR", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $bv3QM = parcelRequire("bv3QM");
var $a93486d2307f31c3$var$validators = $bv3QM.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $bv3QM.assertOptions(transitional, {
        silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
        forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
        clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $dlZEJ,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $dlZEJ(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    var fullPath = $7GD7a(config.baseURL, config.url);
    return $cbIsf(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($lk5EI(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($gKvUL.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + "=" + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $dIGMp();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $blSvA.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $blSvA;
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("blSvA", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");
var $843bf0209bc94df8$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $843bf0209bc94df8$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $843bf0209bc94df8$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ($gKvUL.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $gKvUL.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $843bf0209bc94df8$var$defaults = {
    transitional: $6YCMk,
    adapter: $843bf0209bc94df8$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, "Accept");
            $kiL6T(headers, "Content-Type");
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $843bf0209bc94df8$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = $gKvUL.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = $gKvUL.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return $jOwpo(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                $843bf0209bc94df8$var$setContentTypeIfUnset(headers, "application/json");
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $gKvUL.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $6HVMZ.from(e, $6HVMZ.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("5vpyF"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$gKvUL.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $843bf0209bc94df8$var$defaults.headers[method] = $gKvUL.merge($843bf0209bc94df8$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $843bf0209bc94df8$var$defaults;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("kiL6T", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("6HVMZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$gKvUL.inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
var $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    $gKvUL.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $4e2395edb77acf3a$var$AxiosError;

});

parcelRegister("6YCMk", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("jOwpo", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $e6cbd383b18c9625$var$toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return "";
        if ($gKvUL.isDate(value)) return value.toISOString();
        if ($gKvUL.isArrayBuffer(value) || $gKvUL.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if ($gKvUL.isPlainObject(data) || $gKvUL.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            $gKvUL.forEach(data, function each(value, key) {
                if ($gKvUL.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if ($gKvUL.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($gKvUL.endsWith(key, "[]") && (arr = $gKvUL.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$gKvUL.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("at5cb", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $32jg5 = parcelRequire("32jg5");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($gKvUL.isFormData(requestData) && $gKvUL.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $6HVMZ("Request aborted", $6HVMZ.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $6HVMZ("Network Error", $6HVMZ.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $6YCMk;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $6HVMZ(timeoutErrorMessage, transitional.clarifyTimeoutError ? $6HVMZ.ETIMEDOUT : $6HVMZ.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $dIGMp() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $32jg5(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new $6HVMZ("Unsupported protocol " + protocol + ":", $6HVMZ.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
"use strict";

var $6HVMZ = parcelRequire("6HVMZ");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $6HVMZ("Request failed with status code " + response.status, [
        $6HVMZ.ERR_BAD_REQUEST,
        $6HVMZ.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("8JRzs", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push("path=" + path);
            if ($gKvUL.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7GD7a", function(module, exports) {
"use strict";

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("dIGMp", function(module, exports) {
"use strict";

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $9fd0919e266b4fda$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $6HVMZ.call(this, message == null ? "canceled" : message, $6HVMZ.ERR_CANCELED);
    this.name = "CanceledError";
}
$gKvUL.inherits($9fd0919e266b4fda$var$CanceledError, $6HVMZ, {
    __CANCEL__: true
});
module.exports = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("32jg5", function(module, exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

});


parcelRegister("5vpyF", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRegister("7L4QX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("lk5EI", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $gKvUL.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $gKvUL.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("bv3QM", function(module, exports) {
"use strict";

var $35BUy = parcelRequire("35BUy");
var $85f59389941e7907$require$VERSION = $35BUy.version;

var $6HVMZ = parcelRequire("6HVMZ");
var $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $85f59389941e7907$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $6HVMZ(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $6HVMZ.ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $6HVMZ("options must be an object", $6HVMZ.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $6HVMZ("option " + opt + " must be " + result, $6HVMZ.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $6HVMZ("Unknown option " + opt, $6HVMZ.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("35BUy", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRegister("lAKPy", function(module, exports) {
"use strict";

var $dIGMp = parcelRequire("dIGMp");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $dIGMp(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $fb81495929d8a282$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $fb81495929d8a282$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dxy9O", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $gKvUL.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !(({
        __proto__: null
    }) instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("2RJ2t", function(module, exports) {

$parcel$export(module.exports, "epsilon", () => epsilon);
$parcel$export(module.exports, "epsilon2", () => epsilon2);
$parcel$export(module.exports, "beaches", () => beaches);
$parcel$export(module.exports, "cells", () => cells);
$parcel$export(module.exports, "circles", () => circles);
$parcel$export(module.exports, "edges", () => edges);
$parcel$export(module.exports, "default", () => Diagram);

var $b1XfE = parcelRequire("b1XfE");

var $j61Qm = parcelRequire("j61Qm");

var $7AZxF = parcelRequire("7AZxF");

var $gzJsf = parcelRequire("gzJsf");

var $bo307 = parcelRequire("bo307");
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;
function triangleArea(a, b, c) {
    return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}
function lexicographic(a, b) {
    return b[1] - a[1] || b[0] - a[0];
}
function Diagram(sites, extent) {
    var site = sites.sort(lexicographic).pop(), x, y, circle;
    edges = [];
    cells = new Array(sites.length);
    beaches = new (0, $bo307.default);
    circles = new (0, $bo307.default);
    while(true){
        circle = (0, $7AZxF.firstCircle);
        if (site && (!circle || site[1] < circle.y || site[1] === circle.y && site[0] < circle.x)) {
            if (site[0] !== x || site[1] !== y) {
                (0, $b1XfE.addBeach)(site);
                x = site[0], y = site[1];
            }
            site = sites.pop();
        } else if (circle) (0, $b1XfE.removeBeach)(circle.arc);
        else break;
    }
    (0, $j61Qm.sortCellHalfedges)();
    if (extent) {
        var x0 = +extent[0][0], y0 = +extent[0][1], x1 = +extent[1][0], y1 = +extent[1][1];
        (0, $gzJsf.clipEdges)(x0, y0, x1, y1);
        (0, $j61Qm.clipCells)(x0, y0, x1, y1);
    }
    this.edges = edges;
    this.cells = cells;
    beaches = circles = edges = cells = null;
}
Diagram.prototype = {
    constructor: Diagram,
    polygons: function() {
        var edges = this.edges;
        return this.cells.map(function(cell) {
            var polygon = cell.halfedges.map(function(i) {
                return (0, $j61Qm.cellHalfedgeStart)(cell, edges[i]);
            });
            polygon.data = cell.site.data;
            return polygon;
        });
    },
    triangles: function() {
        var triangles = [], edges = this.edges;
        this.cells.forEach(function(cell, i) {
            if (!(m = (halfedges = cell.halfedges).length)) return;
            var site = cell.site, halfedges, j = -1, m, s0, e1 = edges[halfedges[m - 1]], s1 = e1.left === site ? e1.right : e1.left;
            while(++j < m){
                s0 = s1;
                e1 = edges[halfedges[j]];
                s1 = e1.left === site ? e1.right : e1.left;
                if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) triangles.push([
                    site.data,
                    s0.data,
                    s1.data
                ]);
            }
        });
        return triangles;
    },
    links: function() {
        return this.edges.filter(function(edge) {
            return edge.right;
        }).map(function(edge) {
            return {
                source: edge.left.data,
                target: edge.right.data
            };
        });
    },
    find: function(x, y, radius) {
        var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
        // Use the previously-found cell, or start with an arbitrary one.
        while(!(cell = that.cells[i1]))if (++i1 >= n) return null;
        var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
        // Traverse the half-edges to find a closer cell, if any.
        do {
            cell = that.cells[i0 = i1], i1 = null;
            cell.halfedges.forEach(function(e) {
                var edge = that.edges[e], v = edge.left;
                if ((v === cell.site || !v) && !(v = edge.right)) return;
                var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
                if (v2 < d2) d2 = v2, i1 = v.index;
            });
        }while (i1 !== null);
        that._found = i0;
        return radius == null || d2 <= radius * radius ? cell.site : null;
    }
};

});
parcelRegister("b1XfE", function(module, exports) {

$parcel$export(module.exports, "removeBeach", () => $807dbfd47a592bc5$export$25be321a9b2d3c3c);
$parcel$export(module.exports, "addBeach", () => $807dbfd47a592bc5$export$fec167a219592370);

var $bo307 = parcelRequire("bo307");

var $j61Qm = parcelRequire("j61Qm");

var $7AZxF = parcelRequire("7AZxF");

var $gzJsf = parcelRequire("gzJsf");

var $2RJ2t = parcelRequire("2RJ2t");
var $807dbfd47a592bc5$var$beachPool = [];
function $807dbfd47a592bc5$var$Beach() {
    (0, $bo307.RedBlackNode)(this);
    this.edge = this.site = this.circle = null;
}
function $807dbfd47a592bc5$var$createBeach(site) {
    var beach = $807dbfd47a592bc5$var$beachPool.pop() || new $807dbfd47a592bc5$var$Beach;
    beach.site = site;
    return beach;
}
function $807dbfd47a592bc5$var$detachBeach(beach) {
    (0, $7AZxF.detachCircle)(beach);
    (0, $2RJ2t.beaches).remove(beach);
    $807dbfd47a592bc5$var$beachPool.push(beach);
    (0, $bo307.RedBlackNode)(beach);
}
function $807dbfd47a592bc5$export$25be321a9b2d3c3c(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = [
        x,
        y
    ], previous = beach.P, next = beach.N, disappearing = [
        beach
    ];
    $807dbfd47a592bc5$var$detachBeach(beach);
    var lArc = previous;
    while(lArc.circle && Math.abs(x - lArc.circle.x) < (0, $2RJ2t.epsilon) && Math.abs(y - lArc.circle.cy) < (0, $2RJ2t.epsilon)){
        previous = lArc.P;
        disappearing.unshift(lArc);
        $807dbfd47a592bc5$var$detachBeach(lArc);
        lArc = previous;
    }
    disappearing.unshift(lArc);
    (0, $7AZxF.detachCircle)(lArc);
    var rArc = next;
    while(rArc.circle && Math.abs(x - rArc.circle.x) < (0, $2RJ2t.epsilon) && Math.abs(y - rArc.circle.cy) < (0, $2RJ2t.epsilon)){
        next = rArc.N;
        disappearing.push(rArc);
        $807dbfd47a592bc5$var$detachBeach(rArc);
        rArc = next;
    }
    disappearing.push(rArc);
    (0, $7AZxF.detachCircle)(rArc);
    var nArcs = disappearing.length, iArc;
    for(iArc = 1; iArc < nArcs; ++iArc){
        rArc = disappearing[iArc];
        lArc = disappearing[iArc - 1];
        (0, $gzJsf.setEdgeEnd)(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = (0, $gzJsf.createEdge)(lArc.site, rArc.site, null, vertex);
    (0, $7AZxF.attachCircle)(lArc);
    (0, $7AZxF.attachCircle)(rArc);
}
function $807dbfd47a592bc5$export$fec167a219592370(site) {
    var x = site[0], directrix = site[1], lArc, rArc, dxl, dxr, node = (0, $2RJ2t.beaches)._;
    while(node){
        dxl = $807dbfd47a592bc5$var$leftBreakPoint(node, directrix) - x;
        if (dxl > (0, $2RJ2t.epsilon)) node = node.L;
        else {
            dxr = x - $807dbfd47a592bc5$var$rightBreakPoint(node, directrix);
            if (dxr > (0, $2RJ2t.epsilon)) {
                if (!node.R) {
                    lArc = node;
                    break;
                }
                node = node.R;
            } else {
                if (dxl > -(0, $2RJ2t.epsilon)) {
                    lArc = node.P;
                    rArc = node;
                } else if (dxr > -(0, $2RJ2t.epsilon)) {
                    lArc = node;
                    rArc = node.N;
                } else lArc = rArc = node;
                break;
            }
        }
    }
    (0, $j61Qm.createCell)(site);
    var newArc = $807dbfd47a592bc5$var$createBeach(site);
    (0, $2RJ2t.beaches).insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
        (0, $7AZxF.detachCircle)(lArc);
        rArc = $807dbfd47a592bc5$var$createBeach(lArc.site);
        (0, $2RJ2t.beaches).insert(newArc, rArc);
        newArc.edge = rArc.edge = (0, $gzJsf.createEdge)(lArc.site, newArc.site);
        (0, $7AZxF.attachCircle)(lArc);
        (0, $7AZxF.attachCircle)(rArc);
        return;
    }
    if (!rArc) {
        newArc.edge = (0, $gzJsf.createEdge)(lArc.site, newArc.site);
        return;
    }
    // else lArc !== rArc
    (0, $7AZxF.detachCircle)(lArc);
    (0, $7AZxF.detachCircle)(rArc);
    var lSite = lArc.site, ax = lSite[0], ay = lSite[1], bx = site[0] - ax, by = site[1] - ay, rSite = rArc.site, cx = rSite[0] - ax, cy = rSite[1] - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = [
        (cy * hb - by * hc) / d + ax,
        (bx * hc - cx * hb) / d + ay
    ];
    (0, $gzJsf.setEdgeEnd)(rArc.edge, lSite, rSite, vertex);
    newArc.edge = (0, $gzJsf.createEdge)(lSite, site, null, vertex);
    rArc.edge = (0, $gzJsf.createEdge)(site, rSite, null, vertex);
    (0, $7AZxF.attachCircle)(lArc);
    (0, $7AZxF.attachCircle)(rArc);
}
function $807dbfd47a592bc5$var$leftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site[0], rfocy = site[1], pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site[0], lfocy = site[1], plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
}
function $807dbfd47a592bc5$var$rightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return $807dbfd47a592bc5$var$leftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site[1] === directrix ? site[0] : Infinity;
}

});
parcelRegister("bo307", function(module, exports) {

$parcel$export(module.exports, "RedBlackNode", () => $84a4437e8ef0514b$export$5072552a5e64b90a);
$parcel$export(module.exports, "default", () => $84a4437e8ef0514b$export$2e2bcd8739ae039);
function $84a4437e8ef0514b$var$RedBlackTree() {
    this._ = null; // root node
}
function $84a4437e8ef0514b$export$5072552a5e64b90a(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null; // next node
}
$84a4437e8ef0514b$var$RedBlackTree.prototype = {
    constructor: $84a4437e8ef0514b$var$RedBlackTree,
    insert: function(after, node) {
        var parent, grandpa, uncle;
        if (after) {
            node.P = after;
            node.N = after.N;
            if (after.N) after.N.P = node;
            after.N = node;
            if (after.R) {
                after = after.R;
                while(after.L)after = after.L;
                after.L = node;
            } else after.R = node;
            parent = after;
        } else if (this._) {
            after = $84a4437e8ef0514b$var$RedBlackFirst(this._);
            node.P = null;
            node.N = after;
            after.P = after.L = node;
            parent = after;
        } else {
            node.P = node.N = null;
            this._ = node;
            parent = null;
        }
        node.L = node.R = null;
        node.U = parent;
        node.C = true;
        after = node;
        while(parent && parent.C){
            grandpa = parent.U;
            if (parent === grandpa.L) {
                uncle = grandpa.R;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.R) {
                        $84a4437e8ef0514b$var$RedBlackRotateLeft(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $84a4437e8ef0514b$var$RedBlackRotateRight(this, grandpa);
                }
            } else {
                uncle = grandpa.L;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.L) {
                        $84a4437e8ef0514b$var$RedBlackRotateRight(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $84a4437e8ef0514b$var$RedBlackRotateLeft(this, grandpa);
                }
            }
            parent = after.U;
        }
        this._.C = false;
    },
    remove: function(node) {
        if (node.N) node.N.P = node.P;
        if (node.P) node.P.N = node.N;
        node.N = node.P = null;
        var parent = node.U, sibling, left = node.L, right = node.R, next, red;
        if (!left) next = right;
        else if (!right) next = left;
        else next = $84a4437e8ef0514b$var$RedBlackFirst(right);
        if (parent) {
            if (parent.L === node) parent.L = next;
            else parent.R = next;
        } else this._ = next;
        if (left && right) {
            red = next.C;
            next.C = node.C;
            next.L = left;
            left.U = next;
            if (next !== right) {
                parent = next.U;
                next.U = node.U;
                node = next.R;
                parent.L = node;
                next.R = right;
                right.U = next;
            } else {
                next.U = parent;
                parent = next;
                node = next.R;
            }
        } else {
            red = node.C;
            node = next;
        }
        if (node) node.U = parent;
        if (red) return;
        if (node && node.C) {
            node.C = false;
            return;
        }
        do {
            if (node === this._) break;
            if (node === parent.L) {
                sibling = parent.R;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $84a4437e8ef0514b$var$RedBlackRotateLeft(this, parent);
                    sibling = parent.R;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.R || !sibling.R.C) {
                        sibling.L.C = false;
                        sibling.C = true;
                        $84a4437e8ef0514b$var$RedBlackRotateRight(this, sibling);
                        sibling = parent.R;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.R.C = false;
                    $84a4437e8ef0514b$var$RedBlackRotateLeft(this, parent);
                    node = this._;
                    break;
                }
            } else {
                sibling = parent.L;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $84a4437e8ef0514b$var$RedBlackRotateRight(this, parent);
                    sibling = parent.L;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.L || !sibling.L.C) {
                        sibling.R.C = false;
                        sibling.C = true;
                        $84a4437e8ef0514b$var$RedBlackRotateLeft(this, sibling);
                        sibling = parent.L;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.L.C = false;
                    $84a4437e8ef0514b$var$RedBlackRotateRight(this, parent);
                    node = this._;
                    break;
                }
            }
            sibling.C = true;
            node = parent;
            parent = parent.U;
        }while (!node.C);
        if (node) node.C = false;
    }
};
function $84a4437e8ef0514b$var$RedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
}
function $84a4437e8ef0514b$var$RedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
}
function $84a4437e8ef0514b$var$RedBlackFirst(node) {
    while(node.L)node = node.L;
    return node;
}
var $84a4437e8ef0514b$export$2e2bcd8739ae039 = $84a4437e8ef0514b$var$RedBlackTree;

});

parcelRegister("j61Qm", function(module, exports) {

$parcel$export(module.exports, "createCell", () => $de7001ec5c970277$export$3cb21b6b1233300e);
$parcel$export(module.exports, "cellHalfedgeStart", () => $de7001ec5c970277$export$67c16aa967774be);
$parcel$export(module.exports, "sortCellHalfedges", () => $de7001ec5c970277$export$41888d88cbc31210);
$parcel$export(module.exports, "clipCells", () => $de7001ec5c970277$export$cdcebd68073bc3f);

var $gzJsf = parcelRequire("gzJsf");

var $2RJ2t = parcelRequire("2RJ2t");
function $de7001ec5c970277$export$3cb21b6b1233300e(site) {
    return (0, $2RJ2t.cells)[site.index] = {
        site: site,
        halfedges: []
    };
}
function $de7001ec5c970277$var$cellHalfedgeAngle(cell, edge) {
    var site = cell.site, va = edge.left, vb = edge.right;
    if (site === vb) vb = va, va = site;
    if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
    if (site === va) va = edge[1], vb = edge[0];
    else va = edge[0], vb = edge[1];
    return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}
function $de7001ec5c970277$export$67c16aa967774be(cell, edge) {
    return edge[+(edge.left !== cell.site)];
}
function $de7001ec5c970277$export$bf8e581ba65a00a5(cell, edge) {
    return edge[+(edge.left === cell.site)];
}
function $de7001ec5c970277$export$41888d88cbc31210() {
    for(var i = 0, n = (0, $2RJ2t.cells).length, cell, halfedges, j, m; i < n; ++i)if ((cell = (0, $2RJ2t.cells)[i]) && (m = (halfedges = cell.halfedges).length)) {
        var index = new Array(m), array = new Array(m);
        for(j = 0; j < m; ++j)index[j] = j, array[j] = $de7001ec5c970277$var$cellHalfedgeAngle(cell, (0, $2RJ2t.edges)[halfedges[j]]);
        index.sort(function(i, j) {
            return array[j] - array[i];
        });
        for(j = 0; j < m; ++j)array[j] = halfedges[index[j]];
        for(j = 0; j < m; ++j)halfedges[j] = array[j];
    }
}
function $de7001ec5c970277$export$cdcebd68073bc3f(x0, y0, x1, y1) {
    var nCells = (0, $2RJ2t.cells).length, iCell, cell, site, iHalfedge, halfedges, nHalfedges, start, startX, startY, end, endX, endY, cover = true;
    for(iCell = 0; iCell < nCells; ++iCell)if (cell = (0, $2RJ2t.cells)[iCell]) {
        site = cell.site;
        halfedges = cell.halfedges;
        iHalfedge = halfedges.length;
        // Remove any dangling clipped edges.
        while(iHalfedge--)if (!(0, $2RJ2t.edges)[halfedges[iHalfedge]]) halfedges.splice(iHalfedge, 1);
        // Insert any border edges as necessary.
        iHalfedge = 0, nHalfedges = halfedges.length;
        while(iHalfedge < nHalfedges){
            end = $de7001ec5c970277$export$bf8e581ba65a00a5(cell, (0, $2RJ2t.edges)[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
            start = $de7001ec5c970277$export$67c16aa967774be(cell, (0, $2RJ2t.edges)[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
            if (Math.abs(endX - startX) > (0, $2RJ2t.epsilon) || Math.abs(endY - startY) > (0, $2RJ2t.epsilon)) {
                halfedges.splice(iHalfedge, 0, (0, $2RJ2t.edges).push((0, $gzJsf.createBorderEdge)(site, end, Math.abs(endX - x0) < (0, $2RJ2t.epsilon) && y1 - endY > (0, $2RJ2t.epsilon) ? [
                    x0,
                    Math.abs(startX - x0) < (0, $2RJ2t.epsilon) ? startY : y1
                ] : Math.abs(endY - y1) < (0, $2RJ2t.epsilon) && x1 - endX > (0, $2RJ2t.epsilon) ? [
                    Math.abs(startY - y1) < (0, $2RJ2t.epsilon) ? startX : x1,
                    y1
                ] : Math.abs(endX - x1) < (0, $2RJ2t.epsilon) && endY - y0 > (0, $2RJ2t.epsilon) ? [
                    x1,
                    Math.abs(startX - x1) < (0, $2RJ2t.epsilon) ? startY : y0
                ] : Math.abs(endY - y0) < (0, $2RJ2t.epsilon) && endX - x0 > (0, $2RJ2t.epsilon) ? [
                    Math.abs(startY - y0) < (0, $2RJ2t.epsilon) ? startX : x0,
                    y0
                ] : null)) - 1);
                ++nHalfedges;
            }
        }
        if (nHalfedges) cover = false;
    }
    // If there weren’t any edges, have the closest site cover the extent.
    // It doesn’t matter which corner of the extent we measure!
    if (cover) {
        var dx, dy, d2, dc = Infinity;
        for(iCell = 0, cover = null; iCell < nCells; ++iCell)if (cell = (0, $2RJ2t.cells)[iCell]) {
            site = cell.site;
            dx = site[0] - x0;
            dy = site[1] - y0;
            d2 = dx * dx + dy * dy;
            if (d2 < dc) dc = d2, cover = cell;
        }
        if (cover) {
            var v00 = [
                x0,
                y0
            ], v01 = [
                x0,
                y1
            ], v11 = [
                x1,
                y1
            ], v10 = [
                x1,
                y0
            ];
            cover.halfedges.push((0, $2RJ2t.edges).push((0, $gzJsf.createBorderEdge)(site = cover.site, v00, v01)) - 1, (0, $2RJ2t.edges).push((0, $gzJsf.createBorderEdge)(site, v01, v11)) - 1, (0, $2RJ2t.edges).push((0, $gzJsf.createBorderEdge)(site, v11, v10)) - 1, (0, $2RJ2t.edges).push((0, $gzJsf.createBorderEdge)(site, v10, v00)) - 1);
        }
    }
    // Lastly delete any cells with no edges; these were entirely clipped.
    for(iCell = 0; iCell < nCells; ++iCell){
        if (cell = (0, $2RJ2t.cells)[iCell]) {
            if (!cell.halfedges.length) delete (0, $2RJ2t.cells)[iCell];
        }
    }
}

});
parcelRegister("gzJsf", function(module, exports) {

$parcel$export(module.exports, "createEdge", () => $c1132c8ae02cf463$export$bdd941b9b8806569);
$parcel$export(module.exports, "setEdgeEnd", () => $c1132c8ae02cf463$export$9e883caea829cb44);
$parcel$export(module.exports, "createBorderEdge", () => $c1132c8ae02cf463$export$681cc0bbec712be1);
$parcel$export(module.exports, "clipEdges", () => $c1132c8ae02cf463$export$db4502aa9c1617af);

var $2RJ2t = parcelRequire("2RJ2t");
function $c1132c8ae02cf463$export$bdd941b9b8806569(left, right, v0, v1) {
    var edge = [
        null,
        null
    ], index = (0, $2RJ2t.edges).push(edge) - 1;
    edge.left = left;
    edge.right = right;
    if (v0) $c1132c8ae02cf463$export$9e883caea829cb44(edge, left, right, v0);
    if (v1) $c1132c8ae02cf463$export$9e883caea829cb44(edge, right, left, v1);
    (0, $2RJ2t.cells)[left.index].halfedges.push(index);
    (0, $2RJ2t.cells)[right.index].halfedges.push(index);
    return edge;
}
function $c1132c8ae02cf463$export$681cc0bbec712be1(left, v0, v1) {
    var edge = [
        v0,
        v1
    ];
    edge.left = left;
    return edge;
}
function $c1132c8ae02cf463$export$9e883caea829cb44(edge, left, right, vertex) {
    if (!edge[0] && !edge[1]) {
        edge[0] = vertex;
        edge.left = left;
        edge.right = right;
    } else if (edge.left === right) edge[1] = vertex;
    else edge[0] = vertex;
}
// Liang–Barsky line clipping.
function $c1132c8ae02cf463$var$clipEdge(edge, x0, y0, x1, y1) {
    var a = edge[0], b = edge[1], ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
    if (t0 > 0) edge[0] = [
        ax + t0 * dx,
        ay + t0 * dy
    ];
    if (t1 < 1) edge[1] = [
        ax + t1 * dx,
        ay + t1 * dy
    ];
    return true;
}
function $c1132c8ae02cf463$var$connectEdge(edge, x0, y0, x1, y1) {
    var v1 = edge[1];
    if (v1) return true;
    var v0 = edge[0], left = edge.left, right = edge.right, lx = left[0], ly = left[1], rx = right[0], ry = right[1], fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
        if (fx < x0 || fx >= x1) return;
        if (lx > rx) {
            if (!v0) v0 = [
                fx,
                y0
            ];
            else if (v0[1] >= y1) return;
            v1 = [
                fx,
                y1
            ];
        } else {
            if (!v0) v0 = [
                fx,
                y1
            ];
            else if (v0[1] < y0) return;
            v1 = [
                fx,
                y0
            ];
        }
    } else {
        fm = (lx - rx) / (ry - ly);
        fb = fy - fm * fx;
        if (fm < -1 || fm > 1) {
            if (lx > rx) {
                if (!v0) v0 = [
                    (y0 - fb) / fm,
                    y0
                ];
                else if (v0[1] >= y1) return;
                v1 = [
                    (y1 - fb) / fm,
                    y1
                ];
            } else {
                if (!v0) v0 = [
                    (y1 - fb) / fm,
                    y1
                ];
                else if (v0[1] < y0) return;
                v1 = [
                    (y0 - fb) / fm,
                    y0
                ];
            }
        } else if (ly < ry) {
            if (!v0) v0 = [
                x0,
                fm * x0 + fb
            ];
            else if (v0[0] >= x1) return;
            v1 = [
                x1,
                fm * x1 + fb
            ];
        } else {
            if (!v0) v0 = [
                x1,
                fm * x1 + fb
            ];
            else if (v0[0] < x0) return;
            v1 = [
                x0,
                fm * x0 + fb
            ];
        }
    }
    edge[0] = v0;
    edge[1] = v1;
    return true;
}
function $c1132c8ae02cf463$export$db4502aa9c1617af(x0, y0, x1, y1) {
    var i = (0, $2RJ2t.edges).length, edge;
    while(i--)if (!$c1132c8ae02cf463$var$connectEdge(edge = (0, $2RJ2t.edges)[i], x0, y0, x1, y1) || !$c1132c8ae02cf463$var$clipEdge(edge, x0, y0, x1, y1) || !(Math.abs(edge[0][0] - edge[1][0]) > (0, $2RJ2t.epsilon) || Math.abs(edge[0][1] - edge[1][1]) > (0, $2RJ2t.epsilon))) delete (0, $2RJ2t.edges)[i];
}

});


parcelRegister("7AZxF", function(module, exports) {

$parcel$export(module.exports, "firstCircle", () => $587ba22dbacb1cfa$export$2ca650a30b282a37);
$parcel$export(module.exports, "attachCircle", () => $587ba22dbacb1cfa$export$2a19333f6373b7a2);
$parcel$export(module.exports, "detachCircle", () => $587ba22dbacb1cfa$export$f0bd50ff687673c1);

var $bo307 = parcelRequire("bo307");

var $2RJ2t = parcelRequire("2RJ2t");
var $587ba22dbacb1cfa$var$circlePool = [];
var $587ba22dbacb1cfa$export$2ca650a30b282a37;
function $587ba22dbacb1cfa$var$Circle() {
    (0, $bo307.RedBlackNode)(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
}
function $587ba22dbacb1cfa$export$2a19333f6373b7a2(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite[0], by = cSite[1], ax = lSite[0] - bx, ay = lSite[1] - by, cx = rSite[0] - bx, cy = rSite[1] - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -(0, $2RJ2t.epsilon2)) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d;
    var circle = $587ba22dbacb1cfa$var$circlePool.pop() || new $587ba22dbacb1cfa$var$Circle;
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
    arc.circle = circle;
    var before = null, node = (0, $2RJ2t.circles)._;
    while(node){
        if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
            if (node.L) node = node.L;
            else {
                before = node.P;
                break;
            }
        } else if (node.R) node = node.R;
        else {
            before = node;
            break;
        }
    }
    (0, $2RJ2t.circles).insert(before, circle);
    if (!before) $587ba22dbacb1cfa$export$2ca650a30b282a37 = circle;
}
function $587ba22dbacb1cfa$export$f0bd50ff687673c1(arc) {
    var circle = arc.circle;
    if (circle) {
        if (!circle.P) $587ba22dbacb1cfa$export$2ca650a30b282a37 = circle.N;
        (0, $2RJ2t.circles).remove(circle);
        $587ba22dbacb1cfa$var$circlePool.push(circle);
        (0, $bo307.RedBlackNode)(circle);
        arc.circle = null;
    }
}

});



parcelRegister("bYoiY", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bfWFq = parcelRequire("bfWFq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bfWFq.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Rgb, rgb, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Hsl, hsl, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bfWFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $831e9a7deaab9d1d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $831e9a7deaab9d1d$export$8b58be045bf06082);
function $831e9a7deaab9d1d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $831e9a7deaab9d1d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("6FEsA", function(module, exports) {

$parcel$export(module.exports, "point", () => point);
$parcel$export(module.exports, "default", () => $4db5f4f17c3a16b3$export$2e2bcd8739ae039);

var $kDiOX = parcelRequire("kDiOX");

var $hga9n = parcelRequire("hga9n");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $kDiOX.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $kDiOX.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $4db5f4f17c3a16b3$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $hga9n.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("kDiOX", function(module, exports) {

$parcel$export(module.exports, "abs", () => $f0560c970166d25b$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan2", () => $f0560c970166d25b$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $f0560c970166d25b$export$50d414a77b60d802);
$parcel$export(module.exports, "max", () => $f0560c970166d25b$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $f0560c970166d25b$export$96ec731ed4dcb222);
$parcel$export(module.exports, "sin", () => $f0560c970166d25b$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sqrt", () => $f0560c970166d25b$export$eba8049fb5020b81);
$parcel$export(module.exports, "epsilon", () => $f0560c970166d25b$export$6c421550c66a327d);
$parcel$export(module.exports, "pi", () => $f0560c970166d25b$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $f0560c970166d25b$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $f0560c970166d25b$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "acos", () => $f0560c970166d25b$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $f0560c970166d25b$export$41726bdb1fc63f);
const $f0560c970166d25b$export$2335f513bbd82c6d = Math.abs;
const $f0560c970166d25b$export$b8b770ee6a0d9760 = Math.atan2;
const $f0560c970166d25b$export$50d414a77b60d802 = Math.cos;
const $f0560c970166d25b$export$8960430cfd85939f = Math.max;
const $f0560c970166d25b$export$96ec731ed4dcb222 = Math.min;
const $f0560c970166d25b$export$5de3937cb4b592ed = Math.sin;
const $f0560c970166d25b$export$eba8049fb5020b81 = Math.sqrt;
const $f0560c970166d25b$export$6c421550c66a327d = 1e-12;
const $f0560c970166d25b$export$18c7bea995a110f = Math.PI;
const $f0560c970166d25b$export$e51408a300e8929a = $f0560c970166d25b$export$18c7bea995a110f / 2;
const $f0560c970166d25b$export$a4b4b4d4d776fe92 = 2 * $f0560c970166d25b$export$18c7bea995a110f;
function $f0560c970166d25b$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $f0560c970166d25b$export$18c7bea995a110f : Math.acos(x);
}
function $f0560c970166d25b$export$41726bdb1fc63f(x) {
    return x >= 1 ? $f0560c970166d25b$export$e51408a300e8929a : x <= -1 ? -$f0560c970166d25b$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("hga9n", function(module, exports) {

$parcel$export(module.exports, "point", () => $c90bcdedc71457ea$export$105684a3041cb6f3);
$parcel$export(module.exports, "Cardinal", () => $c90bcdedc71457ea$export$ee51ff373511cbeb);
$parcel$export(module.exports, "default", () => $c90bcdedc71457ea$export$2e2bcd8739ae039);
function $c90bcdedc71457ea$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $c90bcdedc71457ea$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$c90bcdedc71457ea$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $c90bcdedc71457ea$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                $c90bcdedc71457ea$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c90bcdedc71457ea$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $c90bcdedc71457ea$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("z1gio", function(module, exports) {
"use strict";
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("4nFCC", function(module, exports) {
"use strict";
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, "prototype");
    var $330998a67e44345d$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys["$" + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $330998a67e44345d$var$toStr.call(object) === "[object Function]";
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === "constructor") && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});

parcelRegister("3KyxH", function(module, exports) {
"use strict";

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});

parcelRegister("i16wS", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $d1dd62937e17e68d$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($d1dd62937e17e68d$var$$defineProperty) try {
        $d1dd62937e17e68d$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$d1dd62937e17e68d$var$hasPropertyDescriptors()) return null;
    try {
        return $d1dd62937e17e68d$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;
var $1258b452ecf218a1$var$$SyntaxError = SyntaxError;
var $1258b452ecf218a1$var$$Function = Function;
var $1258b452ecf218a1$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $1258b452ecf218a1$var$$TypeError();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $1258b452ecf218a1$var$$SyntaxError,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $1258b452ecf218a1$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $8aKn2 = parcelRequire("8aKn2");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($8aKn2($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $1258b452ecf218a1$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1258b452ecf218a1$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $1258b452ecf218a1$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $1258b452ecf218a1$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1258b452ecf218a1$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $1258b452ecf218a1$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $1258b452ecf218a1$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $8aKn2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$slice = Array.prototype.slice;
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.call(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("8aKn2", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");
module.exports = $gvair.call(Function.call, Object.prototype.hasOwnProperty);

});



parcelRegister("1NQyn", function(module, exports) {
"use strict";
var $15032211f1d46f99$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === "string";
};
var $15032211f1d46f99$var$gOPD = Object.getOwnPropertyDescriptor;
if ($15032211f1d46f99$var$gOPD) try {
    $15032211f1d46f99$var$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $15032211f1d46f99$var$gOPD = null;
}
$15032211f1d46f99$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$15032211f1d46f99$var$functionsHaveNames() || !$15032211f1d46f99$var$gOPD) return false;
    var desc = $15032211f1d46f99$var$gOPD(function() {}, "name");
    return !!desc && !!desc.configurable;
};
var $15032211f1d46f99$var$$bind = Function.prototype.bind;
$15032211f1d46f99$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $15032211f1d46f99$var$functionsHaveNames() && typeof $15032211f1d46f99$var$$bind === "function" && (function f() {}).bind().name !== "";
};
module.exports = $15032211f1d46f99$var$functionsHaveNames;

});

parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("2iRJw", function(module, exports) {
"use strict";
// https://kb.medical-objects.com.au/display/PUB/HL7v2+parsing
// ~ = sub component
// && = repeating field
if (!String.prototype.startsWith) Object.defineProperty(String.prototype, "startsWith", {
    value: function(search, rawPos) {
        pos = rawPos > 0 ? rawPos | 0 : 0;
        return this.substring(pos, pos + search.length) === search;
    }
});
const $1ad6f17e647c925e$var$_addBatchSegment = function(data, type) {
    if (data.constructor.name !== "HL7") throw new Error("HL7 data added is not HL7 constructor");
    return this[type].push(data);
};
const $1ad6f17e647c925e$var$_addToBatch = function(data) {
    if (data.constructor.name !== "HL7") throw new Error("HL7 data added is not HL7 constructor");
    return this.container.push(data);
};
const $1ad6f17e647c925e$var$_splitBatch = (indexes)=>(data, batch = [])=>{
        indexes.sort((a, b)=>a - b);
        for(var i = 0; i < indexes.length; i++){
            let start = indexes[i], end = indexes[i + 1];
            if (i + 1 === indexes.length) end = data.length;
            batch.push(data.slice(start, end));
        }
        return batch;
    };
const $1ad6f17e647c925e$var$_getSegIndexes = (names, data, list = [])=>{
    for(let i = 0; i < names.length; i++){
        let regexp = new RegExp(`(\n|\r\n|^|\r)${names[i]}\\|`, "g"), m;
        while(m = regexp.exec(data)){
            var s = m[0];
            if (s.indexOf("\r\n") != -1) m.index = m.index + 2;
            else if (s.indexOf("\n") != -1) m.index++;
            else if (s.indexOf("\r") != -1) m.index++;
            if (m.index !== null) list.push(m.index);
        }
    }
    return list;
};
const $1ad6f17e647c925e$var$_isBatch = (data, batch)=>{
    return typeof data === "string" && (data.startsWith("FHS") || data.startsWith("BHS") || batch) ? true : false;
};
const $1ad6f17e647c925e$var$_batchIterate = function(predicate) {
    for(let i = 0; i < this.container.length; i++)predicate.call(this, i, this.container[i]);
};
const $1ad6f17e647c925e$var$_invalidSegments = function(segs) {
    return segs.some((seg)=>seg.match(/[^A-Z0-9]/g) !== null);
};
const $1ad6f17e647c925e$var$_defineLineEndings = function(data, cb) {
    function _mode(assets) {
        const map = assets.reduce((list, asset)=>{
            if (!(asset in list)) list[asset] = 0;
            return list[asset]++, list;
        }, {});
        var keys = Object.keys(map), keyValues = keys.map((v)=>map[v]);
        let max = Math.max.apply(null, keyValues), modes = [];
        keys.forEach((v)=>{
            if (map[v] === max) modes.push(v);
        });
        return modes.length ? cb(null, modes[0]) : cb(new Error("HL7 data must contain valid line endings ['\\r\\n', '\\n', or '\\r'] to be parsed."), null);
    }
    const eols = data.match(/\r\n|\r|\n/g) || [];
    return _mode(eols);
};
const $1ad6f17e647c925e$var$_transformSegment = function(opts) {
    let { segment: segment, name: name, content: content, isMSH: isMSH, parseOptions: parseOptions } = opts;
    const { subComponents: subComponents, repeatingFields: repeatingFields } = parseOptions;
    for(let idx = 1; idx < content.length; idx++){
        let pos1 = isMSH ? idx + 1 : idx;
        if (content[idx].indexOf(subComponents) > -1) {
            let subcomp = content[idx].split(subComponents);
            segment.data[`${name}.${pos1}`] = [];
            for(let j = 0; j < subcomp.length; j++){
                let component = {};
                let subs = subcomp[j].split("^");
                for(let k = 0; k < subs.length; k++)if (subs[k].indexOf(repeatingFields) > -1) {
                    let repeating = subs[k].split(repeatingFields);
                    component[`${name}.${pos1}.${k + 1}`] = [];
                    for(let l = 0; l < repeating.length; l++)component[`${name}.${pos1}.${k + 1}`].push(repeating[l]);
                } else component[`${name}.${pos1}.${k + 1}`] = subs[k];
                segment.data[`${name}.${pos1}`].push(component);
            }
        } else if (content[idx].indexOf("^") > -1) {
            let subs = content[idx].split("^");
            segment.data[`${name}.${pos1}`] = {};
            for(let j = 0; j < subs.length; j++)if (subs[j].indexOf(repeatingFields) > -1) {
                let repeating = subs[j].split(repeatingFields);
                segment.data[`${name}.${pos1}`][`${name}.${pos1}.${j + 1}`] = [];
                for(let l = 0; l < repeating.length; l++)segment.data[`${name}.${pos1}`][`${name}.${pos1}.${j + 1}`].push(repeating[l]);
            } else segment.data[`${name}.${pos1}`][`${name}.${pos1}.${j + 1}`] = subs[j];
        } else if (content[idx].indexOf(repeatingFields) > -1) {
            let repeating = content[idx].split(repeatingFields);
            segment.data[`${name}.${pos1}`] = [];
            for(let l = 0; l < repeating.length; l++)segment.data[`${name}.${pos1}`].push(repeating[l]);
        } else segment.data[`${name}.${pos1}`] = content[idx];
    }
    return segment;
};
const $1ad6f17e647c925e$var$_buildSegment = function(line, fields, segment, opts) {
    const { subComponents: subComponents, repeatingFields: repeatingFields } = opts;
    for(let j = 0; j < fields.length; j++){
        let component = segment.data[fields[j]];
        if (Array.isArray(component)) for(let m = 0; m < component.length; m++){
            if (typeof component[m] === "object") {
                let subcomponents = Object.keys(component[m]);
                if (!subcomponents.length) line += subComponents;
                for(let n = 0; n < subcomponents.length; n++){
                    let subcompvalue = component[m][subcomponents[n]];
                    if (Array.isArray(subcompvalue)) for(let o = 0; o < subcompvalue.length; o++){
                        if (o + 1 === subcompvalue.length && n + 1 === subcomponents.length && m + 1 === component.length) line += `${subcompvalue[o]}|`;
                        else if (o + 1 === subcompvalue.length && n + 1 === subcomponents.length) line += `${subcompvalue[o]}${subComponents}`;
                        else if (o + 1 === subcompvalue.length) line += `${subcompvalue[o]}^`;
                        else line += `${subcompvalue[o]}${repeatingFields}`;
                    }
                    else {
                        if (n + 1 === subcomponents.length && m + 1 === component.length) line += `${subcompvalue}|`;
                        else if (n + 1 === subcomponents.length) line += `${subcompvalue}${subComponents}`;
                        else line += `${subcompvalue}^`;
                    }
                }
            } else if (m + 1 === component.length) line += `${component[m]}|`;
            else line += `${component[m]}${subComponents}`;
        }
        else if (typeof component === "object") {
            let subcomponents = Object.keys(component);
            for(let n = 0; n < subcomponents.length; n++){
                let subcompvalue = component[subcomponents[n]];
                if (Array.isArray(subcompvalue)) for(let o = 0; o < subcompvalue.length; o++){
                    if (o + 1 === subcompvalue.length && n + 1 === subcomponents.length) line += `${subcompvalue[o]}|`;
                    else if (o + 1 === subcompvalue.length) line += `${subcompvalue[o]}^`;
                    else line += `${subcompvalue[o]}${repeatingFields}`;
                }
                else if (n + 1 === subcomponents.length) line += `${subcompvalue}|`;
                else line += `${subcompvalue}^`;
            }
        } else line += `${component}|`;
    }
    return line;
};
const $1ad6f17e647c925e$var$_build = function(data, parseOpts) {
    const segments = Object.keys(data);
    var lines = [];
    for(let i = 0; i < segments.length; i++){
        let segment = data[segments[i]];
        if (Array.isArray(segment)) for(let r = 0; r < segment.length; r++){
            if (!segment[r]) continue;
            let line = segments[i] + "|";
            let fields = Object.keys(segment[r].data);
            let index = segment[r].index;
            lines.push({
                index: index,
                line: $1ad6f17e647c925e$var$_buildSegment(line, fields, segment[r], parseOpts)
            });
        }
        else {
            let line = segments[i] + "|";
            let fields = Object.keys(segment.data);
            let index = segment.index;
            lines.push({
                index: index,
                line: $1ad6f17e647c925e$var$_buildSegment(line, fields, segment, parseOpts)
            });
        }
    }
    return lines;
};
const $1ad6f17e647c925e$var$_defineField = function(field) {
    if (typeof field !== "string") throw new Error(`Cannot set/get HL7 field: ${field}. The parameter 'field' must be a string.`);
    const notation = field.split(".");
    const segment = typeof notation[0] !== "undefined" && notation[0].length === 3 ? notation[0] : null;
    const section = typeof notation[1] !== "undefined" ? `${notation[0]}.${notation[1]}` : null;
    const sub = typeof notation[2] !== "undefined" ? `${notation[0]}.${notation[1]}.${notation[2]}` : null;
    return {
        notation: notation,
        segment: segment,
        section: section,
        sub: sub
    };
};
const $1ad6f17e647c925e$var$_segmentExists = function(segment, index) {
    let segmentExists = typeof this.transformed[segment] !== "undefined" ? true : false, isArray = false;
    if (segmentExists) isArray = Array.isArray(this.transformed[segment]) ? true : false;
    if (isArray) segmentExists = typeof this.transformed[segment][index ? index : 0] !== "undefined" ? true : false;
    return {
        segmentExists: segmentExists,
        isArray: isArray
    };
};
const $1ad6f17e647c925e$var$_sectionExists = function(reference, section, sectionIndex) {
    let isArray = false, isAtIndex = false;
    let sectionExists = typeof reference.data[section] !== "undefined" ? true : false;
    if (sectionExists) {
        isArray = Array.isArray(reference.data[section]) ? true : false;
        if (typeof sectionIndex === "number" && isArray) isAtIndex = typeof reference.data[section][sectionIndex ? sectionIndex : 0] !== "undefined" ? true : false;
    }
    return {
        sectionExists: sectionExists,
        isAtIndex: isAtIndex,
        isArray: isArray
    };
};
const $1ad6f17e647c925e$var$_subSectionExists = function(reference, sub, subIndex) {
    let isArray = false, isAtIndex = false;
    let subSectionExists = typeof reference[sub] !== "undefined" ? true : false;
    if (subSectionExists) {
        isArray = Array.isArray(reference[sub]) ? true : false;
        if (typeof subIndex === "number" && isArray) isAtIndex = typeof reference[sub][subIndex ? subIndex : 0] !== "undefined" ? true : false;
    }
    return {
        subSectionExists: subSectionExists,
        isAtIndex: isAtIndex,
        isArray: isArray
    };
};
const $1ad6f17e647c925e$var$_createSection = function(reference, position) {
    for(let i = reference.type !== "MSH" ? 1 : 2; i <= position; i++)if (typeof reference.data[`${reference.type}.${i}`] === "undefined") reference.data[`${reference.type}.${i}`] = "";
    return reference;
};
const $1ad6f17e647c925e$var$_createSectionAtIndex = function(reference, isArray, section = 0) {
    reference = isArray ? reference : [
        typeof reference !== "undefined" ? reference : {}
    ];
    for(let i = 0; i <= section; i++)if (typeof reference[i] === "undefined") reference[i] = {};
    return reference;
};
const $1ad6f17e647c925e$var$_createSubSection = function(reference, section, position) {
    reference = typeof reference !== "object" ? {} : reference;
    for(let i = 1; i <= position; i++)if (typeof reference[`${section}.${i}`] === "undefined") reference[`${section}.${i}`] = "";
    return reference;
};
const $1ad6f17e647c925e$var$_createSubSectionAtIndex = function(reference, isArray, sub = 0) {
    reference = isArray ? reference : [
        typeof reference !== "undefined" ? reference : ""
    ];
    for(let i = 0; i <= sub; i++)if (typeof reference[i] === "undefined") reference[i] = "";
    return reference;
};
const $1ad6f17e647c925e$var$_validSegment = function(segment) {
    return typeof segment === "string" && segment.length === 3 ? true : false;
};
const $1ad6f17e647c925e$var$_moveSegment = function(from, forward) {
    const segments = Object.keys(this.transformed);
    for(let i = 0; i < segments.length; i++){
        for(let j = 0; j < this.transformed[segments[i]].length; j++)if (this.transformed[segments[i]][j] && this.transformed[segments[i]][j].index >= from) {
            if (forward) this.transformed[segments[i]][j].index++;
            else this.transformed[segments[i]][j].index--;
        }
    }
    return this;
};
const $1ad6f17e647c925e$var$_cleanse = function(categories) {
    for(let i = 0; i < categories.length; i++){
        let j = this.transformed[categories[i]].length;
        while(j >= 0){
            if (!this.transformed[categories[i]][j]) this.transformed[categories[i]].splice(j, 1);
            j--;
        }
    }
};
const $1ad6f17e647c925e$var$_SegmentGenerator = function(type) {
    return new ((function Segment(scope, type) {
        this.type = type;
        this.data = {};
        this.set = (function(ref, field, value, sectionIndex, subIndex) {
            let idx = Array.isArray(ref.transformed[this.type]) ? ref.transformed[this.type].indexOf(this) : 0;
            return ref.set.call(ref, field, value, idx, sectionIndex, subIndex);
        }).bind(this, scope);
        this.get = (function(ref, field, sectionIndex, subIndex) {
            let idx = Array.isArray(ref.transformed[this.type]) ? ref.transformed[this.type].indexOf(this) : 0;
            return ref.get.call(ref, field, idx, sectionIndex, subIndex);
        }).bind(this, scope);
    }).bind(this))(this, type);
};
module.exports = class HL7 {
    constructor(data = "", opts = {}){
        this.raw = typeof data === "string" ? data : "";
        this.transformed = {};
        this.encoded = "";
        this.parseOptions = {
            subComponents: opts.subComponents ? opts.subComponents : "~",
            repeatingFields: opts.repeatingFields ? opts.repeatingFields : "&",
            lineEndings: opts.lineEndings ? opts.lineEndings : "\r\n"
        };
        this.forceBatch = false;
        this.isBatch = ()=>this.forceBatch;
        this.lastIndex = 0;
    }
    /**
   * Transforms raw HL7 data to 'hl7-standard' constructor format for message manipulation
   *
   * @param {Function} callback function used to control transformation errors, optional
   * @param {Boolean} batch boolean specifying if message should be treated as a batch message, optional
   * @api public
   */ transform(cb, batch = false) {
        if (!this.raw.startsWith("MSH") && !this.raw.startsWith("FHS") && !this.raw.startsWith("BHS") && !this.raw.startsWith("BTS") && !this.raw.startsWith("FTS")) {
            let error = new Error("Expected raw data to be HL7");
            if (cb) return cb(error, null);
            throw error;
        }
        if (!batch && $1ad6f17e647c925e$var$_isBatch(this.raw, this.forceBatch)) {
            delete this.transformed;
            this.header = [];
            this.trailer = [];
            this.container = [];
            this.forceBatch = true;
            this.get = null;
            this.set = null;
            this.createSegment = null;
            this.getSegmentsAfter = null;
            this.iterate = null;
            var b = $1ad6f17e647c925e$var$_splitBatch([
                ...$1ad6f17e647c925e$var$_getSegIndexes([
                    "FHS",
                    "BHS",
                    "MSH",
                    "BTS",
                    "FTS"
                ], this.raw)
            ])(this.raw);
            for(let i = 0; i < b.length; i++){
                let hl7 = new HL7(b[i]);
                hl7.transform((err)=>{
                    if (err) throw err;
                    if (hl7.transformed["FHS"] || hl7.transformed["BHS"]) $1ad6f17e647c925e$var$_addBatchSegment.call(this, hl7, "header");
                    if (hl7.transformed["BTS"] || hl7.transformed["FTS"]) $1ad6f17e647c925e$var$_addBatchSegment.call(this, hl7, "trailer");
                    if (hl7.transformed["MSH"]) $1ad6f17e647c925e$var$_addToBatch.call(this, hl7);
                }, true);
            }
            this.iterate = $1ad6f17e647c925e$var$_batchIterate;
            if (cb) return cb(null, this.container);
        } else $1ad6f17e647c925e$var$_defineLineEndings(this.raw, (err, lr)=>{
            if (err) {
                if (cb) return cb(err, null);
                throw err;
            }
            const { parseOptions: parseOptions } = this;
            var lines = this.raw.split(lr).filter((line)=>line.indexOf("|") > -1), isMSH = false;
            this.lastIndex = lines.length - 1;
            for(let i = 0; i < lines.length; i++){
                let name = lines[i].substring(0, 3);
                isMSH = name === "MSH" ? true : false;
                if (Object.keys(this.transformed).indexOf(name) > -1) {
                    if (Array.isArray(this.transformed[name])) {
                        let segment = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, name);
                        segment.index = i;
                        let content = lines[i].split("|");
                        segment = $1ad6f17e647c925e$var$_transformSegment({
                            segment: segment,
                            name: name,
                            content: content,
                            isMSH: isMSH,
                            parseOptions: parseOptions
                        });
                        this.transformed[name].push(segment);
                    } else {
                        let tmp = this.transformed[name];
                        this.transformed[name] = new Array();
                        this.transformed[name].push(tmp);
                        let segment = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, name);
                        segment.index = i;
                        let content = lines[i].split("|");
                        segment = $1ad6f17e647c925e$var$_transformSegment({
                            segment: segment,
                            name: name,
                            content: content,
                            isMSH: isMSH,
                            parseOptions: parseOptions
                        });
                        this.transformed[name].push(segment);
                    }
                } else {
                    let segment = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, name);
                    segment.index = i;
                    let content = lines[i].split("|");
                    segment = $1ad6f17e647c925e$var$_transformSegment({
                        segment: segment,
                        name: name,
                        content: content,
                        isMSH: isMSH,
                        parseOptions: parseOptions
                    });
                    this.transformed[name] = [
                        segment
                    ];
                }
            }
            if (this.transformed["MSH"]) this.transformed["MSH"][0].data["MSH.2"] = "^~\\&";
            if ($1ad6f17e647c925e$var$_invalidSegments(Object.keys(this.transformed))) {
                let error = new Error("HL7 Data contains invalid EOL characters");
                if (cb) return cb(error, null);
                throw error;
            } else {
                if (cb) return cb(null, this.transformed);
            }
        });
    }
    /**
   * Builds a new HL7 message from transformed data
   *
   * @return {String|Object|Array} set value
   * @api public
   */ build() {
        const { transformed: transformed, parseOptions: parseOptions } = this;
        this.encoded = "";
        if (this.isBatch()) {
            this.header.forEach((data)=>{
                this.encoded += $1ad6f17e647c925e$var$_build(data.transformed, parseOptions).sort((a, b)=>a.index - b.index).map((line)=>line.line).join(parseOptions.lineEndings);
                this.encoded += parseOptions.lineEndings;
            });
            this.container.forEach((data)=>{
                this.encoded += $1ad6f17e647c925e$var$_build(data.transformed, parseOptions).sort((a, b)=>a.index - b.index).map((line)=>line.line).join(parseOptions.lineEndings);
                this.encoded += parseOptions.lineEndings;
            });
            this.trailer.forEach((data)=>{
                this.encoded += $1ad6f17e647c925e$var$_build(data.transformed, parseOptions).sort((a, b)=>a.index - b.index).map((line)=>line.line).join(parseOptions.lineEndings);
                this.encoded += parseOptions.lineEndings;
            });
        } else this.encoded += $1ad6f17e647c925e$var$_build(transformed, parseOptions).sort((a, b)=>a.index - b.index).map((line)=>line.line).join(parseOptions.lineEndings);
        return this.encoded;
    }
    /**
   * Sets a value on a transformed segment
   *
   * @param {String} field name of field being set, required
   * @param {String} value index of segment relative to other segments of same type, optional
   * @param {String} sectionIndex index of section within segment being set, optional
   * @param {String} subIndex index of value in repeating field, optional
   * @return {String|Object|Array} set value
   * @api public
   */ set(field, value, index, sectionIndex, subIndex) {
        const { notation: notation, segment: segment, section: section, sub: sub } = $1ad6f17e647c925e$var$_defineField(field);
        let segmentStatus = $1ad6f17e647c925e$var$_segmentExists.apply(this, [
            segment,
            index
        ]);
        if (segmentStatus.segmentExists) {
            let segmentRef = segmentStatus.isArray ? this.transformed[segment][index ? index : 0] : this.transformed[segment];
            if (section !== null) {
                let sectionStatus = $1ad6f17e647c925e$var$_sectionExists.apply(this, [
                    segmentRef,
                    section,
                    sectionIndex
                ]);
                if (!sectionStatus.sectionExists) segmentRef = $1ad6f17e647c925e$var$_createSection(segmentRef, notation[1]);
                if (!sectionStatus.isAtIndex && typeof sectionIndex === "number") segmentRef.data[section] = $1ad6f17e647c925e$var$_createSectionAtIndex(segmentRef.data[section], sectionStatus.isArray, sectionIndex);
                let sectionRef = Array.isArray(segmentRef.data[section]) ? segmentRef.data[section][sectionIndex ? sectionIndex : 0] : segmentRef.data[section];
                if (sub !== null) {
                    let subSectionStatus = $1ad6f17e647c925e$var$_subSectionExists.apply(this, [
                        sectionRef,
                        sub,
                        subIndex
                    ]);
                    if (!subSectionStatus.subSectionExists) {
                        if (Array.isArray(segmentRef.data[section])) segmentRef.data[section][sectionIndex ? sectionIndex : 0] = $1ad6f17e647c925e$var$_createSubSection(segmentRef.data[section][sectionIndex ? sectionIndex : 0], section, notation[2]);
                        else segmentRef.data[section] = $1ad6f17e647c925e$var$_createSubSection(segmentRef.data[section], section, notation[2]);
                    }
                    if (!subSectionStatus.isAtIndex && typeof subIndex === "number") {
                        if (Array.isArray(segmentRef.data[section])) {
                            if (Array.isArray(segmentRef.data[section][sectionIndex ? sectionIndex : 0][sub])) segmentRef.data[section][sectionIndex ? sectionIndex : 0][sub][subIndex ? subIndex : 0] = $1ad6f17e647c925e$var$_createSubSectionAtIndex(segmentRef.data[section][sectionIndex ? sectionIndex : 0][sub][subIndex ? subIndex : 0], subSectionStatus.isArray, subIndex);
                            else segmentRef.data[section][sectionIndex ? sectionIndex : 0][sub] = $1ad6f17e647c925e$var$_createSubSectionAtIndex(segmentRef.data[section][sectionIndex ? sectionIndex : 0][sub], subSectionStatus.isArray, subIndex);
                        } else if (Array.isArray(segmentRef.data[section][sub])) segmentRef.data[section][sub][subIndex ? subIndex : 0] = $1ad6f17e647c925e$var$_createSubSectionAtIndex(segmentRef.data[section][sub][subIndex ? subIndex : 0], subSectionStatus.isArray, subIndex);
                        else segmentRef.data[section][sub] = $1ad6f17e647c925e$var$_createSubSectionAtIndex(segmentRef.data[section][sub], subSectionStatus.isArray, subIndex);
                    }
                    if (Array.isArray(segmentRef.data[section])) {
                        if (Array.isArray(segmentRef.data[section][sectionIndex ? sectionIndex : 0][sub])) {
                            if (typeof value === "string") return segmentRef.data[section][sectionIndex ? sectionIndex : 0][sub][subIndex ? subIndex : 0] = value;
                            else throw new Error("DataType must be a string to set field");
                        } else {
                            if (typeof value === "string" || Array.isArray(value)) return segmentRef.data[section][sectionIndex ? sectionIndex : 0][sub] = value;
                            else throw new Error("DataType must be a string or an array to set field");
                        }
                    } else if (Array.isArray(segmentRef.data[section][sub])) {
                        if (typeof value === "string") return segmentRef.data[section][sub][subIndex ? subIndex : 0] = value;
                        else throw new Error("DataType must be a string to set field");
                    } else {
                        if (typeof value === "string" || Array.isArray(value)) return segmentRef.data[section][sub] = value;
                        else throw new Error("DataType must be a string or an array to set field");
                    }
                } else {
                    if (Array.isArray(segmentRef.data[section])) return segmentRef.data[section][sectionIndex ? sectionIndex : 0] = value;
                    else return segmentRef.data[section] = value;
                }
            } else {
                if (typeof value === "object" && !Array.isArray(value)) return segmentRef.data = value;
                else throw new Error("Must provide object notation in order to overwrite existing segment");
            }
        } else throw new Error(`Values cannot be set on segment that does not exist: ${segment}`);
    }
    /**
   * Gets a value from a transformed segment returning an array, object, or string
   *
   * @param {String} field name of field being requested, required
   * @param {Number} index index of segment relative to other segments of same type, optional
   * @param {Number} sectionIndex index of section within segment being requested, optional
   * @param {Number} subIndex index of value in repeating field, optional
   * @return {String|Object|Array} value at specified segment position
   * @api public
   */ get(field, index, sectionIndex, subIndex) {
        index = index || 0;
        sectionIndex = sectionIndex || 0;
        subIndex = subIndex || 0;
        const { notation: notation, segment: segment, section: section, sub: sub } = $1ad6f17e647c925e$var$_defineField(field);
        if (segment !== null && section !== null && sub !== null) {
            if (typeof this.transformed[segment] !== "undefined") {
                if (typeof this.transformed[segment][index].data[section] !== "undefined") {
                    if (Array.isArray(this.transformed[segment][index].data[section])) {
                        if (typeof this.transformed[segment][index].data[section][sectionIndex][sub] !== "undefined") {
                            if (Array.isArray(this.transformed[segment][index].data[section][sectionIndex][sub])) return this.transformed[segment][index].data[section][sectionIndex][sub][subIndex];
                            else return this.transformed[segment][index].data[section][sectionIndex][sub];
                        } else {
                            let val = this.transformed[segment][index].data[section][sectionIndex];
                            return notation[2] == 1 && typeof val === "string" ? val : null;
                        }
                    } else if (typeof this.transformed[segment][index].data[section][sub] !== "undefined") {
                        if (Array.isArray(this.transformed[segment][index].data[section][sub])) return this.transformed[segment][index].data[section][sub][subIndex];
                        else return this.transformed[segment][index].data[section][sub];
                    } else {
                        let val = this.transformed[segment][index].data[section];
                        return notation[2] == 1 && typeof val === "string" ? val : null;
                    }
                } else return null;
            } else return null;
        } else if (segment !== null && section !== null) {
            if (typeof this.transformed[segment] !== "undefined") {
                if (typeof this.transformed[segment][index].data[section] !== "undefined") {
                    if (Array.isArray(this.transformed[segment][index].data[section])) return this.transformed[segment][index].data[section][sectionIndex];
                    else return this.transformed[segment][index].data[section];
                } else return null;
            } else return null;
        } else if (segment !== null) {
            if (typeof this.transformed[segment] !== "undefined") return this.transformed[segment][index].data;
            else return null;
        } else throw new Error("Segment name must be provided as parameter to get function");
    }
    /**
   * Gets a single segment constructor, if multiple exist, it will return the first one.
   *
   * @param {String} segment name, must be 3 char, required
   * @return {Object} 'Segment' constructor with get and set methods
   * @api public
   */ getSegment(segment) {
        if (!$1ad6f17e647c925e$var$_validSegment(segment)) throw new Error("Cannot get segment after because 'segment' parameter: is invalid.");
        return this.transformed[segment] && this.transformed[segment][0] ? this.transformed[segment][0] : null;
    }
    /**
   * Gets all segment constructors by segment type, if no segment is specified, method will
   * return all segments in the message
   *
   * @param {String} segment name, optional
   * @return {Array} list of all 'Segment' constructors, with get and set methods, by that type
   * @api public
   */ getSegments(segment) {
        if (segment) {
            if (!$1ad6f17e647c925e$var$_validSegment(segment)) throw new Error("Cannot get segments because 'segment' parameter: is invalid.");
            return this.transformed[segment] ? this.transformed[segment] : [];
        } else return Object.keys(this.transformed).reduce((a, b)=>{
            a = a.concat(this.transformed[b]);
            return a;
        }, []);
    }
    /**
   * Creates a single segment at the end of the hl7 message
   *
   * @param {String} segment name, optional
   * @return {Array} list of all 'Segment' constructors, with get and set methods, by that type
   * @api public
   */ createSegment(segment) {
        if (!$1ad6f17e647c925e$var$_validSegment(segment)) throw new Error("Cannot create segment because 'segment' parameter: is invalid.");
        const exists = typeof this.transformed[segment] !== "undefined" ? true : false;
        this.lastIndex++;
        if (exists) {
            if (Array.isArray(this.transformed[segment])) {
                let seg = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, segment);
                seg.index = this.lastIndex;
                this.transformed[segment].push(seg);
                return seg;
            } else {
                let current = this.transformed[segment];
                this.transformed[segment] = [];
                let seg = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, segment);
                seg.index = this.lastIndex;
                this.transformed[segment] = this.transformed[segment].concat([
                    current,
                    seg
                ]);
                return seg;
            }
        } else {
            let seg = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, segment);
            seg.index = this.lastIndex;
            this.transformed[segment] = [
                seg
            ];
            return seg;
        }
    }
    /**
   * Creates a single segment after an already existing, specified segment
   *
   * @param {String} segment name, required
   * @param {Object} afterSegment 'Segment' constructor, required
   * @return {Object} newly created 'Segment' constructor
   * @api public
   */ createSegmentAfter(segment, afterSegment = {}) {
        if (!$1ad6f17e647c925e$var$_validSegment(segment)) throw new Error("Cannot create segment after because 'segment' parameter: is invalid.");
        const exists = typeof this.transformed[segment] !== "undefined" ? true : false;
        if (afterSegment.constructor.name !== "Segment") throw new Error("Cannot create segment after because 'afterSegment' parameter: is invalid.");
        this.lastIndex++;
        const newIndex = afterSegment.index + 1;
        if (exists) {
            if (Array.isArray(this.transformed[segment])) {
                $1ad6f17e647c925e$var$_moveSegment.call(this, newIndex, true);
                let seg = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, segment);
                seg.index = newIndex;
                this.transformed[segment].push(seg);
                return seg;
            } else {
                $1ad6f17e647c925e$var$_moveSegment.call(this, newIndex, true);
                let current = this.transformed[segment];
                this.transformed[segment] = [];
                let seg = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, segment);
                seg.index = newIndex;
                this.transformed[segment] = this.transformed[segment].concat([
                    current,
                    seg
                ]);
                return seg;
            }
        } else {
            $1ad6f17e647c925e$var$_moveSegment.call(this, newIndex, true);
            let seg = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, segment);
            seg.index = newIndex;
            this.transformed[segment] = [
                seg
            ];
            return seg;
        }
    }
    /**
   * Creates a single segment before an already existing, specified segment
   *
   * @param {String} segment name, required
   * @param {Object} beforeSegment 'Segment' constructor, required
   * @return {Object} newly created 'Segment' constructor
   * @api public
   */ createSegmentBefore(segment, beforeSegment = {}) {
        if (!$1ad6f17e647c925e$var$_validSegment(segment)) throw new Error("Cannot create segment before because 'segment' parameter: is invalid.");
        const exists = typeof this.transformed[segment] !== "undefined" ? true : false;
        if (beforeSegment.constructor.name !== "Segment") throw new Error("Cannot create segment before because 'beforeSegment' parameter: is invalid.");
        this.lastIndex++;
        const newIndex = beforeSegment.index - 1;
        if (exists) {
            if (Array.isArray(this.transformed[segment])) {
                $1ad6f17e647c925e$var$_moveSegment.call(this, newIndex, false);
                let seg = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, segment);
                seg.index = newIndex;
                this.transformed[segment].push(seg);
                return seg;
            } else {
                $1ad6f17e647c925e$var$_moveSegment.call(this, newIndex, false);
                let current = this.transformed[segment];
                this.transformed[segment] = [];
                let seg = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, segment);
                seg.index = newIndex;
                this.transformed[segment] = this.transformed[segment].concat([
                    current,
                    seg
                ]);
                return seg;
            }
        } else {
            $1ad6f17e647c925e$var$_moveSegment.call(this, newIndex, false);
            let seg = $1ad6f17e647c925e$var$_SegmentGenerator.call(this, segment);
            seg.index = newIndex;
            this.transformed[segment] = [
                seg
            ];
            return seg;
        }
    }
    /**
   * Deletes a single segment from the HL7 message
   *
   * @param {Object} segment 'Segment' constructor to be deleted, required
   * @api public
   */ deleteSegment(segment) {
        if (segment.constructor.name !== "Segment") throw new Error("Cannot delete segment because 'segment' parameter: is invalid.");
        this.deleteSegments.call(this, [
            segment
        ]);
    }
    /**
   * Deletes multiple segments from the HL7 message
   *
   * @param {Array} segments array of 'Segment' constructors to be deleted, required
   * @api public
   */ deleteSegments(segments) {
        if (!Array.isArray(segments)) segments = [
            segments
        ];
        const segmentTypes = segments.map(({ type: type })=>type).filter((a, b, list)=>b === list.indexOf(a));
        var i = 0;
        const length = segments.length - 1;
        while(i <= length){
            delete this.transformed[segments[i].type][this.transformed[segments[i].type].indexOf(segments[i])];
            i++;
        }
        $1ad6f17e647c925e$var$_cleanse.call(this, segmentTypes);
    }
    /**
   * Returns all requested 'Segment' constructors at occur in the HL7 message after a specified start point
   *
   * @param {Object} start 'Segment' constructor that marks the starting point for the retrieval of segments, required
   * @param {String} name name of segment that you wish to retrieve, required
   * @param {Boolean} consecutive boolean telling the method to only grab segments that are consecutive or back to back in the HL7 message, optional
   * @param {String|Array} stop segment name or list of segment names that would trigger the method to stop collecting matching segments, optional
   * @api public
   */ getSegmentsAfter(start, name, consecutive, stop) {
        var group = [], previousIndex = null, stopSeg = null;
        consecutive = consecutive || false;
        if (typeof start !== "undefined" && start.constructor.name === "Segment") {
            if (typeof stop !== "undefined") {
                if (Array.isArray(stop)) {
                    var multiStop = [], stopIndex = null;
                    for(let i = 0; i < stop.length; i++)if (typeof this.transformed[stop[i]] !== "undefined") {
                        stopIndex = Array.isArray(this.transformed[stop[i]]) ? this.transformed[stop[i]].map((j)=>j.index).find((x)=>x > start.index) : this.transformed[stop[i]].index;
                        if (typeof stopIndex === "undefined") stopIndex = null;
                        if (stopIndex !== null) {
                            if (start.index > stopIndex) stopIndex = null;
                            if (stopIndex !== null) multiStop.push(stopIndex);
                        }
                    }
                    stopSeg = multiStop.length ? Math.min(...multiStop) : null;
                } else if (typeof this.transformed[stop] !== "undefined") {
                    stopSeg = Array.isArray(this.transformed[stop]) ? this.transformed[stop].map((i)=>i.index).find((x)=>x > start.index) : this.transformed[stop].index;
                    if (typeof stopSeg === "undefined") stopSeg = null;
                    if (stopSeg !== null) {
                        if (start.index > stopSeg) stopSeg = null;
                    }
                }
            }
            if ($1ad6f17e647c925e$var$_validSegment(name)) {
                if (typeof this.transformed[name] !== "undefined") {
                    for(let i = 0; i < this.transformed[name].length; i++)if (this.transformed[name][i].index > start.index) {
                        if (consecutive) {
                            if (previousIndex === null) group.push(this.transformed[name][i]);
                            else {
                                if (previousIndex + 1 === this.transformed[name][i].index) group.push(this.transformed[name][i]);
                                else return group;
                            }
                            previousIndex = this.transformed[name][i].index;
                        } else if (stopSeg !== null) {
                            if (this.transformed[name][i].index < stopSeg) group.push(this.transformed[name][i]);
                            else return group;
                        } else group.push(this.transformed[name][i]);
                    }
                    return group;
                } else return group;
            } else throw new Error(`Cannot get segments because segment name is invalid: ${name}`);
        } else throw new Error("Cannot retrieve start position from segment.");
    }
    /**
   * Moves existing segment after another existing segment
   *
   * @param {Object} segment 'Segment' constructor that is being moved, required
   * @param {Object} afterSegment 'Segment' constructor that marks where the segment is being moved after, required
   * @api public
   */ moveSegmentAfter(segment, afterSegment) {
        if (segment.constructor.name !== "Segment") throw new Error("Cannot create segment before because 'segment' parameter: is invalid.");
        if (afterSegment.constructor.name !== "Segment") throw new Error("Cannot create segment before because 'afterSegment' parameter: is invalid.");
        const newIndex = afterSegment.index + 1;
        $1ad6f17e647c925e$var$_moveSegment.call(this, newIndex, true);
        segment.index = newIndex;
    }
    /**
   * Moves existing segment before another existing segment
   *
   * @param {Object} segment 'Segment' constructor that is being moved, required
   * @param {Object} beforeSegment 'Segment' constructor that marks where the segment is being moved before, required
   * @api public
   */ moveSegmentBefore(segment, beforeSegment) {
        if (segment.constructor.name !== "Segment") throw new Error("Cannot create segment before because 'segment' parameter: is invalid.");
        if (beforeSegment.constructor.name !== "Segment") throw new Error("Cannot create segment before because 'beforeSegment' parameter: is invalid.");
        const newIndex = beforeSegment.index;
        $1ad6f17e647c925e$var$_moveSegment.call(this, newIndex, true);
        segment.index = newIndex;
    }
};

});

parcelRegister("jIrAL", function(module, exports) {
"use strict";

var $dBgTd = parcelRequire("dBgTd");
var $e5a78797c4262d1f$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $e5a78797c4262d1f$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $e5a78797c4262d1f$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $e5a78797c4262d1f$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $dBgTd();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $e5a78797c4262d1f$var$clipboardToIE11Formatting[options.format] || $e5a78797c4262d1f$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $e5a78797c4262d1f$var$format("message" in options ? options.message : $e5a78797c4262d1f$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $e5a78797c4262d1f$var$copy;

});
parcelRegister("dBgTd", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});


parcelRegister("289ZW", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire);
$parcel$export(module.exports, "loadModule", () => loadModule);

var $Wgg6o = parcelRequire("Wgg6o");

var $hPtJY = parcelRequire("hPtJY");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $Wgg6o.isBrowserBundle)() && Object.prototype.toString.call(typeof $hPtJY !== "undefined" ? $hPtJY : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ function dynamicRequire(mod, request) {
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("Wgg6o", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $0af207894032bdf2$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0af207894032bdf2$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}

});


parcelRegister("cvSY8", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds);
$parcel$export(module.exports, "timestampWithMs", () => timestampWithMs);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => browserPerformanceTimeOrigin);

var $42ap3 = parcelRequire("42ap3");

var $289ZW = parcelRequire("289ZW");
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance } = (0, $42ap3.getGlobalObject)();
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $289ZW.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $289ZW.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ var browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = (0, $42ap3.getGlobalObject)();
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
})();

});
parcelRegister("42ap3", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $2eff6b2a80d0a23d$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $2eff6b2a80d0a23d$export$7e223ec222791509);

var $289ZW = parcelRequire("289ZW");
/** Internal */ var $2eff6b2a80d0a23d$var$fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */ function $2eff6b2a80d0a23d$export$256479dc0cea61c4() {
    return (0, $289ZW.isNodeEnv)() ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : $2eff6b2a80d0a23d$var$fallbackGlobalObject;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */ function $2eff6b2a80d0a23d$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $2eff6b2a80d0a23d$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("b0Nlg", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", () => startIdleTransaction);
$parcel$export(module.exports, "addExtensionMethods", () => addExtensionMethods);

var $8x56E = parcelRequire("8x56E");

var $289ZW = parcelRequire("289ZW");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");

var $6IwWN = parcelRequire("6IwWN");

var $7pcHN = parcelRequire("7pcHN");

var $aRkAb = parcelRequire("aRkAb");

var $iwSqi = parcelRequire("iwSqi");
/** Returns all trace headers that are currently on the top scope. */ function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) return {
            "sentry-trace": span.toTraceparent()
        };
    }
    return {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $iwSqi.hasTracingEnabled)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            transactionSampling: {
                method: "explicitly_set"
            }
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            transactionSampling: {
                method: "client_sampler",
                // cast to number in case it's a boolean
                rate: Number(sampleRate)
            }
        });
    } else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
        transaction.setMetadata({
            transactionSampling: {
                method: "inheritance"
            }
        });
    } else {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            transactionSampling: {
                method: "client_rate",
                // cast to number in case it's a boolean
                rate: Number(sampleRate)
            }
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if ((0, $2zW56.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function _startTransaction(transactionContext, customSamplingContext) {
    var client = this.getClient();
    var options = client && client.getOptions() || {};
    let transaction = new (0, $aRkAb.Transaction)(transactionContext, this);
    transaction = sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function startIdleTransaction(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext) {
    var client = hub.getClient();
    var options = client && client.getOptions() || {};
    let transaction = new (0, $7pcHN.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, onScope);
    transaction = sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    return transaction;
}
/**
 * @private
 */ function _addTracingExtensions() {
    var carrier = (0, $8x56E.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
}
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    var carrier = (0, $8x56E.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    var packageToIntegrationMapping = {
        mongodb () {
            var integration = (0, $289ZW.dynamicRequire)(module, "./integrations/node/mongo");
            return new integration.Mongo();
        },
        mongoose () {
            var integration = (0, $289ZW.dynamicRequire)(module, "./integrations/node/mongo");
            return new integration.Mongo({
                mongoose: true
            });
        },
        mysql () {
            var integration = (0, $289ZW.dynamicRequire)(module, "./integrations/node/mysql");
            return new integration.Mysql();
        },
        pg () {
            var integration = (0, $289ZW.dynamicRequire)(module, "./integrations/node/postgres");
            return new integration.Postgres();
        }
    };
    var mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $289ZW.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    _addTracingExtensions();
    // Detect and automatically load specified integrations.
    if ((0, $289ZW.isNodeEnv)()) _autoloadDatabaseIntegrations();
    // If an error happens globally, we should make sure transaction status is set to error.
    (0, $6IwWN.registerErrorInstrumentation)();
}

});
parcelRegister("8x56E", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $63655dd03b5e846b$export$19eade501500c6c1);
$parcel$export(module.exports, "getCurrentHub", () => $63655dd03b5e846b$export$a07cdf6544bbd7c);

var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $42ap3 = parcelRequire("42ap3");
var $289ZW = parcelRequire("289ZW");
var $b1E2c = parcelRequire("b1E2c");

var $NU9Qs = parcelRequire("NU9Qs");

var $lvhwF = parcelRequire("lvhwF");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ var $63655dd03b5e846b$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $63655dd03b5e846b$var$DEFAULT_BREADCRUMBS = 100;
/**
 * A layer in the process stack.
 * @hidden
 */ /**
 * @inheritDoc
 */ class $63655dd03b5e846b$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ __init() {
        this._stack = [
            {}
        ];
    }
    /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $NU9Qs.Scope)(), _version = $63655dd03b5e846b$export$24a86ef7798177e4){
        this._version = _version;
        $63655dd03b5e846b$export$8c41bb232f1008b1.prototype.__init.call(this);
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        var scope = (0, $NU9Qs.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        var syntheticException = new Error("Sentry syntheticException");
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        var syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (event.type !== "transaction") this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope, client: client } = this.getStackTop();
        if (!scope || !client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $63655dd03b5e846b$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $cvSY8.dateTimestampInSeconds)();
        var mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        var finalBreadcrumb = beforeBreadcrumb ? (0, $4g0Ct.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ setContext(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (scope && client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        var oldHub = $63655dd03b5e846b$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $63655dd03b5e846b$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        return this._callExtensionMethod("startTransaction", context, customSamplingContext);
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) (0, $lvhwF.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        var global = (0, $42ap3.getGlobalObject)();
        const { userAgent: userAgent } = global.navigator || {};
        var session = (0, $lvhwF.makeSession)({
            release: release,
            environment: environment,
            ...scope && {
                user: scope.getUser()
            },
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === "ok") (0, $lvhwF.updateSession)(currentSession, {
                status: "exited"
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        var client = this.getClient();
        var options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope, client: client } = this.getStackTop();
        if (!scope) return;
        var session = scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    _callExtensionMethod(method, ...args) {
        var carrier = $63655dd03b5e846b$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $63655dd03b5e846b$export$19eade501500c6c1() {
    var carrier = (0, $42ap3.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $63655dd03b5e846b$export$4188a14ad302d1bc(hub) {
    var registry = $63655dd03b5e846b$export$19eade501500c6c1();
    var oldHub = $63655dd03b5e846b$export$bfa8a924a84a76b7(registry);
    $63655dd03b5e846b$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $63655dd03b5e846b$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $63655dd03b5e846b$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$63655dd03b5e846b$var$hasHubOnCarrier(registry) || $63655dd03b5e846b$export$bfa8a924a84a76b7(registry).isOlderThan($63655dd03b5e846b$export$24a86ef7798177e4)) $63655dd03b5e846b$export$849f05434e95d2f2(registry, new $63655dd03b5e846b$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $289ZW.isNodeEnv)()) return $63655dd03b5e846b$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $63655dd03b5e846b$export$bfa8a924a84a76b7(registry);
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $63655dd03b5e846b$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $63655dd03b5e846b$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $63655dd03b5e846b$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$63655dd03b5e846b$var$hasHubOnCarrier(activeDomain) || $63655dd03b5e846b$export$bfa8a924a84a76b7(activeDomain).isOlderThan($63655dd03b5e846b$export$24a86ef7798177e4)) {
            var registryHubTopStack = $63655dd03b5e846b$export$bfa8a924a84a76b7(registry).getStackTop();
            $63655dd03b5e846b$export$849f05434e95d2f2(activeDomain, new $63655dd03b5e846b$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $NU9Qs.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $63655dd03b5e846b$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $63655dd03b5e846b$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $63655dd03b5e846b$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $63655dd03b5e846b$export$bfa8a924a84a76b7(carrier) {
    return (0, $42ap3.getGlobalSingleton)("hub", ()=>new $63655dd03b5e846b$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $63655dd03b5e846b$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("4g0Ct", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $3199231328e69de5$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $3199231328e69de5$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $3199231328e69de5$export$af88d00dbe7f521);

var $42ap3 = parcelRequire("42ap3");
// TODO: Implement different loggers for different environments
var $3199231328e69de5$var$global = (0, $42ap3.getGlobalObject)();
/** Prefix for logging strings */ var $3199231328e69de5$var$PREFIX = "Sentry Logger ";
var $3199231328e69de5$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $3199231328e69de5$export$cda52e2a8927a2ca(callback) {
    var global = (0, $42ap3.getGlobalObject)();
    if (!("console" in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((level)=>{
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach((level)=>{
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $3199231328e69de5$var$makeLogger() {
    let enabled = false;
    var logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        }
    };
    if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $3199231328e69de5$export$cda52e2a8927a2ca(()=>{
                $3199231328e69de5$var$global.console[name](`${$3199231328e69de5$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let $3199231328e69de5$export$af88d00dbe7f521;
if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) $3199231328e69de5$export$af88d00dbe7f521 = (0, $42ap3.getGlobalSingleton)("logger", $3199231328e69de5$var$makeLogger);
else $3199231328e69de5$export$af88d00dbe7f521 = $3199231328e69de5$var$makeLogger();

});

parcelRegister("b1E2c", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $806ed7b2edb8ea09$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $806ed7b2edb8ea09$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $806ed7b2edb8ea09$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $806ed7b2edb8ea09$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $806ed7b2edb8ea09$export$6de4ffac6a2f1098);

var $42ap3 = parcelRequire("42ap3");

var $jL8lq = parcelRequire("jL8lq");

var $91U3U = parcelRequire("91U3U");
/**
 * Extended Window interface that allows for Crypto API usage in IE browsers
 */ /**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $806ed7b2edb8ea09$export$19f53698e68b2496() {
    var global = (0, $42ap3.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
    var getRandomByte = crypto && crypto.getRandomValues ? ()=>crypto.getRandomValues(new Uint8Array(1))[0] : ()=>Math.random() * 16;
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>(c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $806ed7b2edb8ea09$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $806ed7b2edb8ea09$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    var firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $806ed7b2edb8ea09$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $806ed7b2edb8ea09$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        var mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $806ed7b2edb8ea09$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $806ed7b2edb8ea09$export$d364f2020ab30578(input) {
    var match = input.match($806ed7b2edb8ea09$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $806ed7b2edb8ea09$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $91U3U.snipLine)(line, 0));
    frame.context_line = (0, $91U3U.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $91U3U.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $806ed7b2edb8ea09$export$6de4ffac6a2f1098(exception) {
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $jL8lq.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("jL8lq", function(module, exports) {

$parcel$export(module.exports, "fill", () => $e628e125e878fd27$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $e628e125e878fd27$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $e628e125e878fd27$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $e628e125e878fd27$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $e628e125e878fd27$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $e628e125e878fd27$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $e628e125e878fd27$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $e628e125e878fd27$export$d25f2688db1bb433);

var $ibKgU = parcelRequire("ibKgU");

var $2zW56 = parcelRequire("2zW56");

var $91U3U = parcelRequire("91U3U");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $e628e125e878fd27$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") try {
        $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $e628e125e878fd27$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $e628e125e878fd27$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $e628e125e878fd27$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $e628e125e878fd27$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $e628e125e878fd27$export$62ff257738bf57f5(value) {
    if ((0, $2zW56.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$e628e125e878fd27$var$getOwnProperties(value)
    };
    else if ((0, $2zW56.isEvent)(value)) {
        var newObj = {
            type: value.type,
            target: $e628e125e878fd27$var$serializeEventTarget(value.target),
            currentTarget: $e628e125e878fd27$var$serializeEventTarget(value.currentTarget),
            ...$e628e125e878fd27$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $2zW56.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $e628e125e878fd27$var$serializeEventTarget(target) {
    try {
        return (0, $2zW56.isElement)(target) ? (0, $ibKgU.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $e628e125e878fd27$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        var extractedProps = {};
        for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $e628e125e878fd27$export$b0244d5063c0b61b(exception, maxLength = 40) {
    var keys = Object.keys($e628e125e878fd27$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $91U3U.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $91U3U.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $e628e125e878fd27$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    var memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $2zW56.isPlainObject)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        var memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        var returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (var key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $e628e125e878fd27$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        var memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        var returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($e628e125e878fd27$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $e628e125e878fd27$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $2zW56.isPrimitive)(wat):
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("ibKgU", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $d3dd25a69ce66c78$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $d3dd25a69ce66c78$export$1cfafeee2987818b);

var $42ap3 = parcelRequire("42ap3");

var $2zW56 = parcelRequire("2zW56");
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        let height = 0;
        let len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        let nextStr;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d3dd25a69ce66c78$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        className = elem.className;
        if (className && (0, $2zW56.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    var allowedAttrs = [
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $d3dd25a69ce66c78$export$1cfafeee2987818b() {
    var global = (0, $42ap3.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return "";
    }
}

});
parcelRegister("2zW56", function(module, exports) {

$parcel$export(module.exports, "isError", () => $1e0be767ffa822d8$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $1e0be767ffa822d8$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $1e0be767ffa822d8$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $1e0be767ffa822d8$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $1e0be767ffa822d8$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $1e0be767ffa822d8$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $1e0be767ffa822d8$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $1e0be767ffa822d8$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $1e0be767ffa822d8$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $1e0be767ffa822d8$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $1e0be767ffa822d8$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $1e0be767ffa822d8$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $1e0be767ffa822d8$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $1e0be767ffa822d8$export$c9f5652083b8129d);
var $1e0be767ffa822d8$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$e6127cc7fe7395c3(wat) {
    switch($1e0be767ffa822d8$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $1e0be767ffa822d8$export$49034edbe6b62415(wat, Error);
    }
}
function $1e0be767ffa822d8$var$isBuiltin(wat, ty) {
    return $1e0be767ffa822d8$var$objectToString.call(wat) === `[object ${ty}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9f9636d330b71954(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$ef9e2056653f0c8e(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$12e869b2a583f783(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$844ec244b1367d54(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49841c62b9eff15(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $1e0be767ffa822d8$export$f5b060c2914b97c8(wat) {
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$bc2894c7158efbac(wat) {
    return $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("91U3U", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $692fb1c9fae23fc3$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $692fb1c9fae23fc3$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $692fb1c9fae23fc3$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $692fb1c9fae23fc3$export$cdded5b28a5f8c6d);

var $2zW56 = parcelRequire("2zW56");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.substr(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $692fb1c9fae23fc3$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    for(let i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */ function $692fb1c9fae23fc3$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $2zW56.isString)(value)) return false;
    if ((0, $2zW56.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === "string") return value.indexOf(pattern) !== -1;
    return false;
}
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ function $692fb1c9fae23fc3$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}

});



parcelRegister("NU9Qs", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $0960237c638309e1$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $0960237c638309e1$export$8e4e25f54d456511);

var $cvSY8 = parcelRequire("cvSY8");
var $42ap3 = parcelRequire("42ap3");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $j3a3y = parcelRequire("j3a3y");

var $lvhwF = parcelRequire("lvhwF");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $0960237c638309e1$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $0960237c638309e1$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        var newScope = new $0960237c638309e1$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $lvhwF.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts = {
            ...this._contexts,
            [key]: context
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            var updatedScope = captureContext(this);
            return updatedScope instanceof $0960237c638309e1$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $0960237c638309e1$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $2zW56.isPlainObject)(captureContext)) {
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === "number" ? Math.min(maxBreadcrumbs, $0960237c638309e1$var$MAX_BREADCRUMBS) : $0960237c638309e1$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = {
            timestamp: (0, $cvSY8.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        this._breadcrumbs = [
            ...this._breadcrumbs,
            mergedBreadcrumb
        ].slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies the current context and fingerprint to the event.
   * Note that breadcrumbs will be added by the client.
   * Also if the event has already breadcrumbs on it, we do not merge them.
   * @param event Event
   * @param hint May contain additional information about the original exception.
   * @hidden
   */ applyToEvent(event, hint = {}) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = {
                transaction: transactionName,
                ...event.tags
            };
        }
        this._applyFingerprint(event);
        event.breadcrumbs = [
            ...event.breadcrumbs || [],
            ...this._breadcrumbs
        ];
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata
        };
        return this._notifyEventProcessors([
            ...$0960237c638309e1$var$getGlobalEventProcessors(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * This will be called after {@link applyToEvent} is finished.
   */ _notifyEventProcessors(processors, event, hint, index = 0) {
        return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
            var processor = processors[index];
            if (event === null || typeof processor !== "function") resolve(event);
            else {
                var result = processor({
                    ...event
                }, hint);
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && processor.id && result === null && (0, $4g0Ct.logger).log(`Event processor "${processor.id}" dropped event`);
                if ((0, $2zW56.isThenable)(result)) result.then((final)=>this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
                else this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
/**
 * Returns the global event processors.
 */ function $0960237c638309e1$var$getGlobalEventProcessors() {
    return (0, $42ap3.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $0960237c638309e1$export$8e4e25f54d456511(callback) {
    $0960237c638309e1$var$getGlobalEventProcessors().push(callback);
}

});
parcelRegister("j3a3y", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $dde6191ffa17294f$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $dde6191ffa17294f$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $dde6191ffa17294f$export$78e43115b553f358);

var $2zW56 = parcelRequire("2zW56");
/** SyncPromise internal states */ var $dde6191ffa17294f$var$States;
(function(States) {
    /** Pending */ var PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ var RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ var REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($dde6191ffa17294f$var$States || ($dde6191ffa17294f$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $dde6191ffa17294f$export$1fda8aa4d135f8aa(value) {
    return new $dde6191ffa17294f$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $dde6191ffa17294f$export$78e43115b553f358(reason) {
    return new $dde6191ffa17294f$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $dde6191ffa17294f$export$6f292d4960313241 {
    __init() {
        this._state = $dde6191ffa17294f$var$States.PENDING;
    }
    __init2() {
        this._handlers = [];
    }
    constructor(executor){
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init2.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init3.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init4.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init5.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init6.call(this);
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init3() {
        this._resolve = (value)=>{
            this._setResult($dde6191ffa17294f$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init4() {
        this._reject = (reason)=>{
            this._setResult($dde6191ffa17294f$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init5() {
        this._setResult = (state, value)=>{
            if (this._state !== $dde6191ffa17294f$var$States.PENDING) return;
            if ((0, $2zW56.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init6() {
        this._executeHandlers = ()=>{
            if (this._state === $dde6191ffa17294f$var$States.PENDING) return;
            var cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $dde6191ffa17294f$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $dde6191ffa17294f$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});

parcelRegister("lvhwF", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $fa7a168528eec8de$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $fa7a168528eec8de$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $fa7a168528eec8de$export$56521d9ba90f62ee);

var $jL8lq = parcelRequire("jL8lq");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $fa7a168528eec8de$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    var startingTime = (0, $cvSY8.timestampInSeconds)();
    var session = {
        sid: (0, $b1E2c.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$fa7a168528eec8de$var$sessionToJSON(session)
    };
    if (context) $fa7a168528eec8de$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ function $fa7a168528eec8de$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $cvSY8.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $b1E2c.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $fa7a168528eec8de$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $fa7a168528eec8de$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $fa7a168528eec8de$var$sessionToJSON(session) {
    return (0, $jL8lq.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});



parcelRegister("6IwWN", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $4e4068cc7b2f1e19$export$637857c1d87b640c);

var $js14m = parcelRequire("js14m");
var $4g0Ct = parcelRequire("4g0Ct");

var $iwSqi = parcelRequire("iwSqi");
/**
 * Configures global error listeners
 */ function $4e4068cc7b2f1e19$export$637857c1d87b640c() {
    (0, $js14m.addInstrumentationHandler)("error", $4e4068cc7b2f1e19$var$errorCallback);
    (0, $js14m.addInstrumentationHandler)("unhandledrejection", $4e4068cc7b2f1e19$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $4e4068cc7b2f1e19$var$errorCallback() {
    var activeTransaction = (0, $iwSqi.getActiveTransaction)();
    if (activeTransaction) {
        var status = "internal_error";
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}

});
parcelRegister("js14m", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $e2917634788cccfb$export$285b9172a3741fb7);

var $42ap3 = parcelRequire("42ap3");

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");

var $jL8lq = parcelRequire("jL8lq");

var $16dZf = parcelRequire("16dZf");

var $esO9h = parcelRequire("esO9h");
var $e2917634788cccfb$var$global = (0, $42ap3.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $e2917634788cccfb$var$handlers = {};
var $e2917634788cccfb$var$instrumented = {};
/** Instruments given API */ function $e2917634788cccfb$var$instrument(type) {
    if ($e2917634788cccfb$var$instrumented[type]) return;
    $e2917634788cccfb$var$instrumented[type] = true;
    switch(type){
        case "console":
            $e2917634788cccfb$var$instrumentConsole();
            break;
        case "dom":
            $e2917634788cccfb$var$instrumentDOM();
            break;
        case "xhr":
            $e2917634788cccfb$var$instrumentXHR();
            break;
        case "fetch":
            $e2917634788cccfb$var$instrumentFetch();
            break;
        case "history":
            $e2917634788cccfb$var$instrumentHistory();
            break;
        case "error":
            $e2917634788cccfb$var$instrumentError();
            break;
        case "unhandledrejection":
            $e2917634788cccfb$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("unknown instrumentation type:", type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e2917634788cccfb$export$285b9172a3741fb7(type, callback) {
    $e2917634788cccfb$var$handlers[type] = $e2917634788cccfb$var$handlers[type] || [];
    $e2917634788cccfb$var$handlers[type].push(callback);
    $e2917634788cccfb$var$instrument(type);
}
/** JSDoc */ function $e2917634788cccfb$var$triggerHandlers(type, data) {
    if (!type || !$e2917634788cccfb$var$handlers[type]) return;
    for (var handler of $e2917634788cccfb$var$handlers[type] || [])try {
        handler(data);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $16dZf.getFunctionName)(handler)}\nError:`, e);
    }
}
/** JSDoc */ function $e2917634788cccfb$var$instrumentConsole() {
    if (!("console" in $e2917634788cccfb$var$global)) return;
    (0, $4g0Ct.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $e2917634788cccfb$var$global.console)) return;
        (0, $jL8lq.fill)($e2917634788cccfb$var$global.console, level, function(originalConsoleMethod) {
            return function(...args) {
                $e2917634788cccfb$var$triggerHandlers("console", {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($e2917634788cccfb$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $e2917634788cccfb$var$instrumentFetch() {
    if (!(0, $esO9h.supportsNativeFetch)()) return;
    (0, $jL8lq.fill)($e2917634788cccfb$var$global, "fetch", function(originalFetch) {
        return function(...args) {
            var handlerData = {
                args: args,
                fetchData: {
                    method: $e2917634788cccfb$var$getFetchMethod(args),
                    url: $e2917634788cccfb$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $e2917634788cccfb$var$triggerHandlers("fetch", {
                ...handlerData
            });
            return originalFetch.apply($e2917634788cccfb$var$global, args).then((response)=>{
                $e2917634788cccfb$var$triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                });
                return response;
            }, (error)=>{
                $e2917634788cccfb$var$triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                });
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/** Extract `method` from fetch call arguments */ function $e2917634788cccfb$var$getFetchMethod(fetchArgs = []) {
    if ("Request" in $e2917634788cccfb$var$global && (0, $2zW56.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return "GET";
}
/** Extract `url` from fetch call arguments */ function $e2917634788cccfb$var$getFetchUrl(fetchArgs = []) {
    if (typeof fetchArgs[0] === "string") return fetchArgs[0];
    if ("Request" in $e2917634788cccfb$var$global && (0, $2zW56.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/** JSDoc */ function $e2917634788cccfb$var$instrumentXHR() {
    if (!("XMLHttpRequest" in $e2917634788cccfb$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $jL8lq.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                method: (0, $2zW56.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            if ((0, $2zW56.isString)(url) && xhrInfo.method === "POST" && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $e2917634788cccfb$var$triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ("onreadystatechange" in xhr && typeof xhr.onreadystatechange === "function") (0, $jL8lq.fill)(xhr, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener("readystatechange", onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $jL8lq.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $e2917634788cccfb$var$triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
let $e2917634788cccfb$var$lastHref;
/** JSDoc */ function $e2917634788cccfb$var$instrumentHistory() {
    if (!(0, $esO9h.supportsHistory)()) return;
    var oldOnPopState = $e2917634788cccfb$var$global.onpopstate;
    $e2917634788cccfb$var$global.onpopstate = function(...args) {
        var to = $e2917634788cccfb$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $e2917634788cccfb$var$lastHref;
        $e2917634788cccfb$var$lastHref = to;
        $e2917634788cccfb$var$triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $e2917634788cccfb$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $e2917634788cccfb$var$lastHref = to;
                $e2917634788cccfb$var$triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $jL8lq.fill)($e2917634788cccfb$var$global.history, "pushState", historyReplacementFunction);
    (0, $jL8lq.fill)($e2917634788cccfb$var$global.history, "replaceState", historyReplacementFunction);
}
var $e2917634788cccfb$var$debounceDuration = 1000;
let $e2917634788cccfb$var$debounceTimerID;
let $e2917634788cccfb$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $e2917634788cccfb$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $e2917634788cccfb$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== "keypress") return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $e2917634788cccfb$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $e2917634788cccfb$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($e2917634788cccfb$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === "keypress" ? "input" : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($e2917634788cccfb$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $e2917634788cccfb$var$lastCapturedEvent = event;
        } else if ($e2917634788cccfb$var$shouldShortcircuitPreviousDebounce($e2917634788cccfb$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $e2917634788cccfb$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($e2917634788cccfb$var$debounceTimerID);
        $e2917634788cccfb$var$debounceTimerID = $e2917634788cccfb$var$global.setTimeout(()=>{
            $e2917634788cccfb$var$debounceTimerID = undefined;
        }, $e2917634788cccfb$var$debounceDuration);
    };
}
/** JSDoc */ function $e2917634788cccfb$var$instrumentDOM() {
    if (!("document" in $e2917634788cccfb$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $e2917634788cccfb$var$triggerHandlers.bind(null, "dom");
    var globalDOMEventHandler = $e2917634788cccfb$var$makeDOMEventHandler(triggerDOMHandler, true);
    $e2917634788cccfb$var$global.document.addEventListener("click", globalDOMEventHandler, false);
    $e2917634788cccfb$var$global.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        var proto = $e2917634788cccfb$var$global[target] && $e2917634788cccfb$var$global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $jL8lq.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    var el = this;
                    var handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $e2917634788cccfb$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $jL8lq.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    var el = this;
                    var handlers = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type];
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
let $e2917634788cccfb$var$_oldOnErrorHandler = null;
/** JSDoc */ function $e2917634788cccfb$var$instrumentError() {
    $e2917634788cccfb$var$_oldOnErrorHandler = $e2917634788cccfb$var$global.onerror;
    $e2917634788cccfb$var$global.onerror = function(msg, url, line, column, error) {
        $e2917634788cccfb$var$triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($e2917634788cccfb$var$_oldOnErrorHandler) return $e2917634788cccfb$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
let $e2917634788cccfb$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $e2917634788cccfb$var$instrumentUnhandledRejection() {
    $e2917634788cccfb$var$_oldOnUnhandledRejectionHandler = $e2917634788cccfb$var$global.onunhandledrejection;
    $e2917634788cccfb$var$global.onunhandledrejection = function(e) {
        $e2917634788cccfb$var$triggerHandlers("unhandledrejection", e);
        if ($e2917634788cccfb$var$_oldOnUnhandledRejectionHandler) return $e2917634788cccfb$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("16dZf", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $0cd1337813906a62$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $0cd1337813906a62$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $0cd1337813906a62$export$aad197c7121a6651);

var $g0HNG = parcelRequire("g0HNG");
var $0cd1337813906a62$var$STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $0cd1337813906a62$export$a5739666fb2d03d4(...parsers) {
    var sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        var frames = [];
        for (var line of stack.split("\n").slice(skipFirst)){
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            var cleanedLine = line.replace(/\(error: (.*)\)/, "$1");
            for (var parser of sortedParsers){
                var frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
        }
        return $0cd1337813906a62$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $0cd1337813906a62$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $0cd1337813906a62$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * @hidden
 */ function $0cd1337813906a62$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    let localStack = stack;
    var firstFrameFunction = localStack[0].function || "";
    var lastFrameFunction = localStack[localStack.length - 1].function || "";
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf("captureMessage") !== -1 || firstFrameFunction.indexOf("captureException") !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf("sentryWrapped") !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $0cd1337813906a62$var$STACKTRACE_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[0].filename,
            function: frame.function || "?"
        })).reverse();
}
var $0cd1337813906a62$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $0cd1337813906a62$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $0cd1337813906a62$var$defaultFunctionName;
        return fn.name || $0cd1337813906a62$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $0cd1337813906a62$var$defaultFunctionName;
    }
}
function $0cd1337813906a62$var$node(getModule) {
    var FILENAME_MATCH = /^\s*[-]{4,}$/;
    var FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    return (line)=>{
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        var lineMatch = line.match(FULL_MATCH);
        if (!lineMatch) return undefined;
        let object;
        let method;
        let functionName;
        let typeName;
        let methodName;
        if (lineMatch[1]) {
            functionName = lineMatch[1];
            let methodStart = functionName.lastIndexOf(".");
            if (functionName[methodStart - 1] === ".") methodStart--;
            if (methodStart > 0) {
                object = functionName.substr(0, methodStart);
                method = functionName.substr(methodStart + 1);
                var objectEnd = object.indexOf(".Module");
                if (objectEnd > 0) {
                    functionName = functionName.substr(objectEnd + 1);
                    object = object.substr(0, objectEnd);
                }
            }
            typeName = undefined;
        }
        if (method) {
            typeName = object;
            methodName = method;
        }
        if (method === "<anonymous>") {
            methodName = undefined;
            functionName = undefined;
        }
        if (functionName === undefined) {
            methodName = methodName || "<anonymous>";
            functionName = typeName ? `${typeName}.${methodName}` : methodName;
        }
        var filename = (0, $g0HNG._optionalChain)([
            lineMatch,
            "access",
            (_)=>_[2],
            "optionalAccess",
            (_2)=>_2.startsWith,
            "call",
            (_3)=>_3("file://")
        ]) ? lineMatch[2].substr(7) : lineMatch[2];
        var isNative = lineMatch[5] === "native";
        var isInternal = isNative || filename && !filename.startsWith("/") && !filename.startsWith(".") && filename.indexOf(":\\") !== 1;
        // in_app is all that's not an internal Node function or a module within node_modules
        // note that isNative appears to return true even for node core libraries
        // see https://github.com/getsentry/raven-node/issues/176
        var in_app = !isInternal && filename !== undefined && !filename.includes("node_modules/");
        return {
            filename: filename,
            module: (0, $g0HNG._optionalChain)([
                getModule,
                "optionalCall",
                (_4)=>_4(filename)
            ]),
            function: functionName,
            lineno: parseInt(lineMatch[3], 10) || undefined,
            colno: parseInt(lineMatch[4], 10) || undefined,
            in_app: in_app
        };
    };
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $0cd1337813906a62$export$673345a0da635a78(getModule) {
    return [
        90,
        $0cd1337813906a62$var$node(getModule)
    ];
}

});
parcelRegister("g0HNG", function(module, exports) {

$parcel$export(module.exports, "_optionalChain", () => $ba7e9f49429c2354$export$3cc482e6b02f32f7);
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $ba7e9f49429c2354$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

});


parcelRegister("esO9h", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", () => $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $a87a94b8e4ff7f26$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $a87a94b8e4ff7f26$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsHistory", () => $a87a94b8e4ff7f26$export$67fc34576016d6ec);

var $42ap3 = parcelRequire("42ap3");

var $4g0Ct = parcelRequire("4g0Ct");
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in (0, $42ap3.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request("");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ function $a87a94b8e4ff7f26$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a87a94b8e4ff7f26$export$c82d238e23c40b21() {
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $42ap3.getGlobalObject)();
    // Fast path to avoid DOM I/O
    if ($a87a94b8e4ff7f26$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    var doc = global.document;
    if (doc && typeof doc.createElement === "function") try {
        var sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) result = $a87a94b8e4ff7f26$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$531055a6c684a70a() {
    return "ReportingObserver" in (0, $42ap3.getGlobalObject)();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $42ap3.getGlobalObject)();
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = "history" in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("iwSqi", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $d7d56e6ebc6c1ccf$export$5008da00b1b6dee6);
$parcel$export(module.exports, "getActiveTransaction", () => $d7d56e6ebc6c1ccf$export$a7feb32fdd923295);
$parcel$export(module.exports, "msToSec", () => $d7d56e6ebc6c1ccf$export$b4785dbd4a81b33f);

var $8x56E = parcelRequire("8x56E");

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $d7d56e6ebc6c1ccf$export$5008da00b1b6dee6(maybeOptions) {
    var client = (0, $8x56E.getCurrentHub)().getClient();
    var options = maybeOptions || client && client.getOptions();
    return !!options && ("tracesSampleRate" in options || "tracesSampler" in options);
}
/** Grabs active transaction off scope, if any */ function $d7d56e6ebc6c1ccf$export$a7feb32fdd923295(maybeHub) {
    var hub = maybeHub || (0, $8x56E.getCurrentHub)();
    var scope = hub.getScope();
    return scope && scope.getTransaction();
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $d7d56e6ebc6c1ccf$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */ function $d7d56e6ebc6c1ccf$export$a3ba11b11516dfdb(time) {
    return time * 1000;
}

});


parcelRegister("7pcHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IDLE_TIMEOUT", () => $5644b93d607dbbeb$export$68a507a5e6cb6de5);
$parcel$export(module.exports, "DEFAULT_FINAL_TIMEOUT", () => $5644b93d607dbbeb$export$a9bb9f6cf9cd1d42);
$parcel$export(module.exports, "IdleTransaction", () => $5644b93d607dbbeb$export$b279e6bd7040371f);

var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");

var $fX68s = parcelRequire("fX68s");

var $aRkAb = parcelRequire("aRkAb");
var $5644b93d607dbbeb$export$68a507a5e6cb6de5 = 1000;
var $5644b93d607dbbeb$export$a9bb9f6cf9cd1d42 = 30000;
var $5644b93d607dbbeb$export$31c453b5fe09788d = 5000;
/**
 * @inheritDoc
 */ class $5644b93d607dbbeb$export$370d6113c18ba86c extends (0, $fX68s.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = (endTimestamp)=>{
                span.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $cvSY8.timestampWithMs)();
                this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $5644b93d607dbbeb$export$b279e6bd7040371f extends (0, $aRkAb.Transaction) {
    // Activities store a list of active spans
    __init() {
        this.activities = {};
    }
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    __init2() {
        this._heartbeatCounter = 0;
    }
    // We should not use heartbeat if we finished a transaction
    __init3() {
        this._finished = false;
    }
    __init4() {
        this._beforeFinishCallbacks = [];
    }
    /**
   * Timer that tracks Transaction idleTimeout
   */ constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $5644b93d607dbbeb$export$68a507a5e6cb6de5, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $5644b93d607dbbeb$export$a9bb9f6cf9cd1d42, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._onScope = _onScope;
        $5644b93d607dbbeb$export$b279e6bd7040371f.prototype.__init.call(this);
        $5644b93d607dbbeb$export$b279e6bd7040371f.prototype.__init2.call(this);
        $5644b93d607dbbeb$export$b279e6bd7040371f.prototype.__init3.call(this);
        $5644b93d607dbbeb$export$b279e6bd7040371f.prototype.__init4.call(this);
        if (_onScope) {
            // There should only be one active transaction on the scope
            $5644b93d607dbbeb$var$clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
            _idleHub.configureScope((scope)=>scope.setSpan(this));
        }
        this._startIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this.finish();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ finish(endTimestamp = (0, $cvSY8.timestampWithMs)()) {
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestamp * 1000).toISOString(), this.op);
            for (var callback of this._beforeFinishCallbacks)callback(this, endTimestamp);
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus("cancelled");
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                var keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", JSON.stringify(span, undefined, 2));
                return keepSpan;
            });
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] flushing IdleTransaction");
        } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) $5644b93d607dbbeb$var$clearActiveTransaction(this._idleHub);
        return super.finish(endTimestamp);
    }
    /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        if (!this.spanRecorder) {
            var pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            var popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            this.spanRecorder = new $5644b93d607dbbeb$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idletimeout, if there is one
   */ _cancelIdleTimeout() {
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
        }
    }
    /**
   * Creates an idletimeout
   */ _startIdleTimeout(endTimestamp) {
        this._cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) this.finish(endTimestamp);
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this._cancelIdleTimeout();
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] popActivity ${spanId}`);
            delete this.activities[spanId];
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            var endTimestamp = (0, $cvSY8.timestampWithMs)() + this._idleTimeout / 1000;
            this._startIdleTimeout(endTimestamp);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        var heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter += 1;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
            this.setStatus("deadline_exceeded");
            this.finish();
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, $5644b93d607dbbeb$export$31c453b5fe09788d);
    }
}
/**
 * Reset transaction on scope to `undefined`
 */ function $5644b93d607dbbeb$var$clearActiveTransaction(hub) {
    var scope = hub.getScope();
    if (scope) {
        var transaction = scope.getTransaction();
        if (transaction) scope.setSpan(undefined);
    }
}

});
parcelRegister("fX68s", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $b9d120122ceccb68$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $b9d120122ceccb68$export$5f1714a13ed34c01);

var $8bvs9 = parcelRequire("8bvs9");

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $b9d120122ceccb68$export$10c95c129cd0d4fe {
    __init() {
        this.spans = [];
    }
    constructor(maxlen = 1000){
        $b9d120122ceccb68$export$10c95c129cd0d4fe.prototype.__init.call(this);
        this._maxlen = maxlen;
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $b9d120122ceccb68$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ __init2() {
        this.traceId = (0, $b1E2c.uuid4)();
    }
    /**
   * @inheritDoc
   */ __init3() {
        this.spanId = (0, $b1E2c.uuid4)().substring(16);
    }
    /**
   * @inheritDoc
   */ /**
   * Internal keeper of the status
   */ /**
   * @inheritDoc
   */ /**
   * Timestamp in seconds when the span was created.
   */ __init4() {
        this.startTimestamp = (0, $cvSY8.timestampWithMs)();
    }
    /**
   * Timestamp in seconds when the span ended.
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ __init5() {
        this.tags = {};
    }
    /**
   * @inheritDoc
   */ __init6() {
        this.data = {};
    }
    /**
   * List of spans that were finalized
   */ /**
   * @inheritDoc
   */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext){
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init2.call(this);
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init3.call(this);
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init4.call(this);
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init5.call(this);
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init6.call(this);
        if (!spanContext) return this;
        if (spanContext.traceId) this.traceId = spanContext.traceId;
        if (spanContext.spanId) this.spanId = spanContext.spanId;
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.data) this.data = spanContext.data;
        if (spanContext.tags) this.tags = spanContext.tags;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.startTimestamp) this.startTimestamp = spanContext.startTimestamp;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
    }
    /**
   * @inheritDoc
   */ startChild(spanContext) {
        var childSpan = new $b9d120122ceccb68$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        });
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && childSpan.transaction) {
            var opStr = spanContext && spanContext.op || "< unknown op >";
            var nameStr = childSpan.transaction.name || "< unknown name >";
            var idStr = childSpan.transaction.spanId;
            var logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                logMessage: logMessage
            };
            (0, $4g0Ct.logger).log(logMessage);
        }
        return childSpan;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setData(key, value) {
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this.status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        this.setTag("http.status_code", String(httpStatus));
        var spanStatus = $b9d120122ceccb68$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== "unknown_error") this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritDoc
   */ isSuccess() {
        return this.status === "ok";
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && // Don't call this for transactions
        this.transaction && this.transaction.spanId !== this.spanId) {
            const { logMessage: logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
            if (logMessage) (0, $4g0Ct.logger).log(logMessage.replace("Starting", "Finishing"));
        }
        this.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $cvSY8.timestampWithMs)();
    }
    /**
   * @inheritDoc
   */ toTraceparent() {
        let sampledString = "";
        if (this.sampled !== undefined) sampledString = this.sampled ? "-1" : "-0";
        return `${this.traceId}-${this.spanId}${sampledString}`;
    }
    /**
   * @inheritDoc
   */ toContext() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(spanContext) {
        this.data = (0, $8bvs9._nullishCoalesce)(spanContext.data, ()=>({}));
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = (0, $8bvs9._nullishCoalesce)(spanContext.spanId, ()=>this.spanId);
        this.startTimestamp = (0, $8bvs9._nullishCoalesce)(spanContext.startTimestamp, ()=>this.startTimestamp);
        this.status = spanContext.status;
        this.tags = (0, $8bvs9._nullishCoalesce)(spanContext.tags, ()=>({}));
        this.traceId = (0, $8bvs9._nullishCoalesce)(spanContext.traceId, ()=>this.traceId);
        return this;
    }
    /**
   * @inheritDoc
   */ getTraceContext() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ toJSON() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId
        });
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $b9d120122ceccb68$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}

});
parcelRegister("8bvs9", function(module, exports) {

$parcel$export(module.exports, "_nullishCoalesce", () => $5f57bfb89049a269$export$8db64e83cc1a933c);
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $5f57bfb89049a269$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

});


parcelRegister("aRkAb", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $7e7ed1ea7bbcc692$export$febc5573c75cefb0);

var $8bvs9 = parcelRequire("8bvs9");

var $8x56E = parcelRequire("8x56E");

var $dzA7g = parcelRequire("dzA7g");
var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");

var $fX68s = parcelRequire("fX68s");
/** JSDoc */ class $7e7ed1ea7bbcc692$export$febc5573c75cefb0 extends (0, $fX68s.Span) {
    /**
   * The reference to the current hub.
   */ __init() {
        this._measurements = {};
    }
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(transactionContext, hub){
        super(transactionContext);
        $7e7ed1ea7bbcc692$export$febc5573c75cefb0.prototype.__init.call(this);
        this._hub = hub || (0, $8x56E.getCurrentHub)();
        this._name = transactionContext.name || "";
        this.metadata = {
            ...transactionContext.metadata,
            spanMetadata: {}
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        this.transaction = this;
    }
    /** Getter for `name` property */ get name() {
        return this._name;
    }
    /** Setter for `name` property, which also sets `source` */ set name(newName) {
        this._name = newName;
        this.metadata.source = "custom";
    }
    /**
   * JSDoc
   */ setName(name, source = "custom") {
        this.name = name;
        this.metadata.source = source;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        if (!this.spanRecorder) this.spanRecorder = new (0, $fX68s.SpanRecorder)(maxlen);
        this.spanRecorder.add(this);
    }
    /**
   * @inheritDoc
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * @inheritDoc
   */ setMetadata(newMetadata) {
        this.metadata = {
            ...this.metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this.name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.finish(endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            var client = this._hub.getClient();
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((s)=>s !== this && s.endTimestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce((prev, current)=>{
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        var metadata = this.metadata;
        var transaction = {
            contexts: {
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                baggage: this.getBaggage()
            },
            ...metadata.source && {
                transaction_info: {
                    source: metadata.source
                }
            }
        };
        var hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        var spanContext = super.toContext();
        return (0, $jL8lq.dropUndefinedKeys)({
            ...spanContext,
            name: this.name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        super.updateWithContext(transactionContext);
        this.name = (0, $8bvs9._nullishCoalesce)(transactionContext.name, ()=>"");
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   */ getBaggage() {
        var existingBaggage = this.metadata.baggage;
        // Only add Sentry baggage items to baggage, if baggage does not exist yet or it is still
        // empty and mutable
        var finalBaggage = !existingBaggage || (0, $dzA7g.isBaggageMutable)(existingBaggage) ? this._populateBaggageWithSentryValues(existingBaggage) : existingBaggage;
        // Update the baggage stored on the transaction.
        this.metadata.baggage = finalBaggage;
        return finalBaggage;
    }
    /**
   * Collects and adds data to the passed baggage object.
   *
   * Note: This function does not explicitly check if the passed baggage object is allowed
   * to be modified. Implicitly, `setBaggageValue` will not make modification to the object
   * if it was already set immutable.
   *
   * After adding the data, the baggage object is set immutable to prevent further modifications.
   *
   * @param baggage
   *
   * @returns modified and immutable baggage object
   */ _populateBaggageWithSentryValues(baggage = (0, $dzA7g.createBaggage)({})) {
        var hub = this._hub || (0, $8x56E.getCurrentHub)();
        var client = hub && hub.getClient();
        if (!client) return baggage;
        const { environment: environment, release: release } = client.getOptions() || {};
        const { publicKey: public_key } = client.getDsn() || {};
        var sample_rate = this.metadata && this.metadata.transactionSampling && this.metadata.transactionSampling.rate && this.metadata.transactionSampling.rate.toString();
        var scope = hub.getScope();
        const { segment: user_segment } = scope && scope.getUser() || {};
        var source = this.metadata.source;
        var transaction = source && source !== "url" ? this.name : undefined;
        return (0, $dzA7g.createBaggage)((0, $jL8lq.dropUndefinedKeys)({
            environment: environment,
            release: release,
            transaction: transaction,
            user_segment: user_segment,
            public_key: public_key,
            trace_id: this.traceId,
            sample_rate: sample_rate,
            ...(0, $dzA7g.getSentryBaggageItems)(baggage)
        }), "", false);
    }
}

});
parcelRegister("dzA7g", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", () => $9e1a8f302f19c673$export$9ca9946bd449ac06);
$parcel$export(module.exports, "createBaggage", () => $9e1a8f302f19c673$export$1034a425c7384452);
$parcel$export(module.exports, "isBaggageMutable", () => $9e1a8f302f19c673$export$70f99813104b61a9);
$parcel$export(module.exports, "getSentryBaggageItems", () => $9e1a8f302f19c673$export$40baa2960a12f158);
$parcel$export(module.exports, "mergeAndSerializeBaggage", () => $9e1a8f302f19c673$export$878dd31bdda95e7a);
$parcel$export(module.exports, "parseBaggageSetMutability", () => $9e1a8f302f19c673$export$9f844442d2ce6374);

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");
var $9e1a8f302f19c673$export$9ca9946bd449ac06 = "baggage";
var $9e1a8f302f19c673$export$6e69537d67fa20f = "sentry-";
var $9e1a8f302f19c673$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ var $9e1a8f302f19c673$export$bdd844ddb2def819 = 8192;
/** Create an instance of Baggage */ function $9e1a8f302f19c673$export$1034a425c7384452(initItems, baggageString = "", mutable = true) {
    return [
        {
            ...initItems
        },
        baggageString,
        mutable
    ];
}
/** Get a value from baggage */ function $9e1a8f302f19c673$export$2584a8c20e5ce83a(baggage, key) {
    return baggage[0][key];
}
/** Add a value to baggage */ function $9e1a8f302f19c673$export$ac14bf387fbe4d5d(baggage, key, value) {
    if ($9e1a8f302f19c673$export$70f99813104b61a9(baggage)) baggage[0][key] = value;
}
/** Check if the Sentry part of the passed baggage (i.e. the first element in the tuple) is empty */ function $9e1a8f302f19c673$export$dbc20483d8a38073(baggage) {
    return Object.keys(baggage[0]).length === 0;
}
/** Returns Sentry specific baggage values */ function $9e1a8f302f19c673$export$40baa2960a12f158(baggage) {
    return baggage[0];
}
/**
 * Returns 3rd party baggage string of @param baggage
 * @param baggage
 */ function $9e1a8f302f19c673$export$47e5d8a6a267d89b(baggage) {
    return baggage[1];
}
/**
 * Checks if baggage is mutable
 * @param baggage
 * @returns true if baggage is mutable, else false
 */ function $9e1a8f302f19c673$export$70f99813104b61a9(baggage) {
    return baggage[2];
}
/**
 * Sets the passed baggage immutable
 * @param baggage
 */ function $9e1a8f302f19c673$export$744e521d84c86d23(baggage) {
    baggage[2] = false;
}
/** Serialize a baggage object */ function $9e1a8f302f19c673$export$42d6b35c33d40ea3(baggage) {
    return Object.keys(baggage[0]).reduce((prev, key)=>{
        var val = baggage[0][key];
        var baggageEntry = `${$9e1a8f302f19c673$export$6e69537d67fa20f}${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
        var newVal = prev === "" ? baggageEntry : `${prev},${baggageEntry}`;
        if (newVal.length > $9e1a8f302f19c673$export$bdd844ddb2def819) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Not adding key: ${key} with val: ${val} to baggage due to exceeding baggage size limits.`);
            return prev;
        } else return newVal;
    }, baggage[1]);
}
/**
 * Parse a baggage header from a string or a string array and return a Baggage object
 *
 * If @param includeThirdPartyEntries is set to true, third party baggage entries are added to the Baggage object
 * (This is necessary for merging potentially pre-existing baggage headers in outgoing requests with
 * our `sentry-` values)
 */ function $9e1a8f302f19c673$export$397de414d189db00(inputBaggageValue, includeThirdPartyEntries = false) {
    // Adding this check here because we got reports of this function failing due to the input value
    // not being a string. This debug log might help us determine what's going on here.
    if (!Array.isArray(inputBaggageValue) && !(0, $2zW56.isString)(inputBaggageValue) || typeof inputBaggageValue === "number") {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("[parseBaggageHeader] Received input value of incompatible type: ", typeof inputBaggageValue, inputBaggageValue);
        // Gonna early-return an empty baggage object so that we don't fail later on
        return $9e1a8f302f19c673$export$1034a425c7384452({}, "");
    }
    var baggageEntries = ((0, $2zW56.isString)(inputBaggageValue) ? inputBaggageValue : inputBaggageValue.join(",")).split(",").map((entry)=>entry.trim()).filter((entry)=>entry !== "" && (includeThirdPartyEntries || $9e1a8f302f19c673$export$eb0401070c617ea5.test(entry)));
    return baggageEntries.reduce(([baggageObj, baggageString], curr)=>{
        const [key, val] = curr.split("=");
        if ($9e1a8f302f19c673$export$eb0401070c617ea5.test(key)) {
            var baggageKey = decodeURIComponent(key.split("-")[1]);
            return [
                {
                    ...baggageObj,
                    [baggageKey]: decodeURIComponent(val)
                },
                baggageString,
                true
            ];
        } else return [
            baggageObj,
            baggageString === "" ? curr : `${baggageString},${curr}`,
            true
        ];
    }, [
        {},
        "",
        true
    ]);
}
/**
 * Merges the baggage header we saved from the incoming request (or meta tag) with
 * a possibly created or modified baggage header by a third party that's been added
 * to the outgoing request header.
 *
 * In case @param headerBaggageString exists, we can safely add the the 3rd party part of @param headerBaggage
 * with our @param incomingBaggage. This is possible because if we modified anything beforehand,
 * it would only affect parts of the sentry baggage (@see Baggage interface).
 *
 * @param incomingBaggage the baggage header of the incoming request that might contain sentry entries
 * @param thirdPartyBaggageHeader possibly existing baggage header string or string[] added from a third
 *        party to the request headers
 *
 * @return a merged and serialized baggage string to be propagated with the outgoing request
 */ function $9e1a8f302f19c673$export$878dd31bdda95e7a(incomingBaggage, thirdPartyBaggageHeader) {
    if (!incomingBaggage && !thirdPartyBaggageHeader) return "";
    var headerBaggage = thirdPartyBaggageHeader && $9e1a8f302f19c673$export$397de414d189db00(thirdPartyBaggageHeader, true) || undefined;
    var thirdPartyHeaderBaggage = headerBaggage && $9e1a8f302f19c673$export$47e5d8a6a267d89b(headerBaggage);
    var finalBaggage = $9e1a8f302f19c673$export$1034a425c7384452(incomingBaggage && incomingBaggage[0] || {}, thirdPartyHeaderBaggage || "");
    return $9e1a8f302f19c673$export$42d6b35c33d40ea3(finalBaggage);
}
/**
 * Helper function that takes a raw baggage string (if available) and the processed sentry-trace header
 * data (if available), parses the baggage string and creates a Baggage object
 * If there is no baggage string, it will create an empty Baggage object.
 * In a second step, this functions determines if the created Baggage object should be set immutable
 * to prevent mutation of the Sentry data.
 *
 * Extracted this logic to a function because it's duplicated in a lot of places.
 *
 * @param rawBaggageValue
 * @param sentryTraceHeader
 */ function $9e1a8f302f19c673$export$9f844442d2ce6374(rawBaggageValue, sentryTraceHeader) {
    var baggage = $9e1a8f302f19c673$export$397de414d189db00(rawBaggageValue || "");
    // Because we are always creating a Baggage object by calling `parseBaggageHeader` above
    // (either a filled one or an empty one, even if we didn't get a `baggage` header),
    // we only need to check if we have a sentry-trace header or not. As soon as we have it,
    // we set baggage immutable. In case we don't get a sentry-trace header, we can assume that
    // this SDK is the head of the trace and thus we still permit mutation at this time.
    // There is one exception though, which is that we get a baggage-header with `sentry-`
    // items but NO sentry-trace header. In this case we also set the baggage immutable for now
    // but if smoething like this would ever happen, we should revisit this and determine
    // what this would actually mean for the trace (i.e. is this SDK the head?, what happened
    // before that we don't have a sentry-trace header?, etc)
    (sentryTraceHeader || !$9e1a8f302f19c673$export$dbc20483d8a38073(baggage)) && $9e1a8f302f19c673$export$744e521d84c86d23(baggage);
    return baggage;
}

});




var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}



var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}


function $0b14391bdc5d7d11$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $0b14391bdc5d7d11$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $0b14391bdc5d7d11$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $0b14391bdc5d7d11$var$isAbsolute(to);
    var isFromAbs = from && $0b14391bdc5d7d11$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $0b14391bdc5d7d11$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$0b14391bdc5d7d11$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $0b14391bdc5d7d11$export$2e2bcd8739ae039 = $0b14391bdc5d7d11$var$resolvePathname;


function $6e4c488965e5c6e8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $6e4c488965e5c6e8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6e4c488965e5c6e8$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $6e4c488965e5c6e8$var$valueOf(a);
        var bValue = $6e4c488965e5c6e8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $6e4c488965e5c6e8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $6e4c488965e5c6e8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6e4c488965e5c6e8$export$2e2bcd8739ae039 = $6e4c488965e5c6e8$var$valueEqual;



var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = "Invariant failed";
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}


function $2756f79476f0245f$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $2756f79476f0245f$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $2756f79476f0245f$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $2756f79476f0245f$var$stripBasename(path, prefix) {
    return $2756f79476f0245f$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $2756f79476f0245f$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $2756f79476f0245f$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $2756f79476f0245f$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $2756f79476f0245f$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $2756f79476f0245f$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $0b14391bdc5d7d11$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $2756f79476f0245f$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $6e4c488965e5c6e8$export$2e2bcd8739ae039)(a.state, b.state);
}
function $2756f79476f0245f$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $2756f79476f0245f$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $2756f79476f0245f$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $2756f79476f0245f$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $2756f79476f0245f$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $2756f79476f0245f$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $2756f79476f0245f$var$PopStateEvent = "popstate";
var $2756f79476f0245f$var$HashChangeEvent = "hashchange";
function $2756f79476f0245f$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $2756f79476f0245f$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $2756f79476f0245f$var$supportsHistory();
    var needsHashChangeListener = !$2756f79476f0245f$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($2756f79476f0245f$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($2756f79476f0245f$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($2756f79476f0245f$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $2756f79476f0245f$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $2756f79476f0245f$var$HashChangeEvent$1 = "hashchange";
var $2756f79476f0245f$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $2756f79476f0245f$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $2756f79476f0245f$var$stripLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    },
    slash: {
        encodePath: $2756f79476f0245f$var$addLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    }
};
function $2756f79476f0245f$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $2756f79476f0245f$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $2756f79476f0245f$var$pushHashPath(path) {
    window.location.hash = path;
}
function $2756f79476f0245f$var$replaceHashPath(path) {
    window.location.replace($2756f79476f0245f$var$stripHash(window.location.href) + "#" + path);
}
function $2756f79476f0245f$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $2756f79476f0245f$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($2756f79476f0245f$var$getHashPath());
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $2756f79476f0245f$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $2756f79476f0245f$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $2756f79476f0245f$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $2756f79476f0245f$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $2756f79476f0245f$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $2756f79476f0245f$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $2756f79476f0245f$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $2756f79476f0245f$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $2756f79476f0245f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $2756f79476f0245f$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $2756f79476f0245f$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, createKey()) : $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $2756f79476f0245f$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $2756f79476f0245f$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $62ddf3174d9df941$exports = {};
var $748a9cdfa4dd7926$exports = {};
$748a9cdfa4dd7926$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $62ddf3174d9df941$exports = $62ddf3174d9df941$var$pathToRegexp;
$62ddf3174d9df941$exports.parse = $62ddf3174d9df941$var$parse;
$62ddf3174d9df941$exports.compile = $62ddf3174d9df941$var$compile;
$62ddf3174d9df941$exports.tokensToFunction = $62ddf3174d9df941$var$tokensToFunction;
$62ddf3174d9df941$exports.tokensToRegExp = $62ddf3174d9df941$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $62ddf3174d9df941$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $62ddf3174d9df941$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $62ddf3174d9df941$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $62ddf3174d9df941$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $62ddf3174d9df941$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $62ddf3174d9df941$var$compile(str, options) {
    return $62ddf3174d9df941$var$tokensToFunction($62ddf3174d9df941$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $62ddf3174d9df941$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $62ddf3174d9df941$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $62ddf3174d9df941$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($748a9cdfa4dd7926$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $62ddf3174d9df941$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $62ddf3174d9df941$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $62ddf3174d9df941$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($62ddf3174d9df941$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $62ddf3174d9df941$var$flags(options));
    return $62ddf3174d9df941$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$stringToRegexp(path, keys, options) {
    return $62ddf3174d9df941$var$tokensToRegExp($62ddf3174d9df941$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$tokensToRegExp(tokens, keys, options) {
    if (!$748a9cdfa4dd7926$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $62ddf3174d9df941$var$escapeString(token);
        else {
            var prefix = $62ddf3174d9df941$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $62ddf3174d9df941$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $62ddf3174d9df941$var$attachKeys(new RegExp("^" + route, $62ddf3174d9df941$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$pathToRegexp(path, keys, options) {
    if (!$748a9cdfa4dd7926$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $62ddf3174d9df941$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($748a9cdfa4dd7926$exports(path)) return $62ddf3174d9df941$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $62ddf3174d9df941$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $72623ab6bcb0a33b$exports = {};
"use strict";

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


var $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $ebf4c3fe5600f7ed$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $ebf4c3fe5600f7ed$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $ebf4c3fe5600f7ed$var$commonjsGlobal[key] = ($ebf4c3fe5600f7ed$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $ebf4c3fe5600f7ed$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $ebf4c3fe5600f7ed$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $ebf4c3fe5600f7ed$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $ebf4c3fe5600f7ed$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $ebf4c3fe5600f7ed$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $ebf4c3fe5600f7ed$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($ebf4c3fe5600f7ed$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $ebf4c3fe5600f7ed$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $ebf4c3fe5600f7ed$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext || $ebf4c3fe5600f7ed$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $ebf4c3fe5600f7ed$var$createNamedContext = function createNamedContext(name) {
    var context = $ebf4c3fe5600f7ed$var$createContext();
    context.displayName = name;
    return context;
};
var $ebf4c3fe5600f7ed$export$c213558b66925821 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router-History");
var $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $ebf4c3fe5600f7ed$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $ebf4c3fe5600f7ed$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $ebf4c3fe5600f7ed$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $ebf4c3fe5600f7ed$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $ebf4c3fe5600f7ed$var$messageType;
var $ebf4c3fe5600f7ed$var$cache = {};
var $ebf4c3fe5600f7ed$var$cacheLimit = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount = 0;
function $ebf4c3fe5600f7ed$var$compilePath(path) {
    if ($ebf4c3fe5600f7ed$var$cache[path]) return $ebf4c3fe5600f7ed$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($62ddf3174d9df941$exports))).compile(path);
    if ($ebf4c3fe5600f7ed$var$cacheCount < $ebf4c3fe5600f7ed$var$cacheLimit) {
        $ebf4c3fe5600f7ed$var$cache[path] = generator;
        $ebf4c3fe5600f7ed$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $ebf4c3fe5600f7ed$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $ebf4c3fe5600f7ed$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $2756f79476f0245f$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $ebf4c3fe5600f7ed$export$82476f982757e71e(to, computedMatch.params) : (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, to, {
            pathname: $ebf4c3fe5600f7ed$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $2756f79476f0245f$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $2756f79476f0245f$export$c3e8bb440bd55b18)(prevLocation, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $ebf4c3fe5600f7ed$var$cache$1 = {};
var $ebf4c3fe5600f7ed$var$cacheLimit$1 = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount$1 = 0;
function $ebf4c3fe5600f7ed$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $ebf4c3fe5600f7ed$var$cache$1[cacheKey] || ($ebf4c3fe5600f7ed$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($62ddf3174d9df941$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($ebf4c3fe5600f7ed$var$cacheCount$1 < $ebf4c3fe5600f7ed$var$cacheLimit$1) {
        pathCache[path] = result;
        $ebf4c3fe5600f7ed$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $ebf4c3fe5600f7ed$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $ebf4c3fe5600f7ed$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $ebf4c3fe5600f7ed$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 0;
}
function $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $ebf4c3fe5600f7ed$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $ebf4c3fe5600f7ed$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ebf4c3fe5600f7ed$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, location, {
        pathname: $ebf4c3fe5600f7ed$var$addLeadingSlash(basename) + location.pathname
    });
}
function $ebf4c3fe5600f7ed$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $ebf4c3fe5600f7ed$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $ebf4c3fe5600f7ed$var$createURL(location) {
    return typeof location === "string" ? location : (0, $2756f79476f0245f$export$fe53371bee54353d)(location);
}
function $ebf4c3fe5600f7ed$var$staticHandler(methodName) {
    return function() {
        (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    };
}
function $ebf4c3fe5600f7ed$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $ebf4c3fe5600f7ed$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        _this.handleBlock = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $ebf4c3fe5600f7ed$var$addBasename(basename, (0, $2756f79476f0245f$export$90c043f1c57770b8)(location));
        context.url = $ebf4c3fe5600f7ed$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $ebf4c3fe5600f7ed$var$addLeadingSlash(basename + $ebf4c3fe5600f7ed$var$createURL(path));
            },
            action: "POP",
            location: $ebf4c3fe5600f7ed$var$stripBasename(basename, (0, $2756f79476f0245f$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $ebf4c3fe5600f7ed$var$staticHandler("go"),
            goBack: $ebf4c3fe5600f7ed$var$staticHandler("goBack"),
            goForward: $ebf4c3fe5600f7ed$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $ebf4c3fe5600f7ed$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(C, Component);
}
var $ebf4c3fe5600f7ed$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext;
function $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$c213558b66925821);
}
function $ebf4c3fe5600f7ed$export$45d76561a5302f2b() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).location;
}
function $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef() {
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $ebf4c3fe5600f7ed$export$632be4bb944c1bc7(path) {
    var location = $ebf4c3fe5600f7ed$export$45d76561a5302f2b();
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, path) : match;
}
var $ebf4c3fe5600f7ed$var$global$1, $ebf4c3fe5600f7ed$var$key, $ebf4c3fe5600f7ed$var$buildNames, $ebf4c3fe5600f7ed$var$initialBuildName, $ebf4c3fe5600f7ed$var$secondaryBuildName;




var $acw62 = parcelRequire("acw62");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $3189c83282a9a1c6$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $3189c83282a9a1c6$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $3189c83282a9a1c6$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $3189c83282a9a1c6$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $2756f79476f0245f$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $3189c83282a9a1c6$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef === "undefined") $3189c83282a9a1c6$var$forwardRef = $3189c83282a9a1c6$var$forwardRefShim;
function $3189c83282a9a1c6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $3189c83282a9a1c6$var$LinkAnchor = $3189c83282a9a1c6$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$3189c83282a9a1c6$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $3189c83282a9a1c6$export$a6c7ac8248d6e38a = $3189c83282a9a1c6$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $3189c83282a9a1c6$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $3189c83282a9a1c6$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $2756f79476f0245f$export$fe53371bee54353d)(context.location) === (0, $2756f79476f0245f$export$fe53371bee54353d)($3189c83282a9a1c6$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props);
    });
});
var $3189c83282a9a1c6$var$toType, $3189c83282a9a1c6$var$refType;
var $3189c83282a9a1c6$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef$1 === "undefined") $3189c83282a9a1c6$var$forwardRef$1 = $3189c83282a9a1c6$var$forwardRefShim$1;
function $3189c83282a9a1c6$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $3189c83282a9a1c6$export$b0d92dbee9b5b60d = $3189c83282a9a1c6$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $ebf4c3fe5600f7ed$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $3189c83282a9a1c6$var$joinClassnames(className, activeClassName);
            style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim$1 !== $3189c83282a9a1c6$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3189c83282a9a1c6$export$a6c7ac8248d6e38a, props);
    });
});
var $3189c83282a9a1c6$var$ariaCurrentType;


/**
 * Main App component that handles auth state and routing.
 *
 * Initializes auth hook, fetches user account data, handles routing and navigation state.
 * Renders main app layout with Navigation, WorkspaceSelectModal and Content components.
 * Handles global state like selected workspace, environments, etc.
 * Redirects to Product page if no authenticated user.
 */ 

var $acw62 = parcelRequire("acw62");

/**
 * The above code is a JavaScript module that provides authentication functionality using Amazon
 * Cognito User Pool in a React application.
 * @param initialState - The `initialState` parameter is the initial state of the user. It is used to
 * set the initial value of the `user` state in the `useProvideAuth` hook.
 * @returns The code is returning a custom hook called `useProvideAuth` and a component called
 * `ProvideAuth`. The `useProvideAuth` hook provides authentication functionality such as login,
 * registration, verification, password reset, and logout. The `ProvideAuth` component wraps the
 * application and provides the authentication context to its children.
 */ 

var $acw62 = parcelRequire("acw62");
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $010becf709f0452a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $7fb856e564cccfe9$export$a143d493d941bafc;
var $7fb856e564cccfe9$export$e4cf37d7f6fb9e0a;
var $7fb856e564cccfe9$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $7fb856e564cccfe9$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $52af415c3a3d4253$exports = {};
var $52af415c3a3d4253$var$toString = {}.toString;
$52af415c3a3d4253$exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == "[object Array]";
};


$7fb856e564cccfe9$export$a143d493d941bafc = $7fb856e564cccfe9$var$Buffer;
$7fb856e564cccfe9$export$e4cf37d7f6fb9e0a = $7fb856e564cccfe9$var$SlowBuffer;
$7fb856e564cccfe9$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $7fb856e564cccfe9$var$typedArraySupport();
$7fb856e564cccfe9$export$599f31c3813fae4d = $7fb856e564cccfe9$var$kMaxLength();
function $7fb856e564cccfe9$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $7fb856e564cccfe9$var$kMaxLength() {
    return $7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $7fb856e564cccfe9$var$createBuffer(that, length) {
    if ($7fb856e564cccfe9$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $7fb856e564cccfe9$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $7fb856e564cccfe9$var$Buffer(arg, encodingOrOffset, length) {
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $7fb856e564cccfe9$var$Buffer)) return new $7fb856e564cccfe9$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $7fb856e564cccfe9$var$allocUnsafe(this, arg);
    }
    return $7fb856e564cccfe9$var$from(this, arg, encodingOrOffset, length);
}
$7fb856e564cccfe9$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$7fb856e564cccfe9$var$Buffer._augment = function(arr) {
    arr.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    return arr;
};
function $7fb856e564cccfe9$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $7fb856e564cccfe9$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $7fb856e564cccfe9$var$fromString(that, value, encodingOrOffset);
    return $7fb856e564cccfe9$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $7fb856e564cccfe9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $7fb856e564cccfe9$var$from(null, value, encodingOrOffset, length);
};
if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $7fb856e564cccfe9$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $7fb856e564cccfe9$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $7fb856e564cccfe9$var$Buffer[Symbol.species] === $7fb856e564cccfe9$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($7fb856e564cccfe9$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $7fb856e564cccfe9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $7fb856e564cccfe9$var$alloc(that, size, fill, encoding) {
    $7fb856e564cccfe9$var$assertSize(size);
    if (size <= 0) return $7fb856e564cccfe9$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $7fb856e564cccfe9$var$createBuffer(that, size).fill(fill, encoding) : $7fb856e564cccfe9$var$createBuffer(that, size).fill(fill);
    return $7fb856e564cccfe9$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $7fb856e564cccfe9$var$Buffer.alloc = function(size, fill, encoding) {
    return $7fb856e564cccfe9$var$alloc(null, size, fill, encoding);
};
function $7fb856e564cccfe9$var$allocUnsafe(that, size) {
    $7fb856e564cccfe9$var$assertSize(size);
    that = $7fb856e564cccfe9$var$createBuffer(that, size < 0 ? 0 : $7fb856e564cccfe9$var$checked(size) | 0);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $7fb856e564cccfe9$var$Buffer.allocUnsafe = function(size) {
    return $7fb856e564cccfe9$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $7fb856e564cccfe9$var$Buffer.allocUnsafeSlow = function(size) {
    return $7fb856e564cccfe9$var$allocUnsafe(null, size);
};
function $7fb856e564cccfe9$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$7fb856e564cccfe9$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $7fb856e564cccfe9$var$byteLength(string, encoding) | 0;
    that = $7fb856e564cccfe9$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $7fb856e564cccfe9$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $7fb856e564cccfe9$var$checked(array.length) | 0;
    that = $7fb856e564cccfe9$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $7fb856e564cccfe9$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $7fb856e564cccfe9$var$fromArrayLike(that, array);
    return that;
}
function $7fb856e564cccfe9$var$fromObject(that, obj) {
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(obj)) {
        var len = $7fb856e564cccfe9$var$checked(obj.length) | 0;
        that = $7fb856e564cccfe9$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $7fb856e564cccfe9$var$isnan(obj.length)) return $7fb856e564cccfe9$var$createBuffer(that, 0);
            return $7fb856e564cccfe9$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $52af415c3a3d4253$exports(obj.data)) return $7fb856e564cccfe9$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $7fb856e564cccfe9$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $7fb856e564cccfe9$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $7fb856e564cccfe9$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $7fb856e564cccfe9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $7fb856e564cccfe9$var$Buffer.alloc(+length);
}
$7fb856e564cccfe9$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$7fb856e564cccfe9$var$Buffer.compare = function compare(a, b) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(a) || !$7fb856e564cccfe9$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$7fb856e564cccfe9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$7fb856e564cccfe9$var$Buffer.concat = function concat(list, length) {
    if (!$52af415c3a3d4253$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $7fb856e564cccfe9$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $7fb856e564cccfe9$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$7fb856e564cccfe9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $7fb856e564cccfe9$var$byteLength(string, encoding) {
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $7fb856e564cccfe9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $7fb856e564cccfe9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $7fb856e564cccfe9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$7fb856e564cccfe9$var$Buffer.byteLength = $7fb856e564cccfe9$var$byteLength;
function $7fb856e564cccfe9$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $7fb856e564cccfe9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $7fb856e564cccfe9$var$utf8Slice(this, start, end);
        case "ascii":
            return $7fb856e564cccfe9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $7fb856e564cccfe9$var$latin1Slice(this, start, end);
        case "base64":
            return $7fb856e564cccfe9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $7fb856e564cccfe9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$7fb856e564cccfe9$var$Buffer.prototype._isBuffer = true;
function $7fb856e564cccfe9$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$7fb856e564cccfe9$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$7fb856e564cccfe9$var$swap(this, i, i + 1);
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $7fb856e564cccfe9$var$swap(this, i, i + 3);
        $7fb856e564cccfe9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $7fb856e564cccfe9$var$swap(this, i, i + 7);
        $7fb856e564cccfe9$var$swap(this, i + 1, i + 6);
        $7fb856e564cccfe9$var$swap(this, i + 2, i + 5);
        $7fb856e564cccfe9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$7fb856e564cccfe9$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $7fb856e564cccfe9$var$utf8Slice(this, 0, length);
    return $7fb856e564cccfe9$var$slowToString.apply(this, arguments);
};
$7fb856e564cccfe9$var$Buffer.prototype.equals = function equals(b) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $7fb856e564cccfe9$var$Buffer.compare(this, b) === 0;
};
$7fb856e564cccfe9$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $7fb856e564cccfe9$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$7fb856e564cccfe9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $7fb856e564cccfe9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $7fb856e564cccfe9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($7fb856e564cccfe9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $7fb856e564cccfe9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $7fb856e564cccfe9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $7fb856e564cccfe9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$7fb856e564cccfe9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$7fb856e564cccfe9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $7fb856e564cccfe9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$7fb856e564cccfe9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $7fb856e564cccfe9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $7fb856e564cccfe9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $7fb856e564cccfe9$var$utf8Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $7fb856e564cccfe9$var$asciiWrite(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$asciiToBytes(string), buf, offset, length);
}
function $7fb856e564cccfe9$var$latin1Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$asciiWrite(buf, string, offset, length);
}
function $7fb856e564cccfe9$var$base64Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$base64ToBytes(string), buf, offset, length);
}
function $7fb856e564cccfe9$var$ucs2Write(buf, string, offset, length) {
    return $7fb856e564cccfe9$var$blitBuffer($7fb856e564cccfe9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$7fb856e564cccfe9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $7fb856e564cccfe9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $7fb856e564cccfe9$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $7fb856e564cccfe9$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $7fb856e564cccfe9$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $7fb856e564cccfe9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $7fb856e564cccfe9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$7fb856e564cccfe9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $7fb856e564cccfe9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $7fb856e564cccfe9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $7fb856e564cccfe9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $7fb856e564cccfe9$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $7fb856e564cccfe9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $7fb856e564cccfe9$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $7fb856e564cccfe9$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $7fb856e564cccfe9$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $7fb856e564cccfe9$var$toHex(buf[i]);
    return out;
}
function $7fb856e564cccfe9$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$7fb856e564cccfe9$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $7fb856e564cccfe9$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $7fb856e564cccfe9$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $7fb856e564cccfe9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$7fb856e564cccfe9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$7fb856e564cccfe9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$7fb856e564cccfe9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$7fb856e564cccfe9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$7fb856e564cccfe9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$7fb856e564cccfe9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$7fb856e564cccfe9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$7fb856e564cccfe9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $7fb856e564cccfe9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$7fb856e564cccfe9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $7fb856e564cccfe9$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $7fb856e564cccfe9$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7fb856e564cccfe9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7fb856e564cccfe9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7fb856e564cccfe9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7fb856e564cccfe9$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $7fb856e564cccfe9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeFloat(this, value, offset, true, noAssert);
};
$7fb856e564cccfe9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeFloat(this, value, offset, false, noAssert);
};
function $7fb856e564cccfe9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7fb856e564cccfe9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$7fb856e564cccfe9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeDouble(this, value, offset, true, noAssert);
};
$7fb856e564cccfe9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $7fb856e564cccfe9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$7fb856e564cccfe9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$7fb856e564cccfe9$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$7fb856e564cccfe9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$7fb856e564cccfe9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $7fb856e564cccfe9$var$Buffer.isBuffer(val) ? val : $7fb856e564cccfe9$var$utf8ToBytes(new $7fb856e564cccfe9$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $7fb856e564cccfe9$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $7fb856e564cccfe9$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $7fb856e564cccfe9$var$stringtrim(str).replace($7fb856e564cccfe9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $7fb856e564cccfe9$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $7fb856e564cccfe9$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $7fb856e564cccfe9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $7fb856e564cccfe9$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $7fb856e564cccfe9$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $7fb856e564cccfe9$var$base64ToBytes(str) {
    return $kuxul.toByteArray($7fb856e564cccfe9$var$base64clean(str));
}
function $7fb856e564cccfe9$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $7fb856e564cccfe9$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}



var $3OBZa = parcelRequire("3OBZa");
parcelRequire("dOqqi");

var $dCBbD = parcelRequire("dCBbD");

var $WS9F7 = parcelRequire("WS9F7");
var $b1d17d9b5b43e6ab$var$crypto; // Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) $b1d17d9b5b43e6ab$var$crypto = window.crypto;
 // Native (experimental IE 11) crypto from window (Browser)
if (!$b1d17d9b5b43e6ab$var$crypto && typeof window !== "undefined" && window.msCrypto) $b1d17d9b5b43e6ab$var$crypto = window.msCrypto;
 // Native crypto from global (NodeJS)
if (!$b1d17d9b5b43e6ab$var$crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) $b1d17d9b5b43e6ab$var$crypto = $parcel$global.crypto;
 // Native crypto import via require (NodeJS)

if (!$b1d17d9b5b43e6ab$var$crypto && true) try {
    $b1d17d9b5b43e6ab$var$crypto = (parcelRequire("kjyEk"));
} catch (err) {}
function $b1d17d9b5b43e6ab$export$2e2bcd8739ae039() {
    if ($b1d17d9b5b43e6ab$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $b1d17d9b5b43e6ab$var$crypto.getRandomValues === "function") try {
            return $b1d17d9b5b43e6ab$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
         // Use randomBytes method (NodeJS)
        if (typeof $b1d17d9b5b43e6ab$var$crypto.randomBytes === "function") try {
            return $b1d17d9b5b43e6ab$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $604987de3d14fe69$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes; // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var $604987de3d14fe69$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $b1d17d9b5b43e6ab$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $604987de3d14fe69$var$hexStringify(this);
    };
    return WordArray;
}();


// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $4cdeaf8f1e22336b$export$2e2bcd8739ae039 = $4cdeaf8f1e22336b$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $4cdeaf8f1e22336b$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
} // return new, unset BigInteger
function $4cdeaf8f1e22336b$var$nbi() {
    return new $4cdeaf8f1e22336b$var$BigInteger(null);
} // Bits per digit
var $4cdeaf8f1e22336b$var$dbits; // JavaScript engine analysis
var $4cdeaf8f1e22336b$var$canary = 0xdeadbeefcafe;
var $4cdeaf8f1e22336b$var$j_lm = ($4cdeaf8f1e22336b$var$canary & 0xffffff) == 0xefcafe; // am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $4cdeaf8f1e22336b$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
} // am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $4cdeaf8f1e22336b$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
} // Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $4cdeaf8f1e22336b$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $4cdeaf8f1e22336b$var$inBrowser = typeof navigator !== "undefined";
if ($4cdeaf8f1e22336b$var$inBrowser && $4cdeaf8f1e22336b$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am2;
    $4cdeaf8f1e22336b$var$dbits = 30;
} else if ($4cdeaf8f1e22336b$var$inBrowser && $4cdeaf8f1e22336b$var$j_lm && navigator.appName != "Netscape") {
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am1;
    $4cdeaf8f1e22336b$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $4cdeaf8f1e22336b$var$BigInteger.prototype.am = $4cdeaf8f1e22336b$var$am3;
    $4cdeaf8f1e22336b$var$dbits = 28;
}
$4cdeaf8f1e22336b$var$BigInteger.prototype.DB = $4cdeaf8f1e22336b$var$dbits;
$4cdeaf8f1e22336b$var$BigInteger.prototype.DM = (1 << $4cdeaf8f1e22336b$var$dbits) - 1;
$4cdeaf8f1e22336b$var$BigInteger.prototype.DV = 1 << $4cdeaf8f1e22336b$var$dbits;
var $4cdeaf8f1e22336b$var$BI_FP = 52;
$4cdeaf8f1e22336b$var$BigInteger.prototype.FV = Math.pow(2, $4cdeaf8f1e22336b$var$BI_FP);
$4cdeaf8f1e22336b$var$BigInteger.prototype.F1 = $4cdeaf8f1e22336b$var$BI_FP - $4cdeaf8f1e22336b$var$dbits;
$4cdeaf8f1e22336b$var$BigInteger.prototype.F2 = 2 * $4cdeaf8f1e22336b$var$dbits - $4cdeaf8f1e22336b$var$BI_FP; // Digit conversions
var $4cdeaf8f1e22336b$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $4cdeaf8f1e22336b$var$BI_RC = new Array();
var $4cdeaf8f1e22336b$var$rr, $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = "0".charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 0; $4cdeaf8f1e22336b$var$vv <= 9; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = "a".charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 10; $4cdeaf8f1e22336b$var$vv < 36; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
$4cdeaf8f1e22336b$var$rr = "A".charCodeAt(0);
for($4cdeaf8f1e22336b$var$vv = 10; $4cdeaf8f1e22336b$var$vv < 36; ++$4cdeaf8f1e22336b$var$vv)$4cdeaf8f1e22336b$var$BI_RC[$4cdeaf8f1e22336b$var$rr++] = $4cdeaf8f1e22336b$var$vv;
function $4cdeaf8f1e22336b$var$int2char(n) {
    return $4cdeaf8f1e22336b$var$BI_RM.charAt(n);
}
function $4cdeaf8f1e22336b$var$intAt(s, i) {
    var c = $4cdeaf8f1e22336b$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
} // (protected) copy this to r
function $4cdeaf8f1e22336b$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
} // (protected) set from integer value x, -DV <= x < DV
function $4cdeaf8f1e22336b$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
} // return bigint initialized to value
function $4cdeaf8f1e22336b$var$nbv(i) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    r.fromInt(i);
    return r;
} // (protected) set from string and radix
function $4cdeaf8f1e22336b$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $4cdeaf8f1e22336b$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(this, this);
} // (protected) clamp off excess high words
function $4cdeaf8f1e22336b$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
} // (public) return string representation in given radix
function $4cdeaf8f1e22336b$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $4cdeaf8f1e22336b$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $4cdeaf8f1e22336b$var$int2char(d);
        }
    }
    return m ? r : "0";
} // (public) -this
function $4cdeaf8f1e22336b$var$bnNegate() {
    var r = $4cdeaf8f1e22336b$var$nbi();
    $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(this, r);
    return r;
} // (public) |this|
function $4cdeaf8f1e22336b$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
} // (public) return + if this > a, - if this < a, 0 if equal
function $4cdeaf8f1e22336b$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0){
        if ((r = this[i] - a[i]) != 0) return r;
    }
    return 0;
} // returns bit length of the integer x
function $4cdeaf8f1e22336b$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
} // (public) return the number of bits in "this"
function $4cdeaf8f1e22336b$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $4cdeaf8f1e22336b$var$nbits(this[this.t - 1] ^ this.s & this.DM);
} // (protected) r = this << n*DB
function $4cdeaf8f1e22336b$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
} // (protected) r = this >> n*DB
function $4cdeaf8f1e22336b$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
} // (protected) r = this << n
function $4cdeaf8f1e22336b$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
} // (protected) r = this >> n
function $4cdeaf8f1e22336b$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
} // (protected) r = this - a
function $4cdeaf8f1e22336b$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
} // (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $4cdeaf8f1e22336b$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(r, r);
} // (protected) r = this^2, r != this (HAC 14.16)
function $4cdeaf8f1e22336b$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
} // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $4cdeaf8f1e22336b$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $4cdeaf8f1e22336b$var$nbi();
    var y = $4cdeaf8f1e22336b$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $4cdeaf8f1e22336b$var$nbits(pm[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $4cdeaf8f1e22336b$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $4cdeaf8f1e22336b$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $4cdeaf8f1e22336b$var$BigInteger.ZERO.subTo(r, r);
} // (public) this mod a
function $4cdeaf8f1e22336b$var$bnMod(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($4cdeaf8f1e22336b$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
} // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $4cdeaf8f1e22336b$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $4cdeaf8f1e22336b$var$bnEquals(a) {
    return this.compareTo(a) == 0;
} // (protected) r = this + a
function $4cdeaf8f1e22336b$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
} // (public) this + a
function $4cdeaf8f1e22336b$var$bnAdd(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.addTo(a, r);
    return r;
} // (public) this - a
function $4cdeaf8f1e22336b$var$bnSubtract(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.subTo(a, r);
    return r;
} // (public) this * a
function $4cdeaf8f1e22336b$var$bnMultiply(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.multiplyTo(a, r);
    return r;
} // (public) this / a
function $4cdeaf8f1e22336b$var$bnDivide(a) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    this.divRemTo(a, r, null);
    return r;
} // Montgomery reduction
function $4cdeaf8f1e22336b$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
} // xR mod m
function $4cdeaf8f1e22336b$var$montConvert(x) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($4cdeaf8f1e22336b$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
} // x/R mod m
function $4cdeaf8f1e22336b$var$montRevert(x) {
    var r = $4cdeaf8f1e22336b$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
} // x = x/R mod m (HAC 14.32)
function $4cdeaf8f1e22336b$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM; // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t); // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
} // r = "x^2/R mod m"; x != r
function $4cdeaf8f1e22336b$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
} // r = "xy/R mod m"; x,y != r
function $4cdeaf8f1e22336b$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$4cdeaf8f1e22336b$var$Montgomery.prototype.convert = $4cdeaf8f1e22336b$var$montConvert;
$4cdeaf8f1e22336b$var$Montgomery.prototype.revert = $4cdeaf8f1e22336b$var$montRevert;
$4cdeaf8f1e22336b$var$Montgomery.prototype.reduce = $4cdeaf8f1e22336b$var$montReduce;
$4cdeaf8f1e22336b$var$Montgomery.prototype.mulTo = $4cdeaf8f1e22336b$var$montMulTo;
$4cdeaf8f1e22336b$var$Montgomery.prototype.sqrTo = $4cdeaf8f1e22336b$var$montSqrTo; // (public) this^e % m (HAC 14.85)
function $4cdeaf8f1e22336b$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $4cdeaf8f1e22336b$var$nbv(1), z = new $4cdeaf8f1e22336b$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6; // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $4cdeaf8f1e22336b$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $4cdeaf8f1e22336b$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $4cdeaf8f1e22336b$var$nbi(), t;
    i = $4cdeaf8f1e22336b$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
} // protected
$4cdeaf8f1e22336b$var$BigInteger.prototype.copyTo = $4cdeaf8f1e22336b$var$bnpCopyTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.fromInt = $4cdeaf8f1e22336b$var$bnpFromInt;
$4cdeaf8f1e22336b$var$BigInteger.prototype.fromString = $4cdeaf8f1e22336b$var$bnpFromString;
$4cdeaf8f1e22336b$var$BigInteger.prototype.clamp = $4cdeaf8f1e22336b$var$bnpClamp;
$4cdeaf8f1e22336b$var$BigInteger.prototype.dlShiftTo = $4cdeaf8f1e22336b$var$bnpDLShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.drShiftTo = $4cdeaf8f1e22336b$var$bnpDRShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.lShiftTo = $4cdeaf8f1e22336b$var$bnpLShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.rShiftTo = $4cdeaf8f1e22336b$var$bnpRShiftTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.subTo = $4cdeaf8f1e22336b$var$bnpSubTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.multiplyTo = $4cdeaf8f1e22336b$var$bnpMultiplyTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.squareTo = $4cdeaf8f1e22336b$var$bnpSquareTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.divRemTo = $4cdeaf8f1e22336b$var$bnpDivRemTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.invDigit = $4cdeaf8f1e22336b$var$bnpInvDigit;
$4cdeaf8f1e22336b$var$BigInteger.prototype.addTo = $4cdeaf8f1e22336b$var$bnpAddTo; // public
$4cdeaf8f1e22336b$var$BigInteger.prototype.toString = $4cdeaf8f1e22336b$var$bnToString;
$4cdeaf8f1e22336b$var$BigInteger.prototype.negate = $4cdeaf8f1e22336b$var$bnNegate;
$4cdeaf8f1e22336b$var$BigInteger.prototype.abs = $4cdeaf8f1e22336b$var$bnAbs;
$4cdeaf8f1e22336b$var$BigInteger.prototype.compareTo = $4cdeaf8f1e22336b$var$bnCompareTo;
$4cdeaf8f1e22336b$var$BigInteger.prototype.bitLength = $4cdeaf8f1e22336b$var$bnBitLength;
$4cdeaf8f1e22336b$var$BigInteger.prototype.mod = $4cdeaf8f1e22336b$var$bnMod;
$4cdeaf8f1e22336b$var$BigInteger.prototype.equals = $4cdeaf8f1e22336b$var$bnEquals;
$4cdeaf8f1e22336b$var$BigInteger.prototype.add = $4cdeaf8f1e22336b$var$bnAdd;
$4cdeaf8f1e22336b$var$BigInteger.prototype.subtract = $4cdeaf8f1e22336b$var$bnSubtract;
$4cdeaf8f1e22336b$var$BigInteger.prototype.multiply = $4cdeaf8f1e22336b$var$bnMultiply;
$4cdeaf8f1e22336b$var$BigInteger.prototype.divide = $4cdeaf8f1e22336b$var$bnDivide;
$4cdeaf8f1e22336b$var$BigInteger.prototype.modPow = $4cdeaf8f1e22336b$var$bnModPow; // "constants"
$4cdeaf8f1e22336b$var$BigInteger.ZERO = $4cdeaf8f1e22336b$var$nbv(0);
$4cdeaf8f1e22336b$var$BigInteger.ONE = $4cdeaf8f1e22336b$var$nbv(1);


/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $80fee53f057853d0$var$randomBytes(nBytes) {
    return (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(new (0, $604987de3d14fe69$export$2e2bcd8739ae039)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $80fee53f057853d0$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $80fee53f057853d0$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $80fee53f057853d0$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $80fee53f057853d0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)($80fee53f057853d0$var$initN, 16);
        this.g = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)("2", 16);
        this.k = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $7fb856e564cccfe9$export$a143d493d941bafc).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $80fee53f057853d0$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(hexRandom, 16); // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $80fee53f057853d0$var$randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $80fee53f057853d0$var$randomBytes(16).toString("hex"); // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var str = buf instanceof (0, $7fb856e564cccfe9$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(buf) : buf;
        var hashHex = (0, (/*@__PURE__*/$parcel$interopDefault($dCBbD)))(str).toString();
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $7fb856e564cccfe9$export$a143d493d941bafc).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsWordArray = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create((0, $7fb856e564cccfe9$export$a143d493d941bafc).concat([
            this.infoBits,
            (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(String.fromCharCode(1), "utf8")
        ]));
        var ikmWordArray = ikm instanceof (0, $7fb856e564cccfe9$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(ikm) : ikm;
        var saltWordArray = salt instanceof (0, $7fb856e564cccfe9$export$a143d493d941bafc) ? (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(salt) : salt;
        var prk = (0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(ikmWordArray, saltWordArray);
        var hmac = (0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(infoBitsWordArray, prk);
        return (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(hmac.toString(), "hex").slice(0, 16);
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this4.padHex(sValue), "hex"), (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $80fee53f057853d0$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $80fee53f057853d0$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
/** @class */ var $3ebef4e0e2340f79$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $7fb856e564cccfe9$export$a143d493d941bafc).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $8281217ccf88c1bf$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8281217ccf88c1bf$var$_setPrototypeOf(subClass, superClass);
}
function $8281217ccf88c1bf$var$_setPrototypeOf(o, p) {
    $8281217ccf88c1bf$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8281217ccf88c1bf$var$_setPrototypeOf(o, p);
}
/** @class */ var $8281217ccf88c1bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $8281217ccf88c1bf$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, $3ebef4e0e2340f79$export$2e2bcd8739ae039));



function $8eb7209a41983bfc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8eb7209a41983bfc$var$_setPrototypeOf(subClass, superClass);
}
function $8eb7209a41983bfc$var$_setPrototypeOf(o, p) {
    $8eb7209a41983bfc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8eb7209a41983bfc$var$_setPrototypeOf(o, p);
}
/** @class */ var $8eb7209a41983bfc$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $8eb7209a41983bfc$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, $3ebef4e0e2340f79$export$2e2bcd8739ae039));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $c59d7f07074bc9f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $3OBZa = parcelRequire("3OBZa");
parcelRequire("dOqqi");

var $33Dov = parcelRequire("33Dov");

var $WS9F7 = parcelRequire("WS9F7");





/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $82508fd376aeac3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $a942b99a35e53a72$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $a942b99a35e53a72$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $a942b99a35e53a72$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $a942b99a35e53a72$var$weekNames[now.getUTCDay()];
        var month = $a942b99a35e53a72$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear(); // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $38555859a52f4863$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $a337e11db75e0691$var$dataMemory = {};
var $a337e11db75e0691$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $a337e11db75e0691$var$dataMemory[key] = value;
        return $a337e11db75e0691$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($a337e11db75e0691$var$dataMemory, key) ? $a337e11db75e0691$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $a337e11db75e0691$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $a337e11db75e0691$var$dataMemory = {};
        return $a337e11db75e0691$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $a337e11db75e0691$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $a337e11db75e0691$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $737214f2f07cda56$var$isBrowser = typeof navigator !== "undefined";
var $737214f2f07cda56$var$userAgent = $737214f2f07cda56$var$isBrowser ? navigator.userAgent : "nodejs";
/** @class */ var $737214f2f07cda56$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $a337e11db75e0691$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolId().split("_")[1]);
        var dateHelper = new (0, $a942b99a35e53a72$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create((0, $7fb856e564cccfe9$export$a143d493d941bafc).concat([
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this2.pool.getUserPoolId().split("_")[1], "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this2.username, "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($33Dov))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined; // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }); // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolId().split("_")[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
         // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $737214f2f07cda56$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolId().split("_")[1]);
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $a942b99a35e53a72$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $4cdeaf8f1e22336b$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create((0, $7fb856e564cccfe9$export$a143d493d941bafc).concat([
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this6.deviceGroupKey, "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(_this6.deviceKey, "utf8"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($3OBZa))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($33Dov))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($WS9F7)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined; // getPasswordAuthenticationKey callback end
                });
                return undefined;
            }); // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(this.pool.getUserPoolId().split("_")[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $80fee53f057853d0$export$2e2bcd8739ae039)(_this8.pool.getUserPoolId().split("_")[1]);
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $7fb856e564cccfe9$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $737214f2f07cda56$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
             // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $38555859a52f4863$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
             // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $8eb7209a41983bfc$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $8281217ccf88c1bf$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $c59d7f07074bc9f5$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $82508fd376aeac3c$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $8eb7209a41983bfc$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $8281217ccf88c1bf$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $c59d7f07074bc9f5$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $82508fd376aeac3c$export$2e2bcd8739ae039)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {}
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $436950a2454b4407$exports = {};


$436950a2454b4407$exports = self.fetch || (self.fetch = (parcelRequire("laOt8")).default || (parcelRequire("laOt8")));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // generated by genversion
var $09728a2d1518e4a6$export$83d89fbfd8236492 = "5.0.4";


var $d09126a5f5299c10$var$BASE_USER_AGENT = "aws-amplify/" + (0, $09728a2d1518e4a6$export$83d89fbfd8236492);
var $d09126a5f5299c10$export$2dffd0b5373a4389 = {
    userAgent: $d09126a5f5299c10$var$BASE_USER_AGENT + " js",
    product: "",
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== "undefined" && navigator.product) {
    $d09126a5f5299c10$export$2dffd0b5373a4389.product = navigator.product || "";
    $d09126a5f5299c10$export$2dffd0b5373a4389.navigator = navigator || null;
    switch(navigator.product){
        case "ReactNative":
            $d09126a5f5299c10$export$2dffd0b5373a4389.userAgent = $d09126a5f5299c10$var$BASE_USER_AGENT + " react-native";
            $d09126a5f5299c10$export$2dffd0b5373a4389.isReactNative = true;
            break;
        default:
            $d09126a5f5299c10$export$2dffd0b5373a4389.userAgent = $d09126a5f5299c10$var$BASE_USER_AGENT + " js";
            $d09126a5f5299c10$export$2dffd0b5373a4389.isReactNative = false;
            break;
    }
}
var $d09126a5f5299c10$export$7935961ef7719cb0 = function getUserAgent() {
    return $d09126a5f5299c10$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $d09126a5f5299c10$export$2e2bcd8739ae039 = $d09126a5f5299c10$export$2dffd0b5373a4389;


function $68caf4bd6c7da8b9$var$UserAgent() {} // public
$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = (0, $d09126a5f5299c10$export$7935961ef7719cb0)();
var $68caf4bd6c7da8b9$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent && !$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent.includes(content)) $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent.concat(" ", content);
    if (!$68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent || $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent === "") $68caf4bd6c7da8b9$var$UserAgent.prototype.userAgent = content;
}; // class for defining the amzn user-agent
var $68caf4bd6c7da8b9$export$2e2bcd8739ae039 = $68caf4bd6c7da8b9$var$UserAgent;


function $bb0b3502dd43cbf5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $bb0b3502dd43cbf5$var$_setPrototypeOf(subClass, superClass);
}
function $bb0b3502dd43cbf5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bb0b3502dd43cbf5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bb0b3502dd43cbf5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $bb0b3502dd43cbf5$var$_construct(Class, arguments, $bb0b3502dd43cbf5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bb0b3502dd43cbf5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $bb0b3502dd43cbf5$var$_wrapNativeSuper(Class);
}
function $bb0b3502dd43cbf5$var$_construct(Parent, args, Class) {
    if ($bb0b3502dd43cbf5$var$_isNativeReflectConstruct()) $bb0b3502dd43cbf5$var$_construct = Reflect.construct;
    else $bb0b3502dd43cbf5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bb0b3502dd43cbf5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $bb0b3502dd43cbf5$var$_construct.apply(null, arguments);
}
function $bb0b3502dd43cbf5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bb0b3502dd43cbf5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $bb0b3502dd43cbf5$var$_setPrototypeOf(o, p) {
    $bb0b3502dd43cbf5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bb0b3502dd43cbf5$var$_setPrototypeOf(o, p);
}
function $bb0b3502dd43cbf5$var$_getPrototypeOf(o) {
    $bb0b3502dd43cbf5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bb0b3502dd43cbf5$var$_getPrototypeOf(o);
}
var $bb0b3502dd43cbf5$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $bb0b3502dd43cbf5$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $bb0b3502dd43cbf5$var$_wrapNativeSuper(Error));
/** @class */ var $bb0b3502dd43cbf5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $bb0b3502dd43cbf5$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $bb0b3502dd43cbf5$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, $68caf4bd6c7da8b9$export$2e2bcd8739ae039).prototype.userAgent
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data; // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            } // otherwise check if error is Network error
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var $bb0b3502dd43cbf5$var$logger = {
    debug: function debug() {}
};
/**
 * For now, all errors are retryable.
 */ var $bb0b3502dd43cbf5$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $bb0b3502dd43cbf5$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $bb0b3502dd43cbf5$var$_wrapNativeSuper(Error));
var $bb0b3502dd43cbf5$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $bb0b3502dd43cbf5$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $bb0b3502dd43cbf5$var$logger.debug("error on " + functionToRetry.name, err);
        if ($bb0b3502dd43cbf5$var$isNonRetryableError(err)) {
            $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $bb0b3502dd43cbf5$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $bb0b3502dd43cbf5$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $bb0b3502dd43cbf5$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $bb0b3502dd43cbf5$var$MAX_DELAY_MS = 300000;
function $bb0b3502dd43cbf5$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $bb0b3502dd43cbf5$var$MAX_DELAY_MS;
    return $bb0b3502dd43cbf5$var$retry(functionToRetry, args, $bb0b3502dd43cbf5$var$jitteredBackoff(maxDelayMs));
}




var $b355f5e976985f5d$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $b355f5e976985f5d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > $b355f5e976985f5d$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $bb0b3502dd43cbf5$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $a337e11db75e0691$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $737214f2f07cda56$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $737214f2f07cda56$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();



var $ae921eff144f1916$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $ae921eff144f1916$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


/** @class */ var $d2150fd716ee36a9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behaviour (default: null)
   */ function CookieStorage(data) {
        if (data.domain) this.domain = data.domain;
        else throw new Error("The domain of cookieStorage can not be undefined.");
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $ae921eff144f1916$exports.set(key, value, options);
        return $ae921eff144f1916$exports.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $ae921eff144f1916$exports.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $ae921eff144f1916$exports.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $ae921eff144f1916$exports.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();







var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));


const $15f24a665de742b6$var$config = {
    url: "https://api.retrohook.com",
    client_url: "https://retrohook.com",
    stripe_api_key: "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",
    nav: [
        {
            name: "Dashboard",
            href: "/",
            current: false
        },
        {
            name: "Workflows",
            href: "/workflows",
            current: false
        },
        {
            name: "Tunnels",
            href: "/tunnels",
            current: false
        }
    ]
};
var $15f24a665de742b6$export$2e2bcd8739ae039 = $15f24a665de742b6$var$config;


var $92d8b824f9c60d69$exports = {};
/**
A function that returns a universally unique identifier (uuid).  
example: 1b83fd69-abe7-468c-bea1-306a8aa1c81d
@returns `string` : 32 character uuid (see example)
*/ function $92d8b824f9c60d69$var$uuid() {
    const hashTable = [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9"
    ];
    let uuid = [];
    for(let i = 0; i < 35; i++)if (i === 7 || i === 12 || i === 17 || i === 22) uuid[i] = "-";
    else uuid[i] = hashTable[Math.floor(Math.random() * hashTable.length - 1)];
    return uuid.join("");
}
$92d8b824f9c60d69$exports = $92d8b824f9c60d69$var$uuid;



const $cb5b9529b8ae0bf0$var$userPoolId = "us-east-1_GKEACqTmC";
const $cb5b9529b8ae0bf0$var$clientId = "4s91koj1asuu9ojevav26bppmo";
const $cb5b9529b8ae0bf0$var$userPool = new (0, $b355f5e976985f5d$export$2e2bcd8739ae039)({
    UserPoolId: $cb5b9529b8ae0bf0$var$userPoolId,
    ClientId: $cb5b9529b8ae0bf0$var$clientId
});
const $cb5b9529b8ae0bf0$var$authContext = /*#__PURE__*/ (0, $acw62.createContext)();
const $cb5b9529b8ae0bf0$var$localAuth = ()=>{
    const user = localStorage.getItem("user");
    if (user) return user;
    else return null;
};
const $cb5b9529b8ae0bf0$var$fetchUserData = ()=>{
    const cognitoUser = $cb5b9529b8ae0bf0$var$userPool.getCurrentUser();
    return new Promise((resolve, reject)=>{
        if (cognitoUser != null) cognitoUser.getSession((err)=>{
            if (err) reject(err);
            cognitoUser.getUserData((attrErr, userData)=>{
                if (attrErr) reject(attrErr);
                resolve(userData);
            }, {
                bypassCache: true
            });
        });
    });
};
const $cb5b9529b8ae0bf0$var$fetchAccount = async (token, id)=>{
    if (token.jwtToken) (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).defaults.headers.common["Authorization"] = "Bearer " + token.jwtToken;
    else (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).defaults.headers.common["Authorization"] = "Bearer " + token;
    return new Promise((resolve, reject)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post(`${(0, $15f24a665de742b6$export$2e2bcd8739ae039).url}/account/get-account/${id}`).then(async (res)=>{
            const account = res.data.account;
            if (account) resolve(account);
            else resolve(null);
        }).catch((err)=>{
            console.error(err);
            reject(Error(err.message));
        });
    });
};
const $cb5b9529b8ae0bf0$var$createAccount = async (token, id, accountParams)=>{
    if (token.jwtToken) (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).defaults.headers.common["Authorization"] = "Bearer " + token.jwtToken;
    else (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).defaults.headers.common["Authorization"] = "Bearer " + token;
    return await (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post(`${(0, $15f24a665de742b6$export$2e2bcd8739ae039).url}/account/register-account/${id}`, {
        accountParams: accountParams
    }).then(async (res)=>{
        const account = res.data;
        if (account) return account;
        else return null;
    }).catch((err)=>{
        console.error(err);
    });
};
const $cb5b9529b8ae0bf0$var$createAWSAccount = async (token, id, accountParams)=>{
    if (token.jwtToken) (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).defaults.headers.common["Authorization"] = "Bearer " + token.jwtToken;
    else (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).defaults.headers.common["Authorization"] = "Bearer " + token;
    return await (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post(`${(0, $15f24a665de742b6$export$2e2bcd8739ae039).url}/account/register-aws-account/${id}`, {
        accountParams: accountParams
    }).then(async (res)=>{
        const account = res.data;
        if (account) return account;
        else return null;
    }).catch((err)=>{
        console.error(err);
    });
};
const $cb5b9529b8ae0bf0$var$constructUser = (session)=>{
    const { sub: sub } = session.getIdToken().decodePayload();
    return {
        admin: session.getAccessToken().decodePayload()["cognito:groups"] ? session.getAccessToken().decodePayload()["cognito:groups"].includes("Admin") : false,
        email: session.getIdToken().decodePayload().email,
        username: session.getAccessToken().decodePayload().username,
        firstName: session.getAccessToken().decodePayload().given_name,
        lastName: session.getAccessToken().decodePayload().family_name,
        tokens: {
            IdToken: session.getIdToken().getJwtToken(),
            AccessToken: session.getAccessToken().getJwtToken(),
            RefreshToken: session.getRefreshToken().getToken()
        },
        attributes: {
            id: sub
        }
    };
};
function $cb5b9529b8ae0bf0$export$30f4dc2f64d6c9c4({ children: children }) {
    const user = $cb5b9529b8ae0bf0$var$localAuth();
    const auth = $cb5b9529b8ae0bf0$var$useProvideAuth(user);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cb5b9529b8ae0bf0$var$authContext.Provider, {
        value: auth,
        children: children
    });
}
const $cb5b9529b8ae0bf0$export$1d39dc5b47e56ff0 = ()=>{
    return (0, $acw62.useContext)($cb5b9529b8ae0bf0$var$authContext);
};
function $cb5b9529b8ae0bf0$var$useProvideAuth(initialState) {
    const [user, setUser] = (0, $acw62.useState)(initialState);
    const setUserCallback = (0, $acw62.useCallback)((user)=>{
        setUser(user);
        localStorage.setItem("user", user);
    }, []);
    (0, $acw62.useEffect)(()=>{
        let isComponentMounted = true;
        const localAuth = async ()=>{
            try {
                const user = await getCurrentUser();
                if (!isComponentMounted) return;
                user.account = await $cb5b9529b8ae0bf0$var$fetchAccount(user.tokens.AccessToken, user.attributes.id);
                if (user) setUserCallback(user);
            } catch (error) {
                if (!isComponentMounted) return;
                setUserCallback(null);
            }
        };
        localAuth();
        return ()=>{
            isComponentMounted = false;
            setUserCallback(null);
        };
    }, []);
    const login = async (username, password)=>{
        const authDetails = new (0, $010becf709f0452a$export$2e2bcd8739ae039)({
            Username: username,
            Password: password
        });
        const user = new (0, $737214f2f07cda56$export$2e2bcd8739ae039)({
            Username: username,
            Pool: $cb5b9529b8ae0bf0$var$userPool
        });
        try {
            const session = await authenticateUser(user, authDetails);
            const userAccount = await processUserAccount(session);
            setUserCallback(userAccount);
            localStorage.setItem("user", JSON.stringify(userAccount));
            return true;
        } catch (error) {
            console.error("Login error:", error);
            throw error;
        }
    };
    const authenticateUser = (user, authDetails)=>{
        return new Promise((resolve, reject)=>{
            user.authenticateUser(authDetails, {
                onSuccess: (session)=>{
                    resolve(session);
                },
                onFailure: (err)=>{
                    reject(err);
                },
                newPasswordRequired: (userAttributes)=>{
                    console.log("New password required:", userAttributes);
                    userAttributes.FORCE_PASSWORD_CHANGE = true;
                    resolve(userAttributes);
                }
            });
        });
    };
    const createAccountHandler = async (session, payload)=>{
        const accountParams = {
            email: payload.email,
            firstName: payload.given_name,
            lastName: payload.family_name,
            organization: payload.nickname
        };
        if (payload["custom:rawToken"] && payload["custom:rawToken"].length > 0) {
            accountParams.type = "aws";
            accountParams.customerIdentifier = payload["custom:customerIdentifier"];
            accountParams.productCode = payload["custom:productCode"];
            accountParams.quantityPurchased = payload["custom:quantityPurchased"];
            accountParams.productExpiration = payload["custom:productExpiration"];
            accountParams.rawToken = payload["custom:rawToken"];
            const account = await $cb5b9529b8ae0bf0$var$createAWSAccount(session.getAccessToken(), payload.sub, accountParams);
            return account;
        } else {
            const account = await $cb5b9529b8ae0bf0$var$createAccount(session.getAccessToken(), payload.sub, accountParams);
            return account;
        }
    };
    const processUserAccount = async (session)=>{
        try {
            await $cb5b9529b8ae0bf0$var$fetchUserData();
            const payload = await session.getIdToken().decodePayload();
            let accountResponse = await $cb5b9529b8ae0bf0$var$fetchAccount(session.getAccessToken().jwtToken, payload.sub);
            console.dir(accountResponse);
            if (!accountResponse) accountResponse = await createAccountHandler(session, payload);
            const user = await $cb5b9529b8ae0bf0$var$constructUser(session);
            user.account = accountResponse;
            return user;
        } catch (error) {
            console.error("Error in processUserAccount:", error);
            throw error; // Rethrow or handle the error as required
        }
    };
    const newPasswordChange = ({ username: username, password: password, newPassword: newPassword })=>{
        const authDetails = new (0, $010becf709f0452a$export$2e2bcd8739ae039)({
            Username: username,
            Password: password
        });
        const user = new (0, $737214f2f07cda56$export$2e2bcd8739ae039)({
            Username: username,
            Pool: $cb5b9529b8ae0bf0$var$userPool
        });
        return new Promise((resolve, reject)=>{
            user.authenticateUser(authDetails, {
                onSuccess: async (session)=>{
                    await $cb5b9529b8ae0bf0$var$fetchUserData();
                    const payload = session.getIdToken().decodePayload();
                    const account = await $cb5b9529b8ae0bf0$var$fetchAccount(session.getAccessToken().getJwtToken(), session.getIdToken().decodePayload().sub);
                    const user = $cb5b9529b8ae0bf0$var$constructUser(session);
                    user.account = account;
                    setUserCallback(user);
                    resolve(true);
                },
                onFailure: (err)=>{
                    reject(err);
                },
                newPasswordRequired: (userAttributes)=>{
                    delete userAttributes.email_verified;
                    delete userAttributes.email;
                    Object.keys(userAttributes).forEach((attributeKey)=>{
                        if (attributeKey.startsWith("custom:") || attributeKey.startsWith("phone")) delete userAttributes[attributeKey];
                    });
                    user.completeNewPasswordChallenge(newPassword, userAttributes, {
                        onSuccess: async (session)=>{
                            await $cb5b9529b8ae0bf0$var$fetchUserData();
                            const payload = session.getIdToken().decodePayload();
                            const account = await $cb5b9529b8ae0bf0$var$fetchAccount(session.getAccessToken().getJwtToken(), payload.sub);
                            const user = $cb5b9529b8ae0bf0$var$constructUser(session);
                            user.account = account;
                            setUserCallback(user);
                            resolve(true);
                        },
                        onFailure: (err)=>{
                            reject(err);
                        }
                    });
                }
            });
        });
    };
    const forgotPassword = async (email)=>{
        const cognitoUser = new (0, $737214f2f07cda56$export$2e2bcd8739ae039)({
            Username: email,
            Pool: $cb5b9529b8ae0bf0$var$userPool
        });
        return new Promise((resolve, reject)=>{
            cognitoUser.forgotPassword({
                onSuccess: function(data) {
                    resolve(data);
                },
                onFailure: function(err) {
                    reject(err);
                }
            });
        });
    };
    const confirmPasswordReset = async (email, verificationCode, newPassword)=>{
        const cognitoUser = new (0, $737214f2f07cda56$export$2e2bcd8739ae039)({
            Username: email,
            Pool: $cb5b9529b8ae0bf0$var$userPool
        });
        return new Promise((resolve, reject)=>{
            cognitoUser.confirmPassword(verificationCode, newPassword, {
                onSuccess () {
                    console.log("Password confirmed!");
                    resolve(true);
                },
                onFailure (err) {
                    console.log("Password not confirmed!");
                    reject(err);
                }
            });
        });
    };
    const logout = async ()=>{
        const user = $cb5b9529b8ae0bf0$var$userPool.getCurrentUser();
        if (user) user.signOut({
            global: true
        });
        window.localStorage.clear();
        setUser(null);
    };
    const register = async (email, organization, firstName, lastName, password, confirm)=>{
        if (!organization) organization = email.split(".")[0].split("@")[1];
        const username = email;
        const emailData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "email",
            Value: email
        });
        const firstNameData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "given_name",
            Value: firstName
        });
        const lastNameData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "family_name",
            Value: lastName
        });
        const organizationData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "nickname",
            Value: organization
        });
        return new Promise((resolve, reject)=>{
            $cb5b9529b8ae0bf0$var$userPool.signUp(username, password, [
                emailData,
                firstNameData,
                lastNameData,
                organizationData
            ], null, (err, result)=>{
                if (err) {
                    console.error(err);
                    reject(err);
                }
                const user = result.user;
                resolve(result);
            });
        });
    };
    const registerAWS = async (email, organization, firstName, lastName, password, confirm, customerIdentifier, productCode, quantityPurchased, productExpiration, rawToken)=>{
        if (!organization) organization = email.split(".")[0].split("@")[1];
        const username = email;
        const emailData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "email",
            Value: email
        });
        const firstNameData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "given_name",
            Value: firstName
        });
        const lastNameData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "family_name",
            Value: lastName
        });
        const organizationData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "nickname",
            Value: organization
        });
        const registrationData = newCognitoUserAttribute({
            Name: "custom:rawToken",
            Value: rawToken
        });
        const customerIdentifierData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "custom:customerIdentifier",
            Value: customerIdentifier
        });
        const productCodeData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "custom:productCode",
            Value: productCode
        });
        const quantityPurchasedData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "custom:quantityPurchased",
            Value: quantityPurchased
        });
        const productExpirationData = new (0, $38555859a52f4863$export$2e2bcd8739ae039)({
            Name: "custom:productExpiration",
            Value: productExpiration
        });
        return new Promise((resolve, reject)=>{
            $cb5b9529b8ae0bf0$var$userPool.signUp(username, password, [
                emailData,
                firstNameData,
                lastNameData,
                organizationData,
                registrationData,
                customerIdentifierData,
                productCodeData,
                quantityPurchasedData,
                productExpirationData
            ], null, (err, result)=>{
                if (err) {
                    console.error(err);
                    reject(err);
                }
                const user = result.user;
                resolve(result);
            });
        });
    };
    const verify = async (email, code)=>{
        const cognitoUser = new (0, $737214f2f07cda56$export$2e2bcd8739ae039)({
            Username: email,
            Pool: $cb5b9529b8ae0bf0$var$userPool
        });
        return new Promise((resolve, reject)=>{
            cognitoUser.confirmRegistration(code, true, function(err, result) {
                if (err) {
                    alert(err.message || JSON.stringify(err));
                    reject(err);
                }
                resolve(result);
            });
        });
    };
    const sendCode = async (email)=>{
        const cognitoUser = new (0, $737214f2f07cda56$export$2e2bcd8739ae039)({
            Username: email,
            Pool: $cb5b9529b8ae0bf0$var$userPool
        });
        return new Promise((resolve, reject)=>{
            cognitoUser.resendConfirmationCode(function(err, result) {
                if (err) {
                    alert(err.message || JSON.stringify(err));
                    reject(err);
                }
                console.log("call result: " + result);
                resolve(result);
            });
        });
    };
    const getCurrentUser = async ()=>{
        const cognitoUser = await $cb5b9529b8ae0bf0$var$userPool.getCurrentUser();
        if (!cognitoUser) {
            logout();
            throw new Error("No Cognito user found");
        }
        try {
            const session = await getSession(cognitoUser);
            const user = await constructUserFromSession(session);
            return user;
        } catch (error) {
            console.error("Error in getCurrentUser:", error);
            logout();
            throw error;
        }
    };
    const getSession = (cognitoUser)=>{
        return new Promise((resolve, reject)=>{
            cognitoUser.getSession((err, session)=>{
                if (err) reject(err);
                else if (session) resolve(session);
                else reject(new Error("No session"));
            });
        });
    };
    const constructUserFromSession = async (session)=>{
        const userData = await $cb5b9529b8ae0bf0$var$fetchUserData(); // Assuming fetchUserData handles its own errors
        const user = $cb5b9529b8ae0bf0$var$constructUser(session); // Assuming constructUser handles its own errors
        const account = await $cb5b9529b8ae0bf0$var$fetchAccount(session.getAccessToken().getJwtToken(), session.getIdToken().decodePayload().sub);
        if (!account) throw new Error("No account associated with the user");
        user.account = account;
        return user;
    };
    return {
        user: user,
        login: login,
        register: register,
        registerAWS: registerAWS,
        verify: verify,
        sendCode: sendCode,
        getCurrentUser: getCurrentUser,
        newPasswordChange: newPasswordChange,
        forgotPassword: forgotPassword,
        confirmPasswordReset: confirmPasswordReset,
        logout: logout
    };
}



var $acw62 = parcelRequire("acw62");
function $52c622b24bc01603$var$useBoolean(defaultValue) {
    const [value, setValue] = (0, $acw62.useState)(!!defaultValue);
    const setTrue = (0, $acw62.useCallback)(()=>setValue(true), []);
    const setFalse = (0, $acw62.useCallback)(()=>setValue(false), []);
    const toggle = (0, $acw62.useCallback)(()=>setValue((x)=>!x), []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $52c622b24bc01603$export$2e2bcd8739ae039 = $52c622b24bc01603$var$useBoolean;



function $e7fa1043157c00bc$var$useClickAnyWhere(handler) {
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("click", (event)=>{
        handler(event);
    });
}
var $e7fa1043157c00bc$export$2e2bcd8739ae039 = $e7fa1043157c00bc$var$useClickAnyWhere;



var $acw62 = parcelRequire("acw62");
var $9a0fde183137c5be$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $9a0fde183137c5be$var$useCopyToClipboard() {
    const [copiedText, setCopiedText] = (0, $acw62.useState)(null);
    const copy = (text)=>$9a0fde183137c5be$var$__awaiter(this, void 0, void 0, function*() {
            if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
                console.warn("Clipboard not supported");
                return false;
            }
            try {
                yield navigator.clipboard.writeText(text);
                setCopiedText(text);
                return true;
            } catch (error) {
                console.warn("Copy failed", error);
                setCopiedText(null);
                return false;
            }
        });
    return [
        copiedText,
        copy
    ];
}
var $9a0fde183137c5be$export$2e2bcd8739ae039 = $9a0fde183137c5be$var$useCopyToClipboard;



var $acw62 = parcelRequire("acw62");

function $dee8059bb01eae67$var$useCountdown(countdownOption) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ("seconds" in countdownOption) {
        console.warn("[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.");
        isDeprecated = true;
        countStart = countdownOption.seconds;
        intervalMs = countdownOption.interval;
        isIncrement = countdownOption.isIncrement;
    } else ({ countStart: countStart, intervalMs: intervalMs, isIncrement: isIncrement, countStop: countStop } = countdownOption);
    intervalMs = intervalMs !== null && intervalMs !== void 0 ? intervalMs : 1000;
    isIncrement = isIncrement !== null && isIncrement !== void 0 ? isIncrement : false;
    countStop = countStop !== null && countStop !== void 0 ? countStop : 0;
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = (0, $64d6a81d3b34103c$export$2e2bcd8739ae039)(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = (0, $52c622b24bc01603$export$2e2bcd8739ae039)(false);
    const resetCountdown = ()=>{
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = (0, $acw62.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    (0, $cad3627fc009bc5c$export$2e2bcd8739ae039)(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated ? [
        count,
        {
            start: startCountdown,
            stop: stopCountdown,
            reset: resetCountdown
        }
    ] : [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
var $dee8059bb01eae67$export$2e2bcd8739ae039 = $dee8059bb01eae67$var$useCountdown;



var $acw62 = parcelRequire("acw62");
function $64d6a81d3b34103c$var$useCounter(initialValue) {
    const [count, setCount] = (0, $acw62.useState)(initialValue || 0);
    const increment = ()=>setCount((x)=>x + 1);
    const decrement = ()=>setCount((x)=>x - 1);
    const reset = ()=>setCount(initialValue || 0);
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
var $64d6a81d3b34103c$export$2e2bcd8739ae039 = $64d6a81d3b34103c$var$useCounter;



const $1f300b0b52e62f92$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
function $1f300b0b52e62f92$var$useDarkMode(defaultValue) {
    var _a;
    const isDarkOS = (0, $07ace55178af353c$export$2e2bcd8739ae039)($1f300b0b52e62f92$var$COLOR_SCHEME_QUERY);
    const [isDarkMode, setDarkMode] = (0, $396aba8b73bd6dda$export$2e2bcd8739ae039)("usehooks-ts-dark-mode", (_a = defaultValue !== null && defaultValue !== void 0 ? defaultValue : isDarkOS) !== null && _a !== void 0 ? _a : false);
    (0, $2abb83b6078c8c26$export$2e2bcd8739ae039)(()=>{
        setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>setDarkMode((prev)=>!prev),
        enable: ()=>setDarkMode(true),
        disable: ()=>setDarkMode(false)
    };
}
var $1f300b0b52e62f92$export$2e2bcd8739ae039 = $1f300b0b52e62f92$var$useDarkMode;



var $acw62 = parcelRequire("acw62");
function $1ccafb8707bec393$var$useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $acw62.useState)(value);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>setDebouncedValue(value), delay || 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
var $1ccafb8707bec393$export$2e2bcd8739ae039 = $1ccafb8707bec393$var$useDebounce;



function $cdb44c1e306f7ce0$var$useDocumentTitle(title) {
    (0, $a99581597c4712df$export$2e2bcd8739ae039)(()=>{
        window.document.title = title;
    }, [
        title
    ]);
}
var $cdb44c1e306f7ce0$export$2e2bcd8739ae039 = $cdb44c1e306f7ce0$var$useDocumentTitle;



var $acw62 = parcelRequire("acw62");
function $6b498fb04d93462e$var$useEffectOnce(effect) {
    (0, $acw62.useEffect)(effect, []);
}
var $6b498fb04d93462e$export$2e2bcd8739ae039 = $6b498fb04d93462e$var$useEffectOnce;



var $acw62 = parcelRequire("acw62");

function $a8074bc33155f19d$var$useElementSize() {
    const [ref, setRef] = (0, $acw62.useState)(null);
    const [size, setSize] = (0, $acw62.useState)({
        width: 0,
        height: 0
    });
    const handleSize = (0, $acw62.useCallback)(()=>{
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0
        });
    }, [
        ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
        ref === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("resize", handleSize);
    (0, $a99581597c4712df$export$2e2bcd8739ae039)(()=>{
        handleSize();
    }, [
        ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
        ref === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    return [
        setRef,
        size
    ];
}
var $a8074bc33155f19d$export$2e2bcd8739ae039 = $a8074bc33155f19d$var$useElementSize;



var $acw62 = parcelRequire("acw62");

function $20cc8019787076a2$export$2e2bcd8739ae039(fn) {
    const ref = (0, $acw62.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    (0, $a99581597c4712df$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $acw62.useCallback)((...args)=>ref.current(...args), [
        ref
    ]);
}



var $acw62 = parcelRequire("acw62");

function $5cf93f27e4ddc68b$var$useEventListener(eventName, handler, element, options) {
    const savedHandler = (0, $acw62.useRef)(handler);
    (0, $a99581597c4712df$export$2e2bcd8739ae039)(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        const targetElement = (_a = element === null || element === void 0 ? void 0 : element.current) !== null && _a !== void 0 ? _a : window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>savedHandler.current(event);
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
var $5cf93f27e4ddc68b$export$2e2bcd8739ae039 = $5cf93f27e4ddc68b$var$useEventListener;



var $acw62 = parcelRequire("acw62");
var $86bc5f4971a34ed3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $86bc5f4971a34ed3$var$useFetch(url, options) {
    const cache = (0, $acw62.useRef)({});
    const cancelRequest = (0, $acw62.useRef)(false);
    const initialState = {
        error: undefined,
        data: undefined
    };
    const fetchReducer = (state, action)=>{
        switch(action.type){
            case "loading":
                return Object.assign({}, initialState);
            case "fetched":
                return Object.assign(Object.assign({}, initialState), {
                    data: action.payload
                });
            case "error":
                return Object.assign(Object.assign({}, initialState), {
                    error: action.payload
                });
            default:
                return state;
        }
    };
    const [state, dispatch] = (0, $acw62.useReducer)(fetchReducer, initialState);
    (0, $acw62.useEffect)(()=>{
        if (!url) return;
        cancelRequest.current = false;
        const fetchData = ()=>$86bc5f4971a34ed3$var$__awaiter(this, void 0, void 0, function*() {
                dispatch({
                    type: "loading"
                });
                if (cache.current[url]) {
                    dispatch({
                        type: "fetched",
                        payload: cache.current[url]
                    });
                    return;
                }
                try {
                    const response = yield fetch(url, options);
                    if (!response.ok) throw new Error(response.statusText);
                    const data = yield response.json();
                    cache.current[url] = data;
                    if (cancelRequest.current) return;
                    dispatch({
                        type: "fetched",
                        payload: data
                    });
                } catch (error) {
                    if (cancelRequest.current) return;
                    dispatch({
                        type: "error",
                        payload: error
                    });
                }
            });
        fetchData();
        return ()=>{
            cancelRequest.current = true;
        };
    }, [
        url
    ]);
    return state;
}
var $86bc5f4971a34ed3$export$2e2bcd8739ae039 = $86bc5f4971a34ed3$var$useFetch;



var $acw62 = parcelRequire("acw62");

function $1949de112e05c281$var$useHover(elementRef) {
    const [value, setValue] = (0, $acw62.useState)(false);
    const handleMouseEnter = ()=>setValue(true);
    const handleMouseLeave = ()=>setValue(false);
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("mouseenter", handleMouseEnter, elementRef);
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("mouseleave", handleMouseLeave, elementRef);
    return value;
}
var $1949de112e05c281$export$2e2bcd8739ae039 = $1949de112e05c281$var$useHover;



var $acw62 = parcelRequire("acw62");
function $4356909ccea20db1$var$useImageOnLoad() {
    const [isLoaded, setIsLoaded] = (0, $acw62.useState)(false);
    const handleImageOnLoad = ()=>{
        setIsLoaded(true);
    };
    const css = {
        thumbnail: {
            visibility: isLoaded ? "hidden" : "visible",
            filter: "blur(8px)",
            transition: "visibility 0ms ease-out 500ms"
        },
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 500ms ease-in 0ms"
        }
    };
    return {
        handleImageOnLoad: handleImageOnLoad,
        css: css
    };
}
var $4356909ccea20db1$export$2e2bcd8739ae039 = $4356909ccea20db1$var$useImageOnLoad;



var $acw62 = parcelRequire("acw62");
function $ac76854689bcd2d8$var$useIntersectionObserver(elementRef, { threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false }) {
    const [entry, setEntry] = (0, $acw62.useState)();
    const frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    const updateEntry = ([entry])=>{
        setEntry(entry);
    };
    (0, $acw62.useEffect)(()=>{
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node) return;
        const observerParams = {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        };
        const observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return ()=>observer.disconnect();
    }, [
        elementRef === null || elementRef === void 0 ? void 0 : elementRef.current,
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen
    ]);
    return entry;
}
var $ac76854689bcd2d8$export$2e2bcd8739ae039 = $ac76854689bcd2d8$var$useIntersectionObserver;



var $acw62 = parcelRequire("acw62");

function $cad3627fc009bc5c$var$useInterval(callback, delay) {
    const savedCallback = (0, $acw62.useRef)(callback);
    (0, $a99581597c4712df$export$2e2bcd8739ae039)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setInterval(()=>savedCallback.current(), delay);
        return ()=>clearInterval(id);
    }, [
        delay
    ]);
}
var $cad3627fc009bc5c$export$2e2bcd8739ae039 = $cad3627fc009bc5c$var$useInterval;



var $acw62 = parcelRequire("acw62");
function $608a4f4ddcf69667$var$useIsClient() {
    const [isClient, setClient] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
var $608a4f4ddcf69667$export$2e2bcd8739ae039 = $608a4f4ddcf69667$var$useIsClient;



var $acw62 = parcelRequire("acw62");
function $b39119e4d1f47989$var$useIsFirstRender() {
    const isFirst = (0, $acw62.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
var $b39119e4d1f47989$export$2e2bcd8739ae039 = $b39119e4d1f47989$var$useIsFirstRender;



var $acw62 = parcelRequire("acw62");
function $c93345c1734e47b6$var$useIsMounted() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $acw62.useCallback)(()=>isMounted.current, []);
}
var $c93345c1734e47b6$export$2e2bcd8739ae039 = $c93345c1734e47b6$var$useIsMounted;



var $acw62 = parcelRequire("acw62");
const $a99581597c4712df$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $a99581597c4712df$export$2e2bcd8739ae039 = $a99581597c4712df$var$useIsomorphicLayoutEffect;



var $acw62 = parcelRequire("acw62");

function $396aba8b73bd6dda$var$useLocalStorage(key, initialValue) {
    const readValue = (0, $acw62.useCallback)(()=>{
        if (typeof window === "undefined") return initialValue;
        try {
            const item = window.localStorage.getItem(key);
            return item ? $396aba8b73bd6dda$var$parseJSON(item) : initialValue;
        } catch (error) {
            console.warn(`Error reading localStorage key \u{201C}${key}\u{201D}:`, error);
            return initialValue;
        }
    }, [
        initialValue,
        key
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(readValue);
    const setValue = (0, $20cc8019787076a2$export$2e2bcd8739ae039)((value)=>{
        if (typeof window === "undefined") console.warn(`Tried setting localStorage key \u{201C}${key}\u{201D} even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.localStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event("local-storage"));
        } catch (error) {
            console.warn(`Error setting localStorage key \u{201C}${key}\u{201D}:`, error);
        }
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("storage", handleStorageChange);
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
var $396aba8b73bd6dda$export$2e2bcd8739ae039 = $396aba8b73bd6dda$var$useLocalStorage;
function $396aba8b73bd6dda$var$parseJSON(value) {
    try {
        return value === "undefined" ? undefined : JSON.parse(value !== null && value !== void 0 ? value : "");
    } catch (_a) {
        console.log("parsing error on", {
            value: value
        });
        return undefined;
    }
}



var $acw62 = parcelRequire("acw62");

function $36875c92d2450a24$var$useLockedBody(initialLocked = false, rootId = "___gatsby") {
    const [locked, setLocked] = (0, $acw62.useState)(initialLocked);
    (0, $a99581597c4712df$export$2e2bcd8739ae039)(()=>{
        if (!locked) return;
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = "hidden";
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) document.body.style.paddingRight = `${scrollBarWidth}px`;
        return ()=>{
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) document.body.style.paddingRight = originalPaddingRight;
        };
    }, [
        locked
    ]);
    (0, $acw62.useEffect)(()=>{
        if (locked !== initialLocked) setLocked(initialLocked);
    }, [
        initialLocked
    ]);
    return [
        locked,
        setLocked
    ];
}
var $36875c92d2450a24$export$2e2bcd8739ae039 = $36875c92d2450a24$var$useLockedBody;



var $acw62 = parcelRequire("acw62");
function $d2bbb64b76121533$var$useMap(initialState = new Map()) {
    const [map, setMap] = (0, $acw62.useState)(new Map(initialState));
    const actions = {
        set: (0, $acw62.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $acw62.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $acw62.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $acw62.useCallback)(()=>{
            setMap(()=>new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
var $d2bbb64b76121533$export$2e2bcd8739ae039 = $d2bbb64b76121533$var$useMap;



var $acw62 = parcelRequire("acw62");
function $07ace55178af353c$var$useMediaQuery(query) {
    const getMatches = (query)=>{
        if (typeof window !== "undefined") return window.matchMedia(query).matches;
        return false;
    };
    const [matches, setMatches] = (0, $acw62.useState)(getMatches(query));
    function handleChange() {
        setMatches(getMatches(query));
    }
    (0, $acw62.useEffect)(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
var $07ace55178af353c$export$2e2bcd8739ae039 = $07ace55178af353c$var$useMediaQuery;



function $cc7a389a0a0df9d8$var$useOnClickOutside(ref, handler, mouseEvent = "mousedown") {
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)(mouseEvent, (event)=>{
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el || el.contains(event.target)) return;
        handler(event);
    });
}
var $cc7a389a0a0df9d8$export$2e2bcd8739ae039 = $cc7a389a0a0df9d8$var$useOnClickOutside;



var $acw62 = parcelRequire("acw62");

function $48dae72734f9cc9f$var$useReadLocalStorage(key) {
    const readValue = (0, $acw62.useCallback)(()=>{
        if (typeof window === "undefined") return null;
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u{201C}${key}\u{201D}:`, error);
            return null;
        }
    }, [
        key
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(readValue);
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("storage", handleStorageChange);
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("local-storage", handleStorageChange);
    return storedValue;
}
var $48dae72734f9cc9f$export$2e2bcd8739ae039 = $48dae72734f9cc9f$var$useReadLocalStorage;



var $acw62 = parcelRequire("acw62");

function $b4952105e572c74c$var$useScreen() {
    const getScreen = ()=>{
        if (typeof window !== "undefined" && window.screen) return window.screen;
        return undefined;
    };
    const [screen, setScreen] = (0, $acw62.useState)(getScreen());
    function handleSize() {
        setScreen(getScreen());
    }
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("resize", handleSize);
    (0, $a99581597c4712df$export$2e2bcd8739ae039)(()=>{
        handleSize();
    }, []);
    return screen;
}
var $b4952105e572c74c$export$2e2bcd8739ae039 = $b4952105e572c74c$var$useScreen;



var $acw62 = parcelRequire("acw62");
const $86933600ef97ba68$var$cachedScriptStatuses = {};
function $86933600ef97ba68$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node === null || node === void 0 ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $86933600ef97ba68$var$useScript(src, options) {
    const [status, setStatus] = (0, $acw62.useState)(()=>{
        var _a;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return (_a = $86933600ef97ba68$var$cachedScriptStatuses[src]) !== null && _a !== void 0 ? _a : "loading";
    });
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $86933600ef97ba68$var$cachedScriptStatuses[src];
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $86933600ef97ba68$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode === null || scriptNode === void 0 || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus((_b = (_a = script.status) !== null && _a !== void 0 ? _a : cachedScriptStatus) !== null && _b !== void 0 ? _b : "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $86933600ef97ba68$var$cachedScriptStatuses[src] = newStatus;
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options === null || options === void 0 ? void 0 : options.removeOnUnmount)) scriptNode.remove();
        };
    }, [
        src,
        options === null || options === void 0 ? void 0 : options.shouldPreventLoad,
        options === null || options === void 0 ? void 0 : options.removeOnUnmount
    ]);
    return status;
}
var $86933600ef97ba68$export$2e2bcd8739ae039 = $86933600ef97ba68$var$useScript;



var $acw62 = parcelRequire("acw62");

function $a55a8f751fdbe3f9$var$useSessionStorage(key, initialValue) {
    const readValue = (0, $acw62.useCallback)(()=>{
        if (typeof window === "undefined") return initialValue;
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? $a55a8f751fdbe3f9$var$parseJSON(item) : initialValue;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u{201C}${key}\u{201D}:`, error);
            return initialValue;
        }
    }, [
        initialValue,
        key
    ]);
    const [storedValue, setStoredValue] = (0, $acw62.useState)(readValue);
    const setValue = (0, $20cc8019787076a2$export$2e2bcd8739ae039)((value)=>{
        if (typeof window == "undefined") console.warn(`Tried setting sessionStorage key \u{201C}${key}\u{201D} even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.sessionStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event("session-storage"));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u{201C}${key}\u{201D}:`, error);
        }
    });
    (0, $acw62.useEffect)(()=>{
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0, $acw62.useCallback)((event)=>{
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("storage", handleStorageChange);
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
var $a55a8f751fdbe3f9$export$2e2bcd8739ae039 = $a55a8f751fdbe3f9$var$useSessionStorage;
function $a55a8f751fdbe3f9$var$parseJSON(value) {
    try {
        return value === "undefined" ? undefined : JSON.parse(value !== null && value !== void 0 ? value : "");
    } catch (_a) {
        console.log("parsing error on", {
            value: value
        });
        return undefined;
    }
}


function $1091769c165f555a$var$useSsr() {
    const isDOM = typeof window !== "undefined" && window.document && window.document.documentElement;
    return {
        isBrowser: isDOM,
        isServer: !isDOM
    };
}
var $1091769c165f555a$export$2e2bcd8739ae039 = $1091769c165f555a$var$useSsr;



var $acw62 = parcelRequire("acw62");
function $2b9ef8a032defe05$var$useStep(maxStep) {
    const [currentStep, setCurrentStep] = (0, $acw62.useState)(1);
    const canGoToNextStep = (0, $acw62.useMemo)(()=>currentStep + 1 <= maxStep, [
        currentStep,
        maxStep
    ]);
    const canGoToPrevStep = (0, $acw62.useMemo)(()=>currentStep - 1 >= 1, [
        currentStep
    ]);
    const setStep = (0, $acw62.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $acw62.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $acw62.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
var $2b9ef8a032defe05$export$2e2bcd8739ae039 = $2b9ef8a032defe05$var$useStep;



var $acw62 = parcelRequire("acw62");

const $f1a6efe10b00aa4a$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
function $f1a6efe10b00aa4a$var$useTernaryDarkMode() {
    const isDarkOS = (0, $07ace55178af353c$export$2e2bcd8739ae039)($f1a6efe10b00aa4a$var$COLOR_SCHEME_QUERY);
    const [ternaryDarkMode, setTernaryDarkMode] = (0, $396aba8b73bd6dda$export$2e2bcd8739ae039)("usehooks-ts-ternary-dark-mode", "system");
    const [isDarkMode, setDarkMode] = (0, $acw62.useState)(isDarkOS);
    (0, $2abb83b6078c8c26$export$2e2bcd8739ae039)(()=>{
        if (ternaryDarkMode === "system") setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    (0, $acw62.useEffect)(()=>{
        switch(ternaryDarkMode){
            case "light":
                setDarkMode(false);
                break;
            case "system":
                setDarkMode(isDarkOS);
                break;
            case "dark":
                setDarkMode(true);
                break;
        }
    }, [
        ternaryDarkMode,
        isDarkOS
    ]);
    function toggleTernaryDarkMode() {
        const toggleDict = {
            light: "system",
            system: "dark",
            dark: "light"
        };
        setTernaryDarkMode((prevMode)=>toggleDict[prevMode]);
    }
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: ternaryDarkMode,
        setTernaryDarkMode: setTernaryDarkMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
var $f1a6efe10b00aa4a$export$2e2bcd8739ae039 = $f1a6efe10b00aa4a$var$useTernaryDarkMode;



var $acw62 = parcelRequire("acw62");

function $624eae122b438c99$var$useTimeout(callback, delay) {
    const savedCallback = (0, $acw62.useRef)(callback);
    (0, $a99581597c4712df$export$2e2bcd8739ae039)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>savedCallback.current(), delay);
        return ()=>clearTimeout(id);
    }, [
        delay
    ]);
}
var $624eae122b438c99$export$2e2bcd8739ae039 = $624eae122b438c99$var$useTimeout;



var $acw62 = parcelRequire("acw62");
function $7e232d63fbe5a971$var$useToggle(defaultValue) {
    const [value, setValue] = (0, $acw62.useState)(!!defaultValue);
    const toggle = (0, $acw62.useCallback)(()=>setValue((x)=>!x), []);
    return [
        value,
        toggle,
        setValue
    ];
}
var $7e232d63fbe5a971$export$2e2bcd8739ae039 = $7e232d63fbe5a971$var$useToggle;



var $acw62 = parcelRequire("acw62");

function $2abb83b6078c8c26$var$useUpdateEffect(effect, deps) {
    const isFirst = (0, $b39119e4d1f47989$export$2e2bcd8739ae039)();
    (0, $acw62.useEffect)(()=>{
        if (!isFirst) return effect();
    }, deps);
}
var $2abb83b6078c8c26$export$2e2bcd8739ae039 = $2abb83b6078c8c26$var$useUpdateEffect;



var $acw62 = parcelRequire("acw62");

function $a25161eb6503ae4b$var$useWindowSize() {
    const [windowSize, setWindowSize] = (0, $acw62.useState)({
        width: 0,
        height: 0
    });
    const handleSize = ()=>{
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    (0, $5cf93f27e4ddc68b$export$2e2bcd8739ae039)("resize", handleSize);
    (0, $a99581597c4712df$export$2e2bcd8739ae039)(()=>{
        handleSize();
    }, []);
    return windowSize;
}
var $a25161eb6503ae4b$export$2e2bcd8739ae039 = $a25161eb6503ae4b$var$useWindowSize;





var $acw62 = parcelRequire("acw62");
var $83d4e0016262c3a3$exports = {};
"use strict";
var $83d4e0016262c3a3$var$__assign = $83d4e0016262c3a3$exports && $83d4e0016262c3a3$exports.__assign || function() {
    $83d4e0016262c3a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $83d4e0016262c3a3$var$__assign.apply(this, arguments);
};
Object.defineProperty($83d4e0016262c3a3$exports, "__esModule", {
    value: true
});
var $83d4e0016262c3a3$var$Device;
(function(Device) {
    Device["Browser"] = "browser";
    Device["Server"] = "server";
    Device["Native"] = "native";
})($83d4e0016262c3a3$var$Device = $83d4e0016262c3a3$exports.Device || ($83d4e0016262c3a3$exports.Device = {}));
var $83d4e0016262c3a3$var$Browser = $83d4e0016262c3a3$var$Device.Browser, $83d4e0016262c3a3$var$Server = $83d4e0016262c3a3$var$Device.Server, $83d4e0016262c3a3$var$Native = $83d4e0016262c3a3$var$Device.Native;
var $83d4e0016262c3a3$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $83d4e0016262c3a3$var$canUseNative = typeof navigator != "undefined" && navigator.product == "ReactNative";
var $83d4e0016262c3a3$var$device = $83d4e0016262c3a3$var$canUseNative ? $83d4e0016262c3a3$var$Native : $83d4e0016262c3a3$var$canUseDOM ? $83d4e0016262c3a3$var$Browser : $83d4e0016262c3a3$var$Server;
var $83d4e0016262c3a3$var$SSRObject = {
    isBrowser: $83d4e0016262c3a3$var$device === $83d4e0016262c3a3$var$Browser,
    isServer: $83d4e0016262c3a3$var$device === $83d4e0016262c3a3$var$Server,
    isNative: $83d4e0016262c3a3$var$device === $83d4e0016262c3a3$var$Native,
    device: $83d4e0016262c3a3$var$device,
    canUseWorkers: typeof Worker !== "undefined",
    canUseEventListeners: $83d4e0016262c3a3$var$device === $83d4e0016262c3a3$var$Browser && !!window.addEventListener,
    canUseViewport: $83d4e0016262c3a3$var$device === $83d4e0016262c3a3$var$Browser && !!window.screen
};
// TODO: instead of this, do a polyfill for `Object.assign` https://www.npmjs.com/package/es6-object-assign
var $83d4e0016262c3a3$var$assign = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.reduce(function(acc, obj) {
        return $83d4e0016262c3a3$var$__assign($83d4e0016262c3a3$var$__assign({}, acc), obj);
    }, {});
};
var $83d4e0016262c3a3$var$values = function(obj) {
    return Object.keys(obj).map(function(key) {
        return obj[key];
    });
};
var $83d4e0016262c3a3$var$toArrayObject = function() {
    return $83d4e0016262c3a3$var$assign(($83d4e0016262c3a3$var$values($83d4e0016262c3a3$var$SSRObject), $83d4e0016262c3a3$var$SSRObject));
};
var $83d4e0016262c3a3$var$useSSRObject = $83d4e0016262c3a3$var$toArrayObject();
$83d4e0016262c3a3$exports.weAreServer = function() {
    $83d4e0016262c3a3$var$SSRObject.isServer = true;
    $83d4e0016262c3a3$var$useSSRObject = $83d4e0016262c3a3$var$toArrayObject();
};
$83d4e0016262c3a3$exports.useSSR = function() {
    return $83d4e0016262c3a3$var$useSSRObject;
};
$83d4e0016262c3a3$exports.default = $83d4e0016262c3a3$exports.useSSR;


var $00251e2e176309d0$exports = {};
"use strict";
Object.defineProperty($00251e2e176309d0$exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
/**
 * Determines if the given param is an object. {}
 * @param obj
 */ $00251e2e176309d0$exports.isObject = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}; // eslint-disable-line
var $00251e2e176309d0$var$useMounted = function() {
    var mounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    return mounted;
};
function $00251e2e176309d0$var$useRefState(initialState, blockIfUnmounted) {
    if (blockIfUnmounted === void 0) blockIfUnmounted = true;
    var mounted = $00251e2e176309d0$var$useMounted();
    var _a = $acw62.useState(initialState), reactState = _a[0], setReactState = _a[1];
    var state = $acw62.useRef(reactState);
    var setState = $acw62.useCallback(function(arg) {
        if (!mounted.current && blockIfUnmounted) return;
        state.current = typeof arg === "function" ? arg(state.current) : arg;
        setReactState(state.current);
    }, []);
    return [
        state,
        setState
    ];
}
$00251e2e176309d0$exports.useRefState = $00251e2e176309d0$var$useRefState;
$00251e2e176309d0$exports.default = $00251e2e176309d0$var$useRefState;


var $f1b9943439e11985$export$f03a741ee867f39c;
(function(HTTPMethod) {
    HTTPMethod["DELETE"] = "DELETE";
    HTTPMethod["GET"] = "GET";
    HTTPMethod["HEAD"] = "HEAD";
    HTTPMethod["OPTIONS"] = "OPTIONS";
    HTTPMethod["PATCH"] = "PATCH";
    HTTPMethod["POST"] = "POST";
    HTTPMethod["PUT"] = "PUT";
    HTTPMethod["CONNECT"] = "CONNECT";
    HTTPMethod["TRACE"] = "TRACE";
})($f1b9943439e11985$export$f03a741ee867f39c || ($f1b9943439e11985$export$f03a741ee867f39c = {}));
var $f1b9943439e11985$export$539a4d7220d600df;
(function(CachePolicies) {
    /**
     * This is the default value where we always try reading data
     * from your cache first. If all the data needed to fulfill
     * your query is in the cache then that data will be returned.
     * useFetch will only fetch from the network if a cached result
     * is not available. This fetch policy aims to minimize the number
     * of network requests sent when rendering your component.
     */ CachePolicies["CACHE_FIRST"] = "cache-first";
    /**
     * This fetch policy will have useFetch first trying to read data
     * from your cache. If all the data needed to fulfill your query
     * is in the cache then that data will be returned. However,
     * regardless of whether or not the full data is in your cache
     * this fetchPolicy will always execute query with the network
     * interface unlike cache-first which will only execute your query
     * if the query data is not in your cache. This fetch policy optimizes
     * for users getting a quick response while also trying to keep
     * cached data consistent with your server data at the cost of extra
     * network requests.
     */ CachePolicies["CACHE_AND_NETWORK"] = "cache-and-network";
    /**
     * This fetch policy will never return your initial data from the
     * cache. Instead it will always make a request using your network
     * interface to the server. This fetch policy optimizes for data
     * consistency with the server, but at the cost of an instant response
     * to the user when one is available.
     */ CachePolicies["NETWORK_ONLY"] = "network-only";
    /**
     * This fetch policy will never execute a query using your network
     * interface. Instead it will always try reading from the cache. If the
     * data for your query does not exist in the cache then an error will be
     * thrown. This fetch policy allows you to only interact with data in
     * your local client cache without making any network requests which
     * keeps your component fast, but means your local data might not be
     * consistent with what is on the server.
     */ CachePolicies["CACHE_ONLY"] = "cache-only";
    /**
     * This fetch policy will never return your initial data from the cache.
     * Instead it will always make a request using your network interface to
     * the server. Unlike the network-only policy, it also will not write
     * any data to the cache after the query completes.
     */ CachePolicies["NO_CACHE"] = "no-cache";
    CachePolicies["EXACT_CACHE_AND_NETWORK"] = "exact-cache-and-network";
})($f1b9943439e11985$export$539a4d7220d600df || ($f1b9943439e11985$export$539a4d7220d600df = {}));



var $acw62 = parcelRequire("acw62");

var $ee4649c695f5d655$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ee4649c695f5d655$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ee4649c695f5d655$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
function $ee4649c695f5d655$export$f5708dca728d7177(condition, format, a, b, c, d, e, f) {
    if (a === void 0) a = "";
    if (b === void 0) b = "";
    if (c === void 0) c = "";
    if (d === void 0) d = "";
    if (e === void 0) e = "";
    if (f === void 0) f = "";
    if (!condition) {
        var error = void 0;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args_1 = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex_1 = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args_1[argIndex_1++];
            }));
            error.name = "Invariant Violation";
        }
        throw error;
    }
}
var $ee4649c695f5d655$export$a8d8866bb84b2760 = function() {
    var isBrowser = (0, (/*@__PURE__*/$parcel$interopDefault($83d4e0016262c3a3$exports)))().isBrowser;
    return (0, $acw62.useMemo)(function() {
        return isBrowser ? window.location.origin : "https://example.com";
    }, [
        isBrowser
    ]);
};
function $ee4649c695f5d655$export$f5863b4ba3e7594(condition, method, optionalMessage) {
    var exampleURL = $ee4649c695f5d655$export$a8d8866bb84b2760();
    (0, $acw62.useEffect)(function() {
        $ee4649c695f5d655$export$f5708dca728d7177(condition, method + ' requires a URL to be set as the 1st argument,\n\n      unless you wrap your app like:\n\n      <Provider url="' + exampleURL + '"><App /></Provider>\n\n      ' + optionalMessage);
    }, [
        condition,
        exampleURL,
        method,
        optionalMessage
    ]);
}
var $ee4649c695f5d655$export$844ec244b1367d54 = function(x) {
    return typeof x === "string";
}; // eslint-disable-line
var $ee4649c695f5d655$export$a6cdc56e425d0d0a = function(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}; // eslint-disable-line
var $ee4649c695f5d655$export$4d67c6ef5413975a = function(obj) {
    return $ee4649c695f5d655$export$a6cdc56e425d0d0a(obj) || Array.isArray(obj);
};
var $ee4649c695f5d655$export$f6e2535fb5126e54 = function(v) {
    return typeof v === "function";
};
var $ee4649c695f5d655$export$7e4aa119212bc614 = function(v) {
    return Object.prototype.toString.call(v) === "[object Number]";
};
var $ee4649c695f5d655$export$18a03f54df5b22a6 = function(options) {
    if (!options) return {};
    var requestInitFields = [
        "body",
        "cache",
        "credentials",
        "headers",
        "integrity",
        "keepalive",
        "method",
        "mode",
        "redirect",
        "referrer",
        "referrerPolicy",
        "signal",
        "window"
    ];
    return requestInitFields.reduce(function(acc, key) {
        if (key in options) acc[key] = options[key];
        return acc;
    }, {});
};
var $ee4649c695f5d655$export$dd1bc94b04021eeb = function(x) {
    return x === undefined || x === null;
};
var $ee4649c695f5d655$export$8215d14a63d9fb10;
(function(Device) {
    Device["Browser"] = "browser";
    Device["Server"] = "server";
    Device["Native"] = "native";
})($ee4649c695f5d655$export$8215d14a63d9fb10 || ($ee4649c695f5d655$export$8215d14a63d9fb10 = {}));
var $ee4649c695f5d655$var$Browser = $ee4649c695f5d655$export$8215d14a63d9fb10.Browser, $ee4649c695f5d655$var$Server = $ee4649c695f5d655$export$8215d14a63d9fb10.Server, $ee4649c695f5d655$var$Native = $ee4649c695f5d655$export$8215d14a63d9fb10.Native;
var $ee4649c695f5d655$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $ee4649c695f5d655$var$canUseNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $ee4649c695f5d655$var$device = $ee4649c695f5d655$var$canUseNative ? $ee4649c695f5d655$var$Native : $ee4649c695f5d655$var$canUseDOM ? $ee4649c695f5d655$var$Browser : $ee4649c695f5d655$var$Server;
var $ee4649c695f5d655$export$4e09c449d6c407f7 = $ee4649c695f5d655$var$device === $ee4649c695f5d655$var$Browser;
var $ee4649c695f5d655$export$6acf61af03e62db = $ee4649c695f5d655$var$device === $ee4649c695f5d655$var$Server;
var $ee4649c695f5d655$export$43ab85c863381e0 = $ee4649c695f5d655$var$device === $ee4649c695f5d655$var$Native;
var $ee4649c695f5d655$export$ab71d8246317109a = function(res, defaultData, responseType) {
    return $ee4649c695f5d655$var$__awaiter(void 0, void 0, void 0, function() {
        var types, data;
        return $ee4649c695f5d655$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (typeof res === "undefined") throw Error("Response cannot be undefined... \uD83D\uDE35");
                    if (typeof responseType === "undefined") throw Error("responseType cannot be undefined... \uD83D\uDE35");
                    types = Array.isArray(responseType) ? responseType : [
                        responseType
                    ];
                    if (types[0] == null) throw Error("could not parse data from response \uD83D\uDE35");
                    return [
                        4 /*yield*/ ,
                        $ee4649c695f5d655$var$tryRetry(res, types)
                    ];
                case 1:
                    data = _a.sent();
                    return [
                        2 /*return*/ ,
                        !$ee4649c695f5d655$export$dd1bc94b04021eeb(defaultData) && $ee4649c695f5d655$export$dd1bc94b04021eeb(data) ? defaultData : data
                    ];
            }
        });
    });
};
var $ee4649c695f5d655$var$tryRetry = function(res, types, i) {
    if (i === void 0) i = 0;
    return $ee4649c695f5d655$var$__awaiter(void 0, void 0, void 0, function() {
        var error_1;
        return $ee4649c695f5d655$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        res.clone()[types[i]]()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 2:
                    error_1 = _a.sent();
                    if (types.length - 1 === i) throw error_1;
                    return [
                        2 /*return*/ ,
                        $ee4649c695f5d655$var$tryRetry(res.clone(), types, ++i)
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $ee4649c695f5d655$export$bee57555ae13b1f = [
    "headers",
    "ok",
    "redirected",
    "trailer",
    "status",
    "statusText",
    "type",
    "url",
    "body",
    "bodyUsed",
    "data"
];
var $ee4649c695f5d655$export$9e34ddd7091d9483 = [
    "clone",
    "arrayBuffer",
    "blob",
    "formData",
    "json",
    "text"
];
var $ee4649c695f5d655$export$d5e7aed3caab5530 = $ee4649c695f5d655$var$__spreadArrays($ee4649c695f5d655$export$bee57555ae13b1f, $ee4649c695f5d655$export$9e34ddd7091d9483);
var $ee4649c695f5d655$export$238dd1dd1833b120 = function(res, data) {
    return Object.defineProperties({}, $ee4649c695f5d655$export$d5e7aed3caab5530.reduce(function(acc, field) {
        if ($ee4649c695f5d655$export$bee57555ae13b1f.includes(field)) acc[field] = {
            get: function() {
                var response = res instanceof Response ? res : res && res.current;
                if (!response) return;
                if (field === "data") return data.current;
                var clonedResponse = "clone" in response ? response.clone() : {};
                return clonedResponse[field];
            },
            enumerable: true
        };
        else if ($ee4649c695f5d655$export$9e34ddd7091d9483.includes(field)) acc[field] = {
            value: function() {
                var response = res instanceof Response ? res : res && res.current;
                if (!response) return;
                var clonedResponse = "clone" in response ? response.clone() : {};
                return clonedResponse[field]();
            },
            enumerable: true
        };
        return acc;
    }, {}));
};
var $ee4649c695f5d655$export$68021f2d72274f97 = $ee4649c695f5d655$export$238dd1dd1833b120();
// TODO: switch this to .reduce()
var $ee4649c695f5d655$var$headersAsObject = function(headers) {
    var obj = {};
    headers.forEach(function(value, key) {
        obj[key] = value;
    });
    return obj;
};
var $ee4649c695f5d655$export$e79f7b4385e9e161 = function(response) {
    return $ee4649c695f5d655$var$__awaiter(void 0, void 0, void 0, function() {
        var body, status, statusText, headers;
        return $ee4649c695f5d655$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        response.text()
                    ];
                case 1:
                    body = _a.sent();
                    status = response.status, statusText = response.statusText;
                    headers = $ee4649c695f5d655$var$headersAsObject(response.headers);
                    return [
                        2 /*return*/ ,
                        {
                            body: body,
                            status: status,
                            statusText: statusText,
                            headers: headers
                        }
                    ];
            }
        });
    });
};
function $ee4649c695f5d655$var$useDeepCompareMemoize(value) {
    var ref = (0, $acw62.useRef)();
    if (JSON.stringify(value) !== JSON.stringify(ref.current)) ref.current = value;
    return ref.current;
}
var $ee4649c695f5d655$export$90712c7e321b5cb0 = function(cb, deps) {
    return (0, $acw62.useCallback)(cb, $ee4649c695f5d655$var$useDeepCompareMemoize(deps));
};
var $ee4649c695f5d655$export$e772c8ff12451969 = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};
var $ee4649c695f5d655$export$5374bb854d0e41c8 = function(n) {
    return Number.isInteger(n) && n > 0;
};
var $ee4649c695f5d655$export$5a4bb2b1c89bdce7 = function(name, message) {
    var error = new Error(message);
    error.name = name + "";
    return error;
};
var $ee4649c695f5d655$export$497e59625710527b = function(input, url) {
    if (!input) return "";
    if (!url) {
        if (input.startsWith("?") || input.startsWith("&") || input.startsWith("/")) return input;
        return "/" + input;
    }
    if (url.endsWith("/") && input.startsWith("/")) return input.substr(1);
    if (!url.endsWith("/") && !input.startsWith("/") && !input.startsWith("?") && !input.startsWith("&") && !url.includes("?")) return "/" + input;
    return input;
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $44c2ce4212999889$export$ee70503aaf87a390 = (0, $acw62.createContext)({
    url: "",
    options: {},
    graphql: false // TODO: this will make it so useFetch(QUERY || MUTATION) will work
});
var $44c2ce4212999889$export$2e2bcd8739ae039 = $44c2ce4212999889$export$ee70503aaf87a390;




var $65e0205c3cbec34a$var$__assign = undefined && undefined.__assign || function() {
    $65e0205c3cbec34a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $65e0205c3cbec34a$var$__assign.apply(this, arguments);
};
var $65e0205c3cbec34a$export$3b1a4818f9ff6fca = {
    host: "",
    path: undefined,
    customOptions: {
        cacheLife: 0,
        cachePolicy: (0, $f1b9943439e11985$export$539a4d7220d600df).CACHE_FIRST,
        interceptors: {},
        onAbort: function() {},
        onError: function() {},
        onNewData: function(currData, newData) {
            return newData;
        },
        onTimeout: function() {},
        perPage: 0,
        persist: false,
        responseType: [
            "json",
            "text",
            "blob",
            "arrayBuffer"
        ],
        retries: 0,
        retryDelay: 1000,
        retryOn: [],
        suspense: false,
        timeout: 0,
        // defaults
        data: undefined,
        loading: false
    },
    requestInit: {
        headers: {
            Accept: "application/json, text/plain, */*"
        }
    },
    dependencies: undefined
};
var $65e0205c3cbec34a$export$2e2bcd8739ae039 = Object.entries($65e0205c3cbec34a$export$3b1a4818f9ff6fca).reduce(function(acc, _a) {
    var _b;
    var key = _a[0], value = _a[1];
    if ((0, $ee4649c695f5d655$export$a6cdc56e425d0d0a)(value)) return $65e0205c3cbec34a$var$__assign($65e0205c3cbec34a$var$__assign({}, acc), value);
    return $65e0205c3cbec34a$var$__assign($65e0205c3cbec34a$var$__assign({}, acc), (_b = {}, _b[key] = value, _b));
}, {});


var $e07d3072c2a130ae$var$__assign = undefined && undefined.__assign || function() {
    $e07d3072c2a130ae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e07d3072c2a130ae$var$__assign.apply(this, arguments);
};
function $e07d3072c2a130ae$export$2e2bcd8739ae039(urlOrPathOrOptionsOrOverwriteGlobalOptions, optionsOrOverwriteGlobalOrDeps, deps) {
    (0, $ee4649c695f5d655$export$f5708dca728d7177)(!((0, $ee4649c695f5d655$export$a6cdc56e425d0d0a)(urlOrPathOrOptionsOrOverwriteGlobalOptions) && (0, $ee4649c695f5d655$export$a6cdc56e425d0d0a)(optionsOrOverwriteGlobalOrDeps)), "You cannot have a 2nd parameter of useFetch as object when your first argument is an object.");
    var context = (0, $acw62.useContext)((0, $44c2ce4212999889$export$2e2bcd8739ae039));
    var host = (0, $acw62.useMemo)(function() {
        var maybeHost = urlOrPathOrOptionsOrOverwriteGlobalOptions;
        if ((0, $ee4649c695f5d655$export$844ec244b1367d54)(maybeHost) && maybeHost.includes("://")) return maybeHost;
        if (context.url) return context.url;
        return (0, $65e0205c3cbec34a$export$2e2bcd8739ae039).host;
    }, [
        context.url,
        urlOrPathOrOptionsOrOverwriteGlobalOptions
    ]);
    var path = (0, $acw62.useMemo)(function() {
        var maybePath = urlOrPathOrOptionsOrOverwriteGlobalOptions;
        if ((0, $ee4649c695f5d655$export$844ec244b1367d54)(maybePath) && !maybePath.includes("://")) return maybePath;
    }, [
        urlOrPathOrOptionsOrOverwriteGlobalOptions
    ]);
    var overwriteGlobalOptions = (0, $acw62.useMemo)(function() {
        if ((0, $ee4649c695f5d655$export$f6e2535fb5126e54)(urlOrPathOrOptionsOrOverwriteGlobalOptions)) return urlOrPathOrOptionsOrOverwriteGlobalOptions;
        if ((0, $ee4649c695f5d655$export$f6e2535fb5126e54)(optionsOrOverwriteGlobalOrDeps)) return optionsOrOverwriteGlobalOrDeps;
    }, []);
    var options = (0, $acw62.useMemo)(function() {
        var localOptions = {
            headers: {}
        };
        if ((0, $ee4649c695f5d655$export$a6cdc56e425d0d0a)(urlOrPathOrOptionsOrOverwriteGlobalOptions)) localOptions = urlOrPathOrOptionsOrOverwriteGlobalOptions;
        else if ((0, $ee4649c695f5d655$export$a6cdc56e425d0d0a)(optionsOrOverwriteGlobalOrDeps)) localOptions = optionsOrOverwriteGlobalOrDeps;
        var globalOptions = context.options;
        var finalOptions = $e07d3072c2a130ae$var$__assign($e07d3072c2a130ae$var$__assign($e07d3072c2a130ae$var$__assign($e07d3072c2a130ae$var$__assign({}, (0, $65e0205c3cbec34a$export$2e2bcd8739ae039)), globalOptions), localOptions), {
            headers: $e07d3072c2a130ae$var$__assign($e07d3072c2a130ae$var$__assign($e07d3072c2a130ae$var$__assign({}, (0, $65e0205c3cbec34a$export$2e2bcd8739ae039).headers), globalOptions.headers), localOptions.headers),
            interceptors: $e07d3072c2a130ae$var$__assign($e07d3072c2a130ae$var$__assign($e07d3072c2a130ae$var$__assign({}, (0, $65e0205c3cbec34a$export$2e2bcd8739ae039).interceptors), globalOptions.interceptors), localOptions.interceptors)
        });
        if (overwriteGlobalOptions) return overwriteGlobalOptions(finalOptions);
        return finalOptions;
    }, [
        urlOrPathOrOptionsOrOverwriteGlobalOptions,
        overwriteGlobalOptions,
        context.options
    ]);
    var requestInit = (0, $acw62.useMemo)(function() {
        return (0, $ee4649c695f5d655$export$18a03f54df5b22a6)(options);
    }, [
        options
    ]);
    var dependencies = (0, $acw62.useMemo)(function() {
        if (Array.isArray(optionsOrOverwriteGlobalOrDeps)) return optionsOrOverwriteGlobalOrDeps;
        if (Array.isArray(deps)) return deps;
        return (0, $65e0205c3cbec34a$export$2e2bcd8739ae039).dependencies;
    }, [
        optionsOrOverwriteGlobalOrDeps,
        deps
    ]);
    var cacheLife = options.cacheLife, retries = options.retries, retryDelay = options.retryDelay, retryOn = options.retryOn;
    (0, $ee4649c695f5d655$export$f5708dca728d7177)(Number.isInteger(cacheLife) && cacheLife >= 0, "`cacheLife` must be a number >= 0");
    (0, $ee4649c695f5d655$export$f5708dca728d7177)(Number.isInteger(retries) && retries >= 0, "`retries` must be a number >= 0");
    (0, $ee4649c695f5d655$export$f5708dca728d7177)((0, $ee4649c695f5d655$export$f6e2535fb5126e54)(retryDelay) || Number.isInteger(retryDelay) && retryDelay >= 0, "`retryDelay` must be a positive number or a function returning a positive number.");
    var isValidRetryOn = (0, $ee4649c695f5d655$export$f6e2535fb5126e54)(retryOn) || Array.isArray(retryOn) && retryOn.every((0, $ee4649c695f5d655$export$5374bb854d0e41c8));
    (0, $ee4649c695f5d655$export$f5708dca728d7177)(isValidRetryOn, "`retryOn` must be an array of positive numbers or a function returning a boolean.");
    var loading = options.loading || Array.isArray(dependencies);
    var interceptors = (0, $acw62.useMemo)(function() {
        var final = {};
        if ("request" in options.interceptors) final.request = options.interceptors.request;
        if ("response" in options.interceptors) final.response = options.interceptors.response;
        return final;
    }, [
        options
    ]);
    var customOptions = (0, $acw62.useMemo)(function() {
        var customOptionKeys = Object.keys((0, $65e0205c3cbec34a$export$3b1a4818f9ff6fca).customOptions); // Array<keyof CustomOptions>
        var customOptions = customOptionKeys.reduce(function(opts, key) {
            opts[key] = options[key];
            return opts;
        }, {});
        return $e07d3072c2a130ae$var$__assign($e07d3072c2a130ae$var$__assign({}, customOptions), {
            interceptors: interceptors,
            loading: loading
        });
    }, [
        interceptors,
        loading
    ]);
    return {
        host: host,
        path: path,
        customOptions: customOptions,
        requestInit: requestInit,
        dependencies: dependencies
    };
}




var $6139100602dc17b7$var$__assign = undefined && undefined.__assign || function() {
    $6139100602dc17b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6139100602dc17b7$var$__assign.apply(this, arguments);
};
var $6139100602dc17b7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6139100602dc17b7$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6139100602dc17b7$var$GET = (0, $f1b9943439e11985$export$f03a741ee867f39c).GET;
function $6139100602dc17b7$export$2e2bcd8739ae039(initialOptions, method, controller, cacheLife, cache, host, path, routeOrBody, bodyAs2ndParam, requestInterceptor) {
    return $6139100602dc17b7$var$__awaiter(this, void 0, void 0, function() {
        var route, url, body, headers, options, responseID, _a, _b;
        var _this = this;
        return $6139100602dc17b7$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    (0, $ee4649c695f5d655$export$f5708dca728d7177)(!((0, $ee4649c695f5d655$export$4d67c6ef5413975a)(routeOrBody) && (0, $ee4649c695f5d655$export$4d67c6ef5413975a)(bodyAs2ndParam)), "If first argument of " + method.toLowerCase() + "() is an object, you cannot have a 2nd argument. \uD83D\uDE1C");
                    (0, $ee4649c695f5d655$export$f5708dca728d7177)(!(method === $6139100602dc17b7$var$GET && (0, $ee4649c695f5d655$export$4d67c6ef5413975a)(routeOrBody)), "You can only have query params as 1st argument of request.get()");
                    (0, $ee4649c695f5d655$export$f5708dca728d7177)(!(method === $6139100602dc17b7$var$GET && bodyAs2ndParam !== undefined), "You can only have query params as 1st argument of request.get()");
                    route = function() {
                        if (!(0, $ee4649c695f5d655$export$6acf61af03e62db) && routeOrBody instanceof URLSearchParams) return "?" + routeOrBody;
                        if ((0, $ee4649c695f5d655$export$844ec244b1367d54)(routeOrBody)) return routeOrBody;
                        return "";
                    }();
                    url = "" + host + (0, $ee4649c695f5d655$export$497e59625710527b)(path, host) + (0, $ee4649c695f5d655$export$497e59625710527b)(route);
                    body = function() {
                        // FormData instanceof check should go first, because React Native's FormData implementation
                        // is indistinguishable from plain object when using isBodyObject check
                        if (routeOrBody instanceof FormData) return routeOrBody;
                        if ((0, $ee4649c695f5d655$export$4d67c6ef5413975a)(routeOrBody)) return JSON.stringify(routeOrBody);
                        if (!(0, $ee4649c695f5d655$export$6acf61af03e62db) && (bodyAs2ndParam instanceof FormData || bodyAs2ndParam instanceof URLSearchParams)) return bodyAs2ndParam;
                        if ((0, $ee4649c695f5d655$export$4d67c6ef5413975a)(bodyAs2ndParam) || (0, $ee4649c695f5d655$export$844ec244b1367d54)(bodyAs2ndParam)) return JSON.stringify(bodyAs2ndParam);
                        if ((0, $ee4649c695f5d655$export$4d67c6ef5413975a)(initialOptions.body) || (0, $ee4649c695f5d655$export$844ec244b1367d54)(bodyAs2ndParam)) return JSON.stringify(initialOptions.body);
                        return null;
                    }();
                    headers = function() {
                        var contentType = (initialOptions.headers || {})["Content-Type"];
                        var shouldAddContentType = !!contentType || [
                            (0, $f1b9943439e11985$export$f03a741ee867f39c).POST,
                            (0, $f1b9943439e11985$export$f03a741ee867f39c).PUT,
                            (0, $f1b9943439e11985$export$f03a741ee867f39c).PATCH
                        ].includes(method) && !(body instanceof FormData);
                        var headers = $6139100602dc17b7$var$__assign({}, initialOptions.headers);
                        if (shouldAddContentType) // default content types http://bit.ly/2N2ovOZ
                        // Accept: 'application/json',
                        // roughly, should only add for POST and PUT http://bit.ly/2NJNt3N
                        // unless specified by the user
                        headers["Content-Type"] = contentType || "application/json";
                        else if (Object.keys(headers).length === 0) return null;
                        return headers;
                    }();
                    return [
                        4 /*yield*/ ,
                        function() {
                            return $6139100602dc17b7$var$__awaiter(_this, void 0, void 0, function() {
                                var opts, interceptor;
                                return $6139100602dc17b7$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            opts = $6139100602dc17b7$var$__assign($6139100602dc17b7$var$__assign({}, initialOptions), {
                                                method: method,
                                                signal: controller.signal
                                            });
                                            if (headers !== null) opts.headers = headers;
                                            else delete opts.headers;
                                            if (body !== null) opts.body = body;
                                            if (!requestInterceptor) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                requestInterceptor({
                                                    options: opts,
                                                    url: host,
                                                    path: path,
                                                    route: route
                                                })
                                            ];
                                        case 1:
                                            interceptor = _a.sent();
                                            return [
                                                2 /*return*/ ,
                                                interceptor
                                            ];
                                        case 2:
                                            return [
                                                2 /*return*/ ,
                                                opts
                                            ];
                                    }
                                });
                            });
                        }()
                    ];
                case 1:
                    options = _c.sent();
                    responseID = Object.entries({
                        url: url,
                        method: method,
                        body: options.body || ""
                    }).map(function(_a) {
                        var key = _a[0], value = _a[1];
                        return key + ":" + value;
                    }).join("||");
                    _a = {
                        url: url,
                        options: options
                    };
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        cache.has(responseID)
                    ];
                case 2:
                    _b.isCached = _c.sent(), _b.id = responseID;
                    return [
                        4 /*yield*/ ,
                        cache.get(responseID)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        (_a.response = (_b.cached = _c.sent(), _b), _a)
                    ];
            }
        });
    });
}







var $4237a5fe97bcf97e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4237a5fe97bcf97e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4237a5fe97bcf97e$var$cacheName = "useHTTPcache";
var $4237a5fe97bcf97e$var$getCache = function() {
    try {
        return JSON.parse(localStorage.getItem($4237a5fe97bcf97e$var$cacheName) || "{}");
    } catch (err) {
        localStorage.removeItem($4237a5fe97bcf97e$var$cacheName);
        return {};
    }
};
var $4237a5fe97bcf97e$var$getLocalStorage = function(_a) {
    var cacheLife = _a.cacheLife;
    var remove = function() {
        var responseIDs = [];
        for(var _i = 0; _i < arguments.length; _i++)responseIDs[_i] = arguments[_i];
        return $4237a5fe97bcf97e$var$__awaiter(void 0, void 0, void 0, function() {
            var cache;
            return $4237a5fe97bcf97e$var$__generator(this, function(_a) {
                cache = $4237a5fe97bcf97e$var$getCache();
                responseIDs.forEach(function(id) {
                    return delete cache[id];
                });
                localStorage.setItem($4237a5fe97bcf97e$var$cacheName, JSON.stringify(cache));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var isExpired = function(responseID) {
        var cache = $4237a5fe97bcf97e$var$getCache();
        var _a = cache[responseID] || {}, expiration = _a.expiration, response = _a.response;
        var expired = expiration > 0 && expiration < Date.now();
        if (expired) remove(responseID);
        return expired || !response;
    };
    var has = function(responseID) {
        return $4237a5fe97bcf97e$var$__awaiter(void 0, void 0, void 0, function() {
            return $4237a5fe97bcf97e$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    !isExpired(responseID)
                ];
            });
        });
    };
    var get = function(responseID) {
        return $4237a5fe97bcf97e$var$__awaiter(void 0, void 0, void 0, function() {
            var cache, _a, body, headers, status, statusText;
            return $4237a5fe97bcf97e$var$__generator(this, function(_b) {
                if (isExpired(responseID)) return [
                    2 /*return*/ 
                ];
                cache = $4237a5fe97bcf97e$var$getCache();
                _a = cache[responseID].response, body = _a.body, headers = _a.headers, status = _a.status, statusText = _a.statusText;
                return [
                    2 /*return*/ ,
                    new Response(body, {
                        status: status,
                        statusText: statusText,
                        headers: new Headers(headers || {})
                    })
                ];
            });
        });
    };
    var set = function(responseID, response) {
        return $4237a5fe97bcf97e$var$__awaiter(void 0, void 0, void 0, function() {
            var cache, _a, _b, _c;
            return $4237a5fe97bcf97e$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        cache = $4237a5fe97bcf97e$var$getCache();
                        _a = cache;
                        _b = responseID;
                        _c = {};
                        return [
                            4 /*yield*/ ,
                            (0, $ee4649c695f5d655$export$e79f7b4385e9e161)(response)
                        ];
                    case 1:
                        _a[_b] = (_c.response = _d.sent(), _c.expiration = Date.now() + cacheLife, _c);
                        localStorage.setItem($4237a5fe97bcf97e$var$cacheName, JSON.stringify(cache));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clear = function() {
        return $4237a5fe97bcf97e$var$__awaiter(void 0, void 0, void 0, function() {
            return $4237a5fe97bcf97e$var$__generator(this, function(_a) {
                localStorage.setItem($4237a5fe97bcf97e$var$cacheName, JSON.stringify({}));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return Object.defineProperties($4237a5fe97bcf97e$var$getCache(), {
        get: {
            value: get,
            writable: false
        },
        set: {
            value: set,
            writable: false
        },
        has: {
            value: has,
            writable: false
        },
        delete: {
            value: remove,
            writable: false
        },
        clear: {
            value: clear,
            writable: false
        }
    });
};
var $4237a5fe97bcf97e$export$2e2bcd8739ae039 = $4237a5fe97bcf97e$var$getLocalStorage;


var $33c347c53f8697ef$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $33c347c53f8697ef$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $33c347c53f8697ef$var$inMemoryStorage = {};
var $33c347c53f8697ef$var$getMemoryStorage = function(_a) {
    var cacheLife = _a.cacheLife;
    var remove = function() {
        var responseIDs = [];
        for(var _i = 0; _i < arguments.length; _i++)responseIDs[_i] = arguments[_i];
        return $33c347c53f8697ef$var$__awaiter(void 0, void 0, void 0, function() {
            var _a, responseIDs_1, responseID;
            return $33c347c53f8697ef$var$__generator(this, function(_b) {
                for(_a = 0, responseIDs_1 = responseIDs; _a < responseIDs_1.length; _a++){
                    responseID = responseIDs_1[_a];
                    delete $33c347c53f8697ef$var$inMemoryStorage[responseID];
                    delete $33c347c53f8697ef$var$inMemoryStorage[responseID + ":ts"];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var isExpired = function(responseID) {
        var expiration = $33c347c53f8697ef$var$inMemoryStorage[responseID + ":ts"];
        var expired = expiration > 0 && expiration < Date.now();
        if (expired) remove(responseID);
        return expired || !$33c347c53f8697ef$var$inMemoryStorage[responseID];
    };
    var get = function(responseID) {
        return $33c347c53f8697ef$var$__awaiter(void 0, void 0, void 0, function() {
            return $33c347c53f8697ef$var$__generator(this, function(_a) {
                if (isExpired(responseID)) return [
                    2 /*return*/ 
                ];
                return [
                    2 /*return*/ ,
                    $33c347c53f8697ef$var$inMemoryStorage[responseID]
                ];
            });
        });
    };
    var set = function(responseID, res) {
        return $33c347c53f8697ef$var$__awaiter(void 0, void 0, void 0, function() {
            return $33c347c53f8697ef$var$__generator(this, function(_a) {
                $33c347c53f8697ef$var$inMemoryStorage[responseID] = res;
                $33c347c53f8697ef$var$inMemoryStorage[responseID + ":ts"] = cacheLife > 0 ? Date.now() + cacheLife : 0;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var has = function(responseID) {
        return $33c347c53f8697ef$var$__awaiter(void 0, void 0, void 0, function() {
            return $33c347c53f8697ef$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    !isExpired(responseID)
                ];
            });
        });
    };
    var clear = function() {
        return $33c347c53f8697ef$var$__awaiter(void 0, void 0, void 0, function() {
            return $33c347c53f8697ef$var$__generator(this, function(_a) {
                $33c347c53f8697ef$var$inMemoryStorage = {};
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return Object.defineProperties($33c347c53f8697ef$var$inMemoryStorage, {
        get: {
            value: get,
            writable: false,
            configurable: true
        },
        set: {
            value: set,
            writable: false,
            configurable: true
        },
        has: {
            value: has,
            writable: false,
            configurable: true
        },
        delete: {
            value: remove,
            writable: false,
            configurable: true
        },
        clear: {
            value: clear,
            writable: false,
            configurable: true
        }
    });
};
var $33c347c53f8697ef$export$2e2bcd8739ae039 = $33c347c53f8697ef$var$getMemoryStorage;


var $e705a1350376e7dc$var$NETWORK_ONLY = (0, $f1b9943439e11985$export$539a4d7220d600df).NETWORK_ONLY, $e705a1350376e7dc$var$NO_CACHE = (0, $f1b9943439e11985$export$539a4d7220d600df).NO_CACHE;
var $e705a1350376e7dc$var$useCache = function(_a) {
    var persist = _a.persist, cacheLife = _a.cacheLife, cachePolicy = _a.cachePolicy;
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($83d4e0016262c3a3$exports)))(), isNative = _b.isNative, isServer = _b.isServer;
    (0, $ee4649c695f5d655$export$f5708dca728d7177)(!(isServer && persist), "There is no persistent storage on the Server currently! \uD83D\uDE45\u200D\u2642\uFE0F");
    (0, $ee4649c695f5d655$export$f5708dca728d7177)(!(isNative && persist), "React Native support for persistent cache is not yet implemented. \uD83D\uDE45\u200D\u2642\uFE0F");
    (0, $ee4649c695f5d655$export$f5708dca728d7177)(!(persist && [
        $e705a1350376e7dc$var$NO_CACHE,
        $e705a1350376e7dc$var$NETWORK_ONLY
    ].includes(cachePolicy)), "You cannot use option 'persist' with cachePolicy: " + cachePolicy + " \uD83D\uDE45\u200D\u2642\uFE0F");
    // right now we're not worrying about react-native
    if (persist) return (0, $4237a5fe97bcf97e$export$2e2bcd8739ae039)({
        cacheLife: cacheLife || 86400000
    });
    return (0, $33c347c53f8697ef$export$2e2bcd8739ae039)({
        cacheLife: cacheLife
    });
};
var $e705a1350376e7dc$export$2e2bcd8739ae039 = $e705a1350376e7dc$var$useCache;


var $b91bde21b94476b1$var$__assign = undefined && undefined.__assign || function() {
    $b91bde21b94476b1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b91bde21b94476b1$var$__assign.apply(this, arguments);
};
var $b91bde21b94476b1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b91bde21b94476b1$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b91bde21b94476b1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b91bde21b94476b1$var$CACHE_FIRST = (0, $f1b9943439e11985$export$539a4d7220d600df).CACHE_FIRST;
function $b91bde21b94476b1$export$d852f5f778460fa4() {
    var _this = this;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var _a = (0, $e07d3072c2a130ae$export$2e2bcd8739ae039).apply(void 0, args), host = _a.host, path = _a.path, customOptions = _a.customOptions, requestInit = _a.requestInit, dependencies = _a.dependencies;
    var cacheLife = customOptions.cacheLife, cachePolicy = customOptions.cachePolicy, interceptors = customOptions.interceptors, onAbort = customOptions.onAbort, onError = customOptions.onError, onNewData = customOptions.onNewData, onTimeout = customOptions.onTimeout, perPage = customOptions.perPage, persist = customOptions.persist, responseType = customOptions.responseType, retries = customOptions.retries, retryDelay = customOptions.retryDelay, retryOn = customOptions.retryOn, suspense = customOptions.suspense, timeout = customOptions.timeout, defaults = $b91bde21b94476b1$var$__rest(customOptions, [
        "cacheLife",
        "cachePolicy",
        "interceptors",
        "onAbort",
        "onError",
        "onNewData",
        "onTimeout",
        "perPage",
        "persist",
        "responseType",
        "retries",
        "retryDelay",
        "retryOn",
        "suspense",
        "timeout"
    ]);
    var cache = (0, $e705a1350376e7dc$export$2e2bcd8739ae039)({
        persist: persist,
        cacheLife: cacheLife,
        cachePolicy: cachePolicy
    });
    var isServer = (0, (/*@__PURE__*/$parcel$interopDefault($83d4e0016262c3a3$exports)))().isServer;
    var controller = (0, $acw62.useRef)();
    var res = (0, $acw62.useRef)({});
    var data = (0, $acw62.useRef)(defaults.data);
    var timedout = (0, $acw62.useRef)(false);
    var attempt = (0, $acw62.useRef)(0);
    var error = (0, $acw62.useRef)();
    var hasMore = (0, $acw62.useRef)(true);
    var suspenseStatus = (0, $acw62.useRef)("pending");
    var suspender = (0, $acw62.useRef)();
    var mounted = (0, $acw62.useRef)(false);
    var _b = (0, (/*@__PURE__*/$parcel$interopDefault($00251e2e176309d0$exports)))(defaults.loading), loading = _b[0], setLoading = _b[1];
    var forceUpdate = (0, $acw62.useReducer)(function() {
        return {};
    }, [])[1];
    var makeFetch = (0, $ee4649c695f5d655$export$90712c7e321b5cb0)(function(method) {
        var doFetch = function(routeOrBody, body) {
            return $b91bde21b94476b1$var$__awaiter(_this, void 0, void 0, function() {
                var theController, _a, url, options, response, timer, newData, newRes, _b, _c, opts, shouldRetry, _d, _e, theData, err_1, opts, shouldRetry, _f, _g, theData;
                return $b91bde21b94476b1$var$__generator(this, function(_h) {
                    switch(_h.label){
                        case 0:
                            if (isServer) return [
                                2 /*return*/ 
                            ]; // for now, we don't do anything on the server
                            controller.current = new AbortController();
                            controller.current.signal.onabort = onAbort;
                            theController = controller.current;
                            return [
                                4 /*yield*/ ,
                                (0, $6139100602dc17b7$export$2e2bcd8739ae039)(requestInit, method, theController, cacheLife, cache, host, path, routeOrBody, body, interceptors.request)
                            ];
                        case 1:
                            _a = _h.sent(), url = _a.url, options = _a.options, response = _a.response;
                            error.current = undefined;
                            // don't perform the request if there is no more data to fetch (pagination)
                            if (perPage > 0 && !hasMore.current && !error.current) return [
                                2 /*return*/ ,
                                data.current
                            ];
                            if (!suspense) setLoading(true);
                            timer = timeout && setTimeout(function() {
                                timedout.current = true;
                                theController.abort();
                                if (onTimeout) onTimeout();
                            }, timeout);
                            _h.label = 2;
                        case 2:
                            _h.trys.push([
                                2,
                                17,
                                23,
                                24
                            ]);
                            if (!(response.isCached && cachePolicy === $b91bde21b94476b1$var$CACHE_FIRST)) return [
                                3 /*break*/ ,
                                3
                            ];
                            newRes = response.cached;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                fetch(url, options)
                            ];
                        case 4:
                            newRes = _h.sent().clone();
                            _h.label = 5;
                        case 5:
                            res.current = newRes.clone();
                            return [
                                4 /*yield*/ ,
                                (0, $ee4649c695f5d655$export$ab71d8246317109a)(newRes, defaults.data, responseType)
                            ];
                        case 6:
                            newData = _h.sent();
                            res.current.data = onNewData(data.current, newData);
                            _b = res;
                            if (!interceptors.response) return [
                                3 /*break*/ ,
                                8
                            ];
                            return [
                                4 /*yield*/ ,
                                interceptors.response({
                                    response: res.current,
                                    request: requestInit
                                })
                            ];
                        case 7:
                            _c = _h.sent();
                            return [
                                3 /*break*/ ,
                                9
                            ];
                        case 8:
                            _c = res.current;
                            _h.label = 9;
                        case 9:
                            _b.current = _c;
                            (0, $ee4649c695f5d655$export$f5708dca728d7177)("data" in res.current, "You must have `data` field on the Response returned from your `interceptors.response`");
                            data.current = res.current.data;
                            opts = {
                                attempt: attempt.current,
                                response: newRes
                            };
                            // if we just have `retries` set with NO `retryOn` then
                            // automatically retry on fail until attempts run out
                            _d = !(0, $ee4649c695f5d655$export$f6e2535fb5126e54)(retryOn) && Array.isArray(retryOn) && retryOn.length < 1 && (newRes === null || newRes === void 0 ? void 0 : newRes.ok) === false || Array.isArray(retryOn) && retryOn.includes(newRes.status);
                            if (_d) // if we just have `retries` set with NO `retryOn` then
                            // automatically retry on fail until attempts run out
                            return [
                                3 /*break*/ ,
                                12
                            ];
                            _e = (0, $ee4649c695f5d655$export$f6e2535fb5126e54)(retryOn);
                            if (!_e) return [
                                3 /*break*/ ,
                                11
                            ];
                            return [
                                4 /*yield*/ ,
                                retryOn(opts)
                            ];
                        case 10:
                            _e = _h.sent();
                            _h.label = 11;
                        case 11:
                            _d = _e;
                            _h.label = 12;
                        case 12:
                            shouldRetry = _d && retries > 0 && retries > attempt.current;
                            if (!shouldRetry) return [
                                3 /*break*/ ,
                                14
                            ];
                            return [
                                4 /*yield*/ ,
                                retry(opts, routeOrBody, body)
                            ];
                        case 13:
                            theData = _h.sent();
                            return [
                                2 /*return*/ ,
                                theData
                            ];
                        case 14:
                            if (!(cachePolicy === $b91bde21b94476b1$var$CACHE_FIRST && !response.isCached)) return [
                                3 /*break*/ ,
                                16
                            ];
                            return [
                                4 /*yield*/ ,
                                cache.set(response.id, newRes.clone())
                            ];
                        case 15:
                            _h.sent();
                            _h.label = 16;
                        case 16:
                            if (Array.isArray(data.current) && !!(data.current.length % perPage)) hasMore.current = false;
                            return [
                                3 /*break*/ ,
                                24
                            ];
                        case 17:
                            err_1 = _h.sent();
                            if (attempt.current >= retries && timedout.current) error.current = (0, $ee4649c695f5d655$export$5a4bb2b1c89bdce7)("AbortError", "Timeout Error");
                            opts = {
                                attempt: attempt.current,
                                error: err_1
                            };
                            // if we just have `retries` set with NO `retryOn` then
                            // automatically retry on fail until attempts run out
                            _f = !(0, $ee4649c695f5d655$export$f6e2535fb5126e54)(retryOn) && Array.isArray(retryOn) && retryOn.length < 1;
                            if (_f) // if we just have `retries` set with NO `retryOn` then
                            // automatically retry on fail until attempts run out
                            return [
                                3 /*break*/ ,
                                20
                            ];
                            _g = (0, $ee4649c695f5d655$export$f6e2535fb5126e54)(retryOn);
                            if (!_g) return [
                                3 /*break*/ ,
                                19
                            ];
                            return [
                                4 /*yield*/ ,
                                retryOn(opts)
                            ];
                        case 18:
                            _g = _h.sent();
                            _h.label = 19;
                        case 19:
                            _f = _g;
                            _h.label = 20;
                        case 20:
                            shouldRetry = _f && retries > 0 && retries > attempt.current;
                            if (!shouldRetry) return [
                                3 /*break*/ ,
                                22
                            ];
                            return [
                                4 /*yield*/ ,
                                retry(opts, routeOrBody, body)
                            ];
                        case 21:
                            theData = _h.sent();
                            return [
                                2 /*return*/ ,
                                theData
                            ];
                        case 22:
                            if (err_1.name !== "AbortError") error.current = err_1;
                            return [
                                3 /*break*/ ,
                                24
                            ];
                        case 23:
                            timedout.current = false;
                            if (timer) clearTimeout(timer);
                            controller.current = undefined;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 24:
                            if (newRes && !newRes.ok && !error.current) error.current = (0, $ee4649c695f5d655$export$5a4bb2b1c89bdce7)(newRes.status, newRes.statusText);
                            if (!suspense) setLoading(false);
                            if (attempt.current === retries) attempt.current = 0;
                            if (error.current) onError({
                                error: error.current
                            });
                            return [
                                2 /*return*/ ,
                                data.current
                            ];
                    }
                });
            });
        }; // end of doFetch()
        var retry = function(opts, routeOrBody, body) {
            return $b91bde21b94476b1$var$__awaiter(_this, void 0, void 0, function() {
                var delay, d;
                return $b91bde21b94476b1$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            delay = (0, $ee4649c695f5d655$export$f6e2535fb5126e54)(retryDelay) ? retryDelay(opts) : retryDelay;
                            if (!(Number.isInteger(delay) && delay >= 0)) console.error("retryDelay must be a number >= 0! If you're using it as a function, it must also return a number >= 0.");
                            attempt.current++;
                            if (!delay) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $ee4649c695f5d655$export$e772c8ff12451969)(delay)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                doFetch(routeOrBody, body)
                            ];
                        case 3:
                            d = _a.sent();
                            return [
                                2 /*return*/ ,
                                d
                            ];
                    }
                });
            });
        };
        if (suspense) return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return $b91bde21b94476b1$var$__awaiter(_this, void 0, void 0, function() {
                var newData;
                return $b91bde21b94476b1$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            suspender.current = doFetch.apply(void 0, args).then(function(newData) {
                                suspenseStatus.current = "success";
                                return newData;
                            }, function() {
                                suspenseStatus.current = "error";
                            });
                            forceUpdate();
                            return [
                                4 /*yield*/ ,
                                suspender.current
                            ];
                        case 1:
                            newData = _a.sent();
                            return [
                                2 /*return*/ ,
                                newData
                            ];
                    }
                });
            });
        };
        return doFetch;
    }, [
        isServer,
        onAbort,
        requestInit,
        host,
        path,
        interceptors,
        cachePolicy,
        perPage,
        timeout,
        persist,
        cacheLife,
        onTimeout,
        defaults.data,
        onNewData,
        forceUpdate,
        suspense
    ]);
    var post = (0, $acw62.useCallback)(makeFetch((0, $f1b9943439e11985$export$f03a741ee867f39c).POST), [
        makeFetch
    ]);
    var del = (0, $acw62.useCallback)(makeFetch((0, $f1b9943439e11985$export$f03a741ee867f39c).DELETE), [
        makeFetch
    ]);
    var request = (0, $acw62.useMemo)(function() {
        return Object.defineProperties({
            get: makeFetch((0, $f1b9943439e11985$export$f03a741ee867f39c).GET),
            post: post,
            patch: makeFetch((0, $f1b9943439e11985$export$f03a741ee867f39c).PATCH),
            put: makeFetch((0, $f1b9943439e11985$export$f03a741ee867f39c).PUT),
            options: makeFetch((0, $f1b9943439e11985$export$f03a741ee867f39c).OPTIONS),
            head: makeFetch((0, $f1b9943439e11985$export$f03a741ee867f39c).HEAD),
            connect: makeFetch((0, $f1b9943439e11985$export$f03a741ee867f39c).CONNECT),
            trace: makeFetch((0, $f1b9943439e11985$export$f03a741ee867f39c).TRACE),
            del: del,
            delete: del,
            abort: function() {
                return controller.current && controller.current.abort();
            },
            query: function(query, variables) {
                return post({
                    query: query,
                    variables: variables
                });
            },
            mutate: function(mutation, variables) {
                return post({
                    mutation: mutation,
                    variables: variables
                });
            },
            cache: cache
        }, {
            loading: {
                get: function() {
                    return loading.current;
                }
            },
            error: {
                get: function() {
                    return error.current;
                }
            },
            data: {
                get: function() {
                    return data.current;
                }
            }
        });
    }, [
        makeFetch
    ]);
    var response = (0, $acw62.useMemo)(function() {
        return (0, $ee4649c695f5d655$export$238dd1dd1833b120)(res, data);
    }, []);
    // onMount/onUpdate
    (0, $acw62.useEffect)(function() {
        mounted.current = true;
        if (Array.isArray(dependencies)) {
            var methodName = requestInit.method || (0, $f1b9943439e11985$export$f03a741ee867f39c).GET;
            var methodLower = methodName.toLowerCase();
            var req = request[methodLower];
            req();
        }
        return function() {
            return mounted.current = false;
        };
    }, dependencies);
    // Cancel any running request when unmounting to avoid updating state after component has unmounted
    // This can happen if a request's promise resolves after component unmounts
    (0, $acw62.useEffect)(function() {
        return request.abort;
    }, []);
    if (suspense && suspender.current) {
        if (isServer) throw new Error("Suspense on server side is not yet supported! \uD83D\uDE45\u200D\u2642\uFE0F");
        switch(suspenseStatus.current){
            case "pending":
                throw suspender.current;
            case "error":
                throw error.current;
        }
    }
    return Object.assign([
        request,
        response,
        loading.current,
        error.current
    ], $b91bde21b94476b1$var$__assign($b91bde21b94476b1$var$__assign({
        request: request,
        response: response
    }, request), {
        loading: loading.current,
        data: data.current,
        error: error.current
    }));
}
var $b91bde21b94476b1$export$2e2bcd8739ae039 = $b91bde21b94476b1$export$d852f5f778460fa4;



var $acw62 = parcelRequire("acw62");



var $0287170e3b2af14f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0287170e3b2af14f$export$609860bf8b0084c = function(urlOrMutation, mutationArg) {
    var context = (0, $acw62.useContext)((0, $44c2ce4212999889$export$ee70503aaf87a390));
    (0, $ee4649c695f5d655$export$f5863b4ba3e7594)(!!context.url && Array.isArray(urlOrMutation), "useMutation");
    (0, $ee4649c695f5d655$export$f5863b4ba3e7594)(!!context.url || (0, $ee4649c695f5d655$export$844ec244b1367d54)(urlOrMutation) && !mutationArg, "useMutation", 'OR you need to do useMutation("https://example.com", `your graphql mutation`)');
    // regular no context: useMutation('https://example.com', `graphql MUTATION`)
    var url = urlOrMutation;
    var MUTATION = mutationArg;
    // tagged template literal with context: useMutation`graphql MUTATION`
    if (Array.isArray(urlOrMutation) && context.url) {
        (0, $ee4649c695f5d655$export$f5708dca728d7177)(!mutationArg, "You cannot have a 2nd argument when using tagged template literal syntax with useMutation.");
        url = context.url;
        MUTATION = urlOrMutation[0];
    // regular with context: useMutation(`graphql MUTATION`)
    } else if (urlOrMutation && !mutationArg && context.url) {
        url = context.url;
        MUTATION = urlOrMutation;
    }
    var _a = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)(url), loading = _a.loading, error = _a.error, cache = _a.cache, request = $0287170e3b2af14f$var$__rest(_a, [
        "loading",
        "error",
        "cache"
    ]);
    var mutate = (0, $acw62.useCallback)(function(inputs) {
        return request.mutate(MUTATION, inputs);
    }, [
        MUTATION,
        request
    ]);
    var data = (request.data || {
        data: undefined
    }).data;
    return Object.assign([
        data,
        loading,
        error,
        mutate
    ], {
        data: data,
        loading: loading,
        error: error,
        mutate: mutate,
        cache: cache
    });
};



var $acw62 = parcelRequire("acw62");



var $73861471ff816c66$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $73861471ff816c66$export$dd0a697e1782aedd = function(urlOrQuery, queryArg) {
    var context = (0, $acw62.useContext)((0, $44c2ce4212999889$export$ee70503aaf87a390));
    (0, $ee4649c695f5d655$export$f5863b4ba3e7594)(!!context.url && Array.isArray(urlOrQuery), "useQuery");
    (0, $ee4649c695f5d655$export$f5863b4ba3e7594)(!!context.url || (0, $ee4649c695f5d655$export$844ec244b1367d54)(urlOrQuery) && !queryArg, "useQuery", 'OR you need to do useQuery("https://example.com", `your graphql query`)');
    // regular no context: useQuery('https://example.com', `graphql QUERY`)
    var url = urlOrQuery;
    var QUERY = queryArg;
    // tagged template literal with context: useQuery`graphql QUERY`
    if (Array.isArray(urlOrQuery) && context.url) {
        (0, $ee4649c695f5d655$export$f5708dca728d7177)(!queryArg, "You cannot have a 2nd argument when using tagged template literal syntax with useQuery.");
        url = context.url;
        QUERY = urlOrQuery[0];
    // regular with context: useQuery(`graphql QUERY`)
    } else if (urlOrQuery && !queryArg && context.url) {
        url = context.url;
        QUERY = urlOrQuery;
    }
    var _a = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)(url), loading = _a.loading, error = _a.error, cache = _a.cache, request = $73861471ff816c66$var$__rest(_a, [
        "loading",
        "error",
        "cache"
    ]);
    var query = (0, $acw62.useCallback)(function(variables) {
        return request.query(QUERY, variables);
    }, [
        QUERY,
        request
    ]);
    var data = (request.data || {
        data: undefined
    }).data;
    return Object.assign([
        data,
        loading,
        error,
        query
    ], {
        data: data,
        loading: loading,
        error: error,
        query: query,
        cache: cache
    });
};



var $acw62 = parcelRequire("acw62");


var $53dbc123c10664bd$export$2881499e37b75b9a = function(_a) {
    var url = _a.url, options = _a.options, _b = _a.graphql, graphql = _b === void 0 ? false : _b, children = _a.children;
    var isBrowser = (0, (/*@__PURE__*/$parcel$interopDefault($83d4e0016262c3a3$exports)))().isBrowser;
    var defaults = (0, $acw62.useMemo)(function() {
        return {
            url: url || (isBrowser ? window.location.origin : ""),
            options: options || {},
            graphql: graphql // TODO: this will make it so useFetch(QUERY || MUTATION) will work
        };
    }, [
        options,
        graphql,
        isBrowser,
        url
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $44c2ce4212999889$export$2e2bcd8739ae039).Provider, {
        value: defaults
    }, children);
};








var $1c66380376aa2c89$exports = {};
"use strict";
var $e5dd19a945a45bbb$exports = {};
"use strict";
var $08e53d4ef2e1f8ef$exports = {};
"use strict";

var $1zENl = parcelRequire("1zENl");
var $d12f4cdcd6b10506$exports = {};
"use strict";

var $1zENl = parcelRequire("1zENl");
var $9546dce5bd4976bd$exports = {};
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);
var $9546dce5bd4976bd$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
var $9546dce5bd4976bd$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
if ($9546dce5bd4976bd$var$$defineProperty) try {
    $9546dce5bd4976bd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9546dce5bd4976bd$var$$defineProperty = null;
}
$9546dce5bd4976bd$exports = function callBind(originalFunction) {
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    if ($9546dce5bd4976bd$var$$gOPD && $9546dce5bd4976bd$var$$defineProperty) {
        var desc = $9546dce5bd4976bd$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $9546dce5bd4976bd$var$$defineProperty(func, "length", {
            value: 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($9546dce5bd4976bd$var$$defineProperty) $9546dce5bd4976bd$var$$defineProperty($9546dce5bd4976bd$exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else $9546dce5bd4976bd$exports.apply = $9546dce5bd4976bd$var$applyBind;


var $d12f4cdcd6b10506$var$$indexOf = $9546dce5bd4976bd$exports($1zENl("String.prototype.indexOf"));
$d12f4cdcd6b10506$exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $9546dce5bd4976bd$exports(intrinsic);
    return intrinsic;
};


var $a48090c7c3dfd2b6$exports = {};
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === "function" && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === "function" && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, "$&_") + "." + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, "$&_");
}

var $kjyEk = parcelRequire("kjyEk");
var $a48090c7c3dfd2b6$var$inspectCustom = $kjyEk.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
$a48090c7c3dfd2b6$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($a48090c7c3dfd2b6$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a48090c7c3dfd2b6$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $a48090c7c3dfd2b6$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === "object" && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = "<" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return "[" + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + "]";
        return "[ " + $a48090c7c3dfd2b6$var$$join.call(xs, ", ") + " ]";
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === "function" && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Map", $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Set", $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakMap");
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakSet");
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakRef");
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $a48090c7c3dfd2b6$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, "&quot;");
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Array]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Date]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object RegExp]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Error]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object String]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Number]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Boolean]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, "single", opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === "function" ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $08e53d4ef2e1f8ef$var$$TypeError = $1zENl("%TypeError%");
var $08e53d4ef2e1f8ef$var$$WeakMap = $1zENl("%WeakMap%", true);
var $08e53d4ef2e1f8ef$var$$Map = $1zENl("%Map%", true);
var $08e53d4ef2e1f8ef$var$$weakMapGet = $d12f4cdcd6b10506$exports("WeakMap.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$weakMapSet = $d12f4cdcd6b10506$exports("WeakMap.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$weakMapHas = $d12f4cdcd6b10506$exports("WeakMap.prototype.has", true);
var $08e53d4ef2e1f8ef$var$$mapGet = $d12f4cdcd6b10506$exports("Map.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$mapSet = $d12f4cdcd6b10506$exports("Map.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$mapHas = $d12f4cdcd6b10506$exports("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var $08e53d4ef2e1f8ef$var$listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $08e53d4ef2e1f8ef$var$listGet = function(objects, key) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    return node && node.value;
};
var $08e53d4ef2e1f8ef$var$listSet = function(objects, key, value) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $08e53d4ef2e1f8ef$var$listHas = function(objects, key) {
    return !!$08e53d4ef2e1f8ef$var$listGetNode(objects, key);
};
$08e53d4ef2e1f8ef$exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $08e53d4ef2e1f8ef$var$$TypeError("Side channel does not contain " + $a48090c7c3dfd2b6$exports(key));
        },
        get: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapGet($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapGet($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapHas($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapHas($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $08e53d4ef2e1f8ef$var$$WeakMap();
                $08e53d4ef2e1f8ef$var$$weakMapSet($wm, key, value);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if (!$m) $m = new $08e53d4ef2e1f8ef$var$$Map();
                $08e53d4ef2e1f8ef$var$$mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                $08e53d4ef2e1f8ef$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};


var $d8a7e190fdc9c6e7$exports = {};
"use strict";
var $d1f90adf4e1eece6$exports = {};
"use strict";
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$d1f90adf4e1eece6$exports = {
    "default": $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};


var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $d1f90adf4e1eece6$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $d8a7e190fdc9c6e7$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$d8a7e190fdc9c6e7$exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};



var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$split = String.prototype.split;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $d1f90adf4e1eece6$exports.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $d8a7e190fdc9c6e7$exports.encode,
    encodeValuesOnly: false,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $d1f90adf4e1eece6$exports.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) obj = $d8a7e190fdc9c6e7$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $d8a7e190fdc9c6e7$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format);
            if (generateArrayPrefix === "comma" && encodeValuesOnly) {
                var valuesArray = $e5dd19a945a45bbb$var$split.call(String(obj), ",");
                var valuesJoined = "";
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format));
                return [
                    formatter(keyValue) + (commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && valuesArray.length === 1 ? "[]" : "") + "=" + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $08e53d4ef2e1f8ef$exports();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $d1f90adf4e1eece6$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$e5dd19a945a45bbb$var$has.call($d1f90adf4e1eece6$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $d1f90adf4e1eece6$exports.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === "function" || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
$e5dd19a945a45bbb$exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $08e53d4ef2e1f8ef$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $8ec5fc0fdc198ba4$exports = {};
"use strict";

var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $d8a7e190fdc9c6e7$exports.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = $d8a7e190fdc9c6e7$exports.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        if ($8ec5fc0fdc198ba4$var$has.call(obj, key)) obj[key] = $d8a7e190fdc9c6e7$exports.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $d8a7e190fdc9c6e7$exports.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling
    };
};
$8ec5fc0fdc198ba4$exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $d8a7e190fdc9c6e7$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $d8a7e190fdc9c6e7$exports.compact(obj);
};



$1c66380376aa2c89$exports = {
    formats: $d1f90adf4e1eece6$exports,
    parse: $8ec5fc0fdc198ba4$exports,
    stringify: $e5dd19a945a45bbb$exports
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $4f240e1aafd2c298$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $4f240e1aafd2c298$export$4659b591c19bdf3d), t;
}



var $acw62 = parcelRequire("acw62");

var $a54bdd13402af126$export$617d79dae526d2cf = ((n)=>(n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))($a54bdd13402af126$export$617d79dae526d2cf || {}), $a54bdd13402af126$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($a54bdd13402af126$export$80c0a745e59f7989 || {});
function $a54bdd13402af126$export$b3890eb0ae9dca99({ ourProps: r, theirProps: t, slot: e, defaultTag: n, features: o, visible: a = !0, name: l }) {
    let s = $a54bdd13402af126$var$m(t, r);
    if (a) return $a54bdd13402af126$var$p(s, e, n, l);
    let u = o != null ? o : 0;
    if (u & 2) {
        let { static: i = !1, ...d } = s;
        if (i) return $a54bdd13402af126$var$p(d, e, n, l);
    }
    if (u & 1) {
        let { unmount: i = !0, ...d } = s;
        return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(i ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $a54bdd13402af126$var$p({
                    ...d,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, n, l);
            }
        });
    }
    return $a54bdd13402af126$var$p(s, e, n, l);
}
function $a54bdd13402af126$var$p(r, t = {}, e, n) {
    let { as: o = e, children: a, refName: l = "ref", ...s } = $a54bdd13402af126$var$f(r, [
        "unmount",
        "static"
    ]), u = r.ref !== void 0 ? {
        [l]: r.ref
    } : {}, i = typeof a == "function" ? a(t) : a;
    if (s.className && typeof s.className == "function" && (s.className = s.className(t)), o === (0, $acw62.Fragment) && Object.keys($a54bdd13402af126$export$8e16b83750b44988(s)).length > 0) {
        if (!(0, $acw62.isValidElement)(i) || Array.isArray(i) && i.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${n} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(s).map((d)=>`  - ${d}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((d)=>`  - ${d}`).join(`
`)
        ].join(`
`));
        return (0, $acw62.cloneElement)(i, Object.assign({}, $a54bdd13402af126$var$m(i.props, $a54bdd13402af126$export$8e16b83750b44988($a54bdd13402af126$var$f(s, [
            "ref"
        ]))), u));
    }
    return (0, $acw62.createElement)(o, Object.assign({}, $a54bdd13402af126$var$f(s, [
        "ref"
    ]), o !== (0, $acw62.Fragment) && u), i);
}
function $a54bdd13402af126$var$m(...r) {
    var n;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let o of r)for(let a in o)a.startsWith("on") && typeof o[a] == "function" ? ((n = e[a]) != null || (e[a] = []), e[a].push(o[a])) : t[a] = o[a];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((o)=>[
            o,
            void 0
        ])));
    for(let o in e)Object.assign(t, {
        [o] (a) {
            let l = e[o];
            for (let s of l){
                if (a.defaultPrevented) return;
                s(a);
            }
        }
    });
    return t;
}
function $a54bdd13402af126$export$e43f39796049410c(r) {
    var t;
    return Object.assign((0, $acw62.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function $a54bdd13402af126$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $a54bdd13402af126$var$f(r, t = []) {
    let e = Object.assign({}, r);
    for (let n of t)n in e && delete e[n];
    return e;
}



var $acw62 = parcelRequire("acw62");
let $4a1854c6a3ad5196$var$l = Symbol();
function $4a1854c6a3ad5196$export$7029785b750eb74(n, t = !0) {
    return Object.assign(n, {
        [$4a1854c6a3ad5196$var$l]: t
    });
}
function $4a1854c6a3ad5196$export$f6a25a78204acc7e(...n) {
    let t = (0, $acw62.useRef)(n);
    (0, $acw62.useEffect)(()=>{
        t.current = n;
    }, [
        n
    ]);
    let c = (0, $acw62.useCallback)((e)=>{
        for (let u of t.current)u != null && (typeof u == "function" ? u(e) : u.current = e);
    }, [
        t
    ]);
    return n.every((e)=>e == null || (e == null ? void 0 : e[$4a1854c6a3ad5196$var$l])) ? void 0 : c;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $65df95ec9b1bb6a8$export$ce5ed857c741fd71 = typeof window != "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");
let $81b1abbf8717f9cc$var$r = {
    serverHandoffComplete: !1
};
function $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa() {
    let [e, f] = (0, $acw62.useState)($81b1abbf8717f9cc$var$r.serverHandoffComplete);
    return (0, $acw62.useEffect)(()=>{
        e !== !0 && f(!0);
    }, [
        e
    ]), (0, $acw62.useEffect)(()=>{
        $81b1abbf8717f9cc$var$r.serverHandoffComplete === !1 && ($81b1abbf8717f9cc$var$r.serverHandoffComplete = !0);
    }, []), e;
}


var $f2a0dea4caee12c6$var$u;
let $f2a0dea4caee12c6$var$l = 0;
function $f2a0dea4caee12c6$var$r() {
    return ++$f2a0dea4caee12c6$var$l;
}
let $f2a0dea4caee12c6$export$f680877a34711e37 = ($f2a0dea4caee12c6$var$u = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) != null ? $f2a0dea4caee12c6$var$u : function() {
    let n = (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)(), [e, o] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(n ? $f2a0dea4caee12c6$var$r : null);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        e === null && o($f2a0dea4caee12c6$var$r());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};


var $4cca0dbc68b0507a$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($4cca0dbc68b0507a$export$4b0075e5ea5e1f26 || {});


function $3d3d670dbe2ceed6$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $3d3d670dbe2ceed6$var$i(l) ? !1 : t;
}
function $3d3d670dbe2ceed6$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}



var $acw62 = parcelRequire("acw62");
let $7a3499b4b3c6f184$var$o = (0, $acw62.createContext)(null);
$7a3499b4b3c6f184$var$o.displayName = "OpenClosedContext";
var $7a3499b4b3c6f184$export$7254cc27399e90bd = ((e)=>(e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($7a3499b4b3c6f184$export$7254cc27399e90bd || {});
function $7a3499b4b3c6f184$export$fc6fdf0ecf360e() {
    return (0, $acw62.useContext)($7a3499b4b3c6f184$var$o);
}
function $7a3499b4b3c6f184$export$2a0ed818b175f558({ value: t, children: n }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a3499b4b3c6f184$var$o.Provider, {
        value: t
    }, n);
}



var $acw62 = parcelRequire("acw62");

function $be828d8bf9bb25ca$var$i(t) {
    var n;
    if (t.type) return t.type;
    let e = (n = t.as) != null ? n : "button";
    if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function $be828d8bf9bb25ca$export$53652b2b272efe9c(t, e) {
    let [n, u] = (0, $acw62.useState)(()=>$be828d8bf9bb25ca$var$i(t));
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        u($be828d8bf9bb25ca$var$i(t));
    }, [
        t.type,
        t.as
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        n || !e.current || e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
    }, [
        n,
        e
    ]), n;
}


function $c0a913ecfa4bf5e5$export$b204af158042fbac(n) {
    return typeof window == "undefined" ? null : n instanceof Node ? n.ownerDocument : n != null && n.hasOwnProperty("current") && n.current instanceof Node ? n.current.ownerDocument : document;
}


var $780306decd8ad6d8$var$Q = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($780306decd8ad6d8$var$Q || {}), $780306decd8ad6d8$var$V = ((l)=>(l[l.ToggleDisclosure = 0] = "ToggleDisclosure", l[l.CloseDisclosure = 1] = "CloseDisclosure", l[l.SetButtonId = 2] = "SetButtonId", l[l.SetPanelId = 3] = "SetPanelId", l[l.LinkPanel = 4] = "LinkPanel", l[l.UnlinkPanel = 5] = "UnlinkPanel", l))($780306decd8ad6d8$var$V || {});
let $780306decd8ad6d8$var$X = {
    [0]: (e)=>({
            ...e,
            disclosureState: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e.disclosureState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1]: (e)=>e.disclosureState === 1 ? e : {
            ...e,
            disclosureState: 1
        },
    [4] (e) {
        return e.linkedPanel === !0 ? e : {
            ...e,
            linkedPanel: !0
        };
    },
    [5] (e) {
        return e.linkedPanel === !1 ? e : {
            ...e,
            linkedPanel: !1
        };
    },
    [2] (e, t) {
        return e.buttonId === t.buttonId ? e : {
            ...e,
            buttonId: t.buttonId
        };
    },
    [3] (e, t) {
        return e.panelId === t.panelId ? e : {
            ...e,
            panelId: t.panelId
        };
    }
}, $780306decd8ad6d8$var$h = (0, $acw62.createContext)(null);
$780306decd8ad6d8$var$h.displayName = "DisclosureContext";
function $780306decd8ad6d8$var$H(e) {
    let t = (0, $acw62.useContext)($780306decd8ad6d8$var$h);
    if (t === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $780306decd8ad6d8$var$H), o;
    }
    return t;
}
let $780306decd8ad6d8$var$U = (0, $acw62.createContext)(null);
$780306decd8ad6d8$var$U.displayName = "DisclosureAPIContext";
function $780306decd8ad6d8$var$K(e) {
    let t = (0, $acw62.useContext)($780306decd8ad6d8$var$U);
    if (t === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $780306decd8ad6d8$var$K), o;
    }
    return t;
}
let $780306decd8ad6d8$var$w = (0, $acw62.createContext)(null);
$780306decd8ad6d8$var$w.displayName = "DisclosurePanelContext";
function $780306decd8ad6d8$var$Y() {
    return (0, $acw62.useContext)($780306decd8ad6d8$var$w);
}
function $780306decd8ad6d8$var$Z(e, t) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(t.type, $780306decd8ad6d8$var$X, e, t);
}
let $780306decd8ad6d8$var$ee = (0, $acw62.Fragment), $780306decd8ad6d8$var$te = (0, $a54bdd13402af126$export$e43f39796049410c)(function(t, o) {
    let { defaultOpen: n = !1, ...r } = t, u = `headlessui-disclosure-button-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, l = `headlessui-disclosure-panel-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, a = (0, $acw62.useRef)(null), D = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(o, (0, $4a1854c6a3ad5196$export$7029785b750eb74)((f)=>{
        a.current = f;
    }, t.as === void 0 || t.as === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment)), P = (0, $acw62.useRef)(null), y = (0, $acw62.useRef)(null), d = (0, $acw62.useReducer)($780306decd8ad6d8$var$Z, {
        disclosureState: n ? 0 : 1,
        linkedPanel: !1,
        buttonRef: y,
        panelRef: P,
        buttonId: u,
        panelId: l
    }), [{ disclosureState: c }, i] = d;
    (0, $acw62.useEffect)(()=>i({
            type: 2,
            buttonId: u
        }), [
        u,
        i
    ]), (0, $acw62.useEffect)(()=>i({
            type: 3,
            panelId: l
        }), [
        l,
        i
    ]);
    let T = (0, $acw62.useCallback)((f)=>{
        i({
            type: 1
        });
        let A = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(a);
        if (!A) return;
        let I = (()=>f ? f instanceof HTMLElement ? f : f.current instanceof HTMLElement ? f.current : A.getElementById(u) : A.getElementById(u))();
        I == null || I.focus();
    }, [
        i,
        u
    ]), C = (0, $acw62.useMemo)(()=>({
            close: T
        }), [
        T
    ]), s = (0, $acw62.useMemo)(()=>({
            open: c === 0,
            close: T
        }), [
        c,
        T
    ]), p = {
        ref: D
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($780306decd8ad6d8$var$h.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($780306decd8ad6d8$var$U.Provider, {
        value: C
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(c, {
            [0]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            [1]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        })
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: p,
        theirProps: r,
        slot: s,
        defaultTag: $780306decd8ad6d8$var$ee,
        name: "Disclosure"
    }))));
}), $780306decd8ad6d8$var$ne = "button", $780306decd8ad6d8$var$le = (0, $a54bdd13402af126$export$e43f39796049410c)(function(t, o) {
    let [n, r] = $780306decd8ad6d8$var$H("Disclosure.Button"), u = $780306decd8ad6d8$var$Y(), l = u === null ? !1 : u === n.panelId, a = (0, $acw62.useRef)(null), D = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(a, o, l ? null : n.buttonRef), P = (0, $acw62.useCallback)((s)=>{
        var p;
        if (l) {
            if (n.disclosureState === 1) return;
            switch(s.key){
                case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                    s.preventDefault(), s.stopPropagation(), r({
                        type: 0
                    }), (p = n.buttonRef.current) == null || p.focus();
                    break;
            }
        } else switch(s.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                s.preventDefault(), s.stopPropagation(), r({
                    type: 0
                });
                break;
        }
    }, [
        r,
        l,
        n.disclosureState,
        n.buttonRef
    ]), y = (0, $acw62.useCallback)((s)=>{
        switch(s.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                s.preventDefault();
                break;
        }
    }, []), d = (0, $acw62.useCallback)((s)=>{
        var p;
        (0, $3d3d670dbe2ceed6$export$db61f031a278447c)(s.currentTarget) || t.disabled || (l ? (r({
            type: 0
        }), (p = n.buttonRef.current) == null || p.focus()) : r({
            type: 0
        }));
    }, [
        r,
        t.disabled,
        n.buttonRef,
        l
    ]), c = (0, $acw62.useMemo)(()=>({
            open: n.disclosureState === 0
        }), [
        n
    ]), i = (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(t, a), T = t, C = l ? {
        ref: D,
        type: i,
        onKeyDown: P,
        onClick: d
    } : {
        ref: D,
        id: n.buttonId,
        type: i,
        "aria-expanded": t.disabled ? void 0 : n.disclosureState === 0,
        "aria-controls": n.linkedPanel ? n.panelId : void 0,
        onKeyDown: P,
        onKeyUp: y,
        onClick: d
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: C,
        theirProps: T,
        slot: c,
        defaultTag: $780306decd8ad6d8$var$ne,
        name: "Disclosure.Button"
    });
}), $780306decd8ad6d8$var$oe = "div", $780306decd8ad6d8$var$re = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static, $780306decd8ad6d8$var$se = (0, $a54bdd13402af126$export$e43f39796049410c)(function(t, o) {
    let [n, r] = $780306decd8ad6d8$var$H("Disclosure.Panel"), { close: u } = $780306decd8ad6d8$var$K("Disclosure.Panel"), l = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(o, n.panelRef, ()=>{
        n.linkedPanel || r({
            type: 4
        });
    }), a = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), D = (()=>a !== null ? a === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : n.disclosureState === 0)();
    (0, $acw62.useEffect)(()=>()=>r({
                type: 5
            }), [
        r
    ]), (0, $acw62.useEffect)(()=>{
        var c;
        n.disclosureState === 1 && ((c = t.unmount) != null ? c : !0) && r({
            type: 5
        });
    }, [
        n.disclosureState,
        t.unmount,
        r
    ]);
    let P = (0, $acw62.useMemo)(()=>({
            open: n.disclosureState === 0,
            close: u
        }), [
        n,
        u
    ]), y = t, d = {
        ref: l,
        id: n.panelId
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($780306decd8ad6d8$var$w.Provider, {
        value: n.panelId
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: d,
        theirProps: y,
        slot: P,
        defaultTag: $780306decd8ad6d8$var$oe,
        features: $780306decd8ad6d8$var$re,
        visible: D,
        name: "Disclosure.Panel"
    }));
}), $780306decd8ad6d8$export$74a362b31437ec83 = Object.assign($780306decd8ad6d8$var$te, {
    Button: $780306decd8ad6d8$var$le,
    Panel: $780306decd8ad6d8$var$se
});


var $acw62 = parcelRequire("acw62");


function $12f0e1633d904536$export$12b26c28a05aa001() {
    let a = [], i = [], n = {
        enqueue (e) {
            i.push(e);
        },
        addEventListener (e, t, r, s) {
            return e.addEventListener(t, r, s), n.add(()=>e.removeEventListener(t, r, s));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return n.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return n.requestAnimationFrame(()=>n.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return n.add(()=>clearTimeout(t));
        },
        add (e) {
            return a.push(e), ()=>{
                let t = a.indexOf(e);
                if (t >= 0) {
                    let [r] = a.splice(t, 1);
                    r();
                }
            };
        },
        dispose () {
            for (let e of a.splice(0))e();
        },
        async workQueue () {
            for (let e of i.splice(0))await e();
        }
    };
    return n;
}



var $acw62 = parcelRequire("acw62");

function $410e668b7f520622$export$fd183955ff4b45d9() {
    let [e] = (0, $acw62.useState)((0, $12f0e1633d904536$export$12b26c28a05aa001));
    return (0, $acw62.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}






function $b7a0b87cd8a0fa3d$var$f(r) {
    throw new Error("Unexpected object: " + r);
}
var $b7a0b87cd8a0fa3d$export$807a7eae502106e7 = ((e)=>(e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))($b7a0b87cd8a0fa3d$export$807a7eae502106e7 || {});
function $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e(r, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let l = n.resolveActiveIndex(), s = l != null ? l : -1, d = (()=>{
        switch(r.focus){
            case 0:
                return t.findIndex((e)=>!n.resolveDisabled(e));
            case 1:
                {
                    let e = t.slice().reverse().findIndex((i, c, u)=>s !== -1 && u.length - c - 1 >= s ? !1 : !n.resolveDisabled(i));
                    return e === -1 ? e : t.length - 1 - e;
                }
            case 2:
                return t.findIndex((e, i)=>i <= s ? !1 : !n.resolveDisabled(e));
            case 3:
                {
                    let e = t.slice().reverse().findIndex((i)=>!n.resolveDisabled(i));
                    return e === -1 ? e : t.length - 1 - e;
                }
            case 4:
                return t.findIndex((e)=>n.resolveId(e) === r.id);
            case 5:
                return null;
            default:
                $b7a0b87cd8a0fa3d$var$f(r);
        }
    })();
    return d === -1 ? l : d;
}





let $cb6dceb64e6c0606$var$f = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $cb6dceb64e6c0606$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))($cb6dceb64e6c0606$export$807a7eae502106e7 || {}), $cb6dceb64e6c0606$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($cb6dceb64e6c0606$export$abf286375dfa6dbd || {}), $cb6dceb64e6c0606$var$L = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($cb6dceb64e6c0606$var$L || {});
function $cb6dceb64e6c0606$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($cb6dceb64e6c0606$var$f));
}
var $cb6dceb64e6c0606$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($cb6dceb64e6c0606$export$27112a34f2f8402d || {});
function $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(e)) == null ? void 0 : t.body) ? !1 : (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(r, {
        [0] () {
            return e.matches($cb6dceb64e6c0606$var$f);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($cb6dceb64e6c0606$var$f)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $cb6dceb64e6c0606$var$b = [
    "textarea",
    "input"
].join(",");
function $cb6dceb64e6c0606$var$M(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $cb6dceb64e6c0606$var$b)) != null ? t : !1;
}
function $cb6dceb64e6c0606$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let o = r(t), a = r(l);
        if (o === null || a === null) return 0;
        let n = o.compareDocumentPosition(a);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $cb6dceb64e6c0606$export$82e1f4f412218a1d(e, r) {
    let t = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, l = Array.isArray(e) ? $cb6dceb64e6c0606$export$20305e96f91bf103(e) : $cb6dceb64e6c0606$export$433aaa1f216cf32d(e), o = t.activeElement, a = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), n = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, l.indexOf(o)) - 1;
        if (r & 4) return Math.max(0, l.indexOf(o)) + 1;
        if (r & 8) return l.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), d = r & 32 ? {
        preventScroll: !0
    } : {}, c = 0, i = l.length, u;
    do {
        if (c >= i || c + i <= 0) return 0;
        let s = n + c;
        if (r & 16) s = (s + i) % i;
        else {
            if (s < 0) return 3;
            if (s >= i) return 1;
        }
        u = l[s], u == null || u.focus(d), c += a;
    }while (u !== t.activeElement);
    return r & 6 && $cb6dceb64e6c0606$var$M(u) && u.select(), u.hasAttribute("tabindex") || u.setAttribute("tabindex", "0"), 2;
}



var $acw62 = parcelRequire("acw62");
function $aba927e9b3929756$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}



var $acw62 = parcelRequire("acw62");

function $fa1923261638cacc$export$86c4283a11f23f95(e) {
    let r = (0, $acw62.useRef)(e);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}



var $acw62 = parcelRequire("acw62");

function $40320926a37dc1cc$export$ee579bb285b8d4aa(e, r, n) {
    let o = (0, $fa1923261638cacc$export$86c4283a11f23f95)(r);
    (0, $acw62.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}


var $17eff26b89e4b024$export$617d79dae526d2cf = ((r)=>(r[r.None = 1] = "None", r[r.IgnoreScrollbars = 2] = "IgnoreScrollbars", r))($17eff26b89e4b024$export$617d79dae526d2cf || {});
function $17eff26b89e4b024$export$71b2224f1ce5e08e(c, a, r = 1) {
    let i = (0, $acw62.useRef)(!1), l = (0, $fa1923261638cacc$export$86c4283a11f23f95)((n)=>{
        if (i.current) return;
        i.current = !0, (0, $aba927e9b3929756$export$a5ff0d6a738703ca)(()=>{
            i.current = !1;
        });
        let f = function t(e) {
            return typeof e == "function" ? t(e()) : Array.isArray(e) || e instanceof Set ? e : [
                e
            ];
        }(c), o = n.target;
        if (!!o.ownerDocument.documentElement.contains(o)) {
            if ((r & 2) === 2) {
                let t = 20, e = o.ownerDocument.documentElement;
                if (n.clientX > e.clientWidth - t || n.clientX < t || n.clientY > e.clientHeight - t || n.clientY < t) return;
            }
            for (let t of f){
                if (t === null) continue;
                let e = t instanceof HTMLElement ? t : t.current;
                if (e != null && e.contains(o)) return;
            }
            return a(n, o);
        }
    });
    (0, $40320926a37dc1cc$export$ee579bb285b8d4aa)("pointerdown", (...n)=>l.current(...n)), (0, $40320926a37dc1cc$export$ee579bb285b8d4aa)("mousedown", (...n)=>l.current(...n));
}



var $acw62 = parcelRequire("acw62");


function $101ef4628501ab0d$export$b0abce39eb34b36({ container: e, accept: t, walk: r, enabled: c = !0 }) {
    let o = (0, $acw62.useRef)(t), l = (0, $acw62.useRef)(r);
    (0, $acw62.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (!e || !c) return;
        let n = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(e);
        if (!n) return;
        let f = o.current, p = l.current, d = Object.assign((i)=>f(i), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}





var $acw62 = parcelRequire("acw62");

function $42a08b28a285ca8e$export$dd9fbcea3de0ae36(...e) {
    return (0, $acw62.useMemo)(()=>(0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(...e), [
        ...e
    ]);
}


var $c9bfa4e2da6232f7$var$oe = ((a)=>(a[a.Open = 0] = "Open", a[a.Closed = 1] = "Closed", a))($c9bfa4e2da6232f7$var$oe || {}), $c9bfa4e2da6232f7$var$ae = ((a)=>(a[a.Pointer = 0] = "Pointer", a[a.Other = 1] = "Other", a))($c9bfa4e2da6232f7$var$ae || {}), $c9bfa4e2da6232f7$var$ie = ((o)=>(o[o.OpenMenu = 0] = "OpenMenu", o[o.CloseMenu = 1] = "CloseMenu", o[o.GoToItem = 2] = "GoToItem", o[o.Search = 3] = "Search", o[o.ClearSearch = 4] = "ClearSearch", o[o.RegisterItem = 5] = "RegisterItem", o[o.UnregisterItem = 6] = "UnregisterItem", o))($c9bfa4e2da6232f7$var$ie || {});
function $c9bfa4e2da6232f7$var$k(t, i = (a)=>a) {
    let a = t.activeItemIndex !== null ? t.items[t.activeItemIndex] : null, e = (0, $cb6dceb64e6c0606$export$20305e96f91bf103)(i(t.items.slice()), (u)=>u.dataRef.current.domRef.current), r = a ? e.indexOf(a) : null;
    return r === -1 && (r = null), {
        items: e,
        activeItemIndex: r
    };
}
let $c9bfa4e2da6232f7$var$ue = {
    [1] (t) {
        return t.menuState === 1 ? t : {
            ...t,
            activeItemIndex: null,
            menuState: 1
        };
    },
    [0] (t) {
        return t.menuState === 0 ? t : {
            ...t,
            menuState: 0
        };
    },
    [2]: (t, i)=>{
        var r;
        let a = $c9bfa4e2da6232f7$var$k(t), e = (0, $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e)(i, {
            resolveItems: ()=>a.items,
            resolveActiveIndex: ()=>a.activeItemIndex,
            resolveId: (u)=>u.id,
            resolveDisabled: (u)=>u.dataRef.current.disabled
        });
        return {
            ...t,
            ...a,
            searchQuery: "",
            activeItemIndex: e,
            activationTrigger: (r = i.trigger) != null ? r : 1
        };
    },
    [3]: (t, i)=>{
        let e = t.searchQuery !== "" ? 0 : 1, r = t.searchQuery + i.value.toLowerCase(), s = (t.activeItemIndex !== null ? t.items.slice(t.activeItemIndex + e).concat(t.items.slice(0, t.activeItemIndex + e)) : t.items).find((l)=>{
            var p;
            return ((p = l.dataRef.current.textValue) == null ? void 0 : p.startsWith(r)) && !l.dataRef.current.disabled;
        }), o = s ? t.items.indexOf(s) : -1;
        return o === -1 || o === t.activeItemIndex ? {
            ...t,
            searchQuery: r
        } : {
            ...t,
            searchQuery: r,
            activeItemIndex: o,
            activationTrigger: 1
        };
    },
    [4] (t) {
        return t.searchQuery === "" ? t : {
            ...t,
            searchQuery: "",
            searchActiveItemIndex: null
        };
    },
    [5]: (t, i)=>{
        let a = $c9bfa4e2da6232f7$var$k(t, (e)=>[
                ...e,
                {
                    id: i.id,
                    dataRef: i.dataRef
                }
            ]);
        return {
            ...t,
            ...a
        };
    },
    [6]: (t, i)=>{
        let a = $c9bfa4e2da6232f7$var$k(t, (e)=>{
            let r = e.findIndex((u)=>u.id === i.id);
            return r !== -1 && e.splice(r, 1), e;
        });
        return {
            ...t,
            ...a,
            activationTrigger: 1
        };
    }
}, $c9bfa4e2da6232f7$var$w = (0, $acw62.createContext)(null);
$c9bfa4e2da6232f7$var$w.displayName = "MenuContext";
function $c9bfa4e2da6232f7$var$C(t) {
    let i = (0, $acw62.useContext)($c9bfa4e2da6232f7$var$w);
    if (i === null) {
        let a = new Error(`<${t} /> is missing a parent <Menu /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(a, $c9bfa4e2da6232f7$var$C), a;
    }
    return i;
}
function $c9bfa4e2da6232f7$var$se(t, i) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(i.type, $c9bfa4e2da6232f7$var$ue, t, i);
}
let $c9bfa4e2da6232f7$var$le = (0, $acw62.Fragment), $c9bfa4e2da6232f7$var$ce = (0, $a54bdd13402af126$export$e43f39796049410c)(function(i, a) {
    let e = (0, $acw62.useReducer)($c9bfa4e2da6232f7$var$se, {
        menuState: 1,
        buttonRef: (0, $acw62.createRef)(),
        itemsRef: (0, $acw62.createRef)(),
        items: [],
        searchQuery: "",
        activeItemIndex: null,
        activationTrigger: 1
    }), [{ menuState: r, itemsRef: u, buttonRef: s }, o] = e, l = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(a);
    (0, $17eff26b89e4b024$export$71b2224f1ce5e08e)([
        s,
        u
    ], (M, R)=>{
        var T;
        r === 0 && (o({
            type: 1
        }), (0, $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5)(R, (0, $cb6dceb64e6c0606$export$27112a34f2f8402d).Loose) || (M.preventDefault(), (T = s.current) == null || T.focus()));
    });
    let p = (0, $acw62.useMemo)(()=>({
            open: r === 0
        }), [
        r
    ]), g = i, f = {
        ref: l
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c9bfa4e2da6232f7$var$w.Provider, {
        value: e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(r, {
            [0]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            [1]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        })
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: f,
        theirProps: g,
        slot: p,
        defaultTag: $c9bfa4e2da6232f7$var$le,
        name: "Menu"
    })));
}), $c9bfa4e2da6232f7$var$pe = "button", $c9bfa4e2da6232f7$var$de = (0, $a54bdd13402af126$export$e43f39796049410c)(function(i, a) {
    var T;
    let [e, r] = $c9bfa4e2da6232f7$var$C("Menu.Button"), u = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e.buttonRef, a), s = `headlessui-menu-button-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, o = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), l = (0, $acw62.useCallback)((c)=>{
        switch(c.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown:
                c.preventDefault(), c.stopPropagation(), r({
                    type: 0
                }), o.nextFrame(()=>r({
                        type: 2,
                        focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).First
                    }));
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp:
                c.preventDefault(), c.stopPropagation(), r({
                    type: 0
                }), o.nextFrame(()=>r({
                        type: 2,
                        focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last
                    }));
                break;
        }
    }, [
        r,
        o
    ]), p = (0, $acw62.useCallback)((c)=>{
        switch(c.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                c.preventDefault();
                break;
        }
    }, []), g = (0, $acw62.useCallback)((c)=>{
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(c.currentTarget)) return c.preventDefault();
        i.disabled || (e.menuState === 0 ? (r({
            type: 1
        }), o.nextFrame(()=>{
            var b;
            return (b = e.buttonRef.current) == null ? void 0 : b.focus({
                preventScroll: !0
            });
        })) : (c.preventDefault(), c.stopPropagation(), r({
            type: 0
        })));
    }, [
        r,
        o,
        e,
        i.disabled
    ]), f = (0, $acw62.useMemo)(()=>({
            open: e.menuState === 0
        }), [
        e
    ]), M = i, R = {
        ref: u,
        id: s,
        type: (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(i, e.buttonRef),
        "aria-haspopup": !0,
        "aria-controls": (T = e.itemsRef.current) == null ? void 0 : T.id,
        "aria-expanded": i.disabled ? void 0 : e.menuState === 0,
        onKeyDown: l,
        onKeyUp: p,
        onClick: g
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: R,
        theirProps: M,
        slot: f,
        defaultTag: $c9bfa4e2da6232f7$var$pe,
        name: "Menu.Button"
    });
}), $c9bfa4e2da6232f7$var$me = "div", $c9bfa4e2da6232f7$var$fe = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static, $c9bfa4e2da6232f7$var$Te = (0, $a54bdd13402af126$export$e43f39796049410c)(function(i, a) {
    var b, O;
    let [e, r] = $c9bfa4e2da6232f7$var$C("Menu.Items"), u = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e.itemsRef, a), s = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(e.itemsRef), o = `headlessui-menu-items-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, l = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), p = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), g = (()=>p !== null ? p === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : e.menuState === 0)();
    (0, $acw62.useEffect)(()=>{
        let n = e.itemsRef.current;
        !n || e.menuState === 0 && n !== (s == null ? void 0 : s.activeElement) && n.focus({
            preventScroll: !0
        });
    }, [
        e.menuState,
        e.itemsRef,
        s
    ]), (0, $101ef4628501ab0d$export$b0abce39eb34b36)({
        container: e.itemsRef.current,
        enabled: e.menuState === 0,
        accept (n) {
            return n.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : n.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (n) {
            n.setAttribute("role", "none");
        }
    });
    let f = (0, $acw62.useCallback)((n)=>{
        var m, S;
        switch(l.dispose(), n.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                if (e.searchQuery !== "") return n.preventDefault(), n.stopPropagation(), r({
                    type: 3,
                    value: n.key
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                if (n.preventDefault(), n.stopPropagation(), r({
                    type: 1
                }), e.activeItemIndex !== null) {
                    let { dataRef: A } = e.items[e.activeItemIndex];
                    (S = (m = A.current) == null ? void 0 : m.domRef.current) == null || S.click();
                }
                (0, $12f0e1633d904536$export$12b26c28a05aa001)().nextFrame(()=>{
                    var A;
                    return (A = e.buttonRef.current) == null ? void 0 : A.focus({
                        preventScroll: !0
                    });
                });
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown:
                return n.preventDefault(), n.stopPropagation(), r({
                    type: 2,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Next
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp:
                return n.preventDefault(), n.stopPropagation(), r({
                    type: 2,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Previous
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Home:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageUp:
                return n.preventDefault(), n.stopPropagation(), r({
                    type: 2,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).First
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).End:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageDown:
                return n.preventDefault(), n.stopPropagation(), r({
                    type: 2,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape:
                n.preventDefault(), n.stopPropagation(), r({
                    type: 1
                }), (0, $12f0e1633d904536$export$12b26c28a05aa001)().nextFrame(()=>{
                    var A;
                    return (A = e.buttonRef.current) == null ? void 0 : A.focus({
                        preventScroll: !0
                    });
                });
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Tab:
                n.preventDefault(), n.stopPropagation();
                break;
            default:
                n.key.length === 1 && (r({
                    type: 3,
                    value: n.key
                }), l.setTimeout(()=>r({
                        type: 4
                    }), 350));
                break;
        }
    }, [
        r,
        l,
        e,
        s
    ]), M = (0, $acw62.useCallback)((n)=>{
        switch(n.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                n.preventDefault();
                break;
        }
    }, []), R = (0, $acw62.useMemo)(()=>({
            open: e.menuState === 0
        }), [
        e
    ]), T = i, c = {
        "aria-activedescendant": e.activeItemIndex === null || (b = e.items[e.activeItemIndex]) == null ? void 0 : b.id,
        "aria-labelledby": (O = e.buttonRef.current) == null ? void 0 : O.id,
        id: o,
        onKeyDown: f,
        onKeyUp: M,
        role: "menu",
        tabIndex: 0,
        ref: u
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: c,
        theirProps: T,
        slot: R,
        defaultTag: $c9bfa4e2da6232f7$var$me,
        features: $c9bfa4e2da6232f7$var$fe,
        visible: g,
        name: "Menu.Items"
    });
}), $c9bfa4e2da6232f7$var$Ie = (0, $acw62.Fragment), $c9bfa4e2da6232f7$var$ye = (0, $a54bdd13402af126$export$e43f39796049410c)(function(i, a) {
    let { disabled: e = !1, ...r } = i, [u, s] = $c9bfa4e2da6232f7$var$C("Menu.Item"), o = `headlessui-menu-item-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, l = u.activeItemIndex !== null ? u.items[u.activeItemIndex].id === o : !1, p = (0, $acw62.useRef)(null), g = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(a, p);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (u.menuState !== 0 || !l || u.activationTrigger === 0) return;
        let n = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
        return n.requestAnimationFrame(()=>{
            var m, S;
            (S = (m = p.current) == null ? void 0 : m.scrollIntoView) == null || S.call(m, {
                block: "nearest"
            });
        }), n.dispose;
    }, [
        p,
        l,
        u.menuState,
        u.activationTrigger,
        u.activeItemIndex
    ]);
    let f = (0, $acw62.useRef)({
        disabled: e,
        domRef: p
    });
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        f.current.disabled = e;
    }, [
        f,
        e
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        var n, m;
        f.current.textValue = (m = (n = p.current) == null ? void 0 : n.textContent) == null ? void 0 : m.toLowerCase();
    }, [
        f,
        p
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>(s({
            type: 5,
            id: o,
            dataRef: f
        }), ()=>s({
                type: 6,
                id: o
            })), [
        f,
        o
    ]);
    let M = (0, $acw62.useCallback)((n)=>{
        if (e) return n.preventDefault();
        s({
            type: 1
        }), (0, $12f0e1633d904536$export$12b26c28a05aa001)().nextFrame(()=>{
            var m;
            return (m = u.buttonRef.current) == null ? void 0 : m.focus({
                preventScroll: !0
            });
        });
    }, [
        s,
        u.buttonRef,
        e
    ]), R = (0, $acw62.useCallback)(()=>{
        if (e) return s({
            type: 2,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing
        });
        s({
            type: 2,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific,
            id: o
        });
    }, [
        e,
        o,
        s
    ]), T = (0, $acw62.useCallback)(()=>{
        e || l || s({
            type: 2,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific,
            id: o,
            trigger: 0
        });
    }, [
        e,
        l,
        o,
        s
    ]), c = (0, $acw62.useCallback)(()=>{
        e || !l || s({
            type: 2,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing
        });
    }, [
        e,
        l,
        s
    ]), b = (0, $acw62.useMemo)(()=>({
            active: l,
            disabled: e
        }), [
        l,
        e
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            id: o,
            ref: g,
            role: "menuitem",
            tabIndex: e === !0 ? void 0 : -1,
            "aria-disabled": e === !0 ? !0 : void 0,
            disabled: void 0,
            onClick: M,
            onFocus: R,
            onPointerMove: T,
            onMouseMove: T,
            onPointerLeave: c,
            onMouseLeave: c
        },
        theirProps: r,
        slot: b,
        defaultTag: $c9bfa4e2da6232f7$var$Ie,
        name: "Menu.Item"
    });
}), $c9bfa4e2da6232f7$export$d9b273488cd8ce6f = Object.assign($c9bfa4e2da6232f7$var$ce, {
    Button: $c9bfa4e2da6232f7$var$de,
    Items: $c9bfa4e2da6232f7$var$Te,
    Item: $c9bfa4e2da6232f7$var$ye
});


var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

function $854f77de70ff8db2$export$80c2a3957bcb42ea() {
    let e = (0, $acw62.useRef)(!1);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}






function $7716801ecfdbcff6$export$d2de3aaeafa91619(r) {
    let e = {
        called: !1
    };
    return (...t)=>{
        if (!e.called) return e.called = !0, r(...t);
    };
}




function $d94e61505c2ccd73$var$p(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function $d94e61505c2ccd73$var$v(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
var $d94e61505c2ccd73$export$fe867595c4640fb1 = ((n)=>(n.Ended = "ended", n.Cancelled = "cancelled", n))($d94e61505c2ccd73$export$fe867595c4640fb1 || {});
function $d94e61505c2ccd73$var$T(t, e) {
    let n = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
    if (!t) return n.dispose;
    let { transitionDuration: l, transitionDelay: a } = getComputedStyle(t), [d, s] = [
        l,
        a
    ].map((i)=>{
        let [r = 0] = i.split(",").filter(Boolean).map((o)=>o.includes("ms") ? parseFloat(o) : parseFloat(o) * 1e3).sort((o, E)=>E - o);
        return r;
    });
    if (d + s !== 0) {
        let i = [];
        i.push(n.addEventListener(t, "transitionrun", ()=>{
            i.splice(0).forEach((r)=>r()), i.push(n.addEventListener(t, "transitionend", ()=>{
                e("ended"), i.splice(0).forEach((r)=>r());
            }, {
                once: !0
            }), n.addEventListener(t, "transitioncancel", ()=>{
                e("cancelled"), i.splice(0).forEach((r)=>r());
            }, {
                once: !0
            }));
        }, {
            once: !0
        }));
    } else e("ended");
    return n.add(()=>e("cancelled")), n.dispose;
}
function $d94e61505c2ccd73$export$66bb15e2994e6a26(t, e, n, l) {
    let a = n ? "enter" : "leave", d = (0, $12f0e1633d904536$export$12b26c28a05aa001)(), s = l !== void 0 ? (0, $7716801ecfdbcff6$export$d2de3aaeafa91619)(l) : ()=>{}, m = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), i = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return $d94e61505c2ccd73$var$v(t, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), $d94e61505c2ccd73$var$p(t, ...m, ...r), d.nextFrame(()=>{
        $d94e61505c2ccd73$var$v(t, ...r), $d94e61505c2ccd73$var$p(t, ...i), $d94e61505c2ccd73$var$T(t, (o)=>(o === "ended" && ($d94e61505c2ccd73$var$v(t, ...m), $d94e61505c2ccd73$var$p(t, ...e.entered)), s(o)));
    }), d.dispose;
}








function $82a0b6c20b323075$export$7b286972b8d8ccbf({ container: u, direction: o, classes: c, events: t, onStart: d, onStop: l }) {
    let f = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)(), m = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), e = (0, $fa1923261638cacc$export$86c4283a11f23f95)(o), b = (0, $fa1923261638cacc$export$86c4283a11f23f95)(()=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e.current, {
            enter: ()=>t.current.beforeEnter(),
            leave: ()=>t.current.beforeLeave(),
            idle: ()=>{}
        })), p = (0, $fa1923261638cacc$export$86c4283a11f23f95)(()=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e.current, {
            enter: ()=>t.current.afterEnter(),
            leave: ()=>t.current.afterLeave(),
            idle: ()=>{}
        }));
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        let r = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
        m.add(r.dispose);
        let s = u.current;
        if (!!s && e.current !== "idle" && !!f.current) return r.dispose(), b.current(), d.current(e.current), r.add((0, $d94e61505c2ccd73$export$66bb15e2994e6a26)(s, c.current, e.current === "enter", (v)=>{
            r.dispose(), (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(v, {
                [(0, $d94e61505c2ccd73$export$fe867595c4640fb1).Ended] () {
                    p.current(), l.current(e.current);
                },
                [(0, $d94e61505c2ccd73$export$fe867595c4640fb1).Cancelled]: ()=>{}
            });
        })), r.dispose;
    }, [
        o
    ]);
}


function $030a82c6b2bb6f00$var$c(e = "") {
    return e.split(" ").filter((r)=>r.trim().length > 1);
}
let $030a82c6b2bb6f00$var$N = (0, $acw62.createContext)(null);
$030a82c6b2bb6f00$var$N.displayName = "TransitionContext";
var $030a82c6b2bb6f00$var$he = ((t)=>(t.Visible = "visible", t.Hidden = "hidden", t))($030a82c6b2bb6f00$var$he || {});
function $030a82c6b2bb6f00$var$ge() {
    let e = (0, $acw62.useContext)($030a82c6b2bb6f00$var$N);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
function $030a82c6b2bb6f00$var$ve() {
    let e = (0, $acw62.useContext)($030a82c6b2bb6f00$var$R);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
let $030a82c6b2bb6f00$var$R = (0, $acw62.createContext)(null);
$030a82c6b2bb6f00$var$R.displayName = "NestingContext";
function $030a82c6b2bb6f00$var$F(e) {
    return "children" in e ? $030a82c6b2bb6f00$var$F(e.children) : e.current.filter(({ state: r })=>r === "visible").length > 0;
}
function $030a82c6b2bb6f00$var$X(e) {
    let r = (0, $fa1923261638cacc$export$86c4283a11f23f95)(e), t = (0, $acw62.useRef)([]), n = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)(), u = (0, $fa1923261638cacc$export$86c4283a11f23f95)((s, o = (0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden)=>{
        let i = t.current.findIndex(({ id: d })=>d === s);
        i !== -1 && ((0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(o, {
            [(0, $a54bdd13402af126$export$80c0a745e59f7989).Unmount] () {
                t.current.splice(i, 1);
            },
            [(0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden] () {
                t.current[i].state = "hidden";
            }
        }), (0, $aba927e9b3929756$export$a5ff0d6a738703ca)(()=>{
            var d;
            !$030a82c6b2bb6f00$var$F(t) && n.current && ((d = r.current) == null || d.call(r));
        }));
    }), m = (0, $fa1923261638cacc$export$86c4283a11f23f95)((s)=>{
        let o = t.current.find(({ id: i })=>i === s);
        return o ? o.state !== "visible" && (o.state = "visible") : t.current.push({
            id: s,
            state: "visible"
        }), ()=>u.current(s, (0, $a54bdd13402af126$export$80c0a745e59f7989).Unmount);
    });
    return (0, $acw62.useMemo)(()=>({
            children: t,
            register: m,
            unregister: u
        }), [
        m,
        u,
        t
    ]);
}
function $030a82c6b2bb6f00$var$Ce() {}
let $030a82c6b2bb6f00$var$be = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function $030a82c6b2bb6f00$var$Y(e) {
    var t;
    let r = {};
    for (let n of $030a82c6b2bb6f00$var$be)r[n] = (t = e[n]) != null ? t : $030a82c6b2bb6f00$var$Ce;
    return r;
}
function $030a82c6b2bb6f00$var$Se(e) {
    let r = (0, $acw62.useRef)($030a82c6b2bb6f00$var$Y(e));
    return (0, $acw62.useEffect)(()=>{
        r.current = $030a82c6b2bb6f00$var$Y(e);
    }, [
        e
    ]), r;
}
let $030a82c6b2bb6f00$var$xe = "div", $030a82c6b2bb6f00$var$Z = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy, $030a82c6b2bb6f00$var$$ = (0, $a54bdd13402af126$export$e43f39796049410c)(function(r, t) {
    let { beforeEnter: n, afterEnter: u, beforeLeave: m, afterLeave: s, enter: o, enterFrom: i, enterTo: d, entered: S, leave: x, leaveFrom: E, leaveTo: L, ...p } = r, h = (0, $acw62.useRef)(null), y = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(h, t), [f, A] = (0, $acw62.useState)("visible"), D = p.unmount ? (0, $a54bdd13402af126$export$80c0a745e59f7989).Unmount : (0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden, { show: g, appear: ee, initial: te } = $030a82c6b2bb6f00$var$ge(), { register: P, unregister: H } = $030a82c6b2bb6f00$var$ve(), O = (0, $acw62.useRef)(null), a = (0, $f2a0dea4caee12c6$export$f680877a34711e37)(), re = (0, $acw62.useRef)(!1), k = $030a82c6b2bb6f00$var$X(()=>{
        re.current || (A("hidden"), H.current(a));
    });
    (0, $acw62.useEffect)(()=>{
        if (!!a) return P.current(a);
    }, [
        P,
        a
    ]), (0, $acw62.useEffect)(()=>{
        if (D === (0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden && !!a) {
            if (g && f !== "visible") {
                A("visible");
                return;
            }
            (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(f, {
                ["hidden"]: ()=>H.current(a),
                ["visible"]: ()=>P.current(a)
            });
        }
    }, [
        f,
        a,
        P,
        H,
        g,
        D
    ]);
    let ne = (0, $fa1923261638cacc$export$86c4283a11f23f95)({
        enter: $030a82c6b2bb6f00$var$c(o),
        enterFrom: $030a82c6b2bb6f00$var$c(i),
        enterTo: $030a82c6b2bb6f00$var$c(d),
        entered: $030a82c6b2bb6f00$var$c(S),
        leave: $030a82c6b2bb6f00$var$c(x),
        leaveFrom: $030a82c6b2bb6f00$var$c(E),
        leaveTo: $030a82c6b2bb6f00$var$c(L)
    }), ie = $030a82c6b2bb6f00$var$Se({
        beforeEnter: n,
        afterEnter: u,
        beforeLeave: m,
        afterLeave: s
    }), w = (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)();
    (0, $acw62.useEffect)(()=>{
        if (w && f === "visible" && h.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        h,
        f,
        w
    ]);
    let M = te && !ee, se = (()=>!w || M || O.current === g ? "idle" : g ? "enter" : "leave")();
    (0, $82a0b6c20b323075$export$7b286972b8d8ccbf)({
        container: h,
        classes: ne,
        events: ie,
        direction: se,
        onStart: (0, $fa1923261638cacc$export$86c4283a11f23f95)(()=>{}),
        onStop: (0, $fa1923261638cacc$export$86c4283a11f23f95)((le)=>{
            le === "leave" && !$030a82c6b2bb6f00$var$F(k) && (A("hidden"), H.current(a));
        })
    }), (0, $acw62.useEffect)(()=>{
        !M || (D === (0, $a54bdd13402af126$export$80c0a745e59f7989).Hidden ? O.current = null : O.current = g);
    }, [
        g,
        M,
        f
    ]);
    let oe = p, ae = {
        ref: y
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$R.Provider, {
        value: k
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(f, {
            ["visible"]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            ["hidden"]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        })
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: ae,
        theirProps: oe,
        defaultTag: $030a82c6b2bb6f00$var$xe,
        features: $030a82c6b2bb6f00$var$Z,
        visible: f === "visible",
        name: "Transition.Child"
    })));
}), $030a82c6b2bb6f00$var$j = (0, $a54bdd13402af126$export$e43f39796049410c)(function(r, t) {
    let { show: n, appear: u = !1, unmount: m, ...s } = r, o = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t);
    (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)();
    let i = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)();
    if (n === void 0 && i !== null && (n = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(i, {
        [(0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open]: !0,
        [(0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed]: !1
    })), ![
        !0,
        !1
    ].includes(n)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [d, S] = (0, $acw62.useState)(n ? "visible" : "hidden"), x = $030a82c6b2bb6f00$var$X(()=>{
        S("hidden");
    }), [E, L] = (0, $acw62.useState)(!0), p = (0, $acw62.useRef)([
        n
    ]);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        E !== !1 && p.current[p.current.length - 1] !== n && (p.current.push(n), L(!1));
    }, [
        p,
        n
    ]);
    let h = (0, $acw62.useMemo)(()=>({
            show: n,
            appear: u,
            initial: E
        }), [
        n,
        u,
        E
    ]);
    (0, $acw62.useEffect)(()=>{
        n ? S("visible") : $030a82c6b2bb6f00$var$F(x) || S("hidden");
    }, [
        n,
        x
    ]);
    let y = {
        unmount: m
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$R.Provider, {
        value: x
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$N.Provider, {
        value: h
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ...y,
            as: (0, $acw62.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$$, {
                ref: o,
                ...y,
                ...s
            })
        },
        theirProps: {},
        defaultTag: (0, $acw62.Fragment),
        features: $030a82c6b2bb6f00$var$Z,
        visible: d === "visible",
        name: "Transition"
    })));
});
function $030a82c6b2bb6f00$var$Ee(e) {
    let r = (0, $acw62.useContext)($030a82c6b2bb6f00$var$N) !== null, t = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !r && t ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$j, {
        ...e
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($030a82c6b2bb6f00$var$$, {
        ...e
    }));
}
let $030a82c6b2bb6f00$export$be58926105124dd4 = Object.assign($030a82c6b2bb6f00$var$j, {
    Child: $030a82c6b2bb6f00$var$Ee,
    Root: $030a82c6b2bb6f00$var$j
});



var $acw62 = parcelRequire("acw62");
function $0ba5c4ec0e202528$var$Bars3Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    }));
}
const $0ba5c4ec0e202528$var$ForwardRef = $acw62.forwardRef($0ba5c4ec0e202528$var$Bars3Icon);
var $0ba5c4ec0e202528$export$2e2bcd8739ae039 = $0ba5c4ec0e202528$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $9e33022247bf2fb5$var$ChevronDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
    }));
}
const $9e33022247bf2fb5$var$ForwardRef = $acw62.forwardRef($9e33022247bf2fb5$var$ChevronDownIcon);
var $9e33022247bf2fb5$export$2e2bcd8739ae039 = $9e33022247bf2fb5$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $968d99013e9e02bc$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18L18 6M6 6l12 12"
    }));
}
const $968d99013e9e02bc$var$ForwardRef = $acw62.forwardRef($968d99013e9e02bc$var$XMarkIcon);
var $968d99013e9e02bc$export$2e2bcd8739ae039 = $968d99013e9e02bc$var$ForwardRef;



var $77f2a9faf1eb3211$exports = {};
$77f2a9faf1eb3211$exports = new URL("retrohook.44e5f527.png", import.meta.url).toString();


function $db8c54ee37aae428$export$2e2bcd8739ae039(props) {
    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }
    const goToWorkspace = ()=>{
        if (props.account.workspaces[0].SK) props.history.push(`/workspace/${props.account.workspaces[0].SK}`);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $780306decd8ad6d8$export$74a362b31437ec83), {
        as: "nav",
        className: "bg-gray-700",
        children: ({ open: open })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "max-w-10xl mx-auto px-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between h-14",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex-shrink-0",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                onClick: ()=>{
                                                    props.redirectToURL("");
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        className: "h-8 inline pr-1",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                                        alt: "logo"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "inline align-middle font-mono text-xl font-semibold tracking-tight text-gray-100",
                                                        children: "Retrohook"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "inline text-xs align-middle text-cyan-300 pl-1"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "hidden md:block",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "ml-10 flex items-baseline space-x-4",
                                                children: [
                                                    props.nav.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                                                            to: item.href,
                                                            onClick: ()=>props.updateNav(item.href),
                                                            className: classNames(item.current ? "bg-cyan-500 text-white" : "text-white hover:bg-cyan-400 hover:bg-opacity-75", "px-3 py-2 rounded-md text-sm font-medium"),
                                                            "aria-current": item.current ? "page" : undefined,
                                                            children: item.name
                                                        }, item.name)),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: "https://docs.retrohook.com/docs/intro",
                                                        target: "_blank",
                                                        className: "flex font-medium text-sm text-white cursor-pointer",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "hover:bg-cyan-400 hover:bg-opacity-75 px-4 py-2 hover:border-transparent hover:rounded-md",
                                                            children: "Docs"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: "https://discord.com/channels/947629811646480414/1112590923893833780",
                                                        target: "_blank",
                                                        className: "flex font-medium text-sm text-white cursor-pointer",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "hover:bg-cyan-400 hover:bg-opacity-75 px-4 py-2 hover:border-transparent hover:rounded-md",
                                                            children: "Discord"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "hidden md:block",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "ml-4 flex items-center md:ml-6",
                                        children: [
                                            props.history.location.pathname.substring(0, 8) != "/account" && props.history.location.pathname.substring(0, 10) != "/workspace" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    props.setSelectedWorkspaceModal(true);
                                                },
                                                className: "p-1 bg-gray-900 rounded-md cursor-pointer text-cyan-200 hover:text-white px-4",
                                                children: [
                                                    props.selectedWorkspace.name ? props.selectedWorkspace.name : "Select a Workspace",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e33022247bf2fb5$export$2e2bcd8739ae039), {
                                                        className: "pl-1 h-6 w-6 inline cursor-pointer",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f), {
                                                as: "div",
                                                className: "ml-3 relative z-40",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Button, {
                                                            className: "p-1 bg-gray-900 rounded-md text-cyan-200 hover:text-white focus:outline-none",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "sr-only",
                                                                    children: "Open user menu"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ba5c4ec0e202528$export$2e2bcd8739ae039), {
                                                                    className: "h-6 w-6",
                                                                    "aria-hidden": "true"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                                                        as: (0, $acw62.Fragment),
                                                        enter: "transition ease-out duration-100",
                                                        enterFrom: "transform opacity-0 scale-95",
                                                        enterTo: "transform opacity-100 scale-100",
                                                        leave: "transition ease-in duration-75",
                                                        leaveFrom: "transform opacity-100 scale-100",
                                                        leaveTo: "transform opacity-0 scale-95",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Items, {
                                                            className: "origin-top-right absolute right-0 mt-2 w-auto rounded-md shadow-lg py-1 bg-gray-700 ring-1 ring-black ring-opacity-5 focus:outline-none",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Item, {
                                                                    children: ({ active: active })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                            onClick: ()=>{
                                                                                goToWorkspace();
                                                                            },
                                                                            className: classNames(active ? "bg-cyan-400" : "", "cursor-pointer block px-4 py-2 truncate text-sm text-gray-100"),
                                                                            children: "Workspace"
                                                                        })
                                                                }, "Workspace"),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9bfa4e2da6232f7$export$d9b273488cd8ce6f).Item, {
                                                                    children: ({ active: active })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                            onClick: ()=>{
                                                                                props.logout();
                                                                            },
                                                                            className: classNames(active ? "bg-cyan-400" : "", "cursor-pointer block px-4 py-2 truncate text-sm text-gray-100"),
                                                                            children: "Sign Out"
                                                                        })
                                                                }, "Sign Out")
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "-mr-2 flex md:hidden",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $780306decd8ad6d8$export$74a362b31437ec83).Button, {
                                        className: "bg-cyan-400 inline-flex items-center justify-center p-2 rounded-md text-cyan-200 hover:text-white hover:bg-cyan-300 hover:bg-opacity-75 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-cyan-400 focus:ring-white",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "Open main menu"
                                            }),
                                            open ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                                className: "block h-6 w-6",
                                                "aria-hidden": "true"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ba5c4ec0e202528$export$2e2bcd8739ae039), {
                                                className: "block h-6 w-6",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $780306decd8ad6d8$export$74a362b31437ec83).Panel, {
                        className: "md:hidden z-100",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "px-2 pt-2 pb-3 space-y-1 sm:px-3",
                                children: [
                                    props.nav.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $780306decd8ad6d8$export$74a362b31437ec83).Button, {
                                            as: "a",
                                            href: item.href,
                                            onClick: ()=>{
                                                props.updateNav(item.href);
                                            },
                                            className: classNames(item.current ? "bg-cyan-500 text-white" : "text-white hover:bg-cyan-300 hover:bg-opacity-75", "block px-3 py-2 rounded-md text-base font-medium"),
                                            "aria-current": item.current ? "page" : undefined,
                                            children: item.name
                                        }, item.name)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://docs.retrohook.com/docs/intro",
                                        target: "_blank",
                                        className: "block px-3 py-2 rounded-md text-base font-medium text-white cursor-pointer",
                                        children: "Docs"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://discord.com/channels/947629811646480414/1112590923893833780",
                                        target: "_blank",
                                        className: "flex font-medium text-sm text-white cursor-pointer",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "hover:bg-cyan-400 hover:bg-opacity-75 px-4 py-2 hover:border-transparent hover:rounded-md",
                                            children: "Discord"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "pt-4 pb-3 border-t border-cyan-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex items-center px-5",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "ml-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-base font-medium text-white",
                                                    children: props.user.name
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "text-sm font-medium text-cyan-300",
                                                    children: props.user.email
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-3 px-2 space-y-1 z-50",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $780306decd8ad6d8$export$74a362b31437ec83).Button, {
                                            onClick: ()=>{
                                                goToWorkspace();
                                            },
                                            as: "a",
                                            className: "block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-cyan-300 hover:bg-opacity-75",
                                            children: "Workspace"
                                        }, "Workspace")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-3 px-2 space-y-1 z-50",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $780306decd8ad6d8$export$74a362b31437ec83).Button, {
                                            onClick: ()=>{
                                                props.handleLogout();
                                            },
                                            as: "a",
                                            className: "block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-cyan-300 hover:bg-opacity-75",
                                            children: "Sign Out"
                                        }, "Sign Out")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $faafded37f338b1b$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $fa1923261638cacc$export$86c4283a11f23f95)(a);
    (0, $acw62.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}




var $b39c76d6b6ce778d$export$617d79dae526d2cf = ((r)=>(r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r))($b39c76d6b6ce778d$export$617d79dae526d2cf || {});
function $b39c76d6b6ce778d$export$5562a1f223a0d314(u, f = 30, { initialFocus: t, containers: s } = {}) {
    let m = (0, $acw62.useRef)(null), c = (0, $acw62.useRef)(null), r = (0, $854f77de70ff8db2$export$80c2a3957bcb42ea)(), M = Boolean(f & 16), a = Boolean(f & 2), e = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(u);
    return (0, $acw62.useEffect)(()=>{
        !M || m.current || (m.current = e == null ? void 0 : e.activeElement);
    }, [
        M,
        e
    ]), (0, $acw62.useEffect)(()=>{
        if (!!M) return ()=>{
            (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(m.current), m.current = null;
        };
    }, [
        M
    ]), (0, $acw62.useEffect)(()=>{
        if (!a) return;
        let l = u.current;
        if (!l) return;
        let n = e == null ? void 0 : e.activeElement;
        if (t != null && t.current) {
            if ((t == null ? void 0 : t.current) === n) {
                c.current = n;
                return;
            }
        } else if (l.contains(n)) {
            c.current = n;
            return;
        }
        t != null && t.current ? (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(t.current) : (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(l, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First) === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), c.current = e == null ? void 0 : e.activeElement;
    }, [
        u,
        t,
        a,
        e
    ]), (0, $faafded37f338b1b$export$7080b3e976bc91ab)(e == null ? void 0 : e.defaultView, "keydown", (l)=>{
        !(f & 4) || !u.current || l.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Tab && (l.preventDefault(), (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(u.current, (l.shiftKey ? (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Previous : (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Next) | (0, $cb6dceb64e6c0606$export$807a7eae502106e7).WrapAround) === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Success && (c.current = e == null ? void 0 : e.activeElement));
    }), (0, $faafded37f338b1b$export$7080b3e976bc91ab)(e == null ? void 0 : e.defaultView, "focus", (l)=>{
        if (!(f & 8)) return;
        let n = new Set(s == null ? void 0 : s.current);
        if (n.add(u), !n.size) return;
        let p = c.current;
        if (!p || !r.current) return;
        let E = l.target;
        E && E instanceof HTMLElement ? $b39c76d6b6ce778d$var$k(n, E) ? (c.current = E, (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(E)) : (l.preventDefault(), l.stopPropagation(), (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(p)) : (0, $cb6dceb64e6c0606$export$5fed9cc43865dc7e)(c.current);
    }, !0), m;
}
function $b39c76d6b6ce778d$var$k(u, f) {
    var t;
    for (let s of u)if ((t = s.current) != null && t.contains(f)) return !0;
    return !1;
}




let $ebb909f7f690e57e$var$i = new Set, $ebb909f7f690e57e$var$r = new Map;
function $ebb909f7f690e57e$var$u(t) {
    t.setAttribute("aria-hidden", "true"), t.inert = !0;
}
function $ebb909f7f690e57e$var$l(t) {
    let n = $ebb909f7f690e57e$var$r.get(t);
    !n || (n["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", n["aria-hidden"]), t.inert = n.inert);
}
function $ebb909f7f690e57e$export$af489fa7e5283cc3(t, n = !0) {
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (!n || !t.current) return;
        let o = t.current, a = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(o);
        if (!!a) {
            $ebb909f7f690e57e$var$i.add(o);
            for (let e of $ebb909f7f690e57e$var$r.keys())e.contains(o) && ($ebb909f7f690e57e$var$l(e), $ebb909f7f690e57e$var$r.delete(e));
            return a.querySelectorAll("body > *").forEach((e)=>{
                if (e instanceof HTMLElement) {
                    for (let f of $ebb909f7f690e57e$var$i)if (e.contains(f)) return;
                    $ebb909f7f690e57e$var$i.size === 1 && ($ebb909f7f690e57e$var$r.set(e, {
                        "aria-hidden": e.getAttribute("aria-hidden"),
                        inert: e.inert
                    }), $ebb909f7f690e57e$var$u(e));
                }
            }), ()=>{
                if ($ebb909f7f690e57e$var$i.delete(o), $ebb909f7f690e57e$var$i.size > 0) a.querySelectorAll("body > *").forEach((e)=>{
                    if (e instanceof HTMLElement && !$ebb909f7f690e57e$var$r.has(e)) {
                        for (let f of $ebb909f7f690e57e$var$i)if (e.contains(f)) return;
                        $ebb909f7f690e57e$var$r.set(e, {
                            "aria-hidden": e.getAttribute("aria-hidden"),
                            inert: e.inert
                        }), $ebb909f7f690e57e$var$u(e);
                    }
                });
                else for (let e of $ebb909f7f690e57e$var$r.keys())$ebb909f7f690e57e$var$l(e), $ebb909f7f690e57e$var$r.delete(e);
            };
        }
    }, [
        n
    ]);
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
let $7e5993dca17d6628$var$e = (0, $acw62.createContext)(!1);
function $7e5993dca17d6628$export$6ecd3efa4eebe261() {
    return (0, $acw62.useContext)($7e5993dca17d6628$var$e);
}
function $7e5993dca17d6628$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e5993dca17d6628$var$e.Provider, {
        value: o.force
    }, o.children);
}





function $a4e89ae9835d0556$var$C(i) {
    let n = (0, $7e5993dca17d6628$export$6ecd3efa4eebe261)(), l = (0, $acw62.useContext)($a4e89ae9835d0556$var$g), e = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(i), [r, a] = (0, $acw62.useState)(()=>{
        if (!n && l !== null || typeof window == "undefined") return null;
        let o = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (o) return o;
        if (e === null) return null;
        let t = e.createElement("div");
        return t.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(t);
    });
    return (0, $acw62.useEffect)(()=>{
        r !== null && (e != null && e.body.contains(r) || e == null || e.body.appendChild(r));
    }, [
        r,
        e
    ]), (0, $acw62.useEffect)(()=>{
        n || l !== null && a(l.current);
    }, [
        l,
        a,
        n
    ]), r;
}
let $a4e89ae9835d0556$var$O = (0, $acw62.Fragment), $a4e89ae9835d0556$var$H = (0, $a54bdd13402af126$export$e43f39796049410c)(function(n, l) {
    let e = n, r = (0, $acw62.useRef)(null), a = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)((0, $4a1854c6a3ad5196$export$7029785b750eb74)((f)=>{
        r.current = f;
    }), l), o = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(r), t = $a4e89ae9835d0556$var$C(r), [u] = (0, $acw62.useState)(()=>{
        var f;
        return typeof window == "undefined" ? null : (f = o == null ? void 0 : o.createElement("div")) != null ? f : null;
    }), E = (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)();
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (!!t && !!u) return t.appendChild(u), ()=>{
            var f;
            !t || !u || (t.removeChild(u), t.childNodes.length <= 0 && ((f = t.parentElement) == null || f.removeChild(t)));
        };
    }, [
        t,
        u
    ]), E ? !t || !u ? null : (0, $11492dca620dcaa5$exports.createPortal)((0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a
        },
        theirProps: e,
        defaultTag: $a4e89ae9835d0556$var$O,
        name: "Portal"
    }), u) : null;
}), $a4e89ae9835d0556$var$x = (0, $acw62.Fragment), $a4e89ae9835d0556$var$g = (0, $acw62.createContext)(null), $a4e89ae9835d0556$var$_ = (0, $a54bdd13402af126$export$e43f39796049410c)(function(n, l) {
    let { target: e, ...r } = n, o = {
        ref: (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(l)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$g.Provider, {
        value: e
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: o,
        theirProps: r,
        defaultTag: $a4e89ae9835d0556$var$x,
        name: "Popover.Group"
    }));
}), $a4e89ae9835d0556$export$602eac185826482c = Object.assign($a4e89ae9835d0556$var$H, {
    Group: $a4e89ae9835d0556$var$_
});




var $acw62 = parcelRequire("acw62");




let $d994aee5798540d7$var$d = (0, $acw62.createContext)(null);
function $d994aee5798540d7$var$u() {
    let r = (0, $acw62.useContext)($d994aee5798540d7$var$d);
    if (r === null) {
        let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $d994aee5798540d7$var$u), t;
    }
    return r;
}
function $d994aee5798540d7$export$babde88292020af7() {
    let [r, t] = (0, $acw62.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $acw62.useMemo)(()=>function(e) {
                let i = (0, $acw62.useCallback)((o)=>(t((n)=>[
                            ...n,
                            o
                        ]), ()=>t((n)=>{
                            let a = n.slice(), l = a.indexOf(o);
                            return l !== -1 && a.splice(l, 1), a;
                        })), []), s = (0, $acw62.useMemo)(()=>({
                        register: i,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    i,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d994aee5798540d7$var$d.Provider, {
                    value: s
                }, e.children);
            }, [
            t
        ])
    ];
}
let $d994aee5798540d7$var$v = "p", $d994aee5798540d7$export$393edc798c47379d = (0, $a54bdd13402af126$export$e43f39796049410c)(function(t, c) {
    let e = $d994aee5798540d7$var$u(), i = `headlessui-description-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, s = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(c);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>e.register(i), [
        i,
        e.register
    ]);
    let o = t, n = {
        ref: s,
        ...e.props,
        id: i
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: n,
        theirProps: o,
        slot: e.slot || {},
        defaultTag: $d994aee5798540d7$var$v,
        name: e.name || "Description"
    });
});





var $acw62 = parcelRequire("acw62");

let $1f71d3aaee714e67$var$o = (0, $acw62.createContext)(()=>{});
$1f71d3aaee714e67$var$o.displayName = "StackContext";
var $1f71d3aaee714e67$export$2dd25ef07fea092e = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))($1f71d3aaee714e67$export$2dd25ef07fea092e || {});
function $1f71d3aaee714e67$export$59510f5936c4d8c4() {
    return (0, $acw62.useContext)($1f71d3aaee714e67$var$o);
}
function $1f71d3aaee714e67$export$4aac1a6640027f56({ children: c, onUpdate: t, type: e, element: n }) {
    let a = $1f71d3aaee714e67$export$59510f5936c4d8c4(), r = (0, $acw62.useCallback)((...l)=>{
        t == null || t(...l), a(...l);
    }, [
        a,
        t
    ]);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>(r(0, e, n), ()=>r(1, e, n)), [
        r,
        e,
        n
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1f71d3aaee714e67$var$o.Provider, {
        value: r
    }, c);
}






var $fd89a26ac969b4f3$var$ve = ((t)=>(t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))($fd89a26ac969b4f3$var$ve || {}), $fd89a26ac969b4f3$var$Ae = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))($fd89a26ac969b4f3$var$Ae || {});
let $fd89a26ac969b4f3$var$Ee = {
    [0] (a, e) {
        return a.titleId === e.id ? a : {
            ...a,
            titleId: e.id
        };
    }
}, $fd89a26ac969b4f3$var$_ = (0, $acw62.createContext)(null);
$fd89a26ac969b4f3$var$_.displayName = "DialogContext";
function $fd89a26ac969b4f3$var$C(a) {
    let e = (0, $acw62.useContext)($fd89a26ac969b4f3$var$_);
    if (e === null) {
        let t = new Error(`<${a} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $fd89a26ac969b4f3$var$C), t;
    }
    return e;
}
function $fd89a26ac969b4f3$var$be(a, e) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e.type, $fd89a26ac969b4f3$var$Ee, a, e);
}
let $fd89a26ac969b4f3$var$Ce = "div", $fd89a26ac969b4f3$var$Oe = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static, $fd89a26ac969b4f3$var$Se = (0, $a54bdd13402af126$export$e43f39796049410c)(function(e, t) {
    let { open: o, onClose: l, initialFocus: p, __demoMode: f = !1, ...g } = e, [m, D] = (0, $acw62.useState)(0), O = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)();
    o === void 0 && O !== null && (o = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(O, {
        [(0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open]: !0,
        [(0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed]: !1
    }));
    let u = (0, $acw62.useRef)(new Set), d = (0, $acw62.useRef)(null), z = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(d, t), P = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(d), x = e.hasOwnProperty("open") || O !== null, G = e.hasOwnProperty("onClose");
    if (!x && !G) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!x) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!G) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof o != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${o}`);
    if (typeof l != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);
    let i = o ? 0 : 1, [y, B] = (0, $acw62.useReducer)($fd89a26ac969b4f3$var$be, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $acw62.createRef)()
    }), R = (0, $acw62.useCallback)(()=>l(!1), [
        l
    ]), H = (0, $acw62.useCallback)((r)=>B({
            type: 0,
            id: r
        }), [
        B
    ]), W = (0, $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa)() ? f ? !1 : i === 0 : !1, S = m > 1, U = (0, $acw62.useContext)($fd89a26ac969b4f3$var$_) !== null, J = (0, $b39c76d6b6ce778d$export$5562a1f223a0d314)(d, W ? (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(S ? "parent" : "leaf", {
        parent: (0, $b39c76d6b6ce778d$export$617d79dae526d2cf).RestoreFocus,
        leaf: (0, $b39c76d6b6ce778d$export$617d79dae526d2cf).All & ~(0, $b39c76d6b6ce778d$export$617d79dae526d2cf).FocusLock
    }) : (0, $b39c76d6b6ce778d$export$617d79dae526d2cf).None, {
        initialFocus: p,
        containers: u
    });
    (0, $ebb909f7f690e57e$export$af489fa7e5283cc3)(d, S ? W : !1), (0, $17eff26b89e4b024$export$71b2224f1ce5e08e)(()=>{
        var n, s;
        return [
            ...Array.from((n = P == null ? void 0 : P.querySelectorAll("body > *")) != null ? n : []).filter((c)=>!(!(c instanceof HTMLElement) || c.contains(J.current) || y.panelRef.current && c.contains(y.panelRef.current))),
            (s = y.panelRef.current) != null ? s : d.current
        ];
    }, ()=>{
        i === 0 && (S || R());
    }, (0, $17eff26b89e4b024$export$617d79dae526d2cf).IgnoreScrollbars), (0, $faafded37f338b1b$export$7080b3e976bc91ab)(P == null ? void 0 : P.defaultView, "keydown", (r)=>{
        r.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape && i === 0 && (S || (r.preventDefault(), r.stopPropagation(), R()));
    }), (0, $acw62.useEffect)(()=>{
        var Y;
        if (i !== 0 || U) return;
        let r = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(d);
        if (!r) return;
        let n = r.documentElement, s = (Y = r.defaultView) != null ? Y : window, c = n.style.overflow, oe = n.style.paddingRight, re = s.innerWidth - n.clientWidth;
        return n.style.overflow = "hidden", n.style.paddingRight = `${re}px`, ()=>{
            n.style.overflow = c, n.style.paddingRight = oe;
        };
    }, [
        i,
        U
    ]), (0, $acw62.useEffect)(()=>{
        if (i !== 0 || !d.current) return;
        let r = new IntersectionObserver((n)=>{
            for (let s of n)s.boundingClientRect.x === 0 && s.boundingClientRect.y === 0 && s.boundingClientRect.width === 0 && s.boundingClientRect.height === 0 && R();
        });
        return r.observe(d.current), ()=>r.disconnect();
    }, [
        i,
        d,
        R
    ]);
    let [Q, X] = (0, $d994aee5798540d7$export$babde88292020af7)(), Z = `headlessui-dialog-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, ee = (0, $acw62.useMemo)(()=>[
            {
                dialogState: i,
                close: R,
                setTitleId: H
            },
            y
        ], [
        i,
        y,
        R,
        H
    ]), $ = (0, $acw62.useMemo)(()=>({
            open: i === 0
        }), [
        i
    ]), te = {
        ref: z,
        id: Z,
        role: "dialog",
        "aria-modal": i === 0 ? !0 : void 0,
        "aria-labelledby": y.titleId,
        "aria-describedby": Q,
        onClick (r) {
            r.stopPropagation();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1f71d3aaee714e67$export$4aac1a6640027f56), {
        type: "Dialog",
        element: d,
        onUpdate: (0, $acw62.useCallback)((r, n, s)=>{
            n === "Dialog" && (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(r, {
                [(0, $1f71d3aaee714e67$export$2dd25ef07fea092e).Add] () {
                    u.current.add(s), D((c)=>c + 1);
                },
                [(0, $1f71d3aaee714e67$export$2dd25ef07fea092e).Remove] () {
                    u.current.add(s), D((c)=>c - 1);
                }
            });
        }, [])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e5993dca17d6628$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4e89ae9835d0556$export$602eac185826482c), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$_.Provider, {
        value: ee
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4e89ae9835d0556$export$602eac185826482c).Group, {
        target: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e5993dca17d6628$export$8f2af6644e3a3c93), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(X, {
        slot: $,
        name: "Dialog.Description"
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: te,
        theirProps: g,
        slot: $,
        defaultTag: $fd89a26ac969b4f3$var$Ce,
        features: $fd89a26ac969b4f3$var$Oe,
        visible: i === 0,
        name: "Dialog"
    }))))))));
}), $fd89a26ac969b4f3$var$we = "div", $fd89a26ac969b4f3$var$Fe = (0, $a54bdd13402af126$export$e43f39796049410c)(function(e, t) {
    let [{ dialogState: o, close: l }] = $fd89a26ac969b4f3$var$C("Dialog.Overlay"), p = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t), f = `headlessui-dialog-overlay-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, g = (0, $acw62.useCallback)((u)=>{
        if (u.target === u.currentTarget) {
            if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(u.currentTarget)) return u.preventDefault();
            u.preventDefault(), u.stopPropagation(), l();
        }
    }, [
        l
    ]), m = (0, $acw62.useMemo)(()=>({
            open: o === 0
        }), [
        o
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: p,
            id: f,
            "aria-hidden": !0,
            onClick: g
        },
        theirProps: e,
        slot: m,
        defaultTag: $fd89a26ac969b4f3$var$we,
        name: "Dialog.Overlay"
    });
}), $fd89a26ac969b4f3$var$Le = "div", $fd89a26ac969b4f3$var$ke = (0, $a54bdd13402af126$export$e43f39796049410c)(function(e, t) {
    let [{ dialogState: o }, l] = $fd89a26ac969b4f3$var$C("Dialog.Backdrop"), p = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t), f = `headlessui-dialog-backdrop-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`;
    (0, $acw62.useEffect)(()=>{
        if (l.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        l.panelRef
    ]);
    let g = (0, $acw62.useMemo)(()=>({
            open: o === 0
        }), [
        o
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7e5993dca17d6628$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4e89ae9835d0556$export$602eac185826482c), null, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: p,
            id: f,
            "aria-hidden": !0
        },
        theirProps: e,
        slot: g,
        defaultTag: $fd89a26ac969b4f3$var$Le,
        name: "Dialog.Backdrop"
    })));
}), $fd89a26ac969b4f3$var$_e = "div", $fd89a26ac969b4f3$var$Me = (0, $a54bdd13402af126$export$e43f39796049410c)(function(e, t) {
    let [{ dialogState: o }, l] = $fd89a26ac969b4f3$var$C("Dialog.Panel"), p = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t, l.panelRef), f = `headlessui-dialog-panel-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, g = (0, $acw62.useMemo)(()=>({
            open: o === 0
        }), [
        o
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: p,
            id: f
        },
        theirProps: e,
        slot: g,
        defaultTag: $fd89a26ac969b4f3$var$_e,
        name: "Dialog.Panel"
    });
}), $fd89a26ac969b4f3$var$Ie = "h2", $fd89a26ac969b4f3$var$xe = (0, $a54bdd13402af126$export$e43f39796049410c)(function(e, t) {
    let [{ dialogState: o, setTitleId: l }] = $fd89a26ac969b4f3$var$C("Dialog.Title"), p = `headlessui-dialog-title-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, f = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(t);
    (0, $acw62.useEffect)(()=>(l(p), ()=>l(null)), [
        p,
        l
    ]);
    let g = (0, $acw62.useMemo)(()=>({
            open: o === 0
        }), [
        o
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: f,
            id: p
        },
        theirProps: e,
        slot: g,
        defaultTag: $fd89a26ac969b4f3$var$Ie,
        name: "Dialog.Title"
    });
}), $fd89a26ac969b4f3$export$3ddf2d174ce01153 = Object.assign($fd89a26ac969b4f3$var$Se, {
    Backdrop: $fd89a26ac969b4f3$var$ke,
    Panel: $fd89a26ac969b4f3$var$Me,
    Overlay: $fd89a26ac969b4f3$var$Fe,
    Title: $fd89a26ac969b4f3$var$xe,
    Description: (0, $d994aee5798540d7$export$393edc798c47379d)
});




var $acw62 = parcelRequire("acw62");
function $8c310f2872bff579$var$CogIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L12 12m6.894 5.785l-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
    }));
}
const $8c310f2872bff579$var$ForwardRef = $acw62.forwardRef($8c310f2872bff579$var$CogIcon);
var $8c310f2872bff579$export$2e2bcd8739ae039 = $8c310f2872bff579$var$ForwardRef;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


function $d78e56d87e9d66e2$export$e3d20747ab930783(e, o) {
    let [u, t] = (0, $acw62.useState)(e), r = (0, $fa1923261638cacc$export$86c4283a11f23f95)(e);
    return (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>t(r.current), [
        r,
        t,
        ...o
    ]), u;
}














let $1bab6a4e68c9a263$var$i = "div", $1bab6a4e68c9a263$export$439d29a4e110a164 = (0, $a54bdd13402af126$export$e43f39796049410c)(function(e, r) {
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: r,
            style: {
                position: "absolute",
                width: 1,
                height: 1,
                padding: 0,
                margin: -1,
                overflow: "hidden",
                clip: "rect(0, 0, 0, 0)",
                whiteSpace: "nowrap",
                borderWidth: "0",
                display: "none"
            }
        },
        theirProps: e,
        slot: {},
        defaultTag: $1bab6a4e68c9a263$var$i,
        name: "VisuallyHidden"
    });
});


function $594e79751740d704$export$bc22b3e852574dab(n = {}, r = null, t = []) {
    for (let [i, o] of Object.entries(n))$594e79751740d704$var$f(t, $594e79751740d704$var$s(r, i), o);
    return t;
}
function $594e79751740d704$var$s(n, r) {
    return n ? n + "[" + r + "]" : r;
}
function $594e79751740d704$var$f(n, r, t) {
    if (Array.isArray(t)) for (let [i, o] of t.entries())$594e79751740d704$var$f(n, $594e79751740d704$var$s(r, i.toString()), o);
    else t instanceof Date ? n.push([
        r,
        t.toISOString()
    ]) : typeof t == "boolean" ? n.push([
        r,
        t ? "1" : "0"
    ]) : typeof t == "string" ? n.push([
        r,
        t
    ]) : typeof t == "number" ? n.push([
        r,
        `${t}`
    ]) : t == null ? n.push([
        r,
        ""
    ]) : $594e79751740d704$export$bc22b3e852574dab(t, r, n);
}
function $594e79751740d704$export$ee02894bdc79dd36(n) {
    var t;
    let r = (t = n == null ? void 0 : n.form) != null ? t : n.closest("form");
    if (!!r) {
        for (let i of r.elements)if (i.tagName === "INPUT" && i.type === "submit" || i.tagName === "BUTTON" && i.type === "submit" || i.nodeName === "INPUT" && i.type === "image") {
            i.click();
            return;
        }
    }
}



var $df20442161b20eb0$var$pe = ((n)=>(n[n.Open = 0] = "Open", n[n.Closed = 1] = "Closed", n))($df20442161b20eb0$var$pe || {}), $df20442161b20eb0$var$ue = ((n)=>(n[n.Single = 0] = "Single", n[n.Multi = 1] = "Multi", n))($df20442161b20eb0$var$ue || {}), $df20442161b20eb0$var$de = ((n)=>(n[n.Pointer = 0] = "Pointer", n[n.Other = 1] = "Other", n))($df20442161b20eb0$var$de || {}), $df20442161b20eb0$var$ce = ((a)=>(a[a.OpenListbox = 0] = "OpenListbox", a[a.CloseListbox = 1] = "CloseListbox", a[a.SetDisabled = 2] = "SetDisabled", a[a.SetOrientation = 3] = "SetOrientation", a[a.GoToOption = 4] = "GoToOption", a[a.Search = 5] = "Search", a[a.ClearSearch = 6] = "ClearSearch", a[a.RegisterOption = 7] = "RegisterOption", a[a.UnregisterOption = 8] = "UnregisterOption", a))($df20442161b20eb0$var$ce || {});
function $df20442161b20eb0$var$_(t, i = (n)=>n) {
    let n = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null, e = (0, $cb6dceb64e6c0606$export$20305e96f91bf103)(i(t.options.slice()), (p)=>p.dataRef.current.domRef.current), o = n ? e.indexOf(n) : null;
    return o === -1 && (o = null), {
        options: e,
        activeOptionIndex: o
    };
}
let $df20442161b20eb0$var$fe = {
    [1] (t) {
        return t.disabled || t.listboxState === 1 ? t : {
            ...t,
            activeOptionIndex: null,
            listboxState: 1
        };
    },
    [0] (t) {
        if (t.disabled || t.listboxState === 0) return t;
        let i = t.activeOptionIndex, { value: n, mode: e } = t.propsRef.current, o = t.options.findIndex((p)=>{
            let r = p.dataRef.current.value;
            return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e, {
                [1]: ()=>n.includes(r),
                [0]: ()=>n === r
            });
        });
        return o !== -1 && (i = o), {
            ...t,
            listboxState: 0,
            activeOptionIndex: i
        };
    },
    [2] (t, i) {
        return t.disabled === i.disabled ? t : {
            ...t,
            disabled: i.disabled
        };
    },
    [3] (t, i) {
        return t.orientation === i.orientation ? t : {
            ...t,
            orientation: i.orientation
        };
    },
    [4] (t, i) {
        var o;
        if (t.disabled || t.listboxState === 1) return t;
        let n = $df20442161b20eb0$var$_(t), e = (0, $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e)(i, {
            resolveItems: ()=>n.options,
            resolveActiveIndex: ()=>n.activeOptionIndex,
            resolveId: (p)=>p.id,
            resolveDisabled: (p)=>p.dataRef.current.disabled
        });
        return {
            ...t,
            ...n,
            searchQuery: "",
            activeOptionIndex: e,
            activationTrigger: (o = i.trigger) != null ? o : 1
        };
    },
    [5]: (t, i)=>{
        if (t.disabled || t.listboxState === 1) return t;
        let e = t.searchQuery !== "" ? 0 : 1, o = t.searchQuery + i.value.toLowerCase(), r = (t.activeOptionIndex !== null ? t.options.slice(t.activeOptionIndex + e).concat(t.options.slice(0, t.activeOptionIndex + e)) : t.options).find((u)=>{
            var a;
            return !u.dataRef.current.disabled && ((a = u.dataRef.current.textValue) == null ? void 0 : a.startsWith(o));
        }), s = r ? t.options.indexOf(r) : -1;
        return s === -1 || s === t.activeOptionIndex ? {
            ...t,
            searchQuery: o
        } : {
            ...t,
            searchQuery: o,
            activeOptionIndex: s,
            activationTrigger: 1
        };
    },
    [6] (t) {
        return t.disabled || t.listboxState === 1 || t.searchQuery === "" ? t : {
            ...t,
            searchQuery: ""
        };
    },
    [7]: (t, i)=>{
        let n = {
            id: i.id,
            dataRef: i.dataRef
        }, e = $df20442161b20eb0$var$_(t, (o)=>[
                ...o,
                n
            ]);
        if (t.activeOptionIndex === null) {
            let { value: o, mode: p } = t.propsRef.current, r = i.dataRef.current.value;
            (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(p, {
                [1]: ()=>o.includes(r),
                [0]: ()=>o === r
            }) && (e.activeOptionIndex = e.options.indexOf(n));
        }
        return {
            ...t,
            ...e
        };
    },
    [8]: (t, i)=>{
        let n = $df20442161b20eb0$var$_(t, (e)=>{
            let o = e.findIndex((p)=>p.id === i.id);
            return o !== -1 && e.splice(o, 1), e;
        });
        return {
            ...t,
            ...n,
            activationTrigger: 1
        };
    }
}, $df20442161b20eb0$var$V = (0, $acw62.createContext)(null);
$df20442161b20eb0$var$V.displayName = "ListboxContext";
function $df20442161b20eb0$var$I(t) {
    let i = (0, $acw62.useContext)($df20442161b20eb0$var$V);
    if (i === null) {
        let n = new Error(`<${t} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, $df20442161b20eb0$var$I), n;
    }
    return i;
}
function $df20442161b20eb0$var$be(t, i) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(i.type, $df20442161b20eb0$var$fe, t, i);
}
let $df20442161b20eb0$var$Te = (0, $acw62.Fragment), $df20442161b20eb0$var$xe = (0, $a54bdd13402af126$export$e43f39796049410c)(function(i, n) {
    let { value: e, name: o, onChange: p, disabled: r = !1, horizontal: s = !1, multiple: u = !1, ...a } = i;
    const y = s ? "horizontal" : "vertical";
    let g = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(n), v = (0, $acw62.useReducer)($df20442161b20eb0$var$be, {
        listboxState: 1,
        propsRef: {
            current: {
                value: e,
                onChange: p,
                mode: u ? 1 : 0
            }
        },
        labelRef: (0, $acw62.createRef)(),
        buttonRef: (0, $acw62.createRef)(),
        optionsRef: (0, $acw62.createRef)(),
        disabled: r,
        orientation: y,
        options: [],
        searchQuery: "",
        activeOptionIndex: null,
        activationTrigger: 1
    }), [{ listboxState: f, propsRef: O, optionsRef: S, buttonRef: d }, l] = v;
    O.current.value = e, O.current.mode = u ? 1 : 0, (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        O.current.onChange = (L)=>(0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(O.current.mode, {
                [0] () {
                    return p(L);
                },
                [1] () {
                    let T = O.current.value.slice(), x = T.indexOf(L);
                    return x === -1 ? T.push(L) : T.splice(x, 1), p(T);
                }
            });
    }, [
        p,
        O
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>l({
            type: 2,
            disabled: r
        }), [
        r
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>l({
            type: 3,
            orientation: y
        }), [
        y
    ]), (0, $17eff26b89e4b024$export$71b2224f1ce5e08e)([
        d,
        S
    ], (L, T)=>{
        var x;
        f === 0 && (l({
            type: 1
        }), (0, $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5)(T, (0, $cb6dceb64e6c0606$export$27112a34f2f8402d).Loose) || (L.preventDefault(), (x = d.current) == null || x.focus()));
    });
    let c = (0, $acw62.useMemo)(()=>({
            open: f === 0,
            disabled: r
        }), [
        f,
        r
    ]), P = {
        ref: g
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df20442161b20eb0$var$V.Provider, {
        value: v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(f, {
            [0]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            [1]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        })
    }, o != null && e != null && (0, $594e79751740d704$export$bc22b3e852574dab)({
        [o]: e
    }).map(([L, T])=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1bab6a4e68c9a263$export$439d29a4e110a164), {
            ...(0, $a54bdd13402af126$export$8e16b83750b44988)({
                key: L,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                name: L,
                value: T
            })
        })), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: P,
        theirProps: a,
        slot: c,
        defaultTag: $df20442161b20eb0$var$Te,
        name: "Listbox"
    })));
}), $df20442161b20eb0$var$ye = "button", $df20442161b20eb0$var$Oe = (0, $a54bdd13402af126$export$e43f39796049410c)(function(i, n) {
    var S;
    let [e, o] = $df20442161b20eb0$var$I("Listbox.Button"), p = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e.buttonRef, n), r = `headlessui-listbox-button-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, s = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), u = (0, $acw62.useCallback)((d)=>{
        switch(d.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown:
                d.preventDefault(), o({
                    type: 0
                }), s.nextFrame(()=>{
                    e.propsRef.current.value || o({
                        type: 4,
                        focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).First
                    });
                });
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp:
                d.preventDefault(), o({
                    type: 0
                }), s.nextFrame(()=>{
                    e.propsRef.current.value || o({
                        type: 4,
                        focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last
                    });
                });
                break;
        }
    }, [
        o,
        e,
        s
    ]), a = (0, $acw62.useCallback)((d)=>{
        switch(d.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                d.preventDefault();
                break;
        }
    }, []), y = (0, $acw62.useCallback)((d)=>{
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(d.currentTarget)) return d.preventDefault();
        e.listboxState === 0 ? (o({
            type: 1
        }), s.nextFrame(()=>{
            var l;
            return (l = e.buttonRef.current) == null ? void 0 : l.focus({
                preventScroll: !0
            });
        })) : (d.preventDefault(), o({
            type: 0
        }));
    }, [
        o,
        s,
        e
    ]), g = (0, $d78e56d87e9d66e2$export$e3d20747ab930783)(()=>{
        if (!!e.labelRef.current) return [
            e.labelRef.current.id,
            r
        ].join(" ");
    }, [
        e.labelRef.current,
        r
    ]), v = (0, $acw62.useMemo)(()=>({
            open: e.listboxState === 0,
            disabled: e.disabled
        }), [
        e
    ]), f = i, O = {
        ref: p,
        id: r,
        type: (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(i, e.buttonRef),
        "aria-haspopup": !0,
        "aria-controls": (S = e.optionsRef.current) == null ? void 0 : S.id,
        "aria-expanded": e.disabled ? void 0 : e.listboxState === 0,
        "aria-labelledby": g,
        disabled: e.disabled,
        onKeyDown: u,
        onKeyUp: a,
        onClick: y
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: O,
        theirProps: f,
        slot: v,
        defaultTag: $df20442161b20eb0$var$ye,
        name: "Listbox.Button"
    });
}), $df20442161b20eb0$var$ge = "label", $df20442161b20eb0$var$Re = (0, $a54bdd13402af126$export$e43f39796049410c)(function(i, n) {
    let [e] = $df20442161b20eb0$var$I("Listbox.Label"), o = `headlessui-listbox-label-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, p = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e.labelRef, n), r = (0, $acw62.useCallback)(()=>{
        var y;
        return (y = e.buttonRef.current) == null ? void 0 : y.focus({
            preventScroll: !0
        });
    }, [
        e.buttonRef
    ]), s = (0, $acw62.useMemo)(()=>({
            open: e.listboxState === 0,
            disabled: e.disabled
        }), [
        e
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: p,
            id: o,
            onClick: r
        },
        theirProps: i,
        slot: s,
        defaultTag: $df20442161b20eb0$var$ge,
        name: "Listbox.Label"
    });
}), $df20442161b20eb0$var$me = "ul", $df20442161b20eb0$var$Le = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static, $df20442161b20eb0$var$ve = (0, $a54bdd13402af126$export$e43f39796049410c)(function(i, n) {
    var d;
    let [e, o] = $df20442161b20eb0$var$I("Listbox.Options"), p = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e.optionsRef, n), r = `headlessui-listbox-options-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, s = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), u = (0, $410e668b7f520622$export$fd183955ff4b45d9)(), a = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), y = (()=>a !== null ? a === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : e.listboxState === 0)();
    (0, $acw62.useEffect)(()=>{
        var c;
        let l = e.optionsRef.current;
        !l || e.listboxState === 0 && l !== ((c = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(l)) == null ? void 0 : c.activeElement) && l.focus({
            preventScroll: !0
        });
    }, [
        e.listboxState,
        e.optionsRef
    ]);
    let g = (0, $acw62.useCallback)((l)=>{
        switch(u.dispose(), l.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                if (e.searchQuery !== "") return l.preventDefault(), l.stopPropagation(), o({
                    type: 5,
                    value: l.key
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                if (l.preventDefault(), l.stopPropagation(), e.activeOptionIndex !== null) {
                    let { dataRef: c } = e.options[e.activeOptionIndex];
                    e.propsRef.current.onChange(c.current.value);
                }
                e.propsRef.current.mode === 0 && (o({
                    type: 1
                }), (0, $12f0e1633d904536$export$12b26c28a05aa001)().nextFrame(()=>{
                    var c;
                    return (c = e.buttonRef.current) == null ? void 0 : c.focus({
                        preventScroll: !0
                    });
                }));
                break;
            case (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e.orientation, {
                vertical: (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowDown,
                horizontal: (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowRight
            }):
                return l.preventDefault(), l.stopPropagation(), o({
                    type: 4,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Next
                });
            case (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(e.orientation, {
                vertical: (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowUp,
                horizontal: (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).ArrowLeft
            }):
                return l.preventDefault(), l.stopPropagation(), o({
                    type: 4,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Previous
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Home:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageUp:
                return l.preventDefault(), l.stopPropagation(), o({
                    type: 4,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).First
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).End:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).PageDown:
                return l.preventDefault(), l.stopPropagation(), o({
                    type: 4,
                    focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Last
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape:
                return l.preventDefault(), l.stopPropagation(), o({
                    type: 1
                }), s.nextFrame(()=>{
                    var c;
                    return (c = e.buttonRef.current) == null ? void 0 : c.focus({
                        preventScroll: !0
                    });
                });
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Tab:
                l.preventDefault(), l.stopPropagation();
                break;
            default:
                l.key.length === 1 && (o({
                    type: 5,
                    value: l.key
                }), u.setTimeout(()=>o({
                        type: 6
                    }), 350));
                break;
        }
    }, [
        s,
        o,
        u,
        e
    ]), v = (0, $d78e56d87e9d66e2$export$e3d20747ab930783)(()=>{
        var l, c, P;
        return (P = (l = e.labelRef.current) == null ? void 0 : l.id) != null ? P : (c = e.buttonRef.current) == null ? void 0 : c.id;
    }, [
        e.labelRef.current,
        e.buttonRef.current
    ]), f = (0, $acw62.useMemo)(()=>({
            open: e.listboxState === 0
        }), [
        e
    ]), O = i, S = {
        "aria-activedescendant": e.activeOptionIndex === null || (d = e.options[e.activeOptionIndex]) == null ? void 0 : d.id,
        "aria-multiselectable": e.propsRef.current.mode === 1 ? !0 : void 0,
        "aria-labelledby": v,
        "aria-orientation": e.orientation,
        id: r,
        onKeyDown: g,
        role: "listbox",
        tabIndex: 0,
        ref: p
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: S,
        theirProps: O,
        slot: f,
        defaultTag: $df20442161b20eb0$var$me,
        features: $df20442161b20eb0$var$Le,
        visible: y,
        name: "Listbox.Options"
    });
}), $df20442161b20eb0$var$Se = "li", $df20442161b20eb0$var$Ae = (0, $a54bdd13402af126$export$e43f39796049410c)(function(i, n) {
    let { disabled: e = !1, value: o, ...p } = i, [r, s] = $df20442161b20eb0$var$I("Listbox.Option"), u = `headlessui-listbox-option-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, a = r.activeOptionIndex !== null ? r.options[r.activeOptionIndex].id === u : !1, y = (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(r.propsRef.current.mode, {
        [1]: ()=>r.propsRef.current.value.includes(o),
        [0]: ()=>r.propsRef.current.value === o
    }), g = (0, $acw62.useRef)(null), v = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(n, g);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        if (r.listboxState !== 0 || !a || r.activationTrigger === 0) return;
        let T = (0, $12f0e1633d904536$export$12b26c28a05aa001)();
        return T.requestAnimationFrame(()=>{
            var x, j;
            (j = (x = g.current) == null ? void 0 : x.scrollIntoView) == null || j.call(x, {
                block: "nearest"
            });
        }), T.dispose;
    }, [
        g,
        a,
        r.listboxState,
        r.activationTrigger,
        r.activeOptionIndex
    ]);
    let f = (0, $acw62.useRef)({
        disabled: e,
        value: o,
        domRef: g
    });
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        f.current.disabled = e;
    }, [
        f,
        e
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        f.current.value = o;
    }, [
        f,
        o
    ]), (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>{
        var T, x;
        f.current.textValue = (x = (T = g.current) == null ? void 0 : T.textContent) == null ? void 0 : x.toLowerCase();
    }, [
        f,
        g
    ]);
    let O = (0, $acw62.useCallback)(()=>r.propsRef.current.onChange(o), [
        r.propsRef,
        o
    ]);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>(s({
            type: 7,
            id: u,
            dataRef: f
        }), ()=>s({
                type: 8,
                id: u
            })), [
        f,
        u
    ]);
    let S = (0, $acw62.useCallback)((T)=>{
        if (e) return T.preventDefault();
        O(), r.propsRef.current.mode === 0 && (s({
            type: 1
        }), (0, $12f0e1633d904536$export$12b26c28a05aa001)().nextFrame(()=>{
            var x;
            return (x = r.buttonRef.current) == null ? void 0 : x.focus({
                preventScroll: !0
            });
        }));
    }, [
        s,
        r.buttonRef,
        e,
        O
    ]), d = (0, $acw62.useCallback)(()=>{
        if (e) return s({
            type: 4,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing
        });
        s({
            type: 4,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific,
            id: u
        });
    }, [
        e,
        u,
        s
    ]), l = (0, $acw62.useCallback)(()=>{
        e || a || s({
            type: 4,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Specific,
            id: u,
            trigger: 0
        });
    }, [
        e,
        a,
        u,
        s
    ]), c = (0, $acw62.useCallback)(()=>{
        e || !a || s({
            type: 4,
            focus: (0, $b7a0b87cd8a0fa3d$export$807a7eae502106e7).Nothing
        });
    }, [
        e,
        a,
        s
    ]), P = (0, $acw62.useMemo)(()=>({
            active: a,
            selected: y,
            disabled: e
        }), [
        a,
        y,
        e
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            id: u,
            ref: v,
            role: "option",
            tabIndex: e === !0 ? void 0 : -1,
            "aria-disabled": e === !0 ? !0 : void 0,
            "aria-selected": y === !0 ? !0 : void 0,
            disabled: void 0,
            onClick: S,
            onFocus: d,
            onPointerMove: l,
            onMouseMove: l,
            onPointerLeave: c,
            onMouseLeave: c
        },
        theirProps: p,
        slot: P,
        defaultTag: $df20442161b20eb0$var$Se,
        name: "Listbox.Option"
    });
}), $df20442161b20eb0$export$8bad31ff872c7659 = Object.assign($df20442161b20eb0$var$xe, {
    Button: $df20442161b20eb0$var$Oe,
    Label: $df20442161b20eb0$var$Re,
    Options: $df20442161b20eb0$var$ve,
    Option: $df20442161b20eb0$var$Ae
});



var $acw62 = parcelRequire("acw62");
function $1045181073ad00d2$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z",
        clipRule: "evenodd"
    }));
}
const $1045181073ad00d2$var$ForwardRef = $acw62.forwardRef($1045181073ad00d2$var$CheckIcon);
var $1045181073ad00d2$export$2e2bcd8739ae039 = $1045181073ad00d2$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $50e37a01dbc37e24$var$ChevronUpDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M11.47 4.72a.75.75 0 011.06 0l3.75 3.75a.75.75 0 01-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 01-1.06-1.06l3.75-3.75zm-3.75 9.75a.75.75 0 011.06 0L12 17.69l3.22-3.22a.75.75 0 111.06 1.06l-3.75 3.75a.75.75 0 01-1.06 0l-3.75-3.75a.75.75 0 010-1.06z",
        clipRule: "evenodd"
    }));
}
const $50e37a01dbc37e24$var$ForwardRef = $acw62.forwardRef($50e37a01dbc37e24$var$ChevronUpDownIcon);
var $50e37a01dbc37e24$export$2e2bcd8739ae039 = $50e37a01dbc37e24$var$ForwardRef;


const $ee132f36ebe164d3$var$classNames = (...classes)=>{
    return classes.filter(Boolean).join(" ");
};
function $ee132f36ebe164d3$export$2e2bcd8739ae039(props) {
    const [selected, setSelected] = (0, $acw62.useState)(props.selectedWorkspace);
    const [workspaces, setWorkspaces] = (0, $acw62.useState)(props.workspaces);
    (0, $acw62.useEffect)(()=>{
        setWorkspaces(props.workspaces);
        setSelected(props.selectedWorkspace);
    }, [
        props.workspaces,
        props.selectedWorkspace
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659), {
        value: selected,
        onChange: setSelected,
        children: ({ open: open })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mr-3 relative z-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $df20442161b20eb0$export$8bad31ff872c7659).Button, {
                        className: " bg-gray-700 text-gray-100 align-middle relative w-full border border-gray-600 rounded-md shadow-sm pl-3 pr-8 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-cyan-300 focus:border-cyan-300 sm:text-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "block align-middle text-sm text-gray-100",
                                children: selected?.name ? selected.name : "Select Workspace"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50e37a01dbc37e24$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-gray-100",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                        show: open,
                        as: (0, $acw62.Fragment),
                        leave: "transition ease-in duration-100",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659).Options, {
                            className: "align-middle w-full bg-gray-700 absolute shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                            children: workspaces.map((workspace)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659).Option, {
                                    className: ({ active: active })=>$ee132f36ebe164d3$var$classNames(active ? "text-white bg-cyan-400" : "text-gray-200", "cursor-default select-none relative py-2 pl-3 pr-9"),
                                    onClick: ()=>props.setSelectedWorkspaceHandler(workspace),
                                    value: workspace,
                                    children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: $ee132f36ebe164d3$var$classNames(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                    children: workspace.name
                                                }),
                                                selected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: $ee132f36ebe164d3$var$classNames(active ? "text-white" : "text-cyan-400", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1045181073ad00d2$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5",
                                                        "aria-hidden": "true"
                                                    })
                                                }) : null
                                            ]
                                        })
                                }, workspace.SK))
                        })
                    })
                ]
            })
    });
}


function $50a5d3792f6b8312$export$2e2bcd8739ae039(props) {
    const { post: post, get: get, response: response, loading: loading } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)();
    const [workspaces, setWorkspaces] = (0, $acw62.useState)(props.workspaces);
    const [selected, setSelected] = (0, $acw62.useState)(props.selectedWorkspace ? props.selectedWorkspace : "Select a Workspace");
    const getAccountWorkspaces = async ()=>{
        const workspacesRequest = await post(`account/get-account/${props.user.attributes.id}`);
        if (response.ok) setWorkspaces(workspacesRequest.account.workspaces);
    };
    (0, $acw62.useEffect)(()=>{
        getAccountWorkspaces();
        setSelected(props.selectedWorkspace);
    }, [
        props.workspaces,
        props.selectedWorkspace
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-10 inset-0 overflow-y-auto text-sm",
            onClose: props.closeSelectModal,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative inline-block align-bottom bg-gray-700 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "px-1 inline-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c310f2872bff579$export$2e2bcd8739ae039), {
                                            className: "h-8 w-8 text-gray-200 bg-gray-700 rounded-md"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Title, {
                                            as: "h3",
                                            className: "text-xl font-medium pl-2 text-gray-200",
                                            children: "Workspace Select"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-2 sm:mt-6 border border-gray-300 bg-gray-700 p-4 rounded-md shadow-sm",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee132f36ebe164d3$export$2e2bcd8739ae039), {
                                        workspaces: workspaces,
                                        selectedWorkspace: selected,
                                        setSelectedWorkspaceHandler: props.setSelectedWorkspaceHandler
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-5 sm:mt-6",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "mt-3 w-full inline-flex justify-center rounded-md border hover:bg-cyan-300 shadow-sm px-4 py-2 text-base font-medium text-gray-100 bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-400 sm:mt-0 sm:col-start-1 sm:text-sm",
                                        onClick: ()=>{
                                            props.closeSelectModal();
                                        },
                                        children: "Close"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}







function $750b0a195ad2ddc2$export$ce9a57d0e5a7c4f5({ ...rest }) {
    const auth = (0, $cb5b9529b8ae0bf0$export$1d39dc5b47e56ff0)();
    const render = (props)=>{
        if (!auth.user) {
            auth.logout();
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e), {
                to: {
                    pathname: "/",
                    state: {
                        from: props.location
                    }
                }
            });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
        ...rest
    });
}




var $acw62 = parcelRequire("acw62");

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

function $ff3d4f19a48078e6$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $08f9f2c3250a99f0$export$d141bba7fdc215a3(d) {
    return d[0];
}
function $08f9f2c3250a99f0$export$4a5767248b18ef41(d) {
    return d[1];
}



var $2RJ2t = parcelRequire("2RJ2t");
function $50e37159451a6d0c$export$2e2bcd8739ae039() {
    var x = (0, $08f9f2c3250a99f0$export$d141bba7fdc215a3), y = (0, $08f9f2c3250a99f0$export$4a5767248b18ef41), extent = null;
    function voronoi(data) {
        return new (0, $2RJ2t.default)(data.map(function(d, i) {
            var s = [
                Math.round(x(d, i, data) / (0, $2RJ2t.epsilon)) * (0, $2RJ2t.epsilon),
                Math.round(y(d, i, data) / (0, $2RJ2t.epsilon)) * (0, $2RJ2t.epsilon)
            ];
            s.index = i;
            s.data = d;
            return s;
        }), extent);
    }
    voronoi.polygons = function(data) {
        return voronoi(data).polygons();
    };
    voronoi.links = function(data) {
        return voronoi(data).links();
    };
    voronoi.triangles = function(data) {
        return voronoi(data).triangles();
    };
    voronoi.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $ff3d4f19a48078e6$export$2e2bcd8739ae039)(+_), voronoi) : x;
    };
    voronoi.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $ff3d4f19a48078e6$export$2e2bcd8739ae039)(+_), voronoi) : y;
    };
    voronoi.extent = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ], voronoi) : extent && [
            [
                extent[0][0],
                extent[0][1]
            ],
            [
                extent[1][0],
                extent[1][1]
            ]
        ];
    };
    voronoi.size = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                0,
                0
            ],
            [
                +_[0],
                +_[1]
            ]
        ], voronoi) : extent && [
            extent[1][0] - extent[0][0],
            extent[1][1] - extent[0][1]
        ];
    };
    return voronoi;
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $bYoiY = parcelRequire("bYoiY");

var $bYoiY = parcelRequire("bYoiY");
function $dd5733431a2d0880$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $dd5733431a2d0880$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $dd5733431a2d0880$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $68731c1c421d9916$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $dd5733431a2d0880$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $78a660cd70c52f6f$export$2e2bcd8739ae039 = (x)=>()=>x;


function $529dc8928f6a4077$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $529dc8928f6a4077$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $529dc8928f6a4077$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $529dc8928f6a4077$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $529dc8928f6a4077$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $529dc8928f6a4077$var$exponential(a, b, y) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $529dc8928f6a4077$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $e7e88f7f6ed95eef$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $529dc8928f6a4077$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bYoiY.rgb)(start)).r, (end = (0, $bYoiY.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $e7e88f7f6ed95eef$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bYoiY.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f = $e7e88f7f6ed95eef$var$rgbSpline((0, $dd5733431a2d0880$export$2e2bcd8739ae039));
var $e7e88f7f6ed95eef$export$53d5214f625ccd4c = $e7e88f7f6ed95eef$var$rgbSpline((0, $68731c1c421d9916$export$2e2bcd8739ae039));



function $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $23bbf03008765dcc$export$2e2bcd8739ae039(a, b) {
    return ((0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : $23bbf03008765dcc$export$15d09067c6a5ee49)(a, b);
}
function $23bbf03008765dcc$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $063cbb46f86ba478$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $bebed377ddb9d3af$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $cf536f4647e343d9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $020916edd93bff72$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $020916edd93bff72$var$reB = new RegExp($020916edd93bff72$var$reA.source, "g");
function $020916edd93bff72$var$zero(b) {
    return function() {
        return b;
    };
}
function $020916edd93bff72$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $020916edd93bff72$export$2e2bcd8739ae039(a, b) {
    var bi = $020916edd93bff72$var$reA.lastIndex = $020916edd93bff72$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $020916edd93bff72$var$reA.exec(a)) && (bm = $020916edd93bff72$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $020916edd93bff72$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $020916edd93bff72$var$one(q[0].x) : $020916edd93bff72$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $8385105b4986daed$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : b instanceof Date ? (0, $063cbb46f86ba478$export$2e2bcd8739ae039) : (0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $23bbf03008765dcc$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $cf536f4647e343d9$export$2e2bcd8739ae039) : (0, $bebed377ddb9d3af$export$2e2bcd8739ae039))(a, b);
}


var $cb64f00fea5662cd$export$1e511d4a378977f5;
var $cb64f00fea5662cd$export$ab7b018719e111db;
var $cb64f00fea5662cd$export$8e2db863497d88e8;
var $cb64f00fea5662cd$export$f55099f28d39dce4;
var $cb64f00fea5662cd$export$b36281d89752ae66;
var $cb64f00fea5662cd$export$7afd9c1079ecedf7;
var $cb64f00fea5662cd$export$5d0a73a0957eccf0;
var $cb64f00fea5662cd$export$e4c0b4e3a05535fb;
"use strict";
$cb64f00fea5662cd$export$1e511d4a378977f5 = true;
function $cb64f00fea5662cd$var$_interopRequire(obj) {
    return obj && obj.__esModule ? obj["default"] : obj;
}
var $6895b90d2b96c358$exports = {};
"use strict";
$6895b90d2b96c358$exports.__esModule = true;
var $6895b90d2b96c358$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $6895b90d2b96c358$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $6895b90d2b96c358$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6895b90d2b96c358$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6895b90d2b96c358$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $2c77977efef4f134$exports = {};
// currently used to initiate the velocity style object to 0
"use strict";
$2c77977efef4f134$exports.__esModule = true;
$2c77977efef4f134$exports["default"] = $2c77977efef4f134$var$mapToZero;
function $2c77977efef4f134$var$mapToZero(obj) {
    var ret = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) ret[key] = 0;
    return ret;
}
$2c77977efef4f134$exports = $2c77977efef4f134$exports["default"];


var $6895b90d2b96c358$var$_mapToZero2 = $6895b90d2b96c358$var$_interopRequireDefault($2c77977efef4f134$exports);
var $34b7a3f98e4e323b$exports = {};
// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
"use strict";
$34b7a3f98e4e323b$exports.__esModule = true;
$34b7a3f98e4e323b$exports["default"] = $34b7a3f98e4e323b$var$stripStyle;
function $34b7a3f98e4e323b$var$stripStyle(style) {
    var ret = {};
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        ret[key] = typeof style[key] === "number" ? style[key] : style[key].val;
    }
    return ret;
}
$34b7a3f98e4e323b$exports = $34b7a3f98e4e323b$exports["default"];


var $6895b90d2b96c358$var$_stripStyle2 = $6895b90d2b96c358$var$_interopRequireDefault($34b7a3f98e4e323b$exports);
var $c2a2056af51b4fc3$exports = {};
// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the
"use strict";
$c2a2056af51b4fc3$exports.__esModule = true;
$c2a2056af51b4fc3$exports["default"] = $c2a2056af51b4fc3$var$stepper;
var $c2a2056af51b4fc3$var$reusedTuple = [
    0,
    0
];
function $c2a2056af51b4fc3$var$stepper(secondPerFrame, x, v, destX, k, b, precision) {
    // Spring stiffness, in kg / s^2
    // for animations, destX is really spring length (spring at rest). initial
    // position is considered as the stretched/compressed position of a spring
    var Fspring = -k * (x - destX);
    // Damping, in kg / s
    var Fdamper = -b * v;
    // usually we put mass here, but for animation purposes, specifying mass is a
    // bit redundant. you could simply adjust k and b accordingly
    // let a = (Fspring + Fdamper) / mass;
    var a = Fspring + Fdamper;
    var newV = v + a * secondPerFrame;
    var newX = x + newV * secondPerFrame;
    if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
        $c2a2056af51b4fc3$var$reusedTuple[0] = destX;
        $c2a2056af51b4fc3$var$reusedTuple[1] = 0;
        return $c2a2056af51b4fc3$var$reusedTuple;
    }
    $c2a2056af51b4fc3$var$reusedTuple[0] = newX;
    $c2a2056af51b4fc3$var$reusedTuple[1] = newV;
    return $c2a2056af51b4fc3$var$reusedTuple;
}
$c2a2056af51b4fc3$exports = $c2a2056af51b4fc3$exports["default"]; // array reference around.


var $6895b90d2b96c358$var$_stepper4 = $6895b90d2b96c358$var$_interopRequireDefault($c2a2056af51b4fc3$exports);
var $8cdfa2ecfa34f952$exports = {};

var $hPtJY = parcelRequire("hPtJY");
// Generated by CoffeeScript 1.7.1
(function() {
    var getNanoSeconds, hrtime, loadTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $8cdfa2ecfa34f952$exports = function() {
        return performance.now();
    };
    else if (typeof $hPtJY !== "undefined" && $hPtJY !== null && $hPtJY.hrtime) {
        $8cdfa2ecfa34f952$exports = function() {
            return (getNanoSeconds() - loadTime) / 1e6;
        };
        hrtime = $hPtJY.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        loadTime = getNanoSeconds();
    } else if (Date.now) {
        $8cdfa2ecfa34f952$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $8cdfa2ecfa34f952$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($8cdfa2ecfa34f952$exports);


var $6895b90d2b96c358$var$_performanceNow2 = $6895b90d2b96c358$var$_interopRequireDefault($8cdfa2ecfa34f952$exports);
var $9161a37c5225314c$exports = {};
var $ad07a536a7534694$exports = {};

var $hPtJY = parcelRequire("hPtJY");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $ad07a536a7534694$exports = function() {
        return performance.now();
    };
    else if (typeof $hPtJY !== "undefined" && $hPtJY !== null && $hPtJY.hrtime) {
        $ad07a536a7534694$exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $hPtJY.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $hPtJY.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        $ad07a536a7534694$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $ad07a536a7534694$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($ad07a536a7534694$exports);


var $9161a37c5225314c$var$root = typeof window === "undefined" ? $parcel$global : window, $9161a37c5225314c$var$vendors = [
    "moz",
    "webkit"
], $9161a37c5225314c$var$suffix = "AnimationFrame", $9161a37c5225314c$var$raf = $9161a37c5225314c$var$root["request" + $9161a37c5225314c$var$suffix], $9161a37c5225314c$var$caf = $9161a37c5225314c$var$root["cancel" + $9161a37c5225314c$var$suffix] || $9161a37c5225314c$var$root["cancelRequest" + $9161a37c5225314c$var$suffix];
for(var $9161a37c5225314c$var$i = 0; !$9161a37c5225314c$var$raf && $9161a37c5225314c$var$i < $9161a37c5225314c$var$vendors.length; $9161a37c5225314c$var$i++){
    $9161a37c5225314c$var$raf = $9161a37c5225314c$var$root[$9161a37c5225314c$var$vendors[$9161a37c5225314c$var$i] + "Request" + $9161a37c5225314c$var$suffix];
    $9161a37c5225314c$var$caf = $9161a37c5225314c$var$root[$9161a37c5225314c$var$vendors[$9161a37c5225314c$var$i] + "Cancel" + $9161a37c5225314c$var$suffix] || $9161a37c5225314c$var$root[$9161a37c5225314c$var$vendors[$9161a37c5225314c$var$i] + "CancelRequest" + $9161a37c5225314c$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$9161a37c5225314c$var$raf || !$9161a37c5225314c$var$caf) {
    var $9161a37c5225314c$var$last = 0, $9161a37c5225314c$var$id = 0, $9161a37c5225314c$var$queue = [], $9161a37c5225314c$var$frameDuration = 1000 / 60;
    $9161a37c5225314c$var$raf = function(callback) {
        if ($9161a37c5225314c$var$queue.length === 0) {
            var _now = $ad07a536a7534694$exports(), next = Math.max(0, $9161a37c5225314c$var$frameDuration - (_now - $9161a37c5225314c$var$last));
            $9161a37c5225314c$var$last = next + _now;
            setTimeout(function() {
                var cp = $9161a37c5225314c$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $9161a37c5225314c$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($9161a37c5225314c$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $9161a37c5225314c$var$queue.push({
            handle: ++$9161a37c5225314c$var$id,
            callback: callback,
            cancelled: false
        });
        return $9161a37c5225314c$var$id;
    };
    $9161a37c5225314c$var$caf = function(handle) {
        for(var i = 0; i < $9161a37c5225314c$var$queue.length; i++)if ($9161a37c5225314c$var$queue[i].handle === handle) $9161a37c5225314c$var$queue[i].cancelled = true;
    };
}
$9161a37c5225314c$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $9161a37c5225314c$var$raf.call($9161a37c5225314c$var$root, fn);
};
$9161a37c5225314c$exports.cancel = function() {
    $9161a37c5225314c$var$caf.apply($9161a37c5225314c$var$root, arguments);
};
$9161a37c5225314c$exports.polyfill = function(object) {
    if (!object) object = $9161a37c5225314c$var$root;
    object.requestAnimationFrame = $9161a37c5225314c$var$raf;
    object.cancelAnimationFrame = $9161a37c5225314c$var$caf;
};


var $6895b90d2b96c358$var$_raf2 = $6895b90d2b96c358$var$_interopRequireDefault($9161a37c5225314c$exports);
var $596309af72e72a40$exports = {};
// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)
"use strict";
$596309af72e72a40$exports.__esModule = true;
$596309af72e72a40$exports["default"] = $596309af72e72a40$var$shouldStopAnimation;
function $596309af72e72a40$var$shouldStopAnimation(currentStyle, style, currentVelocity) {
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        if (currentVelocity[key] !== 0) return false;
        var styleValue = typeof style[key] === "number" ? style[key] : style[key].val;
        // stepper will have already taken care of rounding precision errors, so
        // won't have such thing as 0.9999 !=== 1
        if (currentStyle[key] !== styleValue) return false;
    }
    return true;
}
$596309af72e72a40$exports = $596309af72e72a40$exports["default"];


var $6895b90d2b96c358$var$_shouldStopAnimation2 = $6895b90d2b96c358$var$_interopRequireDefault($596309af72e72a40$exports);

var $acw62 = parcelRequire("acw62");
var $6895b90d2b96c358$var$_react2 = $6895b90d2b96c358$var$_interopRequireDefault($acw62);

var $6895b90d2b96c358$var$_propTypes2 = $6895b90d2b96c358$var$_interopRequireDefault($8da5bfbbed271cd7$exports);
var $6895b90d2b96c358$var$msPerFrame = 1000 / 60;
var $6895b90d2b96c358$var$Motion = function(_React$Component) {
    $6895b90d2b96c358$var$_inherits(Motion, _React$Component);
    $6895b90d2b96c358$var$_createClass(Motion, null, [
        {
            key: "propTypes",
            value: {
                // TOOD: warn against putting a config in here
                defaultStyle: $6895b90d2b96c358$var$_propTypes2["default"].objectOf($6895b90d2b96c358$var$_propTypes2["default"].number),
                style: $6895b90d2b96c358$var$_propTypes2["default"].objectOf($6895b90d2b96c358$var$_propTypes2["default"].oneOfType([
                    $6895b90d2b96c358$var$_propTypes2["default"].number,
                    $6895b90d2b96c358$var$_propTypes2["default"].object
                ])).isRequired,
                children: $6895b90d2b96c358$var$_propTypes2["default"].func.isRequired,
                onRest: $6895b90d2b96c358$var$_propTypes2["default"].func
            },
            enumerable: true
        }
    ]);
    function Motion(props) {
        var _this = this;
        $6895b90d2b96c358$var$_classCallCheck(this, Motion);
        _React$Component.call(this, props);
        this.wasAnimating = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyle = null;
        this.clearUnreadPropStyle = function(destStyle) {
            var dirty = false;
            var _state = _this.state;
            var currentStyle = _state.currentStyle;
            var currentVelocity = _state.currentVelocity;
            var lastIdealStyle = _state.lastIdealStyle;
            var lastIdealVelocity = _state.lastIdealVelocity;
            for(var key in destStyle){
                if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                var styleValue = destStyle[key];
                if (typeof styleValue === "number") {
                    if (!dirty) {
                        dirty = true;
                        currentStyle = $6895b90d2b96c358$var$_extends({}, currentStyle);
                        currentVelocity = $6895b90d2b96c358$var$_extends({}, currentVelocity);
                        lastIdealStyle = $6895b90d2b96c358$var$_extends({}, lastIdealStyle);
                        lastIdealVelocity = $6895b90d2b96c358$var$_extends({}, lastIdealVelocity);
                    }
                    currentStyle[key] = styleValue;
                    currentVelocity[key] = 0;
                    lastIdealStyle[key] = styleValue;
                    lastIdealVelocity[key] = 0;
                }
            }
            if (dirty) _this.setState({
                currentStyle: currentStyle,
                currentVelocity: currentVelocity,
                lastIdealStyle: lastIdealStyle,
                lastIdealVelocity: lastIdealVelocity
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $6895b90d2b96c358$var$_raf2["default"](function(timestamp) {
                // check if we need to animate in the first place
                var propsStyle = _this.props.style;
                if ($6895b90d2b96c358$var$_shouldStopAnimation2["default"](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
                    if (_this.wasAnimating && _this.props.onRest) _this.props.onRest();
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.wasAnimating = false;
                    _this.accumulatedTime = 0;
                    return;
                }
                _this.wasAnimating = true;
                var currentTime = timestamp || $6895b90d2b96c358$var$_performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $6895b90d2b96c358$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $6895b90d2b96c358$var$msPerFrame) * $6895b90d2b96c358$var$msPerFrame) / $6895b90d2b96c358$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $6895b90d2b96c358$var$msPerFrame);
                var newLastIdealStyle = {};
                var newLastIdealVelocity = {};
                var newCurrentStyle = {};
                var newCurrentVelocity = {};
                for(var key in propsStyle){
                    if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) continue;
                    var styleValue = propsStyle[key];
                    if (typeof styleValue === "number") {
                        newCurrentStyle[key] = styleValue;
                        newCurrentVelocity[key] = 0;
                        newLastIdealStyle[key] = styleValue;
                        newLastIdealVelocity[key] = 0;
                    } else {
                        var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
                        var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
                        for(var i = 0; i < framesToCatchUp; i++){
                            var _stepper = $6895b90d2b96c358$var$_stepper4["default"]($6895b90d2b96c358$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            newLastIdealStyleValue = _stepper[0];
                            newLastIdealVelocityValue = _stepper[1];
                        }
                        var _stepper2 = $6895b90d2b96c358$var$_stepper4["default"]($6895b90d2b96c358$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                        var nextIdealX = _stepper2[0];
                        var nextIdealV = _stepper2[1];
                        newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                        newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                        newLastIdealStyle[key] = newLastIdealStyleValue;
                        newLastIdealVelocity[key] = newLastIdealVelocityValue;
                    }
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $6895b90d2b96c358$var$msPerFrame;
                _this.setState({
                    currentStyle: newCurrentStyle,
                    currentVelocity: newCurrentVelocity,
                    lastIdealStyle: newLastIdealStyle,
                    lastIdealVelocity: newLastIdealVelocity
                });
                _this.unreadPropStyle = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    Motion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyle = _props.defaultStyle;
        var style = _props.style;
        var currentStyle = defaultStyle || $6895b90d2b96c358$var$_stripStyle2["default"](style);
        var currentVelocity = $6895b90d2b96c358$var$_mapToZero2["default"](currentStyle);
        return {
            currentStyle: currentStyle,
            currentVelocity: currentVelocity,
            lastIdealStyle: currentStyle,
            lastIdealVelocity: currentVelocity
        };
    };
    // it's possible that currentStyle's value is stale: if props is immediately
    // changed from 0 to 400 to spring(0) again, the async currentStyle is still
    // at 0 (didn't have time to tick and interpolate even once). If we naively
    // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
    // In reality currentStyle should be 400
    Motion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $6895b90d2b96c358$var$_performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyle != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyle);
        this.unreadPropStyle = props.style;
        if (this.animationID == null) {
            this.prevTime = $6895b90d2b96c358$var$_performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    Motion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            $6895b90d2b96c358$var$_raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    Motion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyle);
        return renderedChildren && $6895b90d2b96c358$var$_react2["default"].Children.only(renderedChildren);
    };
    return Motion;
}($6895b90d2b96c358$var$_react2["default"].Component);
$6895b90d2b96c358$exports["default"] = $6895b90d2b96c358$var$Motion;
$6895b90d2b96c358$exports = $6895b90d2b96c358$exports["default"]; // after checking for unreadPropStyle != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)


$cb64f00fea5662cd$export$ab7b018719e111db = $cb64f00fea5662cd$var$_interopRequire($6895b90d2b96c358$exports);
var $e1a4c02ce6a1b8ba$exports = {};
"use strict";
$e1a4c02ce6a1b8ba$exports.__esModule = true;
var $e1a4c02ce6a1b8ba$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e1a4c02ce6a1b8ba$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $e1a4c02ce6a1b8ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e1a4c02ce6a1b8ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e1a4c02ce6a1b8ba$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $e1a4c02ce6a1b8ba$var$_mapToZero2 = $e1a4c02ce6a1b8ba$var$_interopRequireDefault($2c77977efef4f134$exports);

var $e1a4c02ce6a1b8ba$var$_stripStyle2 = $e1a4c02ce6a1b8ba$var$_interopRequireDefault($34b7a3f98e4e323b$exports);

var $e1a4c02ce6a1b8ba$var$_stepper4 = $e1a4c02ce6a1b8ba$var$_interopRequireDefault($c2a2056af51b4fc3$exports);

var $e1a4c02ce6a1b8ba$var$_performanceNow2 = $e1a4c02ce6a1b8ba$var$_interopRequireDefault($8cdfa2ecfa34f952$exports);

var $e1a4c02ce6a1b8ba$var$_raf2 = $e1a4c02ce6a1b8ba$var$_interopRequireDefault($9161a37c5225314c$exports);

var $e1a4c02ce6a1b8ba$var$_shouldStopAnimation2 = $e1a4c02ce6a1b8ba$var$_interopRequireDefault($596309af72e72a40$exports);

var $acw62 = parcelRequire("acw62");
var $e1a4c02ce6a1b8ba$var$_react2 = $e1a4c02ce6a1b8ba$var$_interopRequireDefault($acw62);

var $e1a4c02ce6a1b8ba$var$_propTypes2 = $e1a4c02ce6a1b8ba$var$_interopRequireDefault($8da5bfbbed271cd7$exports);
var $e1a4c02ce6a1b8ba$var$msPerFrame = 1000 / 60;
function $e1a4c02ce6a1b8ba$var$shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
    for(var i = 0; i < currentStyles.length; i++){
        if (!$e1a4c02ce6a1b8ba$var$_shouldStopAnimation2["default"](currentStyles[i], styles[i], currentVelocities[i])) return false;
    }
    return true;
}
var $e1a4c02ce6a1b8ba$var$StaggeredMotion = function(_React$Component) {
    $e1a4c02ce6a1b8ba$var$_inherits(StaggeredMotion, _React$Component);
    $e1a4c02ce6a1b8ba$var$_createClass(StaggeredMotion, null, [
        {
            key: "propTypes",
            value: {
                // TOOD: warn against putting a config in here
                defaultStyles: $e1a4c02ce6a1b8ba$var$_propTypes2["default"].arrayOf($e1a4c02ce6a1b8ba$var$_propTypes2["default"].objectOf($e1a4c02ce6a1b8ba$var$_propTypes2["default"].number)),
                styles: $e1a4c02ce6a1b8ba$var$_propTypes2["default"].func.isRequired,
                children: $e1a4c02ce6a1b8ba$var$_propTypes2["default"].func.isRequired
            },
            enumerable: true
        }
    ]);
    function StaggeredMotion(props) {
        var _this = this;
        $e1a4c02ce6a1b8ba$var$_classCallCheck(this, StaggeredMotion);
        _React$Component.call(this, props);
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _state = _this.state;
            var currentStyles = _state.currentStyles;
            var currentVelocities = _state.currentVelocities;
            var lastIdealStyles = _state.lastIdealStyles;
            var lastIdealVelocities = _state.lastIdealVelocities;
            var someDirty = false;
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i];
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === "number") {
                        if (!dirty) {
                            dirty = true;
                            someDirty = true;
                            currentStyles[i] = $e1a4c02ce6a1b8ba$var$_extends({}, currentStyles[i]);
                            currentVelocities[i] = $e1a4c02ce6a1b8ba$var$_extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = $e1a4c02ce6a1b8ba$var$_extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = $e1a4c02ce6a1b8ba$var$_extends({}, lastIdealVelocities[i]);
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                    }
                }
            }
            if (someDirty) _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $e1a4c02ce6a1b8ba$var$_raf2["default"](function(timestamp) {
                var destStyles = _this.props.styles(_this.state.lastIdealStyles);
                // check if we need to animate in the first place
                if ($e1a4c02ce6a1b8ba$var$shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || $e1a4c02ce6a1b8ba$var$_performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $e1a4c02ce6a1b8ba$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $e1a4c02ce6a1b8ba$var$msPerFrame) * $e1a4c02ce6a1b8ba$var$msPerFrame) / $e1a4c02ce6a1b8ba$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $e1a4c02ce6a1b8ba$var$msPerFrame);
                var newLastIdealStyles = [];
                var newLastIdealVelocities = [];
                var newCurrentStyles = [];
                var newCurrentVelocities = [];
                for(var i = 0; i < destStyles.length; i++){
                    var destStyle = destStyles[i];
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in destStyle){
                        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                        var styleValue = destStyle[key];
                        if (typeof styleValue === "number") {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
                            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = $e1a4c02ce6a1b8ba$var$_stepper4["default"]($e1a4c02ce6a1b8ba$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = $e1a4c02ce6a1b8ba$var$_stepper4["default"]($e1a4c02ce6a1b8ba$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $e1a4c02ce6a1b8ba$var$msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    StaggeredMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var currentStyles = defaultStyles || styles().map($e1a4c02ce6a1b8ba$var$_stripStyle2["default"]);
        var currentVelocities = currentStyles.map(function(currentStyle) {
            return $e1a4c02ce6a1b8ba$var$_mapToZero2["default"](currentStyle);
        });
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: currentStyles,
            lastIdealVelocities: currentVelocities
        };
    };
    StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $e1a4c02ce6a1b8ba$var$_performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
        if (this.animationID == null) {
            this.prevTime = $e1a4c02ce6a1b8ba$var$_performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            $e1a4c02ce6a1b8ba$var$_raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    StaggeredMotion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyles);
        return renderedChildren && $e1a4c02ce6a1b8ba$var$_react2["default"].Children.only(renderedChildren);
    };
    return StaggeredMotion;
}($e1a4c02ce6a1b8ba$var$_react2["default"].Component);
$e1a4c02ce6a1b8ba$exports["default"] = $e1a4c02ce6a1b8ba$var$StaggeredMotion;
$e1a4c02ce6a1b8ba$exports = $e1a4c02ce6a1b8ba$exports["default"]; // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400
 // after checking for unreadPropStyles != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)


$cb64f00fea5662cd$export$8e2db863497d88e8 = $cb64f00fea5662cd$var$_interopRequire($e1a4c02ce6a1b8ba$exports);
var $4869eed1e57dceb5$exports = {};
"use strict";
$4869eed1e57dceb5$exports.__esModule = true;
var $4869eed1e57dceb5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $4869eed1e57dceb5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $4869eed1e57dceb5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4869eed1e57dceb5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4869eed1e57dceb5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $4869eed1e57dceb5$var$_mapToZero2 = $4869eed1e57dceb5$var$_interopRequireDefault($2c77977efef4f134$exports);

var $4869eed1e57dceb5$var$_stripStyle2 = $4869eed1e57dceb5$var$_interopRequireDefault($34b7a3f98e4e323b$exports);

var $4869eed1e57dceb5$var$_stepper4 = $4869eed1e57dceb5$var$_interopRequireDefault($c2a2056af51b4fc3$exports);
var $45c481a8307e9600$exports = {};
// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?
// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous
// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a
// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements
"use strict";
$45c481a8307e9600$exports.__esModule = true;
$45c481a8307e9600$exports["default"] = $45c481a8307e9600$var$mergeDiff;
function $45c481a8307e9600$var$mergeDiff(prev, next, onRemove) {
    // bookkeeping for easier access of a key's index below. This is 2 allocations +
    // potentially triggering chrome hash map mode for objs (so it might be faster
    var prevKeyIndex = {};
    for(var i = 0; i < prev.length; i++)prevKeyIndex[prev[i].key] = i;
    var nextKeyIndex = {};
    for(var i = 0; i < next.length; i++)nextKeyIndex[next[i].key] = i;
    // first, an overly elaborate way of merging prev and next, eliminating
    // duplicates (in terms of keys). If there's dupe, keep the item in next).
    // This way of writing it saves allocations
    var ret = [];
    for(var i = 0; i < next.length; i++)ret[i] = next[i];
    for(var i = 0; i < prev.length; i++)if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
        // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
        // merge in keys that the user desires to kill
        var fill = onRemove(i, prev[i]);
        if (fill != null) ret.push(fill);
    }
    // now all the items all present. Core sorting logic to have the right order
    return ret.sort(function(a, b) {
        var nextOrderA = nextKeyIndex[a.key];
        var nextOrderB = nextKeyIndex[b.key];
        var prevOrderA = prevKeyIndex[a.key];
        var prevOrderB = prevKeyIndex[b.key];
        if (nextOrderA != null && nextOrderB != null) // both keys in next
        return nextKeyIndex[a.key] - nextKeyIndex[b.key];
        else if (prevOrderA != null && prevOrderB != null) // both keys in prev
        return prevKeyIndex[a.key] - prevKeyIndex[b.key];
        else if (nextOrderA != null) {
            // key a in next, key b in prev
            // how to determine the order between a and b? We find a "pivot" (term
            // abuse), a key present in both prev and next, that is sandwiched between
            // a and b. In the context of our above example, if we're comparing a and
            // d, b's (the only) pivot
            for(var i = 0; i < next.length; i++){
                var pivot = next[i].key;
                if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
                if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) return -1;
                else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) return 1;
            }
            // pluggable. default to: next bigger than prev
            return 1;
        }
        // prevOrderA, nextOrderB
        for(var i = 0; i < next.length; i++){
            var pivot = next[i].key;
            if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
            if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) return 1;
            else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) return -1;
        }
        // pluggable. default to: next bigger than prev
        return -1;
    });
}
$45c481a8307e9600$exports = $45c481a8307e9600$exports["default"]; // to loop through and find a key's index each time), but I no longer care


var $4869eed1e57dceb5$var$_mergeDiff2 = $4869eed1e57dceb5$var$_interopRequireDefault($45c481a8307e9600$exports);

var $4869eed1e57dceb5$var$_performanceNow2 = $4869eed1e57dceb5$var$_interopRequireDefault($8cdfa2ecfa34f952$exports);

var $4869eed1e57dceb5$var$_raf2 = $4869eed1e57dceb5$var$_interopRequireDefault($9161a37c5225314c$exports);

var $4869eed1e57dceb5$var$_shouldStopAnimation2 = $4869eed1e57dceb5$var$_interopRequireDefault($596309af72e72a40$exports);

var $acw62 = parcelRequire("acw62");
var $4869eed1e57dceb5$var$_react2 = $4869eed1e57dceb5$var$_interopRequireDefault($acw62);

var $4869eed1e57dceb5$var$_propTypes2 = $4869eed1e57dceb5$var$_interopRequireDefault($8da5bfbbed271cd7$exports);
var $4869eed1e57dceb5$var$msPerFrame = 1000 / 60;
// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function $4869eed1e57dceb5$var$rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
    // Copy the value to a `const` so that Flow understands that the const won't
    // change and will be non-nullable in the callback below.
    var cUnreadPropStyles = unreadPropStyles;
    if (cUnreadPropStyles == null) return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
    return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        for(var j = 0; j < cUnreadPropStyles.length; j++){
            if (cUnreadPropStyles[j].key === mergedPropsStyle.key) return {
                key: cUnreadPropStyles[j].key,
                data: cUnreadPropStyles[j].data,
                style: plainStyles[i]
            };
        }
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
}
function $4869eed1e57dceb5$var$shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
    if (mergedPropsStyles.length !== destStyles.length) return false;
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (mergedPropsStyles[i].key !== destStyles[i].key) return false;
    }
    // we have the invariant that mergedPropsStyles and
    // currentStyles/currentVelocities/last* are synced in terms of cells, see
    // mergeAndSync comment for more info
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (!$4869eed1e57dceb5$var$_shouldStopAnimation2["default"](currentStyles[i], destStyles[i].style, currentVelocities[i])) return false;
    }
    return true;
}
// core key merging logic
// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key
// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function $4869eed1e57dceb5$var$mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
    var newMergedPropsStyles = $4869eed1e57dceb5$var$_mergeDiff2["default"](oldMergedPropsStyles, destStyles, function(oldIndex, oldMergedPropsStyle) {
        var leavingStyle = willLeave(oldMergedPropsStyle);
        if (leavingStyle == null) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        if ($4869eed1e57dceb5$var$_shouldStopAnimation2["default"](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        return {
            key: oldMergedPropsStyle.key,
            data: oldMergedPropsStyle.data,
            style: leavingStyle
        };
    });
    var newCurrentStyles = [];
    var newCurrentVelocities = [];
    var newLastIdealStyles = [];
    var newLastIdealVelocities = [];
    for(var i = 0; i < newMergedPropsStyles.length; i++){
        var newMergedPropsStyleCell = newMergedPropsStyles[i];
        var foundOldIndex = null;
        for(var j = 0; j < oldMergedPropsStyles.length; j++)if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
            foundOldIndex = j;
            break;
        }
        // TODO: key search code
        if (foundOldIndex == null) {
            var plainStyle = willEnter(newMergedPropsStyleCell);
            newCurrentStyles[i] = plainStyle;
            newLastIdealStyles[i] = plainStyle;
            var velocity = $4869eed1e57dceb5$var$_mapToZero2["default"](newMergedPropsStyleCell.style);
            newCurrentVelocities[i] = velocity;
            newLastIdealVelocities[i] = velocity;
        } else {
            newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
            newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
            newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
            newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
        }
    }
    return [
        newMergedPropsStyles,
        newCurrentStyles,
        newCurrentVelocities,
        newLastIdealStyles,
        newLastIdealVelocities
    ];
}
var $4869eed1e57dceb5$var$TransitionMotion = function(_React$Component) {
    $4869eed1e57dceb5$var$_inherits(TransitionMotion, _React$Component);
    $4869eed1e57dceb5$var$_createClass(TransitionMotion, null, [
        {
            key: "propTypes",
            value: {
                defaultStyles: $4869eed1e57dceb5$var$_propTypes2["default"].arrayOf($4869eed1e57dceb5$var$_propTypes2["default"].shape({
                    key: $4869eed1e57dceb5$var$_propTypes2["default"].string.isRequired,
                    data: $4869eed1e57dceb5$var$_propTypes2["default"].any,
                    style: $4869eed1e57dceb5$var$_propTypes2["default"].objectOf($4869eed1e57dceb5$var$_propTypes2["default"].number).isRequired
                })),
                styles: $4869eed1e57dceb5$var$_propTypes2["default"].oneOfType([
                    $4869eed1e57dceb5$var$_propTypes2["default"].func,
                    $4869eed1e57dceb5$var$_propTypes2["default"].arrayOf($4869eed1e57dceb5$var$_propTypes2["default"].shape({
                        key: $4869eed1e57dceb5$var$_propTypes2["default"].string.isRequired,
                        data: $4869eed1e57dceb5$var$_propTypes2["default"].any,
                        style: $4869eed1e57dceb5$var$_propTypes2["default"].objectOf($4869eed1e57dceb5$var$_propTypes2["default"].oneOfType([
                            $4869eed1e57dceb5$var$_propTypes2["default"].number,
                            $4869eed1e57dceb5$var$_propTypes2["default"].object
                        ])).isRequired
                    }))
                ]).isRequired,
                children: $4869eed1e57dceb5$var$_propTypes2["default"].func.isRequired,
                willEnter: $4869eed1e57dceb5$var$_propTypes2["default"].func,
                willLeave: $4869eed1e57dceb5$var$_propTypes2["default"].func,
                didLeave: $4869eed1e57dceb5$var$_propTypes2["default"].func
            },
            enumerable: true
        },
        {
            key: "defaultProps",
            value: {
                willEnter: function willEnter(styleThatEntered) {
                    return $4869eed1e57dceb5$var$_stripStyle2["default"](styleThatEntered.style);
                },
                // recall: returning null makes the current unmounting TransitionStyle
                // disappear immediately
                willLeave: function willLeave() {
                    return null;
                },
                didLeave: function didLeave() {}
            },
            enumerable: true
        }
    ]);
    function TransitionMotion(props) {
        var _this = this;
        $4869eed1e57dceb5$var$_classCallCheck(this, TransitionMotion);
        _React$Component.call(this, props);
        this.unmounting = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _mergeAndSync = $4869eed1e57dceb5$var$mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
            var mergedPropsStyles = _mergeAndSync[0];
            var currentStyles = _mergeAndSync[1];
            var currentVelocities = _mergeAndSync[2];
            var lastIdealStyles = _mergeAndSync[3];
            var lastIdealVelocities = _mergeAndSync[4];
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i].style;
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === "number") {
                        if (!dirty) {
                            dirty = true;
                            currentStyles[i] = $4869eed1e57dceb5$var$_extends({}, currentStyles[i]);
                            currentVelocities[i] = $4869eed1e57dceb5$var$_extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = $4869eed1e57dceb5$var$_extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = $4869eed1e57dceb5$var$_extends({}, lastIdealVelocities[i]);
                            mergedPropsStyles[i] = {
                                key: mergedPropsStyles[i].key,
                                data: mergedPropsStyles[i].data,
                                style: $4869eed1e57dceb5$var$_extends({}, mergedPropsStyles[i].style)
                            };
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                        mergedPropsStyles[i].style[key] = styleValue;
                    }
                }
            }
            // unlike the other 2 components, we can't detect staleness and optionally
            // opt out of setState here. each style object's data might contain new
            // stuff we're not/cannot compare
            _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                mergedPropsStyles: mergedPropsStyles,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            if (_this.unmounting) return;
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $4869eed1e57dceb5$var$_raf2["default"](function(timestamp) {
                // https://github.com/chenglou/react-motion/pull/420
                // > if execution passes the conditional if (this.unmounting), then
                // executes async defaultRaf and after that component unmounts and after
                // that the callback of defaultRaf is called, then setState will be called
                // on unmounted component.
                if (_this.unmounting) return;
                var propStyles = _this.props.styles;
                var destStyles = typeof propStyles === "function" ? propStyles($4869eed1e57dceb5$var$rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
                // check if we need to animate in the first place
                if ($4869eed1e57dceb5$var$shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || $4869eed1e57dceb5$var$_performanceNow2["default"]();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $4869eed1e57dceb5$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $4869eed1e57dceb5$var$msPerFrame) * $4869eed1e57dceb5$var$msPerFrame) / $4869eed1e57dceb5$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $4869eed1e57dceb5$var$msPerFrame);
                var _mergeAndSync2 = $4869eed1e57dceb5$var$mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
                var newMergedPropsStyles = _mergeAndSync2[0];
                var newCurrentStyles = _mergeAndSync2[1];
                var newCurrentVelocities = _mergeAndSync2[2];
                var newLastIdealStyles = _mergeAndSync2[3];
                var newLastIdealVelocities = _mergeAndSync2[4];
                for(var i = 0; i < newMergedPropsStyles.length; i++){
                    var newMergedPropsStyle = newMergedPropsStyles[i].style;
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in newMergedPropsStyle){
                        if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) continue;
                        var styleValue = newMergedPropsStyle[key];
                        if (typeof styleValue === "number") {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = newLastIdealStyles[i][key];
                            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = $4869eed1e57dceb5$var$_stepper4["default"]($4869eed1e57dceb5$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = $4869eed1e57dceb5$var$_stepper4["default"]($4869eed1e57dceb5$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $4869eed1e57dceb5$var$msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities,
                    mergedPropsStyles: newMergedPropsStyles
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    TransitionMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var willEnter = _props.willEnter;
        var willLeave = _props.willLeave;
        var didLeave = _props.didLeave;
        var destStyles = typeof styles === "function" ? styles(defaultStyles) : styles;
        // this is special. for the first time around, we don't have a comparison
        // between last (no last) and current merged props. we'll compute last so:
        // say default is {a, b} and styles (dest style) is {b, c}, we'll
        // fabricate last as {a, b}
        var oldMergedPropsStyles = undefined;
        if (defaultStyles == null) oldMergedPropsStyles = destStyles;
        else oldMergedPropsStyles = defaultStyles.map(function(defaultStyleCell) {
            // TODO: key search code
            for(var i = 0; i < destStyles.length; i++){
                if (destStyles[i].key === defaultStyleCell.key) return destStyles[i];
            }
            return defaultStyleCell;
        });
        var oldCurrentStyles = defaultStyles == null ? destStyles.map(function(s) {
            return $4869eed1e57dceb5$var$_stripStyle2["default"](s.style);
        }) : defaultStyles.map(function(s) {
            return $4869eed1e57dceb5$var$_stripStyle2["default"](s.style);
        });
        var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function(s) {
            return $4869eed1e57dceb5$var$_mapToZero2["default"](s.style);
        }) : defaultStyles.map(function(s) {
            return $4869eed1e57dceb5$var$_mapToZero2["default"](s.style);
        });
        var _mergeAndSync3 = $4869eed1e57dceb5$var$mergeAndSync(// Because this is an old-style createReactClass component, Flow doesn't
        // understand that the willEnter and willLeave props have default values
        // and will always be present.
        willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, oldCurrentVelocities);
        var mergedPropsStyles = _mergeAndSync3[0];
        var currentStyles = _mergeAndSync3[1];
        var currentVelocities = _mergeAndSync3[2];
        var lastIdealStyles = _mergeAndSync3[3];
        var lastIdealVelocities = _mergeAndSync3[4];
        // oldLastIdealVelocities really
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: lastIdealStyles,
            lastIdealVelocities: lastIdealVelocities,
            mergedPropsStyles: mergedPropsStyles
        };
    };
    // after checking for unreadPropStyles != null, we manually go set the
    // non-interpolating values (those that are a number, without a spring
    // config)
    TransitionMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $4869eed1e57dceb5$var$_performanceNow2["default"]();
        this.startAnimationIfNecessary();
    };
    TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        var styles = props.styles;
        if (typeof styles === "function") this.unreadPropStyles = styles($4869eed1e57dceb5$var$rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
        else this.unreadPropStyles = styles;
        if (this.animationID == null) {
            this.prevTime = $4869eed1e57dceb5$var$_performanceNow2["default"]();
            this.startAnimationIfNecessary();
        }
    };
    TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounting = true;
        if (this.animationID != null) {
            $4869eed1e57dceb5$var$_raf2["default"].cancel(this.animationID);
            this.animationID = null;
        }
    };
    TransitionMotion.prototype.render = function render() {
        var hydratedStyles = $4869eed1e57dceb5$var$rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
        var renderedChildren = this.props.children(hydratedStyles);
        return renderedChildren && $4869eed1e57dceb5$var$_react2["default"].Children.only(renderedChildren);
    };
    return TransitionMotion;
}($4869eed1e57dceb5$var$_react2["default"].Component);
$4869eed1e57dceb5$exports["default"] = $4869eed1e57dceb5$var$TransitionMotion;
$4869eed1e57dceb5$exports = $4869eed1e57dceb5$exports["default"]; // list of styles, each containing interpolating values. Part of what's passed
 // to children function. Notice that this is
 // Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
 // data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
 // contains the key & data info (so that we only have a single source of truth
 // for these, and to save space). Check the comment for `rehydrateStyles` to
 // see how we regenerate the entirety of what's passed to children function
 // the array that keeps track of currently rendered stuff! Including stuff
 // that you've unmounted but that's still animating. This is where it lives
 // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400


$cb64f00fea5662cd$export$f55099f28d39dce4 = $cb64f00fea5662cd$var$_interopRequire($4869eed1e57dceb5$exports);
var $9461dbcad992a6e2$exports = {};
"use strict";
$9461dbcad992a6e2$exports.__esModule = true;
var $9461dbcad992a6e2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$9461dbcad992a6e2$exports["default"] = $9461dbcad992a6e2$var$spring;
function $9461dbcad992a6e2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $087f3ca39decd561$exports = {};
"use strict";
$087f3ca39decd561$exports.__esModule = true;
$087f3ca39decd561$exports["default"] = {
    noWobble: {
        stiffness: 170,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 210,
        damping: 20
    }
};
$087f3ca39decd561$exports = $087f3ca39decd561$exports["default"];


var $9461dbcad992a6e2$var$_presets2 = $9461dbcad992a6e2$var$_interopRequireDefault($087f3ca39decd561$exports);
var $9461dbcad992a6e2$var$defaultConfig = $9461dbcad992a6e2$var$_extends({}, $9461dbcad992a6e2$var$_presets2["default"].noWobble, {
    precision: 0.01
});
function $9461dbcad992a6e2$var$spring(val, config) {
    return $9461dbcad992a6e2$var$_extends({}, $9461dbcad992a6e2$var$defaultConfig, config, {
        val: val
    });
}
$9461dbcad992a6e2$exports = $9461dbcad992a6e2$exports["default"];


$cb64f00fea5662cd$export$b36281d89752ae66 = $cb64f00fea5662cd$var$_interopRequire($9461dbcad992a6e2$exports);

$cb64f00fea5662cd$export$7afd9c1079ecedf7 = $cb64f00fea5662cd$var$_interopRequire($087f3ca39decd561$exports);

$cb64f00fea5662cd$export$5d0a73a0957eccf0 = $cb64f00fea5662cd$var$_interopRequire($34b7a3f98e4e323b$exports);
var $ec039032be90c27d$exports = {};
"use strict";
$ec039032be90c27d$exports.__esModule = true;
$ec039032be90c27d$exports["default"] = $ec039032be90c27d$var$reorderKeys;
var $ec039032be90c27d$var$hasWarned = false;
function $ec039032be90c27d$var$reorderKeys() {}
$ec039032be90c27d$exports = $ec039032be90c27d$exports["default"];


$cb64f00fea5662cd$export$e4c0b4e3a05535fb = $cb64f00fea5662cd$var$_interopRequire($ec039032be90c27d$exports);


function $d4808d8f8c60755d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d4808d8f8c60755d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d4808d8f8c60755d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d4808d8f8c60755d$var$_typeof(obj);
}
function $d4808d8f8c60755d$var$_extends() {
    $d4808d8f8c60755d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d4808d8f8c60755d$var$_extends.apply(this, arguments);
}
function $d4808d8f8c60755d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d4808d8f8c60755d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d4808d8f8c60755d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d4808d8f8c60755d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d4808d8f8c60755d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d4808d8f8c60755d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d4808d8f8c60755d$var$_setPrototypeOf(subClass, superClass);
}
function $d4808d8f8c60755d$var$_setPrototypeOf(o, p) {
    $d4808d8f8c60755d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d4808d8f8c60755d$var$_setPrototypeOf(o, p);
}
function $d4808d8f8c60755d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d4808d8f8c60755d$var$_isNativeReflectConstruct();
    return function() {
        var Super = $d4808d8f8c60755d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d4808d8f8c60755d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d4808d8f8c60755d$var$_possibleConstructorReturn(this, result);
    };
}
function $d4808d8f8c60755d$var$_possibleConstructorReturn(self, call) {
    if (call && ($d4808d8f8c60755d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d4808d8f8c60755d$var$_assertThisInitialized(self);
}
function $d4808d8f8c60755d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d4808d8f8c60755d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d4808d8f8c60755d$var$_getPrototypeOf(o) {
    $d4808d8f8c60755d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d4808d8f8c60755d$var$_getPrototypeOf(o);
}
function $d4808d8f8c60755d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d4808d8f8c60755d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d4808d8f8c60755d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d4808d8f8c60755d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d4808d8f8c60755d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d4808d8f8c60755d$var$ownKeys(Object(source), true).forEach(function(key) {
            $d4808d8f8c60755d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d4808d8f8c60755d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d4808d8f8c60755d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d4808d8f8c60755d$var$ANIMATION_PROPTYPES = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        stiffness: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        nonAnimatedProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string),
        damping: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
]);
var $d4808d8f8c60755d$var$propTypes = {
    animatedProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string).isRequired,
    animation: $d4808d8f8c60755d$var$ANIMATION_PROPTYPES,
    onStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
/**
 * Format the animation style object
 * @param {Object|String} animationStyle - The animation style property, either the name of a
 * presets are one of noWobble, gentle, wobbly, stiff
 */ function $d4808d8f8c60755d$var$getAnimationStyle() {
    var animationStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $cb64f00fea5662cd$export$7afd9c1079ecedf7).noWobble;
    if (typeof animationStyle === "string") return (0, $cb64f00fea5662cd$export$7afd9c1079ecedf7)[animationStyle] || (0, $cb64f00fea5662cd$export$7afd9c1079ecedf7).noWobble;
    var damping = animationStyle.damping, stiffness = animationStyle.stiffness;
    return $d4808d8f8c60755d$var$_objectSpread($d4808d8f8c60755d$var$_objectSpread({}, animationStyle), {}, {
        damping: damping || (0, $cb64f00fea5662cd$export$7afd9c1079ecedf7).noWobble.damping,
        stiffness: stiffness || (0, $cb64f00fea5662cd$export$7afd9c1079ecedf7).noWobble.stiffness
    });
}
function $d4808d8f8c60755d$export$b4b2b0749c00e523(props) {
    var animatedProps = props.animatedProps, otherProps = $d4808d8f8c60755d$var$_objectWithoutProperties(props, [
        "animatedProps"
    ]);
    return animatedProps.reduce(function(result, animatedPropName) {
        if (Object.prototype.hasOwnProperty.call(otherProps, animatedPropName)) result[animatedPropName] = otherProps[animatedPropName];
        return result;
    }, {});
}
var $d4808d8f8c60755d$var$Animation = /*#__PURE__*/ function(_PureComponent) {
    $d4808d8f8c60755d$var$_inherits(Animation, _PureComponent);
    var _super = $d4808d8f8c60755d$var$_createSuper(Animation);
    function Animation(props) {
        var _this;
        $d4808d8f8c60755d$var$_classCallCheck(this, Animation);
        _this = _super.call(this, props);
        $d4808d8f8c60755d$var$_defineProperty($d4808d8f8c60755d$var$_assertThisInitialized(_this), "_motionEndHandler", function() {
            if (_this.props.onEnd) _this.props.onEnd();
        });
        $d4808d8f8c60755d$var$_defineProperty($d4808d8f8c60755d$var$_assertThisInitialized(_this), "_renderChildren", function(_ref) {
            var i = _ref.i;
            var children = _this.props.children;
            var interpolator = _this._interpolator;
            var child = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children);
            var interpolatedProps = interpolator ? interpolator(i) : interpolator; // interpolator doesnt play nice with deeply nested objected
            // so we expose an additional prop for situations like these, soit _data,
            // which stores the full tree and can be recombined with the sanitized version
            // after interpolation
            var data = interpolatedProps && interpolatedProps.data || null;
            if (data && child.props._data) data = data.map(function(row, index) {
                var correspondingCell = child.props._data[index];
                return $d4808d8f8c60755d$var$_objectSpread($d4808d8f8c60755d$var$_objectSpread({}, row), {}, {
                    parent: correspondingCell.parent,
                    children: correspondingCell.children
                });
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, $d4808d8f8c60755d$var$_objectSpread($d4808d8f8c60755d$var$_objectSpread($d4808d8f8c60755d$var$_objectSpread({}, child.props), interpolatedProps), {}, {
                data: data || child.props.data || null,
                // enforce re-rendering
                _animation: Math.random()
            }));
        });
        _this._updateInterpolator(props);
        return _this;
    }
    $d4808d8f8c60755d$var$_createClass(Animation, [
        {
            key: "UNSAFE_componentWillUpdate",
            value: function UNSAFE_componentWillUpdate(props) {
                this._updateInterpolator(this.props, props);
                if (props.onStart) props.onStart();
            }
        },
        {
            key: "_updateInterpolator",
            /**
     * Update the interpolator function and assign it to this._interpolator.
     * @param {Object} oldProps Old props.
     * @param {Object} newProps New props.
     * @private
     */ value: function _updateInterpolator(oldProps, newProps) {
                this._interpolator = (0, $8385105b4986daed$export$2e2bcd8739ae039)($d4808d8f8c60755d$export$b4b2b0749c00e523(oldProps), newProps ? $d4808d8f8c60755d$export$b4b2b0749c00e523(newProps) : null);
            }
        },
        {
            key: "render",
            value: function render() {
                var animationStyle = $d4808d8f8c60755d$var$getAnimationStyle(this.props.animation);
                var defaultStyle = {
                    i: 0
                };
                var style = {
                    i: (0, $cb64f00fea5662cd$export$b36281d89752ae66)(1, animationStyle)
                }; // In order to make Motion re-run animations each time, the random key is
                // always passed.
                // TODO: find a better solution for the spring.
                var key = Math.random();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cb64f00fea5662cd$export$ab7b018719e111db), $d4808d8f8c60755d$var$_extends({
                    defaultStyle: defaultStyle,
                    style: style,
                    key: key
                }, {
                    onRest: this._motionEndHandler
                }), this._renderChildren);
            }
        }
    ]);
    return Animation;
}((0, $acw62.PureComponent));
$d4808d8f8c60755d$var$Animation.propTypes = $d4808d8f8c60755d$var$propTypes;
$d4808d8f8c60755d$var$Animation.displayName = "Animation";
var $d4808d8f8c60755d$export$2e2bcd8739ae039 = $d4808d8f8c60755d$var$Animation;
var $d4808d8f8c60755d$export$c6290f21adf0a17a = $d4808d8f8c60755d$var$ANIMATION_PROPTYPES;


const $7c028b8201e48c5a$var$e10 = Math.sqrt(50), $7c028b8201e48c5a$var$e5 = Math.sqrt(10), $7c028b8201e48c5a$var$e2 = Math.sqrt(2);
function $7c028b8201e48c5a$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $7c028b8201e48c5a$var$e10 ? 10 : error >= $7c028b8201e48c5a$var$e5 ? 5 : error >= $7c028b8201e48c5a$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $7c028b8201e48c5a$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $7c028b8201e48c5a$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $7c028b8201e48c5a$var$tickSpec(stop, start, count) : $7c028b8201e48c5a$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $7c028b8201e48c5a$var$tickSpec(start, stop, count)[2];
}
function $7c028b8201e48c5a$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $7c028b8201e48c5a$export$bc64d00cc98e7e95(stop, start, count) : $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}


function $63cbeabc75241824$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $3acd474ceacf8a38$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $0ae9019609d046a1$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $63cbeabc75241824$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $63cbeabc75241824$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $63cbeabc75241824$export$2e2bcd8739ae039) || f === (0, $3acd474ceacf8a38$export$2e2bcd8739ae039) ? f : $0ae9019609d046a1$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $0ae9019609d046a1$var$zero() {
    return 0;
}


function $591ad978f2ce6133$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $591ad978f2ce6133$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $a6e17c0ec55d7735$var$ascendingBisect = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)((0, $63cbeabc75241824$export$2e2bcd8739ae039));
const $a6e17c0ec55d7735$export$4d945ad3ad5751b0 = $a6e17c0ec55d7735$var$ascendingBisect.right;
const $a6e17c0ec55d7735$export$df7d25c84ebd12a5 = $a6e17c0ec55d7735$var$ascendingBisect.left;
const $a6e17c0ec55d7735$export$c1cb828b1117c77b = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)((0, $591ad978f2ce6133$export$2e2bcd8739ae039)).center;
var $a6e17c0ec55d7735$export$2e2bcd8739ae039 = $a6e17c0ec55d7735$export$4d945ad3ad5751b0;


function $c0f8a9efb1caa699$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $acd329741cbdf381$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $6cab7aea8ef8b40b$export$2e2bcd8739ae039(x) {
    return +x;
}


var $afe237385175446a$var$unit = [
    0,
    1
];
function $afe237385175446a$export$f0954fd7d5368655(x) {
    return x;
}
function $afe237385175446a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $acd329741cbdf381$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $afe237385175446a$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $afe237385175446a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $afe237385175446a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $afe237385175446a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $afe237385175446a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $afe237385175446a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $a6e17c0ec55d7735$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $afe237385175446a$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $afe237385175446a$export$6b468dcfb64c653c() {
    var domain = $afe237385175446a$var$unit, range = $afe237385175446a$var$unit, interpolate = (0, $8385105b4986daed$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $afe237385175446a$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $afe237385175446a$export$f0954fd7d5368655) clamp = $afe237385175446a$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $afe237385175446a$var$polymap : $afe237385175446a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $bebed377ddb9d3af$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $6cab7aea8ef8b40b$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $c0f8a9efb1caa699$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $afe237385175446a$export$f0954fd7d5368655, rescale()) : clamp !== $afe237385175446a$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $afe237385175446a$export$2e2bcd8739ae039() {
    return $afe237385175446a$export$6b468dcfb64c653c()($afe237385175446a$export$f0954fd7d5368655, $afe237385175446a$export$f0954fd7d5368655);
}


function $5b694e64f5326630$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $5b694e64f5326630$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}



function $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $1589426e0436f502$export$2e2bcd8739ae039(x) {
    return x = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $f4c0f29ad920aaa1$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $95e9c493347f9308$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $d5828d241e6c1f75$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $d5828d241e6c1f75$export$2e2bcd8739ae039(specifier) {
    if (!(match = $d5828d241e6c1f75$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $d5828d241e6c1f75$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$d5828d241e6c1f75$export$2e2bcd8739ae039.prototype = $d5828d241e6c1f75$export$963aac351db36ed4.prototype; // instanceof
function $d5828d241e6c1f75$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$d5828d241e6c1f75$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $dd689cef4c920567$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $fe491ef31c379765$export$6863724d9a42263;
function $fe491ef31c379765$export$2e2bcd8739ae039(x, p) {
    var d = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($fe491ef31c379765$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $458fe095863893c0$export$2e2bcd8739ae039(x, p) {
    var d = (0, $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $03e2e7837f70dba5$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $458fe095863893c0$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $458fe095863893c0$export$2e2bcd8739ae039),
    "s": (0, $fe491ef31c379765$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $1bc532601db445af$export$2e2bcd8739ae039(x) {
    return x;
}


var $e8b109bb95cf9845$var$map = Array.prototype.map, $e8b109bb95cf9845$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $e8b109bb95cf9845$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $1bc532601db445af$export$2e2bcd8739ae039) : (0, $f4c0f29ad920aaa1$export$2e2bcd8739ae039)($e8b109bb95cf9845$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $1bc532601db445af$export$2e2bcd8739ae039) : (0, $95e9c493347f9308$export$2e2bcd8739ae039)($e8b109bb95cf9845$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $03e2e7837f70dba5$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $03e2e7837f70dba5$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $dd689cef4c920567$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $e8b109bb95cf9845$var$prefixes[8 + (0, $fe491ef31c379765$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $1589426e0436f502$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $e8b109bb95cf9845$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $54a757fa53542946$var$locale;
var $54a757fa53542946$export$d9468344d3651243;
var $54a757fa53542946$export$8d85692a469dde6f;
$54a757fa53542946$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $54a757fa53542946$export$2e2bcd8739ae039(definition) {
    $54a757fa53542946$var$locale = (0, $e8b109bb95cf9845$export$2e2bcd8739ae039)(definition);
    $54a757fa53542946$export$d9468344d3651243 = $54a757fa53542946$var$locale.format;
    $54a757fa53542946$export$8d85692a469dde6f = $54a757fa53542946$var$locale.formatPrefix;
    return $54a757fa53542946$var$locale;
}


function $f4e256a3cb9c44da$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $1589426e0436f502$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $162912dc121d0934$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $1589426e0436f502$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $1589426e0436f502$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $d27f2d3c2137f747$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $1589426e0436f502$export$2e2bcd8739ae039)(max) - (0, $1589426e0436f502$export$2e2bcd8739ae039)(step)) + 1;
}


function $b0a07d06c8b316c1$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $162912dc121d0934$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $54a757fa53542946$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $d27f2d3c2137f747$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $f4e256a3cb9c44da$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $54a757fa53542946$export$d9468344d3651243)(specifier);
}


function $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $b0a07d06c8b316c1$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $7c028b8201e48c5a$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $db1dd3c66a0cbf94$export$2e2bcd8739ae039() {
    var scale = (0, $afe237385175446a$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $db1dd3c66a0cbf94$export$2e2bcd8739ae039());
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale);
}



function $0c42deabcdb569d9$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $5bf2f979a0299157$var$transformLog(x) {
    return Math.log(x);
}
function $5bf2f979a0299157$var$transformExp(x) {
    return Math.exp(x);
}
function $5bf2f979a0299157$var$transformLogn(x) {
    return -Math.log(-x);
}
function $5bf2f979a0299157$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $5bf2f979a0299157$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $5bf2f979a0299157$var$powp(base) {
    return base === 10 ? $5bf2f979a0299157$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $5bf2f979a0299157$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $5bf2f979a0299157$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $5bf2f979a0299157$export$860836db074028f0(transform) {
    const scale = transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $5bf2f979a0299157$var$logp(base), pows = $5bf2f979a0299157$var$powp(base);
        if (domain()[0] < 0) {
            logs = $5bf2f979a0299157$var$reflect(logs), pows = $5bf2f979a0299157$var$reflect(pows);
            transform($5bf2f979a0299157$var$transformLogn, $5bf2f979a0299157$var$transformExpn);
        } else transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $d5828d241e6c1f75$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $54a757fa53542946$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $0c42deabcdb569d9$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $5bf2f979a0299157$export$2e2bcd8739ae039() {
    const scale = $5bf2f979a0299157$export$860836db074028f0((0, $afe237385175446a$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $afe237385175446a$export$784d13d8ee351f07)(scale, $5bf2f979a0299157$export$2e2bcd8739ae039()).base(scale.base());
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}

class $3160658555deb5c9$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($3160658555deb5c9$var$intern_get(this, key));
    }
    has(key) {
        return super.has($3160658555deb5c9$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($3160658555deb5c9$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, key));
    }
}
class $3160658555deb5c9$export$55278c3294239828 extends Set {
    constructor(values, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($3160658555deb5c9$var$intern_get(this, value));
    }
    add(value) {
        return super.add($3160658555deb5c9$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, value));
    }
}
function $3160658555deb5c9$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $3160658555deb5c9$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $3160658555deb5c9$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $3160658555deb5c9$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}



const $38404d762c7ac827$export$e4f898ab14d9d460 = Symbol("implicit");
function $38404d762c7ac827$export$2e2bcd8739ae039() {
    var index = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $38404d762c7ac827$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $38404d762c7ac827$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $38404d762c7ac827$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}

function $61d27a61db04c1a6$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}




function $c1f2fa2a7653ca3a$export$2e2bcd8739ae039() {
    var scale = (0, $38404d762c7ac827$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $c1f2fa2a7653ca3a$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$var$pointish(copy());
    };
    return scale;
}
function $c1f2fa2a7653ca3a$export$105684a3041cb6f3() {
    return $c1f2fa2a7653ca3a$var$pointish($c1f2fa2a7653ca3a$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

const $f26fc9b6912de968$var$t0 = new Date, $f26fc9b6912de968$var$t1 = new Date;
function $f26fc9b6912de968$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $f26fc9b6912de968$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $f26fc9b6912de968$var$t0.setTime(+start), $f26fc9b6912de968$var$t1.setTime(+end);
            floori($f26fc9b6912de968$var$t0), floori($f26fc9b6912de968$var$t1);
            return Math.floor(count($f26fc9b6912de968$var$t0, $f26fc9b6912de968$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}


const $a28c7a35eadfe1f6$export$79ef0e34099623dc = 1000;
const $a28c7a35eadfe1f6$export$683905d551c33fa9 = $a28c7a35eadfe1f6$export$79ef0e34099623dc * 60;
const $a28c7a35eadfe1f6$export$4157bf0c8e241659 = $a28c7a35eadfe1f6$export$683905d551c33fa9 * 60;
const $a28c7a35eadfe1f6$export$353686095f4fbf45 = $a28c7a35eadfe1f6$export$4157bf0c8e241659 * 24;
const $a28c7a35eadfe1f6$export$c241eb88520d5016 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 7;
const $a28c7a35eadfe1f6$export$ab95684df7020b26 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 30;
const $a28c7a35eadfe1f6$export$61f8ee2d834c6959 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 365;


const $51fe2e20810fcb40$export$8888529b966033e5 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45), (date)=>date.getDate() - 1);
const $51fe2e20810fcb40$export$6657a54f3034cf45 = $51fe2e20810fcb40$export$8888529b966033e5.range;
const $51fe2e20810fcb40$export$c8cbc42cefd47140 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $51fe2e20810fcb40$export$d277e198508549a1 = $51fe2e20810fcb40$export$c8cbc42cefd47140.range;
const $51fe2e20810fcb40$export$fb065be2d7ea4a71 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45);
}, (date)=>{
    return Math.floor(date / (0, $a28c7a35eadfe1f6$export$353686095f4fbf45));
});
const $51fe2e20810fcb40$export$a491caaf5e9481aa = $51fe2e20810fcb40$export$fb065be2d7ea4a71.range;



const $9472e71f07850dab$export$46c68a5833bc315b = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc) - date.getMinutes() * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659);
}, (date)=>{
    return date.getHours();
});
const $9472e71f07850dab$export$fb843f9087cd5235 = $9472e71f07850dab$export$46c68a5833bc315b.range;
const $9472e71f07850dab$export$31f6f2b3c63ac75e = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659);
}, (date)=>{
    return date.getUTCHours();
});
const $9472e71f07850dab$export$6e7a76cd5f50b719 = $9472e71f07850dab$export$31f6f2b3c63ac75e.range;



const $292297f992a3b17e$export$a7e4c34a52f0576 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc));
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$683905d551c33fa9);
}, (date)=>{
    return date.getMinutes();
});
const $292297f992a3b17e$export$186d65358374c0a2 = $292297f992a3b17e$export$a7e4c34a52f0576.range;
const $292297f992a3b17e$export$efe6712d6003761b = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$683905d551c33fa9);
}, (date)=>{
    return date.getUTCMinutes();
});
const $292297f992a3b17e$export$cedd563624e8ee50 = $292297f992a3b17e$export$efe6712d6003761b.range;


const $031c190f93ea3efa$export$7e1084fb688591c1 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $031c190f93ea3efa$export$3e24aa839cd0f1c4 = $031c190f93ea3efa$export$7e1084fb688591c1.range;
const $031c190f93ea3efa$export$cd49b3d2bcfe50d5 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $031c190f93ea3efa$export$49159f585997498 = $031c190f93ea3efa$export$cd49b3d2bcfe50d5.range;



const $490d5c36270b8fcb$export$3d3c77ce7df7d30d = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc));
}, (start, end)=>{
    return (end - start) / (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc);
}, (date)=>{
    return date.getUTCSeconds();
});
const $490d5c36270b8fcb$export$4792e48abc550fa1 = $490d5c36270b8fcb$export$3d3c77ce7df7d30d.range;




const $79ec6c01997bf022$export$edc5e5cb87280477 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$79ec6c01997bf022$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $79ec6c01997bf022$export$edc5e5cb87280477;
    return (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $79ec6c01997bf022$export$9a27fac83d67afd3 = $79ec6c01997bf022$export$edc5e5cb87280477.range;








function $7f6029921eecd017$var$timeWeekday(i) {
    return (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)) / (0, $a28c7a35eadfe1f6$export$c241eb88520d5016);
    });
}
const $7f6029921eecd017$export$22ee6205b762968c = $7f6029921eecd017$var$timeWeekday(0);
const $7f6029921eecd017$export$e79bbe0177cf1b01 = $7f6029921eecd017$var$timeWeekday(1);
const $7f6029921eecd017$export$57c0658c29f77708 = $7f6029921eecd017$var$timeWeekday(2);
const $7f6029921eecd017$export$3fbeef226c256e43 = $7f6029921eecd017$var$timeWeekday(3);
const $7f6029921eecd017$export$608689422d5cf9f4 = $7f6029921eecd017$var$timeWeekday(4);
const $7f6029921eecd017$export$548e5227aa183dca = $7f6029921eecd017$var$timeWeekday(5);
const $7f6029921eecd017$export$c56a3ad248908e19 = $7f6029921eecd017$var$timeWeekday(6);
const $7f6029921eecd017$export$eac514c8a8674eba = $7f6029921eecd017$export$22ee6205b762968c.range;
const $7f6029921eecd017$export$f7219b1481948356 = $7f6029921eecd017$export$e79bbe0177cf1b01.range;
const $7f6029921eecd017$export$77e22b12c5bed05b = $7f6029921eecd017$export$57c0658c29f77708.range;
const $7f6029921eecd017$export$b85d407a471809e8 = $7f6029921eecd017$export$3fbeef226c256e43.range;
const $7f6029921eecd017$export$c1bc1c49254c8855 = $7f6029921eecd017$export$608689422d5cf9f4.range;
const $7f6029921eecd017$export$3691a1557fff46f1 = $7f6029921eecd017$export$548e5227aa183dca.range;
const $7f6029921eecd017$export$b755452d02cba8d2 = $7f6029921eecd017$export$c56a3ad248908e19.range;
function $7f6029921eecd017$var$utcWeekday(i) {
    return (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $a28c7a35eadfe1f6$export$c241eb88520d5016);
    });
}
const $7f6029921eecd017$export$4898b06303a92011 = $7f6029921eecd017$var$utcWeekday(0);
const $7f6029921eecd017$export$9cfc53b9cfafd080 = $7f6029921eecd017$var$utcWeekday(1);
const $7f6029921eecd017$export$2a6d545f77eceb15 = $7f6029921eecd017$var$utcWeekday(2);
const $7f6029921eecd017$export$a5c25d8ed64433c4 = $7f6029921eecd017$var$utcWeekday(3);
const $7f6029921eecd017$export$1db08111baec2f53 = $7f6029921eecd017$var$utcWeekday(4);
const $7f6029921eecd017$export$29265e34dd5921f7 = $7f6029921eecd017$var$utcWeekday(5);
const $7f6029921eecd017$export$85b74dad05049604 = $7f6029921eecd017$var$utcWeekday(6);
const $7f6029921eecd017$export$6f3e1c2b0f7d7880 = $7f6029921eecd017$export$4898b06303a92011.range;
const $7f6029921eecd017$export$1d2d8b858bb366f9 = $7f6029921eecd017$export$9cfc53b9cfafd080.range;
const $7f6029921eecd017$export$1d5f6785fc7f30f8 = $7f6029921eecd017$export$2a6d545f77eceb15.range;
const $7f6029921eecd017$export$7a75faf0e37ef4af = $7f6029921eecd017$export$a5c25d8ed64433c4.range;
const $7f6029921eecd017$export$417eb959611b2f2f = $7f6029921eecd017$export$1db08111baec2f53.range;
const $7f6029921eecd017$export$59d308db7af08c64 = $7f6029921eecd017$export$29265e34dd5921f7.range;
const $7f6029921eecd017$export$a124108a0a7f34c8 = $7f6029921eecd017$export$85b74dad05049604.range;




const $dd6e0f506bfbbd03$export$cd17cfe45df0c046 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $dd6e0f506bfbbd03$export$69a4e90dd2cc3bd1 = $dd6e0f506bfbbd03$export$cd17cfe45df0c046.range;
const $dd6e0f506bfbbd03$export$d5c3802e389714c4 = (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f26fc9b6912de968$export$1a539c8b2950ab40)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $dd6e0f506bfbbd03$export$3e24d311e17f5802 = $dd6e0f506bfbbd03$export$d5c3802e389714c4.range;


function $047ba3ec3f41562e$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            1,
            (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            5,
            5 * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            15,
            15 * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d),
            30,
            30 * (0, $a28c7a35eadfe1f6$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $a28c7a35eadfe1f6$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $a28c7a35eadfe1f6$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $a28c7a35eadfe1f6$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $a28c7a35eadfe1f6$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $a28c7a35eadfe1f6$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $a28c7a35eadfe1f6$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $a28c7a35eadfe1f6$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $a28c7a35eadfe1f6$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $0ae9019609d046a1$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start / (0, $a28c7a35eadfe1f6$export$61f8ee2d834c6959), stop / (0, $a28c7a35eadfe1f6$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $79ec6c01997bf022$export$edc5e5cb87280477).every(Math.max((0, $7c028b8201e48c5a$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$047ba3ec3f41562e$export$826ba5ae907e9767, $047ba3ec3f41562e$export$6262d8d056ea44c4] = $047ba3ec3f41562e$var$ticker((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4), (0, $031c190f93ea3efa$export$cd49b3d2bcfe50d5), (0, $7f6029921eecd017$export$4898b06303a92011), (0, $51fe2e20810fcb40$export$fb065be2d7ea4a71), (0, $9472e71f07850dab$export$31f6f2b3c63ac75e), (0, $292297f992a3b17e$export$efe6712d6003761b));
const [$047ba3ec3f41562e$export$60c76498552d28a6, $047ba3ec3f41562e$export$69511150134dd174] = $047ba3ec3f41562e$var$ticker((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046), (0, $031c190f93ea3efa$export$7e1084fb688591c1), (0, $7f6029921eecd017$export$22ee6205b762968c), (0, $51fe2e20810fcb40$export$8888529b966033e5), (0, $9472e71f07850dab$export$46c68a5833bc315b), (0, $292297f992a3b17e$export$a7e4c34a52f0576));



function $463505b9d968caf4$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $463505b9d968caf4$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $463505b9d968caf4$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $463505b9d968caf4$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $463505b9d968caf4$var$formatRe(locale_periods), periodLookup = $463505b9d968caf4$var$formatLookup(locale_periods), weekdayRe = $463505b9d968caf4$var$formatRe(locale_weekdays), weekdayLookup = $463505b9d968caf4$var$formatLookup(locale_weekdays), shortWeekdayRe = $463505b9d968caf4$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $463505b9d968caf4$var$formatLookup(locale_shortWeekdays), monthRe = $463505b9d968caf4$var$formatRe(locale_months), monthLookup = $463505b9d968caf4$var$formatLookup(locale_months), shortMonthRe = $463505b9d968caf4$var$formatRe(locale_shortMonths), shortMonthLookup = $463505b9d968caf4$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatDayOfMonth,
        "e": $463505b9d968caf4$var$formatDayOfMonth,
        "f": $463505b9d968caf4$var$formatMicroseconds,
        "g": $463505b9d968caf4$var$formatYearISO,
        "G": $463505b9d968caf4$var$formatFullYearISO,
        "H": $463505b9d968caf4$var$formatHour24,
        "I": $463505b9d968caf4$var$formatHour12,
        "j": $463505b9d968caf4$var$formatDayOfYear,
        "L": $463505b9d968caf4$var$formatMilliseconds,
        "m": $463505b9d968caf4$var$formatMonthNumber,
        "M": $463505b9d968caf4$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatSeconds,
        "u": $463505b9d968caf4$var$formatWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatWeekNumberISO,
        "w": $463505b9d968caf4$var$formatWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatYear,
        "Y": $463505b9d968caf4$var$formatFullYear,
        "Z": $463505b9d968caf4$var$formatZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "e": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "f": $463505b9d968caf4$var$formatUTCMicroseconds,
        "g": $463505b9d968caf4$var$formatUTCYearISO,
        "G": $463505b9d968caf4$var$formatUTCFullYearISO,
        "H": $463505b9d968caf4$var$formatUTCHour24,
        "I": $463505b9d968caf4$var$formatUTCHour12,
        "j": $463505b9d968caf4$var$formatUTCDayOfYear,
        "L": $463505b9d968caf4$var$formatUTCMilliseconds,
        "m": $463505b9d968caf4$var$formatUTCMonthNumber,
        "M": $463505b9d968caf4$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatUTCSeconds,
        "u": $463505b9d968caf4$var$formatUTCWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatUTCWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatUTCWeekNumberISO,
        "w": $463505b9d968caf4$var$formatUTCWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatUTCYear,
        "Y": $463505b9d968caf4$var$formatUTCFullYear,
        "Z": $463505b9d968caf4$var$formatUTCZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $463505b9d968caf4$var$parseDayOfMonth,
        "e": $463505b9d968caf4$var$parseDayOfMonth,
        "f": $463505b9d968caf4$var$parseMicroseconds,
        "g": $463505b9d968caf4$var$parseYear,
        "G": $463505b9d968caf4$var$parseFullYear,
        "H": $463505b9d968caf4$var$parseHour24,
        "I": $463505b9d968caf4$var$parseHour24,
        "j": $463505b9d968caf4$var$parseDayOfYear,
        "L": $463505b9d968caf4$var$parseMilliseconds,
        "m": $463505b9d968caf4$var$parseMonthNumber,
        "M": $463505b9d968caf4$var$parseMinutes,
        "p": parsePeriod,
        "q": $463505b9d968caf4$var$parseQuarter,
        "Q": $463505b9d968caf4$var$parseUnixTimestamp,
        "s": $463505b9d968caf4$var$parseUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$parseSeconds,
        "u": $463505b9d968caf4$var$parseWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$parseWeekNumberSunday,
        "V": $463505b9d968caf4$var$parseWeekNumberISO,
        "w": $463505b9d968caf4$var$parseWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $463505b9d968caf4$var$parseYear,
        "Y": $463505b9d968caf4$var$parseFullYear,
        "Z": $463505b9d968caf4$var$parseZone,
        "%": $463505b9d968caf4$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $463505b9d968caf4$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $463505b9d968caf4$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $7f6029921eecd017$export$9cfc53b9cfafd080).ceil(week) : (0, $7f6029921eecd017$export$9cfc53b9cfafd080)(week);
                    week = (0, $51fe2e20810fcb40$export$c8cbc42cefd47140).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $7f6029921eecd017$export$e79bbe0177cf1b01).ceil(week) : (0, $7f6029921eecd017$export$e79bbe0177cf1b01)(week);
                    week = (0, $51fe2e20810fcb40$export$8888529b966033e5).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getUTCDay() : $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $463505b9d968caf4$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $463505b9d968caf4$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $463505b9d968caf4$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $463505b9d968caf4$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $463505b9d968caf4$var$numberRe = /^\s*\d+/, $463505b9d968caf4$var$percentRe = /^%/, $463505b9d968caf4$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $463505b9d968caf4$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $463505b9d968caf4$var$requote(s) {
    return s.replace($463505b9d968caf4$var$requoteRe, "\\$&");
}
function $463505b9d968caf4$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($463505b9d968caf4$var$requote).join("|") + ")", "i");
}
function $463505b9d968caf4$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $463505b9d968caf4$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberISO(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseFullYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseQuarter(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMonthNumber(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfMonth(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseHour24(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMinutes(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMilliseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMicroseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseLiteralPercent(d, string, i) {
    var n = $463505b9d968caf4$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $463505b9d968caf4$var$parseUnixTimestamp(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$formatDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getDate(), p, 2);
}
function $463505b9d968caf4$var$formatHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours(), p, 2);
}
function $463505b9d968caf4$var$formatHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $51fe2e20810fcb40$export$8888529b966033e5).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $463505b9d968caf4$var$formatWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$22ee6205b762968c).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$608689422d5cf9f4)(d) : (0, $7f6029921eecd017$export$608689422d5cf9f4).ceil(d);
}
function $463505b9d968caf4$var$formatWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$608689422d5cf9f4).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d), d) + ((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d).getDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $463505b9d968caf4$var$formatWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$e79bbe0177cf1b01).count((0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatYearISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$608689422d5cf9f4)(d) : (0, $7f6029921eecd017$export$608689422d5cf9f4).ceil(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $463505b9d968caf4$var$pad(z / 60 | 0, "0", 2) + $463505b9d968caf4$var$pad(z % 60, "0", 2);
}
function $463505b9d968caf4$var$formatUTCDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCDate(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatUTCDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $51fe2e20810fcb40$export$c8cbc42cefd47140).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatUTCMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatUTCMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatUTCMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatUTCMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatUTCMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatUTCSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $463505b9d968caf4$var$formatUTCWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$4898b06303a92011).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$1db08111baec2f53)(d) : (0, $7f6029921eecd017$export$1db08111baec2f53).ceil(d);
}
function $463505b9d968caf4$var$formatUTCWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$1db08111baec2f53).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d), d) + ((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d).getUTCDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $463505b9d968caf4$var$formatUTCWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $7f6029921eecd017$export$9cfc53b9cfafd080).count((0, $dd6e0f506bfbbd03$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatUTCYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCYearISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $7f6029921eecd017$export$1db08111baec2f53)(d) : (0, $7f6029921eecd017$export$1db08111baec2f53).ceil(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCZone() {
    return "+0000";
}
function $463505b9d968caf4$var$formatLiteralPercent() {
    return "%";
}
function $463505b9d968caf4$var$formatUnixTimestamp(d) {
    return +d;
}
function $463505b9d968caf4$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $0a9ce0165786feda$var$locale;
var $0a9ce0165786feda$export$94f4d87fad5dcf9a;
var $0a9ce0165786feda$export$32b9cd16e1b8c8d2;
var $0a9ce0165786feda$export$1a08fe38f63ebbbb;
var $0a9ce0165786feda$export$3edae9cf8e233729;
$0a9ce0165786feda$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $0a9ce0165786feda$export$2e2bcd8739ae039(definition) {
    $0a9ce0165786feda$var$locale = (0, $463505b9d968caf4$export$2e2bcd8739ae039)(definition);
    $0a9ce0165786feda$export$94f4d87fad5dcf9a = $0a9ce0165786feda$var$locale.format;
    $0a9ce0165786feda$export$32b9cd16e1b8c8d2 = $0a9ce0165786feda$var$locale.parse;
    $0a9ce0165786feda$export$1a08fe38f63ebbbb = $0a9ce0165786feda$var$locale.utcFormat;
    $0a9ce0165786feda$export$3edae9cf8e233729 = $0a9ce0165786feda$var$locale.utcParse;
    return $0a9ce0165786feda$var$locale;
}





function $304372357472b2a4$var$date(t) {
    return new Date(t);
}
function $304372357472b2a4$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $304372357472b2a4$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $afe237385175446a$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $304372357472b2a4$var$number)) : domain().map($304372357472b2a4$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $0c42deabcdb569d9$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $304372357472b2a4$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $304372357472b2a4$export$2e2bcd8739ae039() {
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply($304372357472b2a4$export$56bbcdb8aca31149((0, $047ba3ec3f41562e$export$60c76498552d28a6), (0, $047ba3ec3f41562e$export$69511150134dd174), (0, $dd6e0f506bfbbd03$export$cd17cfe45df0c046), (0, $031c190f93ea3efa$export$7e1084fb688591c1), (0, $7f6029921eecd017$export$22ee6205b762968c), (0, $51fe2e20810fcb40$export$8888529b966033e5), (0, $9472e71f07850dab$export$46c68a5833bc315b), (0, $292297f992a3b17e$export$a7e4c34a52f0576), (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d), (0, $0a9ce0165786feda$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}





function $f4e8dbe80a3143de$export$2e2bcd8739ae039() {
    return (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply((0, $304372357472b2a4$export$56bbcdb8aca31149)((0, $047ba3ec3f41562e$export$826ba5ae907e9767), (0, $047ba3ec3f41562e$export$6262d8d056ea44c4), (0, $dd6e0f506bfbbd03$export$d5c3802e389714c4), (0, $031c190f93ea3efa$export$cd49b3d2bcfe50d5), (0, $7f6029921eecd017$export$4898b06303a92011), (0, $51fe2e20810fcb40$export$c8cbc42cefd47140), (0, $9472e71f07850dab$export$31f6f2b3c63ac75e), (0, $292297f992a3b17e$export$efe6712d6003761b), (0, $490d5c36270b8fcb$export$3d3c77ce7df7d30d), (0, $0a9ce0165786feda$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}


function $24461355656d8852$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}


var $38063efcb0b229b0$export$82e9f45cca5ba907 = "$";
function $38063efcb0b229b0$var$Map() {}
$38063efcb0b229b0$var$Map.prototype = $38063efcb0b229b0$var$map.prototype = {
    constructor: $38063efcb0b229b0$var$Map,
    has: function(key) {
        return $38063efcb0b229b0$export$82e9f45cca5ba907 + key in this;
    },
    get: function(key) {
        return this[$38063efcb0b229b0$export$82e9f45cca5ba907 + key];
    },
    set: function(key, value) {
        this[$38063efcb0b229b0$export$82e9f45cca5ba907 + key] = value;
        return this;
    },
    remove: function(key) {
        var property = $38063efcb0b229b0$export$82e9f45cca5ba907 + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === $38063efcb0b229b0$export$82e9f45cca5ba907) f(this[property], property.slice(1), this);
    }
};
function $38063efcb0b229b0$var$map(object, f) {
    var map = new $38063efcb0b229b0$var$Map;
    // Copy constructor.
    if (object instanceof $38063efcb0b229b0$var$Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
var $38063efcb0b229b0$export$2e2bcd8739ae039 = $38063efcb0b229b0$var$map;


function $84aeb4920efec81c$export$2e2bcd8739ae039() {
    var keys = [], sortKeys = [], sortValues, rollup, nest;
    function apply(array, depth, createResult, setResult) {
        if (depth >= keys.length) {
            if (sortValues != null) array.sort(sortValues);
            return rollup != null ? rollup(array) : array;
        }
        var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, $38063efcb0b229b0$export$2e2bcd8739ae039)(), values, result = createResult();
        while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
        else valuesByKey.set(keyValue, [
            value
        ]);
        valuesByKey.each(function(values, key) {
            setResult(result, key, apply(values, depth, createResult, setResult));
        });
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        var array, sortKey = sortKeys[depth - 1];
        if (rollup != null && depth >= keys.length) array = map.entries();
        else array = [], map.each(function(v, k) {
            array.push({
                key: k,
                values: entries(v, depth)
            });
        });
        return sortKey != null ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
        }) : array;
    }
    return nest = {
        object: function(array) {
            return apply(array, 0, $84aeb4920efec81c$var$createObject, $84aeb4920efec81c$var$setObject);
        },
        map: function(array) {
            return apply(array, 0, $84aeb4920efec81c$var$createMap, $84aeb4920efec81c$var$setMap);
        },
        entries: function(array) {
            return entries(apply(array, 0, $84aeb4920efec81c$var$createMap, $84aeb4920efec81c$var$setMap), 0);
        },
        key: function(d) {
            keys.push(d);
            return nest;
        },
        sortKeys: function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        },
        sortValues: function(order) {
            sortValues = order;
            return nest;
        },
        rollup: function(f) {
            rollup = f;
            return nest;
        }
    };
}
function $84aeb4920efec81c$var$createObject() {
    return {};
}
function $84aeb4920efec81c$var$setObject(object, key, value) {
    object[key] = value;
}
function $84aeb4920efec81c$var$createMap() {
    return (0, $38063efcb0b229b0$export$2e2bcd8739ae039)();
}
function $84aeb4920efec81c$var$setMap(map, key, value) {
    map.set(key, value);
}



function $cf3c72678de97179$var$Set() {}
var $cf3c72678de97179$var$proto = (0, $38063efcb0b229b0$export$2e2bcd8739ae039).prototype;
$cf3c72678de97179$var$Set.prototype = $cf3c72678de97179$var$set.prototype = {
    constructor: $cf3c72678de97179$var$Set,
    has: $cf3c72678de97179$var$proto.has,
    add: function(value) {
        value += "";
        this[(0, $38063efcb0b229b0$export$82e9f45cca5ba907) + value] = value;
        return this;
    },
    remove: $cf3c72678de97179$var$proto.remove,
    clear: $cf3c72678de97179$var$proto.clear,
    values: $cf3c72678de97179$var$proto.keys,
    size: $cf3c72678de97179$var$proto.size,
    empty: $cf3c72678de97179$var$proto.empty,
    each: $cf3c72678de97179$var$proto.each
};
function $cf3c72678de97179$var$set(object, f) {
    var set = new $cf3c72678de97179$var$Set;
    // Copy constructor.
    if (object instanceof $cf3c72678de97179$var$Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
var $cf3c72678de97179$export$2e2bcd8739ae039 = $cf3c72678de97179$var$set;



function $b1df778a51d6d6fd$export$2e2bcd8739ae039(map) {
    var keys = [];
    for(var key in map)keys.push(key);
    return keys;
}


function $7138699956e0deee$export$2e2bcd8739ae039(map) {
    var values = [];
    for(var key in map)values.push(map[key]);
    return values;
}


function $09fb892cb60fcd6e$export$2e2bcd8739ae039(map) {
    var entries = [];
    for(var key in map)entries.push({
        key: key,
        value: map[key]
    });
    return entries;
}





var $bYoiY = parcelRequire("bYoiY");


var $acw62 = parcelRequire("acw62");
function $ddc583f274f25523$var$_slicedToArray(arr, i) {
    return $ddc583f274f25523$var$_arrayWithHoles(arr) || $ddc583f274f25523$var$_iterableToArrayLimit(arr, i) || $ddc583f274f25523$var$_unsupportedIterableToArray(arr, i) || $ddc583f274f25523$var$_nonIterableRest();
}
function $ddc583f274f25523$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ddc583f274f25523$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ddc583f274f25523$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ddc583f274f25523$var$_arrayLikeToArray(o, minLen);
}
function $ddc583f274f25523$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ddc583f274f25523$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ddc583f274f25523$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $ddc583f274f25523$var$_React$version$split = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.split("."), $ddc583f274f25523$var$_React$version$split2 = $ddc583f274f25523$var$_slicedToArray($ddc583f274f25523$var$_React$version$split, 2), $ddc583f274f25523$var$major = $ddc583f274f25523$var$_React$version$split2[0], $ddc583f274f25523$var$minor = $ddc583f274f25523$var$_React$version$split2[1];
var $ddc583f274f25523$var$versionHigherThanThirteen = Number($ddc583f274f25523$var$minor) > 13 || Number($ddc583f274f25523$var$major) > 13;
var $ddc583f274f25523$export$68219976fd5305d1 = function isReactDOMSupported() {
    return $ddc583f274f25523$var$versionHigherThanThirteen;
};
var $ddc583f274f25523$export$f39f755673ece9e2 = function getDOMNode(ref) {
    if (!$ddc583f274f25523$export$68219976fd5305d1()) return ref && ref.getDOMNode();
    return ref;
};
var $ddc583f274f25523$var$USED_MESSAGES = {};
var $ddc583f274f25523$var$HIDDEN_PROCESSES = {
    test: true,
    production: true
};
function $ddc583f274f25523$export$491112666e282270(message) {
    var onlyShowMessageOnce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    /* eslint-disable no-undef, no-process-env */ if ($parcel$global.process && $ddc583f274f25523$var$HIDDEN_PROCESSES["production"]) return;
    /* eslint-enable no-undef, no-process-env */ if (!onlyShowMessageOnce || !$ddc583f274f25523$var$USED_MESSAGES[message]) {
        /* eslint-disable no-console */ console.warn(message);
        /* eslint-enable no-console */ $ddc583f274f25523$var$USED_MESSAGES[message] = true;
    }
}
function $ddc583f274f25523$export$5b28268982f175ba(message) {
    $ddc583f274f25523$export$491112666e282270(message, true);
}


// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/**
 * Get unique property values from an array.
 * @param {Array} arr Array of data.
 * @param {string} propertyName Prop name.
 * @returns {Array} Array of unique values.
 */ function $a03034fd7b886b96$export$944d52bc02f257af(arr, accessor) {
    var setOfValues = new Set(arr.map(accessor));
    return Array.from(setOfValues);
}
function $a03034fd7b886b96$export$c3fce8d797ca3c33(arr, value) {
    var result = [].concat(arr);
    if (result[0] > value) result[0] = value;
    if (result[result.length - 1] < value) result[result.length - 1] = value;
    return result;
}
function $a03034fd7b886b96$export$e1b48b0771a44e32(value) {
    return Object.prototype.toString.call(value) === "[object Date]" ? value.toDateString() : value;
}


var $379b4f4f942d44ab$var$_SCALE_FUNCTIONS;
function $379b4f4f942d44ab$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $379b4f4f942d44ab$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $379b4f4f942d44ab$var$ownKeys(Object(source), true).forEach(function(key) {
            $379b4f4f942d44ab$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $379b4f4f942d44ab$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $379b4f4f942d44ab$var$_toConsumableArray(arr) {
    return $379b4f4f942d44ab$var$_arrayWithoutHoles(arr) || $379b4f4f942d44ab$var$_iterableToArray(arr) || $379b4f4f942d44ab$var$_unsupportedIterableToArray(arr) || $379b4f4f942d44ab$var$_nonIterableSpread();
}
function $379b4f4f942d44ab$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $379b4f4f942d44ab$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $379b4f4f942d44ab$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $379b4f4f942d44ab$var$_arrayLikeToArray(arr);
}
function $379b4f4f942d44ab$var$_slicedToArray(arr, i) {
    return $379b4f4f942d44ab$var$_arrayWithHoles(arr) || $379b4f4f942d44ab$var$_iterableToArrayLimit(arr, i) || $379b4f4f942d44ab$var$_unsupportedIterableToArray(arr, i) || $379b4f4f942d44ab$var$_nonIterableRest();
}
function $379b4f4f942d44ab$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $379b4f4f942d44ab$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $379b4f4f942d44ab$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $379b4f4f942d44ab$var$_arrayLikeToArray(o, minLen);
}
function $379b4f4f942d44ab$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $379b4f4f942d44ab$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $379b4f4f942d44ab$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $379b4f4f942d44ab$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Linear scale name.
 * @type {string}
 * @const
 */ var $379b4f4f942d44ab$var$LINEAR_SCALE_TYPE = "linear";
/**
 * Ordinal scale name.
 * @type {string}
 * @const
 */ var $379b4f4f942d44ab$var$ORDINAL_SCALE_TYPE = "ordinal";
/**
 * Category scale.
 * @type {string}
 * @const
 */ var $379b4f4f942d44ab$var$CATEGORY_SCALE_TYPE = "category";
/**
 * Literal scale.
 * Differs slightly from d3's identity scale in that it does not coerce value
 * into numbers, it simply returns exactly what you give it
 * @type {string}
 * @const
 */ var $379b4f4f942d44ab$var$LITERAL_SCALE_TYPE = "literal";
/**
 * Log scale name.
 * @type {string}
 * @const
 */ var $379b4f4f942d44ab$var$LOG_SCALE_TYPE = "log";
/**
 * Time scale name.
 * @type {string}
 * @const
 */ var $379b4f4f942d44ab$var$TIME_SCALE_TYPE = "time";
/**
 * Time UTC scale name.
 * @type {string}
 * @const
 */ var $379b4f4f942d44ab$var$TIME_UTC_SCALE_TYPE = "time-utc";
/**
 * Scale functions that are supported in the library.
 * @type {Object}
 * @const
 */ var $379b4f4f942d44ab$var$SCALE_FUNCTIONS = ($379b4f4f942d44ab$var$_SCALE_FUNCTIONS = {}, $379b4f4f942d44ab$var$_defineProperty($379b4f4f942d44ab$var$_SCALE_FUNCTIONS, $379b4f4f942d44ab$var$LINEAR_SCALE_TYPE, (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)), $379b4f4f942d44ab$var$_defineProperty($379b4f4f942d44ab$var$_SCALE_FUNCTIONS, $379b4f4f942d44ab$var$ORDINAL_SCALE_TYPE, (0, $c1f2fa2a7653ca3a$export$105684a3041cb6f3)), $379b4f4f942d44ab$var$_defineProperty($379b4f4f942d44ab$var$_SCALE_FUNCTIONS, $379b4f4f942d44ab$var$CATEGORY_SCALE_TYPE, (0, $38404d762c7ac827$export$2e2bcd8739ae039)), $379b4f4f942d44ab$var$_defineProperty($379b4f4f942d44ab$var$_SCALE_FUNCTIONS, $379b4f4f942d44ab$var$LITERAL_SCALE_TYPE, $379b4f4f942d44ab$export$8260763a729cc964), $379b4f4f942d44ab$var$_defineProperty($379b4f4f942d44ab$var$_SCALE_FUNCTIONS, $379b4f4f942d44ab$var$LOG_SCALE_TYPE, (0, $5bf2f979a0299157$export$2e2bcd8739ae039)), $379b4f4f942d44ab$var$_defineProperty($379b4f4f942d44ab$var$_SCALE_FUNCTIONS, $379b4f4f942d44ab$var$TIME_SCALE_TYPE, (0, $304372357472b2a4$export$2e2bcd8739ae039)), $379b4f4f942d44ab$var$_defineProperty($379b4f4f942d44ab$var$_SCALE_FUNCTIONS, $379b4f4f942d44ab$var$TIME_UTC_SCALE_TYPE, (0, $f4e8dbe80a3143de$export$2e2bcd8739ae039)), $379b4f4f942d44ab$var$_SCALE_FUNCTIONS);
/**
 * Attrs for which a scale can be set up at XYPlot level
 * @type {Array}
 * @const
 */ var $379b4f4f942d44ab$var$XYPLOT_ATTR = [
    "color",
    "fill",
    "opacity",
    "stroke"
];
/**
 * Title case a given string
 * @param {String} str Array of values.
 * @returns {String} titlecased string
 */ function $379b4f4f942d44ab$var$toTitleCase(str) {
    return "".concat(str[0].toUpperCase()).concat(str.slice(1));
}
function $379b4f4f942d44ab$export$88a5ffcaa9c8714e(values, scaleObject) {
    var scaleFn = $379b4f4f942d44ab$export$a984ebcab670d7ab(scaleObject);
    var result = 0;
    if (scaleFn) {
        var nextValue;
        var currentValue = scaleFn(values[0]);
        var distance = Infinity;
        var nextDistance;
        for(var i = 1; i < values.length; i++){
            nextValue = scaleFn(values[i]);
            nextDistance = Math.abs(nextValue - currentValue);
            if (nextDistance < distance) {
                distance = nextDistance;
                result = i;
            }
            currentValue = nextValue;
        }
    }
    return result;
}
/**
 * This is a workaround for issue that ordinal scale
 * does not have invert method implemented in d3-scale.
 * @param {Object} Ordinal d3-scale object.
 * @returns {void}
 * @private
 */ function $379b4f4f942d44ab$var$addInvertFunctionToOrdinalScaleObject(scale) {
    if (scale.invert) return;
    scale.invert = function invert(value) {
        var _scale$range = scale.range(), _scale$range2 = $379b4f4f942d44ab$var$_slicedToArray(_scale$range, 2), lower = _scale$range2[0], upper = _scale$range2[1];
        var start = Math.min(lower, upper);
        var stop = Math.max(lower, upper);
        if (value < start + scale.padding() * scale.step()) return scale.domain()[0];
        if (value > stop - scale.padding() * scale.step()) return scale.domain()[scale.domain().length - 1];
        var index = Math.floor((value - start - scale.padding() * scale.step()) / scale.step());
        return scale.domain()[index];
    };
}
function $379b4f4f942d44ab$export$a984ebcab670d7ab(scaleObject) {
    if (!scaleObject) return null;
    var type = scaleObject.type, domain = scaleObject.domain, range = scaleObject.range;
    var modDomain = domain[0] === domain[1] ? domain[0] === 0 ? [
        -1,
        0
    ] : [
        -domain[0],
        domain[0]
    ] : domain;
    if (type === $379b4f4f942d44ab$var$LITERAL_SCALE_TYPE) return $379b4f4f942d44ab$export$8260763a729cc964(range[0]);
    var scale = $379b4f4f942d44ab$var$SCALE_FUNCTIONS[type]().domain(modDomain).range(range);
    if (type === $379b4f4f942d44ab$var$ORDINAL_SCALE_TYPE) {
        scale.padding(0.5);
        $379b4f4f942d44ab$var$addInvertFunctionToOrdinalScaleObject(scale);
    }
    return scale;
}
function $379b4f4f942d44ab$export$f4d2af053da0c7d3(allData, accessor, accessor0, type) {
    var domain; // Collect both attr and available attr0 values from the array of data.
    var values = allData.reduce(function(data, d) {
        var value = accessor(d);
        var value0 = accessor0(d);
        if ($379b4f4f942d44ab$var$_isDefined(value)) data.push(value);
        if ($379b4f4f942d44ab$var$_isDefined(value0)) data.push(value0);
        return data;
    }, []);
    if (!values.length) return [];
     // Create proper domain depending on the type of the scale.
    if (type !== $379b4f4f942d44ab$var$ORDINAL_SCALE_TYPE && type !== $379b4f4f942d44ab$var$CATEGORY_SCALE_TYPE) domain = (0, $24461355656d8852$export$2e2bcd8739ae039)(values);
    else domain = (0, $cf3c72678de97179$export$2e2bcd8739ae039)(values).values();
    return domain;
}
/**
 * Create custom scale object from the value. When the scale is created from
 * this object, it should return the same value all time.
 * @param {string} attr Attribute.
 * @param {*} value Value.
 * @param {string} type - the type of scale being used
 * @param {function} accessor - the accessor function
 * @param {function} accessor0 - the accessor function for the potential naught value
 * @returns {Object} Custom scale object.
 * @private
 */ function $379b4f4f942d44ab$var$_createScaleObjectForValue(attr, value, type, accessor, accessor0) {
    if (type === $379b4f4f942d44ab$var$LITERAL_SCALE_TYPE) return {
        type: $379b4f4f942d44ab$var$LITERAL_SCALE_TYPE,
        domain: [],
        range: [
            value
        ],
        distance: 0,
        attr: attr,
        baseValue: undefined,
        isValue: true,
        accessor: accessor,
        accessor0: accessor0
    };
    if (typeof value === "undefined") return null;
    return {
        type: $379b4f4f942d44ab$var$CATEGORY_SCALE_TYPE,
        range: [
            value
        ],
        domain: [],
        distance: 0,
        attr: attr,
        baseValue: undefined,
        isValue: true,
        accessor: accessor,
        accessor0: accessor0
    };
}
/**
 * Create a regular scale object for a further use from the existing parameters.
 * @param {Array} domain - Domain.
 * @param {Array} range - Range.
 * @param {string} type - Type.
 * @param {number} distance - Distance.
 * @param {string} attr - Attribute.
 * @param {number} baseValue - Base value.
 * @param {function} accessor - Attribute accesor
 * @param {function} accessor0 - Attribute accesor for potential naught value
 * @returns {Object} Scale object.
 * @private
 */ function $379b4f4f942d44ab$var$_createScaleObjectForFunction(_ref) {
    var domain = _ref.domain, range = _ref.range, type = _ref.type, distance = _ref.distance, attr = _ref.attr, baseValue = _ref.baseValue, accessor = _ref.accessor, accessor0 = _ref.accessor0;
    return {
        domain: domain,
        range: range,
        type: type,
        distance: distance,
        attr: attr,
        baseValue: baseValue,
        isValue: false,
        accessor: accessor,
        accessor0: accessor0
    };
}
/**
 * Get scale object from props. E. g. object like {xRange, xDomain, xDistance,
 * xType} is transformed into {range, domain, distance, type}.
 * @param {Object} props Props.
 * @param {string} attr Attribute.
 * @returns {*} Null or an object with the scale.
 * @private
 */ function $379b4f4f942d44ab$var$_collectScaleObjectFromProps(props, attr) {
    var value = props[attr], fallbackValue = props["_".concat(attr, "Value")], range = props["".concat(attr, "Range")], _props$ = props["".concat(attr, "Distance")], distance = _props$ === void 0 ? 0 : _props$, baseValue = props["".concat(attr, "BaseValue")], _props$2 = props["".concat(attr, "Type")], type = _props$2 === void 0 ? $379b4f4f942d44ab$var$LINEAR_SCALE_TYPE : _props$2, noFallBack = props["".concat(attr, "NoFallBack")], _props$3 = props["get".concat($379b4f4f942d44ab$var$toTitleCase(attr))], accessor = _props$3 === void 0 ? function(d) {
        return d[attr];
    } : _props$3, _props$4 = props["get".concat($379b4f4f942d44ab$var$toTitleCase(attr), "0")], accessor0 = _props$4 === void 0 ? function(d) {
        return d["".concat(attr, "0")];
    } : _props$4;
    var domain = props["".concat(attr, "Domain")]; // Return value-based scale if the value is assigned.
    if (!noFallBack && typeof value !== "undefined") return $379b4f4f942d44ab$var$_createScaleObjectForValue(attr, value, props["".concat(attr, "Type")], accessor, accessor0);
     // Pick up the domain from the properties and create a new one if it's not
    // available.
    if (typeof baseValue !== "undefined") domain = (0, $a03034fd7b886b96$export$c3fce8d797ca3c33)(domain, baseValue);
     // Make sure that the minimum necessary properties exist.
    if (!range || !domain || !domain.length) // Try to use the fallback value if it is available.
    return $379b4f4f942d44ab$var$_createScaleObjectForValue(attr, fallbackValue, props["".concat(attr, "Type")], accessor, accessor0);
    return $379b4f4f942d44ab$var$_createScaleObjectForFunction({
        domain: domain,
        range: range,
        type: type,
        distance: distance,
        attr: attr,
        baseValue: baseValue,
        accessor: accessor,
        accessor0: accessor0
    });
}
/**
 * Compute left domain adjustment for the given values.
 * @param {Array} values Array of values.
 * @returns {number} Domain adjustment.
 * @private
 */ function $379b4f4f942d44ab$var$_computeLeftDomainAdjustment(values) {
    if (values.length > 1) return (values[1] - values[0]) / 2;
    if (values.length === 1) return values[0] - 0.5;
    return 0;
}
/**
 * Compute right domain adjustment for the given values.
 * @param {Array} values Array of values.
 * @returns {number} Domain adjustment.
 * @private
 */ function $379b4f4f942d44ab$var$_computeRightDomainAdjustment(values) {
    if (values.length > 1) return (values[values.length - 1] - values[values.length - 2]) / 2;
    if (values.length === 1) return values[0] - 0.5;
    return 0;
}
/**
 * Compute distance for the given values.
 * @param {Array} values Array of values.
 * @param {Array} domain Domain.
 * @param {number} bestDistIndex Index of a best distance found.
 * @param {function} scaleFn Scale function.
 * @returns {number} Domain adjustment.
 * @private
 */ function $379b4f4f942d44ab$var$_computeScaleDistance(values, domain, bestDistIndex, scaleFn) {
    if (values.length > 1) {
        // Avoid zero indexes.
        var i = Math.max(bestDistIndex, 1);
        return Math.abs(scaleFn(values[i]) - scaleFn(values[i - 1]));
    }
    if (values.length === 1) return Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
    return 0;
}
/**
 * Normilize array of values with a single value.
 * @param {Array} arr Array of data.
 * @param {Array} values Array of values.
 * @param {string} attr Attribute.
 * @param {string} type Type.
 * @private
 */ function $379b4f4f942d44ab$var$_normalizeValues(data, values, accessor0, type) {
    if (type === $379b4f4f942d44ab$var$TIME_SCALE_TYPE && values.length === 1) {
        var attr0 = accessor0(data[0]);
        return [
            attr0
        ].concat($379b4f4f942d44ab$var$_toConsumableArray(values));
    }
    return values;
}
function $379b4f4f942d44ab$export$7c013b995b145b99(data, scaleObject) {
    var domain = scaleObject.domain, type = scaleObject.type, accessor = scaleObject.accessor, accessor0 = scaleObject.accessor0;
    var uniqueValues = (0, $a03034fd7b886b96$export$944d52bc02f257af)(data, accessor); // Fix time scale if a data has only one value.
    var values = $379b4f4f942d44ab$var$_normalizeValues(data, uniqueValues, accessor0, type);
    var index = $379b4f4f942d44ab$export$88a5ffcaa9c8714e(values, scaleObject);
    var adjustedDomain = [].concat(domain);
    adjustedDomain[0] -= $379b4f4f942d44ab$var$_computeLeftDomainAdjustment(values);
    adjustedDomain[domain.length - 1] += $379b4f4f942d44ab$var$_computeRightDomainAdjustment(values); // Fix log scale if it's too small.
    if (type === $379b4f4f942d44ab$var$LOG_SCALE_TYPE && domain[0] <= 0) adjustedDomain[0] = Math.min(domain[1] / 10, 1);
    var adjustedScaleFn = $379b4f4f942d44ab$export$a984ebcab670d7ab($379b4f4f942d44ab$var$_objectSpread($379b4f4f942d44ab$var$_objectSpread({}, scaleObject), {}, {
        domain: adjustedDomain
    }));
    var distance = $379b4f4f942d44ab$var$_computeScaleDistance(values, adjustedDomain, index, adjustedScaleFn);
    return {
        domain0: adjustedDomain[0],
        domainN: adjustedDomain[adjustedDomain.length - 1],
        distance: distance
    };
}
/**
 * Returns true if scale adjustments are possible for a given scale.
 * @param {Object} props Props.
 * @param {Object} scaleObject Scale object.
 * @returns {boolean} True if scale adjustments possible.
 * @private
 */ function $379b4f4f942d44ab$var$_isScaleAdjustmentPossible(props, scaleObject) {
    var attr = scaleObject.attr;
    var _props$_adjustBy = props._adjustBy, adjustBy = _props$_adjustBy === void 0 ? [] : _props$_adjustBy, _props$_adjustWhat = props._adjustWhat, adjustWhat = _props$_adjustWhat === void 0 ? [] : _props$_adjustWhat; // The scale cannot be adjusted if there's no attributes to adjust, no
    // suitable values
    return adjustWhat.length && adjustBy.length && adjustBy.indexOf(attr) !== -1;
}
/**
 * Adjust continuous scales (e.g. 'linear', 'log' and 'time') by adding the
 * space from the left and right of them and by computing the best distance.
 * @param {Object} props Props.
 * @param {Object} scaleObject Scale object.
 * @returns {*} Scale object with adjustments.
 * @private
 */ function $379b4f4f942d44ab$var$_adjustContinuousScale(props, scaleObject) {
    var allSeriesData = props._allData, _props$_adjustWhat2 = props._adjustWhat, adjustWhat = _props$_adjustWhat2 === void 0 ? [] : _props$_adjustWhat2; // Assign the initial values.
    var domainLength = scaleObject.domain.length;
    var domain = scaleObject.domain;
    var scaleDomain0 = domain[0];
    var scaleDomainN = domain[domainLength - 1];
    var scaleDistance = scaleObject.distance; // Find the smallest left position of the domain, the largest right position
    // of the domain and the best distance for them.
    allSeriesData.forEach(function(data, index) {
        if (adjustWhat.indexOf(index) === -1) return;
        if (data && data.length) {
            var _getScaleDistanceAndA = $379b4f4f942d44ab$export$7c013b995b145b99(data, scaleObject), domain0 = _getScaleDistanceAndA.domain0, domainN = _getScaleDistanceAndA.domainN, distance = _getScaleDistanceAndA.distance;
            scaleDomain0 = Math.min(scaleDomain0, domain0);
            scaleDomainN = Math.max(scaleDomainN, domainN);
            scaleDistance = Math.max(scaleDistance, distance);
        }
    });
    scaleObject.domain = [
        scaleDomain0
    ].concat($379b4f4f942d44ab$var$_toConsumableArray(domain.slice(1, -1)), [
        scaleDomainN
    ]);
    scaleObject.distance = scaleDistance;
    return scaleObject;
}
function $379b4f4f942d44ab$export$564aa7766c86dc98(scaleObject) {
    var scaleFn = $379b4f4f942d44ab$export$a984ebcab670d7ab(scaleObject);
    var domain = scaleObject.domain, range = scaleObject.range;
    if (domain.length > 1) scaleObject.distance = Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
    else scaleObject.distance = Math.abs(range[1] - range[0]);
    return scaleObject;
}
function $379b4f4f942d44ab$export$6b08c10e39e8737a(props, attr) {
    // Create the initial scale object.
    var scaleObject = $379b4f4f942d44ab$var$_collectScaleObjectFromProps(props, attr);
    if (!scaleObject) return null;
     // Make sure if it's possible to add space to the scale object. If not,
    // return the object immediately.
    if (!$379b4f4f942d44ab$var$_isScaleAdjustmentPossible(props, scaleObject)) return scaleObject;
    var type = scaleObject.type; // Depending on what type the scale is, apply different adjustments. Distances
    // for the ordinal and category scales are even, equal domains cannot be
    // adjusted.
    if (type === $379b4f4f942d44ab$var$ORDINAL_SCALE_TYPE || type === $379b4f4f942d44ab$var$CATEGORY_SCALE_TYPE) return $379b4f4f942d44ab$export$564aa7766c86dc98(scaleObject);
    return $379b4f4f942d44ab$var$_adjustContinuousScale(props, scaleObject);
}
function $379b4f4f942d44ab$export$cb87eff04da17d9(props, attr) {
    var scaleObject = $379b4f4f942d44ab$export$6b08c10e39e8737a(props, attr);
    return $379b4f4f942d44ab$export$a984ebcab670d7ab(scaleObject);
}
/**
 * Get the value of `attr` from the object.
 * @param {Object} d - data Object.
 * @param {Function} accessor - accessor function.
 * @returns {*} Value of the point.
 * @private
 */ function $379b4f4f942d44ab$var$_getAttrValue(d, accessor) {
    return accessor(d.data ? d.data : d);
}
function $379b4f4f942d44ab$var$_isDefined(value) {
    return typeof value !== "undefined";
}
/*
 * Adds a percentage of padding to a given domain
 * @param {Array} domain X or Y domain to pad.
 * @param {Number} padding Percentage of padding to add to domain
 * @returns {Array} Padded Domain
 */ function $379b4f4f942d44ab$var$_padDomain(domain, padding) {
    if (!domain) return domain;
    if (isNaN(parseFloat(domain[0])) || isNaN(parseFloat(domain[1]))) return domain;
    var _domain = $379b4f4f942d44ab$var$_slicedToArray(domain, 2), min = _domain[0], max = _domain[1];
    var domainPadding = (max - min) * (padding * 0.01);
    return [
        min - domainPadding,
        max + domainPadding
    ];
}
function $379b4f4f942d44ab$export$735c878afad94f32(props, attr) {
    var scaleObject = $379b4f4f942d44ab$export$6b08c10e39e8737a(props, attr);
    if (scaleObject) {
        var scaleFn = $379b4f4f942d44ab$export$a984ebcab670d7ab(scaleObject);
        return function(d) {
            return scaleFn($379b4f4f942d44ab$var$_getAttrValue(d, scaleObject.accessor));
        };
    }
    return null;
}
function $379b4f4f942d44ab$export$8b4d7b016ad3bc31(props, attr) {
    var scaleObject = $379b4f4f942d44ab$export$6b08c10e39e8737a(props, attr);
    if (scaleObject) {
        var domain = scaleObject.domain;
        var _scaleObject$baseValu = scaleObject.baseValue, baseValue = _scaleObject$baseValu === void 0 ? domain[0] : _scaleObject$baseValu;
        var scaleFn = $379b4f4f942d44ab$export$a984ebcab670d7ab(scaleObject);
        return function(d) {
            var value = $379b4f4f942d44ab$var$_getAttrValue(d, scaleObject.accessor0);
            return scaleFn($379b4f4f942d44ab$var$_isDefined(value) ? value : baseValue);
        };
    }
    return null;
}
function $379b4f4f942d44ab$export$1e335898aa11b111(props, attr) {
    var scaleObject = $379b4f4f942d44ab$export$6b08c10e39e8737a(props, attr);
    if (scaleObject) {
        if (!scaleObject.isValue && props["_".concat(attr, "Value")] === undefined) (0, $ddc583f274f25523$export$491112666e282270)("[React-vis] Cannot use data defined ".concat(attr, " for this ") + "series type. Using fallback value instead.");
        return props["_".concat(attr, "Value")] || scaleObject.range[0];
    }
    return null;
}
function $379b4f4f942d44ab$export$860d546dd4901970(attr) {
    var _ref2;
    return _ref2 = {}, $379b4f4f942d44ab$var$_defineProperty(_ref2, "_".concat(attr, "Value"), (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any), $379b4f4f942d44ab$var$_defineProperty(_ref2, "".concat(attr, "Domain"), (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).array), $379b4f4f942d44ab$var$_defineProperty(_ref2, "get".concat($379b4f4f942d44ab$var$toTitleCase(attr)), (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func), $379b4f4f942d44ab$var$_defineProperty(_ref2, "get".concat($379b4f4f942d44ab$var$toTitleCase(attr), "0"), (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func), $379b4f4f942d44ab$var$_defineProperty(_ref2, "".concat(attr, "Range"), (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).array), $379b4f4f942d44ab$var$_defineProperty(_ref2, "".concat(attr, "Type"), (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf(Object.keys($379b4f4f942d44ab$var$SCALE_FUNCTIONS))), $379b4f4f942d44ab$var$_defineProperty(_ref2, "".concat(attr, "Distance"), (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number), $379b4f4f942d44ab$var$_defineProperty(_ref2, "".concat(attr, "BaseValue"), (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any), _ref2;
}
function $379b4f4f942d44ab$export$9ba38978f16a5362(props, attributes) {
    var result = {};
    Object.keys(props).forEach(function(key) {
        // this filtering is critical for extracting the correct accessors!
        var attr = attributes.find(function(a) {
            // width
            var isPlainSet = key.indexOf(a) === 0; // Ex: _data
            var isUnderscoreSet = key.indexOf("_".concat(a)) === 0; // EX: getX
            var usesGet = key.indexOf("get".concat($379b4f4f942d44ab$var$toTitleCase(a))) === 0;
            return isPlainSet || isUnderscoreSet || usesGet;
        });
        if (!attr) return;
        result[key] = props[key];
    });
    return result;
}
function $379b4f4f942d44ab$export$6b25e8934069fbf5(props, data, attributes) {
    var result = {}; // Make sure that the domain is set pad it if specified
    attributes.forEach(function(attr) {
        if (!props["get".concat($379b4f4f942d44ab$var$toTitleCase(attr))]) result["get".concat($379b4f4f942d44ab$var$toTitleCase(attr))] = function(d) {
            return d[attr];
        };
        if (!props["get".concat($379b4f4f942d44ab$var$toTitleCase(attr), "0")]) result["get".concat($379b4f4f942d44ab$var$toTitleCase(attr), "0")] = function(d) {
            return d["".concat(attr, "0")];
        };
        if (!props["".concat(attr, "Domain")]) {
            result["".concat(attr, "Domain")] = $379b4f4f942d44ab$export$f4d2af053da0c7d3(data, props["get".concat($379b4f4f942d44ab$var$toTitleCase(attr))] || result["get".concat($379b4f4f942d44ab$var$toTitleCase(attr))], props["get".concat($379b4f4f942d44ab$var$toTitleCase(attr), "0")] || result["get".concat($379b4f4f942d44ab$var$toTitleCase(attr), "0")], props["".concat(attr, "Type")]);
            if (props["".concat(attr, "Padding")]) result["".concat(attr, "Domain")] = $379b4f4f942d44ab$var$_padDomain(result["".concat(attr, "Domain")], props["".concat(attr, "Padding")]);
        }
    });
    return result;
}
function $379b4f4f942d44ab$export$8260763a729cc964(defaultValue) {
    function scale(d) {
        if (d === undefined) return defaultValue;
        return d;
    }
    function response() {
        return scale;
    }
    scale.domain = response;
    scale.range = response;
    scale.unknown = response;
    scale.copy = response;
    return scale;
}
function $379b4f4f942d44ab$export$f8102d7542f8efe4(background) {
    if (background) return (0, $bYoiY.hsl)(background).l > 0.57 ? "#222" : "#fff";
    return null;
}
function $379b4f4f942d44ab$export$bcb757bdc9760c42(props, children) {
    var XYPlotScales = $379b4f4f942d44ab$var$XYPLOT_ATTR.reduce(function(prev, attr) {
        var domain = props["".concat(attr, "Domain")], range = props["".concat(attr, "Range")], type = props["".concat(attr, "Type")];
        if (domain && range && type) return $379b4f4f942d44ab$var$_objectSpread($379b4f4f942d44ab$var$_objectSpread({}, prev), {}, $379b4f4f942d44ab$var$_defineProperty({}, attr, $379b4f4f942d44ab$var$SCALE_FUNCTIONS[type]().domain(domain).range(range)));
        return prev;
    }, {});
    return children.map(function(child) {
        return $379b4f4f942d44ab$var$XYPLOT_ATTR.reduce(function(prev, attr) {
            if (child.props && child.props[attr] !== undefined) {
                var scaleInput = child.props[attr];
                var scale = XYPlotScales[attr];
                var fallbackValue = scale ? scale(scaleInput) : scaleInput;
                return $379b4f4f942d44ab$var$_objectSpread($379b4f4f942d44ab$var$_objectSpread({}, prev), {}, $379b4f4f942d44ab$var$_defineProperty({}, "_".concat(attr, "Value"), fallbackValue));
            }
            return prev;
        }, {});
    });
}
var $379b4f4f942d44ab$var$OPTIONAL_SCALE_PROPS = [
    "Padding"
];
var $379b4f4f942d44ab$var$OPTIONAL_SCALE_PROPS_REGS = $379b4f4f942d44ab$var$OPTIONAL_SCALE_PROPS.map(function(str) {
    return new RegExp("".concat(str, "$"), "i");
});
function $379b4f4f942d44ab$export$17db1cfb5431bf96(props) {
    return Object.keys(props).reduce(function(acc, prop) {
        var propIsNotOptional = $379b4f4f942d44ab$var$OPTIONAL_SCALE_PROPS_REGS.every(function(reg) {
            return !prop.match(reg);
        });
        if (propIsNotOptional) return acc;
        acc[prop] = props[prop];
        return acc;
    }, {});
}
var $379b4f4f942d44ab$export$2e2bcd8739ae039 = {
    extractScalePropsFromProps: $379b4f4f942d44ab$export$9ba38978f16a5362,
    getAttributeScale: $379b4f4f942d44ab$export$cb87eff04da17d9,
    getAttributeFunctor: $379b4f4f942d44ab$export$735c878afad94f32,
    getAttr0Functor: $379b4f4f942d44ab$export$8b4d7b016ad3bc31,
    getAttributeValue: $379b4f4f942d44ab$export$1e335898aa11b111,
    getDomainByAccessor: $379b4f4f942d44ab$export$f4d2af053da0c7d3,
    getFontColorFromBackground: $379b4f4f942d44ab$export$f8102d7542f8efe4,
    getMissingScaleProps: $379b4f4f942d44ab$export$6b25e8934069fbf5,
    getOptionalScaleProps: $379b4f4f942d44ab$export$17db1cfb5431bf96,
    getScaleObjectFromProps: $379b4f4f942d44ab$export$6b08c10e39e8737a,
    getScalePropTypesByAttribute: $379b4f4f942d44ab$export$860d546dd4901970,
    getXYPlotValues: $379b4f4f942d44ab$export$bcb757bdc9760c42,
    literalScale: $379b4f4f942d44ab$export$8260763a729cc964
};


function $e900f871d9675978$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e900f871d9675978$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e900f871d9675978$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e900f871d9675978$var$_typeof(obj);
}
function $e900f871d9675978$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e900f871d9675978$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e900f871d9675978$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e900f871d9675978$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e900f871d9675978$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e900f871d9675978$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e900f871d9675978$var$_setPrototypeOf(subClass, superClass);
}
function $e900f871d9675978$var$_setPrototypeOf(o, p) {
    $e900f871d9675978$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e900f871d9675978$var$_setPrototypeOf(o, p);
}
function $e900f871d9675978$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e900f871d9675978$var$_isNativeReflectConstruct();
    return function() {
        var Super = $e900f871d9675978$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e900f871d9675978$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e900f871d9675978$var$_possibleConstructorReturn(this, result);
    };
}
function $e900f871d9675978$var$_possibleConstructorReturn(self, call) {
    if (call && ($e900f871d9675978$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $e900f871d9675978$var$_assertThisInitialized(self);
}
function $e900f871d9675978$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e900f871d9675978$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e900f871d9675978$var$_getPrototypeOf(o) {
    $e900f871d9675978$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e900f871d9675978$var$_getPrototypeOf(o);
}
function $e900f871d9675978$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e900f871d9675978$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e900f871d9675978$var$ownKeys(Object(source), true).forEach(function(key) {
            $e900f871d9675978$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e900f871d9675978$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e900f871d9675978$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e900f871d9675978$var$propTypes = $e900f871d9675978$var$_objectSpread($e900f871d9675978$var$_objectSpread($e900f871d9675978$var$_objectSpread($e900f871d9675978$var$_objectSpread($e900f871d9675978$var$_objectSpread($e900f871d9675978$var$_objectSpread({}, (0, $379b4f4f942d44ab$export$860d546dd4901970)("x")), (0, $379b4f4f942d44ab$export$860d546dd4901970)("y")), (0, $379b4f4f942d44ab$export$860d546dd4901970)("size")), (0, $379b4f4f942d44ab$export$860d546dd4901970)("opacity")), (0, $379b4f4f942d44ab$export$860d546dd4901970)("color")), {}, {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).array
    ])),
    onValueMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onSeriesMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onSeriesMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onSeriesClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onSeriesRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNearestX: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNearestXY: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    animation: (0, $d4808d8f8c60755d$export$c6290f21adf0a17a),
    stack: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
});
var $e900f871d9675978$var$defaultProps = {
    className: "",
    stack: false,
    style: {}
};
var $e900f871d9675978$var$AbstractSeries = /*#__PURE__*/ function(_PureComponent) {
    $e900f871d9675978$var$_inherits(AbstractSeries, _PureComponent);
    var _super = $e900f871d9675978$var$_createSuper(AbstractSeries);
    function AbstractSeries() {
        var _this;
        $e900f871d9675978$var$_classCallCheck(this, AbstractSeries);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $e900f871d9675978$var$_defineProperty($e900f871d9675978$var$_assertThisInitialized(_this), "_seriesClickHandler", function(event) {
            var onSeriesClick = _this.props.onSeriesClick;
            if (onSeriesClick) onSeriesClick({
                event: event
            });
        });
        $e900f871d9675978$var$_defineProperty($e900f871d9675978$var$_assertThisInitialized(_this), "_seriesMouseOutHandler", function(event) {
            var onSeriesMouseOut = _this.props.onSeriesMouseOut;
            if (onSeriesMouseOut) onSeriesMouseOut({
                event: event
            });
        });
        $e900f871d9675978$var$_defineProperty($e900f871d9675978$var$_assertThisInitialized(_this), "_seriesMouseOverHandler", function(event) {
            var onSeriesMouseOver = _this.props.onSeriesMouseOver;
            if (onSeriesMouseOver) onSeriesMouseOver({
                event: event
            });
        });
        $e900f871d9675978$var$_defineProperty($e900f871d9675978$var$_assertThisInitialized(_this), "_seriesRightClickHandler", function(event) {
            var onSeriesRightClick = _this.props.onSeriesRightClick;
            if (onSeriesRightClick) onSeriesRightClick({
                event: event
            });
        });
        $e900f871d9675978$var$_defineProperty($e900f871d9675978$var$_assertThisInitialized(_this), "_valueClickHandler", function(d, event) {
            var _this$props = _this.props, onValueClick = _this$props.onValueClick, onSeriesClick = _this$props.onSeriesClick;
            if (onValueClick) onValueClick(d, {
                event: event
            });
            if (onSeriesClick) onSeriesClick({
                event: event
            });
        });
        $e900f871d9675978$var$_defineProperty($e900f871d9675978$var$_assertThisInitialized(_this), "_valueMouseOutHandler", function(d, event) {
            var _this$props2 = _this.props, onValueMouseOut = _this$props2.onValueMouseOut, onSeriesMouseOut = _this$props2.onSeriesMouseOut;
            if (onValueMouseOut) onValueMouseOut(d, {
                event: event
            });
            if (onSeriesMouseOut) onSeriesMouseOut({
                event: event
            });
        });
        $e900f871d9675978$var$_defineProperty($e900f871d9675978$var$_assertThisInitialized(_this), "_valueMouseOverHandler", function(d, event) {
            var _this$props3 = _this.props, onValueMouseOver = _this$props3.onValueMouseOver, onSeriesMouseOver = _this$props3.onSeriesMouseOver;
            if (onValueMouseOver) onValueMouseOver(d, {
                event: event
            });
            if (onSeriesMouseOver) onSeriesMouseOver({
                event: event
            });
        });
        $e900f871d9675978$var$_defineProperty($e900f871d9675978$var$_assertThisInitialized(_this), "_valueRightClickHandler", function(d, event) {
            var _this$props4 = _this.props, onValueRightClick = _this$props4.onValueRightClick, onSeriesRightClick = _this$props4.onSeriesRightClick;
            if (onValueRightClick) onValueRightClick(d, {
                event: event
            });
            if (onSeriesRightClick) onSeriesRightClick({
                event: event
            });
        });
        return _this;
    }
    $e900f871d9675978$var$_createClass(AbstractSeries, [
        {
            key: "onParentMouseMove",
            value: function onParentMouseMove(event) {
                var _this$props5 = this.props, onNearestX = _this$props5.onNearestX, onNearestXY = _this$props5.onNearestXY, data = _this$props5.data;
                if (!onNearestX && !onNearestXY || !data) return;
                if (onNearestXY) this._handleNearestXY(event);
                else this._handleNearestX(event);
            }
        },
        {
            key: "onParentTouchMove",
            value: function onParentTouchMove(e) {
                e.preventDefault();
                this.onParentMouseMove(e);
            }
        },
        {
            key: "onParentTouchStart",
            value: function onParentTouchStart(e) {
                // prevent mouse event emulation
                e.preventDefault();
            }
        },
        {
            key: "_getAttr0Functor",
            value: function _getAttr0Functor(attr) {
                return (0, $379b4f4f942d44ab$export$8b4d7b016ad3bc31)(this.props, attr);
            }
        },
        {
            key: "_getAttributeFunctor",
            value: function _getAttributeFunctor(attr) {
                return (0, $379b4f4f942d44ab$export$735c878afad94f32)(this.props, attr);
            }
        },
        {
            key: "_getAttributeValue",
            value: function _getAttributeValue(attr) {
                return (0, $379b4f4f942d44ab$export$1e335898aa11b111)(this.props, attr);
            }
        },
        {
            key: "_getScaleDistance",
            value: function _getScaleDistance(attr) {
                var scaleObject = (0, $379b4f4f942d44ab$export$6b08c10e39e8737a)(this.props, attr);
                return scaleObject ? scaleObject.distance : 0;
            }
        },
        {
            key: "_getXYCoordinateInContainer",
            value: function _getXYCoordinateInContainer(event) {
                var _this$props6 = this.props, _this$props6$marginTo = _this$props6.marginTop, marginTop = _this$props6$marginTo === void 0 ? 0 : _this$props6$marginTo, _this$props6$marginLe = _this$props6.marginLeft, marginLeft = _this$props6$marginLe === void 0 ? 0 : _this$props6$marginLe;
                var evt = event.nativeEvent, currentTarget = event.currentTarget;
                var rect = currentTarget.getBoundingClientRect();
                var x = evt.clientX;
                var y = evt.clientY;
                if (evt.type === "touchmove") {
                    x = evt.touches[0].pageX;
                    y = evt.touches[0].pageY;
                }
                return {
                    x: x - rect.left - currentTarget.clientLeft - marginLeft,
                    y: y - rect.top - currentTarget.clientTop - marginTop
                };
            }
        },
        {
            key: "_handleNearestX",
            value: function _handleNearestX(event) {
                var _this$props7 = this.props, onNearestX = _this$props7.onNearestX, data = _this$props7.data;
                var minDistance = Number.POSITIVE_INFINITY;
                var value = null;
                var valueIndex = null;
                var coordinate = this._getXYCoordinateInContainer(event);
                var xScaleFn = this._getAttributeFunctor("x");
                data.forEach(function(item, i) {
                    var currentCoordinate = xScaleFn(item);
                    var newDistance = Math.abs(coordinate.x - currentCoordinate);
                    if (newDistance < minDistance) {
                        minDistance = newDistance;
                        value = item;
                        valueIndex = i;
                    }
                });
                if (!value) return;
                onNearestX(value, {
                    innerX: xScaleFn(value),
                    index: valueIndex,
                    event: event.nativeEvent
                });
            }
        },
        {
            key: "_handleNearestXY",
            value: function _handleNearestXY(event) {
                var _this$props8 = this.props, onNearestXY = _this$props8.onNearestXY, data = _this$props8.data;
                var coordinate = this._getXYCoordinateInContainer(event);
                var xScaleFn = this._getAttributeFunctor("x");
                var yScaleFn = this._getAttributeFunctor("y"); // Create a voronoi with each node center points
                var voronoiInstance = (0, $50e37159451a6d0c$export$2e2bcd8739ae039)().x(xScaleFn).y(yScaleFn);
                var foundPoint = voronoiInstance(data).find(coordinate.x, coordinate.y);
                var value = foundPoint.data;
                if (!value) return;
                onNearestXY(value, {
                    innerX: foundPoint[0],
                    innerY: foundPoint[1],
                    index: foundPoint.index,
                    event: event.nativeEvent
                });
            }
        }
    ], [
        {
            key: "getParentConfig",
            /**
     * Get a default config for the parent.
     * @returns {Object} Empty config.
     */ value: function getParentConfig() {
                return {};
            }
        },
        {
            key: "requiresSVG",
            get: function get() {
                return true;
            }
        }
    ]);
    return AbstractSeries;
}((0, $acw62.PureComponent));
$e900f871d9675978$var$AbstractSeries.displayName = "AbstractSeries";
$e900f871d9675978$var$AbstractSeries.propTypes = $e900f871d9675978$var$propTypes;
$e900f871d9675978$var$AbstractSeries.defaultProps = $e900f871d9675978$var$defaultProps;
var $e900f871d9675978$export$2e2bcd8739ae039 = $e900f871d9675978$var$AbstractSeries;



var $acw62 = parcelRequire("acw62");


function $59cb0344df9474fa$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}



var $kDiOX = parcelRequire("kDiOX");
const $c9f66a4d1c06b373$var$pi = Math.PI, $c9f66a4d1c06b373$var$tau = 2 * $c9f66a4d1c06b373$var$pi, $c9f66a4d1c06b373$var$epsilon = 1e-6, $c9f66a4d1c06b373$var$tauEpsilon = $c9f66a4d1c06b373$var$tau - $c9f66a4d1c06b373$var$epsilon;
function $c9f66a4d1c06b373$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $c9f66a4d1c06b373$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $c9f66a4d1c06b373$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $c9f66a4d1c06b373$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $c9f66a4d1c06b373$var$append : $c9f66a4d1c06b373$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $c9f66a4d1c06b373$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c9f66a4d1c06b373$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c9f66a4d1c06b373$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $c9f66a4d1c06b373$var$epsilon || Math.abs(this._y1 - y0) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c9f66a4d1c06b373$var$tau + $c9f66a4d1c06b373$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c9f66a4d1c06b373$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $c9f66a4d1c06b373$var$epsilon) this._append`A${r},${r},0,${+(da >= $c9f66a4d1c06b373$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $c9f66a4d1c06b373$export$bb654e07daaf8c3a() {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$c9f66a4d1c06b373$export$bb654e07daaf8c3a.prototype = $c9f66a4d1c06b373$export$4b2950bdac9b6ee9.prototype;
function $c9f66a4d1c06b373$export$e181c6ece8d9cc5f(digits = 3) {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9(+digits);
}


function $5c3aa3aea2c844cf$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $c9f66a4d1c06b373$export$4b2950bdac9b6ee9)(digits);
}


function $b196a0c5210e8c70$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $b196a0c5210e8c70$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $b196a0c5210e8c70$var$arcStartAngle(d) {
    return d.startAngle;
}
function $b196a0c5210e8c70$var$arcEndAngle(d) {
    return d.endAngle;
}
function $b196a0c5210e8c70$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $b196a0c5210e8c70$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $kDiOX.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $b196a0c5210e8c70$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $kDiOX.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $kDiOX.sqrt)((0, $kDiOX.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $b196a0c5210e8c70$export$2e2bcd8739ae039() {
    var innerRadius = $b196a0c5210e8c70$var$arcInnerRadius, outerRadius = $b196a0c5210e8c70$var$arcOuterRadius, cornerRadius = (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(0), padRadius = null, startAngle = $b196a0c5210e8c70$var$arcStartAngle, endAngle = $b196a0c5210e8c70$var$arcEndAngle, padAngle = $b196a0c5210e8c70$var$arcPadAngle, context = null, path = (0, $5c3aa3aea2c844cf$export$fb6e83118a5dcd45)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $kDiOX.halfPi), a1 = endAngle.apply(this, arguments) - (0, $kDiOX.halfPi), da = (0, $kDiOX.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $kDiOX.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $kDiOX.tau) - (0, $kDiOX.epsilon)) {
            context.moveTo(r1 * (0, $kDiOX.cos)(a0), r1 * (0, $kDiOX.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $kDiOX.epsilon)) {
                context.moveTo(r0 * (0, $kDiOX.cos)(a1), r0 * (0, $kDiOX.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $kDiOX.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $kDiOX.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $kDiOX.min)((0, $kDiOX.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $kDiOX.epsilon)) {
                var p0 = (0, $kDiOX.asin)(rp / r0 * (0, $kDiOX.sin)(ap)), p1 = (0, $kDiOX.asin)(rp / r1 * (0, $kDiOX.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $kDiOX.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $kDiOX.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $kDiOX.cos)(a01), y01 = r1 * (0, $kDiOX.sin)(a01), x10 = r0 * (0, $kDiOX.cos)(a10), y10 = r0 * (0, $kDiOX.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $kDiOX.epsilon)) {
                var x11 = r1 * (0, $kDiOX.cos)(a11), y11 = r1 * (0, $kDiOX.sin)(a11), x00 = r0 * (0, $kDiOX.cos)(a00), y00 = r0 * (0, $kDiOX.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < (0, $kDiOX.pi)) {
                    if (oc = $b196a0c5210e8c70$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $kDiOX.sin)((0, $kDiOX.acos)((ax * bx + ay * by) / ((0, $kDiOX.sqrt)(ax * ax + ay * ay) * (0, $kDiOX.sqrt)(bx * bx + by * by))) / 2), lc = (0, $kDiOX.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $kDiOX.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $kDiOX.min)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $kDiOX.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $kDiOX.epsilon)) {
                t0 = $b196a0c5210e8c70$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $b196a0c5210e8c70$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $kDiOX.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $kDiOX.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $kDiOX.atan2)(t1.y11, t1.x11), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $kDiOX.epsilon)) || !(da0 > (0, $kDiOX.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $kDiOX.epsilon)) {
                t0 = $b196a0c5210e8c70$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $b196a0c5210e8c70$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $kDiOX.atan2)(t0.y01, t0.x01), (0, $kDiOX.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $kDiOX.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $kDiOX.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $kDiOX.atan2)(t1.y11, t1.x11), (0, $kDiOX.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $kDiOX.pi) / 2;
        return [
            (0, $kDiOX.cos)(a) * r,
            (0, $kDiOX.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}



var $acw62 = parcelRequire("acw62");

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var $d629c93f7b094ef1$export$b59a484929f340e1 = [
    "#12939A",
    "#79C7E3",
    "#1A3177",
    "#FF9833",
    "#EF5D28"
];
var $d629c93f7b094ef1$export$9bfc784861ab91d8 = [
    "#19CDD7",
    "#DDB27C",
    "#88572C",
    "#FF991F",
    "#F15C17",
    "#223F9A",
    "#DA70BF",
    "#125C77",
    "#4DC19C",
    "#776E57",
    "#12939A",
    "#17B8BE",
    "#F6D18A",
    "#B7885E",
    "#FFCB99",
    "#F89570",
    "#829AE3",
    "#E79FD5",
    "#1E96BE",
    "#89DAC1",
    "#B3AD9E"
];
var $d629c93f7b094ef1$export$36688c8ae3834bf8 = [
    "#EF5D28",
    "#FF9833"
];
var $d629c93f7b094ef1$export$933e9b6491d90bfd = [
    1,
    10
];
var $d629c93f7b094ef1$export$88e5577c7042528a = [
    0.1,
    1
];
var $d629c93f7b094ef1$export$dba5ca323c28272c = "literal";
var $d629c93f7b094ef1$export$95a809b606e7af75 = 1;
var $d629c93f7b094ef1$export$e4c0458e30711294 = 5;
var $d629c93f7b094ef1$export$37394b0fa44b998c = $d629c93f7b094ef1$export$b59a484929f340e1[0];
var $d629c93f7b094ef1$export$8a4d07e0b80bc8b4 = 7;


function $ba94dd19eb06369c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ba94dd19eb06369c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ba94dd19eb06369c$var$ownKeys(Object(source), true).forEach(function(key) {
            $ba94dd19eb06369c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ba94dd19eb06369c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ba94dd19eb06369c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ba94dd19eb06369c$export$cef01c0a4cef80c(child) {
    var prototype = child.type.prototype;
    return prototype instanceof (0, $e900f871d9675978$export$2e2bcd8739ae039);
}
function $ba94dd19eb06369c$export$ba0d7ce1f57c52a6(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children).filter(function(child) {
        return child && $ba94dd19eb06369c$export$cef01c0a4cef80c(child);
    });
}
/**
 * Collect the map of repetitions of the series type for all children.
 * @param {Array} children Array of children.
 * @returns {{}} Map of repetitions where sameTypeTotal is the total amount and
 * sameTypeIndex is always 0.
 */ function $ba94dd19eb06369c$var$collectSeriesTypesInfo(children) {
    var result = {};
    children.filter($ba94dd19eb06369c$export$cef01c0a4cef80c).forEach(function(child) {
        var displayName = child.type.displayName;
        var cluster = child.props.cluster;
        if (!result[displayName]) result[displayName] = {
            sameTypeTotal: 0,
            sameTypeIndex: 0,
            clusters: new Set()
        };
        result[displayName].clusters.add(cluster);
        result[displayName].sameTypeTotal++;
    });
    return result;
}
/**
 * Check series to see if it has angular data that needs to be converted
 * @param {Array} data - an array of objects to check
 * @returns {Boolean} whether or not this series contains polar configuration
 */ function $ba94dd19eb06369c$var$seriesHasAngleRadius() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (!data) return false;
    return data.some(function(row) {
        return row.radius && row.angle;
    });
}
/**
 * Possibly convert polar coordinates to x/y for computing domain
 * @param {Array} data - an array of objects to check
 * @param {String} attr - the property being checked
 * @returns {Boolean} whether or not this series contains polar configuration
 */ function $ba94dd19eb06369c$var$prepareData(data) {
    if (!$ba94dd19eb06369c$var$seriesHasAngleRadius(data)) return data;
    return data.map(function(row) {
        return $ba94dd19eb06369c$var$_objectSpread($ba94dd19eb06369c$var$_objectSpread({}, row), {}, {
            x: row.radius * Math.cos(row.angle),
            y: row.radius * Math.sin(row.angle)
        });
    });
}
function $ba94dd19eb06369c$export$c2170542cfc0177c(children, attr) {
    var areSomeSeriesStacked = children.some(function(series) {
        return series && series.props.stack;
    }); // It stores the last segment position added to each bar, separated by cluster.
    var latestAttrPositions = {};
    return children.reduce(function(accumulator, series) {
        // Skip the children that are not series (e.g. don't have any data).
        if (!series) {
            accumulator.push(null);
            return accumulator;
        }
        var seriesType = series.type.displayName;
        var _series$props = series.props, data = _series$props.data, _series$props$cluster = _series$props.cluster, cluster = _series$props$cluster === void 0 ? "default" : _series$props$cluster, stack = _series$props.stack;
        var preppedData = $ba94dd19eb06369c$var$prepareData(data, attr);
        if (!attr || !preppedData || !preppedData.length || areSomeSeriesStacked && !stack) {
            accumulator.push(preppedData);
            return accumulator;
        }
        var attr0 = "".concat(attr, "0");
        var baseAttr = attr === "y" ? "x" : "y";
        accumulator.push(preppedData.map(function(d) {
            var _objectSpread2, _latestAttrPositions$2;
            if (!latestAttrPositions[cluster]) latestAttrPositions[cluster] = {};
            if (!latestAttrPositions[cluster][seriesType]) latestAttrPositions[cluster][seriesType] = {};
            var prevD = latestAttrPositions[cluster][seriesType][d[baseAttr]]; // It is the first segment of a bar.
            if (!prevD) {
                var _latestAttrPositions$;
                latestAttrPositions[cluster][seriesType][d[baseAttr]] = (_latestAttrPositions$ = {}, $ba94dd19eb06369c$var$_defineProperty(_latestAttrPositions$, attr0, d[attr0]), $ba94dd19eb06369c$var$_defineProperty(_latestAttrPositions$, attr, d[attr]), _latestAttrPositions$);
                return $ba94dd19eb06369c$var$_objectSpread({}, d);
            } // Calculate the position of the next segment in a bar.
            var nextD = $ba94dd19eb06369c$var$_objectSpread($ba94dd19eb06369c$var$_objectSpread({}, d), {}, (_objectSpread2 = {}, $ba94dd19eb06369c$var$_defineProperty(_objectSpread2, attr0, prevD[attr]), $ba94dd19eb06369c$var$_defineProperty(_objectSpread2, attr, prevD[attr] + d[attr] - (d[attr0] || 0)), _objectSpread2));
            latestAttrPositions[cluster][seriesType][d[baseAttr]] = (_latestAttrPositions$2 = {}, $ba94dd19eb06369c$var$_defineProperty(_latestAttrPositions$2, attr0, nextD[attr0]), $ba94dd19eb06369c$var$_defineProperty(_latestAttrPositions$2, attr, nextD[attr]), _latestAttrPositions$2);
            return nextD;
        }));
        return accumulator;
    }, []);
}
function $ba94dd19eb06369c$export$72592ebe4579131b(children) {
    var result = [];
    var seriesTypesInfo = $ba94dd19eb06369c$var$collectSeriesTypesInfo(children);
    var seriesIndex = 0;
    var _opacityValue = (0, $d629c93f7b094ef1$export$95a809b606e7af75);
    children.forEach(function(child) {
        var props;
        if ($ba94dd19eb06369c$export$cef01c0a4cef80c(child)) {
            var seriesTypeInfo = seriesTypesInfo[child.type.displayName];
            var _colorValue = (0, $d629c93f7b094ef1$export$b59a484929f340e1)[seriesIndex % (0, $d629c93f7b094ef1$export$b59a484929f340e1).length];
            props = $ba94dd19eb06369c$var$_objectSpread($ba94dd19eb06369c$var$_objectSpread({}, seriesTypeInfo), {}, {
                seriesIndex: seriesIndex,
                _colorValue: _colorValue,
                _opacityValue: _opacityValue
            });
            seriesTypeInfo.sameTypeIndex++;
            seriesIndex++;
            if (child.props.cluster) {
                props.cluster = child.props.cluster; // Using Array.from() so we can use .indexOf
                props.clusters = Array.from(seriesTypeInfo.clusters);
                props.sameTypeTotal = props.clusters.length;
                props.sameTypeIndex = props.clusters.indexOf(child.props.cluster);
            }
        }
        result.push(props);
    });
    return result;
}
function $ba94dd19eb06369c$export$8db0eb04c74fd34e(data) {
    return data.reduce(function(res, row) {
        return Math.max(row.radius, res);
    }, 0);
}
var $ba94dd19eb06369c$export$d820d92204df1f3c = [
    "xRange",
    "xDomain",
    "x",
    "yRange",
    "yDomain",
    "y",
    "colorRange",
    "colorDomain",
    "color",
    "opacityRange",
    "opacityDomain",
    "opacity",
    "strokeRange",
    "strokeDomain",
    "stroke",
    "fillRange",
    "fillDomain",
    "fill",
    "width",
    "height",
    "marginLeft",
    "marginTop",
    "marginRight",
    "marginBottom",
    "data",
    "angleDomain",
    "angleRange",
    "angle",
    "radiusDomain",
    "radiusRange",
    "radius",
    "innerRadiusDomain",
    "innerRadiusRange",
    "innerRadius"
];
function $ba94dd19eb06369c$export$e8849e85b4deee73(props) {
    var _stackBy = props._stackBy, valuePosAttr = props.valuePosAttr, cluster = props.cluster;
    var _props$sameTypeTotal = props.sameTypeTotal, sameTypeTotal = _props$sameTypeTotal === void 0 ? 1 : _props$sameTypeTotal, _props$sameTypeIndex = props.sameTypeIndex, sameTypeIndex = _props$sameTypeIndex === void 0 ? 0 : _props$sameTypeIndex; // If bars are stacked, but not clustering, override `sameTypeTotal` and
    // `sameTypeIndex` such that bars are stacked and not staggered.
    if (_stackBy === valuePosAttr && !cluster) {
        sameTypeTotal = 1;
        sameTypeIndex = 0;
    }
    return {
        sameTypeTotal: sameTypeTotal,
        sameTypeIndex: sameTypeIndex
    };
}




// Copyright (c) 2016 - 2019 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/**
 * Generates interpolated class names signature based on multiple class names
 * ignoring the falsy and non-string values
 * @param {...string} classNames CSS class signatures.
 * @returns {string} Interpolated string containing all valid class names.
 */ function $bc758dcd9beb6337$export$5eda8697d8fc9890() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.filter(function(cn) {
        return cn && typeof cn === "string";
    }).join(" ");
}


function $682e33890727be82$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $682e33890727be82$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $682e33890727be82$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $682e33890727be82$var$_typeof(obj);
}
function $682e33890727be82$var$_extends() {
    $682e33890727be82$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $682e33890727be82$var$_extends.apply(this, arguments);
}
function $682e33890727be82$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $682e33890727be82$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $682e33890727be82$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $682e33890727be82$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $682e33890727be82$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $682e33890727be82$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $682e33890727be82$var$_setPrototypeOf(subClass, superClass);
}
function $682e33890727be82$var$_setPrototypeOf(o, p) {
    $682e33890727be82$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $682e33890727be82$var$_setPrototypeOf(o, p);
}
function $682e33890727be82$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $682e33890727be82$var$_isNativeReflectConstruct();
    return function() {
        var Super = $682e33890727be82$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $682e33890727be82$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $682e33890727be82$var$_possibleConstructorReturn(this, result);
    };
}
function $682e33890727be82$var$_possibleConstructorReturn(self, call) {
    if (call && ($682e33890727be82$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $682e33890727be82$var$_assertThisInitialized(self);
}
function $682e33890727be82$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $682e33890727be82$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $682e33890727be82$var$_getPrototypeOf(o) {
    $682e33890727be82$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $682e33890727be82$var$_getPrototypeOf(o);
}
function $682e33890727be82$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $682e33890727be82$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $682e33890727be82$var$ownKeys(Object(source), true).forEach(function(key) {
            $682e33890727be82$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $682e33890727be82$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $682e33890727be82$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $682e33890727be82$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--arc";
var $682e33890727be82$var$ATTRIBUTES = [
    "radius",
    "angle"
];
var $682e33890727be82$var$defaultProps = $682e33890727be82$var$_objectSpread($682e33890727be82$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).defaultProps), {}, {
    center: {
        x: 0,
        y: 0
    },
    arcClassName: "",
    className: "",
    style: {},
    padAngle: 0
});
/**
 * Prepare the internal representation of row for real use.
 * This is necessary because d3 insists on starting at 12 oclock and moving
 * clockwise, rather than starting at 3 oclock and moving counter clockwise
 * as one might expect from polar
 * @param {Object} row - coordinate object to be modifed
 * @return {Object} angle corrected object
 */ function $682e33890727be82$var$modifyRow(row) {
    var radius = row.radius, angle = row.angle, angle0 = row.angle0;
    var truedAngle = -1 * angle + Math.PI / 2;
    var truedAngle0 = -1 * angle0 + Math.PI / 2;
    return $682e33890727be82$var$_objectSpread($682e33890727be82$var$_objectSpread({}, row), {}, {
        x: radius * Math.cos(truedAngle),
        y: radius * Math.sin(truedAngle),
        angle: truedAngle,
        angle0: truedAngle0
    });
}
var $682e33890727be82$var$ArcSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $682e33890727be82$var$_inherits(ArcSeries, _AbstractSeries);
    var _super = $682e33890727be82$var$_createSuper(ArcSeries);
    function ArcSeries(props) {
        var _this;
        $682e33890727be82$var$_classCallCheck(this, ArcSeries);
        _this = _super.call(this, props);
        var scaleProps = _this._getAllScaleProps(props);
        _this.state = {
            scaleProps: scaleProps
        };
        return _this;
    }
    $682e33890727be82$var$_createClass(ArcSeries, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                this.setState({
                    scaleProps: this._getAllScaleProps(nextProps)
                });
            }
        },
        {
            key: "_getAllScaleProps",
            value: function _getAllScaleProps(props) {
                var defaultScaleProps = this._getDefaultScaleProps(props);
                var userScaleProps = (0, $379b4f4f942d44ab$export$9ba38978f16a5362)(props, $682e33890727be82$var$ATTRIBUTES);
                var missingScaleProps = (0, $379b4f4f942d44ab$export$6b25e8934069fbf5)($682e33890727be82$var$_objectSpread($682e33890727be82$var$_objectSpread({}, defaultScaleProps), userScaleProps), props.data, $682e33890727be82$var$ATTRIBUTES);
                return $682e33890727be82$var$_objectSpread($682e33890727be82$var$_objectSpread($682e33890727be82$var$_objectSpread({}, defaultScaleProps), userScaleProps), missingScaleProps);
            }
        },
        {
            key: "_getDefaultScaleProps",
            value: function _getDefaultScaleProps(props) {
                var innerWidth = props.innerWidth, innerHeight = props.innerHeight;
                var radius = Math.min(innerWidth / 2, innerHeight / 2);
                return {
                    radiusRange: [
                        0,
                        radius
                    ],
                    _radiusValue: radius,
                    angleType: "literal"
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, arcClassName = _this$props.arcClassName, animation = _this$props.animation, className = _this$props.className, center = _this$props.center, data = _this$props.data, disableSeries = _this$props.disableSeries, hideSeries = _this$props.hideSeries, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, padAngle = _this$props.padAngle, style = _this$props.style;
                if (!data) return null;
                if (animation) {
                    var cloneData = data.map(function(d) {
                        return $682e33890727be82$var$_objectSpread({}, d);
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                        className: "rv-xy-plot__series--arc__animation-wrapper"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $682e33890727be82$var$_extends({}, this.props, {
                        animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c),
                        data: cloneData
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ArcSeries, $682e33890727be82$var$_extends({}, this.props, {
                        animation: null,
                        disableSeries: true,
                        data: cloneData
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ArcSeries, $682e33890727be82$var$_extends({}, this.props, {
                        animation: null,
                        hideSeries: true,
                        style: {
                            stroke: "red"
                        }
                    })));
                }
                var scaleProps = this.state.scaleProps;
                var radiusDomain = scaleProps.radiusDomain; // need to generate our own functors as abstract series doesnt have anythign for us
                var radius = (0, $379b4f4f942d44ab$export$735c878afad94f32)(scaleProps, "radius");
                var radius0 = (0, $379b4f4f942d44ab$export$8b4d7b016ad3bc31)(scaleProps, "radius");
                var angle = (0, $379b4f4f942d44ab$export$735c878afad94f32)(scaleProps, "angle");
                var angle0 = (0, $379b4f4f942d44ab$export$8b4d7b016ad3bc31)(scaleProps, "angle"); // but it does have good color support!
                var fill = this._getAttributeFunctor("fill") || this._getAttributeFunctor("color");
                var stroke = this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color");
                var opacity = this._getAttributeFunctor("opacity");
                var x = this._getAttributeFunctor("x");
                var y = this._getAttributeFunctor("y");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($682e33890727be82$var$predefinedClassName, className),
                    onMouseOver: this._seriesMouseOverHandler,
                    onMouseOut: this._seriesMouseOutHandler,
                    onClick: this._seriesClickHandler,
                    onContextMenu: this._seriesRightClickHandler,
                    opacity: hideSeries ? 0 : 1,
                    pointerEvents: disableSeries ? "none" : "all",
                    transform: "translate(".concat(marginLeft + x(center), ",").concat(marginTop + y(center), ")")
                }, data.map(function(row, i) {
                    var noRadius = radiusDomain[1] === radiusDomain[0];
                    var arcArg = {
                        innerRadius: noRadius ? 0 : radius0(row),
                        outerRadius: radius(row),
                        startAngle: angle0(row) || 0,
                        endAngle: angle(row)
                    };
                    var arcedData = (0, $b196a0c5210e8c70$export$2e2bcd8739ae039)().padAngle(padAngle);
                    var rowStyle = row.style || {};
                    var rowClassName = row.className || "";
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                        key: "path-".concat(i),
                        style: $682e33890727be82$var$_objectSpread($682e33890727be82$var$_objectSpread({
                            opacity: opacity && opacity(row),
                            stroke: stroke && stroke(row),
                            fill: fill && fill(row)
                        }, style), rowStyle),
                        onClick: function onClick(e) {
                            return _this2._valueClickHandler($682e33890727be82$var$modifyRow(row), e);
                        },
                        onContextMenu: function onContextMenu(e) {
                            return _this2._valueRightClickHandler($682e33890727be82$var$modifyRow(row), e);
                        },
                        onMouseOver: function onMouseOver(e) {
                            return _this2._valueMouseOverHandler($682e33890727be82$var$modifyRow(row), e);
                        },
                        onMouseOut: function onMouseOut(e) {
                            return _this2._valueMouseOutHandler($682e33890727be82$var$modifyRow(row), e);
                        },
                        className: "".concat($682e33890727be82$var$predefinedClassName, "-path ").concat(arcClassName, " ").concat(rowClassName),
                        d: arcedData(arcArg)
                    });
                }));
            }
        }
    ]);
    return ArcSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$682e33890727be82$var$ArcSeries.propTypes = $682e33890727be82$var$_objectSpread($682e33890727be82$var$_objectSpread($682e33890727be82$var$_objectSpread($682e33890727be82$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), (0, $379b4f4f942d44ab$export$860d546dd4901970)("radius")), (0, $379b4f4f942d44ab$export$860d546dd4901970)("angle")), {}, {
    center: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    }),
    arcClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    padAngle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ])
});
$682e33890727be82$var$ArcSeries.defaultProps = $682e33890727be82$var$defaultProps;
$682e33890727be82$var$ArcSeries.displayName = "ArcSeries";
var $682e33890727be82$export$2e2bcd8739ae039 = $682e33890727be82$var$ArcSeries;



var $acw62 = parcelRequire("acw62");

var $917a97ee579c920c$exports = {};

$parcel$export($917a97ee579c920c$exports, "arc", () => $b196a0c5210e8c70$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "area", () => $b654034e6c52569c$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "line", () => $3fbda81220c6ea9c$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "pie", () => $b3395c44b48089b3$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "areaRadial", () => $593a6c9db6c01801$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "radialArea", () => $593a6c9db6c01801$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "lineRadial", () => $2a786db3fa594b9b$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "radialLine", () => $2a786db3fa594b9b$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "pointRadial", () => $8bd0ba086b92e84b$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "link", () => $3cf76165ec7f8ace$export$9c30223ca0a664fb);
$parcel$export($917a97ee579c920c$exports, "linkHorizontal", () => $3cf76165ec7f8ace$export$e7c381889b2cd14d);
$parcel$export($917a97ee579c920c$exports, "linkVertical", () => $3cf76165ec7f8ace$export$75de4c8c66884e04);
$parcel$export($917a97ee579c920c$exports, "linkRadial", () => $3cf76165ec7f8ace$export$7739cfe68d4e0799);
$parcel$export($917a97ee579c920c$exports, "symbol", () => $497fe223f0c7b3e8$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolsStroke", () => $497fe223f0c7b3e8$export$915e06de6acf8fe);
$parcel$export($917a97ee579c920c$exports, "symbolsFill", () => $497fe223f0c7b3e8$export$19158c96a6700c15);
$parcel$export($917a97ee579c920c$exports, "symbols", () => $497fe223f0c7b3e8$export$19158c96a6700c15);
$parcel$export($917a97ee579c920c$exports, "symbolAsterisk", () => $134055608cfdbbf1$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolCircle", () => $77cd44e2ac6dc1c2$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolCross", () => $6389eccbe795c95c$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolDiamond", () => $42af998bb354705d$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolDiamond2", () => $f2564dd3ed0020e5$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolPlus", () => $6eee48c5df32b70c$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolSquare", () => $1dda04e919c4f021$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolSquare2", () => $efaaae86227c5844$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolStar", () => $4ff326387f52757d$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolTriangle", () => $d45526fd1ffbd617$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolTriangle2", () => $70a1b9646572faf7$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolWye", () => $6b5c98530d683be5$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolTimes", () => $91f4a6205a1a3d92$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "symbolX", () => $91f4a6205a1a3d92$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveBasisClosed", () => $183ce554afe8c6f0$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveBasisOpen", () => $a34a32e088f640bf$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveBasis", () => $4fcc1327a5d07e55$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveBumpX", () => $bf3175dc82ec4a49$export$2c099b5096f70ce6);
$parcel$export($917a97ee579c920c$exports, "curveBumpY", () => $bf3175dc82ec4a49$export$908da9dfa54cbed6);
$parcel$export($917a97ee579c920c$exports, "curveBundle", () => $f6400194fd6a0bdb$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveCardinalClosed", () => $73ff40c99770ef6d$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveCardinalOpen", () => $a213115754da7990$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveCardinal", () => (parcelRequire("hga9n")).default);
$parcel$export($917a97ee579c920c$exports, "curveCatmullRomClosed", () => $f936d5ffcfb25824$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveCatmullRomOpen", () => $341349acb9991726$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveCatmullRom", () => (parcelRequire("6FEsA")).default);
$parcel$export($917a97ee579c920c$exports, "curveLinearClosed", () => $35e56ad4997e8f65$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveLinear", () => $c1e9e09d9174b864$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveMonotoneX", () => $cab75dc01e66b193$export$99563b5420dbdc55);
$parcel$export($917a97ee579c920c$exports, "curveMonotoneY", () => $cab75dc01e66b193$export$8b5360456d6bdb88);
$parcel$export($917a97ee579c920c$exports, "curveNatural", () => $ecaddebfc9069a1b$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveStep", () => $1262f1c88e9696b5$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "curveStepAfter", () => $1262f1c88e9696b5$export$793b3db073781cbb);
$parcel$export($917a97ee579c920c$exports, "curveStepBefore", () => $1262f1c88e9696b5$export$10eafa5b7478b343);
$parcel$export($917a97ee579c920c$exports, "stack", () => $73c272f50974b1c6$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOffsetExpand", () => $51565f53ec41433e$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOffsetDiverging", () => $d09434863b8b6e3d$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOffsetNone", () => $c64e8c12a3952a1f$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOffsetSilhouette", () => $95481d90954f4963$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOffsetWiggle", () => $ffb6de494d457d9e$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOrderAppearance", () => $e4e2d1e78c331793$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOrderAscending", () => $913764245d665e2c$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOrderDescending", () => $68d1e6105a476da6$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOrderInsideOut", () => $ce234225308b920e$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOrderNone", () => $6392d700c6254b89$export$2e2bcd8739ae039);
$parcel$export($917a97ee579c920c$exports, "stackOrderReverse", () => $ba9e5360bfebb59e$export$2e2bcd8739ae039);

var $b1edd492c2923d6f$export$58adb3bec8346d0f = Array.prototype.slice;
function $b1edd492c2923d6f$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}



function $c1e9e09d9174b864$var$Linear(context) {
    this._context = context;
}
$c1e9e09d9174b864$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $c1e9e09d9174b864$export$2e2bcd8739ae039(context) {
    return new $c1e9e09d9174b864$var$Linear(context);
}






function $ebec7ab58e49c436$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $ebec7ab58e49c436$export$4a5767248b18ef41(p) {
    return p[1];
}


function $3fbda81220c6ea9c$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(true), context = null, curve = (0, $c1e9e09d9174b864$export$2e2bcd8739ae039), output = null, path = (0, $5c3aa3aea2c844cf$export$fb6e83118a5dcd45)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $ebec7ab58e49c436$export$d141bba7fdc215a3) : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $ebec7ab58e49c436$export$4a5767248b18ef41) : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $b1edd492c2923d6f$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}




function $b654034e6c52569c$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(true), context = null, curve = (0, $c1e9e09d9174b864$export$2e2bcd8739ae039), output = null, path = (0, $5c3aa3aea2c844cf$export$fb6e83118a5dcd45)(area);
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $ebec7ab58e49c436$export$d141bba7fdc215a3) : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(0) : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $ebec7ab58e49c436$export$4a5767248b18ef41) : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $b1edd492c2923d6f$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $3fbda81220c6ea9c$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}





function $afcf5628442ed482$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $b802d97edd5fe3af$export$2e2bcd8739ae039(d) {
    return d;
}



var $kDiOX = parcelRequire("kDiOX");
function $b3395c44b48089b3$export$2e2bcd8739ae039() {
    var value = (0, $b802d97edd5fe3af$export$2e2bcd8739ae039), sortValues = (0, $afcf5628442ed482$export$2e2bcd8739ae039), sort = null, startAngle = (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(0), endAngle = (0, $59cb0344df9474fa$export$2e2bcd8739ae039)((0, $kDiOX.tau)), padAngle = (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(0);
    function pie(data) {
        var i, n = (data = (0, $b1edd492c2923d6f$export$2e2bcd8739ae039)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $kDiOX.tau), Math.max(-(0, $kDiOX.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), pie) : padAngle;
    };
    return pie;
}



var $da46f1219e1ec848$export$22d25ffb9fb15b6f = $da46f1219e1ec848$export$2e2bcd8739ae039((0, $c1e9e09d9174b864$export$2e2bcd8739ae039));
function $da46f1219e1ec848$var$Radial(curve) {
    this._curve = curve;
}
$da46f1219e1ec848$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $da46f1219e1ec848$export$2e2bcd8739ae039(curve) {
    function radial(context) {
        return new $da46f1219e1ec848$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}





function $2a786db3fa594b9b$export$4d8815a75dc8cd4d(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $da46f1219e1ec848$export$2e2bcd8739ae039)(_)) : c()._curve;
    };
    return l;
}
function $2a786db3fa594b9b$export$2e2bcd8739ae039() {
    return $2a786db3fa594b9b$export$4d8815a75dc8cd4d((0, $3fbda81220c6ea9c$export$2e2bcd8739ae039)().curve((0, $da46f1219e1ec848$export$22d25ffb9fb15b6f)));
}


function $593a6c9db6c01801$export$2e2bcd8739ae039() {
    var a = (0, $b654034e6c52569c$export$2e2bcd8739ae039)().curve((0, $da46f1219e1ec848$export$22d25ffb9fb15b6f)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $2a786db3fa594b9b$export$4d8815a75dc8cd4d)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $2a786db3fa594b9b$export$4d8815a75dc8cd4d)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $2a786db3fa594b9b$export$4d8815a75dc8cd4d)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $2a786db3fa594b9b$export$4d8815a75dc8cd4d)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $da46f1219e1ec848$export$2e2bcd8739ae039)(_)) : c()._curve;
    };
    return a;
}



function $8bd0ba086b92e84b$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}





class $bf3175dc82ec4a49$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $bf3175dc82ec4a49$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, $8bd0ba086b92e84b$export$2e2bcd8739ae039)(this._x0, this._y0);
            const p1 = (0, $8bd0ba086b92e84b$export$2e2bcd8739ae039)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $8bd0ba086b92e84b$export$2e2bcd8739ae039)(x, this._y0);
            const p3 = (0, $8bd0ba086b92e84b$export$2e2bcd8739ae039)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
}
function $bf3175dc82ec4a49$export$2c099b5096f70ce6(context) {
    return new $bf3175dc82ec4a49$var$Bump(context, true);
}
function $bf3175dc82ec4a49$export$908da9dfa54cbed6(context) {
    return new $bf3175dc82ec4a49$var$Bump(context, false);
}
function $bf3175dc82ec4a49$export$8c82a77a5061b331(context) {
    return new $bf3175dc82ec4a49$var$BumpRadial(context);
}




function $3cf76165ec7f8ace$var$linkSource(d) {
    return d.source;
}
function $3cf76165ec7f8ace$var$linkTarget(d) {
    return d.target;
}
function $3cf76165ec7f8ace$export$9c30223ca0a664fb(curve) {
    let source = $3cf76165ec7f8ace$var$linkSource, target = $3cf76165ec7f8ace$var$linkTarget, x = (0, $ebec7ab58e49c436$export$d141bba7fdc215a3), y = (0, $ebec7ab58e49c436$export$4a5767248b18ef41), context = null, output = null, path = (0, $5c3aa3aea2c844cf$export$fb6e83118a5dcd45)(link);
    function link() {
        let buffer;
        const argv = (0, $b1edd492c2923d6f$export$58adb3bec8346d0f).call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = path());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $3cf76165ec7f8ace$export$e7c381889b2cd14d() {
    return $3cf76165ec7f8ace$export$9c30223ca0a664fb((0, $bf3175dc82ec4a49$export$2c099b5096f70ce6));
}
function $3cf76165ec7f8ace$export$75de4c8c66884e04() {
    return $3cf76165ec7f8ace$export$9c30223ca0a664fb((0, $bf3175dc82ec4a49$export$908da9dfa54cbed6));
}
function $3cf76165ec7f8ace$export$7739cfe68d4e0799() {
    const l = $3cf76165ec7f8ace$export$9c30223ca0a664fb((0, $bf3175dc82ec4a49$export$8c82a77a5061b331));
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}





var $kDiOX = parcelRequire("kDiOX");
const $134055608cfdbbf1$var$sqrt3 = (0, $kDiOX.sqrt)(3);
var $134055608cfdbbf1$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size + (0, $kDiOX.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $134055608cfdbbf1$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};



var $kDiOX = parcelRequire("kDiOX");
var $77cd44e2ac6dc1c2$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size / (0, $kDiOX.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $kDiOX.tau));
    }
};



var $kDiOX = parcelRequire("kDiOX");
var $6389eccbe795c95c$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
const $42af998bb354705d$var$tan30 = (0, $kDiOX.sqrt)(1 / 3);
const $42af998bb354705d$var$tan30_2 = $42af998bb354705d$var$tan30 * 2;
var $42af998bb354705d$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = (0, $kDiOX.sqrt)(size / $42af998bb354705d$var$tan30_2);
        const x = y * $42af998bb354705d$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
var $f2564dd3ed0020e5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
var $6eee48c5df32b70c$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size - (0, $kDiOX.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};



var $kDiOX = parcelRequire("kDiOX");
var $1dda04e919c4f021$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const w = (0, $kDiOX.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};



var $kDiOX = parcelRequire("kDiOX");
var $efaaae86227c5844$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
const $4ff326387f52757d$var$ka = 0.89081309152928522810;
const $4ff326387f52757d$var$kr = (0, $kDiOX.sin)((0, $kDiOX.pi) / 10) / (0, $kDiOX.sin)(7 * (0, $kDiOX.pi) / 10);
const $4ff326387f52757d$var$kx = (0, $kDiOX.sin)((0, $kDiOX.tau) / 10) * $4ff326387f52757d$var$kr;
const $4ff326387f52757d$var$ky = -(0, $kDiOX.cos)((0, $kDiOX.tau) / 10) * $4ff326387f52757d$var$kr;
var $4ff326387f52757d$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size * $4ff326387f52757d$var$ka);
        const x = $4ff326387f52757d$var$kx * r;
        const y = $4ff326387f52757d$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, $kDiOX.tau) * i / 5;
            const c = (0, $kDiOX.cos)(a);
            const s = (0, $kDiOX.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
const $d45526fd1ffbd617$var$sqrt3 = (0, $kDiOX.sqrt)(3);
var $d45526fd1ffbd617$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = -(0, $kDiOX.sqrt)(size / ($d45526fd1ffbd617$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$d45526fd1ffbd617$var$sqrt3 * y, -y);
        context.lineTo($d45526fd1ffbd617$var$sqrt3 * y, -y);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
const $70a1b9646572faf7$var$sqrt3 = (0, $kDiOX.sqrt)(3);
var $70a1b9646572faf7$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const s = (0, $kDiOX.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $70a1b9646572faf7$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
const $6b5c98530d683be5$var$c = -0.5;
const $6b5c98530d683be5$var$s = (0, $kDiOX.sqrt)(3) / 2;
const $6b5c98530d683be5$var$k = 1 / (0, $kDiOX.sqrt)(12);
const $6b5c98530d683be5$var$a = ($6b5c98530d683be5$var$k / 2 + 1) * 3;
var $6b5c98530d683be5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size / $6b5c98530d683be5$var$a);
        const x0 = r / 2, y0 = r * $6b5c98530d683be5$var$k;
        const x1 = x0, y1 = r * $6b5c98530d683be5$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($6b5c98530d683be5$var$c * x0 - $6b5c98530d683be5$var$s * y0, $6b5c98530d683be5$var$s * x0 + $6b5c98530d683be5$var$c * y0);
        context.lineTo($6b5c98530d683be5$var$c * x1 - $6b5c98530d683be5$var$s * y1, $6b5c98530d683be5$var$s * x1 + $6b5c98530d683be5$var$c * y1);
        context.lineTo($6b5c98530d683be5$var$c * x2 - $6b5c98530d683be5$var$s * y2, $6b5c98530d683be5$var$s * x2 + $6b5c98530d683be5$var$c * y2);
        context.lineTo($6b5c98530d683be5$var$c * x0 + $6b5c98530d683be5$var$s * y0, $6b5c98530d683be5$var$c * y0 - $6b5c98530d683be5$var$s * x0);
        context.lineTo($6b5c98530d683be5$var$c * x1 + $6b5c98530d683be5$var$s * y1, $6b5c98530d683be5$var$c * y1 - $6b5c98530d683be5$var$s * x1);
        context.lineTo($6b5c98530d683be5$var$c * x2 + $6b5c98530d683be5$var$s * y2, $6b5c98530d683be5$var$c * y2 - $6b5c98530d683be5$var$s * x2);
        context.closePath();
    }
};



var $kDiOX = parcelRequire("kDiOX");
var $91f4a6205a1a3d92$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $kDiOX.sqrt)(size - (0, $kDiOX.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};


const $497fe223f0c7b3e8$export$19158c96a6700c15 = [
    (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039),
    (0, $6389eccbe795c95c$export$2e2bcd8739ae039),
    (0, $42af998bb354705d$export$2e2bcd8739ae039),
    (0, $1dda04e919c4f021$export$2e2bcd8739ae039),
    (0, $4ff326387f52757d$export$2e2bcd8739ae039),
    (0, $d45526fd1ffbd617$export$2e2bcd8739ae039),
    (0, $6b5c98530d683be5$export$2e2bcd8739ae039)
];
const $497fe223f0c7b3e8$export$915e06de6acf8fe = [
    (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039),
    (0, $6eee48c5df32b70c$export$2e2bcd8739ae039),
    (0, $91f4a6205a1a3d92$export$2e2bcd8739ae039),
    (0, $70a1b9646572faf7$export$2e2bcd8739ae039),
    (0, $134055608cfdbbf1$export$2e2bcd8739ae039),
    (0, $efaaae86227c5844$export$2e2bcd8739ae039),
    (0, $f2564dd3ed0020e5$export$2e2bcd8739ae039)
];
function $497fe223f0c7b3e8$export$2e2bcd8739ae039(type, size) {
    let context = null, path = (0, $5c3aa3aea2c844cf$export$fb6e83118a5dcd45)(symbol);
    type = typeof type === "function" ? type : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(type || (0, $77cd44e2ac6dc1c2$export$2e2bcd8739ae039));
    size = typeof size === "function" ? size : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}















function $72ccadd7b0a5f010$export$2e2bcd8739ae039() {}


function $4fcc1327a5d07e55$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $4fcc1327a5d07e55$export$957f7263e89bedd2(context) {
    this._context = context;
}
$4fcc1327a5d07e55$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $4fcc1327a5d07e55$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $4fcc1327a5d07e55$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $4fcc1327a5d07e55$export$2e2bcd8739ae039(context) {
    return new $4fcc1327a5d07e55$export$957f7263e89bedd2(context);
}


function $183ce554afe8c6f0$var$BasisClosed(context) {
    this._context = context;
}
$183ce554afe8c6f0$var$BasisClosed.prototype = {
    areaStart: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    areaEnd: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $4fcc1327a5d07e55$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $183ce554afe8c6f0$export$2e2bcd8739ae039(context) {
    return new $183ce554afe8c6f0$var$BasisClosed(context);
}



function $a34a32e088f640bf$var$BasisOpen(context) {
    this._context = context;
}
$a34a32e088f640bf$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $4fcc1327a5d07e55$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $a34a32e088f640bf$export$2e2bcd8739ae039(context) {
    return new $a34a32e088f640bf$var$BasisOpen(context);
}





function $f6400194fd6a0bdb$var$Bundle(context, beta) {
    this._basis = new (0, $4fcc1327a5d07e55$export$957f7263e89bedd2)(context);
    this._beta = beta;
}
$f6400194fd6a0bdb$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $f6400194fd6a0bdb$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $4fcc1327a5d07e55$export$957f7263e89bedd2)(context) : new $f6400194fd6a0bdb$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);




var $hga9n = parcelRequire("hga9n");
function $73ff40c99770ef6d$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$73ff40c99770ef6d$export$da3940d7e9162858.prototype = {
    areaStart: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    areaEnd: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $hga9n.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $73ff40c99770ef6d$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $73ff40c99770ef6d$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);



var $hga9n = parcelRequire("hga9n");
function $a213115754da7990$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$a213115754da7990$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $hga9n.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a213115754da7990$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $a213115754da7990$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);



var $hga9n = parcelRequire("hga9n");



var $6FEsA = parcelRequire("6FEsA");
function $f936d5ffcfb25824$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$f936d5ffcfb25824$var$CatmullRomClosed.prototype = {
    areaStart: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    areaEnd: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $6FEsA.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f936d5ffcfb25824$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $f936d5ffcfb25824$var$CatmullRomClosed(context, alpha) : new (0, $73ff40c99770ef6d$export$da3940d7e9162858)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);




var $6FEsA = parcelRequire("6FEsA");
function $341349acb9991726$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$341349acb9991726$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $6FEsA.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $341349acb9991726$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $341349acb9991726$var$CatmullRomOpen(context, alpha) : new (0, $a213115754da7990$export$cd7d1a617282f2f1)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);



var $6FEsA = parcelRequire("6FEsA");

function $35e56ad4997e8f65$var$LinearClosed(context) {
    this._context = context;
}
$35e56ad4997e8f65$var$LinearClosed.prototype = {
    areaStart: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    areaEnd: (0, $72ccadd7b0a5f010$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $35e56ad4997e8f65$export$2e2bcd8739ae039(context) {
    return new $35e56ad4997e8f65$var$LinearClosed(context);
}



function $cab75dc01e66b193$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $cab75dc01e66b193$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($cab75dc01e66b193$var$sign(s0) + $cab75dc01e66b193$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $cab75dc01e66b193$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $cab75dc01e66b193$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $cab75dc01e66b193$var$MonotoneX(context) {
    this._context = context;
}
$cab75dc01e66b193$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $cab75dc01e66b193$var$point(this, this._t0, $cab75dc01e66b193$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $cab75dc01e66b193$var$point(this, $cab75dc01e66b193$var$slope2(this, t1 = $cab75dc01e66b193$var$slope3(this, x, y)), t1);
                break;
            default:
                $cab75dc01e66b193$var$point(this, this._t0, t1 = $cab75dc01e66b193$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $cab75dc01e66b193$var$MonotoneY(context) {
    this._context = new $cab75dc01e66b193$var$ReflectContext(context);
}
($cab75dc01e66b193$var$MonotoneY.prototype = Object.create($cab75dc01e66b193$var$MonotoneX.prototype)).point = function(x, y) {
    $cab75dc01e66b193$var$MonotoneX.prototype.point.call(this, y, x);
};
function $cab75dc01e66b193$var$ReflectContext(context) {
    this._context = context;
}
$cab75dc01e66b193$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $cab75dc01e66b193$export$99563b5420dbdc55(context) {
    return new $cab75dc01e66b193$var$MonotoneX(context);
}
function $cab75dc01e66b193$export$8b5360456d6bdb88(context) {
    return new $cab75dc01e66b193$var$MonotoneY(context);
}


function $ecaddebfc9069a1b$var$Natural(context) {
    this._context = context;
}
$ecaddebfc9069a1b$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $ecaddebfc9069a1b$var$controlPoints(x), py = $ecaddebfc9069a1b$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $ecaddebfc9069a1b$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $ecaddebfc9069a1b$export$2e2bcd8739ae039(context) {
    return new $ecaddebfc9069a1b$var$Natural(context);
}


function $1262f1c88e9696b5$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$1262f1c88e9696b5$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $1262f1c88e9696b5$export$2e2bcd8739ae039(context) {
    return new $1262f1c88e9696b5$var$Step(context, 0.5);
}
function $1262f1c88e9696b5$export$10eafa5b7478b343(context) {
    return new $1262f1c88e9696b5$var$Step(context, 0);
}
function $1262f1c88e9696b5$export$793b3db073781cbb(context) {
    return new $1262f1c88e9696b5$var$Step(context, 1);
}




function $c64e8c12a3952a1f$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $6392d700c6254b89$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $73c272f50974b1c6$var$stackValue(d, key) {
    return d[key];
}
function $73c272f50974b1c6$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $73c272f50974b1c6$export$2e2bcd8739ae039() {
    var keys = (0, $59cb0344df9474fa$export$2e2bcd8739ae039)([]), order = (0, $6392d700c6254b89$export$2e2bcd8739ae039), offset = (0, $c64e8c12a3952a1f$export$2e2bcd8739ae039), value = $73c272f50974b1c6$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $73c272f50974b1c6$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $b1edd492c2923d6f$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $6392d700c6254b89$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $59cb0344df9474fa$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $c64e8c12a3952a1f$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}



function $51565f53ec41433e$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $c64e8c12a3952a1f$export$2e2bcd8739ae039)(series, order);
}


function $d09434863b8b6e3d$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}




function $95481d90954f4963$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $c64e8c12a3952a1f$export$2e2bcd8739ae039)(series, order);
}



function $ffb6de494d457d9e$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $c64e8c12a3952a1f$export$2e2bcd8739ae039)(series, order);
}



function $e4e2d1e78c331793$export$2e2bcd8739ae039(series) {
    var peaks = series.map($e4e2d1e78c331793$var$peak);
    return (0, $6392d700c6254b89$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $e4e2d1e78c331793$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}



function $913764245d665e2c$export$2e2bcd8739ae039(series) {
    var sums = series.map($913764245d665e2c$export$8a63f25cc62965f1);
    return (0, $6392d700c6254b89$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $913764245d665e2c$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}



function $68d1e6105a476da6$export$2e2bcd8739ae039(series) {
    return (0, $913764245d665e2c$export$2e2bcd8739ae039)(series).reverse();
}




function $ce234225308b920e$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $913764245d665e2c$export$8a63f25cc62965f1)), order = (0, $e4e2d1e78c331793$export$2e2bcd8739ae039)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}




function $ba9e5360bfebb59e$export$2e2bcd8739ae039(series) {
    return (0, $6392d700c6254b89$export$2e2bcd8739ae039)(series).reverse();
}










function $1c0fc38ce5208a3b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1c0fc38ce5208a3b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1c0fc38ce5208a3b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1c0fc38ce5208a3b$var$_typeof(obj);
}
function $1c0fc38ce5208a3b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c0fc38ce5208a3b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1c0fc38ce5208a3b$var$ownKeys(Object(source), true).forEach(function(key) {
            $1c0fc38ce5208a3b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1c0fc38ce5208a3b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1c0fc38ce5208a3b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1c0fc38ce5208a3b$var$_extends() {
    $1c0fc38ce5208a3b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c0fc38ce5208a3b$var$_extends.apply(this, arguments);
}
function $1c0fc38ce5208a3b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1c0fc38ce5208a3b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1c0fc38ce5208a3b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1c0fc38ce5208a3b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1c0fc38ce5208a3b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1c0fc38ce5208a3b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1c0fc38ce5208a3b$var$_setPrototypeOf(subClass, superClass);
}
function $1c0fc38ce5208a3b$var$_setPrototypeOf(o, p) {
    $1c0fc38ce5208a3b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1c0fc38ce5208a3b$var$_setPrototypeOf(o, p);
}
function $1c0fc38ce5208a3b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1c0fc38ce5208a3b$var$_isNativeReflectConstruct();
    return function() {
        var Super = $1c0fc38ce5208a3b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1c0fc38ce5208a3b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1c0fc38ce5208a3b$var$_possibleConstructorReturn(this, result);
    };
}
function $1c0fc38ce5208a3b$var$_possibleConstructorReturn(self, call) {
    if (call && ($1c0fc38ce5208a3b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1c0fc38ce5208a3b$var$_assertThisInitialized(self);
}
function $1c0fc38ce5208a3b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1c0fc38ce5208a3b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1c0fc38ce5208a3b$var$_getPrototypeOf(o) {
    $1c0fc38ce5208a3b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1c0fc38ce5208a3b$var$_getPrototypeOf(o);
}
var $1c0fc38ce5208a3b$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--line";
var $1c0fc38ce5208a3b$var$AreaSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $1c0fc38ce5208a3b$var$_inherits(AreaSeries, _AbstractSeries);
    var _super = $1c0fc38ce5208a3b$var$_createSuper(AreaSeries);
    function AreaSeries() {
        $1c0fc38ce5208a3b$var$_classCallCheck(this, AreaSeries);
        return _super.apply(this, arguments);
    }
    $1c0fc38ce5208a3b$var$_createClass(AreaSeries, [
        {
            key: "_renderArea",
            value: function _renderArea(data, x, y0, y, curve, getNull) {
                var area = $917a97ee579c920c$exports.area();
                if (curve !== null) {
                    if (typeof curve === "string" && $917a97ee579c920c$exports[curve]) area = area.curve($917a97ee579c920c$exports[curve]);
                    else if (typeof curve === "function") area = area.curve(curve);
                }
                area = area.defined(getNull);
                area = area.x(x).y0(y0).y1(y);
                return area(data);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, animation = _this$props.animation, className = _this$props.className, curve = _this$props.curve, data = _this$props.data, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, style = _this$props.style;
                if (this.props.nullAccessor) (0, $ddc583f274f25523$export$491112666e282270)("nullAccessor has been renamed to getNull", true);
                if (!data) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $1c0fc38ce5208a3b$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(AreaSeries, $1c0fc38ce5208a3b$var$_extends({}, this.props, {
                    animation: null
                })));
                var x = this._getAttributeFunctor("x");
                var y = this._getAttributeFunctor("y");
                var y0 = this._getAttr0Functor("y");
                var stroke = this._getAttributeValue("stroke") || this._getAttributeValue("color");
                var fill = this._getAttributeValue("fill") || this._getAttributeValue("color");
                var newOpacity = this._getAttributeValue("opacity");
                var opacity = Number.isFinite(newOpacity) ? newOpacity : (0, $d629c93f7b094ef1$export$95a809b606e7af75);
                var getNull = this.props.nullAccessor || this.props.getNull;
                var d = this._renderArea(data, x, y0, y, curve, getNull);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                    d: d,
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($1c0fc38ce5208a3b$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")"),
                    onMouseOver: this._seriesMouseOverHandler,
                    onMouseOut: this._seriesMouseOutHandler,
                    onClick: this._seriesClickHandler,
                    onContextMenu: this._seriesRightClickHandler,
                    style: $1c0fc38ce5208a3b$var$_objectSpread({
                        opacity: opacity,
                        stroke: stroke,
                        fill: fill
                    }, style)
                });
            }
        }
    ]);
    return AreaSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$1c0fc38ce5208a3b$var$AreaSeries.displayName = "AreaSeries";
$1c0fc38ce5208a3b$var$AreaSeries.propTypes = $1c0fc38ce5208a3b$var$_objectSpread($1c0fc38ce5208a3b$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
    getNull: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
});
$1c0fc38ce5208a3b$var$AreaSeries.defaultProps = $1c0fc38ce5208a3b$var$_objectSpread($1c0fc38ce5208a3b$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).defaultProps), {}, {
    getNull: function getNull() {
        return true;
    }
});
var $1c0fc38ce5208a3b$export$2e2bcd8739ae039 = $1c0fc38ce5208a3b$var$AreaSeries;



var $acw62 = parcelRequire("acw62");


function $3e02f9c933bbff1a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3e02f9c933bbff1a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3e02f9c933bbff1a$var$ownKeys(Object(source), true).forEach(function(key) {
            $3e02f9c933bbff1a$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3e02f9c933bbff1a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3e02f9c933bbff1a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3e02f9c933bbff1a$var$propTypes = {
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        left: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        right: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        top: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    }),
    // supplied by xyplot
    marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginBottom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginRight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    innerWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    innerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
};
var $3e02f9c933bbff1a$var$CLASSES = {
    bottom: "rv-xy-plot__borders-bottom",
    container: "rv-xy-plot__borders",
    left: "rv-xy-plot__borders-left",
    right: "rv-xy-plot__borders-right",
    top: "rv-xy-plot__borders-top"
};
function $3e02f9c933bbff1a$var$Borders(props) {
    var marginTop = props.marginTop, marginBottom = props.marginBottom, marginLeft = props.marginLeft, marginRight = props.marginRight, innerWidth = props.innerWidth, innerHeight = props.innerHeight, style = props.style, className = props.className;
    var height = innerHeight + marginTop + marginBottom;
    var width = innerWidth + marginLeft + marginRight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($3e02f9c933bbff1a$var$CLASSES.container, className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($3e02f9c933bbff1a$var$CLASSES.bottom, "".concat(className, "-bottom")),
        style: $3e02f9c933bbff1a$var$_objectSpread($3e02f9c933bbff1a$var$_objectSpread({}, style.all), style.bottom),
        x: 0,
        y: height - marginBottom,
        width: width,
        height: marginBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($3e02f9c933bbff1a$var$CLASSES.left, "".concat(className, "-left")),
        style: $3e02f9c933bbff1a$var$_objectSpread($3e02f9c933bbff1a$var$_objectSpread({}, style.all), style.left),
        x: 0,
        y: 0,
        width: marginLeft,
        height: height
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($3e02f9c933bbff1a$var$CLASSES.right, "".concat(className, "-right")),
        style: $3e02f9c933bbff1a$var$_objectSpread($3e02f9c933bbff1a$var$_objectSpread({}, style.all), style.right),
        x: width - marginRight,
        y: 0,
        width: marginRight,
        height: height
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($3e02f9c933bbff1a$var$CLASSES.top, "".concat(className, "-top")),
        style: $3e02f9c933bbff1a$var$_objectSpread($3e02f9c933bbff1a$var$_objectSpread({}, style.all), style.top),
        x: 0,
        y: 0,
        width: width,
        height: marginTop
    }));
}
$3e02f9c933bbff1a$var$Borders.displayName = "Borders";
$3e02f9c933bbff1a$var$Borders.defaultProps = {
    className: "",
    style: {
        all: {},
        bottom: {},
        left: {},
        right: {},
        top: {}
    }
};
$3e02f9c933bbff1a$var$Borders.propTypes = $3e02f9c933bbff1a$var$propTypes;
$3e02f9c933bbff1a$var$Borders.requiresSVG = true;
var $3e02f9c933bbff1a$export$2e2bcd8739ae039 = $3e02f9c933bbff1a$var$Borders;



var $acw62 = parcelRequire("acw62");


function $2a176d9687299751$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2a176d9687299751$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2a176d9687299751$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2a176d9687299751$var$_typeof(obj);
}
function $2a176d9687299751$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2a176d9687299751$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2a176d9687299751$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2a176d9687299751$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2a176d9687299751$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2a176d9687299751$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $2a176d9687299751$var$_setPrototypeOf(subClass, superClass);
}
function $2a176d9687299751$var$_setPrototypeOf(o, p) {
    $2a176d9687299751$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2a176d9687299751$var$_setPrototypeOf(o, p);
}
function $2a176d9687299751$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2a176d9687299751$var$_isNativeReflectConstruct();
    return function() {
        var Super = $2a176d9687299751$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2a176d9687299751$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2a176d9687299751$var$_possibleConstructorReturn(this, result);
    };
}
function $2a176d9687299751$var$_possibleConstructorReturn(self, call) {
    if (call && ($2a176d9687299751$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $2a176d9687299751$var$_assertThisInitialized(self);
}
function $2a176d9687299751$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2a176d9687299751$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2a176d9687299751$var$_getPrototypeOf(o) {
    $2a176d9687299751$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2a176d9687299751$var$_getPrototypeOf(o);
}
var $2a176d9687299751$var$ChartLabel = /*#__PURE__*/ function(_React$PureComponent) {
    $2a176d9687299751$var$_inherits(ChartLabel, _React$PureComponent);
    var _super = $2a176d9687299751$var$_createSuper(ChartLabel);
    function ChartLabel() {
        $2a176d9687299751$var$_classCallCheck(this, ChartLabel);
        return _super.apply(this, arguments);
    }
    $2a176d9687299751$var$_createClass(ChartLabel, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, innerHeight = _this$props.innerHeight, innerWidth = _this$props.innerWidth, marginBottom = _this$props.marginBottom, marginLeft = _this$props.marginLeft, marginRight = _this$props.marginRight, marginTop = _this$props.marginTop, className = _this$props.className, includeMargin = _this$props.includeMargin, style = _this$props.style, text = _this$props.text, xPercent = _this$props.xPercent, yPercent = _this$props.yPercent;
                var width = innerWidth + (includeMargin ? marginLeft + marginRight : 0);
                var height = innerHeight + (includeMargin ? marginTop + marginBottom : 0);
                var xPos = width * xPercent + (includeMargin ? 0 : marginLeft);
                var yPos = height * yPercent + (includeMargin ? marginTop : 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    transform: "translate(".concat(xPos, ", ").concat(yPos, ")"),
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-xy-plot__axis__title", className)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", style, text));
            }
        }
    ], [
        {
            key: "requiresSVG",
            get: function get() {
                return true;
            }
        }
    ]);
    return ChartLabel;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent);
$2a176d9687299751$var$ChartLabel.displayName = "ChartLabel";
$2a176d9687299751$var$ChartLabel.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    includeMargin: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    xPercent: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    yPercent: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
$2a176d9687299751$var$ChartLabel.defaultProps = {
    className: "",
    includeMargin: true,
    text: "",
    xPercent: 0,
    yPercent: 0,
    style: {}
};
var $2a176d9687299751$export$2e2bcd8739ae039 = $2a176d9687299751$var$ChartLabel;



var $acw62 = parcelRequire("acw62");



// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.


var $16d91db751e2a422$export$7423c88bc54edb74 = {
    TOP: "top",
    LEFT: "left",
    RIGHT: "right",
    BOTTOM: "bottom",
    VERTICAL: "vertical",
    HORIZONTAL: "horizontal"
};
var $16d91db751e2a422$export$9106728c49045482 = {
    VERTICAL: "vertical",
    HORIZONTAL: "horizontal"
};
function $16d91db751e2a422$export$8d2671251b7b6f75(size) {
    if (size < 700) {
        if (size > 300) return 10;
        return 5;
    }
    return 20;
}
function $16d91db751e2a422$export$4cc7a216492b1f53(scale, tickTotal, tickValues) {
    return !tickValues ? scale.ticks ? scale.ticks(tickTotal) : scale.domain() : tickValues;
}
function $16d91db751e2a422$export$58141da123cff63f(axisStart, axisEnd) {
    // address the special case when the slope is infinite
    if (axisStart.x === axisEnd.x) return {
        left: axisStart.y,
        right: axisEnd.y,
        slope: 0,
        offset: axisStart.x
    };
    var slope = (axisStart.y - axisEnd.y) / (axisStart.x - axisEnd.x);
    return {
        left: axisStart.x,
        right: axisEnd.x,
        // generate the linear projection of the axis direction
        slope: slope,
        offset: axisStart.y - slope * axisStart.x
    };
}
function $16d91db751e2a422$export$a4274e8b1679c276(_ref) {
    var axisStart = _ref.axisStart, axisEnd = _ref.axisEnd, numberOfTicks = _ref.numberOfTicks, axisDomain = _ref.axisDomain;
    var _generateFit = $16d91db751e2a422$export$58141da123cff63f(axisStart, axisEnd), left = _generateFit.left, right = _generateFit.right, slope = _generateFit.slope, offset = _generateFit.offset; // construct a linear band of points, then map them
    var pointSlope = (right - left) / numberOfTicks;
    var axisScale = (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)().domain([
        left,
        right
    ]).range(axisDomain);
    var slopeVertical = axisStart.x === axisEnd.x;
    return {
        slope: slopeVertical ? Infinity : slope,
        points: (0, $61d27a61db04c1a6$export$2e2bcd8739ae039)(left, right + pointSlope, pointSlope).map(function(val) {
            if (slopeVertical) return {
                y: val,
                x: slope * val + offset,
                text: axisScale(val)
            };
            return {
                x: val,
                y: slope * val + offset,
                text: axisScale(val)
            };
        }).slice(0, numberOfTicks + 1)
    };
}
function $16d91db751e2a422$export$3f70be5e7d7dc51(axisStart, axisEnd) {
    if (axisStart.x === axisEnd.x) return axisEnd.y > axisStart.y ? Math.PI / 2 : 3 * Math.PI / 2;
    return Math.atan((axisEnd.y - axisStart.y) / (axisEnd.x - axisStart.x));
}
var $16d91db751e2a422$export$2e2bcd8739ae039 = {
    DIRECTION: $16d91db751e2a422$export$9106728c49045482,
    ORIENTATION: $16d91db751e2a422$export$7423c88bc54edb74,
    getTicksTotalFromSize: $16d91db751e2a422$export$8d2671251b7b6f75,
    getTickValues: $16d91db751e2a422$export$4cc7a216492b1f53
};


function $70a357baeafe15d9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $70a357baeafe15d9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $70a357baeafe15d9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $70a357baeafe15d9$var$_typeof(obj);
}
function $70a357baeafe15d9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $70a357baeafe15d9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $70a357baeafe15d9$var$ownKeys(Object(source), true).forEach(function(key) {
            $70a357baeafe15d9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $70a357baeafe15d9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $70a357baeafe15d9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $70a357baeafe15d9$var$_extends() {
    $70a357baeafe15d9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70a357baeafe15d9$var$_extends.apply(this, arguments);
}
function $70a357baeafe15d9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $70a357baeafe15d9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $70a357baeafe15d9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $70a357baeafe15d9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $70a357baeafe15d9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $70a357baeafe15d9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $70a357baeafe15d9$var$_setPrototypeOf(subClass, superClass);
}
function $70a357baeafe15d9$var$_setPrototypeOf(o, p) {
    $70a357baeafe15d9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $70a357baeafe15d9$var$_setPrototypeOf(o, p);
}
function $70a357baeafe15d9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $70a357baeafe15d9$var$_isNativeReflectConstruct();
    return function() {
        var Super = $70a357baeafe15d9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $70a357baeafe15d9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $70a357baeafe15d9$var$_possibleConstructorReturn(this, result);
    };
}
function $70a357baeafe15d9$var$_possibleConstructorReturn(self, call) {
    if (call && ($70a357baeafe15d9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $70a357baeafe15d9$var$_assertThisInitialized(self);
}
function $70a357baeafe15d9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $70a357baeafe15d9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $70a357baeafe15d9$var$_getPrototypeOf(o) {
    $70a357baeafe15d9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $70a357baeafe15d9$var$_getPrototypeOf(o);
}
var $70a357baeafe15d9$var$animatedProps = [
    "xRange",
    "yRange",
    "xDomain",
    "yDomain",
    "width",
    "height",
    "marginLeft",
    "marginTop",
    "marginRight",
    "marginBottom",
    "tickTotal"
];
var $70a357baeafe15d9$var$CircularGridLines = /*#__PURE__*/ function(_PureComponent) {
    $70a357baeafe15d9$var$_inherits(CircularGridLines, _PureComponent);
    var _super = $70a357baeafe15d9$var$_createSuper(CircularGridLines);
    function CircularGridLines() {
        $70a357baeafe15d9$var$_classCallCheck(this, CircularGridLines);
        return _super.apply(this, arguments);
    }
    $70a357baeafe15d9$var$_createClass(CircularGridLines, [
        {
            key: "_getDefaultProps",
            value: function _getDefaultProps() {
                var _this$props = this.props, innerWidth = _this$props.innerWidth, innerHeight = _this$props.innerHeight, marginTop = _this$props.marginTop, marginLeft = _this$props.marginLeft;
                return {
                    left: marginLeft,
                    top: marginTop,
                    width: innerWidth,
                    height: innerHeight,
                    style: {},
                    tickTotal: (0, $16d91db751e2a422$export$8d2671251b7b6f75)(Math.min(innerWidth, innerHeight))
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, animation = _this$props2.animation, centerX = _this$props2.centerX, centerY = _this$props2.centerY;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $70a357baeafe15d9$var$_extends({}, this.props, {
                    animatedProps: $70a357baeafe15d9$var$animatedProps
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CircularGridLines, $70a357baeafe15d9$var$_extends({}, this.props, {
                    animation: null
                })));
                var props = $70a357baeafe15d9$var$_objectSpread($70a357baeafe15d9$var$_objectSpread({}, this._getDefaultProps()), this.props);
                var tickTotal = props.tickTotal, tickValues = props.tickValues, marginLeft = props.marginLeft, marginTop = props.marginTop, rRange = props.rRange, style = props.style;
                var xScale = (0, $379b4f4f942d44ab$export$cb87eff04da17d9)(props, "x");
                var yScale = (0, $379b4f4f942d44ab$export$cb87eff04da17d9)(props, "y");
                var values = (0, $16d91db751e2a422$export$4cc7a216492b1f53)(xScale, tickTotal, tickValues);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    transform: "translate(".concat(xScale(centerX) + marginLeft, ",").concat(yScale(centerY) + marginTop, ")"),
                    className: "rv-xy-plot__circular-grid-lines"
                }, values.reduce(function(res, value, index) {
                    var radius = xScale(value);
                    if (rRange && (radius < rRange[0] || radius > rRange[1])) return res;
                    return res.concat([
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", $70a357baeafe15d9$var$_extends({
                            cx: 0,
                            cy: 0,
                            r: radius
                        }, {
                            key: index,
                            className: "rv-xy-plot__circular-grid-lines__line",
                            style: style
                        }))
                    ]);
                }, []));
            }
        }
    ]);
    return CircularGridLines;
}((0, $acw62.PureComponent));
$70a357baeafe15d9$var$CircularGridLines.displayName = "CircularGridLines";
$70a357baeafe15d9$var$CircularGridLines.propTypes = {
    centerX: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    centerY: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    top: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    rRange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    tickValues: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number),
    tickTotal: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    animation: (0, $d4808d8f8c60755d$export$c6290f21adf0a17a),
    // generally supplied by xyplot
    marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginBottom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginRight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    innerWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    innerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
};
$70a357baeafe15d9$var$CircularGridLines.defaultProps = {
    centerX: 0,
    centerY: 0
};
$70a357baeafe15d9$var$CircularGridLines.requiresSVG = true;
var $70a357baeafe15d9$export$2e2bcd8739ae039 = $70a357baeafe15d9$var$CircularGridLines;



var $acw62 = parcelRequire("acw62");

function $959c5fb23fe069ae$export$2cc7ff91bcacba5e(values, r) {
    if (!((r = +r) >= 0)) throw new RangeError("invalid r");
    let length = values.length;
    if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
    if (!length || !r) return values;
    const blur = $959c5fb23fe069ae$var$blurf(r);
    const temp = values.slice();
    blur(values, temp, 0, length, 1);
    blur(temp, values, 0, length, 1);
    blur(values, temp, 0, length, 1);
    return values;
}
const $959c5fb23fe069ae$export$7671911241d9460b = $959c5fb23fe069ae$var$Blur2($959c5fb23fe069ae$var$blurf);
const $959c5fb23fe069ae$export$44bf2d4c3a4dda00 = $959c5fb23fe069ae$var$Blur2($959c5fb23fe069ae$var$blurfImage);
function $959c5fb23fe069ae$var$Blur2(blur) {
    return function(data, rx, ry = rx) {
        if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
        if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
        let { data: values, width: width, height: height } = data;
        if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
        if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
        if (!width || !height || !rx && !ry) return data;
        const blurx = rx && blur(rx);
        const blury = ry && blur(ry);
        const temp = values.slice();
        if (blurx && blury) {
            $959c5fb23fe069ae$var$blurh(blurx, temp, values, width, height);
            $959c5fb23fe069ae$var$blurh(blurx, values, temp, width, height);
            $959c5fb23fe069ae$var$blurh(blurx, temp, values, width, height);
            $959c5fb23fe069ae$var$blurv(blury, values, temp, width, height);
            $959c5fb23fe069ae$var$blurv(blury, temp, values, width, height);
            $959c5fb23fe069ae$var$blurv(blury, values, temp, width, height);
        } else if (blurx) {
            $959c5fb23fe069ae$var$blurh(blurx, values, temp, width, height);
            $959c5fb23fe069ae$var$blurh(blurx, temp, values, width, height);
            $959c5fb23fe069ae$var$blurh(blurx, values, temp, width, height);
        } else if (blury) {
            $959c5fb23fe069ae$var$blurv(blury, values, temp, width, height);
            $959c5fb23fe069ae$var$blurv(blury, temp, values, width, height);
            $959c5fb23fe069ae$var$blurv(blury, values, temp, width, height);
        }
        return data;
    };
}
function $959c5fb23fe069ae$var$blurh(blur, T, S, w, h) {
    for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
}
function $959c5fb23fe069ae$var$blurv(blur, T, S, w, h) {
    for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
}
function $959c5fb23fe069ae$var$blurfImage(radius) {
    const blur = $959c5fb23fe069ae$var$blurf(radius);
    return (T, S, start, stop, step)=>{
        start <<= 2, stop <<= 2, step <<= 2;
        blur(T, S, start + 0, stop + 0, step);
        blur(T, S, start + 1, stop + 1, step);
        blur(T, S, start + 2, stop + 2, step);
        blur(T, S, start + 3, stop + 3, step);
    };
}
// Given a target array T, a source array S, sets each value T[i] to the average
// of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
// for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
// S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
// integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
// according to r - ⌊radius⌋.
function $959c5fb23fe069ae$var$blurf(radius) {
    const radius0 = Math.floor(radius);
    if (radius0 === radius) return $959c5fb23fe069ae$var$bluri(radius);
    const t = radius - radius0;
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius0 * S[start];
        const s0 = step * radius0;
        const s1 = s0 + step;
        for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s0)];
            T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
            sum -= S[Math.max(start, i - s0)];
        }
    };
}
// Like blurf, but optimized for integer radius.
function $959c5fb23fe069ae$var$bluri(radius) {
    const w = 2 * radius + 1;
    return (T, S, start, stop, step)=>{
        if (!((stop -= step) >= start)) return; // inclusive stop
        let sum = radius * S[start];
        const s = step * radius;
        for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
        for(let i = start, j = stop; i <= j; i += step){
            sum += S[Math.min(stop, i + s)];
            T[i] = sum / w;
            sum -= S[Math.max(start, i - s)];
        }
    };
}

function $5a964dca3df4eea7$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


var $6e529a4d7c5318cb$var$array = Array.prototype;
var $6e529a4d7c5318cb$export$58adb3bec8346d0f = $6e529a4d7c5318cb$var$array.slice;


var $2c54087e0cd22b13$export$2e2bcd8739ae039 = (x)=>()=>x;



function $4bf21a6c2cd653e6$export$2e2bcd8739ae039(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $7c028b8201e48c5a$export$bc64d00cc98e7e95)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

function $5c80433537c7ad93$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}


function $6d386446084ca1a9$export$2e2bcd8739ae039(values) {
    return Math.max(1, Math.ceil(Math.log((0, $5c80433537c7ad93$export$2e2bcd8739ae039)(values)) / Math.LN2) + 1);
}



function $8cf317e8294c08d4$export$2e2bcd8739ae039(a, b) {
    return a - b;
}


function $3e63541b38411916$export$2e2bcd8739ae039(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}



function $dab7974168a117cc$export$2e2bcd8739ae039(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = $dab7974168a117cc$var$ringContains(ring, hole[i])) return c;
    return 0;
}
function $dab7974168a117cc$var$ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if ($dab7974168a117cc$var$segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function $dab7974168a117cc$var$segmentContains(a, b, c) {
    var i;
    return $dab7974168a117cc$var$collinear(a, b, c) && $dab7974168a117cc$var$within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function $dab7974168a117cc$var$collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function $dab7974168a117cc$var$within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}


function $a2ef71a294399755$export$2e2bcd8739ae039() {}


var $bedfe0973872bedd$var$cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
function $bedfe0973872bedd$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, threshold = (0, $6d386446084ca1a9$export$2e2bcd8739ae039), smooth = smoothLinear;
    function contours(values) {
        var tz = threshold(values);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            const e = (0, $24461355656d8852$export$2e2bcd8739ae039)(values, $bedfe0973872bedd$var$finite);
            tz = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(...(0, $4bf21a6c2cd653e6$export$2e2bcd8739ae039)(e[0], e[1], tz), tz);
            while(tz[tz.length - 1] >= e[1])tz.pop();
            while(tz[1] < e[0])tz.shift();
        } else tz = tz.slice().sort((0, $8cf317e8294c08d4$export$2e2bcd8739ae039));
        return tz.map((value)=>contour(values, value));
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        const v = value == null ? NaN : +value;
        if (isNaN(v)) throw new Error(`invalid value: ${value}`);
        var polygons = [], holes = [];
        isorings(values, v, function(ring) {
            smooth(ring, values, v);
            if ((0, $3e63541b38411916$export$2e2bcd8739ae039)(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach(function(hole) {
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, $dab7974168a117cc$export$2e2bcd8739ae039)((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: "MultiPolygon",
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = $bedfe0973872bedd$var$above(values[0], value);
        $bedfe0973872bedd$var$cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = $bedfe0973872bedd$var$above(values[x + 1], value);
            $bedfe0973872bedd$var$cases[t0 | t1 << 1].forEach(stitch);
        }
        $bedfe0973872bedd$var$cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = $bedfe0973872bedd$var$above(values[y * dx + dx], value);
            t2 = $bedfe0973872bedd$var$above(values[y * dx], value);
            $bedfe0973872bedd$var$cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = $bedfe0973872bedd$var$above(values[y * dx + dx + x + 1], value);
                t3 = t2, t2 = $bedfe0973872bedd$var$above(values[y * dx + x + 1], value);
                $bedfe0973872bedd$var$cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            $bedfe0973872bedd$var$cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        $bedfe0973872bedd$var$cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = $bedfe0973872bedd$var$above(values[y * dx + x + 1], value);
            $bedfe0973872bedd$var$cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        $bedfe0973872bedd$var$cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach(function(point) {
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v1 = $bedfe0973872bedd$var$valid(values[yt * dx + xt]);
            if (x > 0 && x < dx && xt === x) point[0] = $bedfe0973872bedd$var$smooth1(x, $bedfe0973872bedd$var$valid(values[yt * dx + xt - 1]), v1, value);
            if (y > 0 && y < dy && yt === y) point[1] = $bedfe0973872bedd$var$smooth1(y, $bedfe0973872bedd$var$valid(values[(yt - 1) * dx + xt]), v1, value);
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, contours;
    };
    contours.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)((0, $6e529a4d7c5318cb$export$58adb3bec8346d0f).call(_)) : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(_), contours) : threshold;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : (0, $a2ef71a294399755$export$2e2bcd8739ae039), contours) : smooth === smoothLinear;
    };
    return contours;
}
// When computing the extent, ignore infinite values (as well as invalid ones).
function $bedfe0973872bedd$var$finite(x) {
    return isFinite(x) ? x : NaN;
}
// Is the (possibly invalid) x greater than or equal to the (known valid) value?
// Treat any invalid value as below negative infinity.
function $bedfe0973872bedd$var$above(x, value) {
    return x == null ? false : +x >= value;
}
// During smoothing, treat any invalid value as negative infinity.
function $bedfe0973872bedd$var$valid(v) {
    return v == null || isNaN(v = +v) ? -Infinity : v;
}
function $bedfe0973872bedd$var$smooth1(x, v0, v1, value) {
    const a = value - v0;
    const b = v1 - v0;
    const d = isFinite(a) || isFinite(b) ? a / b : Math.sign(a) / Math.sign(b);
    return isNaN(d) ? x : x + d - 0.5;
}


function $ad0d499b029c9e60$var$defaultX(d) {
    return d[0];
}
function $ad0d499b029c9e60$var$defaultY(d) {
    return d[1];
}
function $ad0d499b029c9e60$var$defaultWeight() {
    return 1;
}
function $ad0d499b029c9e60$export$2e2bcd8739ae039() {
    var x = $ad0d499b029c9e60$var$defaultX, y = $ad0d499b029c9e60$var$defaultY, weight = $ad0d499b029c9e60$var$defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(20);
    function grid(data) {
        var values = new Float32Array(n * m), pow2k = Math.pow(2, -k), i = -1;
        for (const d of data){
            var xi = (x(d, ++i, data) + o) * pow2k, yi = (y(d, i, data) + o) * pow2k, wi = +weight(d, i, data);
            if (wi && xi >= 0 && xi < n && yi >= 0 && yi < m) {
                var x0 = Math.floor(xi), y0 = Math.floor(yi), xt = xi - x0 - 0.5, yt = yi - y0 - 0.5;
                values[x0 + y0 * n] += (1 - xt) * (1 - yt) * wi;
                values[x0 + 1 + y0 * n] += xt * (1 - yt) * wi;
                values[x0 + 1 + (y0 + 1) * n] += xt * yt * wi;
                values[x0 + (y0 + 1) * n] += (1 - xt) * yt * wi;
            }
        }
        (0, $959c5fb23fe069ae$export$7671911241d9460b)({
            data: values,
            width: n,
            height: m
        }, r * pow2k);
        return values;
    }
    function density(data) {
        var values = grid(data), tz = threshold(values), pow4k = Math.pow(2, 2 * k);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) tz = (0, $7c028b8201e48c5a$export$2e2bcd8739ae039)(Number.MIN_VALUE, (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(values) / pow4k, tz);
        return (0, $bedfe0973872bedd$export$2e2bcd8739ae039)().size([
            n,
            m
        ]).thresholds(tz.map((d)=>d * pow4k))(values).map((c, i)=>(c.value = +tz[i], transform(c)));
    }
    density.contours = function(data) {
        var values = grid(data), contours = (0, $bedfe0973872bedd$export$2e2bcd8739ae039)().size([
            n,
            m
        ]), pow4k = Math.pow(2, 2 * k), contour = (value)=>{
            value = +value;
            var c = transform(contours.contour(values, value * pow4k));
            c.value = value; // preserve exact threshold value
            return c;
        };
        Object.defineProperty(contour, "max", {
            get: ()=>(0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(values) / pow4k
        });
        return contour;
    };
    function transform(geometry) {
        geometry.coordinates.forEach(transformPolygon);
        return geometry;
    }
    function transformPolygon(coordinates) {
        coordinates.forEach(transformRing);
    }
    function transformRing(coordinates) {
        coordinates.forEach(transformPoint);
    }
    // TODO Optimize.
    function transformPoint(coordinates) {
        coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
        coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
    }
    function resize() {
        o = r * 3;
        n = dx + o * 2 >> k;
        m = dy + o * 2 >> k;
        return density;
    }
    density.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(+_), density) : x;
    };
    density.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(+_), density) : y;
    };
    density.weight = function(_) {
        return arguments.length ? (weight = typeof _ === "function" ? _ : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(+_), density) : weight;
    };
    density.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = +_[0], _1 = +_[1];
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, resize();
    };
    density.cellSize = function(_) {
        if (!arguments.length) return 1 << k;
        if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
        return k = Math.floor(Math.log(_) / Math.LN2), resize();
    };
    density.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)((0, $6e529a4d7c5318cb$export$58adb3bec8346d0f).call(_)) : (0, $2c54087e0cd22b13$export$2e2bcd8739ae039)(_), density) : threshold;
    };
    density.bandwidth = function(_) {
        if (!arguments.length) return Math.sqrt(r * (r + 1));
        if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
        return r = (Math.sqrt(4 * _ * _ + 1) - 1) / 2, resize();
    };
    return density;
}


var $523470b6dc0fb943$export$2e2bcd8739ae039 = (x)=>x;


function $f64eb890237a613b$var$streamGeometry(geometry, stream) {
    if (geometry && $f64eb890237a613b$var$streamGeometryType.hasOwnProperty(geometry.type)) $f64eb890237a613b$var$streamGeometryType[geometry.type](geometry, stream);
}
var $f64eb890237a613b$var$streamObjectType = {
    Feature: function(object, stream) {
        $f64eb890237a613b$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$f64eb890237a613b$var$streamGeometry(features[i].geometry, stream);
    }
};
var $f64eb890237a613b$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $f64eb890237a613b$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$f64eb890237a613b$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $f64eb890237a613b$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$f64eb890237a613b$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$f64eb890237a613b$var$streamGeometry(geometries[i], stream);
    }
};
function $f64eb890237a613b$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $f64eb890237a613b$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$f64eb890237a613b$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $f64eb890237a613b$export$2e2bcd8739ae039(object, stream) {
    if (object && $f64eb890237a613b$var$streamObjectType.hasOwnProperty(object.type)) $f64eb890237a613b$var$streamObjectType[object.type](object, stream);
    else $f64eb890237a613b$var$streamGeometry(object, stream);
}


// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $44a48d1cb1f34224$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $44a48d1cb1f34224$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $44a48d1cb1f34224$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $44a48d1cb1f34224$export$5a6391da70c130da(values, valueof) {
    const adder = new $44a48d1cb1f34224$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}


var $670604c4306869d0$export$6c421550c66a327d = 1e-6;
var $670604c4306869d0$export$92c06fba281fe81b = 1e-12;
var $670604c4306869d0$export$18c7bea995a110f = Math.PI;
var $670604c4306869d0$export$e51408a300e8929a = $670604c4306869d0$export$18c7bea995a110f / 2;
var $670604c4306869d0$export$c39a5cba78ea0fc2 = $670604c4306869d0$export$18c7bea995a110f / 4;
var $670604c4306869d0$export$a4b4b4d4d776fe92 = $670604c4306869d0$export$18c7bea995a110f * 2;
var $670604c4306869d0$export$41fc368e1a942b97 = 180 / $670604c4306869d0$export$18c7bea995a110f;
var $670604c4306869d0$export$8449e153fbd325fc = $670604c4306869d0$export$18c7bea995a110f / 180;
var $670604c4306869d0$export$2335f513bbd82c6d = Math.abs;
var $670604c4306869d0$export$628dc4eed22b0fbd = Math.atan;
var $670604c4306869d0$export$b8b770ee6a0d9760 = Math.atan2;
var $670604c4306869d0$export$50d414a77b60d802 = Math.cos;
var $670604c4306869d0$export$803ce6b71a0a94b2 = Math.ceil;
var $670604c4306869d0$export$b310ec824aaee37f = Math.exp;
var $670604c4306869d0$export$a3fe094919f356fd = Math.floor;
var $670604c4306869d0$export$f95c7888b62f8e9a = Math.hypot;
var $670604c4306869d0$export$bef1f36f5486a6a3 = Math.log;
var $670604c4306869d0$export$9c297f60e22e3389 = Math.pow;
var $670604c4306869d0$export$5de3937cb4b592ed = Math.sin;
var $670604c4306869d0$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $670604c4306869d0$export$eba8049fb5020b81 = Math.sqrt;
var $670604c4306869d0$export$fcdd3b0b3246a325 = Math.tan;
function $670604c4306869d0$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $670604c4306869d0$export$18c7bea995a110f : Math.acos(x);
}
function $670604c4306869d0$export$41726bdb1fc63f(x) {
    return x > 1 ? $670604c4306869d0$export$e51408a300e8929a : x < -1 ? -$670604c4306869d0$export$e51408a300e8929a : Math.asin(x);
}
function $670604c4306869d0$export$e808712c2966e662(x) {
    return (x = $670604c4306869d0$export$5de3937cb4b592ed(x / 2)) * x;
}


function $f233d25ba5a1175b$export$2e2bcd8739ae039() {}


var $aac5fcedac7c8011$var$areaSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)(), $aac5fcedac7c8011$var$areaRingSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)(), $aac5fcedac7c8011$var$x00, $aac5fcedac7c8011$var$y00, $aac5fcedac7c8011$var$x0, $aac5fcedac7c8011$var$y0;
var $aac5fcedac7c8011$var$areaStream = {
    point: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineStart: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    polygonStart: function() {
        $aac5fcedac7c8011$var$areaStream.lineStart = $aac5fcedac7c8011$var$areaRingStart;
        $aac5fcedac7c8011$var$areaStream.lineEnd = $aac5fcedac7c8011$var$areaRingEnd;
    },
    polygonEnd: function() {
        $aac5fcedac7c8011$var$areaStream.lineStart = $aac5fcedac7c8011$var$areaStream.lineEnd = $aac5fcedac7c8011$var$areaStream.point = (0, $f233d25ba5a1175b$export$2e2bcd8739ae039);
        $aac5fcedac7c8011$var$areaSum.add((0, $670604c4306869d0$export$2335f513bbd82c6d)($aac5fcedac7c8011$var$areaRingSum));
        $aac5fcedac7c8011$var$areaRingSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
    },
    result: function() {
        var area = $aac5fcedac7c8011$var$areaSum / 2;
        $aac5fcedac7c8011$var$areaSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
        return area;
    }
};
function $aac5fcedac7c8011$var$areaRingStart() {
    $aac5fcedac7c8011$var$areaStream.point = $aac5fcedac7c8011$var$areaPointFirst;
}
function $aac5fcedac7c8011$var$areaPointFirst(x, y) {
    $aac5fcedac7c8011$var$areaStream.point = $aac5fcedac7c8011$var$areaPoint;
    $aac5fcedac7c8011$var$x00 = $aac5fcedac7c8011$var$x0 = x, $aac5fcedac7c8011$var$y00 = $aac5fcedac7c8011$var$y0 = y;
}
function $aac5fcedac7c8011$var$areaPoint(x, y) {
    $aac5fcedac7c8011$var$areaRingSum.add($aac5fcedac7c8011$var$y0 * x - $aac5fcedac7c8011$var$x0 * y);
    $aac5fcedac7c8011$var$x0 = x, $aac5fcedac7c8011$var$y0 = y;
}
function $aac5fcedac7c8011$var$areaRingEnd() {
    $aac5fcedac7c8011$var$areaPoint($aac5fcedac7c8011$var$x00, $aac5fcedac7c8011$var$y00);
}
var $aac5fcedac7c8011$export$2e2bcd8739ae039 = $aac5fcedac7c8011$var$areaStream;



var $efdab2656f7d9ccc$var$x0 = Infinity, $efdab2656f7d9ccc$var$y0 = $efdab2656f7d9ccc$var$x0, $efdab2656f7d9ccc$var$x1 = -$efdab2656f7d9ccc$var$x0, $efdab2656f7d9ccc$var$y1 = $efdab2656f7d9ccc$var$x1;
var $efdab2656f7d9ccc$var$boundsStream = {
    point: $efdab2656f7d9ccc$var$boundsPoint,
    lineStart: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    polygonStart: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    polygonEnd: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $efdab2656f7d9ccc$var$x0,
                $efdab2656f7d9ccc$var$y0
            ],
            [
                $efdab2656f7d9ccc$var$x1,
                $efdab2656f7d9ccc$var$y1
            ]
        ];
        $efdab2656f7d9ccc$var$x1 = $efdab2656f7d9ccc$var$y1 = -($efdab2656f7d9ccc$var$y0 = $efdab2656f7d9ccc$var$x0 = Infinity);
        return bounds;
    }
};
function $efdab2656f7d9ccc$var$boundsPoint(x, y) {
    if (x < $efdab2656f7d9ccc$var$x0) $efdab2656f7d9ccc$var$x0 = x;
    if (x > $efdab2656f7d9ccc$var$x1) $efdab2656f7d9ccc$var$x1 = x;
    if (y < $efdab2656f7d9ccc$var$y0) $efdab2656f7d9ccc$var$y0 = y;
    if (y > $efdab2656f7d9ccc$var$y1) $efdab2656f7d9ccc$var$y1 = y;
}
var $efdab2656f7d9ccc$export$2e2bcd8739ae039 = $efdab2656f7d9ccc$var$boundsStream;



// TODO Enforce positive area for exterior, negative area for interior?
var $8d0804faef1e75f0$var$X0 = 0, $8d0804faef1e75f0$var$Y0 = 0, $8d0804faef1e75f0$var$Z0 = 0, $8d0804faef1e75f0$var$X1 = 0, $8d0804faef1e75f0$var$Y1 = 0, $8d0804faef1e75f0$var$Z1 = 0, $8d0804faef1e75f0$var$X2 = 0, $8d0804faef1e75f0$var$Y2 = 0, $8d0804faef1e75f0$var$Z2 = 0, $8d0804faef1e75f0$var$x00, $8d0804faef1e75f0$var$y00, $8d0804faef1e75f0$var$x0, $8d0804faef1e75f0$var$y0;
var $8d0804faef1e75f0$var$centroidStream = {
    point: $8d0804faef1e75f0$var$centroidPoint,
    lineStart: $8d0804faef1e75f0$var$centroidLineStart,
    lineEnd: $8d0804faef1e75f0$var$centroidLineEnd,
    polygonStart: function() {
        $8d0804faef1e75f0$var$centroidStream.lineStart = $8d0804faef1e75f0$var$centroidRingStart;
        $8d0804faef1e75f0$var$centroidStream.lineEnd = $8d0804faef1e75f0$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPoint;
        $8d0804faef1e75f0$var$centroidStream.lineStart = $8d0804faef1e75f0$var$centroidLineStart;
        $8d0804faef1e75f0$var$centroidStream.lineEnd = $8d0804faef1e75f0$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $8d0804faef1e75f0$var$Z2 ? [
            $8d0804faef1e75f0$var$X2 / $8d0804faef1e75f0$var$Z2,
            $8d0804faef1e75f0$var$Y2 / $8d0804faef1e75f0$var$Z2
        ] : $8d0804faef1e75f0$var$Z1 ? [
            $8d0804faef1e75f0$var$X1 / $8d0804faef1e75f0$var$Z1,
            $8d0804faef1e75f0$var$Y1 / $8d0804faef1e75f0$var$Z1
        ] : $8d0804faef1e75f0$var$Z0 ? [
            $8d0804faef1e75f0$var$X0 / $8d0804faef1e75f0$var$Z0,
            $8d0804faef1e75f0$var$Y0 / $8d0804faef1e75f0$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $8d0804faef1e75f0$var$X0 = $8d0804faef1e75f0$var$Y0 = $8d0804faef1e75f0$var$Z0 = $8d0804faef1e75f0$var$X1 = $8d0804faef1e75f0$var$Y1 = $8d0804faef1e75f0$var$Z1 = $8d0804faef1e75f0$var$X2 = $8d0804faef1e75f0$var$Y2 = $8d0804faef1e75f0$var$Z2 = 0;
        return centroid;
    }
};
function $8d0804faef1e75f0$var$centroidPoint(x, y) {
    $8d0804faef1e75f0$var$X0 += x;
    $8d0804faef1e75f0$var$Y0 += y;
    ++$8d0804faef1e75f0$var$Z0;
}
function $8d0804faef1e75f0$var$centroidLineStart() {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointFirstLine;
}
function $8d0804faef1e75f0$var$centroidPointFirstLine(x, y) {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointLine;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y0 = y);
}
function $8d0804faef1e75f0$var$centroidPointLine(x, y) {
    var dx = x - $8d0804faef1e75f0$var$x0, dy = y - $8d0804faef1e75f0$var$y0, z = (0, $670604c4306869d0$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $8d0804faef1e75f0$var$X1 += z * ($8d0804faef1e75f0$var$x0 + x) / 2;
    $8d0804faef1e75f0$var$Y1 += z * ($8d0804faef1e75f0$var$y0 + y) / 2;
    $8d0804faef1e75f0$var$Z1 += z;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y0 = y);
}
function $8d0804faef1e75f0$var$centroidLineEnd() {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPoint;
}
function $8d0804faef1e75f0$var$centroidRingStart() {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointFirstRing;
}
function $8d0804faef1e75f0$var$centroidRingEnd() {
    $8d0804faef1e75f0$var$centroidPointRing($8d0804faef1e75f0$var$x00, $8d0804faef1e75f0$var$y00);
}
function $8d0804faef1e75f0$var$centroidPointFirstRing(x, y) {
    $8d0804faef1e75f0$var$centroidStream.point = $8d0804faef1e75f0$var$centroidPointRing;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x00 = $8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y00 = $8d0804faef1e75f0$var$y0 = y);
}
function $8d0804faef1e75f0$var$centroidPointRing(x, y) {
    var dx = x - $8d0804faef1e75f0$var$x0, dy = y - $8d0804faef1e75f0$var$y0, z = (0, $670604c4306869d0$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $8d0804faef1e75f0$var$X1 += z * ($8d0804faef1e75f0$var$x0 + x) / 2;
    $8d0804faef1e75f0$var$Y1 += z * ($8d0804faef1e75f0$var$y0 + y) / 2;
    $8d0804faef1e75f0$var$Z1 += z;
    z = $8d0804faef1e75f0$var$y0 * x - $8d0804faef1e75f0$var$x0 * y;
    $8d0804faef1e75f0$var$X2 += z * ($8d0804faef1e75f0$var$x0 + x);
    $8d0804faef1e75f0$var$Y2 += z * ($8d0804faef1e75f0$var$y0 + y);
    $8d0804faef1e75f0$var$Z2 += z * 3;
    $8d0804faef1e75f0$var$centroidPoint($8d0804faef1e75f0$var$x0 = x, $8d0804faef1e75f0$var$y0 = y);
}
var $8d0804faef1e75f0$export$2e2bcd8739ae039 = $8d0804faef1e75f0$var$centroidStream;




function $bc272bd0e70c3e89$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$bc272bd0e70c3e89$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $670604c4306869d0$export$a4b4b4d4d776fe92));
                break;
        }
    },
    result: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039)
};





var $9d42a1f4ad2437ef$var$lengthSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)(), $9d42a1f4ad2437ef$var$lengthRing, $9d42a1f4ad2437ef$var$x00, $9d42a1f4ad2437ef$var$y00, $9d42a1f4ad2437ef$var$x0, $9d42a1f4ad2437ef$var$y0;
var $9d42a1f4ad2437ef$var$lengthStream = {
    point: (0, $f233d25ba5a1175b$export$2e2bcd8739ae039),
    lineStart: function() {
        $9d42a1f4ad2437ef$var$lengthStream.point = $9d42a1f4ad2437ef$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($9d42a1f4ad2437ef$var$lengthRing) $9d42a1f4ad2437ef$var$lengthPoint($9d42a1f4ad2437ef$var$x00, $9d42a1f4ad2437ef$var$y00);
        $9d42a1f4ad2437ef$var$lengthStream.point = (0, $f233d25ba5a1175b$export$2e2bcd8739ae039);
    },
    polygonStart: function() {
        $9d42a1f4ad2437ef$var$lengthRing = true;
    },
    polygonEnd: function() {
        $9d42a1f4ad2437ef$var$lengthRing = null;
    },
    result: function() {
        var length = +$9d42a1f4ad2437ef$var$lengthSum;
        $9d42a1f4ad2437ef$var$lengthSum = new (0, $44a48d1cb1f34224$export$bda7ba77fb86c375)();
        return length;
    }
};
function $9d42a1f4ad2437ef$var$lengthPointFirst(x, y) {
    $9d42a1f4ad2437ef$var$lengthStream.point = $9d42a1f4ad2437ef$var$lengthPoint;
    $9d42a1f4ad2437ef$var$x00 = $9d42a1f4ad2437ef$var$x0 = x, $9d42a1f4ad2437ef$var$y00 = $9d42a1f4ad2437ef$var$y0 = y;
}
function $9d42a1f4ad2437ef$var$lengthPoint(x, y) {
    $9d42a1f4ad2437ef$var$x0 -= x, $9d42a1f4ad2437ef$var$y0 -= y;
    $9d42a1f4ad2437ef$var$lengthSum.add((0, $670604c4306869d0$export$eba8049fb5020b81)($9d42a1f4ad2437ef$var$x0 * $9d42a1f4ad2437ef$var$x0 + $9d42a1f4ad2437ef$var$y0 * $9d42a1f4ad2437ef$var$y0));
    $9d42a1f4ad2437ef$var$x0 = x, $9d42a1f4ad2437ef$var$y0 = y;
}
var $9d42a1f4ad2437ef$export$2e2bcd8739ae039 = $9d42a1f4ad2437ef$var$lengthStream;


// Simple caching for constant-radius points.
let $eeca8dbd32c6e6b7$var$cacheDigits, $eeca8dbd32c6e6b7$var$cacheAppend, $eeca8dbd32c6e6b7$var$cacheRadius, $eeca8dbd32c6e6b7$var$cacheCircle;
class $eeca8dbd32c6e6b7$export$2e2bcd8739ae039 {
    constructor(digits){
        this._append = digits == null ? $eeca8dbd32c6e6b7$var$append : $eeca8dbd32c6e6b7$var$appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== $eeca8dbd32c6e6b7$var$cacheRadius || this._append !== $eeca8dbd32c6e6b7$var$cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    $eeca8dbd32c6e6b7$var$cacheRadius = r;
                    $eeca8dbd32c6e6b7$var$cacheAppend = this._append;
                    $eeca8dbd32c6e6b7$var$cacheCircle = this._;
                    this._ = s;
                }
                this._ += $eeca8dbd32c6e6b7$var$cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
function $eeca8dbd32c6e6b7$var$append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function $eeca8dbd32c6e6b7$var$appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return $eeca8dbd32c6e6b7$var$append;
    if (d !== $eeca8dbd32c6e6b7$var$cacheDigits) {
        const k = 10 ** d;
        $eeca8dbd32c6e6b7$var$cacheDigits = d;
        $eeca8dbd32c6e6b7$var$cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return $eeca8dbd32c6e6b7$var$cacheAppend;
}


function $58c46562f4a8d739$export$2e2bcd8739ae039(projection, context) {
    let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $aac5fcedac7c8011$export$2e2bcd8739ae039)));
        return (0, $aac5fcedac7c8011$export$2e2bcd8739ae039).result();
    };
    path.measure = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $9d42a1f4ad2437ef$export$2e2bcd8739ae039)));
        return (0, $9d42a1f4ad2437ef$export$2e2bcd8739ae039).result();
    };
    path.bounds = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $efdab2656f7d9ccc$export$2e2bcd8739ae039)));
        return (0, $efdab2656f7d9ccc$export$2e2bcd8739ae039).result();
    };
    path.centroid = function(object) {
        (0, $f64eb890237a613b$export$2e2bcd8739ae039)(object, projectionStream((0, $8d0804faef1e75f0$export$2e2bcd8739ae039)));
        return (0, $8d0804faef1e75f0$export$2e2bcd8739ae039).result();
    };
    path.projection = function(_) {
        if (!arguments.length) return projection;
        projectionStream = _ == null ? (projection = null, $523470b6dc0fb943$export$2e2bcd8739ae039) : (projection = _).stream;
        return path;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $eeca8dbd32c6e6b7$export$2e2bcd8739ae039)(digits)) : new (0, $bc272bd0e70c3e89$export$2e2bcd8739ae039)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    path.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        if (context === null) contextStream = new (0, $eeca8dbd32c6e6b7$export$2e2bcd8739ae039)(digits);
        return path;
    };
    return path.projection(projection).digits(digits).context(context);
}








function $561bb29a13c6eb5c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $561bb29a13c6eb5c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $561bb29a13c6eb5c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $561bb29a13c6eb5c$var$_typeof(obj);
}
function $561bb29a13c6eb5c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $561bb29a13c6eb5c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $561bb29a13c6eb5c$var$ownKeys(Object(source), true).forEach(function(key) {
            $561bb29a13c6eb5c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $561bb29a13c6eb5c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $561bb29a13c6eb5c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $561bb29a13c6eb5c$var$_extends() {
    $561bb29a13c6eb5c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $561bb29a13c6eb5c$var$_extends.apply(this, arguments);
}
function $561bb29a13c6eb5c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $561bb29a13c6eb5c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $561bb29a13c6eb5c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $561bb29a13c6eb5c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $561bb29a13c6eb5c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $561bb29a13c6eb5c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $561bb29a13c6eb5c$var$_setPrototypeOf(subClass, superClass);
}
function $561bb29a13c6eb5c$var$_setPrototypeOf(o, p) {
    $561bb29a13c6eb5c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $561bb29a13c6eb5c$var$_setPrototypeOf(o, p);
}
function $561bb29a13c6eb5c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $561bb29a13c6eb5c$var$_isNativeReflectConstruct();
    return function() {
        var Super = $561bb29a13c6eb5c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $561bb29a13c6eb5c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $561bb29a13c6eb5c$var$_possibleConstructorReturn(this, result);
    };
}
function $561bb29a13c6eb5c$var$_possibleConstructorReturn(self, call) {
    if (call && ($561bb29a13c6eb5c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $561bb29a13c6eb5c$var$_assertThisInitialized(self);
}
function $561bb29a13c6eb5c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $561bb29a13c6eb5c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $561bb29a13c6eb5c$var$_getPrototypeOf(o) {
    $561bb29a13c6eb5c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $561bb29a13c6eb5c$var$_getPrototypeOf(o);
}
var $561bb29a13c6eb5c$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--contour";
function $561bb29a13c6eb5c$var$getDomain(data) {
    return data.reduce(function(acc, row) {
        return {
            min: Math.min(acc.min, row.value),
            max: Math.max(acc.max, row.value)
        };
    }, {
        min: Infinity,
        max: -Infinity
    });
}
var $561bb29a13c6eb5c$var$ContourSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $561bb29a13c6eb5c$var$_inherits(ContourSeries, _AbstractSeries);
    var _super = $561bb29a13c6eb5c$var$_createSuper(ContourSeries);
    function ContourSeries() {
        $561bb29a13c6eb5c$var$_classCallCheck(this, ContourSeries);
        return _super.apply(this, arguments);
    }
    $561bb29a13c6eb5c$var$_createClass(ContourSeries, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, animation = _this$props.animation, bandwidth = _this$props.bandwidth, className = _this$props.className, colorRange = _this$props.colorRange, data = _this$props.data, innerHeight = _this$props.innerHeight, innerWidth = _this$props.innerWidth, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, style = _this$props.style;
                if (!data || !innerWidth || !innerHeight) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $561bb29a13c6eb5c$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ContourSeries, $561bb29a13c6eb5c$var$_extends({}, this.props, {
                    animation: null
                })));
                var x = this._getAttributeFunctor("x");
                var y = this._getAttributeFunctor("y");
                var contouredData = (0, $ad0d499b029c9e60$export$2e2bcd8739ae039)().x(function(d) {
                    return x(d);
                }).y(function(d) {
                    return y(d);
                }).size([
                    innerWidth,
                    innerHeight
                ]).bandwidth(bandwidth)(data);
                var geo = (0, $58c46562f4a8d739$export$2e2bcd8739ae039)();
                var _getDomain = $561bb29a13c6eb5c$var$getDomain(contouredData), min = _getDomain.min, max = _getDomain.max;
                var colorScale = (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)().domain([
                    min,
                    max
                ]).range(colorRange || (0, $d629c93f7b094ef1$export$36688c8ae3834bf8));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($561bb29a13c6eb5c$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")")
                }, contouredData.map(function(polygon, index) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                        className: "rv-xy-plot__series--contour-line",
                        key: "rv-xy-plot__series--contour-line-".concat(index),
                        d: geo(polygon),
                        style: $561bb29a13c6eb5c$var$_objectSpread({
                            fill: colorScale(polygon.value)
                        }, style)
                    });
                }));
            }
        }
    ]);
    return ContourSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$561bb29a13c6eb5c$var$ContourSeries.propTypes = $561bb29a13c6eb5c$var$_objectSpread($561bb29a13c6eb5c$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
    animation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    bandwidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
});
$561bb29a13c6eb5c$var$ContourSeries.defaultProps = $561bb29a13c6eb5c$var$_objectSpread($561bb29a13c6eb5c$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).defaultProps), {}, {
    bandwidth: 40,
    style: {}
});
var $561bb29a13c6eb5c$export$2e2bcd8739ae039 = $561bb29a13c6eb5c$var$ContourSeries;



var $acw62 = parcelRequire("acw62");




function $d3c3b096f169932f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d3c3b096f169932f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d3c3b096f169932f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d3c3b096f169932f$var$_typeof(obj);
}
function $d3c3b096f169932f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d3c3b096f169932f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d3c3b096f169932f$var$ownKeys(Object(source), true).forEach(function(key) {
            $d3c3b096f169932f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d3c3b096f169932f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d3c3b096f169932f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d3c3b096f169932f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d3c3b096f169932f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d3c3b096f169932f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d3c3b096f169932f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d3c3b096f169932f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d3c3b096f169932f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d3c3b096f169932f$var$_setPrototypeOf(subClass, superClass);
}
function $d3c3b096f169932f$var$_setPrototypeOf(o, p) {
    $d3c3b096f169932f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d3c3b096f169932f$var$_setPrototypeOf(o, p);
}
function $d3c3b096f169932f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d3c3b096f169932f$var$_isNativeReflectConstruct();
    return function() {
        var Super = $d3c3b096f169932f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d3c3b096f169932f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d3c3b096f169932f$var$_possibleConstructorReturn(this, result);
    };
}
function $d3c3b096f169932f$var$_possibleConstructorReturn(self, call) {
    if (call && ($d3c3b096f169932f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d3c3b096f169932f$var$_assertThisInitialized(self);
}
function $d3c3b096f169932f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d3c3b096f169932f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d3c3b096f169932f$var$_getPrototypeOf(o) {
    $d3c3b096f169932f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d3c3b096f169932f$var$_getPrototypeOf(o);
}
/**
 * Format title by detault.
 * @param {Array} values List of values.
 * @returns {*} Formatted value or undefined.
 */ function $d3c3b096f169932f$var$defaultTitleFormat(values) {
    var value = $d3c3b096f169932f$var$getFirstNonEmptyValue(values);
    if (value) return {
        title: "x",
        value: (0, $a03034fd7b886b96$export$e1b48b0771a44e32)(value.x)
    };
}
/**
 * Format items by default.
 * @param {Array} values Array of values.
 * @returns {*} Formatted list of items.
 */ function $d3c3b096f169932f$var$defaultItemsFormat(values) {
    return values.map(function(v, i) {
        if (v) return {
            value: v.y,
            title: i
        };
    });
}
/**
 * Get the first non-empty item from an array.
 * @param {Array} values Array of values.
 * @returns {*} First non-empty value or undefined.
 */ function $d3c3b096f169932f$var$getFirstNonEmptyValue(values) {
    return (values || []).find(function(v) {
        return Boolean(v);
    });
}
var $d3c3b096f169932f$var$Crosshair = /*#__PURE__*/ function(_PureComponent) {
    $d3c3b096f169932f$var$_inherits(Crosshair, _PureComponent);
    var _super = $d3c3b096f169932f$var$_createSuper(Crosshair);
    function Crosshair() {
        $d3c3b096f169932f$var$_classCallCheck(this, Crosshair);
        return _super.apply(this, arguments);
    }
    $d3c3b096f169932f$var$_createClass(Crosshair, [
        {
            key: "_renderCrosshairItems",
            /**
     * Render crosshair items (title + value for each series).
     * @returns {*} Array of React classes with the crosshair values.
     * @private
     */ value: function _renderCrosshairItems() {
                var _this$props = this.props, values = _this$props.values, itemsFormat = _this$props.itemsFormat;
                var items = itemsFormat(values);
                if (!items) return null;
                return items.filter(function(i) {
                    return i;
                }).map(function renderValue(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        className: "rv-crosshair__item",
                        key: "item".concat(i)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        className: "rv-crosshair__item__title"
                    }, item.title), ": ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        className: "rv-crosshair__item__value"
                    }, item.value));
                });
            }
        },
        {
            key: "_renderCrosshairTitle",
            value: function _renderCrosshairTitle() {
                var _this$props2 = this.props, values = _this$props2.values, titleFormat = _this$props2.titleFormat, style = _this$props2.style;
                var titleItem = titleFormat(values);
                if (!titleItem) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "rv-crosshair__title",
                    key: "title",
                    style: style.title
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "rv-crosshair__title__title"
                }, titleItem.title), ": ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "rv-crosshair__title__value"
                }, titleItem.value));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, children = _this$props3.children, className = _this$props3.className, values = _this$props3.values, marginTop = _this$props3.marginTop, marginLeft = _this$props3.marginLeft, innerWidth = _this$props3.innerWidth, innerHeight = _this$props3.innerHeight, style = _this$props3.style;
                var value = $d3c3b096f169932f$var$getFirstNonEmptyValue(values);
                if (!value) return null;
                var x = (0, $379b4f4f942d44ab$export$735c878afad94f32)(this.props, "x");
                var innerLeft = x(value);
                var _this$props$orientati = this.props.orientation, orientation = _this$props$orientati === void 0 ? innerLeft > innerWidth / 2 ? "left" : "right" : _this$props$orientati;
                var left = marginLeft + innerLeft;
                var top = marginTop;
                var innerClassName = "rv-crosshair__inner rv-crosshair__inner--".concat(orientation);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-crosshair", className),
                    style: {
                        left: "".concat(left, "px"),
                        top: "".concat(top, "px")
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "rv-crosshair__line",
                    style: $d3c3b096f169932f$var$_objectSpread({
                        height: "".concat(innerHeight, "px")
                    }, style.line)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: innerClassName
                }, children ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "rv-crosshair__inner__content",
                    style: style.box
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, this._renderCrosshairTitle(), this._renderCrosshairItems()))));
            }
        }
    ], [
        {
            key: "defaultProps",
            get: function get() {
                return {
                    titleFormat: $d3c3b096f169932f$var$defaultTitleFormat,
                    itemsFormat: $d3c3b096f169932f$var$defaultItemsFormat,
                    style: {
                        line: {},
                        title: {},
                        box: {}
                    }
                };
            }
        },
        {
            key: "propTypes",
            get: function get() {
                return {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    values: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
                        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
                        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
                        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
                    ])),
                    series: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
                    innerWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
                    innerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
                    marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
                    marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
                    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
                        "left",
                        "right"
                    ]),
                    itemsFormat: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    titleFormat: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
                        line: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
                        title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
                        box: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
                    })
                };
            }
        }
    ]);
    return Crosshair;
}((0, $acw62.PureComponent));
$d3c3b096f169932f$var$Crosshair.displayName = "Crosshair";
var $d3c3b096f169932f$export$2e2bcd8739ae039 = $d3c3b096f169932f$var$Crosshair;



var $acw62 = parcelRequire("acw62");





function $ec1ff944c50f5047$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ec1ff944c50f5047$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ec1ff944c50f5047$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ec1ff944c50f5047$var$_typeof(obj);
}
function $ec1ff944c50f5047$var$_extends() {
    $ec1ff944c50f5047$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ec1ff944c50f5047$var$_extends.apply(this, arguments);
}
function $ec1ff944c50f5047$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ec1ff944c50f5047$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ec1ff944c50f5047$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ec1ff944c50f5047$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ec1ff944c50f5047$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ec1ff944c50f5047$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ec1ff944c50f5047$var$_setPrototypeOf(subClass, superClass);
}
function $ec1ff944c50f5047$var$_setPrototypeOf(o, p) {
    $ec1ff944c50f5047$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ec1ff944c50f5047$var$_setPrototypeOf(o, p);
}
function $ec1ff944c50f5047$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ec1ff944c50f5047$var$_isNativeReflectConstruct();
    return function() {
        var Super = $ec1ff944c50f5047$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ec1ff944c50f5047$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ec1ff944c50f5047$var$_possibleConstructorReturn(this, result);
    };
}
function $ec1ff944c50f5047$var$_possibleConstructorReturn(self, call) {
    if (call && ($ec1ff944c50f5047$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ec1ff944c50f5047$var$_assertThisInitialized(self);
}
function $ec1ff944c50f5047$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ec1ff944c50f5047$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ec1ff944c50f5047$var$_getPrototypeOf(o) {
    $ec1ff944c50f5047$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ec1ff944c50f5047$var$_getPrototypeOf(o);
}
function $ec1ff944c50f5047$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ec1ff944c50f5047$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ec1ff944c50f5047$var$ownKeys(Object(source), true).forEach(function(key) {
            $ec1ff944c50f5047$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ec1ff944c50f5047$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ec1ff944c50f5047$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ec1ff944c50f5047$var$_toConsumableArray(arr) {
    return $ec1ff944c50f5047$var$_arrayWithoutHoles(arr) || $ec1ff944c50f5047$var$_iterableToArray(arr) || $ec1ff944c50f5047$var$_unsupportedIterableToArray(arr) || $ec1ff944c50f5047$var$_nonIterableSpread();
}
function $ec1ff944c50f5047$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ec1ff944c50f5047$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ec1ff944c50f5047$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ec1ff944c50f5047$var$_arrayLikeToArray(o, minLen);
}
function $ec1ff944c50f5047$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $ec1ff944c50f5047$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ec1ff944c50f5047$var$_arrayLikeToArray(arr);
}
function $ec1ff944c50f5047$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ec1ff944c50f5047$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--custom-svg-wrapper";
var $ec1ff944c50f5047$var$DEFAULT_STYLE = {
    stroke: "blue",
    fill: "blue"
};
function $ec1ff944c50f5047$var$predefinedComponents(type) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ec1ff944c50f5047$var$DEFAULT_STYLE;
    switch(type){
        case "diamond":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
                style: style,
                points: "0 0 ".concat(size / 2, " ").concat(size / 2, " 0 ").concat(size, " ").concat(-size / 2, " ").concat(size / 2, " 0 0")
            });
        case "star":
            var starPoints = $ec1ff944c50f5047$var$_toConsumableArray(new Array(5)).map(function(c, index) {
                var angle = index / 5 * Math.PI * 2;
                var innerAngle = angle + Math.PI / 10;
                var outerAngle = angle - Math.PI / 10; // ratio of inner polygon to outer polgyon
                var innerRadius = size / 2.61;
                return "\n        ".concat(Math.cos(outerAngle) * size, " ").concat(Math.sin(outerAngle) * size, "\n        ").concat(Math.cos(innerAngle) * innerRadius, " ").concat(Math.sin(innerAngle) * innerRadius, "\n      ");
            }).join(" ");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polygon", {
                points: starPoints,
                x: "0",
                y: "0",
                height: size,
                width: size,
                style: style
            });
        case "square":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                x: "".concat(-size / 2),
                y: "".concat(-size / 2),
                height: size,
                width: size,
                style: style
            });
        default:
        case "circle":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
                cx: "0",
                cy: "0",
                r: size / 2,
                style: style
            });
    }
}
function $ec1ff944c50f5047$var$getInnerComponent(_ref) {
    var customComponent = _ref.customComponent, defaultType = _ref.defaultType, positionInPixels = _ref.positionInPixels, positionFunctions = _ref.positionFunctions, style = _ref.style, propsSize = _ref.propsSize;
    var size = customComponent.size;
    var aggStyle = $ec1ff944c50f5047$var$_objectSpread($ec1ff944c50f5047$var$_objectSpread({}, style), customComponent.style || {});
    var innerComponent = customComponent.customComponent;
    if (!innerComponent && typeof defaultType === "string") return $ec1ff944c50f5047$var$predefinedComponents(defaultType, size || propsSize, aggStyle);
     // if default component is a function
    if (!innerComponent) return defaultType(customComponent, positionInPixels, aggStyle, positionFunctions);
    if (typeof innerComponent === "string") return $ec1ff944c50f5047$var$predefinedComponents(innerComponent || defaultType, size, aggStyle);
     // if inner component is a function
    return innerComponent(customComponent, positionInPixels, aggStyle, positionFunctions);
}
var $ec1ff944c50f5047$var$CustomSVGSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $ec1ff944c50f5047$var$_inherits(CustomSVGSeries, _AbstractSeries);
    var _super = $ec1ff944c50f5047$var$_createSuper(CustomSVGSeries);
    function CustomSVGSeries() {
        $ec1ff944c50f5047$var$_classCallCheck(this, CustomSVGSeries);
        return _super.apply(this, arguments);
    }
    $ec1ff944c50f5047$var$_createClass(CustomSVGSeries, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, animation = _this$props.animation, className = _this$props.className, customComponent = _this$props.customComponent, data = _this$props.data, innerHeight = _this$props.innerHeight, innerWidth = _this$props.innerWidth, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, style = _this$props.style, size = _this$props.size;
                if (!data || !innerWidth || !innerHeight) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $ec1ff944c50f5047$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CustomSVGSeries, $ec1ff944c50f5047$var$_extends({}, this.props, {
                    animation: false
                })));
                var x = this._getAttributeFunctor("x");
                var y = this._getAttributeFunctor("y");
                var contents = data.map(function(seriesComponent, index) {
                    var positionInPixels = {
                        x: x(seriesComponent),
                        y: y(seriesComponent)
                    };
                    var innerComponent = $ec1ff944c50f5047$var$getInnerComponent({
                        customComponent: seriesComponent,
                        positionInPixels: positionInPixels,
                        defaultType: customComponent,
                        positionFunctions: {
                            x: x,
                            y: y
                        },
                        style: style,
                        propsSize: size
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                        className: "rv-xy-plot__series--custom-svg",
                        key: "rv-xy-plot__series--custom-svg-".concat(index),
                        transform: "translate(".concat(positionInPixels.x, ",").concat(positionInPixels.y, ")"),
                        onMouseEnter: function onMouseEnter(e) {
                            return _this._valueMouseOverHandler(seriesComponent, e);
                        },
                        onMouseLeave: function onMouseLeave(e) {
                            return _this._valueMouseOutHandler(seriesComponent, e);
                        }
                    }, innerComponent);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($ec1ff944c50f5047$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")")
                }, contents);
            }
        }
    ]);
    return CustomSVGSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$ec1ff944c50f5047$var$CustomSVGSeries.propTypes = {
    animation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    customComponent: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
        ]).isRequired,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
        ]).isRequired
    })).isRequired,
    marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    onValueMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
$ec1ff944c50f5047$var$CustomSVGSeries.defaultProps = $ec1ff944c50f5047$var$_objectSpread($ec1ff944c50f5047$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).defaultProps), {}, {
    animation: false,
    customComponent: "circle",
    style: {},
    size: 2
});
var $ec1ff944c50f5047$export$2e2bcd8739ae039 = $ec1ff944c50f5047$var$CustomSVGSeries;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

function $f446f142e8191b73$var$_extends() {
    $f446f142e8191b73$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f446f142e8191b73$var$_extends.apply(this, arguments);
}
function $f446f142e8191b73$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f446f142e8191b73$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f446f142e8191b73$var$ownKeys(Object(source), true).forEach(function(key) {
            $f446f142e8191b73$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f446f142e8191b73$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f446f142e8191b73$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f446f142e8191b73$export$2e2bcd8739ae039(props) {
    var axisDomain = props.axisDomain, numberOfTicks = props.numberOfTicks, axisStart = props.axisStart, axisEnd = props.axisEnd, tickValue = props.tickValue, tickSize = props.tickSize, style = props.style;
    var _generatePoints = (0, $16d91db751e2a422$export$a4274e8b1679c276)({
        axisStart: axisStart,
        axisEnd: axisEnd,
        numberOfTicks: numberOfTicks,
        axisDomain: axisDomain
    }), points = _generatePoints.points; // add a quarter rotation to make ticks orthogonal to axis
    var tickAngle = (0, $16d91db751e2a422$export$3f70be5e7d7dc51)(axisStart, axisEnd) + Math.PI / 2;
    return points.map(function(point, index) {
        var tickProps = $f446f142e8191b73$var$_objectSpread({
            x1: 0,
            y1: 0,
            x2: tickSize * Math.cos(tickAngle),
            y2: tickSize * Math.sin(tickAngle)
        }, style.ticks);
        var textProps = $f446f142e8191b73$var$_objectSpread({
            x: tickSize * Math.cos(tickAngle),
            y: tickSize * Math.sin(tickAngle),
            textAnchor: "start"
        }, style.text);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: index,
            transform: "translate(".concat(point.x, ", ").concat(point.y, ")"),
            className: "rv-xy-plot__axis__tick"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $f446f142e8191b73$var$_extends({}, tickProps, {
            className: "rv-xy-plot__axis__tick__line"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", $f446f142e8191b73$var$_extends({}, textProps, {
            className: "rv-xy-plot__axis__tick__text"
        }), tickValue(point.text)));
    });
}




function $cc228db9775fdbe5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cc228db9775fdbe5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cc228db9775fdbe5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cc228db9775fdbe5$var$_typeof(obj);
}
function $cc228db9775fdbe5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cc228db9775fdbe5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $cc228db9775fdbe5$var$ownKeys(Object(source), true).forEach(function(key) {
            $cc228db9775fdbe5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $cc228db9775fdbe5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cc228db9775fdbe5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cc228db9775fdbe5$var$_extends() {
    $cc228db9775fdbe5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cc228db9775fdbe5$var$_extends.apply(this, arguments);
}
function $cc228db9775fdbe5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cc228db9775fdbe5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cc228db9775fdbe5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cc228db9775fdbe5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cc228db9775fdbe5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cc228db9775fdbe5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cc228db9775fdbe5$var$_setPrototypeOf(subClass, superClass);
}
function $cc228db9775fdbe5$var$_setPrototypeOf(o, p) {
    $cc228db9775fdbe5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cc228db9775fdbe5$var$_setPrototypeOf(o, p);
}
function $cc228db9775fdbe5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cc228db9775fdbe5$var$_isNativeReflectConstruct();
    return function() {
        var Super = $cc228db9775fdbe5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cc228db9775fdbe5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cc228db9775fdbe5$var$_possibleConstructorReturn(this, result);
    };
}
function $cc228db9775fdbe5$var$_possibleConstructorReturn(self, call) {
    if (call && ($cc228db9775fdbe5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $cc228db9775fdbe5$var$_assertThisInitialized(self);
}
function $cc228db9775fdbe5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cc228db9775fdbe5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cc228db9775fdbe5$var$_getPrototypeOf(o) {
    $cc228db9775fdbe5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cc228db9775fdbe5$var$_getPrototypeOf(o);
}
var $cc228db9775fdbe5$var$predefinedClassName = "rv-xy-manipulable-axis rv-xy-plot__axis";
var $cc228db9775fdbe5$var$animatedProps = [
    "xRange",
    "yRange",
    "xDomain",
    "yDomain",
    "width",
    "height",
    "marginLeft",
    "marginTop",
    "marginRight",
    "marginBottom",
    "tickSize",
    "tickTotal",
    "tickSizeInner",
    "tickSizeOuter"
];
var $cc228db9775fdbe5$var$DecorativeAxis = /*#__PURE__*/ function(_AbstractSeries) {
    $cc228db9775fdbe5$var$_inherits(DecorativeAxis, _AbstractSeries);
    var _super = $cc228db9775fdbe5$var$_createSuper(DecorativeAxis);
    function DecorativeAxis() {
        $cc228db9775fdbe5$var$_classCallCheck(this, DecorativeAxis);
        return _super.apply(this, arguments);
    }
    $cc228db9775fdbe5$var$_createClass(DecorativeAxis, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, animation = _this$props.animation, className = _this$props.className, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, axisStart = _this$props.axisStart, axisEnd = _this$props.axisEnd, axisDomain = _this$props.axisDomain, numberOfTicks = _this$props.numberOfTicks, tickValue = _this$props.tickValue, tickSize = _this$props.tickSize, style = _this$props.style;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $cc228db9775fdbe5$var$_extends({}, this.props, {
                    animatedProps: $cc228db9775fdbe5$var$animatedProps
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DecorativeAxis, $cc228db9775fdbe5$var$_extends({}, this.props, {
                    animation: null
                })));
                var x = this._getAttributeFunctor("x");
                var y = this._getAttributeFunctor("y");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($cc228db9775fdbe5$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")")
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $cc228db9775fdbe5$var$_extends({}, $cc228db9775fdbe5$var$_objectSpread({
                    x1: x({
                        x: axisStart.x
                    }),
                    x2: x({
                        x: axisEnd.x
                    }),
                    y1: y({
                        y: axisStart.y
                    }),
                    y2: y({
                        y: axisEnd.y
                    })
                }, style.line), {
                    className: "rv-xy-plot__axis__line"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: "rv-xy-manipulable-axis__ticks"
                }, (0, $f446f142e8191b73$export$2e2bcd8739ae039)({
                    axisDomain: axisDomain,
                    axisEnd: {
                        x: x(axisEnd),
                        y: y(axisEnd)
                    },
                    axisStart: {
                        x: x(axisStart),
                        y: y(axisStart)
                    },
                    numberOfTicks: numberOfTicks,
                    tickValue: tickValue,
                    tickSize: tickSize,
                    style: style
                })));
            }
        }
    ]);
    return DecorativeAxis;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
var $cc228db9775fdbe5$var$DEFAULT_FORMAT = (0, $54a757fa53542946$export$d9468344d3651243)(".2r");
$cc228db9775fdbe5$var$DecorativeAxis.defaultProps = {
    className: "",
    numberOfTicks: 10,
    tickValue: function tickValue(d) {
        return $cc228db9775fdbe5$var$DEFAULT_FORMAT(d);
    },
    tickSize: 5,
    style: {
        line: {
            strokeWidth: 1
        },
        ticks: {
            strokeWidth: 2
        },
        text: {}
    }
};
$cc228db9775fdbe5$var$DecorativeAxis.propTypes = $cc228db9775fdbe5$var$_objectSpread($cc228db9775fdbe5$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
    axisDomain: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number).isRequired,
    axisEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
        ]),
        y: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
        ])
    }).isRequired,
    axisStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
        ]),
        y: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
        ])
    }).isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    numberOfTicks: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    tickValue: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    tickSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        line: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        ticks: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        text: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    })
});
$cc228db9775fdbe5$var$DecorativeAxis.displayName = "DecorativeAxis";
var $cc228db9775fdbe5$export$2e2bcd8739ae039 = $cc228db9775fdbe5$var$DecorativeAxis;


// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var $acw62 = parcelRequire("acw62");


var $6b5650ccd995f6f4$var$predefinedClassName = "rv-gradient-defs";
function $6b5650ccd995f6f4$var$GradientDefs(props) {
    var className = props.className;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($6b5650ccd995f6f4$var$predefinedClassName, className)
    }, props.children);
}
$6b5650ccd995f6f4$var$GradientDefs.displayName = "GradientDefs";
$6b5650ccd995f6f4$var$GradientDefs.requiresSVG = true;
$6b5650ccd995f6f4$var$GradientDefs.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
$6b5650ccd995f6f4$var$GradientDefs.defaultProps = {
    className: ""
};
var $6b5650ccd995f6f4$export$2e2bcd8739ae039 = $6b5650ccd995f6f4$var$GradientDefs;



var $acw62 = parcelRequire("acw62");





function $bfd175a5af321bd0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bfd175a5af321bd0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bfd175a5af321bd0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bfd175a5af321bd0$var$_typeof(obj);
}
function $bfd175a5af321bd0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bfd175a5af321bd0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bfd175a5af321bd0$var$ownKeys(Object(source), true).forEach(function(key) {
            $bfd175a5af321bd0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bfd175a5af321bd0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bfd175a5af321bd0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bfd175a5af321bd0$var$_extends() {
    $bfd175a5af321bd0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bfd175a5af321bd0$var$_extends.apply(this, arguments);
}
function $bfd175a5af321bd0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bfd175a5af321bd0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bfd175a5af321bd0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bfd175a5af321bd0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bfd175a5af321bd0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bfd175a5af321bd0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bfd175a5af321bd0$var$_setPrototypeOf(subClass, superClass);
}
function $bfd175a5af321bd0$var$_setPrototypeOf(o, p) {
    $bfd175a5af321bd0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bfd175a5af321bd0$var$_setPrototypeOf(o, p);
}
function $bfd175a5af321bd0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bfd175a5af321bd0$var$_isNativeReflectConstruct();
    return function() {
        var Super = $bfd175a5af321bd0$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bfd175a5af321bd0$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bfd175a5af321bd0$var$_possibleConstructorReturn(this, result);
    };
}
function $bfd175a5af321bd0$var$_possibleConstructorReturn(self, call) {
    if (call && ($bfd175a5af321bd0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bfd175a5af321bd0$var$_assertThisInitialized(self);
}
function $bfd175a5af321bd0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bfd175a5af321bd0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bfd175a5af321bd0$var$_getPrototypeOf(o) {
    $bfd175a5af321bd0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bfd175a5af321bd0$var$_getPrototypeOf(o);
}
var $bfd175a5af321bd0$var$VERTICAL = (0, $16d91db751e2a422$export$9106728c49045482).VERTICAL, $bfd175a5af321bd0$var$HORIZONTAL = (0, $16d91db751e2a422$export$9106728c49045482).HORIZONTAL;
var $bfd175a5af321bd0$var$propTypes = {
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        $bfd175a5af321bd0$var$VERTICAL,
        $bfd175a5af321bd0$var$HORIZONTAL
    ]),
    attr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    top: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    tickValues: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ])),
    tickTotal: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    animation: (0, $d4808d8f8c60755d$export$c6290f21adf0a17a),
    // generally supplied by xyplot
    marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginBottom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginRight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    innerWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    innerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
};
var $bfd175a5af321bd0$var$defaultProps = {
    direction: $bfd175a5af321bd0$var$VERTICAL
};
var $bfd175a5af321bd0$var$animatedProps = [
    "xRange",
    "yRange",
    "xDomain",
    "yDomain",
    "width",
    "height",
    "marginLeft",
    "marginTop",
    "marginRight",
    "marginBottom",
    "tickTotal"
];
var $bfd175a5af321bd0$var$GridLines = /*#__PURE__*/ function(_PureComponent) {
    $bfd175a5af321bd0$var$_inherits(GridLines, _PureComponent);
    var _super = $bfd175a5af321bd0$var$_createSuper(GridLines);
    function GridLines() {
        $bfd175a5af321bd0$var$_classCallCheck(this, GridLines);
        return _super.apply(this, arguments);
    }
    $bfd175a5af321bd0$var$_createClass(GridLines, [
        {
            key: "_getDefaultProps",
            value: function _getDefaultProps() {
                var _this$props = this.props, innerWidth = _this$props.innerWidth, innerHeight = _this$props.innerHeight, marginTop = _this$props.marginTop, marginLeft = _this$props.marginLeft, direction = _this$props.direction;
                return {
                    left: marginLeft,
                    top: marginTop,
                    width: innerWidth,
                    height: innerHeight,
                    tickTotal: (0, $16d91db751e2a422$export$8d2671251b7b6f75)(direction === $bfd175a5af321bd0$var$VERTICAL ? innerWidth : innerHeight)
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, animation = _this$props2.animation, className = _this$props2.className;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $bfd175a5af321bd0$var$_extends({}, this.props, {
                    animatedProps: $bfd175a5af321bd0$var$animatedProps
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GridLines, $bfd175a5af321bd0$var$_extends({}, this.props, {
                    animation: null
                })));
                var props = $bfd175a5af321bd0$var$_objectSpread($bfd175a5af321bd0$var$_objectSpread({}, this._getDefaultProps()), this.props);
                var attr = props.attr, direction = props.direction, width = props.width, height = props.height, style = props.style, tickTotal = props.tickTotal, tickValues = props.tickValues, top = props.top, left = props.left;
                var isVertical = direction === $bfd175a5af321bd0$var$VERTICAL;
                var tickXAttr = isVertical ? "y" : "x";
                var tickYAttr = isVertical ? "x" : "y";
                var length = isVertical ? height : width;
                var scale = (0, $379b4f4f942d44ab$export$cb87eff04da17d9)(props, attr);
                var values = (0, $16d91db751e2a422$export$4cc7a216492b1f53)(scale, tickTotal, tickValues);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    transform: "translate(".concat(left, ",").concat(top, ")"),
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-xy-plot__grid-lines", className)
                }, values.map(function(v, i) {
                    var _pathProps;
                    var pos = scale(v);
                    var pathProps = (_pathProps = {}, $bfd175a5af321bd0$var$_defineProperty(_pathProps, "".concat(tickYAttr, "1"), pos), $bfd175a5af321bd0$var$_defineProperty(_pathProps, "".concat(tickYAttr, "2"), pos), $bfd175a5af321bd0$var$_defineProperty(_pathProps, "".concat(tickXAttr, "1"), 0), $bfd175a5af321bd0$var$_defineProperty(_pathProps, "".concat(tickXAttr, "2"), length), _pathProps);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $bfd175a5af321bd0$var$_extends({}, pathProps, {
                        key: i,
                        className: "rv-xy-plot__grid-lines__line",
                        style: style
                    }));
                }));
            }
        }
    ]);
    return GridLines;
}((0, $acw62.PureComponent));
$bfd175a5af321bd0$var$GridLines.displayName = "GridLines";
$bfd175a5af321bd0$var$GridLines.defaultProps = $bfd175a5af321bd0$var$defaultProps;
$bfd175a5af321bd0$var$GridLines.propTypes = $bfd175a5af321bd0$var$propTypes;
$bfd175a5af321bd0$var$GridLines.requiresSVG = true;
var $bfd175a5af321bd0$export$2e2bcd8739ae039 = $bfd175a5af321bd0$var$GridLines;



var $acw62 = parcelRequire("acw62");




function $c82ebc9a2136cfa4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c82ebc9a2136cfa4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c82ebc9a2136cfa4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c82ebc9a2136cfa4$var$_typeof(obj);
}
function $c82ebc9a2136cfa4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c82ebc9a2136cfa4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c82ebc9a2136cfa4$var$ownKeys(Object(source), true).forEach(function(key) {
            $c82ebc9a2136cfa4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c82ebc9a2136cfa4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c82ebc9a2136cfa4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c82ebc9a2136cfa4$var$_extends() {
    $c82ebc9a2136cfa4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c82ebc9a2136cfa4$var$_extends.apply(this, arguments);
}
function $c82ebc9a2136cfa4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c82ebc9a2136cfa4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c82ebc9a2136cfa4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c82ebc9a2136cfa4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c82ebc9a2136cfa4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c82ebc9a2136cfa4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c82ebc9a2136cfa4$var$_setPrototypeOf(subClass, superClass);
}
function $c82ebc9a2136cfa4$var$_setPrototypeOf(o, p) {
    $c82ebc9a2136cfa4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c82ebc9a2136cfa4$var$_setPrototypeOf(o, p);
}
function $c82ebc9a2136cfa4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c82ebc9a2136cfa4$var$_isNativeReflectConstruct();
    return function() {
        var Super = $c82ebc9a2136cfa4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c82ebc9a2136cfa4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c82ebc9a2136cfa4$var$_possibleConstructorReturn(this, result);
    };
}
function $c82ebc9a2136cfa4$var$_possibleConstructorReturn(self, call) {
    if (call && ($c82ebc9a2136cfa4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c82ebc9a2136cfa4$var$_assertThisInitialized(self);
}
function $c82ebc9a2136cfa4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c82ebc9a2136cfa4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c82ebc9a2136cfa4$var$_getPrototypeOf(o) {
    $c82ebc9a2136cfa4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c82ebc9a2136cfa4$var$_getPrototypeOf(o);
}
var $c82ebc9a2136cfa4$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--heatmap";
var $c82ebc9a2136cfa4$var$HeatmapSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $c82ebc9a2136cfa4$var$_inherits(HeatmapSeries, _AbstractSeries);
    var _super = $c82ebc9a2136cfa4$var$_createSuper(HeatmapSeries);
    function HeatmapSeries() {
        $c82ebc9a2136cfa4$var$_classCallCheck(this, HeatmapSeries);
        return _super.apply(this, arguments);
    }
    $c82ebc9a2136cfa4$var$_createClass(HeatmapSeries, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, animation = _this$props.animation, className = _this$props.className, data = _this$props.data, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, style = _this$props.style;
                if (!data) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $c82ebc9a2136cfa4$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(HeatmapSeries, $c82ebc9a2136cfa4$var$_extends({}, this.props, {
                    animation: null
                })));
                var _rectStyle$style = $c82ebc9a2136cfa4$var$_objectSpread({
                    rectStyle: {}
                }, style), rectStyle = _rectStyle$style.rectStyle;
                var x = this._getAttributeFunctor("x");
                var y = this._getAttributeFunctor("y");
                var opacity = this._getAttributeFunctor("opacity");
                var fill = this._getAttributeFunctor("fill") || this._getAttributeFunctor("color");
                var stroke = this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color");
                var xDistance = this._getScaleDistance("x");
                var yDistance = this._getScaleDistance("y");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($c82ebc9a2136cfa4$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")")
                }, data.map(function(d, i) {
                    var attrs = $c82ebc9a2136cfa4$var$_objectSpread($c82ebc9a2136cfa4$var$_objectSpread({
                        style: $c82ebc9a2136cfa4$var$_objectSpread({
                            stroke: stroke && stroke(d),
                            fill: fill && fill(d),
                            opacity: opacity && opacity(d)
                        }, style)
                    }, rectStyle), {}, {
                        x: x(d) - xDistance / 2,
                        y: y(d) - yDistance / 2,
                        width: xDistance,
                        height: yDistance,
                        onClick: function onClick(e) {
                            return _this._valueClickHandler(d, e);
                        },
                        onContextMenu: function onContextMenu(e) {
                            return _this._valueRightClickHandler(d, e);
                        },
                        onMouseOver: function onMouseOver(e) {
                            return _this._valueMouseOverHandler(d, e);
                        },
                        onMouseOut: function onMouseOut(e) {
                            return _this._valueMouseOutHandler(d, e);
                        }
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", $c82ebc9a2136cfa4$var$_extends({
                        key: i
                    }, attrs));
                }));
            }
        }
    ], [
        {
            key: "getParentConfig",
            value: function getParentConfig(attr) {
                var isDomainAdjustmentNeeded = attr === "x" || attr === "y";
                return {
                    isDomainAdjustmentNeeded: isDomainAdjustmentNeeded
                };
            }
        }
    ]);
    return HeatmapSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$c82ebc9a2136cfa4$var$HeatmapSeries.propTypes = $c82ebc9a2136cfa4$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes);
$c82ebc9a2136cfa4$var$HeatmapSeries.displayName = "HeatmapSeries";
var $c82ebc9a2136cfa4$export$2e2bcd8739ae039 = $c82ebc9a2136cfa4$var$HeatmapSeries;



var $acw62 = parcelRequire("acw62");


var $28bd4c13f05a9ff5$var$thirdPi = Math.PI / 3, $28bd4c13f05a9ff5$var$angles = [
    0,
    $28bd4c13f05a9ff5$var$thirdPi,
    2 * $28bd4c13f05a9ff5$var$thirdPi,
    3 * $28bd4c13f05a9ff5$var$thirdPi,
    4 * $28bd4c13f05a9ff5$var$thirdPi,
    5 * $28bd4c13f05a9ff5$var$thirdPi
];
function $28bd4c13f05a9ff5$var$pointX(d) {
    return d[0];
}
function $28bd4c13f05a9ff5$var$pointY(d) {
    return d[1];
}
function $28bd4c13f05a9ff5$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 1, y1 = 1, x = $28bd4c13f05a9ff5$var$pointX, y = $28bd4c13f05a9ff5$var$pointY, r, dx, dy;
    function hexbin(points) {
        var binsById = {}, bins = [], i, n = points.length;
        for(i = 0; i < n; ++i){
            if (isNaN(px = +x.call(null, point = points[i], i, points)) || isNaN(py = +y.call(null, point, i, points))) continue;
            var point, px, py, pj = Math.round(py = py / dy), pi = Math.round(px = px / dx - (pj & 1) / 2), py1 = py - pj;
            if (Math.abs(py1) * 3 > 1) {
                var px1 = px - pi, pi2 = pi + (px < pi ? -1 : 1) / 2, pj2 = pj + (py < pj ? -1 : 1), px2 = px - pi2, py2 = py - pj2;
                if (px1 * px1 + py1 * py1 > px2 * px2 + py2 * py2) pi = pi2 + (pj & 1 ? 1 : -1) / 2, pj = pj2;
            }
            var id = pi + "-" + pj, bin = binsById[id];
            if (bin) bin.push(point);
            else {
                bins.push(bin = binsById[id] = [
                    point
                ]);
                bin.x = (pi + (pj & 1) / 2) * dx;
                bin.y = pj * dy;
            }
        }
        return bins;
    }
    function hexagon(radius) {
        var x0 = 0, y0 = 0;
        return $28bd4c13f05a9ff5$var$angles.map(function(angle) {
            var x1 = Math.sin(angle) * radius, y1 = -Math.cos(angle) * radius, dx = x1 - x0, dy = y1 - y0;
            x0 = x1, y0 = y1;
            return [
                dx,
                dy
            ];
        });
    }
    hexbin.hexagon = function(radius) {
        return "m" + hexagon(radius == null ? r : +radius).join("l") + "z";
    };
    hexbin.centers = function() {
        var centers = [], j = Math.round(y0 / dy), i = Math.round(x0 / dx);
        for(var y = j * dy; y < y1 + r; y += dy, ++j)for(var x = i * dx + (j & 1) * dx / 2; x < x1 + dx / 2; x += dx)centers.push([
            x,
            y
        ]);
        return centers;
    };
    hexbin.mesh = function() {
        var fragment = hexagon(r).slice(0, 4).join("l");
        return hexbin.centers().map(function(p) {
            return "M" + p + "m" + fragment;
        }).join("");
    };
    hexbin.x = function(_) {
        return arguments.length ? (x = _, hexbin) : x;
    };
    hexbin.y = function(_) {
        return arguments.length ? (y = _, hexbin) : y;
    };
    hexbin.radius = function(_) {
        return arguments.length ? (r = +_, dx = r * 2 * Math.sin($28bd4c13f05a9ff5$var$thirdPi), dy = r * 1.5, hexbin) : r;
    };
    hexbin.size = function(_) {
        return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], hexbin) : [
            x1 - x0,
            y1 - y0
        ];
    };
    hexbin.extent = function(_) {
        return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], hexbin) : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    return hexbin.radius(1);
}









function $2cdf0c7db572669c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2cdf0c7db572669c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2cdf0c7db572669c$var$ownKeys(Object(source), true).forEach(function(key) {
            $2cdf0c7db572669c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2cdf0c7db572669c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2cdf0c7db572669c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2cdf0c7db572669c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2cdf0c7db572669c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2cdf0c7db572669c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2cdf0c7db572669c$var$_typeof(obj);
}
function $2cdf0c7db572669c$var$_extends() {
    $2cdf0c7db572669c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2cdf0c7db572669c$var$_extends.apply(this, arguments);
}
function $2cdf0c7db572669c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2cdf0c7db572669c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2cdf0c7db572669c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2cdf0c7db572669c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2cdf0c7db572669c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2cdf0c7db572669c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $2cdf0c7db572669c$var$_setPrototypeOf(subClass, superClass);
}
function $2cdf0c7db572669c$var$_setPrototypeOf(o, p) {
    $2cdf0c7db572669c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2cdf0c7db572669c$var$_setPrototypeOf(o, p);
}
function $2cdf0c7db572669c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2cdf0c7db572669c$var$_isNativeReflectConstruct();
    return function() {
        var Super = $2cdf0c7db572669c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2cdf0c7db572669c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2cdf0c7db572669c$var$_possibleConstructorReturn(this, result);
    };
}
function $2cdf0c7db572669c$var$_possibleConstructorReturn(self, call) {
    if (call && ($2cdf0c7db572669c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $2cdf0c7db572669c$var$_assertThisInitialized(self);
}
function $2cdf0c7db572669c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2cdf0c7db572669c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2cdf0c7db572669c$var$_getPrototypeOf(o) {
    $2cdf0c7db572669c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2cdf0c7db572669c$var$_getPrototypeOf(o);
}
function $2cdf0c7db572669c$var$_toConsumableArray(arr) {
    return $2cdf0c7db572669c$var$_arrayWithoutHoles(arr) || $2cdf0c7db572669c$var$_iterableToArray(arr) || $2cdf0c7db572669c$var$_unsupportedIterableToArray(arr) || $2cdf0c7db572669c$var$_nonIterableSpread();
}
function $2cdf0c7db572669c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2cdf0c7db572669c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2cdf0c7db572669c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2cdf0c7db572669c$var$_arrayLikeToArray(o, minLen);
}
function $2cdf0c7db572669c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $2cdf0c7db572669c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2cdf0c7db572669c$var$_arrayLikeToArray(arr);
}
function $2cdf0c7db572669c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $2cdf0c7db572669c$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--hexbin";
function $2cdf0c7db572669c$var$getColorDomain(_ref, hexes) {
    var countDomain = _ref.countDomain;
    if (countDomain) return countDomain;
    return [
        0,
        Math.max.apply(Math, $2cdf0c7db572669c$var$_toConsumableArray(hexes.map(function(row) {
            return row.length;
        })))
    ];
}
var $2cdf0c7db572669c$var$HexbinSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $2cdf0c7db572669c$var$_inherits(HexbinSeries, _AbstractSeries);
    var _super = $2cdf0c7db572669c$var$_createSuper(HexbinSeries);
    function HexbinSeries() {
        $2cdf0c7db572669c$var$_classCallCheck(this, HexbinSeries);
        return _super.apply(this, arguments);
    }
    $2cdf0c7db572669c$var$_createClass(HexbinSeries, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, animation = _this$props.animation, className = _this$props.className, colorRange = _this$props.colorRange, data = _this$props.data, innerHeight = _this$props.innerHeight, innerWidth = _this$props.innerWidth, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, radius = _this$props.radius, sizeHexagonsWithCount = _this$props.sizeHexagonsWithCount, style = _this$props.style, xOffset = _this$props.xOffset, yOffset = _this$props.yOffset;
                if (!data) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $2cdf0c7db572669c$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(HexbinSeries, $2cdf0c7db572669c$var$_extends({}, this.props, {
                    animation: null
                })));
                var x = this._getAttributeFunctor("x");
                var y = this._getAttributeFunctor("y");
                var hex = (0, $28bd4c13f05a9ff5$export$2e2bcd8739ae039)().x(function(d) {
                    return x(d) + xOffset;
                }).y(function(d) {
                    return y(d) + yOffset;
                }).radius(radius).size([
                    innerWidth,
                    innerHeight
                ]);
                var hexagonPath = hex.hexagon();
                var hexes = hex(data);
                var countDomain = $2cdf0c7db572669c$var$getColorDomain(this.props, hexes);
                var color = (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)().domain(countDomain).range(colorRange);
                var size = (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)().domain(countDomain).range([
                    0,
                    radius
                ]);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($2cdf0c7db572669c$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")")
                }, hexes.map(function(d, i) {
                    var attrs = {
                        style: style,
                        d: sizeHexagonsWithCount ? hex.hexagon(size(d.length)) : hexagonPath,
                        fill: color(d.length),
                        transform: "translate(".concat(d.x, ", ").concat(d.y, ")"),
                        onClick: function onClick(e) {
                            return _this._valueClickHandler(d, e);
                        },
                        onContextMenu: function onContextMenu(e) {
                            return _this._valueRightClickHandler(d, e);
                        },
                        onMouseOver: function onMouseOver(e) {
                            return _this._valueMouseOverHandler(d, e);
                        },
                        onMouseOut: function onMouseOut(e) {
                            return _this._valueMouseOutHandler(d, e);
                        }
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $2cdf0c7db572669c$var$_extends({
                        key: String(i)
                    }, attrs));
                }));
            }
        }
    ]);
    return HexbinSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$2cdf0c7db572669c$var$HexbinSeries.propTypes = $2cdf0c7db572669c$var$_objectSpread($2cdf0c7db572669c$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
});
$2cdf0c7db572669c$var$HexbinSeries.defaultProps = {
    radius: 20,
    colorRange: (0, $d629c93f7b094ef1$export$36688c8ae3834bf8),
    xOffset: 0,
    yOffset: 0
};
$2cdf0c7db572669c$var$HexbinSeries.displayName = "HexbinSeries";
var $2cdf0c7db572669c$export$2e2bcd8739ae039 = $2cdf0c7db572669c$var$HexbinSeries;



var $acw62 = parcelRequire("acw62");




function $500a384b6c14ad41$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $500a384b6c14ad41$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $500a384b6c14ad41$var$ownKeys(Object(source), true).forEach(function(key) {
            $500a384b6c14ad41$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $500a384b6c14ad41$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $500a384b6c14ad41$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $500a384b6c14ad41$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $500a384b6c14ad41$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $500a384b6c14ad41$var$_typeof(obj);
}
function $500a384b6c14ad41$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $500a384b6c14ad41$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $500a384b6c14ad41$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $500a384b6c14ad41$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $500a384b6c14ad41$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $500a384b6c14ad41$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $500a384b6c14ad41$var$_setPrototypeOf(subClass, superClass);
}
function $500a384b6c14ad41$var$_setPrototypeOf(o, p) {
    $500a384b6c14ad41$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $500a384b6c14ad41$var$_setPrototypeOf(o, p);
}
function $500a384b6c14ad41$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $500a384b6c14ad41$var$_isNativeReflectConstruct();
    return function() {
        var Super = $500a384b6c14ad41$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $500a384b6c14ad41$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $500a384b6c14ad41$var$_possibleConstructorReturn(this, result);
    };
}
function $500a384b6c14ad41$var$_possibleConstructorReturn(self, call) {
    if (call && ($500a384b6c14ad41$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $500a384b6c14ad41$var$_assertThisInitialized(self);
}
function $500a384b6c14ad41$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $500a384b6c14ad41$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $500a384b6c14ad41$var$_getPrototypeOf(o) {
    $500a384b6c14ad41$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $500a384b6c14ad41$var$_getPrototypeOf(o);
}
function $500a384b6c14ad41$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $500a384b6c14ad41$var$getLocs(evt) {
    var xLoc = evt.type === "touchstart" ? evt.pageX : evt.offsetX;
    var yLoc = evt.type === "touchstart" ? evt.pageY : evt.offsetY;
    return {
        xLoc: xLoc,
        yLoc: yLoc
    };
}
var $500a384b6c14ad41$var$Highlight = /*#__PURE__*/ function(_AbstractSeries) {
    $500a384b6c14ad41$var$_inherits(Highlight, _AbstractSeries);
    var _super = $500a384b6c14ad41$var$_createSuper(Highlight);
    function Highlight() {
        var _this;
        $500a384b6c14ad41$var$_classCallCheck(this, Highlight);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $500a384b6c14ad41$var$_defineProperty($500a384b6c14ad41$var$_assertThisInitialized(_this), "state", {
            dragging: false,
            brushArea: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            brushing: false,
            startLocX: 0,
            startLocY: 0,
            dragArea: null
        });
        return _this;
    }
    $500a384b6c14ad41$var$_createClass(Highlight, [
        {
            key: "_getDrawArea",
            value: function _getDrawArea(xLoc, yLoc) {
                var _this$state = this.state, startLocX = _this$state.startLocX, startLocY = _this$state.startLocY;
                var _this$props = this.props, enableX = _this$props.enableX, enableY = _this$props.enableY, highlightWidth = _this$props.highlightWidth, highlightHeight = _this$props.highlightHeight, innerWidth = _this$props.innerWidth, innerHeight = _this$props.innerHeight, marginLeft = _this$props.marginLeft, marginRight = _this$props.marginRight, marginBottom = _this$props.marginBottom, marginTop = _this$props.marginTop;
                var plotHeight = innerHeight + marginTop + marginBottom;
                var plotWidth = innerWidth + marginLeft + marginRight;
                var touchWidth = highlightWidth || plotWidth;
                var touchHeight = highlightHeight || plotHeight;
                return {
                    bottom: enableY ? Math.max(startLocY, yLoc) : touchHeight,
                    right: enableX ? Math.max(startLocX, xLoc) : touchWidth,
                    left: enableX ? Math.min(xLoc, startLocX) : 0,
                    top: enableY ? Math.min(yLoc, startLocY) : 0
                };
            }
        },
        {
            key: "_getDragArea",
            value: function _getDragArea(xLoc, yLoc) {
                var _this$props2 = this.props, enableX = _this$props2.enableX, enableY = _this$props2.enableY;
                var _this$state2 = this.state, startLocX = _this$state2.startLocX, startLocY = _this$state2.startLocY, dragArea = _this$state2.dragArea;
                return {
                    bottom: dragArea.bottom + (enableY ? yLoc - startLocY : 0),
                    left: dragArea.left + (enableX ? xLoc - startLocX : 0),
                    right: dragArea.right + (enableX ? xLoc - startLocX : 0),
                    top: dragArea.top + (enableY ? yLoc - startLocY : 0)
                };
            }
        },
        {
            key: "_clickedOutsideDrag",
            value: function _clickedOutsideDrag(xLoc, yLoc) {
                var _this$props3 = this.props, enableX = _this$props3.enableX, enableY = _this$props3.enableY;
                var _this$state3 = this.state, dragArea = _this$state3.dragArea, _this$state3$brushAre = _this$state3.brushArea, left = _this$state3$brushAre.left, right = _this$state3$brushAre.right, top = _this$state3$brushAre.top, bottom = _this$state3$brushAre.bottom;
                var clickedOutsideDragX = dragArea && (xLoc < left || xLoc > right);
                var clickedOutsideDragY = dragArea && (yLoc < top || yLoc > bottom);
                if (enableX && enableY) return clickedOutsideDragX || clickedOutsideDragY;
                if (enableX) return clickedOutsideDragX;
                if (enableY) return clickedOutsideDragY;
                return true;
            }
        },
        {
            key: "_convertAreaToCoordinates",
            value: function _convertAreaToCoordinates(brushArea) {
                // NOTE only continuous scales are supported for brushing/getting coordinates back
                var _this$props4 = this.props, enableX = _this$props4.enableX, enableY = _this$props4.enableY, marginLeft = _this$props4.marginLeft, marginTop = _this$props4.marginTop;
                var xScale = (0, $379b4f4f942d44ab$export$cb87eff04da17d9)(this.props, "x");
                var yScale = (0, $379b4f4f942d44ab$export$cb87eff04da17d9)(this.props, "y"); // Ensure that users wishes are being respected about which scales are evaluated
                // this is specifically enabled to ensure brushing on mixed categorical and linear
                // charts will run as expected
                if (enableX && enableY) return {
                    bottom: yScale.invert(brushArea.bottom),
                    left: xScale.invert(brushArea.left - marginLeft),
                    right: xScale.invert(brushArea.right - marginLeft),
                    top: yScale.invert(brushArea.top)
                };
                if (enableY) return {
                    bottom: yScale.invert(brushArea.bottom - marginTop),
                    top: yScale.invert(brushArea.top - marginTop)
                };
                if (enableX) return {
                    left: xScale.invert(brushArea.left - marginLeft),
                    right: xScale.invert(brushArea.right - marginLeft)
                };
                return {};
            }
        },
        {
            key: "startBrushing",
            value: function startBrushing(e) {
                var _this2 = this;
                var _this$props5 = this.props, onBrushStart = _this$props5.onBrushStart, onDragStart = _this$props5.onDragStart, drag = _this$props5.drag;
                var dragArea = this.state.dragArea;
                var _getLocs = $500a384b6c14ad41$var$getLocs(e.nativeEvent), xLoc = _getLocs.xLoc, yLoc = _getLocs.yLoc;
                var startArea = function startArea(dragging, resetDrag) {
                    var emptyBrush = {
                        bottom: yLoc,
                        left: xLoc,
                        right: xLoc,
                        top: yLoc
                    };
                    _this2.setState({
                        dragging: dragging,
                        brushArea: dragArea && !resetDrag ? dragArea : emptyBrush,
                        brushing: !dragging,
                        startLocX: xLoc,
                        startLocY: yLoc
                    });
                };
                var clickedOutsideDrag = this._clickedOutsideDrag(xLoc, yLoc);
                if (drag && !dragArea || !drag || clickedOutsideDrag) {
                    startArea(false, clickedOutsideDrag);
                    if (onBrushStart) onBrushStart(e);
                    return;
                }
                if (drag && dragArea) {
                    startArea(true, clickedOutsideDrag);
                    if (onDragStart) onDragStart(e);
                }
            }
        },
        {
            key: "stopBrushing",
            value: function stopBrushing() {
                var _this$state4 = this.state, brushing = _this$state4.brushing, dragging = _this$state4.dragging, brushArea = _this$state4.brushArea; // Quickly short-circuit if the user isn't brushing in our component
                if (!brushing && !dragging) return;
                var _this$props6 = this.props, onBrushEnd = _this$props6.onBrushEnd, onDragEnd = _this$props6.onDragEnd, drag = _this$props6.drag;
                var noHorizontal = Math.abs(brushArea.right - brushArea.left) < 5;
                var noVertical = Math.abs(brushArea.top - brushArea.bottom) < 5; // Invoke the callback with null if the selected area was < 5px
                var isNulled = noVertical || noHorizontal; // Clear the draw area
                this.setState({
                    brushing: false,
                    dragging: false,
                    brushArea: drag ? brushArea : {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    },
                    startLocX: 0,
                    startLocY: 0,
                    dragArea: drag && !isNulled && brushArea
                });
                if (brushing && onBrushEnd) onBrushEnd(!isNulled ? this._convertAreaToCoordinates(brushArea) : null);
                if (drag && onDragEnd) onDragEnd(!isNulled ? this._convertAreaToCoordinates(brushArea) : null);
            }
        },
        {
            key: "onBrush",
            value: function onBrush(e) {
                var _this$props7 = this.props, onBrush = _this$props7.onBrush, onDrag = _this$props7.onDrag, drag = _this$props7.drag;
                var _this$state5 = this.state, brushing = _this$state5.brushing, dragging = _this$state5.dragging;
                var _getLocs2 = $500a384b6c14ad41$var$getLocs(e.nativeEvent), xLoc = _getLocs2.xLoc, yLoc = _getLocs2.yLoc;
                if (brushing) {
                    var brushArea = this._getDrawArea(xLoc, yLoc);
                    this.setState({
                        brushArea: brushArea
                    });
                    if (onBrush) onBrush(this._convertAreaToCoordinates(brushArea));
                }
                if (drag && dragging) {
                    var _brushArea = this._getDragArea(xLoc, yLoc);
                    this.setState({
                        brushArea: _brushArea
                    });
                    if (onDrag) onDrag(this._convertAreaToCoordinates(_brushArea));
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props8 = this.props, color = _this$props8.color, className = _this$props8.className, highlightHeight = _this$props8.highlightHeight, highlightWidth = _this$props8.highlightWidth, highlightX = _this$props8.highlightX, highlightY = _this$props8.highlightY, innerWidth = _this$props8.innerWidth, innerHeight = _this$props8.innerHeight, marginLeft = _this$props8.marginLeft, marginRight = _this$props8.marginRight, marginTop = _this$props8.marginTop, marginBottom = _this$props8.marginBottom, opacity = _this$props8.opacity;
                var _this$state$brushArea = this.state.brushArea, left = _this$state$brushArea.left, right = _this$state$brushArea.right, top = _this$state$brushArea.top, bottom = _this$state$brushArea.bottom;
                var leftPos = 0;
                if (highlightX) {
                    var xScale = (0, $379b4f4f942d44ab$export$cb87eff04da17d9)(this.props, "x");
                    leftPos = xScale(highlightX);
                }
                var topPos = 0;
                if (highlightY) {
                    var yScale = (0, $379b4f4f942d44ab$export$cb87eff04da17d9)(this.props, "y");
                    topPos = yScale(highlightY);
                }
                var plotWidth = marginLeft + marginRight + innerWidth;
                var plotHeight = marginTop + marginBottom + innerHeight;
                var touchWidth = highlightWidth || plotWidth;
                var touchHeight = highlightHeight || plotHeight;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    transform: "translate(".concat(leftPos, ", ").concat(topPos, ")"),
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)(className, "rv-highlight-container")
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    className: "rv-mouse-target",
                    fill: "black",
                    opacity: "0",
                    x: "0",
                    y: "0",
                    width: Math.max(touchWidth, 0),
                    height: Math.max(touchHeight, 0),
                    onMouseDown: function onMouseDown(e) {
                        return _this3.startBrushing(e);
                    },
                    onMouseMove: function onMouseMove(e) {
                        return _this3.onBrush(e);
                    },
                    onMouseUp: function onMouseUp(e) {
                        return _this3.stopBrushing(e);
                    },
                    onMouseLeave: function onMouseLeave(e) {
                        return _this3.stopBrushing(e);
                    } // preventDefault() so that mouse event emulation does not happen
                    ,
                    onTouchEnd: function onTouchEnd(e) {
                        e.preventDefault();
                        _this3.stopBrushing(e);
                    },
                    onTouchCancel: function onTouchCancel(e) {
                        e.preventDefault();
                        _this3.stopBrushing(e);
                    },
                    onContextMenu: function onContextMenu(e) {
                        return e.preventDefault();
                    },
                    onContextMenuCapture: function onContextMenuCapture(e) {
                        return e.preventDefault();
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                    className: "rv-highlight",
                    pointerEvents: "none",
                    opacity: opacity,
                    fill: color,
                    x: left,
                    y: top,
                    width: Math.min(Math.max(0, right - left), touchWidth),
                    height: Math.min(Math.max(0, bottom - top), touchHeight)
                }));
            }
        }
    ]);
    return Highlight;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$500a384b6c14ad41$var$Highlight.displayName = "HighlightOverlay";
$500a384b6c14ad41$var$Highlight.defaultProps = {
    color: "rgb(77, 182, 172)",
    className: "",
    enableX: true,
    enableY: true,
    opacity: 0.3
};
$500a384b6c14ad41$var$Highlight.propTypes = $500a384b6c14ad41$var$_objectSpread($500a384b6c14ad41$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
    enableX: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    enableY: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    highlightHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    highlightWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    highlightX: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]),
    highlightY: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]),
    onBrushStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onBrush: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onBrushEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onDragEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
});
var $500a384b6c14ad41$export$2e2bcd8739ae039 = $500a384b6c14ad41$var$Highlight;



var $acw62 = parcelRequire("acw62");




function $fb39910207614e04$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fb39910207614e04$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fb39910207614e04$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fb39910207614e04$var$_typeof(obj);
}
function $fb39910207614e04$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fb39910207614e04$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fb39910207614e04$var$ownKeys(Object(source), true).forEach(function(key) {
            $fb39910207614e04$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fb39910207614e04$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fb39910207614e04$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fb39910207614e04$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fb39910207614e04$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fb39910207614e04$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fb39910207614e04$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fb39910207614e04$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fb39910207614e04$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $fb39910207614e04$var$_setPrototypeOf(subClass, superClass);
}
function $fb39910207614e04$var$_setPrototypeOf(o, p) {
    $fb39910207614e04$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fb39910207614e04$var$_setPrototypeOf(o, p);
}
function $fb39910207614e04$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fb39910207614e04$var$_isNativeReflectConstruct();
    return function() {
        var Super = $fb39910207614e04$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $fb39910207614e04$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fb39910207614e04$var$_possibleConstructorReturn(this, result);
    };
}
function $fb39910207614e04$var$_possibleConstructorReturn(self, call) {
    if (call && ($fb39910207614e04$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $fb39910207614e04$var$_assertThisInitialized(self);
}
function $fb39910207614e04$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fb39910207614e04$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fb39910207614e04$var$_getPrototypeOf(o) {
    $fb39910207614e04$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fb39910207614e04$var$_getPrototypeOf(o);
}
/*
 * Hint provides two options for placement of hint:
 * a) around a data point in one of four quadrants (imagine the point bisected
 *    by two axes -vertical, horizontal- creating 4 quadrants around a data
 *    point).
 * b) **New** pin to an edge of chart/plot area and position along that edge
 *    using data point's other dimension value.
 *
 * To support these two options, deprecate one Hint props (orientation) with two
 * new Hint align prop object (horizontal, vertical) with following values:
 *
 *   horizontal: auto, left, right, leftEdge, rightEdge
 *   vertical: auto, bottom, top, bottomEdge, topEdge
 *
 * Thus, the following ALIGN constants are the values for horizontal
 * and vertical
 */ var $fb39910207614e04$var$ALIGN = {
    AUTO: "auto",
    LEFT: "left",
    RIGHT: "right",
    LEFT_EDGE: "leftEdge",
    RIGHT_EDGE: "rightEdge",
    BOTTOM: "bottom",
    TOP: "top",
    BOTTOM_EDGE: "bottomEdge",
    TOP_EDGE: "topEdge"
};
/**
 * For backwards support, retain the ORIENTATION prop constants
 */ var $fb39910207614e04$var$ORIENTATION = {
    BOTTOM_LEFT: "bottomleft",
    BOTTOM_RIGHT: "bottomright",
    TOP_LEFT: "topleft",
    TOP_RIGHT: "topright"
};
/**
 * Default format function for the value.
 * @param {Object} value Value.
 * @returns {Array} title-value pairs.
 */ function $fb39910207614e04$var$defaultFormat(value) {
    return Object.keys(value).map(function getProp(key) {
        return {
            title: key,
            value: (0, $a03034fd7b886b96$export$e1b48b0771a44e32)(value[key])
        };
    });
}
var $fb39910207614e04$var$Hint = /*#__PURE__*/ function(_PureComponent) {
    $fb39910207614e04$var$_inherits(Hint, _PureComponent);
    var _super = $fb39910207614e04$var$_createSuper(Hint);
    function Hint() {
        $fb39910207614e04$var$_classCallCheck(this, Hint);
        return _super.apply(this, arguments);
    }
    $fb39910207614e04$var$_createClass(Hint, [
        {
            key: "_getAlign",
            /**
     * Obtain align object with horizontal and vertical settings
     * but convert any AUTO values to the non-auto ALIGN depending on the
     * values of x and y.
     * @param {number} x X value.
     * @param {number} y Y value.
     * @returns {Object} Align object w/ horizontal, vertical prop strings.
     * @private
     */ value: function _getAlign(x, y) {
                var _this$props = this.props, innerWidth = _this$props.innerWidth, innerHeight = _this$props.innerHeight, orientation = _this$props.orientation, _this$props$align = _this$props.align, horizontal = _this$props$align.horizontal, vertical = _this$props$align.vertical;
                var align = orientation ? this._mapOrientationToAlign(orientation) : {
                    horizontal: horizontal,
                    vertical: vertical
                };
                if (horizontal === $fb39910207614e04$var$ALIGN.AUTO) align.horizontal = x > innerWidth / 2 ? $fb39910207614e04$var$ALIGN.LEFT : $fb39910207614e04$var$ALIGN.RIGHT;
                if (vertical === $fb39910207614e04$var$ALIGN.AUTO) align.vertical = y > innerHeight / 2 ? $fb39910207614e04$var$ALIGN.TOP : $fb39910207614e04$var$ALIGN.BOTTOM;
                return align;
            }
        },
        {
            key: "_getAlignClassNames",
            value: function _getAlignClassNames(align) {
                var orientation = this.props.orientation;
                var orientationClass = orientation ? "rv-hint--orientation-".concat(orientation) : "";
                return "".concat(orientationClass, " rv-hint--horizontalAlign-").concat(align.horizontal, "\n     rv-hint--verticalAlign-").concat(align.vertical);
            }
        },
        {
            key: "_getAlignStyle",
            value: function _getAlignStyle(align, x, y) {
                return $fb39910207614e04$var$_objectSpread($fb39910207614e04$var$_objectSpread({}, this._getXCSS(align.horizontal, x)), this._getYCSS(align.vertical, y));
            }
        },
        {
            key: "_getCSSBottom",
            value: function _getCSSBottom(y) {
                if (y === undefined || y === null) return {
                    bottom: 0
                };
                var _this$props2 = this.props, innerHeight = _this$props2.innerHeight, marginBottom = _this$props2.marginBottom;
                return {
                    bottom: marginBottom + innerHeight - y
                };
            }
        },
        {
            key: "_getCSSLeft",
            value: function _getCSSLeft(x) {
                if (x === undefined || x === null) return {
                    left: 0
                };
                var marginLeft = this.props.marginLeft;
                return {
                    left: marginLeft + x
                };
            }
        },
        {
            key: "_getCSSRight",
            value: function _getCSSRight(x) {
                if (x === undefined || x === null) return {
                    right: 0
                };
                var _this$props3 = this.props, innerWidth = _this$props3.innerWidth, marginRight = _this$props3.marginRight;
                return {
                    right: marginRight + innerWidth - x
                };
            }
        },
        {
            key: "_getCSSTop",
            value: function _getCSSTop(y) {
                if (y === undefined || y === null) return {
                    top: 0
                };
                var marginTop = this.props.marginTop;
                return {
                    top: marginTop + y
                };
            }
        },
        {
            key: "_getPositionInfo",
            value: function _getPositionInfo() {
                var _this$props4 = this.props, value = _this$props4.value, getAlignStyle = _this$props4.getAlignStyle;
                var x = (0, $379b4f4f942d44ab$export$735c878afad94f32)(this.props, "x")(value);
                var y = (0, $379b4f4f942d44ab$export$735c878afad94f32)(this.props, "y")(value);
                var align = this._getAlign(x, y);
                return {
                    position: getAlignStyle ? getAlignStyle(align, x, y) : this._getAlignStyle(align, x, y),
                    positionClassName: this._getAlignClassNames(align)
                };
            }
        },
        {
            key: "_getXCSS",
            value: function _getXCSS(horizontal, x) {
                // obtain xCSS
                switch(horizontal){
                    case $fb39910207614e04$var$ALIGN.LEFT_EDGE:
                        // this pins x to left edge
                        return this._getCSSLeft(null);
                    case $fb39910207614e04$var$ALIGN.RIGHT_EDGE:
                        // this pins x to left edge
                        return this._getCSSRight(null);
                    case $fb39910207614e04$var$ALIGN.LEFT:
                        // this places hint text to the left of center, so set its right edge
                        return this._getCSSRight(x);
                    case $fb39910207614e04$var$ALIGN.RIGHT:
                    default:
                        // this places hint text to the right of center, so set its left edge
                        // default case should not be possible but if it happens set to RIGHT
                        return this._getCSSLeft(x);
                }
            }
        },
        {
            key: "_getYCSS",
            value: function _getYCSS(verticalAlign, y) {
                // obtain yCSS
                switch(verticalAlign){
                    case $fb39910207614e04$var$ALIGN.TOP_EDGE:
                        // this pins x to top edge
                        return this._getCSSTop(null);
                    case $fb39910207614e04$var$ALIGN.BOTTOM_EDGE:
                        // this pins x to bottom edge
                        return this._getCSSBottom(null);
                    case $fb39910207614e04$var$ALIGN.BOTTOM:
                        // this places hint text to the bottom of center, so set its top edge
                        return this._getCSSTop(y);
                    case $fb39910207614e04$var$ALIGN.TOP:
                    default:
                        // this places hint text to the top of center, so set its bottom edge
                        // default case should not be possible but if it happens set to BOTTOM
                        return this._getCSSBottom(y);
                }
            }
        },
        {
            key: "_mapOrientationToAlign",
            value: function _mapOrientationToAlign(orientation) {
                // TODO: print warning that this feature is deprecated and support will be
                // removed in next major release.
                switch(orientation){
                    case $fb39910207614e04$var$ORIENTATION.BOTTOM_LEFT:
                        return {
                            horizontal: $fb39910207614e04$var$ALIGN.LEFT,
                            vertical: $fb39910207614e04$var$ALIGN.BOTTOM
                        };
                    case $fb39910207614e04$var$ORIENTATION.BOTTOM_RIGHT:
                        return {
                            horizontal: $fb39910207614e04$var$ALIGN.RIGHT,
                            vertical: $fb39910207614e04$var$ALIGN.BOTTOM
                        };
                    case $fb39910207614e04$var$ORIENTATION.TOP_LEFT:
                        return {
                            horizontal: $fb39910207614e04$var$ALIGN.LEFT,
                            vertical: $fb39910207614e04$var$ALIGN.TOP
                        };
                    case $fb39910207614e04$var$ORIENTATION.TOP_RIGHT:
                        return {
                            horizontal: $fb39910207614e04$var$ALIGN.RIGHT,
                            vertical: $fb39910207614e04$var$ALIGN.TOP
                        };
                    default:
                        break;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, value = _this$props5.value, format = _this$props5.format, children = _this$props5.children, style = _this$props5.style, className = _this$props5.className;
                var _this$_getPositionInf = this._getPositionInfo(), position = _this$_getPositionInf.position, positionClassName = _this$_getPositionInf.positionClassName;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-hint", positionClassName, className),
                    style: $fb39910207614e04$var$_objectSpread($fb39910207614e04$var$_objectSpread($fb39910207614e04$var$_objectSpread({}, style), position), {}, {
                        position: "absolute"
                    })
                }, children ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "rv-hint__content",
                    style: style.content
                }, format(value).map(function(formattedProp, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        key: "rv-hint".concat(i),
                        style: style.row
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        className: "rv-hint__title",
                        style: style.title
                    }, formattedProp.title), ": ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                        className: "rv-hint__value",
                        style: style.value
                    }, formattedProp.value));
                })));
            }
        }
    ], [
        {
            key: "defaultProps",
            get: function get() {
                return {
                    format: $fb39910207614e04$var$defaultFormat,
                    align: {
                        horizontal: $fb39910207614e04$var$ALIGN.AUTO,
                        vertical: $fb39910207614e04$var$ALIGN.AUTO
                    },
                    style: {}
                };
            }
        },
        {
            key: "propTypes",
            get: function get() {
                return {
                    marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
                    marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
                    innerWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
                    innerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
                    scales: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
                    format: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    align: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
                        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
                            $fb39910207614e04$var$ALIGN.AUTO,
                            $fb39910207614e04$var$ALIGN.LEFT,
                            $fb39910207614e04$var$ALIGN.RIGHT,
                            $fb39910207614e04$var$ALIGN.LEFT_EDGE,
                            $fb39910207614e04$var$ALIGN.RIGHT_EDGE
                        ]),
                        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
                            $fb39910207614e04$var$ALIGN.AUTO,
                            $fb39910207614e04$var$ALIGN.BOTTOM,
                            $fb39910207614e04$var$ALIGN.TOP,
                            $fb39910207614e04$var$ALIGN.BOTTOM_EDGE,
                            $fb39910207614e04$var$ALIGN.TOP_EDGE
                        ])
                    }),
                    getAlignStyle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
                        $fb39910207614e04$var$ORIENTATION.BOTTOM_LEFT,
                        $fb39910207614e04$var$ORIENTATION.BOTTOM_RIGHT,
                        $fb39910207614e04$var$ORIENTATION.TOP_LEFT,
                        $fb39910207614e04$var$ORIENTATION.TOP_RIGHT
                    ])
                };
            }
        }
    ]);
    return Hint;
}((0, $acw62.PureComponent));
$fb39910207614e04$var$Hint.displayName = "Hint";
$fb39910207614e04$var$Hint.ORIENTATION = $fb39910207614e04$var$ORIENTATION;
$fb39910207614e04$var$Hint.ALIGN = $fb39910207614e04$var$ALIGN;
var $fb39910207614e04$export$2e2bcd8739ae039 = $fb39910207614e04$var$Hint;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





function $f11fc06aff8a60cc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f11fc06aff8a60cc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f11fc06aff8a60cc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f11fc06aff8a60cc$var$_typeof(obj);
}
function $f11fc06aff8a60cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f11fc06aff8a60cc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f11fc06aff8a60cc$var$ownKeys(Object(source), true).forEach(function(key) {
            $f11fc06aff8a60cc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f11fc06aff8a60cc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f11fc06aff8a60cc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f11fc06aff8a60cc$var$_extends() {
    $f11fc06aff8a60cc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f11fc06aff8a60cc$var$_extends.apply(this, arguments);
}
function $f11fc06aff8a60cc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f11fc06aff8a60cc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f11fc06aff8a60cc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f11fc06aff8a60cc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f11fc06aff8a60cc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f11fc06aff8a60cc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f11fc06aff8a60cc$var$_setPrototypeOf(subClass, superClass);
}
function $f11fc06aff8a60cc$var$_setPrototypeOf(o, p) {
    $f11fc06aff8a60cc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f11fc06aff8a60cc$var$_setPrototypeOf(o, p);
}
function $f11fc06aff8a60cc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f11fc06aff8a60cc$var$_isNativeReflectConstruct();
    return function() {
        var Super = $f11fc06aff8a60cc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f11fc06aff8a60cc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f11fc06aff8a60cc$var$_possibleConstructorReturn(this, result);
    };
}
function $f11fc06aff8a60cc$var$_possibleConstructorReturn(self, call) {
    if (call && ($f11fc06aff8a60cc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f11fc06aff8a60cc$var$_assertThisInitialized(self);
}
function $f11fc06aff8a60cc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f11fc06aff8a60cc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f11fc06aff8a60cc$var$_getPrototypeOf(o) {
    $f11fc06aff8a60cc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f11fc06aff8a60cc$var$_getPrototypeOf(o);
}
var $f11fc06aff8a60cc$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--bar";
var $f11fc06aff8a60cc$var$BarSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $f11fc06aff8a60cc$var$_inherits(BarSeries, _AbstractSeries);
    var _super = $f11fc06aff8a60cc$var$_createSuper(BarSeries);
    function BarSeries() {
        $f11fc06aff8a60cc$var$_classCallCheck(this, BarSeries);
        return _super.apply(this, arguments);
    }
    $f11fc06aff8a60cc$var$_createClass(BarSeries, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, animation = _this$props.animation, className = _this$props.className, data = _this$props.data, linePosAttr = _this$props.linePosAttr, lineSizeAttr = _this$props.lineSizeAttr, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, style = _this$props.style, valuePosAttr = _this$props.valuePosAttr, valueSizeAttr = _this$props.valueSizeAttr, barWidth = _this$props.barWidth;
                if (!data) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $f11fc06aff8a60cc$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BarSeries, $f11fc06aff8a60cc$var$_extends({}, this.props, {
                    animation: null
                })));
                var _getStackParams = (0, $ba94dd19eb06369c$export$e8849e85b4deee73)(this.props), sameTypeTotal = _getStackParams.sameTypeTotal, sameTypeIndex = _getStackParams.sameTypeIndex;
                var distance = this._getScaleDistance(linePosAttr);
                var lineFunctor = this._getAttributeFunctor(linePosAttr);
                var valueFunctor = this._getAttributeFunctor(valuePosAttr);
                var value0Functor = this._getAttr0Functor(valuePosAttr);
                var fillFunctor = this._getAttributeFunctor("fill") || this._getAttributeFunctor("color");
                var strokeFunctor = this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color");
                var opacityFunctor = this._getAttributeFunctor("opacity");
                var halfSpace = distance / 2 * barWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($f11fc06aff8a60cc$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")")
                }, data.map(function(d, i) {
                    var _attrs;
                    // totalSpaceAvailable is the space we have available to draw all the
                    // bars of a same 'linePosAttr' value (a.k.a. sameTypeTotal)
                    var totalSpaceAvailable = halfSpace * 2;
                    var totalSpaceCenter = lineFunctor(d); // totalSpaceStartingPoint is the first pixel were we can start drawing
                    var totalSpaceStartingPoint = totalSpaceCenter - halfSpace; // spaceTakenByInterBarsPixels has the overhead space consumed by each bar of sameTypeTotal
                    var spaceTakenByInterBarsPixels = (sameTypeTotal - 1) / sameTypeTotal; // spacePerBar is the space we have available to draw sameTypeIndex bar
                    var spacePerBar = totalSpaceAvailable / sameTypeTotal - spaceTakenByInterBarsPixels; // barStartingPoint is the first pixel were we can start drawing sameTypeIndex bar
                    var barStartingPoint = totalSpaceStartingPoint + spacePerBar * sameTypeIndex + sameTypeIndex;
                    var attrs = (_attrs = {
                        style: $f11fc06aff8a60cc$var$_objectSpread({
                            opacity: opacityFunctor && opacityFunctor(d),
                            stroke: strokeFunctor && strokeFunctor(d),
                            fill: fillFunctor && fillFunctor(d)
                        }, style)
                    }, $f11fc06aff8a60cc$var$_defineProperty(_attrs, linePosAttr, barStartingPoint), $f11fc06aff8a60cc$var$_defineProperty(_attrs, lineSizeAttr, spacePerBar), $f11fc06aff8a60cc$var$_defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), $f11fc06aff8a60cc$var$_defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), $f11fc06aff8a60cc$var$_defineProperty(_attrs, "onClick", function onClick(e) {
                        return _this._valueClickHandler(d, e);
                    }), $f11fc06aff8a60cc$var$_defineProperty(_attrs, "onContextMenu", function onContextMenu(e) {
                        return _this._valueRightClickHandler(d, e);
                    }), $f11fc06aff8a60cc$var$_defineProperty(_attrs, "onMouseOver", function onMouseOver(e) {
                        return _this._valueMouseOverHandler(d, e);
                    }), $f11fc06aff8a60cc$var$_defineProperty(_attrs, "onMouseOut", function onMouseOut(e) {
                        return _this._valueMouseOutHandler(d, e);
                    }), _attrs);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", $f11fc06aff8a60cc$var$_extends({
                        key: "".concat(i)
                    }, attrs));
                }));
            }
        }
    ], [
        {
            key: "propTypes",
            get: function get() {
                return $f11fc06aff8a60cc$var$_objectSpread($f11fc06aff8a60cc$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
                    linePosAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    valuePosAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    lineSizeAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    valueSizeAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    cluster: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    barWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
                });
            }
        },
        {
            key: "defaultProps",
            get: function get() {
                return {
                    barWidth: 0.85
                };
            }
        }
    ]);
    return BarSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$f11fc06aff8a60cc$var$BarSeries.displayName = "BarSeries";
var $f11fc06aff8a60cc$export$2e2bcd8739ae039 = $f11fc06aff8a60cc$var$BarSeries;


function $1c394d9abad8b75a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1c394d9abad8b75a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1c394d9abad8b75a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1c394d9abad8b75a$var$_typeof(obj);
}
function $1c394d9abad8b75a$var$_extends() {
    $1c394d9abad8b75a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c394d9abad8b75a$var$_extends.apply(this, arguments);
}
function $1c394d9abad8b75a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1c394d9abad8b75a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1c394d9abad8b75a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1c394d9abad8b75a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1c394d9abad8b75a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1c394d9abad8b75a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1c394d9abad8b75a$var$_setPrototypeOf(subClass, superClass);
}
function $1c394d9abad8b75a$var$_setPrototypeOf(o, p) {
    $1c394d9abad8b75a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1c394d9abad8b75a$var$_setPrototypeOf(o, p);
}
function $1c394d9abad8b75a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1c394d9abad8b75a$var$_isNativeReflectConstruct();
    return function() {
        var Super = $1c394d9abad8b75a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1c394d9abad8b75a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1c394d9abad8b75a$var$_possibleConstructorReturn(this, result);
    };
}
function $1c394d9abad8b75a$var$_possibleConstructorReturn(self, call) {
    if (call && ($1c394d9abad8b75a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1c394d9abad8b75a$var$_assertThisInitialized(self);
}
function $1c394d9abad8b75a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1c394d9abad8b75a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1c394d9abad8b75a$var$_getPrototypeOf(o) {
    $1c394d9abad8b75a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1c394d9abad8b75a$var$_getPrototypeOf(o);
}
var $1c394d9abad8b75a$var$HorizontalBarSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $1c394d9abad8b75a$var$_inherits(HorizontalBarSeries, _AbstractSeries);
    var _super = $1c394d9abad8b75a$var$_createSuper(HorizontalBarSeries);
    function HorizontalBarSeries() {
        $1c394d9abad8b75a$var$_classCallCheck(this, HorizontalBarSeries);
        return _super.apply(this, arguments);
    }
    $1c394d9abad8b75a$var$_createClass(HorizontalBarSeries, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f11fc06aff8a60cc$export$2e2bcd8739ae039), $1c394d9abad8b75a$var$_extends({}, this.props, {
                    linePosAttr: "y",
                    valuePosAttr: "x",
                    lineSizeAttr: "height",
                    valueSizeAttr: "width"
                }));
            }
        }
    ], [
        {
            key: "getParentConfig",
            value: function getParentConfig(attr) {
                var isDomainAdjustmentNeeded = attr === "y";
                var zeroBaseValue = attr === "x";
                return {
                    isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
                    zeroBaseValue: zeroBaseValue
                };
            }
        }
    ]);
    return HorizontalBarSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$1c394d9abad8b75a$var$HorizontalBarSeries.displayName = "HorizontalBarSeries";
var $1c394d9abad8b75a$export$2e2bcd8739ae039 = $1c394d9abad8b75a$var$HorizontalBarSeries;





var $bYoiY = parcelRequire("bYoiY");




function $5de732e1f321dfb3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5de732e1f321dfb3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5de732e1f321dfb3$var$ownKeys(Object(source), true).forEach(function(key) {
            $5de732e1f321dfb3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5de732e1f321dfb3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5de732e1f321dfb3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5de732e1f321dfb3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5de732e1f321dfb3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5de732e1f321dfb3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5de732e1f321dfb3$var$_typeof(obj);
}
function $5de732e1f321dfb3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5de732e1f321dfb3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5de732e1f321dfb3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5de732e1f321dfb3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5de732e1f321dfb3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5de732e1f321dfb3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5de732e1f321dfb3$var$_setPrototypeOf(subClass, superClass);
}
function $5de732e1f321dfb3$var$_setPrototypeOf(o, p) {
    $5de732e1f321dfb3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5de732e1f321dfb3$var$_setPrototypeOf(o, p);
}
function $5de732e1f321dfb3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5de732e1f321dfb3$var$_isNativeReflectConstruct();
    return function() {
        var Super = $5de732e1f321dfb3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5de732e1f321dfb3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5de732e1f321dfb3$var$_possibleConstructorReturn(this, result);
    };
}
function $5de732e1f321dfb3$var$_possibleConstructorReturn(self, call) {
    if (call && ($5de732e1f321dfb3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5de732e1f321dfb3$var$_assertThisInitialized(self);
}
function $5de732e1f321dfb3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5de732e1f321dfb3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5de732e1f321dfb3$var$_getPrototypeOf(o) {
    $5de732e1f321dfb3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5de732e1f321dfb3$var$_getPrototypeOf(o);
}
function $5de732e1f321dfb3$var$getScaleDistance(props, attr) {
    var scaleObject = (0, $379b4f4f942d44ab$export$6b08c10e39e8737a)(props, attr);
    return scaleObject ? scaleObject.distance : 0;
}
var $5de732e1f321dfb3$var$BarSeriesCanvas = /*#__PURE__*/ function(_AbstractSeries) {
    $5de732e1f321dfb3$var$_inherits(BarSeriesCanvas, _AbstractSeries);
    var _super = $5de732e1f321dfb3$var$_createSuper(BarSeriesCanvas);
    function BarSeriesCanvas() {
        $5de732e1f321dfb3$var$_classCallCheck(this, BarSeriesCanvas);
        return _super.apply(this, arguments);
    }
    $5de732e1f321dfb3$var$_createClass(BarSeriesCanvas, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ], [
        {
            key: "renderLayer",
            value: function renderLayer(props, ctx) {
                var data = props.data, linePosAttr = props.linePosAttr, lineSizeAttr = props.lineSizeAttr, valuePosAttr = props.valuePosAttr, marginTop = props.marginTop, marginBottom = props.marginBottom;
                if (!data || data.length === 0) return;
                var distance = $5de732e1f321dfb3$var$getScaleDistance(props, linePosAttr);
                var line = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, linePosAttr);
                var value = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, valuePosAttr);
                var value0 = (0, $379b4f4f942d44ab$export$8b4d7b016ad3bc31)(props, valuePosAttr);
                var fill = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "fill") || (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "color");
                var stroke = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "stroke") || (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "color");
                var opacity = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "opacity");
                var halfSpace = distance / 2 * 0.85; // totalSpaceAvailable is the space we have available to draw all the
                // bars of a same 'linePosAttr' value (a.k.a. sameTypeTotal)
                var totalSpaceAvailable = halfSpace * 2;
                var _getStackParams = (0, $ba94dd19eb06369c$export$e8849e85b4deee73)(props), sameTypeTotal = _getStackParams.sameTypeTotal, sameTypeIndex = _getStackParams.sameTypeIndex;
                data.forEach(function(row) {
                    var totalSpaceCenter = line(row); // totalSpaceStartingPoint is the first pixel were we can start drawing
                    var totalSpaceStartingPoint = totalSpaceCenter - halfSpace; // spaceTakenByInterBarsPixels has the overhead space consumed by each bar of sameTypeTotal
                    var spaceTakenByInterBarsPixels = (sameTypeTotal - 1) / sameTypeTotal; // lineSize is the space we have available to draw sameTypeIndex bar
                    var lineSize = totalSpaceAvailable / sameTypeTotal - spaceTakenByInterBarsPixels;
                    var fillColor = (0, $bYoiY.rgb)(fill(row));
                    var strokeColor = (0, $bYoiY.rgb)(stroke(row));
                    var rowOpacity = opacity(row) || (0, $d629c93f7b094ef1$export$95a809b606e7af75); // linePos is the first pixel were we can start drawing sameTypeIndex bar
                    var linePos = totalSpaceStartingPoint + lineSize * sameTypeIndex + sameTypeIndex;
                    var valuePos = Math.min(value0(row), value(row));
                    var x = valuePosAttr === "x" ? valuePos : linePos;
                    var y = valuePosAttr === "y" ? valuePos : linePos;
                    var valueSize = Math.abs(-value0(row) + value(row));
                    var height = lineSizeAttr === "height" ? lineSize : valueSize;
                    var width = lineSizeAttr === "width" ? lineSize : valueSize;
                    ctx.beginPath();
                    ctx.rect(x + marginBottom, y + marginTop, width, height);
                    ctx.fillStyle = "rgba(".concat(fillColor.r, ", ").concat(fillColor.g, ", ").concat(fillColor.b, ", ").concat(rowOpacity, ")");
                    ctx.fill();
                    ctx.strokeStyle = "rgba(".concat(strokeColor.r, ", ").concat(strokeColor.g, ", ").concat(strokeColor.b, ", ").concat(rowOpacity, ")");
                    ctx.stroke();
                });
            }
        },
        {
            key: "requiresSVG",
            get: function get() {
                return false;
            }
        },
        {
            key: "isCanvas",
            get: function get() {
                return true;
            }
        }
    ]);
    return BarSeriesCanvas;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$5de732e1f321dfb3$var$BarSeriesCanvas.displayName = "BarSeriesCanvas";
$5de732e1f321dfb3$var$BarSeriesCanvas.defaultProps = $5de732e1f321dfb3$var$_objectSpread($5de732e1f321dfb3$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).defaultProps), {}, {
    linePosAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    valuePosAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    lineSizeAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    valueSizeAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired
});
$5de732e1f321dfb3$var$BarSeriesCanvas.propTypes = $5de732e1f321dfb3$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes);
var $5de732e1f321dfb3$export$2e2bcd8739ae039 = $5de732e1f321dfb3$var$BarSeriesCanvas;


function $6e047d77aef99b2f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6e047d77aef99b2f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6e047d77aef99b2f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6e047d77aef99b2f$var$_typeof(obj);
}
function $6e047d77aef99b2f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6e047d77aef99b2f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6e047d77aef99b2f$var$ownKeys(Object(source), true).forEach(function(key) {
            $6e047d77aef99b2f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6e047d77aef99b2f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6e047d77aef99b2f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6e047d77aef99b2f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e047d77aef99b2f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6e047d77aef99b2f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6e047d77aef99b2f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e047d77aef99b2f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6e047d77aef99b2f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6e047d77aef99b2f$var$_setPrototypeOf(subClass, superClass);
}
function $6e047d77aef99b2f$var$_setPrototypeOf(o, p) {
    $6e047d77aef99b2f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6e047d77aef99b2f$var$_setPrototypeOf(o, p);
}
function $6e047d77aef99b2f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6e047d77aef99b2f$var$_isNativeReflectConstruct();
    return function() {
        var Super = $6e047d77aef99b2f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6e047d77aef99b2f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6e047d77aef99b2f$var$_possibleConstructorReturn(this, result);
    };
}
function $6e047d77aef99b2f$var$_possibleConstructorReturn(self, call) {
    if (call && ($6e047d77aef99b2f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6e047d77aef99b2f$var$_assertThisInitialized(self);
}
function $6e047d77aef99b2f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6e047d77aef99b2f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6e047d77aef99b2f$var$_getPrototypeOf(o) {
    $6e047d77aef99b2f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6e047d77aef99b2f$var$_getPrototypeOf(o);
}
var $6e047d77aef99b2f$var$HorizontalBarSeriesCanvas = /*#__PURE__*/ function(_AbstractSeries) {
    $6e047d77aef99b2f$var$_inherits(HorizontalBarSeriesCanvas, _AbstractSeries);
    var _super = $6e047d77aef99b2f$var$_createSuper(HorizontalBarSeriesCanvas);
    function HorizontalBarSeriesCanvas() {
        $6e047d77aef99b2f$var$_classCallCheck(this, HorizontalBarSeriesCanvas);
        return _super.apply(this, arguments);
    }
    $6e047d77aef99b2f$var$_createClass(HorizontalBarSeriesCanvas, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ], [
        {
            key: "getParentConfig",
            value: function getParentConfig(attr) {
                var isDomainAdjustmentNeeded = attr === "y";
                var zeroBaseValue = attr === "x";
                return {
                    isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
                    zeroBaseValue: zeroBaseValue
                };
            }
        },
        {
            key: "renderLayer",
            value: function renderLayer(props, ctx) {
                (0, $5de732e1f321dfb3$export$2e2bcd8739ae039).renderLayer($6e047d77aef99b2f$var$_objectSpread($6e047d77aef99b2f$var$_objectSpread({}, props), {}, {
                    linePosAttr: "y",
                    valuePosAttr: "x",
                    lineSizeAttr: "height",
                    valueSizeAttr: "width"
                }), ctx);
            }
        },
        {
            key: "requiresSVG",
            get: function get() {
                return false;
            }
        },
        {
            key: "isCanvas",
            get: function get() {
                return true;
            }
        }
    ]);
    return HorizontalBarSeriesCanvas;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$6e047d77aef99b2f$var$HorizontalBarSeriesCanvas.displayName = "HorizontalBarSeriesCanvas";
$6e047d77aef99b2f$var$HorizontalBarSeriesCanvas.propTypes = $6e047d77aef99b2f$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes);
var $6e047d77aef99b2f$export$2e2bcd8739ae039 = $6e047d77aef99b2f$var$HorizontalBarSeriesCanvas;



var $acw62 = parcelRequire("acw62");



function $700fae1910d27d13$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $700fae1910d27d13$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $700fae1910d27d13$var$ownKeys(Object(source), true).forEach(function(key) {
            $700fae1910d27d13$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $700fae1910d27d13$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $700fae1910d27d13$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $700fae1910d27d13$var$HORIZONTAL = (0, $16d91db751e2a422$export$9106728c49045482).HORIZONTAL;
var $700fae1910d27d13$var$propTypes = $700fae1910d27d13$var$_objectSpread($700fae1910d27d13$var$_objectSpread({}, (0, $bfd175a5af321bd0$export$2e2bcd8739ae039).propTypes), {}, {
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        $700fae1910d27d13$var$HORIZONTAL
    ])
});
var $700fae1910d27d13$var$defaultProps = {
    direction: $700fae1910d27d13$var$HORIZONTAL,
    attr: "y"
};
function $700fae1910d27d13$var$HorizontalGridLines(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfd175a5af321bd0$export$2e2bcd8739ae039), props);
}
$700fae1910d27d13$var$HorizontalGridLines.displayName = "HorizontalGridLines";
$700fae1910d27d13$var$HorizontalGridLines.propTypes = $700fae1910d27d13$var$propTypes;
$700fae1910d27d13$var$HorizontalGridLines.defaultProps = $700fae1910d27d13$var$defaultProps;
$700fae1910d27d13$var$HorizontalGridLines.requiresSVG = true;
var $700fae1910d27d13$export$2e2bcd8739ae039 = $700fae1910d27d13$var$HorizontalGridLines;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





function $5f24d9e6365e3e1e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5f24d9e6365e3e1e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5f24d9e6365e3e1e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5f24d9e6365e3e1e$var$_typeof(obj);
}
function $5f24d9e6365e3e1e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5f24d9e6365e3e1e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5f24d9e6365e3e1e$var$ownKeys(Object(source), true).forEach(function(key) {
            $5f24d9e6365e3e1e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5f24d9e6365e3e1e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5f24d9e6365e3e1e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5f24d9e6365e3e1e$var$_extends() {
    $5f24d9e6365e3e1e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5f24d9e6365e3e1e$var$_extends.apply(this, arguments);
}
function $5f24d9e6365e3e1e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5f24d9e6365e3e1e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5f24d9e6365e3e1e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5f24d9e6365e3e1e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5f24d9e6365e3e1e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5f24d9e6365e3e1e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5f24d9e6365e3e1e$var$_setPrototypeOf(subClass, superClass);
}
function $5f24d9e6365e3e1e$var$_setPrototypeOf(o, p) {
    $5f24d9e6365e3e1e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5f24d9e6365e3e1e$var$_setPrototypeOf(o, p);
}
function $5f24d9e6365e3e1e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5f24d9e6365e3e1e$var$_isNativeReflectConstruct();
    return function() {
        var Super = $5f24d9e6365e3e1e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5f24d9e6365e3e1e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5f24d9e6365e3e1e$var$_possibleConstructorReturn(this, result);
    };
}
function $5f24d9e6365e3e1e$var$_possibleConstructorReturn(self, call) {
    if (call && ($5f24d9e6365e3e1e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5f24d9e6365e3e1e$var$_assertThisInitialized(self);
}
function $5f24d9e6365e3e1e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5f24d9e6365e3e1e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5f24d9e6365e3e1e$var$_getPrototypeOf(o) {
    $5f24d9e6365e3e1e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5f24d9e6365e3e1e$var$_getPrototypeOf(o);
}
var $5f24d9e6365e3e1e$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--rect";
var $5f24d9e6365e3e1e$var$RectSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $5f24d9e6365e3e1e$var$_inherits(RectSeries, _AbstractSeries);
    var _super = $5f24d9e6365e3e1e$var$_createSuper(RectSeries);
    function RectSeries() {
        $5f24d9e6365e3e1e$var$_classCallCheck(this, RectSeries);
        return _super.apply(this, arguments);
    }
    $5f24d9e6365e3e1e$var$_createClass(RectSeries, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, animation = _this$props.animation, className = _this$props.className, data = _this$props.data, linePosAttr = _this$props.linePosAttr, lineSizeAttr = _this$props.lineSizeAttr, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, style = _this$props.style, valuePosAttr = _this$props.valuePosAttr, valueSizeAttr = _this$props.valueSizeAttr;
                if (!data) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $5f24d9e6365e3e1e$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(RectSeries, $5f24d9e6365e3e1e$var$_extends({}, this.props, {
                    animation: null
                })));
                var lineFunctor = this._getAttributeFunctor(linePosAttr);
                var line0Functor = this._getAttr0Functor(linePosAttr);
                var valueFunctor = this._getAttributeFunctor(valuePosAttr);
                var value0Functor = this._getAttr0Functor(valuePosAttr);
                var fillFunctor = this._getAttributeFunctor("fill") || this._getAttributeFunctor("color");
                var strokeFunctor = this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color");
                var opacityFunctor = this._getAttributeFunctor("opacity");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($5f24d9e6365e3e1e$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")")
                }, data.map(function(d, i) {
                    var _attrs;
                    var attrs = (_attrs = {
                        style: $5f24d9e6365e3e1e$var$_objectSpread({
                            opacity: opacityFunctor && opacityFunctor(d),
                            stroke: strokeFunctor && strokeFunctor(d),
                            fill: fillFunctor && fillFunctor(d)
                        }, style)
                    }, $5f24d9e6365e3e1e$var$_defineProperty(_attrs, linePosAttr, line0Functor(d)), $5f24d9e6365e3e1e$var$_defineProperty(_attrs, lineSizeAttr, Math.abs(lineFunctor(d) - line0Functor(d))), $5f24d9e6365e3e1e$var$_defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), $5f24d9e6365e3e1e$var$_defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), $5f24d9e6365e3e1e$var$_defineProperty(_attrs, "onClick", function onClick(e) {
                        return _this._valueClickHandler(d, e);
                    }), $5f24d9e6365e3e1e$var$_defineProperty(_attrs, "onContextMenu", function onContextMenu(e) {
                        return _this._valueRightClickHandler(d, e);
                    }), $5f24d9e6365e3e1e$var$_defineProperty(_attrs, "onMouseOver", function onMouseOver(e) {
                        return _this._valueMouseOverHandler(d, e);
                    }), $5f24d9e6365e3e1e$var$_defineProperty(_attrs, "onMouseOut", function onMouseOut(e) {
                        return _this._valueMouseOutHandler(d, e);
                    }), _attrs);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", $5f24d9e6365e3e1e$var$_extends({
                        key: String(i)
                    }, attrs));
                }));
            }
        }
    ], [
        {
            key: "propTypes",
            get: function get() {
                return $5f24d9e6365e3e1e$var$_objectSpread($5f24d9e6365e3e1e$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
                    linePosAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    valuePosAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    lineSizeAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    valueSizeAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
                });
            }
        }
    ]);
    return RectSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$5f24d9e6365e3e1e$var$RectSeries.displayName = "RectSeries";
var $5f24d9e6365e3e1e$export$2e2bcd8739ae039 = $5f24d9e6365e3e1e$var$RectSeries;


function $05bad5f0ae76c7fd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $05bad5f0ae76c7fd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $05bad5f0ae76c7fd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $05bad5f0ae76c7fd$var$_typeof(obj);
}
function $05bad5f0ae76c7fd$var$_extends() {
    $05bad5f0ae76c7fd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $05bad5f0ae76c7fd$var$_extends.apply(this, arguments);
}
function $05bad5f0ae76c7fd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $05bad5f0ae76c7fd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $05bad5f0ae76c7fd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $05bad5f0ae76c7fd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $05bad5f0ae76c7fd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $05bad5f0ae76c7fd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $05bad5f0ae76c7fd$var$_setPrototypeOf(subClass, superClass);
}
function $05bad5f0ae76c7fd$var$_setPrototypeOf(o, p) {
    $05bad5f0ae76c7fd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $05bad5f0ae76c7fd$var$_setPrototypeOf(o, p);
}
function $05bad5f0ae76c7fd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $05bad5f0ae76c7fd$var$_isNativeReflectConstruct();
    return function() {
        var Super = $05bad5f0ae76c7fd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $05bad5f0ae76c7fd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $05bad5f0ae76c7fd$var$_possibleConstructorReturn(this, result);
    };
}
function $05bad5f0ae76c7fd$var$_possibleConstructorReturn(self, call) {
    if (call && ($05bad5f0ae76c7fd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $05bad5f0ae76c7fd$var$_assertThisInitialized(self);
}
function $05bad5f0ae76c7fd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $05bad5f0ae76c7fd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $05bad5f0ae76c7fd$var$_getPrototypeOf(o) {
    $05bad5f0ae76c7fd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $05bad5f0ae76c7fd$var$_getPrototypeOf(o);
}
var $05bad5f0ae76c7fd$var$HorizontalRectSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $05bad5f0ae76c7fd$var$_inherits(HorizontalRectSeries, _AbstractSeries);
    var _super = $05bad5f0ae76c7fd$var$_createSuper(HorizontalRectSeries);
    function HorizontalRectSeries() {
        $05bad5f0ae76c7fd$var$_classCallCheck(this, HorizontalRectSeries);
        return _super.apply(this, arguments);
    }
    $05bad5f0ae76c7fd$var$_createClass(HorizontalRectSeries, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5f24d9e6365e3e1e$export$2e2bcd8739ae039), $05bad5f0ae76c7fd$var$_extends({}, this.props, {
                    linePosAttr: "y",
                    valuePosAttr: "x",
                    lineSizeAttr: "height",
                    valueSizeAttr: "width"
                }));
            }
        }
    ], [
        {
            key: "getParentConfig",
            value: function getParentConfig(attr) {
                var isDomainAdjustmentNeeded = false;
                var zeroBaseValue = attr === "x";
                return {
                    isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
                    zeroBaseValue: zeroBaseValue
                };
            }
        }
    ]);
    return HorizontalRectSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$05bad5f0ae76c7fd$var$HorizontalRectSeries.displayName = "HorizontalRectSeries";
var $05bad5f0ae76c7fd$export$2e2bcd8739ae039 = $05bad5f0ae76c7fd$var$HorizontalRectSeries;





var $bYoiY = parcelRequire("bYoiY");



function $bef8fada58dcacbd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bef8fada58dcacbd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bef8fada58dcacbd$var$ownKeys(Object(source), true).forEach(function(key) {
            $bef8fada58dcacbd$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bef8fada58dcacbd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bef8fada58dcacbd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bef8fada58dcacbd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bef8fada58dcacbd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bef8fada58dcacbd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bef8fada58dcacbd$var$_typeof(obj);
}
function $bef8fada58dcacbd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bef8fada58dcacbd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bef8fada58dcacbd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bef8fada58dcacbd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bef8fada58dcacbd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bef8fada58dcacbd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bef8fada58dcacbd$var$_setPrototypeOf(subClass, superClass);
}
function $bef8fada58dcacbd$var$_setPrototypeOf(o, p) {
    $bef8fada58dcacbd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bef8fada58dcacbd$var$_setPrototypeOf(o, p);
}
function $bef8fada58dcacbd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bef8fada58dcacbd$var$_isNativeReflectConstruct();
    return function() {
        var Super = $bef8fada58dcacbd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bef8fada58dcacbd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bef8fada58dcacbd$var$_possibleConstructorReturn(this, result);
    };
}
function $bef8fada58dcacbd$var$_possibleConstructorReturn(self, call) {
    if (call && ($bef8fada58dcacbd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bef8fada58dcacbd$var$_assertThisInitialized(self);
}
function $bef8fada58dcacbd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bef8fada58dcacbd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bef8fada58dcacbd$var$_getPrototypeOf(o) {
    $bef8fada58dcacbd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bef8fada58dcacbd$var$_getPrototypeOf(o);
}
var $bef8fada58dcacbd$var$RectSeriesCanvas = /*#__PURE__*/ function(_AbstractSeries) {
    $bef8fada58dcacbd$var$_inherits(RectSeriesCanvas, _AbstractSeries);
    var _super = $bef8fada58dcacbd$var$_createSuper(RectSeriesCanvas);
    function RectSeriesCanvas() {
        $bef8fada58dcacbd$var$_classCallCheck(this, RectSeriesCanvas);
        return _super.apply(this, arguments);
    }
    $bef8fada58dcacbd$var$_createClass(RectSeriesCanvas, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ], [
        {
            key: "renderLayer",
            value: function renderLayer(props, ctx) {
                var data = props.data, linePosAttr = props.linePosAttr, lineSizeAttr = props.lineSizeAttr, marginLeft = props.marginLeft, marginTop = props.marginTop, valuePosAttr = props.valuePosAttr;
                if (!data || data.length === 0) return;
                var line = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, linePosAttr);
                var line0 = (0, $379b4f4f942d44ab$export$8b4d7b016ad3bc31)(props, linePosAttr);
                var value = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, valuePosAttr);
                var value0 = (0, $379b4f4f942d44ab$export$8b4d7b016ad3bc31)(props, valuePosAttr);
                var fill = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "fill") || (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "color");
                var stroke = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "stroke") || (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "color");
                var opacity = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "opacity");
                data.forEach(function(row) {
                    var fillColor = (0, $bYoiY.rgb)(fill(row));
                    var strokeColor = (0, $bYoiY.rgb)(stroke(row));
                    var rowOpacity = opacity(row) || (0, $d629c93f7b094ef1$export$95a809b606e7af75);
                    var linePos = line0(row);
                    var valuePos = Math.min(value0(row), value(row));
                    var x = valuePosAttr === "x" ? valuePos : linePos;
                    var y = valuePosAttr === "y" ? valuePos : linePos;
                    var lineSize = Math.abs(line(row) - line0(row));
                    var valueSize = Math.abs(-value0(row) + value(row));
                    var height = lineSizeAttr === "height" ? lineSize : valueSize;
                    var width = lineSizeAttr === "width" ? lineSize : valueSize;
                    ctx.beginPath();
                    ctx.rect(x + marginLeft, y + marginTop, width, height);
                    ctx.fillStyle = "rgba(".concat(fillColor.r, ", ").concat(fillColor.g, ", ").concat(fillColor.b, ", ").concat(rowOpacity, ")");
                    ctx.fill();
                    ctx.strokeStyle = "rgba(".concat(strokeColor.r, ", ").concat(strokeColor.g, ", ").concat(strokeColor.b, ", ").concat(rowOpacity, ")");
                    ctx.stroke();
                });
            }
        },
        {
            key: "requiresSVG",
            get: function get() {
                return false;
            }
        },
        {
            key: "isCanvas",
            get: function get() {
                return true;
            }
        }
    ]);
    return RectSeriesCanvas;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$bef8fada58dcacbd$var$RectSeriesCanvas.displayName = "RectSeriesCanvas";
$bef8fada58dcacbd$var$RectSeriesCanvas.defaultProps = $bef8fada58dcacbd$var$_objectSpread($bef8fada58dcacbd$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).defaultProps), {}, {
    linePosAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    valuePosAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    lineSizeAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    valueSizeAttr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired
});
$bef8fada58dcacbd$var$RectSeriesCanvas.propTypes = $bef8fada58dcacbd$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes);
var $bef8fada58dcacbd$export$2e2bcd8739ae039 = $bef8fada58dcacbd$var$RectSeriesCanvas;


function $ba11fcbfecaeabe1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ba11fcbfecaeabe1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ba11fcbfecaeabe1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ba11fcbfecaeabe1$var$_typeof(obj);
}
function $ba11fcbfecaeabe1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ba11fcbfecaeabe1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ba11fcbfecaeabe1$var$ownKeys(Object(source), true).forEach(function(key) {
            $ba11fcbfecaeabe1$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ba11fcbfecaeabe1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ba11fcbfecaeabe1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ba11fcbfecaeabe1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ba11fcbfecaeabe1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ba11fcbfecaeabe1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ba11fcbfecaeabe1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ba11fcbfecaeabe1$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ba11fcbfecaeabe1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ba11fcbfecaeabe1$var$_setPrototypeOf(subClass, superClass);
}
function $ba11fcbfecaeabe1$var$_setPrototypeOf(o, p) {
    $ba11fcbfecaeabe1$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ba11fcbfecaeabe1$var$_setPrototypeOf(o, p);
}
function $ba11fcbfecaeabe1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ba11fcbfecaeabe1$var$_isNativeReflectConstruct();
    return function() {
        var Super = $ba11fcbfecaeabe1$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ba11fcbfecaeabe1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ba11fcbfecaeabe1$var$_possibleConstructorReturn(this, result);
    };
}
function $ba11fcbfecaeabe1$var$_possibleConstructorReturn(self, call) {
    if (call && ($ba11fcbfecaeabe1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ba11fcbfecaeabe1$var$_assertThisInitialized(self);
}
function $ba11fcbfecaeabe1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ba11fcbfecaeabe1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ba11fcbfecaeabe1$var$_getPrototypeOf(o) {
    $ba11fcbfecaeabe1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ba11fcbfecaeabe1$var$_getPrototypeOf(o);
}
var $ba11fcbfecaeabe1$var$HorizontalRectSeriesCanvas = /*#__PURE__*/ function(_AbstractSeries) {
    $ba11fcbfecaeabe1$var$_inherits(HorizontalRectSeriesCanvas, _AbstractSeries);
    var _super = $ba11fcbfecaeabe1$var$_createSuper(HorizontalRectSeriesCanvas);
    function HorizontalRectSeriesCanvas() {
        $ba11fcbfecaeabe1$var$_classCallCheck(this, HorizontalRectSeriesCanvas);
        return _super.apply(this, arguments);
    }
    $ba11fcbfecaeabe1$var$_createClass(HorizontalRectSeriesCanvas, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ], [
        {
            key: "getParentConfig",
            value: function getParentConfig(attr) {
                var isDomainAdjustmentNeeded = false;
                var zeroBaseValue = attr === "x";
                return {
                    isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
                    zeroBaseValue: zeroBaseValue
                };
            }
        },
        {
            key: "renderLayer",
            value: function renderLayer(props, ctx) {
                (0, $bef8fada58dcacbd$export$2e2bcd8739ae039).renderLayer($ba11fcbfecaeabe1$var$_objectSpread($ba11fcbfecaeabe1$var$_objectSpread({}, props), {}, {
                    linePosAttr: "y",
                    valuePosAttr: "x",
                    lineSizeAttr: "height",
                    valueSizeAttr: "width"
                }), ctx);
            }
        },
        {
            key: "requiresSVG",
            get: function get() {
                return false;
            }
        },
        {
            key: "isCanvas",
            get: function get() {
                return true;
            }
        }
    ]);
    return HorizontalRectSeriesCanvas;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$ba11fcbfecaeabe1$var$HorizontalRectSeriesCanvas.displayName = "HorizontalRectSeriesCanvas";
$ba11fcbfecaeabe1$var$HorizontalRectSeriesCanvas.propTypes = $ba11fcbfecaeabe1$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes);
var $ba11fcbfecaeabe1$export$2e2bcd8739ae039 = $ba11fcbfecaeabe1$var$HorizontalRectSeriesCanvas;



var $acw62 = parcelRequire("acw62");





function $9ce38b8b6c594605$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9ce38b8b6c594605$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9ce38b8b6c594605$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9ce38b8b6c594605$var$_typeof(obj);
}
function $9ce38b8b6c594605$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9ce38b8b6c594605$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9ce38b8b6c594605$var$ownKeys(Object(source), true).forEach(function(key) {
            $9ce38b8b6c594605$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9ce38b8b6c594605$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9ce38b8b6c594605$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ce38b8b6c594605$var$_extends() {
    $9ce38b8b6c594605$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9ce38b8b6c594605$var$_extends.apply(this, arguments);
}
function $9ce38b8b6c594605$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9ce38b8b6c594605$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9ce38b8b6c594605$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9ce38b8b6c594605$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ce38b8b6c594605$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $9ce38b8b6c594605$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $9ce38b8b6c594605$var$_setPrototypeOf(subClass, superClass);
}
function $9ce38b8b6c594605$var$_setPrototypeOf(o, p) {
    $9ce38b8b6c594605$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9ce38b8b6c594605$var$_setPrototypeOf(o, p);
}
function $9ce38b8b6c594605$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9ce38b8b6c594605$var$_isNativeReflectConstruct();
    return function() {
        var Super = $9ce38b8b6c594605$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9ce38b8b6c594605$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9ce38b8b6c594605$var$_possibleConstructorReturn(this, result);
    };
}
function $9ce38b8b6c594605$var$_possibleConstructorReturn(self, call) {
    if (call && ($9ce38b8b6c594605$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $9ce38b8b6c594605$var$_assertThisInitialized(self);
}
function $9ce38b8b6c594605$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9ce38b8b6c594605$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9ce38b8b6c594605$var$_getPrototypeOf(o) {
    $9ce38b8b6c594605$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9ce38b8b6c594605$var$_getPrototypeOf(o);
}
var $9ce38b8b6c594605$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--label";
var $9ce38b8b6c594605$var$getTextAnchor = function getTextAnchor(labelAnchorX, leftOfMiddle) {
    return labelAnchorX ? labelAnchorX : leftOfMiddle ? "start" : "end";
};
var $9ce38b8b6c594605$var$getDominantBaseline = function getDominantBaseline(labelAnchorY, aboveMiddle) {
    return labelAnchorY ? labelAnchorY : aboveMiddle ? "text-before-edge" : "text-after-edge";
};
var $9ce38b8b6c594605$var$LabelSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $9ce38b8b6c594605$var$_inherits(LabelSeries, _AbstractSeries);
    var _super = $9ce38b8b6c594605$var$_createSuper(LabelSeries);
    function LabelSeries() {
        $9ce38b8b6c594605$var$_classCallCheck(this, LabelSeries);
        return _super.apply(this, arguments);
    }
    $9ce38b8b6c594605$var$_createClass(LabelSeries, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, animation = _this$props.animation, allowOffsetToBeReversed = _this$props.allowOffsetToBeReversed, className = _this$props.className, data = _this$props.data, _data = _this$props._data, getLabel = _this$props.getLabel, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, rotation = _this$props.rotation, style = _this$props.style, xRange = _this$props.xRange, yRange = _this$props.yRange, labelAnchorX = _this$props.labelAnchorX, labelAnchorY = _this$props.labelAnchorY;
                if (!data) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $9ce38b8b6c594605$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LabelSeries, $9ce38b8b6c594605$var$_extends({}, this.props, {
                    animation: null,
                    _data: data
                })));
                var xFunctor = this._getAttributeFunctor("x");
                var yFunctor = this._getAttributeFunctor("y");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($9ce38b8b6c594605$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")"),
                    style: style
                }, data.reduce(function(res, d, i) {
                    var markStyle = d.style, xOffset = d.xOffset, yOffset = d.yOffset;
                    if (!getLabel(d)) return res;
                    var xVal = xFunctor(d);
                    var yVal = yFunctor(d);
                    var leftOfMiddle = xVal < (xRange[1] - xRange[0]) / 2;
                    var aboveMiddle = yVal < Math.abs(yRange[1] - yRange[0]) / 2;
                    var x = xVal + (allowOffsetToBeReversed && leftOfMiddle ? -1 : 1) * (xOffset || 0);
                    var y = yVal + (allowOffsetToBeReversed && aboveMiddle ? -1 : 1) * (yOffset || 0);
                    var hasRotationValueSet = d.rotation === 0 || d.rotation;
                    var labelRotation = hasRotationValueSet ? d.rotation : rotation;
                    var attrs = $9ce38b8b6c594605$var$_objectSpread({
                        dominantBaseline: $9ce38b8b6c594605$var$getDominantBaseline(labelAnchorY, aboveMiddle),
                        className: "rv-xy-plot__series--label-text",
                        onClick: function onClick(e) {
                            return _this._valueClickHandler(d, e);
                        },
                        onContextMenu: function onContextMenu(e) {
                            return _this._valueRightClickHandler(d, e);
                        },
                        onMouseOver: function onMouseOver(e) {
                            return _this._valueMouseOverHandler(d, e);
                        },
                        onMouseOut: function onMouseOut(e) {
                            return _this._valueMouseOutHandler(d, e);
                        },
                        textAnchor: $9ce38b8b6c594605$var$getTextAnchor(labelAnchorX, leftOfMiddle),
                        x: x,
                        y: y,
                        transform: "rotate(".concat(labelRotation, ",").concat(x, ",").concat(y, ")")
                    }, markStyle);
                    var textContent = getLabel(_data ? _data[i] : d);
                    return res.concat([
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", $9ce38b8b6c594605$var$_extends({
                            key: String(i)
                        }, attrs), textContent)
                    ]);
                }, []));
            }
        }
    ]);
    return LabelSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$9ce38b8b6c594605$var$LabelSeries.propTypes = {
    animation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    allowOffsetToBeReversed: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
        ]),
        y: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
        ]),
        angle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        radius: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        xOffset: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        yOffset: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    })).isRequired,
    marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    xRange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number),
    yRange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number),
    labelAnchorX: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    labelAnchorY: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
$9ce38b8b6c594605$var$LabelSeries.defaultProps = $9ce38b8b6c594605$var$_objectSpread($9ce38b8b6c594605$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).defaultProps), {}, {
    animation: false,
    rotation: 0,
    getLabel: function getLabel(d) {
        return d.label;
    }
});
$9ce38b8b6c594605$var$LabelSeries.displayName = "LabelSeries";
var $9ce38b8b6c594605$export$2e2bcd8739ae039 = $9ce38b8b6c594605$var$LabelSeries;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");








function $871fbd36d2e25249$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $871fbd36d2e25249$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $871fbd36d2e25249$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $871fbd36d2e25249$var$_typeof(obj);
}
function $871fbd36d2e25249$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $871fbd36d2e25249$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $871fbd36d2e25249$var$ownKeys(Object(source), true).forEach(function(key) {
            $871fbd36d2e25249$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $871fbd36d2e25249$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $871fbd36d2e25249$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $871fbd36d2e25249$var$_extends() {
    $871fbd36d2e25249$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $871fbd36d2e25249$var$_extends.apply(this, arguments);
}
function $871fbd36d2e25249$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $871fbd36d2e25249$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $871fbd36d2e25249$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $871fbd36d2e25249$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $871fbd36d2e25249$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $871fbd36d2e25249$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $871fbd36d2e25249$var$_setPrototypeOf(subClass, superClass);
}
function $871fbd36d2e25249$var$_setPrototypeOf(o, p) {
    $871fbd36d2e25249$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $871fbd36d2e25249$var$_setPrototypeOf(o, p);
}
function $871fbd36d2e25249$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $871fbd36d2e25249$var$_isNativeReflectConstruct();
    return function() {
        var Super = $871fbd36d2e25249$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $871fbd36d2e25249$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $871fbd36d2e25249$var$_possibleConstructorReturn(this, result);
    };
}
function $871fbd36d2e25249$var$_possibleConstructorReturn(self, call) {
    if (call && ($871fbd36d2e25249$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $871fbd36d2e25249$var$_assertThisInitialized(self);
}
function $871fbd36d2e25249$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $871fbd36d2e25249$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $871fbd36d2e25249$var$_getPrototypeOf(o) {
    $871fbd36d2e25249$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $871fbd36d2e25249$var$_getPrototypeOf(o);
}
var $871fbd36d2e25249$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--line";
var $871fbd36d2e25249$var$STROKE_STYLES = {
    dashed: "6, 2",
    solid: null
};
var $871fbd36d2e25249$var$LineSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $871fbd36d2e25249$var$_inherits(LineSeries, _AbstractSeries);
    var _super = $871fbd36d2e25249$var$_createSuper(LineSeries);
    function LineSeries() {
        $871fbd36d2e25249$var$_classCallCheck(this, LineSeries);
        return _super.apply(this, arguments);
    }
    $871fbd36d2e25249$var$_createClass(LineSeries, [
        {
            key: "_renderLine",
            value: function _renderLine(data, x, y, curve, getNull) {
                var line = $917a97ee579c920c$exports.line();
                if (curve !== null) {
                    if (typeof curve === "string" && $917a97ee579c920c$exports[curve]) line = line.curve($917a97ee579c920c$exports[curve]);
                    else if (typeof curve === "function") line = line.curve(curve);
                }
                line = line.defined(getNull);
                line = line.x(x).y(y);
                return line(data);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, animation = _this$props.animation, className = _this$props.className, data = _this$props.data;
                if (this.props.nullAccessor) (0, $ddc583f274f25523$export$491112666e282270)("nullAccessor has been renamed to getNull", true);
                if (!data) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $871fbd36d2e25249$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LineSeries, $871fbd36d2e25249$var$_extends({}, this.props, {
                    animation: null
                })));
                var _this$props2 = this.props, curve = _this$props2.curve, marginLeft = _this$props2.marginLeft, marginTop = _this$props2.marginTop, strokeDasharray = _this$props2.strokeDasharray, strokeStyle = _this$props2.strokeStyle, strokeWidth = _this$props2.strokeWidth, style = _this$props2.style;
                var x = this._getAttributeFunctor("x");
                var y = this._getAttributeFunctor("y");
                var stroke = this._getAttributeValue("stroke") || this._getAttributeValue("color");
                var newOpacity = this._getAttributeValue("opacity");
                var opacity = Number.isFinite(newOpacity) ? newOpacity : (0, $d629c93f7b094ef1$export$95a809b606e7af75);
                var getNull = this.props.nullAccessor || this.props.getNull;
                var d = this._renderLine(data, x, y, curve, getNull);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                    d: d,
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($871fbd36d2e25249$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")"),
                    onMouseOver: this._seriesMouseOverHandler,
                    onMouseOut: this._seriesMouseOutHandler,
                    onClick: this._seriesClickHandler,
                    onContextMenu: this._seriesRightClickHandler,
                    style: $871fbd36d2e25249$var$_objectSpread({
                        opacity: opacity,
                        strokeDasharray: $871fbd36d2e25249$var$STROKE_STYLES[strokeStyle] || strokeDasharray,
                        strokeWidth: strokeWidth,
                        stroke: stroke
                    }, style)
                });
            }
        }
    ]);
    return LineSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$871fbd36d2e25249$var$LineSeries.displayName = "LineSeries";
$871fbd36d2e25249$var$LineSeries.propTypes = $871fbd36d2e25249$var$_objectSpread($871fbd36d2e25249$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
    strokeStyle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf(Object.keys($871fbd36d2e25249$var$STROKE_STYLES)),
    curve: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    getNull: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
});
$871fbd36d2e25249$var$LineSeries.defaultProps = $871fbd36d2e25249$var$_objectSpread($871fbd36d2e25249$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).defaultProps), {}, {
    strokeStyle: "solid",
    style: {},
    opacity: 1,
    curve: null,
    className: "",
    getNull: function getNull() {
        return true;
    }
});
var $871fbd36d2e25249$export$2e2bcd8739ae039 = $871fbd36d2e25249$var$LineSeries;



var $acw62 = parcelRequire("acw62");







function $dd4ad056f824b78e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dd4ad056f824b78e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dd4ad056f824b78e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dd4ad056f824b78e$var$_typeof(obj);
}
function $dd4ad056f824b78e$var$_extends() {
    $dd4ad056f824b78e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd4ad056f824b78e$var$_extends.apply(this, arguments);
}
function $dd4ad056f824b78e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dd4ad056f824b78e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dd4ad056f824b78e$var$ownKeys(Object(source), true).forEach(function(key) {
            $dd4ad056f824b78e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dd4ad056f824b78e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dd4ad056f824b78e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dd4ad056f824b78e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dd4ad056f824b78e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dd4ad056f824b78e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dd4ad056f824b78e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dd4ad056f824b78e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dd4ad056f824b78e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $dd4ad056f824b78e$var$_setPrototypeOf(subClass, superClass);
}
function $dd4ad056f824b78e$var$_setPrototypeOf(o, p) {
    $dd4ad056f824b78e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dd4ad056f824b78e$var$_setPrototypeOf(o, p);
}
function $dd4ad056f824b78e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dd4ad056f824b78e$var$_isNativeReflectConstruct();
    return function() {
        var Super = $dd4ad056f824b78e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $dd4ad056f824b78e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $dd4ad056f824b78e$var$_possibleConstructorReturn(this, result);
    };
}
function $dd4ad056f824b78e$var$_possibleConstructorReturn(self, call) {
    if (call && ($dd4ad056f824b78e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $dd4ad056f824b78e$var$_assertThisInitialized(self);
}
function $dd4ad056f824b78e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $dd4ad056f824b78e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dd4ad056f824b78e$var$_getPrototypeOf(o) {
    $dd4ad056f824b78e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dd4ad056f824b78e$var$_getPrototypeOf(o);
}
var $dd4ad056f824b78e$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--mark";
var $dd4ad056f824b78e$var$DEFAULT_STROKE_WIDTH = 1;
var $dd4ad056f824b78e$var$MarkSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $dd4ad056f824b78e$var$_inherits(MarkSeries, _AbstractSeries);
    var _super = $dd4ad056f824b78e$var$_createSuper(MarkSeries);
    function MarkSeries() {
        $dd4ad056f824b78e$var$_classCallCheck(this, MarkSeries);
        return _super.apply(this, arguments);
    }
    $dd4ad056f824b78e$var$_createClass(MarkSeries, [
        {
            key: "_renderCircle",
            value: function _renderCircle(d, i, strokeWidth, style, scalingFunctions) {
                var _this = this;
                var fill = scalingFunctions.fill, opacity = scalingFunctions.opacity, size = scalingFunctions.size, stroke = scalingFunctions.stroke, x = scalingFunctions.x, y = scalingFunctions.y;
                var attrs = {
                    r: size ? size(d) : (0, $d629c93f7b094ef1$export$e4c0458e30711294),
                    cx: x(d),
                    cy: y(d),
                    style: $dd4ad056f824b78e$var$_objectSpread({
                        opacity: opacity ? opacity(d) : (0, $d629c93f7b094ef1$export$95a809b606e7af75),
                        stroke: stroke && stroke(d),
                        fill: fill && fill(d),
                        strokeWidth: strokeWidth || $dd4ad056f824b78e$var$DEFAULT_STROKE_WIDTH
                    }, style),
                    key: i,
                    onClick: function onClick(e) {
                        return _this._valueClickHandler(d, e);
                    },
                    onContextMenu: function onContextMenu(e) {
                        return _this._valueRightClickHandler(d, e);
                    },
                    onMouseOver: function onMouseOver(e) {
                        return _this._valueMouseOverHandler(d, e);
                    },
                    onMouseOut: function onMouseOut(e) {
                        return _this._valueMouseOutHandler(d, e);
                    }
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", attrs);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, animation = _this$props.animation, className = _this$props.className, data = _this$props.data, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, strokeWidth = _this$props.strokeWidth, style = _this$props.style;
                if (this.props.nullAccessor) (0, $ddc583f274f25523$export$491112666e282270)("nullAccessor has been renamed to getNull", true);
                var getNull = this.props.nullAccessor || this.props.getNull;
                if (!data) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $dd4ad056f824b78e$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MarkSeries, $dd4ad056f824b78e$var$_extends({}, this.props, {
                    animation: null
                })));
                var scalingFunctions = {
                    fill: this._getAttributeFunctor("fill") || this._getAttributeFunctor("color"),
                    opacity: this._getAttributeFunctor("opacity"),
                    size: this._getAttributeFunctor("size"),
                    stroke: this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color"),
                    x: this._getAttributeFunctor("x"),
                    y: this._getAttributeFunctor("y")
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($dd4ad056f824b78e$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")")
                }, data.map(function(d, i) {
                    return getNull(d) && _this2._renderCircle(d, i, strokeWidth, style, scalingFunctions);
                }));
            }
        }
    ]);
    return MarkSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$dd4ad056f824b78e$var$MarkSeries.displayName = "MarkSeries";
$dd4ad056f824b78e$var$MarkSeries.propTypes = $dd4ad056f824b78e$var$_objectSpread($dd4ad056f824b78e$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
    getNull: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
});
$dd4ad056f824b78e$var$MarkSeries.defaultProps = {
    getNull: function getNull() {
        return true;
    }
};
var $dd4ad056f824b78e$export$2e2bcd8739ae039 = $dd4ad056f824b78e$var$MarkSeries;


function $5f5bf9ff9d0ffd46$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5f5bf9ff9d0ffd46$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5f5bf9ff9d0ffd46$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5f5bf9ff9d0ffd46$var$_typeof(obj);
}
function $5f5bf9ff9d0ffd46$var$_extends() {
    $5f5bf9ff9d0ffd46$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5f5bf9ff9d0ffd46$var$_extends.apply(this, arguments);
}
function $5f5bf9ff9d0ffd46$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5f5bf9ff9d0ffd46$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5f5bf9ff9d0ffd46$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5f5bf9ff9d0ffd46$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5f5bf9ff9d0ffd46$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5f5bf9ff9d0ffd46$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5f5bf9ff9d0ffd46$var$_setPrototypeOf(subClass, superClass);
}
function $5f5bf9ff9d0ffd46$var$_setPrototypeOf(o, p) {
    $5f5bf9ff9d0ffd46$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5f5bf9ff9d0ffd46$var$_setPrototypeOf(o, p);
}
function $5f5bf9ff9d0ffd46$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5f5bf9ff9d0ffd46$var$_isNativeReflectConstruct();
    return function() {
        var Super = $5f5bf9ff9d0ffd46$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5f5bf9ff9d0ffd46$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5f5bf9ff9d0ffd46$var$_possibleConstructorReturn(this, result);
    };
}
function $5f5bf9ff9d0ffd46$var$_possibleConstructorReturn(self, call) {
    if (call && ($5f5bf9ff9d0ffd46$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5f5bf9ff9d0ffd46$var$_assertThisInitialized(self);
}
function $5f5bf9ff9d0ffd46$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5f5bf9ff9d0ffd46$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5f5bf9ff9d0ffd46$var$_getPrototypeOf(o) {
    $5f5bf9ff9d0ffd46$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5f5bf9ff9d0ffd46$var$_getPrototypeOf(o);
}
function $5f5bf9ff9d0ffd46$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5f5bf9ff9d0ffd46$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5f5bf9ff9d0ffd46$var$ownKeys(Object(source), true).forEach(function(key) {
            $5f5bf9ff9d0ffd46$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5f5bf9ff9d0ffd46$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5f5bf9ff9d0ffd46$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5f5bf9ff9d0ffd46$var$propTypes = $5f5bf9ff9d0ffd46$var$_objectSpread($5f5bf9ff9d0ffd46$var$_objectSpread({}, (0, $871fbd36d2e25249$export$2e2bcd8739ae039).propTypes), {}, {
    lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    markStyle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
});
var $5f5bf9ff9d0ffd46$var$LineMarkSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $5f5bf9ff9d0ffd46$var$_inherits(LineMarkSeries, _AbstractSeries);
    var _super = $5f5bf9ff9d0ffd46$var$_createSuper(LineMarkSeries);
    function LineMarkSeries() {
        $5f5bf9ff9d0ffd46$var$_classCallCheck(this, LineMarkSeries);
        return _super.apply(this, arguments);
    }
    $5f5bf9ff9d0ffd46$var$_createClass(LineMarkSeries, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, lineStyle = _this$props.lineStyle, markStyle = _this$props.markStyle, style = _this$props.style;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: "rv-xy-plot__series rv-xy-plot__series--linemark"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $871fbd36d2e25249$export$2e2bcd8739ae039), $5f5bf9ff9d0ffd46$var$_extends({}, this.props, {
                    style: $5f5bf9ff9d0ffd46$var$_objectSpread($5f5bf9ff9d0ffd46$var$_objectSpread({}, style), lineStyle)
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dd4ad056f824b78e$export$2e2bcd8739ae039), $5f5bf9ff9d0ffd46$var$_extends({}, this.props, {
                    style: $5f5bf9ff9d0ffd46$var$_objectSpread($5f5bf9ff9d0ffd46$var$_objectSpread({}, style), markStyle)
                })));
            }
        }
    ], [
        {
            key: "defaultProps",
            get: function get() {
                return $5f5bf9ff9d0ffd46$var$_objectSpread($5f5bf9ff9d0ffd46$var$_objectSpread({}, (0, $871fbd36d2e25249$export$2e2bcd8739ae039).defaultProps), {}, {
                    lineStyle: {},
                    markStyle: {}
                });
            }
        }
    ]);
    return LineMarkSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$5f5bf9ff9d0ffd46$var$LineMarkSeries.displayName = "LineMarkSeries";
$5f5bf9ff9d0ffd46$var$LineMarkSeries.propTypes = $5f5bf9ff9d0ffd46$var$propTypes;
var $5f5bf9ff9d0ffd46$export$2e2bcd8739ae039 = $5f5bf9ff9d0ffd46$var$LineMarkSeries;




var $bYoiY = parcelRequire("bYoiY");



function $c7b3e2ddce3eeb6e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c7b3e2ddce3eeb6e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c7b3e2ddce3eeb6e$var$ownKeys(Object(source), true).forEach(function(key) {
            $c7b3e2ddce3eeb6e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c7b3e2ddce3eeb6e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c7b3e2ddce3eeb6e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c7b3e2ddce3eeb6e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c7b3e2ddce3eeb6e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c7b3e2ddce3eeb6e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c7b3e2ddce3eeb6e$var$_typeof(obj);
}
function $c7b3e2ddce3eeb6e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c7b3e2ddce3eeb6e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c7b3e2ddce3eeb6e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c7b3e2ddce3eeb6e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c7b3e2ddce3eeb6e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c7b3e2ddce3eeb6e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c7b3e2ddce3eeb6e$var$_setPrototypeOf(subClass, superClass);
}
function $c7b3e2ddce3eeb6e$var$_setPrototypeOf(o, p) {
    $c7b3e2ddce3eeb6e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c7b3e2ddce3eeb6e$var$_setPrototypeOf(o, p);
}
function $c7b3e2ddce3eeb6e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c7b3e2ddce3eeb6e$var$_isNativeReflectConstruct();
    return function() {
        var Super = $c7b3e2ddce3eeb6e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c7b3e2ddce3eeb6e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c7b3e2ddce3eeb6e$var$_possibleConstructorReturn(this, result);
    };
}
function $c7b3e2ddce3eeb6e$var$_possibleConstructorReturn(self, call) {
    if (call && ($c7b3e2ddce3eeb6e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c7b3e2ddce3eeb6e$var$_assertThisInitialized(self);
}
function $c7b3e2ddce3eeb6e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c7b3e2ddce3eeb6e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c7b3e2ddce3eeb6e$var$_getPrototypeOf(o) {
    $c7b3e2ddce3eeb6e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c7b3e2ddce3eeb6e$var$_getPrototypeOf(o);
}
var $c7b3e2ddce3eeb6e$var$MarkSeriesCanvas = /*#__PURE__*/ function(_AbstractSeries) {
    $c7b3e2ddce3eeb6e$var$_inherits(MarkSeriesCanvas, _AbstractSeries);
    var _super = $c7b3e2ddce3eeb6e$var$_createSuper(MarkSeriesCanvas);
    function MarkSeriesCanvas() {
        $c7b3e2ddce3eeb6e$var$_classCallCheck(this, MarkSeriesCanvas);
        return _super.apply(this, arguments);
    }
    $c7b3e2ddce3eeb6e$var$_createClass(MarkSeriesCanvas, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ], [
        {
            key: "renderLayer",
            value: function renderLayer(props, ctx) {
                var data = props.data, marginLeft = props.marginLeft, marginTop = props.marginTop;
                var x = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "x");
                var y = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "y");
                var size = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "size") || function() {
                    return 0, $d629c93f7b094ef1$export$e4c0458e30711294;
                };
                var fill = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "fill") || (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "color");
                var stroke = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "stroke") || (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "color");
                var opacity = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "opacity");
                data.forEach(function(row) {
                    var fillColor = (0, $bYoiY.rgb)(fill(row));
                    var strokeColor = (0, $bYoiY.rgb)(stroke(row));
                    var rowOpacity = opacity(row) || (0, $d629c93f7b094ef1$export$95a809b606e7af75);
                    ctx.beginPath();
                    ctx.arc(x(row) + marginLeft, y(row) + marginTop, size(row), 0, 2 * Math.PI);
                    ctx.fillStyle = "rgba(".concat(fillColor.r, ", ").concat(fillColor.g, ", ").concat(fillColor.b, ", ").concat(rowOpacity, ")");
                    ctx.fill();
                    ctx.strokeStyle = "rgba(".concat(strokeColor.r, ", ").concat(strokeColor.g, ", ").concat(strokeColor.b, ", ").concat(rowOpacity, ")");
                    ctx.stroke();
                });
            }
        },
        {
            key: "requiresSVG",
            get: function get() {
                return false;
            }
        },
        {
            key: "isCanvas",
            get: function get() {
                return true;
            }
        }
    ]);
    return MarkSeriesCanvas;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$c7b3e2ddce3eeb6e$var$MarkSeriesCanvas.displayName = "MarkSeriesCanvas";
$c7b3e2ddce3eeb6e$var$MarkSeriesCanvas.propTypes = $c7b3e2ddce3eeb6e$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes);
var $c7b3e2ddce3eeb6e$export$2e2bcd8739ae039 = $c7b3e2ddce3eeb6e$var$MarkSeriesCanvas;




var $bYoiY = parcelRequire("bYoiY");


var $acw62 = parcelRequire("acw62");



function $ea4dcb2e13df6d87$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ea4dcb2e13df6d87$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ea4dcb2e13df6d87$var$ownKeys(Object(source), true).forEach(function(key) {
            $ea4dcb2e13df6d87$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ea4dcb2e13df6d87$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ea4dcb2e13df6d87$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ea4dcb2e13df6d87$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ea4dcb2e13df6d87$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ea4dcb2e13df6d87$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ea4dcb2e13df6d87$var$_typeof(obj);
}
function $ea4dcb2e13df6d87$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ea4dcb2e13df6d87$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ea4dcb2e13df6d87$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ea4dcb2e13df6d87$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ea4dcb2e13df6d87$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ea4dcb2e13df6d87$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ea4dcb2e13df6d87$var$_setPrototypeOf(subClass, superClass);
}
function $ea4dcb2e13df6d87$var$_setPrototypeOf(o, p) {
    $ea4dcb2e13df6d87$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ea4dcb2e13df6d87$var$_setPrototypeOf(o, p);
}
function $ea4dcb2e13df6d87$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ea4dcb2e13df6d87$var$_isNativeReflectConstruct();
    return function() {
        var Super = $ea4dcb2e13df6d87$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ea4dcb2e13df6d87$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ea4dcb2e13df6d87$var$_possibleConstructorReturn(this, result);
    };
}
function $ea4dcb2e13df6d87$var$_possibleConstructorReturn(self, call) {
    if (call && ($ea4dcb2e13df6d87$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ea4dcb2e13df6d87$var$_assertThisInitialized(self);
}
function $ea4dcb2e13df6d87$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ea4dcb2e13df6d87$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ea4dcb2e13df6d87$var$_getPrototypeOf(o) {
    $ea4dcb2e13df6d87$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ea4dcb2e13df6d87$var$_getPrototypeOf(o);
}
var $ea4dcb2e13df6d87$var$LineSeriesCanvas = /*#__PURE__*/ function(_AbstractSeries) {
    $ea4dcb2e13df6d87$var$_inherits(LineSeriesCanvas, _AbstractSeries);
    var _super = $ea4dcb2e13df6d87$var$_createSuper(LineSeriesCanvas);
    function LineSeriesCanvas() {
        $ea4dcb2e13df6d87$var$_classCallCheck(this, LineSeriesCanvas);
        return _super.apply(this, arguments);
    }
    $ea4dcb2e13df6d87$var$_createClass(LineSeriesCanvas, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null);
            }
        }
    ], [
        {
            key: "renderLayer",
            value: function renderLayer(props, ctx) {
                var curve = props.curve, data = props.data, marginLeft = props.marginLeft, marginTop = props.marginTop, strokeWidth = props.strokeWidth, strokeDasharray = props.strokeDasharray;
                if (!data || data.length === 0) return;
                var x = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "x");
                var y = (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "y");
                var stroke = (0, $379b4f4f942d44ab$export$1e335898aa11b111)(props, "stroke") || (0, $379b4f4f942d44ab$export$1e335898aa11b111)(props, "color");
                var strokeColor = (0, $bYoiY.rgb)(stroke);
                var newOpacity = (0, $379b4f4f942d44ab$export$1e335898aa11b111)(props, "opacity");
                var opacity = Number.isFinite(newOpacity) ? newOpacity : (0, $d629c93f7b094ef1$export$95a809b606e7af75);
                var line = $917a97ee579c920c$exports.line().x(function(row) {
                    return x(row) + marginLeft;
                }).y(function(row) {
                    return y(row) + marginTop;
                });
                if (typeof curve === "string" && $917a97ee579c920c$exports[curve]) line = line.curve($917a97ee579c920c$exports[curve]);
                else if (typeof curve === "function") line = line.curve(curve);
                ctx.beginPath();
                ctx.strokeStyle = "rgba(".concat(strokeColor.r, ", ").concat(strokeColor.g, ", ").concat(strokeColor.b, ", ").concat(opacity, ")");
                ctx.lineWidth = strokeWidth;
                if (strokeDasharray) ctx.setLineDash(strokeDasharray);
                line.context(ctx)(data);
                ctx.stroke();
                ctx.closePath(); // set back to default
                ctx.lineWidth = 1;
                ctx.setLineDash([]);
            }
        },
        {
            key: "requiresSVG",
            get: function get() {
                return false;
            }
        },
        {
            key: "isCanvas",
            get: function get() {
                return true;
            }
        }
    ]);
    return LineSeriesCanvas;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$ea4dcb2e13df6d87$var$LineSeriesCanvas.displayName = "LineSeriesCanvas";
$ea4dcb2e13df6d87$var$LineSeriesCanvas.defaultProps = $ea4dcb2e13df6d87$var$_objectSpread($ea4dcb2e13df6d87$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).defaultProps), {}, {
    strokeWidth: 2
});
$ea4dcb2e13df6d87$var$LineSeriesCanvas.propTypes = $ea4dcb2e13df6d87$var$_objectSpread($ea4dcb2e13df6d87$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
    strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
});
var $ea4dcb2e13df6d87$export$2e2bcd8739ae039 = $ea4dcb2e13df6d87$var$LineSeriesCanvas;


function $02bef35b7ba9a504$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $02bef35b7ba9a504$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $02bef35b7ba9a504$var$ownKeys(Object(source), true).forEach(function(key) {
            $02bef35b7ba9a504$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $02bef35b7ba9a504$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $02bef35b7ba9a504$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $02bef35b7ba9a504$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $02bef35b7ba9a504$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $02bef35b7ba9a504$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $02bef35b7ba9a504$var$_typeof(obj);
}
function $02bef35b7ba9a504$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $02bef35b7ba9a504$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $02bef35b7ba9a504$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $02bef35b7ba9a504$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $02bef35b7ba9a504$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $02bef35b7ba9a504$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $02bef35b7ba9a504$var$_setPrototypeOf(subClass, superClass);
}
function $02bef35b7ba9a504$var$_setPrototypeOf(o, p) {
    $02bef35b7ba9a504$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $02bef35b7ba9a504$var$_setPrototypeOf(o, p);
}
function $02bef35b7ba9a504$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $02bef35b7ba9a504$var$_isNativeReflectConstruct();
    return function() {
        var Super = $02bef35b7ba9a504$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $02bef35b7ba9a504$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $02bef35b7ba9a504$var$_possibleConstructorReturn(this, result);
    };
}
function $02bef35b7ba9a504$var$_possibleConstructorReturn(self, call) {
    if (call && ($02bef35b7ba9a504$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $02bef35b7ba9a504$var$_assertThisInitialized(self);
}
function $02bef35b7ba9a504$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $02bef35b7ba9a504$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $02bef35b7ba9a504$var$_getPrototypeOf(o) {
    $02bef35b7ba9a504$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $02bef35b7ba9a504$var$_getPrototypeOf(o);
}
var $02bef35b7ba9a504$var$LineMarkSeriesCanvas = /*#__PURE__*/ function(_AbstractSeries) {
    $02bef35b7ba9a504$var$_inherits(LineMarkSeriesCanvas, _AbstractSeries);
    var _super = $02bef35b7ba9a504$var$_createSuper(LineMarkSeriesCanvas);
    function LineMarkSeriesCanvas() {
        $02bef35b7ba9a504$var$_classCallCheck(this, LineMarkSeriesCanvas);
        return _super.apply(this, arguments);
    }
    $02bef35b7ba9a504$var$_createClass(LineMarkSeriesCanvas, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ], [
        {
            key: "renderLayer",
            value: function renderLayer(props, ctx) {
                (0, $ea4dcb2e13df6d87$export$2e2bcd8739ae039).renderLayer(props, ctx);
                (0, $c7b3e2ddce3eeb6e$export$2e2bcd8739ae039).renderLayer(props, ctx);
            }
        },
        {
            key: "requiresSVG",
            get: function get() {
                return false;
            }
        },
        {
            key: "isCanvas",
            get: function get() {
                return true;
            }
        }
    ]);
    return LineMarkSeriesCanvas;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$02bef35b7ba9a504$var$LineMarkSeriesCanvas.displayName = "LineMarkSeriesCanvas";
$02bef35b7ba9a504$var$LineMarkSeriesCanvas.propTypes = $02bef35b7ba9a504$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes);
var $02bef35b7ba9a504$export$2e2bcd8739ae039 = $02bef35b7ba9a504$var$LineMarkSeriesCanvas;







var $acw62 = parcelRequire("acw62");




function $4adb2019d400d701$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4adb2019d400d701$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4adb2019d400d701$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4adb2019d400d701$var$_typeof(obj);
}
function $4adb2019d400d701$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4adb2019d400d701$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4adb2019d400d701$var$ownKeys(Object(source), true).forEach(function(key) {
            $4adb2019d400d701$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4adb2019d400d701$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4adb2019d400d701$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4adb2019d400d701$var$_extends() {
    $4adb2019d400d701$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4adb2019d400d701$var$_extends.apply(this, arguments);
}
function $4adb2019d400d701$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4adb2019d400d701$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4adb2019d400d701$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4adb2019d400d701$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4adb2019d400d701$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4adb2019d400d701$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $4adb2019d400d701$var$_setPrototypeOf(subClass, superClass);
}
function $4adb2019d400d701$var$_setPrototypeOf(o, p) {
    $4adb2019d400d701$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4adb2019d400d701$var$_setPrototypeOf(o, p);
}
function $4adb2019d400d701$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4adb2019d400d701$var$_isNativeReflectConstruct();
    return function() {
        var Super = $4adb2019d400d701$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $4adb2019d400d701$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4adb2019d400d701$var$_possibleConstructorReturn(this, result);
    };
}
function $4adb2019d400d701$var$_possibleConstructorReturn(self, call) {
    if (call && ($4adb2019d400d701$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $4adb2019d400d701$var$_assertThisInitialized(self);
}
function $4adb2019d400d701$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4adb2019d400d701$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $4adb2019d400d701$var$_getPrototypeOf(o) {
    $4adb2019d400d701$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4adb2019d400d701$var$_getPrototypeOf(o);
}
var $4adb2019d400d701$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--polygon";
var $4adb2019d400d701$var$DEFAULT_COLOR = "#12939A";
var $4adb2019d400d701$var$generatePath = function generatePath(data, xFunctor, yFunctor) {
    return "".concat(data.reduce(function(res, row, i) {
        return "".concat(res, " ").concat(i ? "L" : "M").concat(xFunctor(row), " ").concat(yFunctor(row));
    }, ""), " Z");
};
var $4adb2019d400d701$var$PolygonSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $4adb2019d400d701$var$_inherits(PolygonSeries, _AbstractSeries);
    var _super = $4adb2019d400d701$var$_createSuper(PolygonSeries);
    function PolygonSeries() {
        $4adb2019d400d701$var$_classCallCheck(this, PolygonSeries);
        return _super.apply(this, arguments);
    }
    $4adb2019d400d701$var$_createClass(PolygonSeries, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, animation = _this$props.animation, color = _this$props.color, className = _this$props.className, data = _this$props.data, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, style = _this$props.style;
                if (!data) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $4adb2019d400d701$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PolygonSeries, $4adb2019d400d701$var$_extends({}, this.props, {
                    animation: null
                })));
                var xFunctor = this._getAttributeFunctor("x");
                var yFunctor = this._getAttributeFunctor("y");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($4adb2019d400d701$var$predefinedClassName, className),
                    onMouseOver: function onMouseOver(e) {
                        return _this._seriesMouseOverHandler(data, e);
                    },
                    onMouseOut: function onMouseOut(e) {
                        return _this._seriesMouseOutHandler(data, e);
                    },
                    onClick: this._seriesClickHandler,
                    onContextMenu: this._seriesRightClickHandler,
                    fill: color || $4adb2019d400d701$var$DEFAULT_COLOR,
                    style: style,
                    d: $4adb2019d400d701$var$generatePath(data, xFunctor, yFunctor),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")")
                });
            }
        }
    ], [
        {
            key: "propTypes",
            get: function get() {
                return $4adb2019d400d701$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes);
            }
        }
    ]);
    return PolygonSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$4adb2019d400d701$var$PolygonSeries.displayName = "PolygonSeries";
var $4adb2019d400d701$export$2e2bcd8739ae039 = $4adb2019d400d701$var$PolygonSeries;



var $acw62 = parcelRequire("acw62");


function $cb24d21727ab3f7c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cb24d21727ab3f7c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cb24d21727ab3f7c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cb24d21727ab3f7c$var$_typeof(obj);
}
function $cb24d21727ab3f7c$var$_extends() {
    $cb24d21727ab3f7c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cb24d21727ab3f7c$var$_extends.apply(this, arguments);
}
function $cb24d21727ab3f7c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cb24d21727ab3f7c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cb24d21727ab3f7c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cb24d21727ab3f7c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cb24d21727ab3f7c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cb24d21727ab3f7c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cb24d21727ab3f7c$var$_setPrototypeOf(subClass, superClass);
}
function $cb24d21727ab3f7c$var$_setPrototypeOf(o, p) {
    $cb24d21727ab3f7c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cb24d21727ab3f7c$var$_setPrototypeOf(o, p);
}
function $cb24d21727ab3f7c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cb24d21727ab3f7c$var$_isNativeReflectConstruct();
    return function() {
        var Super = $cb24d21727ab3f7c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cb24d21727ab3f7c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cb24d21727ab3f7c$var$_possibleConstructorReturn(this, result);
    };
}
function $cb24d21727ab3f7c$var$_possibleConstructorReturn(self, call) {
    if (call && ($cb24d21727ab3f7c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $cb24d21727ab3f7c$var$_assertThisInitialized(self);
}
function $cb24d21727ab3f7c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cb24d21727ab3f7c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cb24d21727ab3f7c$var$_getPrototypeOf(o) {
    $cb24d21727ab3f7c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cb24d21727ab3f7c$var$_getPrototypeOf(o);
}
var $cb24d21727ab3f7c$var$VerticalBarSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $cb24d21727ab3f7c$var$_inherits(VerticalBarSeries, _AbstractSeries);
    var _super = $cb24d21727ab3f7c$var$_createSuper(VerticalBarSeries);
    function VerticalBarSeries() {
        $cb24d21727ab3f7c$var$_classCallCheck(this, VerticalBarSeries);
        return _super.apply(this, arguments);
    }
    $cb24d21727ab3f7c$var$_createClass(VerticalBarSeries, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f11fc06aff8a60cc$export$2e2bcd8739ae039), $cb24d21727ab3f7c$var$_extends({}, this.props, {
                    linePosAttr: "x",
                    valuePosAttr: "y",
                    lineSizeAttr: "width",
                    valueSizeAttr: "height"
                }));
            }
        }
    ], [
        {
            key: "getParentConfig",
            value: function getParentConfig(attr) {
                var isDomainAdjustmentNeeded = attr === "x";
                var zeroBaseValue = attr === "y";
                return {
                    isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
                    zeroBaseValue: zeroBaseValue
                };
            }
        }
    ]);
    return VerticalBarSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$cb24d21727ab3f7c$var$VerticalBarSeries.displayName = "VerticalBarSeries";
var $cb24d21727ab3f7c$export$2e2bcd8739ae039 = $cb24d21727ab3f7c$var$VerticalBarSeries;




function $b6ba207ecc728d44$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b6ba207ecc728d44$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b6ba207ecc728d44$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b6ba207ecc728d44$var$_typeof(obj);
}
function $b6ba207ecc728d44$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b6ba207ecc728d44$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b6ba207ecc728d44$var$ownKeys(Object(source), true).forEach(function(key) {
            $b6ba207ecc728d44$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b6ba207ecc728d44$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b6ba207ecc728d44$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b6ba207ecc728d44$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b6ba207ecc728d44$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b6ba207ecc728d44$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b6ba207ecc728d44$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b6ba207ecc728d44$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b6ba207ecc728d44$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b6ba207ecc728d44$var$_setPrototypeOf(subClass, superClass);
}
function $b6ba207ecc728d44$var$_setPrototypeOf(o, p) {
    $b6ba207ecc728d44$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b6ba207ecc728d44$var$_setPrototypeOf(o, p);
}
function $b6ba207ecc728d44$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b6ba207ecc728d44$var$_isNativeReflectConstruct();
    return function() {
        var Super = $b6ba207ecc728d44$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b6ba207ecc728d44$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b6ba207ecc728d44$var$_possibleConstructorReturn(this, result);
    };
}
function $b6ba207ecc728d44$var$_possibleConstructorReturn(self, call) {
    if (call && ($b6ba207ecc728d44$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b6ba207ecc728d44$var$_assertThisInitialized(self);
}
function $b6ba207ecc728d44$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b6ba207ecc728d44$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b6ba207ecc728d44$var$_getPrototypeOf(o) {
    $b6ba207ecc728d44$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b6ba207ecc728d44$var$_getPrototypeOf(o);
}
var $b6ba207ecc728d44$var$HorizontalBarSeriesCanvas = /*#__PURE__*/ function(_AbstractSeries) {
    $b6ba207ecc728d44$var$_inherits(HorizontalBarSeriesCanvas, _AbstractSeries);
    var _super = $b6ba207ecc728d44$var$_createSuper(HorizontalBarSeriesCanvas);
    function HorizontalBarSeriesCanvas() {
        $b6ba207ecc728d44$var$_classCallCheck(this, HorizontalBarSeriesCanvas);
        return _super.apply(this, arguments);
    }
    $b6ba207ecc728d44$var$_createClass(HorizontalBarSeriesCanvas, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ], [
        {
            key: "getParentConfig",
            value: function getParentConfig(attr) {
                var isDomainAdjustmentNeeded = attr === "x";
                var zeroBaseValue = attr === "y";
                return {
                    isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
                    zeroBaseValue: zeroBaseValue
                };
            }
        },
        {
            key: "renderLayer",
            value: function renderLayer(props, ctx) {
                (0, $5de732e1f321dfb3$export$2e2bcd8739ae039).renderLayer($b6ba207ecc728d44$var$_objectSpread($b6ba207ecc728d44$var$_objectSpread({}, props), {}, {
                    linePosAttr: "x",
                    valuePosAttr: "y",
                    lineSizeAttr: "width",
                    valueSizeAttr: "height"
                }), ctx);
            }
        },
        {
            key: "requiresSVG",
            get: function get() {
                return false;
            }
        },
        {
            key: "isCanvas",
            get: function get() {
                return true;
            }
        }
    ]);
    return HorizontalBarSeriesCanvas;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$b6ba207ecc728d44$var$HorizontalBarSeriesCanvas.displayName = "HorizontalBarSeriesCanvas";
$b6ba207ecc728d44$var$HorizontalBarSeriesCanvas.propTypes = $b6ba207ecc728d44$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes);
var $b6ba207ecc728d44$export$2e2bcd8739ae039 = $b6ba207ecc728d44$var$HorizontalBarSeriesCanvas;



var $acw62 = parcelRequire("acw62");



function $5d90e9abce593f78$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5d90e9abce593f78$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5d90e9abce593f78$var$ownKeys(Object(source), true).forEach(function(key) {
            $5d90e9abce593f78$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5d90e9abce593f78$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5d90e9abce593f78$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5d90e9abce593f78$var$VERTICAL = (0, $16d91db751e2a422$export$9106728c49045482).VERTICAL;
var $5d90e9abce593f78$var$propTypes = $5d90e9abce593f78$var$_objectSpread($5d90e9abce593f78$var$_objectSpread({}, (0, $bfd175a5af321bd0$export$2e2bcd8739ae039).propTypes), {}, {
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        $5d90e9abce593f78$var$VERTICAL
    ])
});
var $5d90e9abce593f78$var$defaultProps = {
    direction: $5d90e9abce593f78$var$VERTICAL,
    attr: "x"
};
function $5d90e9abce593f78$var$VerticalGridLines(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfd175a5af321bd0$export$2e2bcd8739ae039), props);
}
$5d90e9abce593f78$var$VerticalGridLines.displayName = "VerticalGridLines";
$5d90e9abce593f78$var$VerticalGridLines.propTypes = $5d90e9abce593f78$var$propTypes;
$5d90e9abce593f78$var$VerticalGridLines.defaultProps = $5d90e9abce593f78$var$defaultProps;
$5d90e9abce593f78$var$VerticalGridLines.requiresSVG = true;
var $5d90e9abce593f78$export$2e2bcd8739ae039 = $5d90e9abce593f78$var$VerticalGridLines;



var $acw62 = parcelRequire("acw62");


function $b0322f447e6a6178$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b0322f447e6a6178$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b0322f447e6a6178$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b0322f447e6a6178$var$_typeof(obj);
}
function $b0322f447e6a6178$var$_extends() {
    $b0322f447e6a6178$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0322f447e6a6178$var$_extends.apply(this, arguments);
}
function $b0322f447e6a6178$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b0322f447e6a6178$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b0322f447e6a6178$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b0322f447e6a6178$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b0322f447e6a6178$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b0322f447e6a6178$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b0322f447e6a6178$var$_setPrototypeOf(subClass, superClass);
}
function $b0322f447e6a6178$var$_setPrototypeOf(o, p) {
    $b0322f447e6a6178$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b0322f447e6a6178$var$_setPrototypeOf(o, p);
}
function $b0322f447e6a6178$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b0322f447e6a6178$var$_isNativeReflectConstruct();
    return function() {
        var Super = $b0322f447e6a6178$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b0322f447e6a6178$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b0322f447e6a6178$var$_possibleConstructorReturn(this, result);
    };
}
function $b0322f447e6a6178$var$_possibleConstructorReturn(self, call) {
    if (call && ($b0322f447e6a6178$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b0322f447e6a6178$var$_assertThisInitialized(self);
}
function $b0322f447e6a6178$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b0322f447e6a6178$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b0322f447e6a6178$var$_getPrototypeOf(o) {
    $b0322f447e6a6178$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b0322f447e6a6178$var$_getPrototypeOf(o);
}
var $b0322f447e6a6178$var$VerticalRectSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $b0322f447e6a6178$var$_inherits(VerticalRectSeries, _AbstractSeries);
    var _super = $b0322f447e6a6178$var$_createSuper(VerticalRectSeries);
    function VerticalRectSeries() {
        $b0322f447e6a6178$var$_classCallCheck(this, VerticalRectSeries);
        return _super.apply(this, arguments);
    }
    $b0322f447e6a6178$var$_createClass(VerticalRectSeries, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5f24d9e6365e3e1e$export$2e2bcd8739ae039), $b0322f447e6a6178$var$_extends({}, this.props, {
                    linePosAttr: "x",
                    valuePosAttr: "y",
                    lineSizeAttr: "width",
                    valueSizeAttr: "height"
                }));
            }
        }
    ], [
        {
            key: "getParentConfig",
            value: function getParentConfig(attr) {
                var isDomainAdjustmentNeeded = false;
                var zeroBaseValue = attr === "y";
                return {
                    isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
                    zeroBaseValue: zeroBaseValue
                };
            }
        }
    ]);
    return VerticalRectSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$b0322f447e6a6178$var$VerticalRectSeries.displayName = "VerticalRectSeries";
var $b0322f447e6a6178$export$2e2bcd8739ae039 = $b0322f447e6a6178$var$VerticalRectSeries;




function $c219d1d42ab5cb37$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c219d1d42ab5cb37$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c219d1d42ab5cb37$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c219d1d42ab5cb37$var$_typeof(obj);
}
function $c219d1d42ab5cb37$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c219d1d42ab5cb37$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c219d1d42ab5cb37$var$ownKeys(Object(source), true).forEach(function(key) {
            $c219d1d42ab5cb37$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c219d1d42ab5cb37$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c219d1d42ab5cb37$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c219d1d42ab5cb37$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c219d1d42ab5cb37$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c219d1d42ab5cb37$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c219d1d42ab5cb37$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c219d1d42ab5cb37$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c219d1d42ab5cb37$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c219d1d42ab5cb37$var$_setPrototypeOf(subClass, superClass);
}
function $c219d1d42ab5cb37$var$_setPrototypeOf(o, p) {
    $c219d1d42ab5cb37$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c219d1d42ab5cb37$var$_setPrototypeOf(o, p);
}
function $c219d1d42ab5cb37$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c219d1d42ab5cb37$var$_isNativeReflectConstruct();
    return function() {
        var Super = $c219d1d42ab5cb37$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c219d1d42ab5cb37$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c219d1d42ab5cb37$var$_possibleConstructorReturn(this, result);
    };
}
function $c219d1d42ab5cb37$var$_possibleConstructorReturn(self, call) {
    if (call && ($c219d1d42ab5cb37$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c219d1d42ab5cb37$var$_assertThisInitialized(self);
}
function $c219d1d42ab5cb37$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c219d1d42ab5cb37$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c219d1d42ab5cb37$var$_getPrototypeOf(o) {
    $c219d1d42ab5cb37$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c219d1d42ab5cb37$var$_getPrototypeOf(o);
}
var $c219d1d42ab5cb37$var$HorizontalRectSeriesCanvas = /*#__PURE__*/ function(_AbstractSeries) {
    $c219d1d42ab5cb37$var$_inherits(HorizontalRectSeriesCanvas, _AbstractSeries);
    var _super = $c219d1d42ab5cb37$var$_createSuper(HorizontalRectSeriesCanvas);
    function HorizontalRectSeriesCanvas() {
        $c219d1d42ab5cb37$var$_classCallCheck(this, HorizontalRectSeriesCanvas);
        return _super.apply(this, arguments);
    }
    $c219d1d42ab5cb37$var$_createClass(HorizontalRectSeriesCanvas, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ], [
        {
            key: "getParentConfig",
            value: function getParentConfig(attr) {
                var isDomainAdjustmentNeeded = false;
                var zeroBaseValue = attr === "y";
                return {
                    isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
                    zeroBaseValue: zeroBaseValue
                };
            }
        },
        {
            key: "renderLayer",
            value: function renderLayer(props, ctx) {
                (0, $bef8fada58dcacbd$export$2e2bcd8739ae039).renderLayer($c219d1d42ab5cb37$var$_objectSpread($c219d1d42ab5cb37$var$_objectSpread({}, props), {}, {
                    linePosAttr: "x",
                    valuePosAttr: "y",
                    lineSizeAttr: "width",
                    valueSizeAttr: "height"
                }), ctx);
            }
        },
        {
            key: "requiresSVG",
            get: function get() {
                return false;
            }
        },
        {
            key: "isCanvas",
            get: function get() {
                return true;
            }
        }
    ]);
    return HorizontalRectSeriesCanvas;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$c219d1d42ab5cb37$var$HorizontalRectSeriesCanvas.displayName = "HorizontalRectSeriesCanvas";
$c219d1d42ab5cb37$var$HorizontalRectSeriesCanvas.propTypes = $c219d1d42ab5cb37$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes);
var $c219d1d42ab5cb37$export$2e2bcd8739ae039 = $c219d1d42ab5cb37$var$HorizontalRectSeriesCanvas;



var $acw62 = parcelRequire("acw62");




function $11aad0bf7d0bc992$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $11aad0bf7d0bc992$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $11aad0bf7d0bc992$var$ownKeys(Object(source), true).forEach(function(key) {
            $11aad0bf7d0bc992$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $11aad0bf7d0bc992$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $11aad0bf7d0bc992$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $11aad0bf7d0bc992$var$NOOP = function NOOP(f) {
    return f;
}; // Find the index of the node at coordinates of a touch point
function $11aad0bf7d0bc992$var$getNodeIndex(evt) {
    var _evt$nativeEvent = evt.nativeEvent, pageX = _evt$nativeEvent.pageX, pageY = _evt$nativeEvent.pageY;
    var target = document.elementFromPoint(pageX, pageY);
    if (!target) return -1;
    var parentNode = target.parentNode;
    return Array.prototype.indexOf.call(parentNode.childNodes, target);
}
function $11aad0bf7d0bc992$var$getExtent(_ref) {
    var innerWidth = _ref.innerWidth, innerHeight = _ref.innerHeight, marginLeft = _ref.marginLeft, marginTop = _ref.marginTop;
    return [
        [
            marginLeft,
            marginTop
        ],
        [
            innerWidth + marginLeft,
            innerHeight + marginTop
        ]
    ];
}
function $11aad0bf7d0bc992$var$Voronoi(props) {
    var className = props.className, extent = props.extent, nodes = props.nodes, onBlur = props.onBlur, _onClick = props.onClick, _onMouseUp = props.onMouseUp, _onMouseDown = props.onMouseDown, onHover = props.onHover, polygonStyle = props.polygonStyle, style = props.style, x = props.x, y = props.y; // Create a voronoi with each node center points
    var voronoiInstance = (0, $50e37159451a6d0c$export$2e2bcd8739ae039)().x(x || (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "x")).y(y || (0, $379b4f4f942d44ab$export$735c878afad94f32)(props, "y")).extent(extent || $11aad0bf7d0bc992$var$getExtent(props)); // Create an array of polygons corresponding to the cells in voronoi
    var polygons = voronoiInstance.polygons(nodes); // Create helper function to handle special logic for touch events
    var handleTouchEvent = function handleTouchEvent(handler) {
        return function(evt) {
            evt.preventDefault();
            var index = $11aad0bf7d0bc992$var$getNodeIndex(evt);
            if (index > -1 && index < polygons.length) {
                var d = polygons[index];
                handler(d.data);
            }
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)(className, "rv-voronoi"),
        style: style // Because of the nature of how touch events, and more specifically touchmove
        ,
        onTouchEnd: handleTouchEvent(_onMouseUp),
        onTouchStart: handleTouchEvent(_onMouseDown),
        onTouchMove: handleTouchEvent(onHover),
        onTouchCancel: handleTouchEvent(onBlur)
    }, polygons.map(function(d, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            className: "rv-voronoi__cell ".concat(d.data && d.data.className || ""),
            d: "M".concat(d.join("L"), "Z"),
            onClick: function onClick() {
                return _onClick(d.data);
            },
            onMouseUp: function onMouseUp() {
                return _onMouseUp(d.data);
            },
            onMouseDown: function onMouseDown() {
                return _onMouseDown(d.data);
            },
            onMouseOver: function onMouseOver() {
                return onHover(d.data);
            },
            onMouseOut: function onMouseOut() {
                return onBlur(d.data);
            },
            fill: "none",
            style: $11aad0bf7d0bc992$var$_objectSpread($11aad0bf7d0bc992$var$_objectSpread({
                pointerEvents: "all"
            }, polygonStyle), d.data && d.data.style),
            key: i
        });
    }));
}
$11aad0bf7d0bc992$var$Voronoi.requiresSVG = true;
$11aad0bf7d0bc992$var$Voronoi.displayName = "Voronoi";
$11aad0bf7d0bc992$var$Voronoi.defaultProps = {
    className: "",
    onBlur: $11aad0bf7d0bc992$var$NOOP,
    onClick: $11aad0bf7d0bc992$var$NOOP,
    onHover: $11aad0bf7d0bc992$var$NOOP,
    onMouseDown: $11aad0bf7d0bc992$var$NOOP,
    onMouseUp: $11aad0bf7d0bc992$var$NOOP
};
$11aad0bf7d0bc992$var$Voronoi.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    extent: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number)),
    nodes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onHover: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onMouseUp: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    x: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    y: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
var $11aad0bf7d0bc992$export$2e2bcd8739ae039 = $11aad0bf7d0bc992$var$Voronoi;





var $acw62 = parcelRequire("acw62");






function $dd399b16c8272906$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dd399b16c8272906$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dd399b16c8272906$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dd399b16c8272906$var$_typeof(obj);
}
function $dd399b16c8272906$var$_extends() {
    $dd399b16c8272906$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd399b16c8272906$var$_extends.apply(this, arguments);
}
function $dd399b16c8272906$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dd399b16c8272906$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dd399b16c8272906$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dd399b16c8272906$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dd399b16c8272906$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dd399b16c8272906$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $dd399b16c8272906$var$_setPrototypeOf(subClass, superClass);
}
function $dd399b16c8272906$var$_setPrototypeOf(o, p) {
    $dd399b16c8272906$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dd399b16c8272906$var$_setPrototypeOf(o, p);
}
function $dd399b16c8272906$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dd399b16c8272906$var$_isNativeReflectConstruct();
    return function() {
        var Super = $dd399b16c8272906$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $dd399b16c8272906$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $dd399b16c8272906$var$_possibleConstructorReturn(this, result);
    };
}
function $dd399b16c8272906$var$_possibleConstructorReturn(self, call) {
    if (call && ($dd399b16c8272906$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $dd399b16c8272906$var$_assertThisInitialized(self);
}
function $dd399b16c8272906$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $dd399b16c8272906$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dd399b16c8272906$var$_getPrototypeOf(o) {
    $dd399b16c8272906$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dd399b16c8272906$var$_getPrototypeOf(o);
}
function $dd399b16c8272906$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dd399b16c8272906$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dd399b16c8272906$var$ownKeys(Object(source), true).forEach(function(key) {
            $dd399b16c8272906$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dd399b16c8272906$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dd399b16c8272906$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $dd399b16c8272906$var$predefinedClassName = "rv-xy-plot__series rv-xy-plot__series--whisker";
var $dd399b16c8272906$var$DEFAULT_STROKE_WIDTH = 1;
var $dd399b16c8272906$var$DEFAULT_CROSS_BAR_WIDTH = 6;
/**
 * Render whisker lines for a data point.
 * @param {Object} whiskerMarkProps All the properties of the whisker mark.
 * @private
 */ var $dd399b16c8272906$var$renderWhiskerMark = function renderWhiskerMark(whiskerMarkProps) {
    return function(d, i) {
        var crossBarWidth = whiskerMarkProps.crossBarWidth, opacityFunctor = whiskerMarkProps.opacityFunctor, sizeFunctor = whiskerMarkProps.sizeFunctor, strokeFunctor = whiskerMarkProps.strokeFunctor, strokeWidth = whiskerMarkProps.strokeWidth, style = whiskerMarkProps.style, valueClickHandler = whiskerMarkProps.valueClickHandler, valueMouseOutHandler = whiskerMarkProps.valueMouseOutHandler, valueMouseOverHandler = whiskerMarkProps.valueMouseOverHandler, valueRightClickHandler = whiskerMarkProps.valueRightClickHandler, xFunctor = whiskerMarkProps.xFunctor, yFunctor = whiskerMarkProps.yFunctor;
        var r = sizeFunctor ? sizeFunctor(d) : 0;
        var cx = xFunctor(d);
        var cy = yFunctor(d);
        var positiveXVariance = xFunctor({
            x: d.x + d.xVariance / 2
        });
        var negativeXVariance = xFunctor({
            x: d.x - d.xVariance / 2
        });
        var positiveYVariance = yFunctor({
            y: d.y + d.yVariance / 2
        });
        var negativeYVariance = yFunctor({
            y: d.y - d.yVariance / 2
        });
        /**
     * Determine whether on not we should draw whiskers in each direction.
     * We need to see an actual variance value, and also have that value extend past the
     * radius "buffer" region in which we won't be drawing (if any).
     */ var hasXWhiskers = positiveXVariance && cx + r < positiveXVariance;
        var hasYWhiskers = positiveYVariance && cy - r > positiveYVariance;
        if (!hasXWhiskers && !hasYWhiskers) return null;
        var styleAttr = $dd399b16c8272906$var$_objectSpread({
            opacity: opacityFunctor ? opacityFunctor(d) : (0, $d629c93f7b094ef1$export$95a809b606e7af75),
            stroke: strokeFunctor && strokeFunctor(d),
            strokeWidth: strokeWidth || $dd399b16c8272906$var$DEFAULT_STROKE_WIDTH
        }, style);
        var crossBarExtension = crossBarWidth / 2;
        var rightLineAttrs = {
            x1: cx + r,
            y1: cy,
            x2: positiveXVariance,
            y2: cy,
            style: styleAttr
        };
        var leftLineAttrs = {
            x1: cx - r,
            y1: cy,
            x2: negativeXVariance,
            y2: cy,
            style: styleAttr
        };
        var rightCrossBarAttrs = {
            x1: positiveXVariance,
            y1: cy - crossBarExtension,
            x2: positiveXVariance,
            y2: cy + crossBarExtension,
            style: styleAttr
        };
        var leftCrossBarAttrs = {
            x1: negativeXVariance,
            y1: cy - crossBarExtension,
            x2: negativeXVariance,
            y2: cy + crossBarExtension,
            style: styleAttr
        };
        var upperLineAttrs = {
            x1: cx,
            y1: cy - r,
            x2: cx,
            y2: positiveYVariance,
            style: styleAttr
        };
        var lowerLineAttrs = {
            x1: cx,
            y1: cy + r,
            x2: cx,
            y2: negativeYVariance,
            style: styleAttr
        };
        var upperCrossBarAttrs = {
            x1: cx - crossBarExtension,
            y1: positiveYVariance,
            x2: cx + crossBarExtension,
            y2: positiveYVariance,
            style: styleAttr
        };
        var lowerCrossBarAttrs = {
            x1: cx - crossBarExtension,
            y1: negativeYVariance,
            x2: cx + crossBarExtension,
            y2: negativeYVariance,
            style: styleAttr
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            className: "mark-whiskers",
            key: i,
            onClick: function onClick(e) {
                return valueClickHandler(d, e);
            },
            onContextMenu: function onContextMenu(e) {
                return valueRightClickHandler(d, e);
            },
            onMouseOver: function onMouseOver(e) {
                return valueMouseOverHandler(d, e);
            },
            onMouseOut: function onMouseOut(e) {
                return valueMouseOutHandler(d, e);
            }
        }, hasXWhiskers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            className: "x-whiskers"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", rightLineAttrs), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", leftLineAttrs), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", rightCrossBarAttrs), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", leftCrossBarAttrs)) : null, hasYWhiskers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            className: "y-whiskers"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", upperLineAttrs), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", lowerLineAttrs), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", upperCrossBarAttrs), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", lowerCrossBarAttrs)) : null);
    };
};
var $dd399b16c8272906$var$WhiskerSeries = /*#__PURE__*/ function(_AbstractSeries) {
    $dd399b16c8272906$var$_inherits(WhiskerSeries, _AbstractSeries);
    var _super = $dd399b16c8272906$var$_createSuper(WhiskerSeries);
    function WhiskerSeries() {
        $dd399b16c8272906$var$_classCallCheck(this, WhiskerSeries);
        return _super.apply(this, arguments);
    }
    $dd399b16c8272906$var$_createClass(WhiskerSeries, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, animation = _this$props.animation, className = _this$props.className, crossBarWidth = _this$props.crossBarWidth, data = _this$props.data, marginLeft = _this$props.marginLeft, marginTop = _this$props.marginTop, strokeWidth = _this$props.strokeWidth, style = _this$props.style;
                if (!data) return null;
                if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $dd399b16c8272906$var$_extends({}, this.props, {
                    animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WhiskerSeries, $dd399b16c8272906$var$_extends({}, this.props, {
                    animation: null
                })));
                var whiskerMarkProps = {
                    crossBarWidth: crossBarWidth,
                    opacityFunctor: this._getAttributeFunctor("opacity"),
                    sizeFunctor: this._getAttributeFunctor("size"),
                    strokeFunctor: this._getAttributeFunctor("stroke") || this._getAttributeFunctor("color"),
                    strokeWidth: strokeWidth,
                    style: style,
                    xFunctor: this._getAttributeFunctor("x"),
                    yFunctor: this._getAttributeFunctor("y"),
                    valueClickHandler: this._valueClickHandler,
                    valueRightClickHandler: this._valueRightClickHandler,
                    valueMouseOverHandler: this._valueMouseOverHandler,
                    valueMouseOutHandler: this._valueMouseOutHandler
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($dd399b16c8272906$var$predefinedClassName, className),
                    transform: "translate(".concat(marginLeft, ",").concat(marginTop, ")")
                }, data.map($dd399b16c8272906$var$renderWhiskerMark(whiskerMarkProps)));
            }
        }
    ]);
    return WhiskerSeries;
}((0, $e900f871d9675978$export$2e2bcd8739ae039));
$dd399b16c8272906$var$WhiskerSeries.displayName = "WhiskerSeries";
$dd399b16c8272906$var$WhiskerSeries.propTypes = $dd399b16c8272906$var$_objectSpread($dd399b16c8272906$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).propTypes), {}, {
    strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
});
$dd399b16c8272906$var$WhiskerSeries.defaultProps = $dd399b16c8272906$var$_objectSpread($dd399b16c8272906$var$_objectSpread({}, (0, $e900f871d9675978$export$2e2bcd8739ae039).defaultProps), {}, {
    crossBarWidth: $dd399b16c8272906$var$DEFAULT_CROSS_BAR_WIDTH,
    size: 0,
    strokeWidth: $dd399b16c8272906$var$DEFAULT_STROKE_WIDTH
});
var $dd399b16c8272906$export$2e2bcd8739ae039 = $dd399b16c8272906$var$WhiskerSeries;



var $acw62 = parcelRequire("acw62");

var $e35a0bae35bfdbad$exports = {};
var $5d69935f2747da8d$exports = {};
"use strict";
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
$5d69935f2747da8d$exports = $5d69935f2747da8d$var$keysShim;


var $af991f1d6c80f097$exports = {};
"use strict";

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $af991f1d6c80f097$var$$toString = $d12f4cdcd6b10506$exports("Object.prototype.toString");
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === "[object Arguments]";
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== "[object Array]" && $af991f1d6c80f097$var$$toString(value.callee) === "[object Function]";
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
$af991f1d6c80f097$exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;


var $ad6ddb07ef0cb149$exports = {};
"use strict";
var $16343f2546a69e4c$exports = {};
"use strict";

var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;
var $16343f2546a69e4c$var$origDefineProperty = Object.defineProperty;
var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === "function" && $16343f2546a69e4c$var$toStr.call(fn) === "[object Function]";
};

var $16343f2546a69e4c$var$hasPropertyDescriptors = (parcelRequire("i16wS"))();
var $16343f2546a69e4c$var$supportsDescriptors = $16343f2546a69e4c$var$origDefineProperty && $16343f2546a69e4c$var$hasPropertyDescriptors;
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($16343f2546a69e4c$var$supportsDescriptors) $16343f2546a69e4c$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value; // eslint-disable-line no-param-reassign
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $5d69935f2747da8d$exports(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
$16343f2546a69e4c$exports = $16343f2546a69e4c$var$defineProperties;



var $4bfda6cb765ad269$exports = {};
"use strict";
var $4bfda6cb765ad269$var$numberIsNaN = function(value) {
    return value !== value;
};
$4bfda6cb765ad269$exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4bfda6cb765ad269$var$numberIsNaN(a) && $4bfda6cb765ad269$var$numberIsNaN(b)) return true;
    return false;
};


var $447be6f8dd7c483c$exports = {};
"use strict";

$447be6f8dd7c483c$exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $4bfda6cb765ad269$exports;
};


var $895d2ff61cb0f7d7$exports = {};
"use strict";


$895d2ff61cb0f7d7$exports = function shimObjectIs() {
    var polyfill = $447be6f8dd7c483c$exports();
    $16343f2546a69e4c$exports(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};


var $ad6ddb07ef0cb149$var$polyfill = $9546dce5bd4976bd$exports($447be6f8dd7c483c$exports(), Object);
$16343f2546a69e4c$exports($ad6ddb07ef0cb149$var$polyfill, {
    getPolyfill: $447be6f8dd7c483c$exports,
    implementation: $4bfda6cb765ad269$exports,
    shim: $895d2ff61cb0f7d7$exports
});
$ad6ddb07ef0cb149$exports = $ad6ddb07ef0cb149$var$polyfill;


var $f52fe3bd41a86f17$exports = {};
"use strict";


var $f52fe3bd41a86f17$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $f52fe3bd41a86f17$var$has;
var $f52fe3bd41a86f17$var$$exec;
var $f52fe3bd41a86f17$var$isRegexMarker;
var $f52fe3bd41a86f17$var$badStringifier;
if ($f52fe3bd41a86f17$var$hasToStringTag) {
    $f52fe3bd41a86f17$var$has = $d12f4cdcd6b10506$exports("Object.prototype.hasOwnProperty");
    $f52fe3bd41a86f17$var$$exec = $d12f4cdcd6b10506$exports("RegExp.prototype.exec");
    $f52fe3bd41a86f17$var$isRegexMarker = {};
    var $f52fe3bd41a86f17$var$throwRegexMarker = function() {
        throw $f52fe3bd41a86f17$var$isRegexMarker;
    };
    $f52fe3bd41a86f17$var$badStringifier = {
        toString: $f52fe3bd41a86f17$var$throwRegexMarker,
        valueOf: $f52fe3bd41a86f17$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") $f52fe3bd41a86f17$var$badStringifier[Symbol.toPrimitive] = $f52fe3bd41a86f17$var$throwRegexMarker;
}
var $f52fe3bd41a86f17$var$$toString = $d12f4cdcd6b10506$exports("Object.prototype.toString");
var $f52fe3bd41a86f17$var$gOPD = Object.getOwnPropertyDescriptor;
var $f52fe3bd41a86f17$var$regexClass = "[object RegExp]";
$f52fe3bd41a86f17$exports = $f52fe3bd41a86f17$var$hasToStringTag ? function isRegex(value) {
    if (!value || typeof value !== "object") return false;
    var descriptor = $f52fe3bd41a86f17$var$gOPD(value, "lastIndex");
    var hasLastIndexDataProperty = descriptor && $f52fe3bd41a86f17$var$has(descriptor, "value");
    if (!hasLastIndexDataProperty) return false;
    try {
        $f52fe3bd41a86f17$var$$exec(value, $f52fe3bd41a86f17$var$badStringifier);
    } catch (e) {
        return e === $f52fe3bd41a86f17$var$isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== "object" && typeof value !== "function") return false;
    return $f52fe3bd41a86f17$var$$toString(value) === $f52fe3bd41a86f17$var$regexClass;
};


var $618155de6b8eecd6$exports = {};
"use strict";


var $2b55586061318c76$exports = {};
"use strict";

var $2b55586061318c76$var$functionsHaveConfigurableNames = (parcelRequire("1NQyn")).functionsHaveConfigurableNames();
var $2b55586061318c76$var$$Object = Object;
var $2b55586061318c76$var$$TypeError = TypeError;
$2b55586061318c76$exports = function flags() {
    if (this != null && this !== $2b55586061318c76$var$$Object(this)) throw new $2b55586061318c76$var$$TypeError("RegExp.prototype.flags getter called on non-object");
    var result = "";
    if (this.hasIndices) result += "d";
    if (this.global) result += "g";
    if (this.ignoreCase) result += "i";
    if (this.multiline) result += "m";
    if (this.dotAll) result += "s";
    if (this.unicode) result += "u";
    if (this.unicodeSets) result += "v";
    if (this.sticky) result += "y";
    return result;
};
if ($2b55586061318c76$var$functionsHaveConfigurableNames && Object.defineProperty) Object.defineProperty($2b55586061318c76$exports, "name", {
    value: "get flags"
});


var $992adeb8827cf321$exports = {};
"use strict";


var $992adeb8827cf321$require$supportsDescriptors = $16343f2546a69e4c$exports.supportsDescriptors;
var $992adeb8827cf321$var$$gOPD = Object.getOwnPropertyDescriptor;
$992adeb8827cf321$exports = function getPolyfill() {
    if ($992adeb8827cf321$require$supportsDescriptors && /a/mig.flags === "gim") {
        var descriptor = $992adeb8827cf321$var$$gOPD(RegExp.prototype, "flags");
        if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
            /* eslint getter-return: 0 */ var calls = "";
            var o = {};
            Object.defineProperty(o, "hasIndices", {
                get: function() {
                    calls += "d";
                }
            });
            Object.defineProperty(o, "sticky", {
                get: function() {
                    calls += "y";
                }
            });
            if (calls === "dy") return descriptor.get;
        }
    }
    return $2b55586061318c76$exports;
};


var $be61a2fd0f680ceb$exports = {};
"use strict";

var $be61a2fd0f680ceb$require$supportsDescriptors = $16343f2546a69e4c$exports.supportsDescriptors;

var $be61a2fd0f680ceb$var$gOPD = Object.getOwnPropertyDescriptor;
var $be61a2fd0f680ceb$var$defineProperty = Object.defineProperty;
var $be61a2fd0f680ceb$var$TypeErr = TypeError;
var $be61a2fd0f680ceb$var$getProto = Object.getPrototypeOf;
var $be61a2fd0f680ceb$var$regex = /a/;
$be61a2fd0f680ceb$exports = function shimFlags() {
    if (!$be61a2fd0f680ceb$require$supportsDescriptors || !$be61a2fd0f680ceb$var$getProto) throw new $be61a2fd0f680ceb$var$TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var polyfill = $992adeb8827cf321$exports();
    var proto = $be61a2fd0f680ceb$var$getProto($be61a2fd0f680ceb$var$regex);
    var descriptor = $be61a2fd0f680ceb$var$gOPD(proto, "flags");
    if (!descriptor || descriptor.get !== polyfill) $be61a2fd0f680ceb$var$defineProperty(proto, "flags", {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};


var $618155de6b8eecd6$var$flagsBound = $9546dce5bd4976bd$exports($992adeb8827cf321$exports());
$16343f2546a69e4c$exports($618155de6b8eecd6$var$flagsBound, {
    getPolyfill: $992adeb8827cf321$exports,
    implementation: $2b55586061318c76$exports,
    shim: $be61a2fd0f680ceb$exports
});
$618155de6b8eecd6$exports = $618155de6b8eecd6$var$flagsBound;


var $ac12648141d132f9$exports = {};
"use strict";
var $ac12648141d132f9$var$getDay = Date.prototype.getDay;
var $ac12648141d132f9$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $ac12648141d132f9$var$getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $ac12648141d132f9$var$toStr = Object.prototype.toString;
var $ac12648141d132f9$var$dateClass = "[object Date]";

var $ac12648141d132f9$var$hasToStringTag = (parcelRequire("3KyxH"))();
$ac12648141d132f9$exports = function isDateObject(value) {
    if (typeof value !== "object" || value === null) return false;
    return $ac12648141d132f9$var$hasToStringTag ? $ac12648141d132f9$var$tryDateObject(value) : $ac12648141d132f9$var$toStr.call(value) === $ac12648141d132f9$var$dateClass;
};


var $e35a0bae35bfdbad$var$getTime = Date.prototype.getTime;
function $e35a0bae35bfdbad$var$deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $ad6ddb07ef0cb149$exports(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") return opts.strict ? $ad6ddb07ef0cb149$exports(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return $e35a0bae35bfdbad$var$objEquiv(actual, expected, opts);
}
function $e35a0bae35bfdbad$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $e35a0bae35bfdbad$var$isBuffer(x) {
    if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
    if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
    if (x.length > 0 && typeof x[0] !== "number") return false;
    return true;
}
function $e35a0bae35bfdbad$var$objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if ($e35a0bae35bfdbad$var$isUndefinedOrNull(a) || $e35a0bae35bfdbad$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if ($af991f1d6c80f097$exports(a) !== $af991f1d6c80f097$exports(b)) return false;
    var aIsRegex = $f52fe3bd41a86f17$exports(a);
    var bIsRegex = $f52fe3bd41a86f17$exports(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && $618155de6b8eecd6$exports(a) === $618155de6b8eecd6$exports(b);
    if ($ac12648141d132f9$exports(a) && $ac12648141d132f9$exports(b)) return $e35a0bae35bfdbad$var$getTime.call(a) === $e35a0bae35bfdbad$var$getTime.call(b);
    var aIsBuffer = $e35a0bae35bfdbad$var$isBuffer(a);
    var bIsBuffer = $e35a0bae35bfdbad$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = $5d69935f2747da8d$exports(a);
        var kb = $5d69935f2747da8d$exports(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$e35a0bae35bfdbad$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
$e35a0bae35bfdbad$exports = $e35a0bae35bfdbad$var$deepEqual;






function $a3dc0e1a1ee08269$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a3dc0e1a1ee08269$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a3dc0e1a1ee08269$var$ownKeys(Object(source), true).forEach(function(key) {
            $a3dc0e1a1ee08269$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a3dc0e1a1ee08269$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a3dc0e1a1ee08269$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a3dc0e1a1ee08269$export$72ee41b0ad150e05(props, defaultMargins) {
    var margin = props.margin, width = props.width, height = props.height;
    var marginProps = $a3dc0e1a1ee08269$var$_objectSpread($a3dc0e1a1ee08269$var$_objectSpread({}, defaultMargins), typeof margin === "number" ? {
        left: margin,
        right: margin,
        top: margin,
        bottom: margin
    } : margin);
    var _marginProps$left = marginProps.left, marginLeft = _marginProps$left === void 0 ? 0 : _marginProps$left, _marginProps$top = marginProps.top, marginTop = _marginProps$top === void 0 ? 0 : _marginProps$top, _marginProps$right = marginProps.right, marginRight = _marginProps$right === void 0 ? 0 : _marginProps$right, _marginProps$bottom = marginProps.bottom, marginBottom = _marginProps$bottom === void 0 ? 0 : _marginProps$bottom;
    return {
        marginLeft: marginLeft,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        innerHeight: height - marginBottom - marginTop,
        innerWidth: width - marginLeft - marginRight
    };
}
function $a3dc0e1a1ee08269$export$b7318b0ae20c2441(width, height, radius) {
    var marginX = width / 2 - radius;
    var marginY = height / 2 - radius;
    return {
        bottom: marginY,
        left: marginX,
        right: marginX,
        top: marginY
    };
}
var $a3dc0e1a1ee08269$export$a2f0519a883a74de = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        left: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        top: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        right: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
]);
var $a3dc0e1a1ee08269$export$d588676965164366 = {
    left: 40,
    right: 10,
    top: 10,
    bottom: 40
};





var $acw62 = parcelRequire("acw62");




function $87709a40a0a5d723$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $87709a40a0a5d723$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $87709a40a0a5d723$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $87709a40a0a5d723$var$_typeof(obj);
}
function $87709a40a0a5d723$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87709a40a0a5d723$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $87709a40a0a5d723$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87709a40a0a5d723$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87709a40a0a5d723$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $87709a40a0a5d723$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $87709a40a0a5d723$var$_setPrototypeOf(subClass, superClass);
}
function $87709a40a0a5d723$var$_setPrototypeOf(o, p) {
    $87709a40a0a5d723$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $87709a40a0a5d723$var$_setPrototypeOf(o, p);
}
function $87709a40a0a5d723$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $87709a40a0a5d723$var$_isNativeReflectConstruct();
    return function() {
        var Super = $87709a40a0a5d723$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $87709a40a0a5d723$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $87709a40a0a5d723$var$_possibleConstructorReturn(this, result);
    };
}
function $87709a40a0a5d723$var$_possibleConstructorReturn(self, call) {
    if (call && ($87709a40a0a5d723$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $87709a40a0a5d723$var$_assertThisInitialized(self);
}
function $87709a40a0a5d723$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $87709a40a0a5d723$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $87709a40a0a5d723$var$_getPrototypeOf(o) {
    $87709a40a0a5d723$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $87709a40a0a5d723$var$_getPrototypeOf(o);
}
function $87709a40a0a5d723$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87709a40a0a5d723$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $87709a40a0a5d723$var$ownKeys(Object(source), true).forEach(function(key) {
            $87709a40a0a5d723$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $87709a40a0a5d723$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87709a40a0a5d723$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $87709a40a0a5d723$var$MAX_DRAWS = 30;
/**
 * Draw loop draws each of the layers until it should draw more
 * @param {CanvasContext} ctx - the context where the drawing will take place
 * @param {Number} height - height of the canvas
 * @param {Number} width - width of the canvas
 * @param {Array} layers - the layer objects to render
 */ function $87709a40a0a5d723$var$engageDrawLoop(ctx, height, width, layers) {
    var drawIteration = 0; // using setInterval because request animation frame goes too fast
    var drawCycle = setInterval(function() {
        if (!ctx) {
            clearInterval(drawCycle);
            return;
        }
        $87709a40a0a5d723$var$drawLayers(ctx, height, width, layers, drawIteration);
        if (drawIteration > $87709a40a0a5d723$var$MAX_DRAWS) clearInterval(drawCycle);
        drawIteration += 1;
    }, 1);
}
/**
 * Loops across each of the layers to be drawn and draws them
 * @param {CanvasContext} ctx - the context where the drawing will take place
 * @param {Number} height - height of the canvas
 * @param {Number} width - width of the canvas
 * @param {Array} layers - the layer objects to render
 * @param {Number} drawIteration - width of the canvas
 */ function $87709a40a0a5d723$var$drawLayers(ctx, height, width, layers, drawIteration) {
    ctx.clearRect(0, 0, width, height);
    layers.forEach(function(layer) {
        var interpolator = layer.interpolator, newProps = layer.newProps, animation = layer.animation; // return an empty object if dont need to be animating
        var interpolatedProps = animation ? interpolator ? interpolator(drawIteration / $87709a40a0a5d723$var$MAX_DRAWS) : interpolator : function() {
            return {};
        };
        layer.renderLayer($87709a40a0a5d723$var$_objectSpread($87709a40a0a5d723$var$_objectSpread({}, newProps), interpolatedProps), ctx);
    });
}
/**
 * Build an array of layer of objects the contain the method for drawing each series
 * as well as an interpolar (specifically a d3-interpolate interpolator)
 * @param {Object} newChildren the new children to be rendered.
 * @param {Object} oldChildren the old children to be rendered.
 * @returns {Array} Object for rendering
 */ function $87709a40a0a5d723$var$buildLayers(newChildren, oldChildren) {
    return newChildren.map(function(child, index) {
        var oldProps = oldChildren[index] ? oldChildren[index].props : {};
        var newProps = child.props;
        var oldAnimatedProps = (0, $d4808d8f8c60755d$export$b4b2b0749c00e523)($87709a40a0a5d723$var$_objectSpread($87709a40a0a5d723$var$_objectSpread({}, oldProps), {}, {
            animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
        }));
        var newAnimatedProps = newProps ? (0, $d4808d8f8c60755d$export$b4b2b0749c00e523)($87709a40a0a5d723$var$_objectSpread($87709a40a0a5d723$var$_objectSpread({}, newProps), {}, {
            animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
        })) : null;
        var interpolator = (0, $8385105b4986daed$export$2e2bcd8739ae039)(oldAnimatedProps, newAnimatedProps);
        return {
            renderLayer: child.type.renderLayer,
            newProps: child.props,
            animation: child.props.animation,
            interpolator: interpolator
        };
    });
}
var $87709a40a0a5d723$var$CanvasWrapper = /*#__PURE__*/ function(_Component) {
    $87709a40a0a5d723$var$_inherits(CanvasWrapper, _Component);
    var _super = $87709a40a0a5d723$var$_createSuper(CanvasWrapper);
    function CanvasWrapper() {
        $87709a40a0a5d723$var$_classCallCheck(this, CanvasWrapper);
        return _super.apply(this, arguments);
    }
    $87709a40a0a5d723$var$_createClass(CanvasWrapper, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var ctx = this.canvas.getContext("2d");
                if (!ctx) return;
                var pixelRatio = this.props.pixelRatio;
                if (!ctx) return;
                ctx.scale(pixelRatio, pixelRatio);
                this.drawChildren(null, this.props, ctx);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(oldProps) {
                this.drawChildren(oldProps, this.props, this.canvas.getContext("2d"));
            }
        },
        {
            key: "drawChildren",
            value: function drawChildren(oldProps, newProps, ctx) {
                var children = newProps.children, innerHeight = newProps.innerHeight, innerWidth = newProps.innerWidth, marginBottom = newProps.marginBottom, marginLeft = newProps.marginLeft, marginRight = newProps.marginRight, marginTop = newProps.marginTop;
                if (!ctx) return;
                var childrenShouldAnimate = children.find(function(child) {
                    return child.props.animation;
                });
                var height = innerHeight + marginTop + marginBottom;
                var width = innerWidth + marginLeft + marginRight;
                var layers = $87709a40a0a5d723$var$buildLayers(newProps.children, oldProps ? oldProps.children : []); // if we don't need to be animating, dont! cut short
                if (!childrenShouldAnimate) {
                    $87709a40a0a5d723$var$drawLayers(ctx, height, width, layers);
                    return;
                }
                $87709a40a0a5d723$var$engageDrawLoop(ctx, height, width, layers);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, innerHeight = _this$props.innerHeight, innerWidth = _this$props.innerWidth, marginBottom = _this$props.marginBottom, marginLeft = _this$props.marginLeft, marginRight = _this$props.marginRight, marginTop = _this$props.marginTop, pixelRatio = _this$props.pixelRatio;
                var height = innerHeight + marginTop + marginBottom;
                var width = innerWidth + marginLeft + marginRight;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        left: 0,
                        top: 0
                    },
                    className: "rv-xy-canvas"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", {
                    className: "rv-xy-canvas-element",
                    height: height * pixelRatio,
                    width: width * pixelRatio,
                    style: {
                        height: "".concat(height, "px"),
                        width: "".concat(width, "px")
                    },
                    ref: function ref(_ref) {
                        return _this.canvas = _ref;
                    }
                }), this.props.children);
            }
        }
    ], [
        {
            key: "defaultProps",
            get: function get() {
                return {
                    pixelRatio: window && window.devicePixelRatio || 1
                };
            }
        }
    ]);
    return CanvasWrapper;
}((0, $acw62.Component));
$87709a40a0a5d723$var$CanvasWrapper.displayName = "CanvasWrapper";
$87709a40a0a5d723$var$CanvasWrapper.propTypes = {
    marginBottom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    marginRight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    innerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    innerWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    pixelRatio: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
var $87709a40a0a5d723$export$2e2bcd8739ae039 = $87709a40a0a5d723$var$CanvasWrapper;


function $70994359f4ceeef3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $70994359f4ceeef3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $70994359f4ceeef3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $70994359f4ceeef3$var$_typeof(obj);
}
function $70994359f4ceeef3$var$_toConsumableArray(arr) {
    return $70994359f4ceeef3$var$_arrayWithoutHoles(arr) || $70994359f4ceeef3$var$_iterableToArray(arr) || $70994359f4ceeef3$var$_unsupportedIterableToArray(arr) || $70994359f4ceeef3$var$_nonIterableSpread();
}
function $70994359f4ceeef3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $70994359f4ceeef3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $70994359f4ceeef3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $70994359f4ceeef3$var$_arrayLikeToArray(o, minLen);
}
function $70994359f4ceeef3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $70994359f4ceeef3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $70994359f4ceeef3$var$_arrayLikeToArray(arr);
}
function $70994359f4ceeef3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $70994359f4ceeef3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $70994359f4ceeef3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $70994359f4ceeef3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $70994359f4ceeef3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $70994359f4ceeef3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $70994359f4ceeef3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $70994359f4ceeef3$var$_setPrototypeOf(subClass, superClass);
}
function $70994359f4ceeef3$var$_setPrototypeOf(o, p) {
    $70994359f4ceeef3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $70994359f4ceeef3$var$_setPrototypeOf(o, p);
}
function $70994359f4ceeef3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $70994359f4ceeef3$var$_isNativeReflectConstruct();
    return function() {
        var Super = $70994359f4ceeef3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $70994359f4ceeef3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $70994359f4ceeef3$var$_possibleConstructorReturn(this, result);
    };
}
function $70994359f4ceeef3$var$_possibleConstructorReturn(self, call) {
    if (call && ($70994359f4ceeef3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $70994359f4ceeef3$var$_assertThisInitialized(self);
}
function $70994359f4ceeef3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $70994359f4ceeef3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $70994359f4ceeef3$var$_getPrototypeOf(o) {
    $70994359f4ceeef3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $70994359f4ceeef3$var$_getPrototypeOf(o);
}
function $70994359f4ceeef3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $70994359f4ceeef3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $70994359f4ceeef3$var$ownKeys(Object(source), true).forEach(function(key) {
            $70994359f4ceeef3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $70994359f4ceeef3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $70994359f4ceeef3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $70994359f4ceeef3$var$ATTRIBUTES = [
    "x",
    "y",
    "radius",
    "angle",
    "color",
    "fill",
    "stroke",
    "opacity",
    "size"
];
/**
 * Remove parents from tree formatted data. deep-equal doesnt play nice with data
 * that has circular structures, so we make every node single directional by pruning the parents.
 * @param {Array} data - the data object to have circular deps resolved in
 * @returns {Array} the sanitized data
 */ function $70994359f4ceeef3$var$cleanseData(data) {
    return data.map(function(series) {
        if (!Array.isArray(series)) return series;
        return series.map(function(row) {
            return $70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread({}, row), {}, {
                parent: null
            });
        });
    });
}
/**
 * Wrapper on the deep-equal method for checking equality of next props vs current props
 * @param {Object} scaleMixins - Scale object.
 * @param {Object} nextScaleMixins - Scale object.
 * @param {Boolean} hasTreeStructure - Whether or not to cleanse the data of possible cyclic structures
 * @returns {Boolean} whether or not the two mixins objects are equal
 */ function $70994359f4ceeef3$var$checkIfMixinsAreEqual(nextScaleMixins, scaleMixins, hasTreeStructure) {
    var newMixins = $70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread({}, nextScaleMixins), {}, {
        _allData: hasTreeStructure ? $70994359f4ceeef3$var$cleanseData(nextScaleMixins._allData) : nextScaleMixins._allData
    });
    var oldMixins = $70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread({}, scaleMixins), {}, {
        _allData: hasTreeStructure ? $70994359f4ceeef3$var$cleanseData(scaleMixins._allData) : scaleMixins._allData
    }); // it's hard to say if this function is reasonable?
    return (0, (/*@__PURE__*/$parcel$interopDefault($e35a0bae35bfdbad$exports)))(newMixins, oldMixins);
}
var $70994359f4ceeef3$var$XYPlot = /*#__PURE__*/ function(_React$Component) {
    $70994359f4ceeef3$var$_inherits(XYPlot, _React$Component);
    var _super = $70994359f4ceeef3$var$_createSuper(XYPlot);
    $70994359f4ceeef3$var$_createClass(XYPlot, null, [
        {
            key: "defaultProps",
            get: function get() {
                return {
                    className: ""
                };
            }
        },
        {
            key: "propTypes",
            get: function get() {
                return {
                    animation: (0, $d4808d8f8c60755d$export$c6290f21adf0a17a),
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                    dontCheckIfEmpty: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
                    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
                    margin: (0, $a3dc0e1a1ee08269$export$a2f0519a883a74de),
                    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onMouseUp: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onMouseMove: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onTouchStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onTouchMove: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onTouchEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onTouchCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    onWheel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
                    stackBy: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf($70994359f4ceeef3$var$ATTRIBUTES),
                    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
                    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
                };
            }
        }
    ]);
    function XYPlot(props) {
        var _this;
        $70994359f4ceeef3$var$_classCallCheck(this, XYPlot);
        _this = _super.call(this, props);
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_clickHandler", function(event) {
            var onClick = _this.props.onClick;
            if (onClick) onClick(event);
        });
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_doubleClickHandler", function(event) {
            var onDoubleClick = _this.props.onDoubleClick;
            if (onDoubleClick) onDoubleClick(event);
        });
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_mouseDownHandler", function(event) {
            var _this$props = _this.props, onMouseDown = _this$props.onMouseDown, children = _this$props.children;
            if (onMouseDown) onMouseDown(event);
            var seriesChildren = (0, $ba94dd19eb06369c$export$ba0d7ce1f57c52a6)(children);
            seriesChildren.forEach(function(child, index) {
                var component = _this["series".concat(index)];
                if (component && component.onParentMouseDown) component.onParentMouseDown(event);
            });
        });
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_mouseEnterHandler", function(event) {
            var _this$props2 = _this.props, onMouseEnter = _this$props2.onMouseEnter, children = _this$props2.children;
            if (onMouseEnter) onMouseEnter(event);
            var seriesChildren = (0, $ba94dd19eb06369c$export$ba0d7ce1f57c52a6)(children);
            seriesChildren.forEach(function(child, index) {
                var component = _this["series".concat(index)];
                if (component && component.onParentMouseEnter) component.onParentMouseEnter(event);
            });
        });
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_mouseLeaveHandler", function(event) {
            var _this$props3 = _this.props, onMouseLeave = _this$props3.onMouseLeave, children = _this$props3.children;
            if (onMouseLeave) onMouseLeave(event);
            var seriesChildren = (0, $ba94dd19eb06369c$export$ba0d7ce1f57c52a6)(children);
            seriesChildren.forEach(function(child, index) {
                var component = _this["series".concat(index)];
                if (component && component.onParentMouseLeave) component.onParentMouseLeave(event);
            });
        });
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_mouseMoveHandler", function(event) {
            var _this$props4 = _this.props, onMouseMove = _this$props4.onMouseMove, children = _this$props4.children;
            if (onMouseMove) onMouseMove(event);
            var seriesChildren = (0, $ba94dd19eb06369c$export$ba0d7ce1f57c52a6)(children);
            seriesChildren.forEach(function(child, index) {
                var component = _this["series".concat(index)];
                if (component && component.onParentMouseMove) component.onParentMouseMove(event);
            });
        });
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_mouseUpHandler", function(event) {
            var _this$props5 = _this.props, onMouseUp = _this$props5.onMouseUp, children = _this$props5.children;
            if (onMouseUp) onMouseUp(event);
            var seriesChildren = (0, $ba94dd19eb06369c$export$ba0d7ce1f57c52a6)(children);
            seriesChildren.forEach(function(child, index) {
                var component = _this["series".concat(index)];
                if (component && component.onParentMouseUp) component.onParentMouseUp(event);
            });
        });
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_touchCancelHandler", function(event) {
            var onTouchCancel = _this.props.onTouchCancel;
            if (onTouchCancel) onTouchCancel(event);
        });
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_touchEndHandler", function(event) {
            var onTouchEnd = _this.props.onTouchEnd;
            if (onTouchEnd) onTouchEnd(event);
        });
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_touchMoveHandler", function(event) {
            var _this$props6 = _this.props, onTouchMove = _this$props6.onTouchMove, children = _this$props6.children;
            if (onTouchMove) onTouchMove(event);
            var seriesChildren = (0, $ba94dd19eb06369c$export$ba0d7ce1f57c52a6)(children);
            seriesChildren.forEach(function(child, index) {
                var component = _this["series".concat(index)];
                if (component && component.onParentTouchMove) component.onParentTouchMove(event);
            });
        });
        $70994359f4ceeef3$var$_defineProperty($70994359f4ceeef3$var$_assertThisInitialized(_this), "_touchStartHandler", function(event) {
            var _this$props7 = _this.props, onTouchStart = _this$props7.onTouchStart, children = _this$props7.children;
            if (onTouchStart) onTouchStart(event);
            var seriesChildren = (0, $ba94dd19eb06369c$export$ba0d7ce1f57c52a6)(children);
            seriesChildren.forEach(function(child, index) {
                var component = _this["series".concat(index)];
                if (component && component.onParentTouchStart) component.onParentTouchStart(event);
            });
        });
        var stackBy = props.stackBy;
        var _children = (0, $ba94dd19eb06369c$export$ba0d7ce1f57c52a6)(props.children);
        var data = (0, $ba94dd19eb06369c$export$c2170542cfc0177c)(_children, stackBy);
        _this.state = {
            scaleMixins: _this._getScaleMixins(data, props),
            data: data
        };
        return _this;
    }
    $70994359f4ceeef3$var$_createClass(XYPlot, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var children = (0, $ba94dd19eb06369c$export$ba0d7ce1f57c52a6)(nextProps.children);
                var nextData = (0, $ba94dd19eb06369c$export$c2170542cfc0177c)(children, nextProps.stackBy);
                var scaleMixins = this.state.scaleMixins;
                var nextScaleMixins = this._getScaleMixins(nextData, nextProps);
                if (!$70994359f4ceeef3$var$checkIfMixinsAreEqual(nextScaleMixins, scaleMixins, nextProps.hasTreeStructure)) this.setState({
                    scaleMixins: nextScaleMixins,
                    data: nextData
                });
            }
        },
        {
            key: "_getClonedChildComponents",
            /**
     * Prepare the child components (including series) for rendering.
     * @returns {Array} Array of child components.
     * @private
     */ value: function _getClonedChildComponents() {
                var _this2 = this;
                var props = this.props;
                var animation = this.props.animation;
                var _this$state = this.state, scaleMixins = _this$state.scaleMixins, data = _this$state.data;
                var dimensions = (0, $a3dc0e1a1ee08269$export$72ee41b0ad150e05)(this.props, (0, $a3dc0e1a1ee08269$export$d588676965164366));
                var children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(this.props.children);
                var seriesProps = (0, $ba94dd19eb06369c$export$72592ebe4579131b)(children);
                var XYPlotValues = (0, $379b4f4f942d44ab$export$bcb757bdc9760c42)(props, children);
                return children.map(function(child, index) {
                    var dataProps = null;
                    if (seriesProps[index]) {
                        // Get the index of the series in the list of props and retrieve
                        // the data property from it.
                        var seriesIndex = seriesProps[index].seriesIndex;
                        dataProps = {
                            data: data[seriesIndex]
                        };
                    }
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, $70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread({}, dimensions), {}, {
                        animation: animation
                    }, dataProps && child.type.prototype && child.type.prototype.render ? {
                        ref: function ref(_ref) {
                            return _this2["series".concat(seriesProps[index].seriesIndex)] = _ref;
                        }
                    } : {}), seriesProps[index]), scaleMixins), child.props), XYPlotValues[index]), dataProps));
                });
            }
        },
        {
            key: "_getDefaultScaleProps",
            value: function _getDefaultScaleProps(props) {
                var _getInnerDimensions = (0, $a3dc0e1a1ee08269$export$72ee41b0ad150e05)(props, (0, $a3dc0e1a1ee08269$export$d588676965164366)), innerWidth = _getInnerDimensions.innerWidth, innerHeight = _getInnerDimensions.innerHeight;
                var colorRanges = [
                    "color",
                    "fill",
                    "stroke"
                ].reduce(function(acc, attr) {
                    var range = props["".concat(attr, "Type")] === "category" ? (0, $d629c93f7b094ef1$export$9bfc784861ab91d8) : (0, $d629c93f7b094ef1$export$36688c8ae3834bf8);
                    return $70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread({}, acc), {}, $70994359f4ceeef3$var$_defineProperty({}, "".concat(attr, "Range"), range));
                }, {});
                return $70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread({
                    xRange: [
                        0,
                        innerWidth
                    ],
                    yRange: [
                        innerHeight,
                        0
                    ]
                }, colorRanges), {}, {
                    opacityType: (0, $d629c93f7b094ef1$export$dba5ca323c28272c),
                    sizeRange: (0, $d629c93f7b094ef1$export$933e9b6491d90bfd)
                });
            }
        },
        {
            key: "_getScaleMixins",
            value: function _getScaleMixins(data, props) {
                var _ref2;
                var filteredData = data.filter(function(d) {
                    return d;
                });
                var allData = (_ref2 = []).concat.apply(_ref2, $70994359f4ceeef3$var$_toConsumableArray(filteredData));
                var defaultScaleProps = this._getDefaultScaleProps(props);
                var optionalScaleProps = (0, $379b4f4f942d44ab$export$17db1cfb5431bf96)(props);
                var userScaleProps = (0, $379b4f4f942d44ab$export$9ba38978f16a5362)(props, $70994359f4ceeef3$var$ATTRIBUTES);
                var missingScaleProps = (0, $379b4f4f942d44ab$export$6b25e8934069fbf5)($70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread({}, defaultScaleProps), optionalScaleProps), userScaleProps), allData, $70994359f4ceeef3$var$ATTRIBUTES);
                var children = (0, $ba94dd19eb06369c$export$ba0d7ce1f57c52a6)(props.children);
                var zeroBaseProps = {};
                var adjustBy = new Set();
                var adjustWhat = new Set();
                children.forEach(function(child, index) {
                    if (!child || !data[index]) return;
                    $70994359f4ceeef3$var$ATTRIBUTES.forEach(function(attr) {
                        var _child$type$getParent = child.type.getParentConfig(attr, child.props), isDomainAdjustmentNeeded = _child$type$getParent.isDomainAdjustmentNeeded, zeroBaseValue = _child$type$getParent.zeroBaseValue;
                        if (isDomainAdjustmentNeeded) {
                            adjustBy.add(attr);
                            adjustWhat.add(index);
                        }
                        if (zeroBaseValue) {
                            var specifiedDomain = props["".concat(attr, "Domain")];
                            zeroBaseProps["".concat(attr, "BaseValue")] = specifiedDomain ? specifiedDomain[0] : 0;
                        }
                    });
                });
                return $70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread($70994359f4ceeef3$var$_objectSpread({}, defaultScaleProps), zeroBaseProps), userScaleProps), missingScaleProps), {}, {
                    _allData: data,
                    _adjustBy: Array.from(adjustBy),
                    _adjustWhat: Array.from(adjustWhat),
                    _stackBy: props.stackBy
                });
            }
        },
        {
            key: "_isPlotEmpty",
            value: function _isPlotEmpty() {
                var data = this.state.data;
                return !data || !data.length || !data.some(function(series) {
                    return series && series.some(function(d) {
                        return d;
                    });
                });
            }
        },
        {
            key: "renderCanvasComponents",
            value: function renderCanvasComponents(components) {
                var componentsToRender = components.filter(function(c) {
                    return c && !c.type.requiresSVG && c.type.isCanvas;
                });
                if (componentsToRender.length === 0) return null;
                var _componentsToRender$ = componentsToRender[0].props, marginLeft = _componentsToRender$.marginLeft, marginTop = _componentsToRender$.marginTop, marginBottom = _componentsToRender$.marginBottom, marginRight = _componentsToRender$.marginRight, innerHeight = _componentsToRender$.innerHeight, innerWidth = _componentsToRender$.innerWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87709a40a0a5d723$export$2e2bcd8739ae039), {
                    innerHeight: innerHeight,
                    innerWidth: innerWidth,
                    marginLeft: marginLeft,
                    marginTop: marginTop,
                    marginBottom: marginBottom,
                    marginRight: marginRight
                }, componentsToRender);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props8 = this.props, className = _this$props8.className, dontCheckIfEmpty = _this$props8.dontCheckIfEmpty, style = _this$props8.style, width = _this$props8.width, height = _this$props8.height, onWheel = _this$props8.onWheel;
                if (!dontCheckIfEmpty && this._isPlotEmpty()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-xy-plot", className),
                    style: $70994359f4ceeef3$var$_objectSpread({
                        width: "".concat(width, "px"),
                        height: "".concat(height, "px")
                    }, this.props.style)
                });
                var components = this._getClonedChildComponents();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: {
                        width: "".concat(width, "px"),
                        height: "".concat(height, "px")
                    },
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-xy-plot", className)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
                    className: "rv-xy-plot__inner",
                    width: width,
                    height: height,
                    style: style,
                    onClick: this._clickHandler,
                    onDoubleClick: this._doubleClickHandler,
                    onMouseDown: this._mouseDownHandler,
                    onMouseUp: this._mouseUpHandler,
                    onMouseMove: this._mouseMoveHandler,
                    onMouseLeave: this._mouseLeaveHandler,
                    onMouseEnter: this._mouseEnterHandler,
                    onTouchStart: this._mouseDownHandler,
                    onTouchMove: this._touchMoveHandler,
                    onTouchEnd: this._touchEndHandler,
                    onTouchCancel: this._touchCancelHandler,
                    onWheel: onWheel
                }, components.filter(function(c) {
                    return c && c.type.requiresSVG;
                })), this.renderCanvasComponents(components), components.filter(function(c) {
                    return c && !c.type.requiresSVG && !c.type.isCanvas;
                }));
            }
        }
    ]);
    return XYPlot;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$70994359f4ceeef3$var$XYPlot.displayName = "XYPlot";
var $70994359f4ceeef3$export$2e2bcd8739ae039 = $70994359f4ceeef3$var$XYPlot;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


function $99d2abdc3b3bd348$var$_extends() {
    $99d2abdc3b3bd348$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $99d2abdc3b3bd348$var$_extends.apply(this, arguments);
}
var $99d2abdc3b3bd348$var$LEFT = (0, $16d91db751e2a422$export$7423c88bc54edb74).LEFT, $99d2abdc3b3bd348$var$RIGHT = (0, $16d91db751e2a422$export$7423c88bc54edb74).RIGHT, $99d2abdc3b3bd348$var$TOP = (0, $16d91db751e2a422$export$7423c88bc54edb74).TOP, $99d2abdc3b3bd348$var$BOTTOM = (0, $16d91db751e2a422$export$7423c88bc54edb74).BOTTOM;
var $99d2abdc3b3bd348$var$propTypes = {
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        $99d2abdc3b3bd348$var$LEFT,
        $99d2abdc3b3bd348$var$RIGHT,
        $99d2abdc3b3bd348$var$TOP,
        $99d2abdc3b3bd348$var$BOTTOM
    ]).isRequired,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
var $99d2abdc3b3bd348$var$defaultProps = {
    style: {}
};
function $99d2abdc3b3bd348$var$AxisLine(_ref) {
    var orientation = _ref.orientation, width = _ref.width, height = _ref.height, style = _ref.style;
    var lineProps;
    if (orientation === $99d2abdc3b3bd348$var$LEFT) lineProps = {
        x1: width,
        x2: width,
        y1: 0,
        y2: height
    };
    else if (orientation === $99d2abdc3b3bd348$var$RIGHT) lineProps = {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: height
    };
    else if (orientation === $99d2abdc3b3bd348$var$TOP) lineProps = {
        x1: 0,
        x2: width,
        y1: height,
        y2: height
    };
    else lineProps = {
        x1: 0,
        x2: width,
        y1: 0,
        y2: 0
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $99d2abdc3b3bd348$var$_extends({}, lineProps, {
        className: "rv-xy-plot__axis__line",
        style: style
    }));
}
$99d2abdc3b3bd348$var$AxisLine.defaultProps = $99d2abdc3b3bd348$var$defaultProps;
$99d2abdc3b3bd348$var$AxisLine.displayName = "AxisLine";
$99d2abdc3b3bd348$var$AxisLine.propTypes = $99d2abdc3b3bd348$var$propTypes;
var $99d2abdc3b3bd348$export$2e2bcd8739ae039 = $99d2abdc3b3bd348$var$AxisLine;



var $acw62 = parcelRequire("acw62");



function $f2891c14f09dce5b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f2891c14f09dce5b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f2891c14f09dce5b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f2891c14f09dce5b$var$_typeof(obj);
}
function $f2891c14f09dce5b$var$_extends() {
    $f2891c14f09dce5b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f2891c14f09dce5b$var$_extends.apply(this, arguments);
}
function $f2891c14f09dce5b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f2891c14f09dce5b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f2891c14f09dce5b$var$ownKeys(Object(source), true).forEach(function(key) {
            $f2891c14f09dce5b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f2891c14f09dce5b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f2891c14f09dce5b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f2891c14f09dce5b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f2891c14f09dce5b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f2891c14f09dce5b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f2891c14f09dce5b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f2891c14f09dce5b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f2891c14f09dce5b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f2891c14f09dce5b$var$_setPrototypeOf(subClass, superClass);
}
function $f2891c14f09dce5b$var$_setPrototypeOf(o, p) {
    $f2891c14f09dce5b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f2891c14f09dce5b$var$_setPrototypeOf(o, p);
}
function $f2891c14f09dce5b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f2891c14f09dce5b$var$_isNativeReflectConstruct();
    return function() {
        var Super = $f2891c14f09dce5b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f2891c14f09dce5b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f2891c14f09dce5b$var$_possibleConstructorReturn(this, result);
    };
}
function $f2891c14f09dce5b$var$_possibleConstructorReturn(self, call) {
    if (call && ($f2891c14f09dce5b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f2891c14f09dce5b$var$_assertThisInitialized(self);
}
function $f2891c14f09dce5b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f2891c14f09dce5b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f2891c14f09dce5b$var$_getPrototypeOf(o) {
    $f2891c14f09dce5b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f2891c14f09dce5b$var$_getPrototypeOf(o);
}
var $f2891c14f09dce5b$var$LEFT = (0, $16d91db751e2a422$export$7423c88bc54edb74).LEFT, $f2891c14f09dce5b$var$RIGHT = (0, $16d91db751e2a422$export$7423c88bc54edb74).RIGHT, $f2891c14f09dce5b$var$TOP = (0, $16d91db751e2a422$export$7423c88bc54edb74).TOP, $f2891c14f09dce5b$var$BOTTOM = (0, $16d91db751e2a422$export$7423c88bc54edb74).BOTTOM;
var $f2891c14f09dce5b$var$propTypes = {
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        $f2891c14f09dce5b$var$LEFT,
        $f2891c14f09dce5b$var$RIGHT,
        $f2891c14f09dce5b$var$TOP,
        $f2891c14f09dce5b$var$BOTTOM
    ]).isRequired,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
var $f2891c14f09dce5b$var$defaultProps = {
    style: {}
};
function $f2891c14f09dce5b$var$_getTickFormatFn(scale, tickTotal, tickFormat) {
    return !tickFormat ? scale.tickFormat ? scale.tickFormat(tickTotal) : function(v) {
        return v;
    } : tickFormat;
}
var $f2891c14f09dce5b$var$AxisTicks = /*#__PURE__*/ function(_React$Component) {
    $f2891c14f09dce5b$var$_inherits(AxisTicks, _React$Component);
    var _super = $f2891c14f09dce5b$var$_createSuper(AxisTicks);
    function AxisTicks() {
        $f2891c14f09dce5b$var$_classCallCheck(this, AxisTicks);
        return _super.apply(this, arguments);
    }
    $f2891c14f09dce5b$var$_createClass(AxisTicks, [
        {
            key: "_areTicksWrapped",
            /**
     * Check if axis ticks should be mirrored (for the right and top positions.
     * @returns {boolean} True if mirrored.
     * @private
     */ value: function _areTicksWrapped() {
                var orientation = this.props.orientation;
                return orientation === $f2891c14f09dce5b$var$LEFT || orientation === $f2891c14f09dce5b$var$TOP;
            }
        },
        {
            key: "_getTickContainerPropsGetterFn",
            value: function _getTickContainerPropsGetterFn() {
                if (this._isAxisVertical()) return function(pos) {
                    return {
                        transform: "translate(0, ".concat(pos, ")")
                    };
                };
                return function(pos) {
                    return {
                        transform: "translate(".concat(pos, ", 0)")
                    };
                };
            }
        },
        {
            key: "_getTickLabelProps",
            value: function _getTickLabelProps() {
                var _this$props = this.props, orientation = _this$props.orientation, tickLabelAngle = _this$props.tickLabelAngle, tickSize = _this$props.tickSize, _this$props$tickSizeO = _this$props.tickSizeOuter, tickSizeOuter = _this$props$tickSizeO === void 0 ? tickSize : _this$props$tickSizeO, _this$props$tickPaddi = _this$props.tickPadding, tickPadding = _this$props$tickPaddi === void 0 ? tickSize : _this$props$tickPaddi; // Assign the text orientation inside the label of the tick mark.
                var textAnchor;
                if (orientation === $f2891c14f09dce5b$var$LEFT || orientation === $f2891c14f09dce5b$var$BOTTOM && tickLabelAngle) textAnchor = "end";
                else if (orientation === $f2891c14f09dce5b$var$RIGHT || orientation === $f2891c14f09dce5b$var$TOP && tickLabelAngle) textAnchor = "start";
                else textAnchor = "middle";
                 // The label's position is translated to the given padding and then the
                // label is rotated to the given angle.
                var isVertical = this._isAxisVertical();
                var wrap = this._areTicksWrapped() ? -1 : 1;
                var labelOffset = wrap * (tickSizeOuter + tickPadding);
                var transform = (isVertical ? "translate(".concat(labelOffset, ", 0)") : "translate(0, ".concat(labelOffset, ")")) + (tickLabelAngle ? " rotate(".concat(tickLabelAngle, ")") : ""); // Set the vertical offset of the label according to the position of
                // the axis.
                var dy = orientation === $f2891c14f09dce5b$var$TOP || tickLabelAngle ? "0" : orientation === $f2891c14f09dce5b$var$BOTTOM ? "0.72em" : "0.32em";
                return {
                    textAnchor: textAnchor,
                    dy: dy,
                    transform: transform
                };
            }
        },
        {
            key: "_getTickLineProps",
            value: function _getTickLineProps() {
                var _ref;
                var _this$props2 = this.props, tickSize = _this$props2.tickSize, _this$props2$tickSize = _this$props2.tickSizeOuter, tickSizeOuter = _this$props2$tickSize === void 0 ? tickSize : _this$props2$tickSize, _this$props2$tickSize2 = _this$props2.tickSizeInner, tickSizeInner = _this$props2$tickSize2 === void 0 ? tickSize : _this$props2$tickSize2;
                var isVertical = this._isAxisVertical();
                var tickXAttr = isVertical ? "y" : "x";
                var tickYAttr = isVertical ? "x" : "y";
                var wrap = this._areTicksWrapped() ? -1 : 1;
                return _ref = {}, $f2891c14f09dce5b$var$_defineProperty(_ref, "".concat(tickXAttr, "1"), 0), $f2891c14f09dce5b$var$_defineProperty(_ref, "".concat(tickXAttr, "2"), 0), $f2891c14f09dce5b$var$_defineProperty(_ref, "".concat(tickYAttr, "1"), -wrap * tickSizeInner), $f2891c14f09dce5b$var$_defineProperty(_ref, "".concat(tickYAttr, "2"), wrap * tickSizeOuter), _ref;
            }
        },
        {
            key: "_isAxisVertical",
            value: function _isAxisVertical() {
                var orientation = this.props.orientation;
                return orientation === $f2891c14f09dce5b$var$LEFT || orientation === $f2891c14f09dce5b$var$RIGHT;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, attr = _this$props3.attr, orientation = _this$props3.orientation, width = _this$props3.width, height = _this$props3.height, style = _this$props3.style, tickFormat = _this$props3.tickFormat, tickTotal = _this$props3.tickTotal, tickValues = _this$props3.tickValues;
                var x = orientation === $f2891c14f09dce5b$var$LEFT ? width : 0;
                var y = orientation === $f2891c14f09dce5b$var$TOP ? height : 0;
                var scale = (0, $379b4f4f942d44ab$export$cb87eff04da17d9)(this.props, attr);
                var values = (0, $16d91db751e2a422$export$4cc7a216492b1f53)(scale, tickTotal, tickValues);
                var tickFormatFn = $f2891c14f09dce5b$var$_getTickFormatFn(scale, tickTotal, tickFormat);
                var translateFn = this._getTickContainerPropsGetterFn();
                var pathProps = this._getTickLineProps();
                var textProps = this._getTickLabelProps();
                var ticks = values.map(function(v, i) {
                    var pos = scale(v);
                    var labelNode = tickFormatFn(v, i, scale, tickTotal);
                    var shouldRenderAsOwnNode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(labelNode) && ![
                        "tspan",
                        "textPath"
                    ].includes(labelNode.type);
                    var shouldAddProps = labelNode && typeof labelNode.type !== "string";
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", $f2891c14f09dce5b$var$_extends({
                        key: i
                    }, translateFn(pos, 0), {
                        className: "rv-xy-plot__axis__tick",
                        style: style
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", $f2891c14f09dce5b$var$_extends({}, pathProps, {
                        className: "rv-xy-plot__axis__tick__line",
                        style: $f2891c14f09dce5b$var$_objectSpread($f2891c14f09dce5b$var$_objectSpread({}, style), style.line)
                    })), shouldRenderAsOwnNode ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(labelNode, shouldAddProps ? $f2891c14f09dce5b$var$_objectSpread($f2891c14f09dce5b$var$_objectSpread({}, textProps), {}, {
                        containerWidth: width,
                        tickCount: values.length
                    }) : undefined) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", $f2891c14f09dce5b$var$_extends({}, textProps, {
                        className: "rv-xy-plot__axis__tick__text",
                        style: $f2891c14f09dce5b$var$_objectSpread($f2891c14f09dce5b$var$_objectSpread({}, style), style.text)
                    }), labelNode));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    transform: "translate(".concat(x, ", ").concat(y, ")"),
                    className: "rv-xy-plot__axis__ticks"
                }, ticks);
            }
        }
    ]);
    return AxisTicks;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$f2891c14f09dce5b$var$AxisTicks.defaultProps = $f2891c14f09dce5b$var$defaultProps;
$f2891c14f09dce5b$var$AxisTicks.displayName = "AxisTicks";
$f2891c14f09dce5b$var$AxisTicks.propTypes = $f2891c14f09dce5b$var$propTypes;
$f2891c14f09dce5b$var$AxisTicks.requiresSVG = true;
var $f2891c14f09dce5b$export$2e2bcd8739ae039 = $f2891c14f09dce5b$var$AxisTicks;



var $acw62 = parcelRequire("acw62");


function $5486ea86df6cd864$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5486ea86df6cd864$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5486ea86df6cd864$var$ownKeys(Object(source), true).forEach(function(key) {
            $5486ea86df6cd864$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5486ea86df6cd864$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5486ea86df6cd864$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5486ea86df6cd864$var$ADJUSTMENT_FOR_TEXT_SIZE = 16;
var $5486ea86df6cd864$var$MARGIN = 6;
var $5486ea86df6cd864$var$LEFT = (0, $16d91db751e2a422$export$7423c88bc54edb74).LEFT, $5486ea86df6cd864$var$RIGHT = (0, $16d91db751e2a422$export$7423c88bc54edb74).RIGHT, $5486ea86df6cd864$var$TOP = (0, $16d91db751e2a422$export$7423c88bc54edb74).TOP, $5486ea86df6cd864$var$BOTTOM = (0, $16d91db751e2a422$export$7423c88bc54edb74).BOTTOM;
var $5486ea86df6cd864$var$defaultProps = {
    position: "end"
};
/**
 * Compute transformations, keyed by orientation
 * @param {number} width - width of axis
 * @param {number} height - height of axis
 * @returns {Object} Object of transformations, keyed by orientation
 */ var $5486ea86df6cd864$var$transformation = function transformation(width, height) {
    var _ref;
    return _ref = {}, $5486ea86df6cd864$var$_defineProperty(_ref, $5486ea86df6cd864$var$LEFT, {
        end: {
            x: $5486ea86df6cd864$var$ADJUSTMENT_FOR_TEXT_SIZE,
            y: $5486ea86df6cd864$var$MARGIN,
            rotation: -90,
            textAnchor: "end"
        },
        middle: {
            x: $5486ea86df6cd864$var$ADJUSTMENT_FOR_TEXT_SIZE,
            y: height / 2 - $5486ea86df6cd864$var$MARGIN,
            rotation: -90,
            textAnchor: "middle"
        },
        start: {
            x: $5486ea86df6cd864$var$ADJUSTMENT_FOR_TEXT_SIZE,
            y: height - $5486ea86df6cd864$var$MARGIN,
            rotation: -90,
            textAnchor: "start"
        }
    }), $5486ea86df6cd864$var$_defineProperty(_ref, $5486ea86df6cd864$var$RIGHT, {
        end: {
            x: $5486ea86df6cd864$var$ADJUSTMENT_FOR_TEXT_SIZE * -0.5,
            y: $5486ea86df6cd864$var$MARGIN,
            rotation: -90,
            textAnchor: "end"
        },
        middle: {
            x: $5486ea86df6cd864$var$ADJUSTMENT_FOR_TEXT_SIZE * -0.5,
            y: height / 2 - $5486ea86df6cd864$var$MARGIN,
            rotation: -90,
            textAnchor: "middle"
        },
        start: {
            x: $5486ea86df6cd864$var$ADJUSTMENT_FOR_TEXT_SIZE * -0.5,
            y: height - $5486ea86df6cd864$var$MARGIN,
            rotation: -90,
            textAnchor: "start"
        }
    }), $5486ea86df6cd864$var$_defineProperty(_ref, $5486ea86df6cd864$var$TOP, {
        start: {
            x: $5486ea86df6cd864$var$MARGIN,
            y: $5486ea86df6cd864$var$ADJUSTMENT_FOR_TEXT_SIZE,
            rotation: 0,
            textAnchor: "start"
        },
        middle: {
            x: width / 2 - $5486ea86df6cd864$var$MARGIN,
            y: $5486ea86df6cd864$var$ADJUSTMENT_FOR_TEXT_SIZE,
            rotation: 0,
            textAnchor: "middle"
        },
        end: {
            x: width - $5486ea86df6cd864$var$MARGIN,
            y: $5486ea86df6cd864$var$ADJUSTMENT_FOR_TEXT_SIZE,
            rotation: 0,
            textAnchor: "end"
        }
    }), $5486ea86df6cd864$var$_defineProperty(_ref, $5486ea86df6cd864$var$BOTTOM, {
        start: {
            x: $5486ea86df6cd864$var$MARGIN,
            y: -$5486ea86df6cd864$var$MARGIN,
            rotation: 0,
            textAnchor: "start"
        },
        middle: {
            x: width / 2 - $5486ea86df6cd864$var$MARGIN,
            y: -$5486ea86df6cd864$var$MARGIN,
            rotation: 0,
            textAnchor: "middle"
        },
        end: {
            x: width - $5486ea86df6cd864$var$MARGIN,
            y: -$5486ea86df6cd864$var$MARGIN,
            rotation: 0,
            textAnchor: "end"
        }
    }), _ref;
};
var $5486ea86df6cd864$var$propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        $5486ea86df6cd864$var$LEFT,
        $5486ea86df6cd864$var$RIGHT,
        $5486ea86df6cd864$var$TOP,
        $5486ea86df6cd864$var$BOTTOM
    ]).isRequired,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired
};
function $5486ea86df6cd864$var$AxisTitle(_ref2) {
    var orientation = _ref2.orientation, position = _ref2.position, width = _ref2.width, height = _ref2.height, style = _ref2.style, title = _ref2.title;
    var outerGroupTranslateX = orientation === $5486ea86df6cd864$var$LEFT ? width : 0;
    var outerGroupTranslateY = orientation === $5486ea86df6cd864$var$TOP ? height : 0;
    var outerGroupTransform = "translate(".concat(outerGroupTranslateX, ", ").concat(outerGroupTranslateY, ")");
    var _transformation$orien = $5486ea86df6cd864$var$transformation(width, height)[orientation][position], x = _transformation$orien.x, y = _transformation$orien.y, rotation = _transformation$orien.rotation, textAnchor = _transformation$orien.textAnchor;
    var innerGroupTransform = "translate(".concat(x, ", ").concat(y, ") rotate(").concat(rotation, ")");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: outerGroupTransform,
        className: "rv-xy-plot__axis__title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        style: $5486ea86df6cd864$var$_objectSpread({
            textAnchor: textAnchor
        }, style),
        transform: innerGroupTransform
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        style: style
    }, title)));
}
$5486ea86df6cd864$var$AxisTitle.displayName = "AxisTitle";
$5486ea86df6cd864$var$AxisTitle.propTypes = $5486ea86df6cd864$var$propTypes;
$5486ea86df6cd864$var$AxisTitle.defaultProps = $5486ea86df6cd864$var$defaultProps;
var $5486ea86df6cd864$export$2e2bcd8739ae039 = $5486ea86df6cd864$var$AxisTitle;


function $dc4391d98b3c1b39$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dc4391d98b3c1b39$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dc4391d98b3c1b39$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dc4391d98b3c1b39$var$_typeof(obj);
}
function $dc4391d98b3c1b39$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc4391d98b3c1b39$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dc4391d98b3c1b39$var$ownKeys(Object(source), true).forEach(function(key) {
            $dc4391d98b3c1b39$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dc4391d98b3c1b39$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc4391d98b3c1b39$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc4391d98b3c1b39$var$_extends() {
    $dc4391d98b3c1b39$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc4391d98b3c1b39$var$_extends.apply(this, arguments);
}
function $dc4391d98b3c1b39$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dc4391d98b3c1b39$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dc4391d98b3c1b39$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dc4391d98b3c1b39$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dc4391d98b3c1b39$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dc4391d98b3c1b39$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $dc4391d98b3c1b39$var$_setPrototypeOf(subClass, superClass);
}
function $dc4391d98b3c1b39$var$_setPrototypeOf(o, p) {
    $dc4391d98b3c1b39$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dc4391d98b3c1b39$var$_setPrototypeOf(o, p);
}
function $dc4391d98b3c1b39$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dc4391d98b3c1b39$var$_isNativeReflectConstruct();
    return function() {
        var Super = $dc4391d98b3c1b39$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $dc4391d98b3c1b39$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $dc4391d98b3c1b39$var$_possibleConstructorReturn(this, result);
    };
}
function $dc4391d98b3c1b39$var$_possibleConstructorReturn(self, call) {
    if (call && ($dc4391d98b3c1b39$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $dc4391d98b3c1b39$var$_assertThisInitialized(self);
}
function $dc4391d98b3c1b39$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $dc4391d98b3c1b39$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dc4391d98b3c1b39$var$_getPrototypeOf(o) {
    $dc4391d98b3c1b39$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dc4391d98b3c1b39$var$_getPrototypeOf(o);
}
var $dc4391d98b3c1b39$var$defaultAnimatedProps = [
    "xRange",
    "yRange",
    "xDomain",
    "yDomain",
    "width",
    "height",
    "marginLeft",
    "marginTop",
    "marginRight",
    "marginBottom",
    "tickSize",
    "tickTotal",
    "tickSizeInner",
    "tickSizeOuter"
];
var $dc4391d98b3c1b39$var$LEFT = (0, $16d91db751e2a422$export$7423c88bc54edb74).LEFT, $dc4391d98b3c1b39$var$RIGHT = (0, $16d91db751e2a422$export$7423c88bc54edb74).RIGHT, $dc4391d98b3c1b39$var$TOP = (0, $16d91db751e2a422$export$7423c88bc54edb74).TOP, $dc4391d98b3c1b39$var$BOTTOM = (0, $16d91db751e2a422$export$7423c88bc54edb74).BOTTOM;
var $dc4391d98b3c1b39$var$propTypes = {
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        $dc4391d98b3c1b39$var$LEFT,
        $dc4391d98b3c1b39$var$RIGHT,
        $dc4391d98b3c1b39$var$TOP,
        $dc4391d98b3c1b39$var$BOTTOM
    ]),
    attr: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    attrAxis: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    top: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    hideTicks: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    hideLine: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    on0: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    tickLabelAngle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    tickSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    tickSizeInner: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    tickSizeOuter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    tickPadding: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    tickValues: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ])),
    tickFormat: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    tickTotal: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    // Not expected to be used by the users.
    // TODO: Add underscore to these properties later.
    marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginBottom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    marginRight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    innerWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    innerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
};
var $dc4391d98b3c1b39$var$defaultProps = {
    className: "",
    on0: false,
    style: {},
    tickSize: 6,
    tickPadding: 8,
    orientation: $dc4391d98b3c1b39$var$BOTTOM
};
var $dc4391d98b3c1b39$var$predefinedClassName = "rv-xy-plot__axis";
var $dc4391d98b3c1b39$var$VERTICAL_CLASS_NAME = "rv-xy-plot__axis--vertical";
var $dc4391d98b3c1b39$var$HORIZONTAL_CLASS_NAME = "rv-xy-plot__axis--horizontal";
var $dc4391d98b3c1b39$var$Axis = /*#__PURE__*/ function(_PureComponent) {
    $dc4391d98b3c1b39$var$_inherits(Axis, _PureComponent);
    var _super = $dc4391d98b3c1b39$var$_createSuper(Axis);
    function Axis() {
        $dc4391d98b3c1b39$var$_classCallCheck(this, Axis);
        return _super.apply(this, arguments);
    }
    $dc4391d98b3c1b39$var$_createClass(Axis, [
        {
            key: "_getDefaultAxisProps",
            /**
     * Define the default values depending on the data passed from the outside.
     * @returns {*} Object of default properties.
     * @private
     */ value: function _getDefaultAxisProps() {
                var _this$props = this.props, innerWidth = _this$props.innerWidth, innerHeight = _this$props.innerHeight, marginTop = _this$props.marginTop, marginBottom = _this$props.marginBottom, marginLeft = _this$props.marginLeft, marginRight = _this$props.marginRight, orientation = _this$props.orientation;
                if (orientation === $dc4391d98b3c1b39$var$BOTTOM) return {
                    tickTotal: (0, $16d91db751e2a422$export$8d2671251b7b6f75)(innerWidth),
                    top: innerHeight + marginTop,
                    left: marginLeft,
                    width: innerWidth,
                    height: marginBottom
                };
                else if (orientation === $dc4391d98b3c1b39$var$TOP) return {
                    tickTotal: (0, $16d91db751e2a422$export$8d2671251b7b6f75)(innerWidth),
                    top: 0,
                    left: marginLeft,
                    width: innerWidth,
                    height: marginTop
                };
                else if (orientation === $dc4391d98b3c1b39$var$LEFT) return {
                    tickTotal: (0, $16d91db751e2a422$export$8d2671251b7b6f75)(innerHeight),
                    top: marginTop,
                    left: 0,
                    width: marginLeft,
                    height: innerHeight
                };
                return {
                    tickTotal: (0, $16d91db751e2a422$export$8d2671251b7b6f75)(innerHeight),
                    top: marginTop,
                    left: marginLeft + innerWidth,
                    width: marginRight,
                    height: innerHeight
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var animation = this.props.animation;
                if (animation) {
                    var animatedProps = animation.nonAnimatedProps ? $dc4391d98b3c1b39$var$defaultAnimatedProps.filter(function(prop) {
                        return animation.nonAnimatedProps.indexOf(prop) < 0;
                    }) : $dc4391d98b3c1b39$var$defaultAnimatedProps;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $dc4391d98b3c1b39$var$_extends({}, this.props, {
                        animatedProps: animatedProps
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Axis, $dc4391d98b3c1b39$var$_extends({}, this.props, {
                        animation: null
                    })));
                }
                var props = $dc4391d98b3c1b39$var$_objectSpread($dc4391d98b3c1b39$var$_objectSpread({}, this._getDefaultAxisProps()), this.props);
                var attrAxis = props.attrAxis, className = props.className, height = props.height, hideLine = props.hideLine, hideTicks = props.hideTicks, left = props.left, marginTop = props.marginTop, on0 = props.on0, orientation = props.orientation, position = props.position, style = props.style, title = props.title, top = props.top, width = props.width;
                var isVertical = [
                    $dc4391d98b3c1b39$var$LEFT,
                    $dc4391d98b3c1b39$var$RIGHT
                ].indexOf(orientation) > -1;
                var axisClassName = isVertical ? $dc4391d98b3c1b39$var$VERTICAL_CLASS_NAME : $dc4391d98b3c1b39$var$HORIZONTAL_CLASS_NAME;
                var leftPos = left;
                var topPos = top;
                if (on0) {
                    var scale = (0, $379b4f4f942d44ab$export$cb87eff04da17d9)(props, attrAxis);
                    if (isVertical) leftPos = scale(0);
                    else topPos = marginTop + scale(0);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                    transform: "translate(".concat(leftPos, ",").concat(topPos, ")"),
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($dc4391d98b3c1b39$var$predefinedClassName, axisClassName, className),
                    style: style
                }, !hideLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99d2abdc3b3bd348$export$2e2bcd8739ae039), {
                    height: height,
                    width: width,
                    orientation: orientation,
                    style: $dc4391d98b3c1b39$var$_objectSpread($dc4391d98b3c1b39$var$_objectSpread({}, style), style.line)
                }), !hideTicks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f2891c14f09dce5b$export$2e2bcd8739ae039), $dc4391d98b3c1b39$var$_extends({}, props, {
                    style: $dc4391d98b3c1b39$var$_objectSpread($dc4391d98b3c1b39$var$_objectSpread({}, style), style.ticks)
                })), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5486ea86df6cd864$export$2e2bcd8739ae039), {
                    position: position,
                    title: title,
                    height: height,
                    width: width,
                    style: $dc4391d98b3c1b39$var$_objectSpread($dc4391d98b3c1b39$var$_objectSpread({}, style), style.title),
                    orientation: orientation
                }) : null);
            }
        }
    ]);
    return Axis;
}((0, $acw62.PureComponent));
$dc4391d98b3c1b39$var$Axis.displayName = "Axis";
$dc4391d98b3c1b39$var$Axis.propTypes = $dc4391d98b3c1b39$var$propTypes;
$dc4391d98b3c1b39$var$Axis.defaultProps = $dc4391d98b3c1b39$var$defaultProps;
$dc4391d98b3c1b39$var$Axis.requiresSVG = true;
var $dc4391d98b3c1b39$export$2e2bcd8739ae039 = $dc4391d98b3c1b39$var$Axis;


function $91c9e8a42ce6481e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $91c9e8a42ce6481e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $91c9e8a42ce6481e$var$ownKeys(Object(source), true).forEach(function(key) {
            $91c9e8a42ce6481e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $91c9e8a42ce6481e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $91c9e8a42ce6481e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $91c9e8a42ce6481e$var$TOP = (0, $16d91db751e2a422$export$7423c88bc54edb74).TOP, $91c9e8a42ce6481e$var$BOTTOM = (0, $16d91db751e2a422$export$7423c88bc54edb74).BOTTOM;
var $91c9e8a42ce6481e$var$propTypes = $91c9e8a42ce6481e$var$_objectSpread($91c9e8a42ce6481e$var$_objectSpread({}, (0, $dc4391d98b3c1b39$export$2e2bcd8739ae039).propTypes), {}, {
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        $91c9e8a42ce6481e$var$TOP,
        $91c9e8a42ce6481e$var$BOTTOM
    ])
});
var $91c9e8a42ce6481e$var$defaultProps = {
    orientation: $91c9e8a42ce6481e$var$BOTTOM,
    attr: "x",
    attrAxis: "y"
};
function $91c9e8a42ce6481e$var$XAxis(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc4391d98b3c1b39$export$2e2bcd8739ae039), props);
}
$91c9e8a42ce6481e$var$XAxis.displayName = "XAxis";
$91c9e8a42ce6481e$var$XAxis.propTypes = $91c9e8a42ce6481e$var$propTypes;
$91c9e8a42ce6481e$var$XAxis.defaultProps = $91c9e8a42ce6481e$var$defaultProps;
$91c9e8a42ce6481e$var$XAxis.requiresSVG = true;
var $91c9e8a42ce6481e$export$2e2bcd8739ae039 = $91c9e8a42ce6481e$var$XAxis;



var $acw62 = parcelRequire("acw62");



function $6b8afae0b4e13d5f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6b8afae0b4e13d5f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6b8afae0b4e13d5f$var$ownKeys(Object(source), true).forEach(function(key) {
            $6b8afae0b4e13d5f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6b8afae0b4e13d5f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6b8afae0b4e13d5f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6b8afae0b4e13d5f$var$LEFT = (0, $16d91db751e2a422$export$7423c88bc54edb74).LEFT, $6b8afae0b4e13d5f$var$RIGHT = (0, $16d91db751e2a422$export$7423c88bc54edb74).RIGHT;
var $6b8afae0b4e13d5f$var$propTypes = $6b8afae0b4e13d5f$var$_objectSpread($6b8afae0b4e13d5f$var$_objectSpread({}, (0, $dc4391d98b3c1b39$export$2e2bcd8739ae039).propTypes), {}, {
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        $6b8afae0b4e13d5f$var$LEFT,
        $6b8afae0b4e13d5f$var$RIGHT
    ])
});
var $6b8afae0b4e13d5f$var$defaultProps = {
    orientation: $6b8afae0b4e13d5f$var$LEFT,
    attr: "y",
    attrAxis: "x"
};
function $6b8afae0b4e13d5f$var$YAxis(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc4391d98b3c1b39$export$2e2bcd8739ae039), props);
}
$6b8afae0b4e13d5f$var$YAxis.displayName = "YAxis";
$6b8afae0b4e13d5f$var$YAxis.propTypes = $6b8afae0b4e13d5f$var$propTypes;
$6b8afae0b4e13d5f$var$YAxis.defaultProps = $6b8afae0b4e13d5f$var$defaultProps;
$6b8afae0b4e13d5f$var$YAxis.requiresSVG = true;
var $6b8afae0b4e13d5f$export$2e2bcd8739ae039 = $6b8afae0b4e13d5f$var$YAxis;


// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var $acw62 = parcelRequire("acw62");



var $7d10d8a27e0367ef$var$propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    endColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    endTitle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]).isRequired,
    midColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    midTitle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]),
    startColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    startTitle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]).isRequired,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
};
var $7d10d8a27e0367ef$var$defaultProps = {
    className: "",
    startColor: (0, $d629c93f7b094ef1$export$36688c8ae3834bf8)[0],
    endColor: (0, $d629c93f7b094ef1$export$36688c8ae3834bf8)[1]
};
function $7d10d8a27e0367ef$var$ContinuousColorLegend(_ref) {
    var startColor = _ref.startColor, midColor = _ref.midColor, endColor = _ref.endColor, startTitle = _ref.startTitle, midTitle = _ref.midTitle, endTitle = _ref.endTitle, height = _ref.height, width = _ref.width, className = _ref.className;
    var colors = [
        startColor
    ];
    if (midColor) colors.push(midColor);
    colors.push(endColor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-continuous-color-legend", className),
        style: {
            width: width,
            height: height
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rv-gradient",
        style: {
            background: "linear-gradient(to right, ".concat(colors.join(","), ")")
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rv-legend-titles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "rv-legend-titles__left"
    }, startTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "rv-legend-titles__right"
    }, endTitle), midTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "rv-legend-titles__center"
    }, midTitle) : null));
}
$7d10d8a27e0367ef$var$ContinuousColorLegend.displayName = "ContinuousColorLegend";
$7d10d8a27e0367ef$var$ContinuousColorLegend.propTypes = $7d10d8a27e0367ef$var$propTypes;
$7d10d8a27e0367ef$var$ContinuousColorLegend.defaultProps = $7d10d8a27e0367ef$var$defaultProps;
var $7d10d8a27e0367ef$export$2e2bcd8739ae039 = $7d10d8a27e0367ef$var$ContinuousColorLegend;


// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var $acw62 = parcelRequire("acw62");


var $f784c6bd9229e9f0$var$propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    circlesTotal: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    endSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    endTitle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]).isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    startSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    startTitle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    ]).isRequired,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
};
var $f784c6bd9229e9f0$var$defaultProps = {
    circlesTotal: 10,
    className: "",
    endSize: 20,
    startSize: 2
};
function $f784c6bd9229e9f0$var$ContinuousSizeLegend(_ref) {
    var startTitle = _ref.startTitle, endTitle = _ref.endTitle, startSize = _ref.startSize, endSize = _ref.endSize, circlesTotal = _ref.circlesTotal, height = _ref.height, width = _ref.width, className = _ref.className;
    var circles = [];
    var step = (endSize - startSize) / (circlesTotal - 1);
    for(var i = 0; i < circlesTotal; i++){
        var size = step * i + startSize;
        circles.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            className: "rv-bubble",
            style: {
                width: size,
                height: size,
                borderRadius: size / 2
            }
        })); // Add the separator in order to justify the content (otherwise the tags
        // will be stacked together without any margins around).
        circles.push(" ");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-continuous-size-legend", className),
        style: {
            width: width,
            height: height
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rv-bubbles",
        style: {
            height: endSize
        }
    }, circles, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rv-spacer"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rv-legend-titles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "rv-legend-titles__left"
    }, startTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "rv-legend-titles__right"
    }, endTitle)));
}
$f784c6bd9229e9f0$var$ContinuousSizeLegend.displayName = "ContinuousSizeLegend";
$f784c6bd9229e9f0$var$ContinuousSizeLegend.propTypes = $f784c6bd9229e9f0$var$propTypes;
$f784c6bd9229e9f0$var$ContinuousSizeLegend.defaultProps = $f784c6bd9229e9f0$var$defaultProps;
var $f784c6bd9229e9f0$export$2e2bcd8739ae039 = $f784c6bd9229e9f0$var$ContinuousSizeLegend;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $dc15a8de96b0cbc7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc15a8de96b0cbc7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dc15a8de96b0cbc7$var$ownKeys(Object(source), true).forEach(function(key) {
            $dc15a8de96b0cbc7$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dc15a8de96b0cbc7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc15a8de96b0cbc7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $dc15a8de96b0cbc7$var$STROKE_STYLES = {
    dashed: "6, 2",
    solid: null
};
function $dc15a8de96b0cbc7$var$DiscreteColorLegendItem(_ref) {
    var color = _ref.color, strokeDasharray = _ref.strokeDasharray, strokeStyle = _ref.strokeStyle, strokeWidth = _ref.strokeWidth, disabled = _ref.disabled, onClick = _ref.onClick, orientation = _ref.orientation, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, title = _ref.title;
    var className = "rv-discrete-color-legend-item ".concat(orientation);
    if (disabled) className += " disabled";
    if (onClick) className += " clickable";
    var strokeDasharrayStyle = $dc15a8de96b0cbc7$var$STROKE_STYLES[strokeStyle] || strokeDasharray;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        className: "rv-discrete-color-legend-item__color",
        height: 2,
        width: 14
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        className: "rv-discrete-color-legend-item__color__path",
        d: "M 0, 1 L 14, 1",
        style: $dc15a8de96b0cbc7$var$_objectSpread($dc15a8de96b0cbc7$var$_objectSpread($dc15a8de96b0cbc7$var$_objectSpread({}, strokeWidth ? {
            strokeWidth: strokeWidth
        } : {}), strokeDasharrayStyle ? {
            strokeDasharray: strokeDasharrayStyle
        } : {}), {}, {
            stroke: disabled ? null : color
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "rv-discrete-color-legend-item__title"
    }, title));
}
$dc15a8de96b0cbc7$var$DiscreteColorLegendItem.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element
    ]).isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    strokeDasharray: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    strokeStyle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf(Object.keys($dc15a8de96b0cbc7$var$STROKE_STYLES))
};
$dc15a8de96b0cbc7$var$DiscreteColorLegendItem.defaultProps = {
    disabled: false,
    strokeStyle: "solid"
};
$dc15a8de96b0cbc7$var$DiscreteColorLegendItem.displayName = "DiscreteColorLegendItem";
var $dc15a8de96b0cbc7$export$2e2bcd8739ae039 = $dc15a8de96b0cbc7$var$DiscreteColorLegendItem;




function $a374170069b2e6c1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a374170069b2e6c1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a374170069b2e6c1$var$ownKeys(Object(source), true).forEach(function(key) {
            $a374170069b2e6c1$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a374170069b2e6c1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a374170069b2e6c1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a374170069b2e6c1$var$DiscreteColorLegend(_ref) {
    var className = _ref.className, colors = _ref.colors, height = _ref.height, items = _ref.items, onItemClick = _ref.onItemClick, onItemMouseEnter = _ref.onItemMouseEnter, onItemMouseLeave = _ref.onItemMouseLeave, orientation = _ref.orientation, style = _ref.style, width = _ref.width;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-discrete-color-legend", orientation, className),
        style: $a374170069b2e6c1$var$_objectSpread({
            width: width,
            height: height
        }, style)
    }, items.map(function(item, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc15a8de96b0cbc7$export$2e2bcd8739ae039), {
            title: item.title ? item.title : item,
            color: item.color ? item.color : colors[i % colors.length],
            strokeDasharray: item.strokeDasharray,
            strokeStyle: item.strokeStyle,
            strokeWidth: item.strokeWidth,
            disabled: Boolean(item.disabled),
            orientation: orientation,
            key: i,
            onClick: onItemClick ? function(e) {
                return onItemClick(item, i, e);
            } : null,
            onMouseEnter: onItemMouseEnter ? function(e) {
                return onItemMouseEnter(item, i, e);
            } : null,
            onMouseLeave: onItemMouseEnter ? function(e) {
                return onItemMouseLeave(item, i, e);
            } : null
        });
    }));
}
$a374170069b2e6c1$var$DiscreteColorLegend.displayName = "DiscreteColorLegendItem";
$a374170069b2e6c1$var$DiscreteColorLegend.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    items: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element
            ]).isRequired,
            color: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
            disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element
    ])).isRequired,
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onItemMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onItemMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "vertical",
        "horizontal"
    ])
};
$a374170069b2e6c1$var$DiscreteColorLegend.defaultProps = {
    className: "",
    colors: (0, $d629c93f7b094ef1$export$b59a484929f340e1),
    orientation: "vertical"
};
var $a374170069b2e6c1$export$2e2bcd8739ae039 = $a374170069b2e6c1$var$DiscreteColorLegend;



var $acw62 = parcelRequire("acw62");



function $2ae2ba66166e439f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2ae2ba66166e439f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2ae2ba66166e439f$var$ownKeys(Object(source), true).forEach(function(key) {
            $2ae2ba66166e439f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2ae2ba66166e439f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2ae2ba66166e439f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $2ae2ba66166e439f$var$propTypes = $2ae2ba66166e439f$var$_objectSpread($2ae2ba66166e439f$var$_objectSpread({}, (0, $a374170069b2e6c1$export$2e2bcd8739ae039).propTypes), {}, {
    searchText: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    onSearchChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    searchPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    searchFn: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
});
var $2ae2ba66166e439f$var$defaultProps = {
    className: "",
    searchText: "",
    searchFn: function searchFn(items, s) {
        return items.filter(function(item) {
            return String(item.title || item).toLowerCase().indexOf(s) !== -1;
        });
    }
};
function $2ae2ba66166e439f$var$SearchableDiscreteColorLegend(props) {
    var className = props.className, colors = props.colors, height = props.height, items = props.items, onItemClick = props.onItemClick, onItemMouseEnter = props.onItemMouseEnter, onItemMouseLeave = props.onItemMouseLeave, onSearchChange = props.onSearchChange, orientation = props.orientation, searchFn = props.searchFn, searchPlaceholder = props.searchPlaceholder, searchText = props.searchText, width = props.width;
    var onChange = onSearchChange ? function(_ref) {
        var value = _ref.target.value;
        return onSearchChange(value);
    } : null;
    var filteredItems = searchFn(items, searchText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-search-wrapper", className),
        style: {
            width: width,
            height: height
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        className: "rv-search-wrapper__form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "search",
        placeholder: searchPlaceholder,
        className: "rv-search-wrapper__form__input",
        value: searchText,
        onChange: onChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rv-search-wrapper__contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a374170069b2e6c1$export$2e2bcd8739ae039), {
        colors: colors,
        items: filteredItems,
        onItemClick: onItemClick,
        onItemMouseEnter: onItemMouseEnter,
        onItemMouseLeave: onItemMouseLeave,
        orientation: orientation
    })));
}
$2ae2ba66166e439f$var$SearchableDiscreteColorLegend.propTypes = $2ae2ba66166e439f$var$propTypes;
$2ae2ba66166e439f$var$SearchableDiscreteColorLegend.defaultProps = $2ae2ba66166e439f$var$defaultProps;
$2ae2ba66166e439f$var$SearchableDiscreteColorLegend.displayName = "SearchableDiscreteColorLegend";
var $2ae2ba66166e439f$export$2e2bcd8739ae039 = $2ae2ba66166e439f$var$SearchableDiscreteColorLegend;



var $acw62 = parcelRequire("acw62");













function $a201ea729317a401$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a201ea729317a401$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a201ea729317a401$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a201ea729317a401$var$_typeof(obj);
}
function $a201ea729317a401$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a201ea729317a401$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a201ea729317a401$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a201ea729317a401$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a201ea729317a401$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a201ea729317a401$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a201ea729317a401$var$_setPrototypeOf(subClass, superClass);
}
function $a201ea729317a401$var$_setPrototypeOf(o, p) {
    $a201ea729317a401$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a201ea729317a401$var$_setPrototypeOf(o, p);
}
function $a201ea729317a401$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a201ea729317a401$var$_isNativeReflectConstruct();
    return function() {
        var Super = $a201ea729317a401$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a201ea729317a401$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a201ea729317a401$var$_possibleConstructorReturn(this, result);
    };
}
function $a201ea729317a401$var$_possibleConstructorReturn(self, call) {
    if (call && ($a201ea729317a401$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a201ea729317a401$var$_assertThisInitialized(self);
}
function $a201ea729317a401$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a201ea729317a401$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a201ea729317a401$var$_getPrototypeOf(o) {
    $a201ea729317a401$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a201ea729317a401$var$_getPrototypeOf(o);
}
function $a201ea729317a401$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a201ea729317a401$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a201ea729317a401$var$ownKeys(Object(source), true).forEach(function(key) {
            $a201ea729317a401$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a201ea729317a401$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a201ea729317a401$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a201ea729317a401$var$predefinedClassName = "rv-parallel-coordinates-chart";
var $a201ea729317a401$var$DEFAULT_FORMAT = (0, $54a757fa53542946$export$d9468344d3651243)(".2r");
/**
 * Generate axes for each of the domains
 * @param {Object} props
 - props.animation {Boolean}
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.style {object} style object for the whole chart
 - props.tickFormat {Function} formatting function for axes
 * @return {Array} the plotted axis components
 */ function $a201ea729317a401$var$getAxes(props) {
    var animation = props.animation, domains = props.domains, style = props.style, tickFormat = props.tickFormat;
    return domains.map(function(domain, index) {
        var sortedDomain = domain.domain;
        var domainTickFormat = function domainTickFormat(t) {
            return domain.tickFormat ? domain.tickFormat(t) : tickFormat(t);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc228db9775fdbe5$export$2e2bcd8739ae039), {
            animation: animation,
            key: "".concat(index, "-axis"),
            axisStart: {
                x: domain.name,
                y: 0
            },
            axisEnd: {
                x: domain.name,
                y: 1
            },
            axisDomain: sortedDomain,
            numberOfTicks: 5,
            tickValue: domainTickFormat,
            style: style.axes
        });
    });
}
/**
 * Generate labels for the ends of the axes
 * @param {Object} props
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.style {object} style object for just the labels
 * @return {Array} the prepped data for the labelSeries
 */ function $a201ea729317a401$var$getLabels(props) {
    var domains = props.domains, style = props.style;
    return domains.map(function(domain) {
        return {
            x: domain.name,
            y: 1.1,
            label: domain.name,
            style: style
        };
    });
}
/**
 * Generate the actual lines to be plotted
 * @param {Object} props
 - props.animation {Boolean}
 - props.data {Array} array of object specifying what values are to be plotted
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.style {object} style object for the whole chart
 - props.showMarks {Bool} whether or not to use the line mark series
 * @return {Array} the plotted axis components
 */ function $a201ea729317a401$var$getLines(props) {
    var animation = props.animation, brushFilters = props.brushFilters, colorRange = props.colorRange, domains = props.domains, data = props.data, style = props.style, showMarks = props.showMarks;
    var scales = domains.reduce(function(acc, _ref) {
        var domain = _ref.domain, name = _ref.name;
        acc[name] = (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)().domain(domain).range([
            0,
            1
        ]);
        return acc;
    }, {}); // const
    return data.map(function(row, rowIndex) {
        var withinFilteredRange = true;
        var mappedData = domains.map(function(domain) {
            var getValue = domain.getValue, name = domain.name; // watch out! Gotcha afoot
            // yVal after being scale is in [0, 1] range
            var yVal = scales[name](getValue ? getValue(row) : row[name]);
            var filter = brushFilters[name]; // filter value after being scale back from pixel space is also in [0, 1]
            if (filter && (yVal < filter.min || yVal > filter.max)) withinFilteredRange = false;
            return {
                x: name,
                y: yVal
            };
        });
        var selectedName = "".concat($a201ea729317a401$var$predefinedClassName, "-line");
        var unselectedName = "".concat(selectedName, " ").concat($a201ea729317a401$var$predefinedClassName, "-line-unselected");
        var lineProps = {
            animation: animation,
            className: withinFilteredRange ? selectedName : unselectedName,
            key: "".concat(rowIndex, "-polygon"),
            data: mappedData,
            color: row.color || colorRange[rowIndex % colorRange.length],
            style: $a201ea729317a401$var$_objectSpread($a201ea729317a401$var$_objectSpread({}, style.lines), row.style || {})
        };
        if (!withinFilteredRange) lineProps.style = $a201ea729317a401$var$_objectSpread($a201ea729317a401$var$_objectSpread({}, lineProps.style), style.deselectedLineStyle);
        return showMarks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5f5bf9ff9d0ffd46$export$2e2bcd8739ae039), lineProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $871fbd36d2e25249$export$2e2bcd8739ae039), lineProps);
    });
}
var $a201ea729317a401$var$ParallelCoordinates = /*#__PURE__*/ function(_Component) {
    $a201ea729317a401$var$_inherits(ParallelCoordinates, _Component);
    var _super = $a201ea729317a401$var$_createSuper(ParallelCoordinates);
    function ParallelCoordinates() {
        var _this;
        $a201ea729317a401$var$_classCallCheck(this, ParallelCoordinates);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $a201ea729317a401$var$_defineProperty($a201ea729317a401$var$_assertThisInitialized(_this), "state", {
            brushFilters: {}
        });
        return _this;
    }
    $a201ea729317a401$var$_createClass(ParallelCoordinates, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var brushFilters = this.state.brushFilters;
                var _this$props = this.props, animation = _this$props.animation, brushing = _this$props.brushing, className = _this$props.className, children = _this$props.children, colorRange = _this$props.colorRange, data = _this$props.data, domains = _this$props.domains, height = _this$props.height, hideInnerMostValues = _this$props.hideInnerMostValues, margin = _this$props.margin, onMouseLeave = _this$props.onMouseLeave, onMouseEnter = _this$props.onMouseEnter, showMarks = _this$props.showMarks, style = _this$props.style, tickFormat = _this$props.tickFormat, width = _this$props.width;
                var axes = $a201ea729317a401$var$getAxes({
                    domains: domains,
                    animation: animation,
                    hideInnerMostValues: hideInnerMostValues,
                    style: style,
                    tickFormat: tickFormat
                });
                var lines = $a201ea729317a401$var$getLines({
                    animation: animation,
                    brushFilters: brushFilters,
                    colorRange: colorRange,
                    domains: domains,
                    data: data,
                    showMarks: showMarks,
                    style: style
                });
                var labelSeries = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ce38b8b6c594605$export$2e2bcd8739ae039), {
                    animation: true,
                    key: className,
                    className: "".concat($a201ea729317a401$var$predefinedClassName, "-label"),
                    data: $a201ea729317a401$var$getLabels({
                        domains: domains,
                        style: style.labels
                    })
                });
                var _getInnerDimensions = (0, $a3dc0e1a1ee08269$export$72ee41b0ad150e05)(this.props, (0, $a3dc0e1a1ee08269$export$d588676965164366)), marginLeft = _getInnerDimensions.marginLeft, marginRight = _getInnerDimensions.marginRight;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70994359f4ceeef3$export$2e2bcd8739ae039), {
                    height: height,
                    width: width,
                    margin: margin,
                    dontCheckIfEmpty: true,
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)(className, $a201ea729317a401$var$predefinedClassName),
                    onMouseLeave: onMouseLeave,
                    onMouseEnter: onMouseEnter,
                    xType: "ordinal",
                    yDomain: [
                        0,
                        1
                    ]
                }, children, axes.concat(lines).concat(labelSeries), brushing && domains.map(function(d) {
                    var trigger = function trigger(row) {
                        _this2.setState({
                            brushFilters: $a201ea729317a401$var$_objectSpread($a201ea729317a401$var$_objectSpread({}, brushFilters), {}, $a201ea729317a401$var$_defineProperty({}, d.name, row ? {
                                min: row.bottom,
                                max: row.top
                            } : null))
                        });
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $500a384b6c14ad41$export$2e2bcd8739ae039), {
                        key: d.name,
                        drag: true,
                        highlightX: d.name,
                        onBrushEnd: trigger,
                        onDragEnd: trigger,
                        highlightWidth: (width - marginLeft - marginRight) / domains.length,
                        enableX: false
                    });
                }));
            }
        }
    ]);
    return ParallelCoordinates;
}((0, $acw62.Component));
$a201ea729317a401$var$ParallelCoordinates.displayName = "ParallelCoordinates";
$a201ea729317a401$var$ParallelCoordinates.propTypes = {
    animation: (0, $d4808d8f8c60755d$export$c6290f21adf0a17a),
    brushing: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    colorType: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    colorRange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired,
    domains: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        domain: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number).isRequired,
        tickFormat: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    })).isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    margin: (0, $a3dc0e1a1ee08269$export$a2f0519a883a74de),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        axes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        lines: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    }),
    showMarks: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    tickFormat: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
$a201ea729317a401$var$ParallelCoordinates.defaultProps = {
    className: "",
    colorType: "category",
    colorRange: (0, $d629c93f7b094ef1$export$b59a484929f340e1),
    style: {
        axes: {
            line: {},
            ticks: {},
            text: {}
        },
        labels: {
            fontSize: 10,
            textAnchor: "middle"
        },
        lines: {
            strokeWidth: 1,
            strokeOpacity: 1
        },
        deselectedLineStyle: {
            strokeOpacity: 0.1
        }
    },
    tickFormat: $a201ea729317a401$var$DEFAULT_FORMAT
};
var $a201ea729317a401$export$2e2bcd8739ae039 = $a201ea729317a401$var$ParallelCoordinates;



var $acw62 = parcelRequire("acw62");












function $42554fee78a7e68b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $42554fee78a7e68b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $42554fee78a7e68b$var$ownKeys(Object(source), true).forEach(function(key) {
            $42554fee78a7e68b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $42554fee78a7e68b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $42554fee78a7e68b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $42554fee78a7e68b$var$predefinedClassName = "rv-radar-chart";
var $42554fee78a7e68b$var$DEFAULT_FORMAT = (0, $54a757fa53542946$export$d9468344d3651243)(".2r");
/**
 * Generate axes for each of the domains
 * @param {Object} props
 - props.animation {Boolean}
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.style {object} style object for the whole chart
 - props.tickFormat {Function} formatting function for axes
 - props.startingAngle {number} the initial angle offset
 * @return {Array} the plotted axis components
 */ function $42554fee78a7e68b$var$getAxes(props) {
    var animation = props.animation, domains = props.domains, startingAngle = props.startingAngle, style = props.style, tickFormat = props.tickFormat, hideInnerMostValues = props.hideInnerMostValues;
    return domains.map(function(domain, index) {
        var angle = index / domains.length * Math.PI * 2 + startingAngle;
        var sortedDomain = domain.domain;
        var domainTickFormat = function domainTickFormat(t) {
            if (hideInnerMostValues && t === sortedDomain[0]) return "";
            return domain.tickFormat ? domain.tickFormat(t) : tickFormat(t);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cc228db9775fdbe5$export$2e2bcd8739ae039), {
            animation: animation,
            key: "".concat(index, "-axis"),
            axisStart: {
                x: 0,
                y: 0
            },
            axisEnd: {
                x: $42554fee78a7e68b$var$getCoordinate(Math.cos(angle)),
                y: $42554fee78a7e68b$var$getCoordinate(Math.sin(angle))
            },
            axisDomain: sortedDomain,
            numberOfTicks: 5,
            tickValue: domainTickFormat,
            style: style.axes
        });
    });
}
/**
 * Generate x or y coordinate for axisEnd
 * @param {Number} axisEndPoint
 - epsilon is an arbitrarily chosen small number to approximate axisEndPoints
 - to true values resulting from trigonometry functions (sin, cos) on angles
 * @return {Number} the x or y coordinate accounting for exact trig values
 */ function $42554fee78a7e68b$var$getCoordinate(axisEndPoint) {
    var epsilon = 10e-13;
    if (Math.abs(axisEndPoint) <= epsilon) axisEndPoint = 0;
    else if (axisEndPoint > 0) {
        if (Math.abs(axisEndPoint - 0.5) <= epsilon) axisEndPoint = 0.5;
    } else if (axisEndPoint < 0) {
        if (Math.abs(axisEndPoint + 0.5) <= epsilon) axisEndPoint = -0.5;
    }
    return axisEndPoint;
}
/**
 * Generate labels for the ends of the axes
 * @param {Object} props
 - props.domains {Array} array of object specifying the way each axis is to be plotted
  - props.startingAngle {number} the initial angle offset
 - props.style {object} style object for just the labels
 * @return {Array} the prepped data for the labelSeries
 */ function $42554fee78a7e68b$var$getLabels(props) {
    var domains = props.domains, startingAngle = props.startingAngle, style = props.style;
    return domains.map(function(_ref, index) {
        var name = _ref.name;
        var angle = index / domains.length * Math.PI * 2 + startingAngle;
        var radius = 1.2;
        return {
            x: radius * Math.cos(angle),
            y: radius * Math.sin(angle),
            label: name,
            style: style
        };
    });
}
/**
 * Generate the actual polygons to be plotted
 * @param {Object} props
 - props.animation {Boolean}
 - props.data {Array} array of object specifying what values are to be plotted
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.startingAngle {number} the initial angle offset
 - props.style {object} style object for the whole chart
 * @return {Array} the plotted axis components
 */ function $42554fee78a7e68b$var$getPolygons(props) {
    var animation = props.animation, colorRange = props.colorRange, domains = props.domains, data = props.data, style = props.style, startingAngle = props.startingAngle, onSeriesMouseOver = props.onSeriesMouseOver, onSeriesMouseOut = props.onSeriesMouseOut;
    var scales = domains.reduce(function(acc, _ref2) {
        var domain = _ref2.domain, name = _ref2.name;
        acc[name] = (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)().domain(domain).range([
            0,
            1
        ]);
        return acc;
    }, {});
    return data.map(function(row, rowIndex) {
        var mappedData = domains.map(function(_ref3, index) {
            var name = _ref3.name, getValue = _ref3.getValue;
            var dataPoint = getValue ? getValue(row) : row[name]; // error handling if point doesn't exist
            var angle = index / domains.length * Math.PI * 2 + startingAngle; // dont let the radius become negative
            var radius = Math.max(scales[name](dataPoint), 0);
            return {
                x: radius * Math.cos(angle),
                y: radius * Math.sin(angle),
                name: row.name
            };
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4adb2019d400d701$export$2e2bcd8739ae039), {
            animation: animation,
            className: "".concat($42554fee78a7e68b$var$predefinedClassName, "-polygon"),
            key: "".concat(rowIndex, "-polygon"),
            data: mappedData,
            style: $42554fee78a7e68b$var$_objectSpread({
                stroke: row.color || row.stroke || colorRange[rowIndex % colorRange.length],
                fill: row.color || row.fill || colorRange[rowIndex % colorRange.length]
            }, style.polygons),
            onSeriesMouseOver: onSeriesMouseOver,
            onSeriesMouseOut: onSeriesMouseOut
        });
    });
}
/**
 * Generate circles at the polygon points for Hover functionality
 * @param {Object} props
 - props.animation {Boolean}
 - props.data {Array} array of object specifying what values are to be plotted
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.startingAngle {number} the initial angle offset
 - props.style {object} style object for the whole chart
 - props.onValueMouseOver {function} function to call on mouse over a polygon point
 - props.onValueMouseOver {function} function to call when mouse leaves a polygon point
 * @return {Array} the plotted axis components
 */ function $42554fee78a7e68b$var$getPolygonPoints(props) {
    var animation = props.animation, domains = props.domains, data = props.data, startingAngle = props.startingAngle, style = props.style, onValueMouseOver = props.onValueMouseOver, onValueMouseOut = props.onValueMouseOut;
    if (!onValueMouseOver) return;
    var scales = domains.reduce(function(acc, _ref4) {
        var domain = _ref4.domain, name = _ref4.name;
        acc[name] = (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)().domain(domain).range([
            0,
            1
        ]);
        return acc;
    }, {});
    return data.map(function(row, rowIndex) {
        var mappedData = domains.map(function(_ref5, index) {
            var name = _ref5.name, getValue = _ref5.getValue;
            var dataPoint = getValue ? getValue(row) : row[name]; // error handling if point doesn't exist
            var angle = index / domains.length * Math.PI * 2 + startingAngle; // dont let the radius become negative
            var radius = Math.max(scales[name](dataPoint), 0);
            return {
                x: radius * Math.cos(angle),
                y: radius * Math.sin(angle),
                domain: name,
                value: dataPoint,
                dataName: row.name
            };
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dd4ad056f824b78e$export$2e2bcd8739ae039), {
            animation: animation,
            className: "".concat($42554fee78a7e68b$var$predefinedClassName, "-polygonPoint"),
            key: "".concat(rowIndex, "-polygonPoint"),
            data: mappedData,
            size: 10,
            style: $42554fee78a7e68b$var$_objectSpread($42554fee78a7e68b$var$_objectSpread({}, style.polygons), {}, {
                fill: "transparent",
                stroke: "transparent"
            }),
            onValueMouseOver: onValueMouseOver,
            onValueMouseOut: onValueMouseOut
        });
    });
}
function $42554fee78a7e68b$var$RadarChart(props) {
    var animation = props.animation, className = props.className, children = props.children, colorRange = props.colorRange, data = props.data, domains = props.domains, height = props.height, hideInnerMostValues = props.hideInnerMostValues, margin = props.margin, onMouseLeave = props.onMouseLeave, onMouseEnter = props.onMouseEnter, startingAngle = props.startingAngle, style = props.style, tickFormat = props.tickFormat, width = props.width, renderAxesOverPolygons = props.renderAxesOverPolygons, onValueMouseOver = props.onValueMouseOver, onValueMouseOut = props.onValueMouseOut, onSeriesMouseOver = props.onSeriesMouseOver, onSeriesMouseOut = props.onSeriesMouseOut;
    var axes = $42554fee78a7e68b$var$getAxes({
        domains: domains,
        animation: animation,
        hideInnerMostValues: hideInnerMostValues,
        startingAngle: startingAngle,
        style: style,
        tickFormat: tickFormat
    });
    var polygons = $42554fee78a7e68b$var$getPolygons({
        animation: animation,
        colorRange: colorRange,
        domains: domains,
        data: data,
        startingAngle: startingAngle,
        style: style,
        onSeriesMouseOver: onSeriesMouseOver,
        onSeriesMouseOut: onSeriesMouseOut
    });
    var polygonPoints = $42554fee78a7e68b$var$getPolygonPoints({
        animation: animation,
        colorRange: colorRange,
        domains: domains,
        data: data,
        startingAngle: startingAngle,
        style: style,
        onValueMouseOver: onValueMouseOver,
        onValueMouseOut: onValueMouseOut
    });
    var labelSeries = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ce38b8b6c594605$export$2e2bcd8739ae039), {
        animation: animation,
        key: className,
        className: "".concat($42554fee78a7e68b$var$predefinedClassName, "-label"),
        data: $42554fee78a7e68b$var$getLabels({
            domains: domains,
            style: style.labels,
            startingAngle: startingAngle
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70994359f4ceeef3$export$2e2bcd8739ae039), {
        height: height,
        width: width,
        margin: margin,
        dontCheckIfEmpty: true,
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)(className, $42554fee78a7e68b$var$predefinedClassName),
        onMouseLeave: onMouseLeave,
        onMouseEnter: onMouseEnter,
        xDomain: [
            -1,
            1
        ],
        yDomain: [
            -1,
            1
        ]
    }, children, !renderAxesOverPolygons && axes.concat(polygons).concat(labelSeries).concat(polygonPoints), renderAxesOverPolygons && polygons.concat(labelSeries).concat(axes).concat(polygonPoints));
}
$42554fee78a7e68b$var$RadarChart.displayName = "RadarChart";
$42554fee78a7e68b$var$RadarChart.propTypes = {
    animation: (0, $d4808d8f8c60755d$export$c6290f21adf0a17a),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    colorType: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    colorRange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired,
    domains: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        domain: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number).isRequired,
        tickFormat: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    })).isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    hideInnerMostValues: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    margin: (0, $a3dc0e1a1ee08269$export$a2f0519a883a74de),
    startingAngle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        axes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        polygons: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    }),
    tickFormat: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    renderAxesOverPolygons: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    onValueMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onSeriesMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onSeriesMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
$42554fee78a7e68b$var$RadarChart.defaultProps = {
    className: "",
    colorType: "category",
    colorRange: (0, $d629c93f7b094ef1$export$b59a484929f340e1),
    hideInnerMostValues: true,
    startingAngle: Math.PI / 2,
    style: {
        axes: {
            line: {},
            ticks: {},
            text: {}
        },
        labels: {
            fontSize: 10,
            textAnchor: "middle"
        },
        polygons: {
            strokeWidth: 0.5,
            strokeOpacity: 1,
            fillOpacity: 0.1
        }
    },
    tickFormat: $42554fee78a7e68b$var$DEFAULT_FORMAT,
    renderAxesOverPolygons: false
};
var $42554fee78a7e68b$export$2e2bcd8739ae039 = $42554fee78a7e68b$var$RadarChart;



var $acw62 = parcelRequire("acw62");










function $4c1405bd53d88022$var$_extends() {
    $4c1405bd53d88022$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4c1405bd53d88022$var$_extends.apply(this, arguments);
}
function $4c1405bd53d88022$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4c1405bd53d88022$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4c1405bd53d88022$var$ownKeys(Object(source), true).forEach(function(key) {
            $4c1405bd53d88022$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4c1405bd53d88022$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4c1405bd53d88022$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $4c1405bd53d88022$var$predefinedClassName = "rv-radial-chart";
var $4c1405bd53d88022$var$DEFAULT_RADIUS_MARGIN = 15;
/**
 * Create the list of wedges to render.
 * @param {Object} props
   props.data {Object} - tree structured data (each node has a name anc an array of children)
 * @returns {Array} Array of nodes.
 */ function $4c1405bd53d88022$var$getWedgesToRender(_ref) {
    var data = _ref.data, getAngle = _ref.getAngle;
    var pie = (0, $b3395c44b48089b3$export$2e2bcd8739ae039)().sort(null).value(getAngle);
    var pieData = pie(data).reverse();
    return pieData.map(function(row, index) {
        return $4c1405bd53d88022$var$_objectSpread($4c1405bd53d88022$var$_objectSpread({}, row.data), {}, {
            angle0: row.startAngle,
            angle: row.endAngle,
            radius0: row.data.innerRadius || 0,
            radius: row.data.radius || 1,
            color: row.data.color || index
        });
    });
}
function $4c1405bd53d88022$var$generateLabels(mappedData, accessors) {
    var labelsRadiusMultiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1.1;
    var getLabel = accessors.getLabel, getSubLabel = accessors.getSubLabel;
    return mappedData.reduce(function(res, row) {
        var angle = row.angle, angle0 = row.angle0, radius = row.radius;
        var centeredAngle = (angle + angle0) / 2; // unfortunate, but true fact: d3 starts its radians at 12 oclock rather than 3
        // and move clockwise rather than counter clockwise. why why why!
        var updatedAngle = -1 * centeredAngle + Math.PI / 2;
        var newLabels = [];
        if (getLabel(row)) newLabels.push({
            angle: updatedAngle,
            radius: radius * labelsRadiusMultiplier,
            label: getLabel(row)
        });
        if (getSubLabel(row)) newLabels.push({
            angle: updatedAngle,
            radius: radius * labelsRadiusMultiplier,
            label: getSubLabel(row),
            style: {
                fontSize: 10
            },
            yOffset: 12
        });
        return res.concat(newLabels);
    }, []); // could add force direction here to make sure the labels dont overlap
}
/**
 * Get the max radius so the chart can extend to the margin.
 * @param  {Number} width - container width
 * @param  {Number} height - container height
 * @return {Number} radius
 */ function $4c1405bd53d88022$var$getMaxRadius(width, height) {
    return Math.min(width, height) / 2 - $4c1405bd53d88022$var$DEFAULT_RADIUS_MARGIN;
}
function $4c1405bd53d88022$var$RadialChart(props) {
    var animation = props.animation, className = props.className, children = props.children, colorType = props.colorType, data = props.data, getAngle = props.getAngle, getLabel = props.getLabel, getSubLabel = props.getSubLabel, height = props.height, hideRootNode = props.hideRootNode, innerRadius = props.innerRadius, labelsAboveChildren = props.labelsAboveChildren, labelsRadiusMultiplier = props.labelsRadiusMultiplier, labelsStyle = props.labelsStyle, margin = props.margin, onMouseLeave = props.onMouseLeave, onMouseEnter = props.onMouseEnter, radius = props.radius, showLabels = props.showLabels, style = props.style, width = props.width;
    var mappedData = $4c1405bd53d88022$var$getWedgesToRender({
        data: data,
        height: height,
        hideRootNode: hideRootNode,
        width: width,
        getAngle: getAngle
    });
    var radialDomain = (0, $ba94dd19eb06369c$export$8db0eb04c74fd34e)(mappedData);
    var arcProps = $4c1405bd53d88022$var$_objectSpread($4c1405bd53d88022$var$_objectSpread({
        colorType: colorType
    }, props), {}, {
        animation: animation,
        radiusDomain: [
            0,
            radialDomain
        ],
        data: mappedData,
        radiusNoFallBack: true,
        style: style,
        arcClassName: "rv-radial-chart__series--pie__slice"
    });
    if (radius) {
        arcProps.radiusDomain = [
            0,
            1
        ];
        arcProps.radiusRange = [
            innerRadius || 0,
            radius
        ];
        arcProps.radiusType = "linear";
    }
    var maxRadius = radius ? radius : $4c1405bd53d88022$var$getMaxRadius(width, height);
    var defaultMargin = (0, $a3dc0e1a1ee08269$export$b7318b0ae20c2441)(width, height, maxRadius);
    var labels = $4c1405bd53d88022$var$generateLabels(mappedData, {
        getLabel: getLabel,
        getSubLabel: getSubLabel
    }, labelsRadiusMultiplier);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70994359f4ceeef3$export$2e2bcd8739ae039), {
        height: height,
        width: width,
        margin: $4c1405bd53d88022$var$_objectSpread($4c1405bd53d88022$var$_objectSpread({}, defaultMargin), margin),
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)(className, $4c1405bd53d88022$var$predefinedClassName),
        onMouseLeave: onMouseLeave,
        onMouseEnter: onMouseEnter,
        xDomain: [
            -radialDomain,
            radialDomain
        ],
        yDomain: [
            -radialDomain,
            radialDomain
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $682e33890727be82$export$2e2bcd8739ae039), $4c1405bd53d88022$var$_extends({}, arcProps, {
        getAngle: function getAngle(d) {
            return d.angle;
        }
    })), showLabels && !labelsAboveChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ce38b8b6c594605$export$2e2bcd8739ae039), {
        data: labels,
        style: labelsStyle
    }), children, showLabels && labelsAboveChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ce38b8b6c594605$export$2e2bcd8739ae039), {
        data: labels,
        style: labelsStyle
    }));
}
$4c1405bd53d88022$var$RadialChart.displayName = "RadialChart";
$4c1405bd53d88022$var$RadialChart.propTypes = {
    animation: (0, $d4808d8f8c60755d$export$c6290f21adf0a17a),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    colorType: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        angle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        radius: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    })).isRequired,
    getAngle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    getAngle0: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    padAngle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]),
    getRadius: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    getRadius0: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    labelsAboveChildren: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    labelsStyle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    margin: (0, $a3dc0e1a1ee08269$export$a2f0519a883a74de),
    onValueClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    showLabels: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    subLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
$4c1405bd53d88022$var$RadialChart.defaultProps = {
    className: "",
    colorType: "category",
    colorRange: (0, $d629c93f7b094ef1$export$b59a484929f340e1),
    padAngle: 0,
    getAngle: function getAngle(d) {
        return d.angle;
    },
    getAngle0: function getAngle0(d) {
        return d.angle0;
    },
    getRadius: function getRadius(d) {
        return d.radius;
    },
    getRadius0: function getRadius0(d) {
        return d.radius0;
    },
    getLabel: function getLabel(d) {
        return d.label;
    },
    getSubLabel: function getSubLabel(d) {
        return d.subLabel;
    }
};
var $4c1405bd53d88022$export$2e2bcd8739ae039 = $4c1405bd53d88022$var$RadialChart;



var $acw62 = parcelRequire("acw62");

function $79b2876019e236cf$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

function $b8c3ad69ded01687$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

function $b3c93b6fbb60c924$export$2e2bcd8739ae039(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}



function $479da5c8e0690793$var$targetDepth(d) {
    return d.target.depth;
}
function $479da5c8e0690793$export$eabcd2c8791e7bf4(node) {
    return node.depth;
}
function $479da5c8e0690793$export$79ffe56a765070d2(node, n) {
    return n - 1 - node.height;
}
function $479da5c8e0690793$export$720f2a50325b840f(node, n) {
    return node.sourceLinks.length ? node.depth : n - 1;
}
function $479da5c8e0690793$export$3481c78889e8fbe8(node) {
    return node.targetLinks.length ? node.depth : node.sourceLinks.length ? (0, $b8c3ad69ded01687$export$2e2bcd8739ae039)(node.sourceLinks, $479da5c8e0690793$var$targetDepth) - 1 : 0;
}


function $b16995f71f2567a8$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $c678c6e8b1555d72$var$ascendingSourceBreadth(a, b) {
    return $c678c6e8b1555d72$var$ascendingBreadth(a.source, b.source) || a.index - b.index;
}
function $c678c6e8b1555d72$var$ascendingTargetBreadth(a, b) {
    return $c678c6e8b1555d72$var$ascendingBreadth(a.target, b.target) || a.index - b.index;
}
function $c678c6e8b1555d72$var$ascendingBreadth(a, b) {
    return a.y0 - b.y0;
}
function $c678c6e8b1555d72$var$value(d) {
    return d.value;
}
function $c678c6e8b1555d72$var$defaultId(d) {
    return d.index;
}
function $c678c6e8b1555d72$var$defaultNodes(graph) {
    return graph.nodes;
}
function $c678c6e8b1555d72$var$defaultLinks(graph) {
    return graph.links;
}
function $c678c6e8b1555d72$var$find(nodeById, id) {
    const node = nodeById.get(id);
    if (!node) throw new Error("missing: " + id);
    return node;
}
function $c678c6e8b1555d72$var$computeLinkBreadths({ nodes: nodes }) {
    for (const node of nodes){
        let y0 = node.y0;
        let y1 = y0;
        for (const link of node.sourceLinks){
            link.y0 = y0 + link.width / 2;
            y0 += link.width;
        }
        for (const link of node.targetLinks){
            link.y1 = y1 + link.width / 2;
            y1 += link.width;
        }
    }
}
function $c678c6e8b1555d72$export$2e2bcd8739ae039() {
    let x0 = 0, y0 = 0, x1 = 1, y1 = 1; // extent
    let dx = 24; // nodeWidth
    let dy = 8, py; // nodePadding
    let id = $c678c6e8b1555d72$var$defaultId;
    let align = (0, $479da5c8e0690793$export$720f2a50325b840f);
    let sort;
    let linkSort;
    let nodes = $c678c6e8b1555d72$var$defaultNodes;
    let links = $c678c6e8b1555d72$var$defaultLinks;
    let iterations = 6;
    function sankey() {
        const graph = {
            nodes: nodes.apply(null, arguments),
            links: links.apply(null, arguments)
        };
        computeNodeLinks(graph);
        computeNodeValues(graph);
        computeNodeDepths(graph);
        computeNodeHeights(graph);
        computeNodeBreadths(graph);
        $c678c6e8b1555d72$var$computeLinkBreadths(graph);
        return graph;
    }
    sankey.update = function(graph) {
        $c678c6e8b1555d72$var$computeLinkBreadths(graph);
        return graph;
    };
    sankey.nodeId = function(_) {
        return arguments.length ? (id = typeof _ === "function" ? _ : (0, $b16995f71f2567a8$export$2e2bcd8739ae039)(_), sankey) : id;
    };
    sankey.nodeAlign = function(_) {
        return arguments.length ? (align = typeof _ === "function" ? _ : (0, $b16995f71f2567a8$export$2e2bcd8739ae039)(_), sankey) : align;
    };
    sankey.nodeSort = function(_) {
        return arguments.length ? (sort = _, sankey) : sort;
    };
    sankey.nodeWidth = function(_) {
        return arguments.length ? (dx = +_, sankey) : dx;
    };
    sankey.nodePadding = function(_) {
        return arguments.length ? (dy = py = +_, sankey) : dy;
    };
    sankey.nodes = function(_) {
        return arguments.length ? (nodes = typeof _ === "function" ? _ : (0, $b16995f71f2567a8$export$2e2bcd8739ae039)(_), sankey) : nodes;
    };
    sankey.links = function(_) {
        return arguments.length ? (links = typeof _ === "function" ? _ : (0, $b16995f71f2567a8$export$2e2bcd8739ae039)(_), sankey) : links;
    };
    sankey.linkSort = function(_) {
        return arguments.length ? (linkSort = _, sankey) : linkSort;
    };
    sankey.size = function(_) {
        return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey) : [
            x1 - x0,
            y1 - y0
        ];
    };
    sankey.extent = function(_) {
        return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey) : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    sankey.iterations = function(_) {
        return arguments.length ? (iterations = +_, sankey) : iterations;
    };
    function computeNodeLinks({ nodes: nodes, links: links }) {
        for (const [i, node] of nodes.entries()){
            node.index = i;
            node.sourceLinks = [];
            node.targetLinks = [];
        }
        const nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ]));
        for (const [i, link] of links.entries()){
            link.index = i;
            let { source: source, target: target } = link;
            if (typeof source !== "object") source = link.source = $c678c6e8b1555d72$var$find(nodeById, source);
            if (typeof target !== "object") target = link.target = $c678c6e8b1555d72$var$find(nodeById, target);
            source.sourceLinks.push(link);
            target.targetLinks.push(link);
        }
        if (linkSort != null) for (const { sourceLinks: sourceLinks, targetLinks: targetLinks } of nodes){
            sourceLinks.sort(linkSort);
            targetLinks.sort(linkSort);
        }
    }
    function computeNodeValues({ nodes: nodes }) {
        for (const node of nodes)node.value = node.fixedValue === undefined ? Math.max((0, $b3c93b6fbb60c924$export$2e2bcd8739ae039)(node.sourceLinks, $c678c6e8b1555d72$var$value), (0, $b3c93b6fbb60c924$export$2e2bcd8739ae039)(node.targetLinks, $c678c6e8b1555d72$var$value)) : node.fixedValue;
    }
    function computeNodeDepths({ nodes: nodes }) {
        const n = nodes.length;
        let current = new Set(nodes);
        let next = new Set;
        let x = 0;
        while(current.size){
            for (const node of current){
                node.depth = x;
                for (const { target: target } of node.sourceLinks)next.add(target);
            }
            if (++x > n) throw new Error("circular link");
            current = next;
            next = new Set;
        }
    }
    function computeNodeHeights({ nodes: nodes }) {
        const n = nodes.length;
        let current = new Set(nodes);
        let next = new Set;
        let x = 0;
        while(current.size){
            for (const node of current){
                node.height = x;
                for (const { source: source } of node.targetLinks)next.add(source);
            }
            if (++x > n) throw new Error("circular link");
            current = next;
            next = new Set;
        }
    }
    function computeNodeLayers({ nodes: nodes }) {
        const x = (0, $79b2876019e236cf$export$2e2bcd8739ae039)(nodes, (d)=>d.depth) + 1;
        const kx = (x1 - x0 - dx) / (x - 1);
        const columns = new Array(x);
        for (const node of nodes){
            const i = Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x))));
            node.layer = i;
            node.x0 = x0 + i * kx;
            node.x1 = node.x0 + dx;
            if (columns[i]) columns[i].push(node);
            else columns[i] = [
                node
            ];
        }
        if (sort) for (const column of columns)column.sort(sort);
        return columns;
    }
    function initializeNodeBreadths(columns) {
        const ky = (0, $b8c3ad69ded01687$export$2e2bcd8739ae039)(columns, (c)=>(y1 - y0 - (c.length - 1) * py) / (0, $b3c93b6fbb60c924$export$2e2bcd8739ae039)(c, $c678c6e8b1555d72$var$value));
        for (const nodes of columns){
            let y = y0;
            for (const node of nodes){
                node.y0 = y;
                node.y1 = y + node.value * ky;
                y = node.y1 + py;
                for (const link of node.sourceLinks)link.width = link.value * ky;
            }
            y = (y1 - y + py) / (nodes.length + 1);
            for(let i = 0; i < nodes.length; ++i){
                const node = nodes[i];
                node.y0 += y * (i + 1);
                node.y1 += y * (i + 1);
            }
            reorderLinks(nodes);
        }
    }
    function computeNodeBreadths(graph) {
        const columns = computeNodeLayers(graph);
        py = Math.min(dy, (y1 - y0) / ((0, $79b2876019e236cf$export$2e2bcd8739ae039)(columns, (c)=>c.length) - 1));
        initializeNodeBreadths(columns);
        for(let i = 0; i < iterations; ++i){
            const alpha = Math.pow(0.99, i);
            const beta = Math.max(1 - alpha, (i + 1) / iterations);
            relaxRightToLeft(columns, alpha, beta);
            relaxLeftToRight(columns, alpha, beta);
        }
    }
    // Reposition each node based on its incoming (target) links.
    function relaxLeftToRight(columns, alpha, beta) {
        for(let i = 1, n = columns.length; i < n; ++i){
            const column = columns[i];
            for (const target of column){
                let y = 0;
                let w = 0;
                for (const { source: source, value: value } of target.targetLinks){
                    let v = value * (target.layer - source.layer);
                    y += targetTop(source, target) * v;
                    w += v;
                }
                if (!(w > 0)) continue;
                let dy = (y / w - target.y0) * alpha;
                target.y0 += dy;
                target.y1 += dy;
                reorderNodeLinks(target);
            }
            if (sort === undefined) column.sort($c678c6e8b1555d72$var$ascendingBreadth);
            resolveCollisions(column, beta);
        }
    }
    // Reposition each node based on its outgoing (source) links.
    function relaxRightToLeft(columns, alpha, beta) {
        for(let n = columns.length, i = n - 2; i >= 0; --i){
            const column = columns[i];
            for (const source of column){
                let y = 0;
                let w = 0;
                for (const { target: target, value: value } of source.sourceLinks){
                    let v = value * (target.layer - source.layer);
                    y += sourceTop(source, target) * v;
                    w += v;
                }
                if (!(w > 0)) continue;
                let dy = (y / w - source.y0) * alpha;
                source.y0 += dy;
                source.y1 += dy;
                reorderNodeLinks(source);
            }
            if (sort === undefined) column.sort($c678c6e8b1555d72$var$ascendingBreadth);
            resolveCollisions(column, beta);
        }
    }
    function resolveCollisions(nodes, alpha) {
        const i = nodes.length >> 1;
        const subject = nodes[i];
        resolveCollisionsBottomToTop(nodes, subject.y0 - py, i - 1, alpha);
        resolveCollisionsTopToBottom(nodes, subject.y1 + py, i + 1, alpha);
        resolveCollisionsBottomToTop(nodes, y1, nodes.length - 1, alpha);
        resolveCollisionsTopToBottom(nodes, y0, 0, alpha);
    }
    // Push any overlapping nodes down.
    function resolveCollisionsTopToBottom(nodes, y, i, alpha) {
        for(; i < nodes.length; ++i){
            const node = nodes[i];
            const dy = (y - node.y0) * alpha;
            if (dy > 1e-6) node.y0 += dy, node.y1 += dy;
            y = node.y1 + py;
        }
    }
    // Push any overlapping nodes up.
    function resolveCollisionsBottomToTop(nodes, y, i, alpha) {
        for(; i >= 0; --i){
            const node = nodes[i];
            const dy = (node.y1 - y) * alpha;
            if (dy > 1e-6) node.y0 -= dy, node.y1 -= dy;
            y = node.y0 - py;
        }
    }
    function reorderNodeLinks({ sourceLinks: sourceLinks, targetLinks: targetLinks }) {
        if (linkSort === undefined) {
            for (const { source: { sourceLinks: sourceLinks } } of targetLinks)sourceLinks.sort($c678c6e8b1555d72$var$ascendingTargetBreadth);
            for (const { target: { targetLinks: targetLinks } } of sourceLinks)targetLinks.sort($c678c6e8b1555d72$var$ascendingSourceBreadth);
        }
    }
    function reorderLinks(nodes) {
        if (linkSort === undefined) for (const { sourceLinks: sourceLinks, targetLinks: targetLinks } of nodes){
            sourceLinks.sort($c678c6e8b1555d72$var$ascendingTargetBreadth);
            targetLinks.sort($c678c6e8b1555d72$var$ascendingSourceBreadth);
        }
    }
    // Returns the target.y0 that would produce an ideal link from source to target.
    function targetTop(source, target) {
        let y = source.y0 - (source.sourceLinks.length - 1) * py / 2;
        for (const { target: node, width: width } of source.sourceLinks){
            if (node === target) break;
            y += width + py;
        }
        for (const { source: node, width: width } of target.targetLinks){
            if (node === source) break;
            y -= width;
        }
        return y;
    }
    // Returns the source.y0 that would produce an ideal link from source to target.
    function sourceTop(source, target) {
        let y = target.y0 - (target.targetLinks.length - 1) * py / 2;
        for (const { source: node, width: width } of target.targetLinks){
            if (node === source) break;
            y += width + py;
        }
        for (const { target: node, width: width } of source.sourceLinks){
            if (node === target) break;
            y -= width;
        }
        return y;
    }
    return sankey;
}



var $298e104bd48cc605$var$pi = Math.PI, $298e104bd48cc605$var$tau = 2 * $298e104bd48cc605$var$pi, $298e104bd48cc605$var$epsilon = 1e-6, $298e104bd48cc605$var$tauEpsilon = $298e104bd48cc605$var$tau - $298e104bd48cc605$var$epsilon;
function $298e104bd48cc605$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $298e104bd48cc605$var$path() {
    return new $298e104bd48cc605$var$Path;
}
$298e104bd48cc605$var$Path.prototype = $298e104bd48cc605$var$path.prototype = {
    constructor: $298e104bd48cc605$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $298e104bd48cc605$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $298e104bd48cc605$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($298e104bd48cc605$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $298e104bd48cc605$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $298e104bd48cc605$var$epsilon || Math.abs(this._y1 - y0) > $298e104bd48cc605$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $298e104bd48cc605$var$tau + $298e104bd48cc605$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $298e104bd48cc605$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $298e104bd48cc605$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $298e104bd48cc605$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $298e104bd48cc605$export$2e2bcd8739ae039 = $298e104bd48cc605$var$path;


var $ad01ee65b1d7d08f$export$58adb3bec8346d0f = Array.prototype.slice;


function $f76f333837183828$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


function $cf155835204818d5$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $cf155835204818d5$export$4a5767248b18ef41(p) {
    return p[1];
}


function $cd165a5d9756f5a0$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}


function $89327eaa351f450b$var$linkSource(d) {
    return d.source;
}
function $89327eaa351f450b$var$linkTarget(d) {
    return d.target;
}
function $89327eaa351f450b$var$link(curve) {
    var source = $89327eaa351f450b$var$linkSource, target = $89327eaa351f450b$var$linkTarget, x = (0, $cf155835204818d5$export$d141bba7fdc215a3), y = (0, $cf155835204818d5$export$4a5767248b18ef41), context = null;
    function link() {
        var buffer, argv = (0, $ad01ee65b1d7d08f$export$58adb3bec8346d0f).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, $298e104bd48cc605$export$2e2bcd8739ae039)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $f76f333837183828$export$2e2bcd8739ae039)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $f76f333837183828$export$2e2bcd8739ae039)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function $89327eaa351f450b$var$curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function $89327eaa351f450b$var$curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function $89327eaa351f450b$var$curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, $cd165a5d9756f5a0$export$2e2bcd8739ae039)(x0, y0), p1 = (0, $cd165a5d9756f5a0$export$2e2bcd8739ae039)(x0, y0 = (y0 + y1) / 2), p2 = (0, $cd165a5d9756f5a0$export$2e2bcd8739ae039)(x1, y0), p3 = (0, $cd165a5d9756f5a0$export$2e2bcd8739ae039)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function $89327eaa351f450b$export$e7c381889b2cd14d() {
    return $89327eaa351f450b$var$link($89327eaa351f450b$var$curveHorizontal);
}
function $89327eaa351f450b$export$75de4c8c66884e04() {
    return $89327eaa351f450b$var$link($89327eaa351f450b$var$curveVertical);
}
function $89327eaa351f450b$export$7739cfe68d4e0799() {
    var l = $89327eaa351f450b$var$link($89327eaa351f450b$var$curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}


function $cfd4e458179697c7$var$horizontalSource(d) {
    return [
        d.source.x1,
        d.y0
    ];
}
function $cfd4e458179697c7$var$horizontalTarget(d) {
    return [
        d.target.x0,
        d.y1
    ];
}
function $cfd4e458179697c7$export$2e2bcd8739ae039() {
    return (0, $89327eaa351f450b$export$e7c381889b2cd14d)().source($cfd4e458179697c7$var$horizontalSource).target($cfd4e458179697c7$var$horizontalTarget);
}












var $acw62 = parcelRequire("acw62");



function $63eaaf0892ed732a$var$_extends() {
    $63eaaf0892ed732a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63eaaf0892ed732a$var$_extends.apply(this, arguments);
}
var $63eaaf0892ed732a$var$DEFAULT_LINK_COLOR = (0, $d629c93f7b094ef1$export$b59a484929f340e1)[1];
var $63eaaf0892ed732a$var$DEFAULT_LINK_OPACITY = 0.7;
function $63eaaf0892ed732a$var$SankeyLink(props) {
    var animation = props.animation, data = props.data, node = props.node, opacity = props.opacity, color = props.color, strokeWidth = props.strokeWidth, style = props.style, onLinkClick = props.onLinkClick, onLinkMouseOver = props.onLinkMouseOver, onLinkMouseOut = props.onLinkMouseOut;
    if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $63eaaf0892ed732a$var$_extends({}, props, {
        animatedProps: (0, $ba94dd19eb06369c$export$d820d92204df1f3c)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($63eaaf0892ed732a$var$SankeyLink, $63eaaf0892ed732a$var$_extends({}, props, {
        animation: null
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", $63eaaf0892ed732a$var$_extends({
        d: data
    }, style, {
        className: "rv-sankey__link",
        opacity: Number.isFinite(opacity) ? opacity : $63eaaf0892ed732a$var$DEFAULT_LINK_OPACITY,
        stroke: color || $63eaaf0892ed732a$var$DEFAULT_LINK_COLOR,
        onClick: function onClick(e) {
            return onLinkClick(node, e);
        },
        onMouseOver: function onMouseOver(e) {
            return onLinkMouseOver(node, e);
        },
        onMouseOut: function onMouseOut(e) {
            return onLinkMouseOut(node, e);
        },
        strokeWidth: strokeWidth,
        fill: "none"
    }));
}
$63eaaf0892ed732a$var$SankeyLink.displayName = "SankeyLink";
$63eaaf0892ed732a$var$SankeyLink.requiresSVG = true;
var $63eaaf0892ed732a$export$2e2bcd8739ae039 = $63eaaf0892ed732a$var$SankeyLink;


function $8532d0ce7e57a343$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8532d0ce7e57a343$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8532d0ce7e57a343$var$ownKeys(Object(source), true).forEach(function(key) {
            $8532d0ce7e57a343$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8532d0ce7e57a343$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8532d0ce7e57a343$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8532d0ce7e57a343$var$_toConsumableArray(arr) {
    return $8532d0ce7e57a343$var$_arrayWithoutHoles(arr) || $8532d0ce7e57a343$var$_iterableToArray(arr) || $8532d0ce7e57a343$var$_unsupportedIterableToArray(arr) || $8532d0ce7e57a343$var$_nonIterableSpread();
}
function $8532d0ce7e57a343$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8532d0ce7e57a343$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8532d0ce7e57a343$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8532d0ce7e57a343$var$_arrayLikeToArray(o, minLen);
}
function $8532d0ce7e57a343$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $8532d0ce7e57a343$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8532d0ce7e57a343$var$_arrayLikeToArray(arr);
}
function $8532d0ce7e57a343$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8532d0ce7e57a343$var$_extends() {
    $8532d0ce7e57a343$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8532d0ce7e57a343$var$_extends.apply(this, arguments);
}
var $8532d0ce7e57a343$var$NOOP = function NOOP(f) {
    return f;
};
var $8532d0ce7e57a343$var$ALIGNMENTS = {
    justify: (0, $479da5c8e0690793$export$720f2a50325b840f),
    center: (0, $479da5c8e0690793$export$3481c78889e8fbe8),
    left: (0, $479da5c8e0690793$export$eabcd2c8791e7bf4),
    right: (0, $479da5c8e0690793$export$79ffe56a765070d2)
};
var $8532d0ce7e57a343$var$DEFAULT_MARGINS = {
    top: 20,
    left: 20,
    right: 20,
    bottom: 20
};
function $8532d0ce7e57a343$var$Sankey(props) {
    var align = props.align, animation = props.animation, children = props.children, className = props.className, hasVoronoi = props.hasVoronoi, height = props.height, hideLabels = props.hideLabels, labelRotation = props.labelRotation, layout = props.layout, links = props.links, linkOpacity = props.linkOpacity, margin = props.margin, nodePadding = props.nodePadding, nodes = props.nodes, nodeWidth = props.nodeWidth, onValueClick = props.onValueClick, onValueMouseOver = props.onValueMouseOver, onValueMouseOut = props.onValueMouseOut, onLinkClick = props.onLinkClick, onLinkMouseOver = props.onLinkMouseOver, onLinkMouseOut = props.onLinkMouseOut, style = props.style, width = props.width; // d3-sankey sankeyInstance no longer accepts empty nodes array, return empty XYPlot by default
    if (nodes.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70994359f4ceeef3$export$2e2bcd8739ae039), $8532d0ce7e57a343$var$_extends({}, props, {
        yType: "literal",
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-sankey", className)
    }));
    var nodesCopy = $8532d0ce7e57a343$var$_toConsumableArray(new Array(nodes.length)).map(function(e, i) {
        return $8532d0ce7e57a343$var$_objectSpread({}, nodes[i]);
    });
    var linksCopy = $8532d0ce7e57a343$var$_toConsumableArray(new Array(links.length)).map(function(e, i) {
        return $8532d0ce7e57a343$var$_objectSpread({}, links[i]);
    });
    var _getInnerDimensions = (0, $a3dc0e1a1ee08269$export$72ee41b0ad150e05)({
        margin: margin,
        height: height,
        width: width
    }, $8532d0ce7e57a343$var$DEFAULT_MARGINS), marginLeft = _getInnerDimensions.marginLeft, marginTop = _getInnerDimensions.marginTop, marginRight = _getInnerDimensions.marginRight, marginBottom = _getInnerDimensions.marginBottom;
    var sankeyInstance = (0, $c678c6e8b1555d72$export$2e2bcd8739ae039)().extent([
        [
            marginLeft,
            marginTop
        ],
        [
            width - marginRight,
            height - marginBottom - marginTop
        ]
    ]).nodeWidth(nodeWidth).nodePadding(nodePadding).nodes(nodesCopy).links(linksCopy).nodeAlign($8532d0ce7e57a343$var$ALIGNMENTS[align]).iterations(layout);
    sankeyInstance(nodesCopy);
    var nWidth = sankeyInstance.nodeWidth();
    var path = (0, $cfd4e458179697c7$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70994359f4ceeef3$export$2e2bcd8739ae039), $8532d0ce7e57a343$var$_extends({}, props, {
        yType: "literal",
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-sankey", className)
    }), linksCopy.map(function(link, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $63eaaf0892ed732a$export$2e2bcd8739ae039), {
            style: style.links,
            data: path(link),
            opacity: link.opacity || linkOpacity,
            color: link.color,
            onLinkClick: onLinkClick,
            onLinkMouseOver: onLinkMouseOver,
            onLinkMouseOut: onLinkMouseOut,
            strokeWidth: Math.max(link.width, 1),
            node: link,
            nWidth: nWidth,
            key: "link-".concat(i)
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b0322f447e6a6178$export$2e2bcd8739ae039), {
        animation: animation,
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)(className, "rv-sankey__node"),
        data: nodesCopy.map(function(node) {
            return $8532d0ce7e57a343$var$_objectSpread($8532d0ce7e57a343$var$_objectSpread({}, node), {}, {
                y: node.y1 - marginTop,
                y0: node.y0 - marginTop,
                x: node.x1,
                x0: node.x0,
                color: node.color || (0, $d629c93f7b094ef1$export$b59a484929f340e1)[0],
                sourceLinks: null,
                targetLinks: null
            });
        }),
        style: style.rects,
        onValueClick: onValueClick,
        onValueMouseOver: onValueMouseOver,
        onValueMouseOut: onValueMouseOut,
        colorType: "literal"
    }), !hideLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ce38b8b6c594605$export$2e2bcd8739ae039), {
        animation: animation,
        className: className,
        rotation: labelRotation,
        labelAnchorY: "text-before-edge",
        data: nodesCopy.map(function(node, i) {
            return $8532d0ce7e57a343$var$_objectSpread({
                x: node.x0 + (node.x0 < width / 2 ? nWidth + 10 : -10),
                y: (node.y0 + node.y1) / 2 - marginTop,
                label: node.name,
                style: $8532d0ce7e57a343$var$_objectSpread({
                    textAnchor: node.x0 < width / 2 ? "start" : "end",
                    dy: "-.5em"
                }, style.labels)
            }, nodes[i]);
        })
    }), hasVoronoi && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $11aad0bf7d0bc992$export$2e2bcd8739ae039), {
        className: "rv-sankey__voronoi",
        extent: [
            [
                -marginLeft,
                -marginTop
            ],
            [
                width + marginRight,
                height + marginBottom
            ]
        ],
        nodes: nodesCopy,
        onClick: onValueClick,
        onHover: onValueMouseOver,
        onBlur: onValueMouseOut,
        x: function x(d) {
            return d.x0 + (d.x1 - d.x0) / 2;
        },
        y: function y(d) {
            return d.y0 + (d.y1 - d.y0) / 2;
        }
    }), children);
}
$8532d0ce7e57a343$var$Sankey.defaultProps = {
    align: "justify",
    className: "",
    hasVoronoi: false,
    hideLabels: false,
    labelRotation: 0,
    layout: 50,
    margin: $8532d0ce7e57a343$var$DEFAULT_MARGINS,
    nodePadding: 10,
    nodeWidth: 10,
    onValueMouseOver: $8532d0ce7e57a343$var$NOOP,
    onValueClick: $8532d0ce7e57a343$var$NOOP,
    onValueMouseOut: $8532d0ce7e57a343$var$NOOP,
    onLinkClick: $8532d0ce7e57a343$var$NOOP,
    onLinkMouseOver: $8532d0ce7e57a343$var$NOOP,
    onLinkMouseOut: $8532d0ce7e57a343$var$NOOP,
    style: {
        links: {},
        rects: {},
        labels: {}
    }
};
$8532d0ce7e57a343$var$Sankey.propTypes = {
    align: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "justify",
        "left",
        "right",
        "center"
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    hasVoronoi: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    hideLabels: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    labelRotation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    layout: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    links: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        source: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
        ]).isRequired,
        target: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
        ]).isRequired
    })).isRequired,
    margin: (0, $a3dc0e1a1ee08269$export$a2f0519a883a74de),
    nodePadding: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    nodes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired,
    nodeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    onValueMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLinkClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLinkMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLinkMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        links: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        rects: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    }),
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
var $8532d0ce7e57a343$export$2e2bcd8739ae039 = $8532d0ce7e57a343$var$Sankey;



var $acw62 = parcelRequire("acw62");

function $06713b77db0b884a$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $06713b77db0b884a$export$2e2bcd8739ae039() {
    return this.eachAfter($06713b77db0b884a$var$count);
}


function $4449780af3a02b1f$export$2e2bcd8739ae039(callback, that) {
    let index = -1;
    for (const node of this)callback.call(that, node, ++index, this);
    return this;
}


function $054d715bf53e9c0d$export$2e2bcd8739ae039(callback, that) {
    var node = this, nodes = [
        node
    ], children, i, index = -1;
    while(node = nodes.pop()){
        callback.call(that, node, ++index, this);
        if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}


function $318ee109364962b6$export$2e2bcd8739ae039(callback, that) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n, index = -1;
    while(node = nodes.pop()){
        next.push(node);
        if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback.call(that, node, ++index, this);
    return this;
}


function $b66499c1cf9f0611$export$2e2bcd8739ae039(callback, that) {
    let index = -1;
    for (const node of this){
        if (callback.call(that, node, ++index, this)) return node;
    }
}


function $94e4aed2771c04cc$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}


function $826cc013cd384109$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}


function $b87aaeb3b6fa0399$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $b87aaeb3b6fa0399$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $b87aaeb3b6fa0399$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}


function $3aa4adf4b1fab731$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}


function $faf9e569de99c052$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $dad9dd452e7acc2b$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}


function $99c2b8cd250f0b60$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}


function* $fc15efcd8611bcd8$export$2e2bcd8739ae039() {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            yield node;
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
}


function $9a60c0761eaba32b$export$2e2bcd8739ae039(data, children) {
    if (data instanceof Map) {
        data = [
            undefined,
            data
        ];
        if (children === undefined) children = $9a60c0761eaba32b$var$mapChildren;
    } else if (children === undefined) children = $9a60c0761eaba32b$var$objectChildren;
    var root = new $9a60c0761eaba32b$export$85c928794f8d04d4(data), node, nodes = [
        root
    ], child, childs, i, n;
    while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = childs[i] = new $9a60c0761eaba32b$export$85c928794f8d04d4(childs[i]));
            child.parent = node;
            child.depth = node.depth + 1;
        }
    }
    return root.eachBefore($9a60c0761eaba32b$export$5af32d52ab5dfd57);
}
function $9a60c0761eaba32b$var$node_copy() {
    return $9a60c0761eaba32b$export$2e2bcd8739ae039(this).eachBefore($9a60c0761eaba32b$var$copyData);
}
function $9a60c0761eaba32b$var$objectChildren(d) {
    return d.children;
}
function $9a60c0761eaba32b$var$mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
}
function $9a60c0761eaba32b$var$copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
}
function $9a60c0761eaba32b$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $9a60c0761eaba32b$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$9a60c0761eaba32b$export$85c928794f8d04d4.prototype = $9a60c0761eaba32b$export$2e2bcd8739ae039.prototype = {
    constructor: $9a60c0761eaba32b$export$85c928794f8d04d4,
    count: (0, $06713b77db0b884a$export$2e2bcd8739ae039),
    each: (0, $4449780af3a02b1f$export$2e2bcd8739ae039),
    eachAfter: (0, $318ee109364962b6$export$2e2bcd8739ae039),
    eachBefore: (0, $054d715bf53e9c0d$export$2e2bcd8739ae039),
    find: (0, $b66499c1cf9f0611$export$2e2bcd8739ae039),
    sum: (0, $94e4aed2771c04cc$export$2e2bcd8739ae039),
    sort: (0, $826cc013cd384109$export$2e2bcd8739ae039),
    path: (0, $b87aaeb3b6fa0399$export$2e2bcd8739ae039),
    ancestors: (0, $3aa4adf4b1fab731$export$2e2bcd8739ae039),
    descendants: (0, $faf9e569de99c052$export$2e2bcd8739ae039),
    leaves: (0, $dad9dd452e7acc2b$export$2e2bcd8739ae039),
    links: (0, $99c2b8cd250f0b60$export$2e2bcd8739ae039),
    copy: $9a60c0761eaba32b$var$node_copy,
    [Symbol.iterator]: (0, $fc15efcd8611bcd8$export$2e2bcd8739ae039)
};

function $aed60e160d4ee5c0$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}


function $41d50c80388e33d8$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}


function $33157bf754db4825$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $aed60e160d4ee5c0$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $41d50c80388e33d8$export$2e2bcd8739ae039)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}





function $d97c146f4f811488$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $d97c146f4f811488$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $d97c146f4f811488$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $d97c146f4f811488$export$34695211ec403a46(transform) {
    var scale = transform((0, $afe237385175446a$export$f0954fd7d5368655), (0, $afe237385175446a$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $afe237385175446a$export$f0954fd7d5368655), (0, $afe237385175446a$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($d97c146f4f811488$var$transformSqrt, $d97c146f4f811488$var$transformSquare) : transform($d97c146f4f811488$var$transformPow(exponent), $d97c146f4f811488$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $db1dd3c66a0cbf94$export$16a5d4b4a61a274d)(scale);
}
function $d97c146f4f811488$export$2e2bcd8739ae039() {
    var scale = $d97c146f4f811488$export$34695211ec403a46((0, $afe237385175446a$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $afe237385175446a$export$784d13d8ee351f07)(scale, $d97c146f4f811488$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $d97c146f4f811488$export$eba8049fb5020b81() {
    return $d97c146f4f811488$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}









function $097f392715badce9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $097f392715badce9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $097f392715badce9$var$ownKeys(Object(source), true).forEach(function(key) {
            $097f392715badce9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $097f392715badce9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $097f392715badce9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $097f392715badce9$var$predefinedClassName = "rv-sunburst";
var $097f392715badce9$var$LISTENERS_TO_OVERWRITE = [
    "onValueMouseOver",
    "onValueMouseOut",
    "onValueClick",
    "onValueRightClick",
    "onSeriesMouseOver",
    "onSeriesMouseOut",
    "onSeriesClick",
    "onSeriesRightClick"
];
/**
 * Create the list of nodes to render.
 * @param {Object} props
   props.data {Object} - tree structured data (each node has a name anc an array of children)
   props.height {number} - the height of the graphic to be rendered
   props.hideRootNode {boolean} - whether or not to hide the root node
   props.width {number} - the width of the graphic to be rendered
   props.getSize {function} - accessor for the size
 * @returns {Array} Array of nodes.
 */ function $097f392715badce9$var$getNodesToRender(_ref) {
    var data = _ref.data, height = _ref.height, hideRootNode = _ref.hideRootNode, width = _ref.width, getSize = _ref.getSize;
    var partitionFunction = (0, $33157bf754db4825$export$2e2bcd8739ae039)();
    var structuredInput = (0, $9a60c0761eaba32b$export$2e2bcd8739ae039)(data).sum(getSize);
    var radius = Math.min(width, height) / 2 - 10;
    var x = (0, $db1dd3c66a0cbf94$export$2e2bcd8739ae039)().range([
        0,
        2 * Math.PI
    ]);
    var y = (0, $d97c146f4f811488$export$eba8049fb5020b81)().range([
        0,
        radius
    ]);
    return partitionFunction(structuredInput).descendants().reduce(function(res, cell, index) {
        if (hideRootNode && index === 0) return res;
        return res.concat([
            $097f392715badce9$var$_objectSpread({
                angle0: Math.max(0, Math.min(2 * Math.PI, x(cell.x0))),
                angle: Math.max(0, Math.min(2 * Math.PI, x(cell.x1))),
                radius0: Math.max(0, y(cell.y0)),
                radius: Math.max(0, y(cell.y1)),
                depth: cell.depth,
                parent: cell.parent
            }, cell.data)
        ]);
    }, []);
}
/**
 * Convert arc nodes into label rows.
 * Important to use mappedData rather than regular data, bc it is already unrolled
 * @param {Array} mappedData - Array of nodes.
 * @param {Object} accessors - object of accessors
 * @returns {Array} array of node for rendering as labels
 */ function $097f392715badce9$var$buildLabels(mappedData, accessors) {
    var getAngle = accessors.getAngle, getAngle0 = accessors.getAngle0, getLabel = accessors.getLabel, getRadius0 = accessors.getRadius0;
    return mappedData.filter(getLabel).map(function(row) {
        var truedAngle = -1 * getAngle(row) + Math.PI / 2;
        var truedAngle0 = -1 * getAngle0(row) + Math.PI / 2;
        var angle = (truedAngle0 + truedAngle) / 2;
        var rotateLabels = !row.dontRotateLabel;
        var rotAngle = -angle / (2 * Math.PI) * 360;
        return $097f392715badce9$var$_objectSpread($097f392715badce9$var$_objectSpread({}, row), {}, {
            children: null,
            angle: null,
            radius: null,
            x: getRadius0(row) * Math.cos(angle),
            y: getRadius0(row) * Math.sin(angle),
            style: $097f392715badce9$var$_objectSpread({
                textAnchor: rotAngle > 90 ? "end" : "start"
            }, row.labelStyle),
            rotation: rotateLabels ? rotAngle > 90 ? rotAngle + 180 : rotAngle === 90 ? 90 : rotAngle : null
        });
    });
}
var $097f392715badce9$var$NOOP = function NOOP() {};
function $097f392715badce9$var$Sunburst(props) {
    var getAngle = props.getAngle, getAngle0 = props.getAngle0, animation = props.animation, className = props.className, children = props.children, data = props.data, height = props.height, hideRootNode = props.hideRootNode, getLabel = props.getLabel, width = props.width, getSize = props.getSize, colorType = props.colorType;
    var mappedData = $097f392715badce9$var$getNodesToRender({
        data: data,
        height: height,
        hideRootNode: hideRootNode,
        width: width,
        getSize: getSize
    });
    var radialDomain = (0, $ba94dd19eb06369c$export$8db0eb04c74fd34e)(mappedData);
    var margin = (0, $a3dc0e1a1ee08269$export$b7318b0ae20c2441)(width, height, radialDomain);
    var labelData = $097f392715badce9$var$buildLabels(mappedData, {
        getAngle: getAngle,
        getAngle0: getAngle0,
        getLabel: getLabel,
        getRadius0: function getRadius0(d) {
            return d.radius0;
        }
    });
    var hofBuilder = function hofBuilder(f) {
        return function(e, i) {
            return f ? f(mappedData[e.index], i) : $097f392715badce9$var$NOOP;
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70994359f4ceeef3$export$2e2bcd8739ae039), {
        height: height,
        hasTreeStructure: true,
        width: width,
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)($097f392715badce9$var$predefinedClassName, className),
        margin: margin,
        xDomain: [
            -radialDomain,
            radialDomain
        ],
        yDomain: [
            -radialDomain,
            radialDomain
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $682e33890727be82$export$2e2bcd8739ae039), $097f392715badce9$var$_objectSpread($097f392715badce9$var$_objectSpread({
        colorType: colorType
    }, props), {}, {
        animation: animation,
        radiusDomain: [
            0,
            radialDomain
        ],
        // need to present a stripped down version for interpolation
        data: animation ? mappedData.map(function(row, index) {
            return $097f392715badce9$var$_objectSpread($097f392715badce9$var$_objectSpread({}, row), {}, {
                parent: null,
                children: null,
                index: index
            });
        }) : mappedData,
        _data: animation ? mappedData : null,
        arcClassName: "".concat($097f392715badce9$var$predefinedClassName, "__series--radial__arc")
    }, $097f392715badce9$var$LISTENERS_TO_OVERWRITE.reduce(function(acc, propName) {
        var prop = props[propName];
        acc[propName] = animation ? hofBuilder(prop) : prop;
        return acc;
    }, {}))), labelData.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ce38b8b6c594605$export$2e2bcd8739ae039), {
        data: labelData,
        getLabel: getLabel
    }), children);
}
$097f392715badce9$var$Sunburst.displayName = "Sunburst";
$097f392715badce9$var$Sunburst.propTypes = {
    animation: (0, $d4808d8f8c60755d$export$c6290f21adf0a17a),
    getAngle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    getAngle0: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    colorType: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    hideRootNode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    getLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onValueMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    getSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    padAngle: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ])
};
$097f392715badce9$var$Sunburst.defaultProps = {
    getAngle: function getAngle(d) {
        return d.angle;
    },
    getAngle0: function getAngle0(d) {
        return d.angle0;
    },
    className: "",
    colorType: "literal",
    getColor: function getColor(d) {
        return d.color;
    },
    hideRootNode: false,
    getLabel: function getLabel(d) {
        return d.label;
    },
    getSize: function getSize(d) {
        return d.size;
    },
    padAngle: 0
};
var $097f392715badce9$export$2e2bcd8739ae039 = $097f392715badce9$var$Sunburst;



var $acw62 = parcelRequire("acw62");

function $90128989f18a9a47$export$516e28dec6a4b6d4(f) {
    return f == null ? null : $90128989f18a9a47$export$a7a0278c004aac3f(f);
}
function $90128989f18a9a47$export$a7a0278c004aac3f(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}


function $4ecbd2dc481264b5$export$99e2e371aa6a9db() {
    return 0;
}
function $4ecbd2dc481264b5$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $a2ff0f94b9ee8fb6$var$a = 1664525;
const $a2ff0f94b9ee8fb6$var$c = 1013904223;
const $a2ff0f94b9ee8fb6$var$m = 4294967296; // 2^32
function $a2ff0f94b9ee8fb6$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($a2ff0f94b9ee8fb6$var$a * s + $a2ff0f94b9ee8fb6$var$c) % $a2ff0f94b9ee8fb6$var$m) / $a2ff0f94b9ee8fb6$var$m;
}


function $b99145bc2d4353db$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}
function $b99145bc2d4353db$export$448332262467e042(array, random) {
    let m = array.length, t, i;
    while(m){
        i = random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}





function $ea1b36d15ec8a0dd$export$2e2bcd8739ae039(circles) {
    return $ea1b36d15ec8a0dd$export$55712536b4d8ce73(circles, (0, $a2ff0f94b9ee8fb6$export$2e2bcd8739ae039)());
}
function $ea1b36d15ec8a0dd$export$55712536b4d8ce73(circles, random) {
    var i = 0, n = (circles = (0, $b99145bc2d4353db$export$448332262467e042)(Array.from(circles), random)).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && $ea1b36d15ec8a0dd$var$enclosesWeak(e, p)) ++i;
        else e = $ea1b36d15ec8a0dd$var$encloseBasis(B = $ea1b36d15ec8a0dd$var$extendBasis(B, p)), i = 0;
    }
    return e;
}
function $ea1b36d15ec8a0dd$var$extendBasis(B, p) {
    var i, j;
    if ($ea1b36d15ec8a0dd$var$enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if ($ea1b36d15ec8a0dd$var$enclosesNot(p, B[i]) && $ea1b36d15ec8a0dd$var$enclosesWeakAll($ea1b36d15ec8a0dd$var$encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if ($ea1b36d15ec8a0dd$var$enclosesNot($ea1b36d15ec8a0dd$var$encloseBasis2(B[i], B[j]), p) && $ea1b36d15ec8a0dd$var$enclosesNot($ea1b36d15ec8a0dd$var$encloseBasis2(B[i], p), B[j]) && $ea1b36d15ec8a0dd$var$enclosesNot($ea1b36d15ec8a0dd$var$encloseBasis2(B[j], p), B[i]) && $ea1b36d15ec8a0dd$var$enclosesWeakAll($ea1b36d15ec8a0dd$var$encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function $ea1b36d15ec8a0dd$var$enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function $ea1b36d15ec8a0dd$var$enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $ea1b36d15ec8a0dd$var$enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!$ea1b36d15ec8a0dd$var$enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function $ea1b36d15ec8a0dd$var$encloseBasis(B) {
    switch(B.length){
        case 1:
            return $ea1b36d15ec8a0dd$var$encloseBasis1(B[0]);
        case 2:
            return $ea1b36d15ec8a0dd$var$encloseBasis2(B[0], B[1]);
        case 3:
            return $ea1b36d15ec8a0dd$var$encloseBasis3(B[0], B[1], B[2]);
    }
}
function $ea1b36d15ec8a0dd$var$encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function $ea1b36d15ec8a0dd$var$encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function $ea1b36d15ec8a0dd$var$encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}


function $6594768d72e976ec$var$place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function $6594768d72e976ec$var$intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $6594768d72e976ec$var$score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function $6594768d72e976ec$var$Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function $6594768d72e976ec$export$5390336473d877c8(circles, random) {
    if (!(n = (circles = (0, $b99145bc2d4353db$export$2e2bcd8739ae039)(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    $6594768d72e976ec$var$place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new $6594768d72e976ec$var$Node(a), b = new $6594768d72e976ec$var$Node(b), c = new $6594768d72e976ec$var$Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        $6594768d72e976ec$var$place(a._, b._, c = circles[i]), c = new $6594768d72e976ec$var$Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if ($6594768d72e976ec$var$intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if ($6594768d72e976ec$var$intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = $6594768d72e976ec$var$score(a);
        while((c = c.next) !== b)if ((ca = $6594768d72e976ec$var$score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, $ea1b36d15ec8a0dd$export$55712536b4d8ce73)(a, random);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}
function $6594768d72e976ec$export$2e2bcd8739ae039(circles) {
    $6594768d72e976ec$export$5390336473d877c8(circles, (0, $a2ff0f94b9ee8fb6$export$2e2bcd8739ae039)());
    return circles;
}


function $2c146828ae9cce7b$var$defaultRadius(d) {
    return Math.sqrt(d.value);
}
function $2c146828ae9cce7b$export$2e2bcd8739ae039() {
    var radius = null, dx = 1, dy = 1, padding = (0, $4ecbd2dc481264b5$export$99e2e371aa6a9db);
    function pack(root) {
        const random = (0, $a2ff0f94b9ee8fb6$export$2e2bcd8739ae039)();
        root.x = dx / 2, root.y = dy / 2;
        if (radius) root.eachBefore($2c146828ae9cce7b$var$radiusLeaf(radius)).eachAfter($2c146828ae9cce7b$var$packChildrenRandom(padding, 0.5, random)).eachBefore($2c146828ae9cce7b$var$translateChild(1));
        else root.eachBefore($2c146828ae9cce7b$var$radiusLeaf($2c146828ae9cce7b$var$defaultRadius)).eachAfter($2c146828ae9cce7b$var$packChildrenRandom((0, $4ecbd2dc481264b5$export$99e2e371aa6a9db), 1, random)).eachAfter($2c146828ae9cce7b$var$packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore($2c146828ae9cce7b$var$translateChild(Math.min(dx, dy) / (2 * root.r)));
        return root;
    }
    pack.radius = function(x) {
        return arguments.length ? (radius = (0, $90128989f18a9a47$export$516e28dec6a4b6d4)(x), pack) : radius;
    };
    pack.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
            dx,
            dy
        ];
    };
    pack.padding = function(x) {
        return arguments.length ? (padding = typeof x === "function" ? x : (0, $4ecbd2dc481264b5$export$2e2bcd8739ae039)(+x), pack) : padding;
    };
    return pack;
}
function $2c146828ae9cce7b$var$radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function $2c146828ae9cce7b$var$packChildrenRandom(padding, k, random) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, $6594768d72e976ec$export$5390336473d877c8)(children, random);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function $2c146828ae9cce7b$var$translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}



function $e510cc16795bdea9$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}


var $b59b7ec66acd2122$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $b59b7ec66acd2122$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $41d50c80388e33d8$export$2e2bcd8739ae039)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $e510cc16795bdea9$export$2e2bcd8739ae039)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $b59b7ec66acd2122$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $b59b7ec66acd2122$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($b59b7ec66acd2122$export$324943737027944a);




function $eaa8edfadbfdf0f7$export$2e2bcd8739ae039() {
    var tile = (0, $b59b7ec66acd2122$export$2e2bcd8739ae039), round = false, dx = 1, dy = 1, paddingStack = [
        0
    ], paddingInner = (0, $4ecbd2dc481264b5$export$99e2e371aa6a9db), paddingTop = (0, $4ecbd2dc481264b5$export$99e2e371aa6a9db), paddingRight = (0, $4ecbd2dc481264b5$export$99e2e371aa6a9db), paddingBottom = (0, $4ecbd2dc481264b5$export$99e2e371aa6a9db), paddingLeft = (0, $4ecbd2dc481264b5$export$99e2e371aa6a9db);
    function treemap(root) {
        root.x0 = root.y0 = 0;
        root.x1 = dx;
        root.y1 = dy;
        root.eachBefore(positionNode);
        paddingStack = [
            0
        ];
        if (round) root.eachBefore((0, $aed60e160d4ee5c0$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(node) {
        var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
        if (node.children) {
            p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
            x0 += paddingLeft(node) - p;
            y0 += paddingTop(node) - p;
            x1 -= paddingRight(node) - p;
            y1 -= paddingBottom(node) - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            tile(node, x0, y0, x1, y1);
        }
    }
    treemap.round = function(x) {
        return arguments.length ? (round = !!x, treemap) : round;
    };
    treemap.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
            dx,
            dy
        ];
    };
    treemap.tile = function(x) {
        return arguments.length ? (tile = (0, $90128989f18a9a47$export$a7a0278c004aac3f)(x), treemap) : tile;
    };
    treemap.padding = function(x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
    treemap.paddingInner = function(x) {
        return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, $4ecbd2dc481264b5$export$2e2bcd8739ae039)(+x), treemap) : paddingInner;
    };
    treemap.paddingOuter = function(x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
    treemap.paddingTop = function(x) {
        return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, $4ecbd2dc481264b5$export$2e2bcd8739ae039)(+x), treemap) : paddingTop;
    };
    treemap.paddingRight = function(x) {
        return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, $4ecbd2dc481264b5$export$2e2bcd8739ae039)(+x), treemap) : paddingRight;
    };
    treemap.paddingBottom = function(x) {
        return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, $4ecbd2dc481264b5$export$2e2bcd8739ae039)(+x), treemap) : paddingBottom;
    };
    treemap.paddingLeft = function(x) {
        return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, $4ecbd2dc481264b5$export$2e2bcd8739ae039)(+x), treemap) : paddingLeft;
    };
    return treemap;
}

function $db77ef44c1b1abd6$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
    for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
    partition(0, n, parent.value, x0, y0, x1, y1);
    function partition(i, j, value, x0, y0, x1, y1) {
        if (i >= j - 1) {
            var node = nodes[i];
            node.x0 = x0, node.y0 = y0;
            node.x1 = x1, node.y1 = y1;
            return;
        }
        var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
        while(k < hi){
            var mid = k + hi >>> 1;
            if (sums[mid] < valueTarget) k = mid + 1;
            else hi = mid;
        }
        if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
        var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
        if (x1 - x0 > y1 - y0) {
            var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
            partition(i, k, valueLeft, x0, y0, xk, y1);
            partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
            var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
            partition(i, k, valueLeft, x0, y0, x1, yk);
            partition(k, j, valueRight, x0, yk, x1, y1);
        }
    }
}




var $7d7ebb8fcbd38e77$export$2e2bcd8739ae039 = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, $41d50c80388e33d8$export$2e2bcd8739ae039)(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                else (0, $e510cc16795bdea9$export$2e2bcd8739ae039)(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, $b59b7ec66acd2122$export$9ff1217655212093)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, $b59b7ec66acd2122$export$324943737027944a));



function $4cdb51c023cf32ea$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? (0, $e510cc16795bdea9$export$2e2bcd8739ae039) : (0, $41d50c80388e33d8$export$2e2bcd8739ae039))(parent, x0, y0, x1, y1);
}







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



function $937ac97db7c2c850$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $937ac97db7c2c850$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $937ac97db7c2c850$var$ownKeys(Object(source), true).forEach(function(key) {
            $937ac97db7c2c850$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $937ac97db7c2c850$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $937ac97db7c2c850$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $937ac97db7c2c850$var$_extends() {
    $937ac97db7c2c850$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $937ac97db7c2c850$var$_extends.apply(this, arguments);
}
var $937ac97db7c2c850$var$ANIMATED_PROPS = [
    "colorRange",
    "colorDomain",
    "color",
    "opacityRange",
    "opacityDomain",
    "opacity",
    "x0",
    "x1",
    "y0",
    "y1",
    "r"
];
function $937ac97db7c2c850$var$TreemapLeaf(props) {
    var animation = props.animation, getLabel = props.getLabel, mode = props.mode, node = props.node, onLeafClick = props.onLeafClick, onLeafMouseOver = props.onLeafMouseOver, onLeafMouseOut = props.onLeafMouseOut, r = props.r, scales = props.scales, x0 = props.x0, x1 = props.x1, y0 = props.y0, y1 = props.y1, style = props.style;
    if (animation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d4808d8f8c60755d$export$2e2bcd8739ae039), $937ac97db7c2c850$var$_extends({}, props, {
        animatedProps: $937ac97db7c2c850$var$ANIMATED_PROPS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($937ac97db7c2c850$var$TreemapLeaf, $937ac97db7c2c850$var$_extends({}, props, {
        animation: null
    })));
    var useCirclePacking = mode === "circlePack";
    var background = scales.color(node);
    var opacity = scales.opacity(node);
    var color = (0, $379b4f4f942d44ab$export$f8102d7542f8efe4)(background);
    var data = node.data;
    var title = getLabel(data);
    var leafStyle = $937ac97db7c2c850$var$_objectSpread($937ac97db7c2c850$var$_objectSpread({
        top: useCirclePacking ? y0 - r : y0,
        left: useCirclePacking ? x0 - r : x0,
        width: useCirclePacking ? r * 2 : x1 - x0,
        height: useCirclePacking ? r * 2 : y1 - y0,
        background: background,
        opacity: opacity,
        color: color
    }, style), node.data.style);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rv-treemap__leaf ".concat(useCirclePacking ? "rv-treemap__leaf--circle" : ""),
        onMouseEnter: function onMouseEnter(event) {
            return onLeafMouseOver(node, event);
        },
        onMouseLeave: function onMouseLeave(event) {
            return onLeafMouseOut(node, event);
        },
        onClick: function onClick(event) {
            return onLeafClick(node, event);
        },
        style: leafStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "rv-treemap__leaf__content"
    }, title));
}
$937ac97db7c2c850$var$TreemapLeaf.propTypes = {
    animation: (0, $d4808d8f8c60755d$export$c6290f21adf0a17a),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    node: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object.isRequired,
    onLeafClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLeafMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLeafMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    scales: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object.isRequired,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    r: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    x0: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    x1: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    y0: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    y1: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
var $937ac97db7c2c850$export$2e2bcd8739ae039 = $937ac97db7c2c850$var$TreemapLeaf;



function $56783b0467b18b29$var$_extends() {
    $56783b0467b18b29$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $56783b0467b18b29$var$_extends.apply(this, arguments);
}
function $56783b0467b18b29$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $56783b0467b18b29$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $56783b0467b18b29$var$ownKeys(Object(source), true).forEach(function(key) {
            $56783b0467b18b29$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $56783b0467b18b29$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $56783b0467b18b29$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $56783b0467b18b29$var$TreemapDOM(props) {
    var animation = props.animation, className = props.className, height = props.height, hideRootNode = props.hideRootNode, getLabel = props.getLabel, mode = props.mode, nodes = props.nodes, width = props.width, scales = props.scales, style = props.style;
    var useCirclePacking = mode === "circlePack";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-treemap", useCirclePacking && "rv-treemap-circle-paked", className),
        style: {
            height: height,
            width: width
        }
    }, nodes.map(function(node, index) {
        // throw out the rootest node
        if (hideRootNode && !index) return null;
        var nodeProps = $56783b0467b18b29$var$_objectSpread($56783b0467b18b29$var$_objectSpread({
            animation: animation,
            node: node,
            getLabel: getLabel
        }, props), {}, {
            x0: useCirclePacking ? node.x : node.x0,
            x1: useCirclePacking ? node.x : node.x1,
            y0: useCirclePacking ? node.y : node.y0,
            y1: useCirclePacking ? node.y : node.y1,
            r: useCirclePacking ? node.r : 1,
            scales: scales,
            style: style
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $937ac97db7c2c850$export$2e2bcd8739ae039), $56783b0467b18b29$var$_extends({}, nodeProps, {
            key: "leaf-".concat(index)
        }));
    }));
}
$56783b0467b18b29$var$TreemapDOM.displayName = "TreemapDOM";
var $56783b0467b18b29$export$2e2bcd8739ae039 = $56783b0467b18b29$var$TreemapDOM;



var $acw62 = parcelRequire("acw62");





function $07b9862a8a111d1d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $07b9862a8a111d1d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $07b9862a8a111d1d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $07b9862a8a111d1d$var$_typeof(obj);
}
function $07b9862a8a111d1d$var$_extends() {
    $07b9862a8a111d1d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $07b9862a8a111d1d$var$_extends.apply(this, arguments);
}
function $07b9862a8a111d1d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $07b9862a8a111d1d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $07b9862a8a111d1d$var$ownKeys(Object(source), true).forEach(function(key) {
            $07b9862a8a111d1d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $07b9862a8a111d1d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $07b9862a8a111d1d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $07b9862a8a111d1d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $07b9862a8a111d1d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07b9862a8a111d1d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $07b9862a8a111d1d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $07b9862a8a111d1d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $07b9862a8a111d1d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $07b9862a8a111d1d$var$_setPrototypeOf(subClass, superClass);
}
function $07b9862a8a111d1d$var$_setPrototypeOf(o, p) {
    $07b9862a8a111d1d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $07b9862a8a111d1d$var$_setPrototypeOf(o, p);
}
function $07b9862a8a111d1d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $07b9862a8a111d1d$var$_isNativeReflectConstruct();
    return function() {
        var Super = $07b9862a8a111d1d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $07b9862a8a111d1d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $07b9862a8a111d1d$var$_possibleConstructorReturn(this, result);
    };
}
function $07b9862a8a111d1d$var$_possibleConstructorReturn(self, call) {
    if (call && ($07b9862a8a111d1d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $07b9862a8a111d1d$var$_assertThisInitialized(self);
}
function $07b9862a8a111d1d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $07b9862a8a111d1d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $07b9862a8a111d1d$var$_getPrototypeOf(o) {
    $07b9862a8a111d1d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $07b9862a8a111d1d$var$_getPrototypeOf(o);
}
var $07b9862a8a111d1d$var$MARGIN_ADJUST = 1.2;
var $07b9862a8a111d1d$var$TreemapSVG = /*#__PURE__*/ function(_React$Component) {
    $07b9862a8a111d1d$var$_inherits(TreemapSVG, _React$Component);
    var _super = $07b9862a8a111d1d$var$_createSuper(TreemapSVG);
    function TreemapSVG() {
        $07b9862a8a111d1d$var$_classCallCheck(this, TreemapSVG);
        return _super.apply(this, arguments);
    }
    $07b9862a8a111d1d$var$_createClass(TreemapSVG, [
        {
            key: "getCircularNodes",
            value: function getCircularNodes() {
                var _this$props = this.props, animation = _this$props.animation, hideRootNode = _this$props.hideRootNode, nodes = _this$props.nodes, onLeafMouseOver = _this$props.onLeafMouseOver, onLeafMouseOut = _this$props.onLeafMouseOut, onLeafClick = _this$props.onLeafClick, scales = _this$props.scales, style = _this$props.style;
                var _nodes$reduce = nodes.reduce(function(acc, node, index) {
                    if (!index && hideRootNode) return acc;
                    var x = node.x, y = node.y, r = node.r;
                    return {
                        maxY: Math.max(y + r, acc.maxY),
                        minY: Math.min(y - r, acc.minY),
                        maxX: Math.max(x + $07b9862a8a111d1d$var$MARGIN_ADJUST * r, acc.maxX),
                        minX: Math.min(x - $07b9862a8a111d1d$var$MARGIN_ADJUST * r, acc.minX),
                        rows: acc.rows.concat([
                            {
                                x: x,
                                y: y,
                                size: r,
                                color: scales.color(node)
                            }
                        ])
                    };
                }, {
                    rows: [],
                    maxY: -Infinity,
                    minY: Infinity,
                    maxX: -Infinity,
                    minX: Infinity
                }), rows = _nodes$reduce.rows, minY = _nodes$reduce.minY, maxY = _nodes$reduce.maxY, minX = _nodes$reduce.minX, maxX = _nodes$reduce.maxX;
                return {
                    updatedNodes: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dd4ad056f824b78e$export$2e2bcd8739ae039), {
                        animation: animation,
                        className: "rv-treemap__leaf rv-treemap__leaf--circle",
                        onSeriesMouseEnter: onLeafMouseOver,
                        onSeriesMouseLeave: onLeafMouseOut,
                        onSeriesClick: onLeafClick,
                        data: rows,
                        colorType: "literal",
                        getColor: function getColor(d) {
                            return d.color;
                        },
                        sizeType: "literal",
                        getSize: function getSize(d) {
                            return d.size;
                        },
                        style: style
                    }),
                    minY: minY,
                    maxY: maxY,
                    minX: minX,
                    maxX: maxX
                };
            }
        },
        {
            key: "getNonCircularNodes",
            value: function getNonCircularNodes() {
                var _this$props2 = this.props, animation = _this$props2.animation, hideRootNode = _this$props2.hideRootNode, nodes = _this$props2.nodes, onLeafMouseOver = _this$props2.onLeafMouseOver, onLeafMouseOut = _this$props2.onLeafMouseOut, onLeafClick = _this$props2.onLeafClick, scales = _this$props2.scales, style = _this$props2.style;
                var color = scales.color;
                return nodes.reduce(function(acc, node, index) {
                    if (!index && hideRootNode) return acc;
                    var x0 = node.x0, x1 = node.x1, y1 = node.y1, y0 = node.y0;
                    var x = x0;
                    var y = y0;
                    var nodeHeight = y1 - y0;
                    var nodeWidth = x1 - x0;
                    acc.maxY = Math.max(y + nodeHeight, acc.maxY);
                    acc.minY = Math.min(y, acc.minY);
                    acc.maxX = Math.max(x + nodeWidth, acc.maxX);
                    acc.minX = Math.min(x, acc.minX);
                    var data = [
                        {
                            x: x,
                            y: y
                        },
                        {
                            x: x,
                            y: y + nodeHeight
                        },
                        {
                            x: x + nodeWidth,
                            y: y + nodeHeight
                        },
                        {
                            x: x + nodeWidth,
                            y: y
                        }
                    ];
                    acc.updatedNodes = acc.updatedNodes.concat([
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4adb2019d400d701$export$2e2bcd8739ae039), {
                            animation: animation,
                            className: "rv-treemap__leaf",
                            key: index,
                            color: color(node),
                            type: "literal",
                            onSeriesMouseEnter: onLeafMouseOver,
                            onSeriesMouseLeave: onLeafMouseOut,
                            onSeriesClick: onLeafClick,
                            data: data,
                            style: $07b9862a8a111d1d$var$_objectSpread($07b9862a8a111d1d$var$_objectSpread({}, style), node.style)
                        })
                    ]);
                    return acc;
                }, {
                    updatedNodes: [],
                    maxY: -Infinity,
                    minY: Infinity,
                    maxX: -Infinity,
                    minX: Infinity
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, className = _this$props3.className, height = _this$props3.height, mode = _this$props3.mode, nodes = _this$props3.nodes, width = _this$props3.width;
                var useCirclePacking = mode === "circlePack";
                var _ref = useCirclePacking ? this.getCircularNodes() : this.getNonCircularNodes(), minY = _ref.minY, maxY = _ref.maxY, minX = _ref.minX, maxX = _ref.maxX, updatedNodes = _ref.updatedNodes;
                var labels = nodes.reduce(function(acc, node) {
                    if (!node.data.title) return acc;
                    return acc.concat($07b9862a8a111d1d$var$_objectSpread($07b9862a8a111d1d$var$_objectSpread({}, node.data), {}, {
                        x: node.x0 || node.x,
                        y: node.y0 || node.y,
                        label: "".concat(node.data.title)
                    }));
                }, []);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70994359f4ceeef3$export$2e2bcd8739ae039), $07b9862a8a111d1d$var$_extends({
                    className: (0, $bc758dcd9beb6337$export$5eda8697d8fc9890)("rv-treemap", useCirclePacking && "rv-treemap-circle-paked", className),
                    width: width,
                    height: height,
                    yDomain: [
                        maxY,
                        minY
                    ],
                    xDomain: [
                        minX,
                        maxX
                    ],
                    colorType: "literal",
                    hasTreeStructure: true
                }, this.props), updatedNodes, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ce38b8b6c594605$export$2e2bcd8739ae039), {
                    data: labels
                }));
            }
        }
    ]);
    return TreemapSVG;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$07b9862a8a111d1d$var$TreemapSVG.displayName = "TreemapSVG";
var $07b9862a8a111d1d$export$2e2bcd8739ae039 = $07b9862a8a111d1d$var$TreemapSVG;


function $d20693cc3b726914$var$_extends() {
    $d20693cc3b726914$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d20693cc3b726914$var$_extends.apply(this, arguments);
}
function $d20693cc3b726914$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d20693cc3b726914$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d20693cc3b726914$var$ownKeys(Object(source), true).forEach(function(key) {
            $d20693cc3b726914$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d20693cc3b726914$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d20693cc3b726914$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d20693cc3b726914$var$TREEMAP_TILE_MODES = {
    squarify: (0, $b59b7ec66acd2122$export$2e2bcd8739ae039),
    resquarify: (0, $7d7ebb8fcbd38e77$export$2e2bcd8739ae039),
    slice: (0, $e510cc16795bdea9$export$2e2bcd8739ae039),
    dice: (0, $41d50c80388e33d8$export$2e2bcd8739ae039),
    slicedice: (0, $4cdb51c023cf32ea$export$2e2bcd8739ae039),
    binary: (0, $db77ef44c1b1abd6$export$2e2bcd8739ae039)
};
var $d20693cc3b726914$var$TREEMAP_LAYOUT_MODES = [
    "circlePack",
    "partition",
    "partition-pivot"
];
var $d20693cc3b726914$var$NOOP = function NOOP(d) {
    return d;
};
var $d20693cc3b726914$var$ATTRIBUTES = [
    "opacity",
    "color"
];
var $d20693cc3b726914$var$DEFAULT_MARGINS = {
    left: 40,
    right: 10,
    top: 10,
    bottom: 40
};
/**
 * Get the map of scale functions from the given props.
 * @param {Object} props Props for the component.
 * @returns {Object} Map of scale functions.
 * @private
 */ function $d20693cc3b726914$var$_getScaleFns(props) {
    var data = props.data;
    var allData = data.children || []; // Adding _allData property to the object to reuse the existing
    // getAttributeFunctor function.
    var compatibleProps = $d20693cc3b726914$var$_objectSpread($d20693cc3b726914$var$_objectSpread($d20693cc3b726914$var$_objectSpread({}, props), (0, $379b4f4f942d44ab$export$6b25e8934069fbf5)(props, allData, $d20693cc3b726914$var$ATTRIBUTES)), {}, {
        _allData: allData
    });
    return {
        opacity: (0, $379b4f4f942d44ab$export$735c878afad94f32)(compatibleProps, "opacity"),
        color: (0, $379b4f4f942d44ab$export$735c878afad94f32)(compatibleProps, "color")
    };
}
function $d20693cc3b726914$var$Treemap(props) {
    var scales = $d20693cc3b726914$var$_getScaleFns(props);
    var innerDimensions = (0, $a3dc0e1a1ee08269$export$72ee41b0ad150e05)(props, props.margin);
    /**
   * Create the list of nodes to render.
   * @returns {Array} Array of nodes.
   * @private
   */ function _getNodesToRender() {
        var innerWidth = innerDimensions.innerWidth, innerHeight = innerDimensions.innerHeight;
        var data = props.data, mode = props.mode, padding = props.padding, sortFunction = props.sortFunction, getSize = props.getSize;
        if (!data) return [];
        if (mode === "partition" || mode === "partition-pivot") {
            var partitionFunction = (0, $33157bf754db4825$export$2e2bcd8739ae039)().size(mode === "partition-pivot" ? [
                innerHeight,
                innerWidth
            ] : [
                innerWidth,
                innerHeight
            ]).padding(padding);
            var _structuredInput = (0, $9a60c0761eaba32b$export$2e2bcd8739ae039)(data).sum(getSize).sort(function(a, b) {
                return sortFunction(a, b, getSize);
            });
            var mappedNodes = partitionFunction(_structuredInput).descendants();
            if (mode === "partition-pivot") return mappedNodes.map(function(node) {
                return $d20693cc3b726914$var$_objectSpread($d20693cc3b726914$var$_objectSpread({}, node), {}, {
                    x0: node.y0,
                    x1: node.y1,
                    y0: node.x0,
                    y1: node.x1
                });
            });
            return mappedNodes;
        }
        if (mode === "circlePack") {
            var packingFunction = (0, $2c146828ae9cce7b$export$2e2bcd8739ae039)().size([
                innerWidth,
                innerHeight
            ]).padding(padding);
            var _structuredInput2 = (0, $9a60c0761eaba32b$export$2e2bcd8739ae039)(data).sum(getSize).sort(function(a, b) {
                return sortFunction(a, b, getSize);
            });
            return packingFunction(_structuredInput2).descendants();
        }
        var tileFn = $d20693cc3b726914$var$TREEMAP_TILE_MODES[mode];
        var treemapingFunction = (0, $eaa8edfadbfdf0f7$export$2e2bcd8739ae039)(tileFn).tile(tileFn).size([
            innerWidth,
            innerHeight
        ]).padding(padding);
        var structuredInput = (0, $9a60c0761eaba32b$export$2e2bcd8739ae039)(data).sum(getSize).sort(function(a, b) {
            return sortFunction(a, b, getSize);
        });
        return treemapingFunction(structuredInput).descendants();
    }
    var renderMode = props.renderMode;
    var nodes = _getNodesToRender();
    var TreemapElement = renderMode === "SVG" ? (0, $07b9862a8a111d1d$export$2e2bcd8739ae039) : (0, $56783b0467b18b29$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TreemapElement, $d20693cc3b726914$var$_extends({}, props, {
        nodes: nodes,
        scales: scales
    }));
}
$d20693cc3b726914$var$Treemap.displayName = "Treemap";
$d20693cc3b726914$var$Treemap.propTypes = {
    animation: (0, $d4808d8f8c60755d$export$c6290f21adf0a17a),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    hideRootNode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    margin: (0, $a3dc0e1a1ee08269$export$a2f0519a883a74de),
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf(Object.keys($d20693cc3b726914$var$TREEMAP_TILE_MODES).concat($d20693cc3b726914$var$TREEMAP_LAYOUT_MODES)),
    onLeafClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLeafMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLeafMouseOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    useCirclePacking: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    sortFunction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    getSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    getColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
$d20693cc3b726914$var$Treemap.defaultProps = {
    className: "",
    colorRange: (0, $d629c93f7b094ef1$export$36688c8ae3834bf8),
    _colorValue: (0, $d629c93f7b094ef1$export$37394b0fa44b998c),
    data: {
        children: []
    },
    hideRootNode: false,
    margin: $d20693cc3b726914$var$DEFAULT_MARGINS,
    mode: "squarify",
    onLeafClick: $d20693cc3b726914$var$NOOP,
    onLeafMouseOver: $d20693cc3b726914$var$NOOP,
    onLeafMouseOut: $d20693cc3b726914$var$NOOP,
    opacityType: (0, $d629c93f7b094ef1$export$dba5ca323c28272c),
    _opacityValue: (0, $d629c93f7b094ef1$export$95a809b606e7af75),
    padding: 1,
    sortFunction: function sortFunction(a, b, accessor) {
        if (!accessor) return 0;
        return accessor(a) - accessor(b);
    },
    getSize: function getSize(d) {
        return d.size;
    },
    getColor: function getColor(d) {
        return d.color;
    },
    getLabel: function getLabel(d) {
        return d.title;
    }
};
var $d20693cc3b726914$export$2e2bcd8739ae039 = $d20693cc3b726914$var$Treemap;



var $acw62 = parcelRequire("acw62");
function $9db77a13dcfc5316$export$2e2bcd8739ae039(props) {
    var _props$id = props.id, id = _props$id === void 0 ? "content-area" : _props$id, innerWidth = props.innerWidth, innerHeight = props.innerHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: 0,
        y: 0,
        width: innerWidth,
        height: innerHeight
    })));
}
$9db77a13dcfc5316$export$2e2bcd8739ae039.requiresSVG = true;
$9db77a13dcfc5316$export$2e2bcd8739ae039.displayName = "ContentClipPath";



var $acw62 = parcelRequire("acw62");
var $aa72d2e69fd2fe14$exports = {};
var $aa72d2e69fd2fe14$var$win;
if (typeof window !== "undefined") $aa72d2e69fd2fe14$var$win = window;
else if (typeof $parcel$global !== "undefined") $aa72d2e69fd2fe14$var$win = $parcel$global;
else if (typeof self !== "undefined") $aa72d2e69fd2fe14$var$win = self;
else $aa72d2e69fd2fe14$var$win = {};
$aa72d2e69fd2fe14$exports = $aa72d2e69fd2fe14$var$win;




function $bc22d0de933514dd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bc22d0de933514dd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bc22d0de933514dd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bc22d0de933514dd$var$_typeof(obj);
}
function $bc22d0de933514dd$var$_extends() {
    $bc22d0de933514dd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc22d0de933514dd$var$_extends.apply(this, arguments);
}
function $bc22d0de933514dd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bc22d0de933514dd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bc22d0de933514dd$var$ownKeys(Object(source), true).forEach(function(key) {
            $bc22d0de933514dd$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bc22d0de933514dd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bc22d0de933514dd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bc22d0de933514dd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bc22d0de933514dd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bc22d0de933514dd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bc22d0de933514dd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bc22d0de933514dd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bc22d0de933514dd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bc22d0de933514dd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bc22d0de933514dd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bc22d0de933514dd$var$_setPrototypeOf(subClass, superClass);
}
function $bc22d0de933514dd$var$_setPrototypeOf(o, p) {
    $bc22d0de933514dd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bc22d0de933514dd$var$_setPrototypeOf(o, p);
}
function $bc22d0de933514dd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bc22d0de933514dd$var$_isNativeReflectConstruct();
    return function() {
        var Super = $bc22d0de933514dd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bc22d0de933514dd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bc22d0de933514dd$var$_possibleConstructorReturn(this, result);
    };
}
function $bc22d0de933514dd$var$_possibleConstructorReturn(self, call) {
    if (call && ($bc22d0de933514dd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bc22d0de933514dd$var$_assertThisInitialized(self);
}
function $bc22d0de933514dd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bc22d0de933514dd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bc22d0de933514dd$var$_getPrototypeOf(o) {
    $bc22d0de933514dd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bc22d0de933514dd$var$_getPrototypeOf(o);
}
function $bc22d0de933514dd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $bc22d0de933514dd$var$CONTAINER_REF = "container"; // As a performance enhancement, we want to only listen once
var $bc22d0de933514dd$var$resizeSubscribers = [];
var $bc22d0de933514dd$var$DEBOUNCE_DURATION = 100;
var $bc22d0de933514dd$var$timeoutId = null;
/**
 * Calls each subscriber, debounced to the
 */ function $bc22d0de933514dd$var$debounceEmitResize() {
    (0, (/*@__PURE__*/$parcel$interopDefault($aa72d2e69fd2fe14$exports))).clearTimeout($bc22d0de933514dd$var$timeoutId);
    $bc22d0de933514dd$var$timeoutId = (0, (/*@__PURE__*/$parcel$interopDefault($aa72d2e69fd2fe14$exports))).setTimeout($bc22d0de933514dd$var$emitResize, $bc22d0de933514dd$var$DEBOUNCE_DURATION);
}
/**
 * Calls each subscriber once syncronously.
 */ function $bc22d0de933514dd$var$emitResize() {
    $bc22d0de933514dd$var$resizeSubscribers.forEach(function(cb) {
        return cb();
    });
}
/**
 * Add the given callback to the list of subscribers to be caled when the
 * window resizes. Returns a function that, when called, removes the given
 * callback from the list of subscribers. This function is also resposible for
 * adding and removing the resize listener on `window`.
 *
 * @param {Function} cb - Subscriber callback function
 * @returns {Function} Unsubscribe function
 */ function $bc22d0de933514dd$var$subscribeToDebouncedResize(cb) {
    $bc22d0de933514dd$var$resizeSubscribers.push(cb); // if we go from zero to one Flexible components instances, add the listener
    if ($bc22d0de933514dd$var$resizeSubscribers.length === 1) (0, (/*@__PURE__*/$parcel$interopDefault($aa72d2e69fd2fe14$exports))).addEventListener("resize", $bc22d0de933514dd$var$debounceEmitResize);
    return function unsubscribe() {
        $bc22d0de933514dd$var$removeSubscriber(cb); // if we have no Flexible components, remove the listener
        if ($bc22d0de933514dd$var$resizeSubscribers.length === 0) {
            (0, (/*@__PURE__*/$parcel$interopDefault($aa72d2e69fd2fe14$exports))).clearTimeout($bc22d0de933514dd$var$timeoutId);
            (0, (/*@__PURE__*/$parcel$interopDefault($aa72d2e69fd2fe14$exports))).removeEventListener("resize", $bc22d0de933514dd$var$debounceEmitResize);
        }
    };
}
/**
 * Helper for removing the given callback from the list of subscribers.
 *
 * @param {Function} cb - Subscriber callback function
 */ function $bc22d0de933514dd$var$removeSubscriber(cb) {
    var index = $bc22d0de933514dd$var$resizeSubscribers.indexOf(cb);
    if (index > -1) $bc22d0de933514dd$var$resizeSubscribers.splice(index, 1);
}
/**
 * Helper for getting a display name for the child component
 * @param {*} Component React class for the child component.
 * @returns {String} The child components name
 */ function $bc22d0de933514dd$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
/**
 * Add the ability to stretch the visualization on window resize.
 * @param {*} Component React class for the child component.
 * @returns {*} Flexible component.
 */ function $bc22d0de933514dd$var$makeFlexible(Component, isWidthFlexible, isHeightFlexible) {
    var _temp;
    var ResultClass = (_temp = /*#__PURE__*/ function(_React$Component) {
        $bc22d0de933514dd$var$_inherits(ResultClass, _React$Component);
        var _super = $bc22d0de933514dd$var$_createSuper(ResultClass);
        $bc22d0de933514dd$var$_createClass(ResultClass, null, [
            {
                key: "propTypes",
                get: function get() {
                    var _Component$propTypes = Component.propTypes, height = _Component$propTypes.height, width = _Component$propTypes.width, otherPropTypes = $bc22d0de933514dd$var$_objectWithoutProperties(_Component$propTypes, [
                        "height",
                        "width"
                    ]); // eslint-disable-line no-unused-vars
                    return otherPropTypes;
                }
            }
        ]);
        function ResultClass(props) {
            var _this;
            $bc22d0de933514dd$var$_classCallCheck(this, ResultClass);
            _this = _super.call(this, props);
            $bc22d0de933514dd$var$_defineProperty($bc22d0de933514dd$var$_assertThisInitialized(_this), "_onResize", function() {
                var containerElement = (0, $ddc583f274f25523$export$f39f755673ece9e2)(_this[$bc22d0de933514dd$var$CONTAINER_REF]);
                var offsetHeight = containerElement.offsetHeight, offsetWidth = containerElement.offsetWidth;
                var newHeight = _this.state.height === offsetHeight ? {} : {
                    height: offsetHeight
                };
                var newWidth = _this.state.width === offsetWidth ? {} : {
                    width: offsetWidth
                };
                _this.setState($bc22d0de933514dd$var$_objectSpread($bc22d0de933514dd$var$_objectSpread({}, newHeight), newWidth));
            });
            _this.state = {
                height: 0,
                width: 0
            };
            return _this;
        }
        /**
     * Get the width of the container and assign the width.
     * @private
     */ $bc22d0de933514dd$var$_createClass(ResultClass, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this._onResize();
                    this.cancelSubscription = $bc22d0de933514dd$var$subscribeToDebouncedResize(this._onResize);
                }
            },
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps() {
                    this._onResize();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.cancelSubscription();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var _this$state = this.state, height = _this$state.height, width = _this$state.width;
                    var props = $bc22d0de933514dd$var$_objectSpread($bc22d0de933514dd$var$_objectSpread({}, this.props), {}, {
                        animation: height === 0 && width === 0 ? null : this.props.animation
                    });
                    var updatedDimensions = $bc22d0de933514dd$var$_objectSpread($bc22d0de933514dd$var$_objectSpread({}, isHeightFlexible ? {
                        height: height
                    } : {}), isWidthFlexible ? {
                        width: width
                    } : {});
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        ref: function ref(_ref) {
                            return _this2[$bc22d0de933514dd$var$CONTAINER_REF] = _ref;
                        },
                        style: {
                            width: "100%",
                            height: "100%"
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, $bc22d0de933514dd$var$_extends({}, updatedDimensions, props)));
                }
            }
        ]);
        return ResultClass;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component), _temp);
    ResultClass.displayName = "Flexible".concat($bc22d0de933514dd$var$getDisplayName(Component));
    return ResultClass;
}
function $bc22d0de933514dd$export$d20d40f1152275a1(component) {
    return $bc22d0de933514dd$var$makeFlexible(component, false, true);
}
function $bc22d0de933514dd$export$67129624334086a0(component) {
    return $bc22d0de933514dd$var$makeFlexible(component, true, true);
}
function $bc22d0de933514dd$export$8458fffb4463e484(component) {
    return $bc22d0de933514dd$var$makeFlexible(component, true, false);
}
var $bc22d0de933514dd$export$84a1bb88981992cd = $bc22d0de933514dd$export$8458fffb4463e484((0, $70994359f4ceeef3$export$2e2bcd8739ae039));
var $bc22d0de933514dd$export$9c49d8b445af6424 = $bc22d0de933514dd$export$d20d40f1152275a1((0, $70994359f4ceeef3$export$2e2bcd8739ae039));
var $bc22d0de933514dd$export$b44c35abd28eeae1 = $bc22d0de933514dd$export$67129624334086a0((0, $70994359f4ceeef3$export$2e2bcd8739ae039));






const $10fc15889b75817b$var$FlexibleXYPlot = (0, $bc22d0de933514dd$export$67129624334086a0)((0, $70994359f4ceeef3$export$2e2bcd8739ae039));
const $10fc15889b75817b$var$style = {
    strokeWidth: 2,
    strokeRadius: "26px"
};
const $10fc15889b75817b$var$opacity = 1.0;
function $10fc15889b75817b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($10fc15889b75817b$var$FlexibleXYPlot, {
        xType: "ordinal",
        stackBy: "y",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d90e9abce593f78$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $700fae1910d27d13$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91c9e8a42ce6481e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b8afae0b4e13d5f$export$2e2bcd8739ae039), {
                tickFormat: (tickValue)=>{
                    const roundedTickValue = tickValue == Math.ceil(tickValue) ? tickValue : "";
                    return roundedTickValue.toLocaleString();
                }
            }),
            props.workflows.map((workflow)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb24d21727ab3f7c$export$2e2bcd8739ae039), {
                    stroke: "#22d3ee",
                    fill: "#06b6d4",
                    opacity: $10fc15889b75817b$var$opacity,
                    style: $10fc15889b75817b$var$style,
                    barWidth: workflow.gridSuccesses.length > 10 ? 0.98 : 0.3,
                    data: workflow.gridSuccesses ? workflow.gridSuccesses.data : [
                        {}
                    ]
                }, `${workflow.SK}-successes`)),
            props.workflows.map((workflow)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb24d21727ab3f7c$export$2e2bcd8739ae039), {
                    stroke: "#fdba74",
                    fill: "#fb923c",
                    opacity: $10fc15889b75817b$var$opacity,
                    style: $10fc15889b75817b$var$style,
                    barWidth: workflow.gridErrors.length > 10 ? 0.98 : 0.3,
                    data: workflow.gridErrors ? workflow.gridErrors.data : [
                        {}
                    ]
                }, `${workflow.SK}-warnings`))
        ]
    });
}



function $b43d88f90a4a45e7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-full mx-auto py-4 px-6 flex grow",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
            className: "text-lg leading-6 font-semibold text-gray-100",
            children: props.title
        })
    });
}




var $acw62 = parcelRequire("acw62");




function $26918d270ead469d$export$2e2bcd8739ae039(props) {
    const { post: post, response: response } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)((0, $15f24a665de742b6$export$2e2bcd8739ae039).url);
    (0, $acw62.useEffect)(()=>{
        if (props.updateBillingCustomer === true && !props.admin) updateCanceledAccount();
    }, [
        props.updateBillingCustomer,
        props.admin
    ]);
    const updateCanceledAccount = async ()=>{
        const account = props.selectedAccount || props.user.account;
        const body = {
            selectedAccount: account
        };
        const request = await post(`delete-customer/${account.customer.id}`, body);
        if (response.ok && request) window.location.href = "/workspaces";
    };
    const classNames = (...classes)=>{
        return classes.filter(Boolean).join(" ");
    };
    const setSelected = (selectedEnvironment)=>{
        props.setSelectedEnvironment(selectedEnvironment);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659), {
        value: props.selectedEnvironment,
        onChange: setSelected,
        children: ({ open: open })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mr-1 relative z-20 bg-gray-800",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $df20442161b20eb0$export$8bad31ff872c7659).Button, {
                        className: "text-xs text-cyan-400 bg-gray-700 align-middle relative w-44 border border-cyan-400 rounded-md shadow-sm pl-3 pr-2 py-2 text-left  cursor-default focus:outline-none focus:ring-1 focus:ring-cyan-300 focus:border-cyan-300 sm:text-xs",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "block align-middle text-xs",
                                children: props.selectedEnvironment?.name ? props.selectedEnvironment?.name?.substring(0, 20) : "Select Environment"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50e37a01dbc37e24$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-gray-200",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                        show: open,
                        as: (0, $acw62.Fragment),
                        leave: "transition ease-in duration-100",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659).Options, {
                            className: "align-middle bg-gray-700 absolute shadow-lg max-h-60 rounded-md py-1 text-gray-200 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-xs",
                            children: props?.selectedWorkspace?.environments.map((environment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659).Option, {
                                    value: environment,
                                    className: ({ active: active })=>classNames(active ? "text-white bg-cyan-400" : "text-white-600", "cursor-default select-none relative py-2 pl-3 pr-9"),
                                    children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    className: classNames(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                    children: [
                                                        environment.name.substring(2, 5) === "Dev" ? environment.name.substring(0, 3) : "",
                                                        environment.name.substring(0, 3) === "Pro" ? environment.name.substring(0, 3) : "",
                                                        environment.name.substring(2, 5) !== "Dev" && environment.name.substring(0, 3) !== "Pro" ? environment.name : ""
                                                    ]
                                                }),
                                                selected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: classNames(active ? "text-white" : "text-cyan-400", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1045181073ad00d2$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5",
                                                        "aria-hidden": "true"
                                                    })
                                                })
                                            ]
                                        })
                                }, environment.name))
                        })
                    })
                ]
            })
    });
}



var $45fvw = parcelRequire("45fvw");


function $2929016173b1249e$export$2e2bcd8739ae039(props) {
    const [workflows, setWorkflows] = (0, $acw62.useState)([]);
    const [shouldRender, setShouldRender] = (0, $acw62.useState)(false);
    const { post: post, response: response, loading: loading } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)();
    (0, $acw62.useEffect)(()=>{
        if (props.selectedWorkspace?.SK && props.selectedEnvironment?.SK) getWorkflows();
    }, [
        props.selectedEnvironment,
        props.selectedWorkspace
    ]);
    const getWorkflows = async ()=>{
        const body = {
            selectedWorkspace: props.selectedWorkspace,
            selectedEnvironment: props.selectedEnvironment
        };
        const workflowRequest = await post(`workflow/list-workflows/${props.user.attributes.id}`, body);
        if (response.ok && workflowRequest) {
            const workflows = typeof workflowRequest?.workflows != "undefined" ? workflowRequest.workflows : [];
            if (workflows) {
                workflows.map((workflow)=>{
                    workflow.events = workflow.events ? workflow.events.map((event)=>{
                        event.timestamp = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(event.timestamp).format("MM/DD/YYYY");
                        return event;
                    }) : [];
                    workflow.eventsByDay = workflow.events.length > 0 ? workflow.events.reduce(function(r, a) {
                        r[a.timestamp] = r[a.timestamp] || [];
                        r[a.timestamp].push(a);
                        return r;
                    }, Object.create(null)) : [];
                    workflow.dailySuccesses = 0;
                    workflow.dailyErrors = 0;
                    workflow.gridSuccesses = {};
                    workflow.gridSuccesses.data = [];
                    workflow.gridErrors = {};
                    workflow.gridErrors.data = [];
                });
                workflows.map((workflow)=>{
                    Object.entries(workflow.eventsByDay).map((flow)=>{
                        flow.filter((day)=>{
                            const successes = flow[1].filter((day)=>day.type === "L-202");
                            const tErrors = flow[1].filter((day)=>day.type === "T-111");
                            const errors = flow[1].filter((day)=>day.type === "L-222");
                            const dailyErrors = errors.length + tErrors.length;
                            const params = {
                                x: flow[0],
                                y: successes.length
                            };
                            const eerams = {
                                x: flow[0],
                                y: dailyErrors
                            };
                            if (successes.length) workflow.gridSuccesses.data.push(params);
                            if (dailyErrors) workflow.gridErrors.data.push(eerams);
                        });
                    });
                    const RemoveDuplicates = (array, key)=>{
                        return array.reduce((arr, item)=>{
                            const removed = arr.filter((i)=>i[key] !== item[key]);
                            return [
                                ...removed,
                                item
                            ];
                        }, []);
                    };
                    workflow.gridSuccesses.data = RemoveDuplicates(workflow.gridSuccesses.data, "x");
                    workflow.gridErrors.data = RemoveDuplicates(workflow.gridErrors.data, "x");
                    workflow.gridSuccesses.data.sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(a.x).format("YYYYMMDD") > (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(b.x).format("YYYYMMDD") ? -1 : 1);
                    workflow.gridErrors.data.sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(a.x).format("YYYYMMDD") > (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(b.x).format("YYYYMMDD") ? -1 : 1);
                });
                if (workflows[0] && workflows[0].gridSuccesses.data.length > 0) setShouldRender(true);
                else setShouldRender(false);
                setWorkflows(workflows);
            } else {
                setWorkflows([]);
                setShouldRender(false);
            }
        } else {
            setWorkflows([]);
            setShouldRender(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-gray-800 shadow-sm pr-4 min-w-0 md:flex md:items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b43d88f90a4a45e7$export$2e2bcd8739ae039), {
                        className: "inline",
                        title: "Dashboard"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex",
                        children: props?.selectedWorkspace?.environments && props?.selectedWorkspace?.environments.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26918d270ead469d$export$2e2bcd8739ae039), {
                            user: props.user,
                            account: props.account,
                            admin: props.admin,
                            environments: props.environments,
                            selectedWorkspace: props.selectedWorkspace,
                            updateBillingCustomer: props.updateBillingCustomer,
                            selectedEnvironment: props.selectedEnvironment,
                            selectedAccount: props.selectedAccount,
                            setSelectedEnvironment: props.setSelectedEnvironment,
                            logout: props.logout
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "my-4 bg-gray-700 mx-4 pb-8 pt-2 px-4 border-2 border-cyan-300 rounded",
                style: {
                    height: "72vh"
                },
                children: [
                    loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "justify-center items-center pt-12 sm:pt-12 md:pt-24 lg:pt-32 xl:pt-48",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "items-center animate-pulse",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    className: "h-24 mx-auto w-auto",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                    alt: "Logo"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    className: "mt-0 text-center text-2xl font-bold text-gray-200",
                                    children: [
                                        "Retrohook",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1",
                                            children: "beta"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-lg mb-2 text-gray-100",
                        children: "Recent Transactions"
                    }),
                    shouldRender ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10fc15889b75817b$export$2e2bcd8739ae039), {
                        workflows: workflows
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                    !shouldRender && !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "text-center text-gray-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-2xl sm:pt-14 md:pt-24 lg:pt-32",
                                children: [
                                    "Hi ",
                                    props.user.account.first,
                                    ", Welcome to Retrohook!"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-md py-1",
                                children: "This environment doesn't have any transactions... Ready to create your first workflow? Click the Workflows tab above. New here and unsure how to build a Workflow? Check out our step-by-step guides at the top or chat with us (the little conversation in the bottom right corner)."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ 

var $acw62 = parcelRequire("acw62");
var $6e5adace1676779e$exports = {};

$6e5adace1676779e$exports = (parcelRequire("2iRJw"));






function $fa6002d268f58925$export$2e2bcd8739ae039(props) {
    let Icon = null;
    if (props.icon) Icon = props.icon;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "mx-1",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            onClick: ()=>props.clickHandler(),
            className: "inline text-gray-200 whitespace-nowrap w-full items-center px-2 py-2 border text-xs font-medium rounded shadow-sm hover:text-cyan-800 bg-gray-700 border-cyan-400 hover:border-cyan-300 hover:bg-cyan-400 focus:outline-none",
            children: props.title
        })
    });
}



function $1e3f88f35ab51eb8$export$2e2bcd8739ae039(props) {
    let Icon = null;
    if (props.icon) Icon = props.icon;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "px-1",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            onClick: ()=>props.clickHandler(),
            className: "inline whitespace-nowrap w-full items-center px-2 py-2 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-cyan-400 hover:bg-cyan-300 focus:outline-none",
            children: props.title
        })
    });
}



var $acw62 = parcelRequire("acw62");
function $d7f345ed8ee9ab7d$var$ArrowLeftIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
    }));
}
const $d7f345ed8ee9ab7d$var$ForwardRef = $acw62.forwardRef($d7f345ed8ee9ab7d$var$ArrowLeftIcon);
var $d7f345ed8ee9ab7d$export$2e2bcd8739ae039 = $d7f345ed8ee9ab7d$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $87ac0ef7b9ff9243$var$InboxArrowDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 3.75H6.912a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859M12 3v8.25m0 0l-3-3m3 3l3-3"
    }));
}
const $87ac0ef7b9ff9243$var$ForwardRef = $acw62.forwardRef($87ac0ef7b9ff9243$var$InboxArrowDownIcon);
var $87ac0ef7b9ff9243$export$2e2bcd8739ae039 = $87ac0ef7b9ff9243$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $0a978d9c72df0c47$var$MapIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"
    }));
}
const $0a978d9c72df0c47$var$ForwardRef = $acw62.forwardRef($0a978d9c72df0c47$var$MapIcon);
var $0a978d9c72df0c47$export$2e2bcd8739ae039 = $0a978d9c72df0c47$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $c8330361804a067d$var$RectangleStackIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122"
    }));
}
const $c8330361804a067d$var$ForwardRef = $acw62.forwardRef($c8330361804a067d$var$RectangleStackIcon);
var $c8330361804a067d$export$2e2bcd8739ae039 = $c8330361804a067d$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $9e73f507bb05d0c8$var$ShareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"
    }));
}
const $9e73f507bb05d0c8$var$ForwardRef = $acw62.forwardRef($9e73f507bb05d0c8$var$ShareIcon);
var $9e73f507bb05d0c8$export$2e2bcd8739ae039 = $9e73f507bb05d0c8$var$ForwardRef;




var $acw62 = parcelRequire("acw62");
const $b4316710b51aa803$var$DropdownButton = (props)=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative inline-block text-left",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                type: "button",
                onClick: ()=>setIsOpen(!isOpen),
                className: "inline-flex justify-center w-full px-4 py-1.5 text-sm font-medium text-gray-200 bg-gray-700 rounded border border-gray-300 shadow-sm hover:bg-gray-600 focus:outline-none",
                children: [
                    props.label,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                        className: "ml-2 -mr-1 h-5 w-5",
                        fill: "currentColor",
                        viewBox: "0 0 20 20",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                            clipRule: "evenodd"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute right-0 z-10 mt-2 w-56 origin-top-right rounded shadow-lg bg-white ring-1 ring-black ring-opacity-5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "py-1",
                    role: "menu",
                    "aria-orientation": "vertical",
                    "aria-labelledby": "options-menu",
                    children: props.options.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>{
                                option.action();
                                setIsOpen(false);
                            },
                            className: "block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
                            children: option.label
                        }, index))
                })
            })
        ]
    });
};
var $b4316710b51aa803$export$2e2bcd8739ae039 = $b4316710b51aa803$var$DropdownButton;


function $b57ad665d45a6002$export$2e2bcd8739ae039(props) {
    const saveOptions = [
        // {
        //   label: props.workflow?.PK ? "Update Template" : "Create Template",
        //   action: props.saveTemplate,
        // },
        {
            label: props.workflow?.PK ? "Update Workflow" : "Create Workflow",
            action: props.saveWorkflow
        }
    ];
    const createOptions = [
        // {
        //   label: "Create Template",
        //   action: props.saveTemplate,
        // },
        {
            label: "Create Workflow",
            action: props.saveWorkflow
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-gray-800 shadow-sm min-w-0 flex",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full m-3 flex justify-end",
            children: [
                props.ux == "adapters" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e3f88f35ab51eb8$export$2e2bcd8739ae039), {
                    title: "Details",
                    icon: (0, $c8330361804a067d$export$2e2bcd8739ae039),
                    clickHandler: ()=>props.adapterClickHandler()
                }),
                props.ux != "adapters" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa6002d268f58925$export$2e2bcd8739ae039), {
                    title: "Details",
                    icon: (0, $c8330361804a067d$export$2e2bcd8739ae039),
                    clickHandler: ()=>props.adapterClickHandler()
                }),
                props.ux == "e-layer" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e3f88f35ab51eb8$export$2e2bcd8739ae039), {
                    title: "Extract",
                    icon: (0, $87ac0ef7b9ff9243$export$2e2bcd8739ae039),
                    clickHandler: ()=>props.eventTriggerClickHandler()
                }),
                props.ux != "e-layer" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa6002d268f58925$export$2e2bcd8739ae039), {
                    title: "Extract",
                    icon: (0, $87ac0ef7b9ff9243$export$2e2bcd8739ae039),
                    clickHandler: ()=>props.eventTriggerClickHandler()
                }),
                props.ux == "t-layer" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e3f88f35ab51eb8$export$2e2bcd8739ae039), {
                    title: "Transform",
                    icon: (0, $0a978d9c72df0c47$export$2e2bcd8739ae039),
                    clickHandler: ()=>props.mapClickHandler()
                }),
                props.ux != "t-layer" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa6002d268f58925$export$2e2bcd8739ae039), {
                    title: "Transform",
                    icon: (0, $0a978d9c72df0c47$export$2e2bcd8739ae039),
                    clickHandler: ()=>props.mapClickHandler()
                }),
                props.ux == "l-layer" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e3f88f35ab51eb8$export$2e2bcd8739ae039), {
                    title: "Load",
                    icon: (0, $9e73f507bb05d0c8$export$2e2bcd8739ae039),
                    clickHandler: ()=>props.loadClickHandler()
                }),
                props.ux != "l-layer" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa6002d268f58925$export$2e2bcd8739ae039), {
                    title: "Load",
                    icon: (0, $9e73f507bb05d0c8$export$2e2bcd8739ae039),
                    clickHandler: ()=>props.loadClickHandler()
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: "border-left border-2 mx-2 border-pink-500"
                }),
                props.workflow?.sampleMessage && !props.workflow?.PK && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4316710b51aa803$export$2e2bcd8739ae039), {
                    label: "Create",
                    options: createOptions
                }),
                props.workflow?.PK && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4316710b51aa803$export$2e2bcd8739ae039), {
                    label: "Save",
                    options: saveOptions
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa6002d268f58925$export$2e2bcd8739ae039), {
                    icon: (0, $d7f345ed8ee9ab7d$export$2e2bcd8739ae039),
                    title: "Close",
                    clickHandler: ()=>props.backToListClickHandler()
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $71e8a6505151d83e$var$ArrowUpCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $71e8a6505151d83e$var$ForwardRef = $acw62.forwardRef($71e8a6505151d83e$var$ArrowUpCircleIcon);
var $71e8a6505151d83e$export$2e2bcd8739ae039 = $71e8a6505151d83e$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $4420ab78738183cd$var$BoltIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"
    }));
}
const $4420ab78738183cd$var$ForwardRef = $acw62.forwardRef($4420ab78738183cd$var$BoltIcon);
var $4420ab78738183cd$export$2e2bcd8739ae039 = $4420ab78738183cd$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $898ede00ff16e210$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $898ede00ff16e210$var$ForwardRef = $acw62.forwardRef($898ede00ff16e210$var$CheckCircleIcon);
var $898ede00ff16e210$export$2e2bcd8739ae039 = $898ede00ff16e210$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $b99b9002c387c378$var$CloudArrowUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
    }));
}
const $b99b9002c387c378$var$ForwardRef = $acw62.forwardRef($b99b9002c387c378$var$CloudArrowUpIcon);
var $b99b9002c387c378$export$2e2bcd8739ae039 = $b99b9002c387c378$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $9fd1e14524d129fb$var$CloudIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z"
    }));
}
const $9fd1e14524d129fb$var$ForwardRef = $acw62.forwardRef($9fd1e14524d129fb$var$CloudIcon);
var $9fd1e14524d129fb$export$2e2bcd8739ae039 = $9fd1e14524d129fb$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $57da1d31b0abcf49$var$CodeBracketIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
    }));
}
const $57da1d31b0abcf49$var$ForwardRef = $acw62.forwardRef($57da1d31b0abcf49$var$CodeBracketIcon);
var $57da1d31b0abcf49$export$2e2bcd8739ae039 = $57da1d31b0abcf49$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $ca6349d0f67ac97f$var$ExclamationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
    }));
}
const $ca6349d0f67ac97f$var$ForwardRef = $acw62.forwardRef($ca6349d0f67ac97f$var$ExclamationCircleIcon);
var $ca6349d0f67ac97f$export$2e2bcd8739ae039 = $ca6349d0f67ac97f$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $fc1405939c84d0e6$var$SparklesIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
    }));
}
const $fc1405939c84d0e6$var$ForwardRef = $acw62.forwardRef($fc1405939c84d0e6$var$SparklesIcon);
var $fc1405939c84d0e6$export$2e2bcd8739ae039 = $fc1405939c84d0e6$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $8253a6dc03e7662d$var$SquaresPlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v2.25A2.25 2.25 0 006 10.5zm0 9.75h2.25A2.25 2.25 0 0010.5 18v-2.25a2.25 2.25 0 00-2.25-2.25H6a2.25 2.25 0 00-2.25 2.25V18A2.25 2.25 0 006 20.25zm9.75-9.75H18a2.25 2.25 0 002.25-2.25V6A2.25 2.25 0 0018 3.75h-2.25A2.25 2.25 0 0013.5 6v2.25a2.25 2.25 0 002.25 2.25z"
    }));
}
const $8253a6dc03e7662d$var$ForwardRef = $acw62.forwardRef($8253a6dc03e7662d$var$SquaresPlusIcon);
var $8253a6dc03e7662d$export$2e2bcd8739ae039 = $8253a6dc03e7662d$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $0682b19766de6cfd$var$VariableIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.745 3A23.933 23.933 0 003 12c0 3.183.62 6.22 1.745 9M19.5 3c.967 2.78 1.5 5.817 1.5 9s-.533 6.22-1.5 9M8.25 8.885l1.444-.89a.75.75 0 011.105.402l2.402 7.206a.75.75 0 001.104.401l1.445-.889m-8.25.75l.213.09a1.687 1.687 0 002.062-.617l4.45-6.676a1.688 1.688 0 012.062-.618l.213.09"
    }));
}
const $0682b19766de6cfd$var$ForwardRef = $acw62.forwardRef($0682b19766de6cfd$var$VariableIcon);
var $0682b19766de6cfd$export$2e2bcd8739ae039 = $0682b19766de6cfd$var$ForwardRef;




var $45fvw = parcelRequire("45fvw");
/* This example requires Tailwind CSS v2.0+ */ 

var $acw62 = parcelRequire("acw62");
function $aba60e8ad9fe6a73$var$ExclamationTriangleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
    }));
}
const $aba60e8ad9fe6a73$var$ForwardRef = $acw62.forwardRef($aba60e8ad9fe6a73$var$ExclamationTriangleIcon);
var $aba60e8ad9fe6a73$export$2e2bcd8739ae039 = $aba60e8ad9fe6a73$var$ForwardRef;


function $90ad1604a43044d7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-md bg-yellow-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba60e8ad9fe6a73$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-yellow-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-medium text-yellow-800",
                        children: "Sorry, please upgrade your account to add another workflow."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mx-1.5 -my-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: ()=>{
                                props.closeProdRequiredAlert();
                            },
                            type: "button",
                            className: "inline-flex bg-yellow-50 rounded-md p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Dismiss"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}




function $d6a36e5609e6fa8c$export$2e2bcd8739ae039(props) {
    let Icon = null;
    if (props.icon) Icon = props.icon;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "px-1",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            onClick: ()=>props.clickHandler(),
            className: "inline whitespace-nowrap w-full items-center p-2 border text-xs font-medium rounded shadow-sm text-white bg-cyan-400 hover:text-white border-cyan-400 hover:border-cyan-500 hover:bg-cyan-300 focus:outline-none",
            children: props.title
        })
    });
}


/**
 * The ConfirmModal component is a reusable modal dialog box that displays a confirmation message with
 * a title and message, and provides options to cancel or confirm an action.
 * @param  - 1. `isOpen` - a boolean value indicating whether the modal is open or not.
 * @returns The ConfirmModal component is being returned.
 */ 


function $53dccccfeb3e8d8d$export$2e2bcd8739ae039({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm, title: title, message: message }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
        open: isOpen,
        onClose: onClose,
        className: "relative z-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 bg-gray-900/80",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 flex items-center justify-center p-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Panel, {
                    className: "mx-auto max-w-sm rounded animate-color-change-2x border-pink-400 border-2 p-6 shadow-xl",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca6349d0f67ac97f$export$2e2bcd8739ae039), {
                            className: "inline h-10 w-10 text-pink-400",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Title, {
                            className: "inline pl-2 text-lg font-medium text-pink-400",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Description, {
                            className: "text-sm text-gray-200",
                            children: message
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-4 flex justify-end space-x-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "rounded bg-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-300",
                                    onClick: onClose,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "rounded bg-pink-600 px-4 py-2 text-sm text-white hover:bg-pink-400",
                                    onClick: onConfirm,
                                    children: "I'm sure!"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


function $60b9d21ed85a25dc$export$2e2bcd8739ae039(props) {
    const { post: post, response: response, loading: loading } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)((0, $15f24a665de742b6$export$2e2bcd8739ae039).url);
    const [workflows, setWorkflows] = (0, $acw62.useState)([]);
    const [selectedFlow, setSelectedFlow] = (0, $acw62.useState)({
        events: [],
        flowName: "",
        SK: "",
        environment: ""
    });
    const [showAccessAlert, setShowAccessAlert] = (0, $acw62.useState)(false);
    const [currentWorkflow, setCurrentWorkflow] = (0, $acw62.useState)({
        flowName: ""
    });
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const [selectedEnvironment, setSelectedEnvironment] = (0, $acw62.useState)(props.selectedEnvironment);
    const [selectedWorkspace, setSelectedWorkspace] = (0, $acw62.useState)(props.selectedWorkspace);
    (0, $acw62.useEffect)(()=>{
        console.dir(props.selectedEnvironment.name);
        setSelectedEnvironment(props.selectedEnvironment);
        setSelectedWorkspace(props.selectedWorkspace);
        getWorkflows();
    }, [
        JSON.stringify(props.selectedWorkspace),
        JSON.stringify(props.SelectedEnvironment)
    ]);
    const updateEnvironment = (env)=>{
        setSelectedEnvironment(env);
        props.setSelectedEnvironment(env);
        getWorkflows();
    };
    const getWorkflows = async ()=>{
        const body = {
            selectedWorkspace: selectedWorkspace,
            selectedEnvironment: selectedEnvironment
        };
        if (!body.selectedEnvironment) return;
        const workflowsRequest = await post(`workflow/list-workflows/${props.user.attributes.id}`, body);
        if (response.ok && workflowsRequest) {
            const workflows = workflowsRequest.workflows.filter((workflow)=>{
                if (workflow?.workspace?.SK == selectedWorkspace.SK || workflow?.workspaceId == selectedWorkspace.SK) return workflow;
            });
            setWorkflows(workflows ? workflows : []);
        } else setWorkflows([]);
    };
    const closeProdRequiredAlert = ()=>{
        setShowAccessAlert(false);
    };
    const canDelete = ()=>{
        const hasUpdateWorkflowInSelectedWorkspace = selectedWorkspace.accounts.filter((account)=>{
            if (account.PK && account.permissions.workflows.delete) return account;
        });
        const isWorkspaceOwner = selectedWorkspace.owner.email === props.user.account.email;
        if (props.admin === true || hasUpdateWorkflowInSelectedWorkspace.length || isWorkspaceOwner) return true;
        return false;
    };
    /**
   * The function `editFlow` is an asynchronous function that takes a `flow` parameter and calls the
   * `loadWorkflow` function from the `props` object with the `flow` parameter.
   * @param {any} flow - The `flow` parameter is an object that represents a workflow.
   */ const editFlow = async (flow)=>{
        await props.loadWorkflow(flow);
    };
    /**
   * The function `deleteWorkflow` deletes a workflow if the user has permission and updates the list
   * of workflows.
   * @param {any} flow - The `flow` parameter is an object that represents a workflow. It is passed to
   * the `deleteWorkflow` function to specify which workflow should be deleted.
   */ const deleteWorkflow = async (flow)=>{
        if (canDelete()) {
            const body = {
                selected: selectedEnvironment,
                flow: flow
            };
            const deleteRequest = await post(`workflow/delete-workflow/${props.user.attributes.id}`, body);
            if (response.ok && deleteRequest) await getWorkflows();
        }
    };
    /**
   * The function `openModal` sets the current tunnel and opens a modal.
   * @param {any} tunnel - The `tunnel` parameter is of type `any`, which means it can accept any data
   * type.
   */ const openModal = (workflow)=>{
        setCurrentWorkflow(workflow);
        setIsModalOpen(true);
    };
    /**
  * The closeModal function sets the state variable isModalOpen to false.
  */ const closeModal = ()=>{
        setIsModalOpen(false);
    };
    /**
   * The function `confirmDelete` deletes a stack in the current environment and closes a modal.
   */ const confirmDelete = ()=>{
        deleteWorkflow(currentWorkflow);
        closeModal();
    };
    const viewEvents = (flow)=>{
        if (flow.events) {
            flow.events.map((event)=>{
                if (event.type === "T-101" || event.type === 101) event.icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0682b19766de6cfd$export$2e2bcd8739ae039), {
                    className: "rounded-lg h-8 w-8 bg-cyan-300 text-gray-100",
                    "aria-hidden": "true"
                });
                if (event.type === "T-111") event.icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0682b19766de6cfd$export$2e2bcd8739ae039), {
                    className: "rounded-lg h-8 w-8 bg-orange-500 text-gray-100",
                    "aria-hidden": "true"
                });
                if (event.type === "T-102" || event.type === 102) event.icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1405939c84d0e6$export$2e2bcd8739ae039), {
                    className: "rounded-lg h-8 w-8 bg-cyan-300 text-cyan-200",
                    "aria-hidden": "true"
                });
                if (event.type === "L-201" || event.type === 201) event.icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b99b9002c387c378$export$2e2bcd8739ae039), {
                    className: "rounded-lg h-8 w-8 bg-cyan-300 text-gray-100",
                    "aria-hidden": "true"
                });
                if (event.type === "L-202" || event.type === 202) event.icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fd1e14524d129fb$export$2e2bcd8739ae039), {
                    className: "rounded-lg h-8 w-8 bg-cyan-300 text-cyan-200",
                    "aria-hidden": "true"
                });
                if (event.type === "C-001") event.icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $898ede00ff16e210$export$2e2bcd8739ae039), {
                    className: "rounded-lg h-8 w-8 bg-cyan-300 text-white",
                    "aria-hidden": "true"
                });
                if (event.type === "U-001") event.icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57da1d31b0abcf49$export$2e2bcd8739ae039), {
                    className: "rounded-lg h-8 w-8 bg-cyan-300 text-white",
                    "aria-hidden": "true"
                });
            });
            setSelectedFlow(flow);
        }
    };
    if (!props.selectedWorkspace.PK) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "card",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "card-body text-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "display-4",
                                    children: "No Workspace Selected"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "lead",
                                    children: "Please select a workspace from the dropdown above."
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
    if (selectedWorkspace && selectedEnvironment) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            !selectedFlow.SK && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "bg-gray-800 shadow-sm pr-4 min-w-0 md:flex md:items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b43d88f90a4a45e7$export$2e2bcd8739ae039), {
                                title: "Workflows"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex w-full justify-end",
                                children: [
                                    selectedWorkspace.environments.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26918d270ead469d$export$2e2bcd8739ae039), {
                                        user: props.user,
                                        account: props.account,
                                        admin: props.admin,
                                        setShowEnvironmentDropdown: props.setShowEnvironmentDropdown,
                                        environments: props.environments,
                                        selectedWorkspace: selectedWorkspace,
                                        updateBillingCustomer: props.updateBillingCustomer,
                                        selectedEnvironment: selectedEnvironment,
                                        selectedAccount: props.selectedAccount,
                                        setSelectedEnvironment: updateEnvironment,
                                        logout: props.logout
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6a36e5609e6fa8c$export$2e2bcd8739ae039), {
                                        title: "Create",
                                        icon: (0, $8253a6dc03e7662d$export$2e2bcd8739ae039),
                                        clickHandler: ()=>{
                                            props.newWorkflowClickHandler();
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    showAccessAlert && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90ad1604a43044d7$export$2e2bcd8739ae039), {
                        closeProdRequiredAlert: closeProdRequiredAlert
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53dccccfeb3e8d8d$export$2e2bcd8739ae039), {
                        isOpen: isModalOpen,
                        onClose: closeModal,
                        onConfirm: ()=>confirmDelete(),
                        title: "Confirm Delete Workflow",
                        message: `Are you sure you want to delete ${currentWorkflow?.flowName}?`
                    }),
                    !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-5 px-4 grid gap-2 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4",
                        children: [
                            workflows.length < 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-2xl sm:col-span-1 md:col-span-2 lg:col-span-3 xl:col-span-3 2xl:col-span text-center text-gray-300",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "You don't have any workflows in this workspace environment."
                                })
                            }),
                            workflows?.map((flow)=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative text-gray-200 bg-gray-800 pt-3 px-3 pb-8 sm:pt-3 sm:px-3 rounded-lg overflow-hidden hover:border-cyan-300 border-2 border-gray-600",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mb-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dt", {
                                                    children: [
                                                        flow.icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "absolute rounded-md pt-1",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(flow.icon, {
                                                                className: "h-8 w-8 text-gray-50 bg-cyan-400 rounded p-1 ring-1 ring-cyan-500 ring-offset-1 ring-offset-cyan-200"
                                                            })
                                                        }),
                                                        !flow.icon && flow.environment?.name.substring(0, 3) != "Dev" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "absolute rounded-md pt-1",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4420ab78738183cd$export$2e2bcd8739ae039), {
                                                                className: "h-8 w-8 text-gray-50 bg-cyan-400 rounded p-1 ring-1 ring-cyan-500 ring-offset-1 ring-offset-cyan-200"
                                                            })
                                                        }),
                                                        !flow.icon && flow.environment?.name.substring(0, 3) == "Dev" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "absolute rounded-md pt-1",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4420ab78738183cd$export$2e2bcd8739ae039), {
                                                                className: "h-8 w-8 text-gray-50 bg-gray-500 rounded p-1 ring-1 ring-gray-600 ring-offset-1 ring-offset-gray-300"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "cursor-pointer pl-10 mr-5",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                onClick: ()=>{
                                                                    editFlow(flow);
                                                                },
                                                                className: "text-3xl font-semibold text-gray-200 truncate pr-2",
                                                                children: [
                                                                    " ",
                                                                    flow.flowName,
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "absolute top-0 right-0 m-2 border-gray-500 border hover:bg-orange-500 hover:text-white hover:border-orange-500 text-gray-500 font-bold text-xs py-1 px-2 rounded focus:outline-none focus:shadow-outline",
                                                            onClick: ()=>{
                                                                openModal(flow);
                                                            },
                                                            children: "X"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dd", {
                                                    className: "absolute top-9 right-2 pl-2 flex items-baseline",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xl font-semibold text-cyan-300",
                                                            children: flow.successes
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "ml-0 flex text-xs pr-2 border-r-gray-500 border-r-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71e8a6505151d83e$export$2e2bcd8739ae039), {
                                                                className: "self-center flex-shrink-0 h-5 w-5 pt-1 text-cyan-300",
                                                                "aria-hidden": "true"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xl ml-0 font-semibold text-gray-300 pl-2",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "text-xl font-semibold text-orange-500",
                                                                children: [
                                                                    " ",
                                                                    flow.failures
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "ml-0 flex text-xs align-base",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca6349d0f67ac97f$export$2e2bcd8739ae039), {
                                                                className: "self-center pt-1 flex-shrink-0 h-5 w-5 text-orange-500",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-xs ml-0 pl-0 mt-2 w-3/4 pr-1 text-gray-200 truncate",
                                                    children: [
                                                        flow.trigger.type.toUpperCase(),
                                                        " -> \xa0",
                                                        flow.next.type
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-xs ml-0 pl-0 mb-2 mt-0.5 w-3/4 pr-1 text-gray-200 truncate",
                                                    children: [
                                                        "Capture Formula:\xa0",
                                                        Object.entries(flow.trigger.custom).map(([key, value], i)=>{
                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "border rounded-sm bg-gray-600 border-pink-400 px-0.5",
                                                                        children: key
                                                                    }),
                                                                    i < Object.keys(flow.trigger.custom).length - 1 ? " + " : ""
                                                                ]
                                                            }, key);
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "absolute bottom-0 inset-x-0 bg-gray-600 px-4 py-2 sm:px-6",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-sm text-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    className: "font-medium text-gray-200 hover:text-cyan-300",
                                                    onClick: ()=>{
                                                        viewEvents(flow);
                                                    },
                                                    children: [
                                                        "Latest Events",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                            className: "sr-only",
                                                            children: [
                                                                " ",
                                                                flow.flowName,
                                                                " events"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }, flow.SK);
                            })
                        ]
                    })
                ]
            }),
            selectedFlow.SK && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "bg-gray-900 shadow-sm pr-4 min-w-0 md:flex md:items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b43d88f90a4a45e7$export$2e2bcd8739ae039), {
                                className: "inline",
                                title: `${selectedFlow.flowName} Event History`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex min-w-2 grow-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "inline",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            setSelectedFlow({
                                                events: [],
                                                flowName: "",
                                                SK: "",
                                                environment: ""
                                            });
                                        },
                                        className: "items-center px-4 py-2 border border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-200 bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300",
                                        children: "Back"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                        className: "overflow:scroll my-6 pb-6 lg:mx-64 sm:px-2 md:mx-24 mx-24 px-12 bg-gray-800 border rounded-md",
                        children: [
                            !selectedFlow.events && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-center text-gray-200 text-xl py-24",
                                children: "Events will start appearing when messages are processed by this workflow."
                            }),
                            selectedFlow?.events.sort((a, b)=>a.timestamp < b.timestamp ? 1 : -1).map((event)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "relative py-4 mx-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-600",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "relative flex space-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-gray-600",
                                                            children: event.icon
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "min-w-0 flex-1 pt-1.5 flex justify-between space-x-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-sm pl-2 text-gray-300",
                                                                    children: [
                                                                        event.message,
                                                                        " "
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-sm whitespace-nowrap text-gray-500",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("time", {
                                                                    dateTime: event.timestamp,
                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(event.timestamp).format("dddd, MMMM Do YYYY, h:mm:ss a")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, event.id))
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $1e8b85dad31c9fca$var$InformationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
    }));
}
const $1e8b85dad31c9fca$var$ForwardRef = $acw62.forwardRef($1e8b85dad31c9fca$var$InformationCircleIcon);
var $1e8b85dad31c9fca$export$2e2bcd8739ae039 = $1e8b85dad31c9fca$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $beefe28644f6e8ce$var$TrashIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    }));
}
const $beefe28644f6e8ce$var$ForwardRef = $acw62.forwardRef($beefe28644f6e8ce$var$TrashIcon);
var $beefe28644f6e8ce$export$2e2bcd8739ae039 = $beefe28644f6e8ce$var$ForwardRef;


/* This example requires Tailwind CSS v2.0+ */ 

function $7487cac41146e5bd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-md bg-yellow-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba60e8ad9fe6a73$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-yellow-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-medium text-yellow-800",
                        children: "Sorry, You cannot share workflows just yet."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mx-1.5 -my-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: ()=>{
                                props.closeAlert();
                            },
                            type: "button",
                            className: "inline-flex bg-yellow-50 rounded-md p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Dismiss"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/* This example requires Tailwind CSS v2.0+ */ 

function $594d3d8da33b1e4a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-md bg-yellow-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba60e8ad9fe6a73$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-yellow-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-medium text-yellow-800",
                        children: "Sorry, you do not have permissions to do that."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mx-1.5 -my-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: ()=>{
                                props.closeAlert();
                            },
                            type: "button",
                            className: "inline-flex bg-yellow-50 rounded-md p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Dismiss"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/* This example requires Tailwind CSS v2.0+ */ 

function $9cf77d15414ee3ef$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-md animate-color-change-2x mx-48 px-4 py-4 shadow border-2 border-pink-400 my-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e8b85dad31c9fca$export$2e2bcd8739ae039), {
                        className: "h-12 w-12 text-pink-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ml-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xl font-medium text-pink-400",
                            children: "Using Wildcards"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm font-medium text-cyan-400",
                            children: 'The "?" matches on one dynamic character, these can be chained. such as "???"'
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm font-medium text-cyan-400",
                            children: 'The "*" matches on all characters to the right of the last defined character. '
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mx-1.5 -my-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: ()=>{
                                props.closeAlert();
                            },
                            type: "button",
                            className: "inline-flex bg-transparent border-2 border-pink-400 rounded-md p-1.5 text-pink-500 hover:border-pink-300 hover:bg-pink-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-pink-50 focus:ring-pink-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Done"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 ",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}



function $5ac22d1c86af11cc$export$2e2bcd8739ae039(props) {
    let Icon = null;
    if (props.icon) Icon = props.icon;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-full mt-2 inline px-2 mx-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
            className: "text-xl leading-6 font-semibold text-cyan-300",
            children: props.title
        })
    });
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");




let $3f2bea42b2459559$var$c = (0, $acw62.createContext)(null);
function $3f2bea42b2459559$var$f() {
    let l = (0, $acw62.useContext)($3f2bea42b2459559$var$c);
    if (l === null) {
        let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $3f2bea42b2459559$var$f), t;
    }
    return l;
}
function $3f2bea42b2459559$export$d6875122194c7b44() {
    let [l, t] = (0, $acw62.useState)([]);
    return [
        l.length > 0 ? l.join(" ") : void 0,
        (0, $acw62.useMemo)(()=>function(e) {
                let o = (0, $acw62.useCallback)((a)=>(t((i)=>[
                            ...i,
                            a
                        ]), ()=>t((i)=>{
                            let n = i.slice(), d = n.indexOf(a);
                            return d !== -1 && n.splice(d, 1), n;
                        })), []), r = (0, $acw62.useMemo)(()=>({
                        register: o,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    o,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3f2bea42b2459559$var$c.Provider, {
                    value: r
                }, e.children);
            }, [
            t
        ])
    ];
}
let $3f2bea42b2459559$var$v = "label", $3f2bea42b2459559$export$b04be29aa201d4f5 = (0, $a54bdd13402af126$export$e43f39796049410c)(function(t, s) {
    let { passive: e = !1, ...o } = t, r = $3f2bea42b2459559$var$f(), a = `headlessui-label-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, i = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(s);
    (0, $65df95ec9b1bb6a8$export$ce5ed857c741fd71)(()=>r.register(a), [
        a,
        r.register
    ]);
    let n = {
        ref: i,
        ...r.props,
        id: a
    };
    return e && ("onClick" in n && delete n.onClick, "onClick" in o && delete o.onClick), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: n,
        theirProps: o,
        slot: r.slot || {},
        defaultTag: $3f2bea42b2459559$var$v,
        name: r.name || "Label"
    });
});







let $8bce35f563baeffd$var$m = (0, $acw62.createContext)(null);
$8bce35f563baeffd$var$m.displayName = "GroupContext";
let $8bce35f563baeffd$var$O = (0, $acw62.Fragment);
function $8bce35f563baeffd$var$j(f) {
    let [n, i] = (0, $acw62.useState)(null), [e, a] = (0, $3f2bea42b2459559$export$d6875122194c7b44)(), [o, d] = (0, $d994aee5798540d7$export$babde88292020af7)(), u = (0, $acw62.useMemo)(()=>({
            switch: n,
            setSwitch: i,
            labelledby: e,
            describedby: o
        }), [
        n,
        i,
        e,
        o
    ]), p = {}, t = f;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(d, {
        name: "Switch.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(a, {
        name: "Switch.Label",
        props: {
            onClick () {
                !n || (n.click(), n.focus({
                    preventScroll: !0
                }));
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8bce35f563baeffd$var$m.Provider, {
        value: u
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: p,
        theirProps: t,
        defaultTag: $8bce35f563baeffd$var$O,
        name: "Switch.Group"
    }))));
}
let $8bce35f563baeffd$var$N = "button", $8bce35f563baeffd$var$V = (0, $a54bdd13402af126$export$e43f39796049410c)(function(n, i) {
    let { checked: e, onChange: a, name: o, value: d, ...u } = n, p = `headlessui-switch-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, t = (0, $acw62.useContext)($8bce35f563baeffd$var$m), h = (0, $acw62.useRef)(null), S = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(h, i, t === null ? null : t.setSwitch), s = (0, $acw62.useCallback)(()=>a(!e), [
        a,
        e
    ]), w = (0, $acw62.useCallback)((r)=>{
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(r.currentTarget)) return r.preventDefault();
        r.preventDefault(), s();
    }, [
        s
    ]), E = (0, $acw62.useCallback)((r)=>{
        r.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space ? (r.preventDefault(), s()) : r.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter && (0, $594e79751740d704$export$ee02894bdc79dd36)(r.currentTarget);
    }, [
        s
    ]), P = (0, $acw62.useCallback)((r)=>r.preventDefault(), []), v = (0, $acw62.useMemo)(()=>({
            checked: e
        }), [
        e
    ]), g = {
        id: p,
        ref: S,
        role: "switch",
        type: (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(n, h),
        tabIndex: 0,
        "aria-checked": e,
        "aria-labelledby": t == null ? void 0 : t.labelledby,
        "aria-describedby": t == null ? void 0 : t.describedby,
        onClick: w,
        onKeyUp: E,
        onKeyPress: P
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, o != null && e && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1bab6a4e68c9a263$export$439d29a4e110a164), {
        ...(0, $a54bdd13402af126$export$8e16b83750b44988)({
            as: "input",
            type: "checkbox",
            hidden: !0,
            readOnly: !0,
            checked: e,
            name: o,
            value: d
        })
    }), (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: g,
        theirProps: u,
        slot: v,
        defaultTag: $8bce35f563baeffd$var$N,
        name: "Switch"
    }));
}), $8bce35f563baeffd$export$b5d5cf8927ab7262 = Object.assign($8bce35f563baeffd$var$V, {
    Group: $8bce35f563baeffd$var$j,
    Label: (0, $3f2bea42b2459559$export$b04be29aa201d4f5),
    Description: (0, $d994aee5798540d7$export$393edc798c47379d)
});


function $f536349c6e0164e5$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $f536349c6e0164e5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8bce35f563baeffd$export$b5d5cf8927ab7262), {
        checked: props.enabled,
        onChange: ()=>{
            props.setEnabled();
        },
        className: $f536349c6e0164e5$var$classNames(props.enabled ? "bg-cyan-400" : "bg-gray-700", "relative inline-flex flex-shrink-0 h-3 w-7 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-400"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: "Toggle Empty Values"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "aria-hidden": "true",
                className: $f536349c6e0164e5$var$classNames(props.enabled ? "translate-x-4" : "translate-x-0", "pointer-events-none inline-block h-2 w-2 rounded-full bg-gray-500 shadow transform ring-0 transition ease-in-out duration-200")
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $ef03f1e36d447ce4$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 12.75l6 6 9-13.5"
    }));
}
const $ef03f1e36d447ce4$var$ForwardRef = $acw62.forwardRef($ef03f1e36d447ce4$var$CheckIcon);
var $ef03f1e36d447ce4$export$2e2bcd8739ae039 = $ef03f1e36d447ce4$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $2480a97a23319a50$var$ChevronUpDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
    }));
}
const $2480a97a23319a50$var$ForwardRef = $acw62.forwardRef($2480a97a23319a50$var$ChevronUpDownIcon);
var $2480a97a23319a50$export$2e2bcd8739ae039 = $2480a97a23319a50$var$ForwardRef;


const $b7cda6ed8c253ed7$var$classNames = (...classes)=>{
    return classes.filter(Boolean).join(" ");
};
function $b7cda6ed8c253ed7$export$2e2bcd8739ae039(props) {
    const sel = !props.selected || Object.keys(props.selected).length === 0 ? props.Types[1] : props.selected;
    const [selected, setSelected] = (0, $acw62.useState)(sel);
    const Types = props.Types;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659), {
        value: selected,
        onChange: (newValue)=>{
            setSelected(newValue);
            props.selectHandler(newValue);
        },
        children: ({ open: open })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mr-3 whitespace-nowrap relative z-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $df20442161b20eb0$export$8bad31ff872c7659).Button, {
                        className: "bg-gray-800 text-gray-100 align-middle relative w-full border border-gray-600 rounded shadow-sm pl-3 pr-12 py-2 text-left text-sm cursor-default focus:outline-none focus:ring-1 focus:ring-cyan-300 focus:border-cyan-300",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm truncate",
                                children: selected.label ? selected.label : selected.type
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2480a97a23319a50$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                        show: open,
                        as: (0, $acw62.Fragment),
                        leave: "transition ease-in duration-100",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659).Options, {
                            className: "align-middle w-full bg-gray-800 text-gray-200 absolute shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                            children: Types.length && Types.map((event)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659).Option, {
                                    className: ({ active: active })=>$b7cda6ed8c253ed7$var$classNames(active ? "text-white bg-cyan-400" : "text-gray-200", "cursor-default select-none relative py-2 pl-3 pr-9"),
                                    onClick: ()=>props.selectHandler(event),
                                    value: event,
                                    defaultValue: event.label,
                                    disabled: event.disabled,
                                    children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: $b7cda6ed8c253ed7$var$classNames(selected ? "font-semibold" : "font-normal", ""),
                                                    children: event.label
                                                }),
                                                selected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: $b7cda6ed8c253ed7$var$classNames(active ? "text-white" : "text-cyan-400", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef03f1e36d447ce4$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5",
                                                        "aria-hidden": "true"
                                                    })
                                                }) : null
                                            ]
                                        })
                                }, event.id))
                        })
                    })
                ]
            })
    });
}




var $acw62 = parcelRequire("acw62");



function $e1d8e6d8020609c6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative border border-gray-600 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-cyan-300 focus-within:border-cyan-300",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: props.name,
                className: "z-20 absolute -top-2 left-2 -mt-px inline-block px-1 bg-gray-700 rounded-md text-xs font-medium text-gray-100",
                children: props.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                name: props.name,
                id: props.name,
                onChange: props.onChange,
                value: props.defaultValue,
                placeholder: props.placeholder ? props.placeholder : "",
                className: "block bg-transparent w-full border-0 p-0 text-gray-200 placeholder-gray-500 focus:ring-0 sm:text-sm"
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $3261502f45869153$var$generateTimeOptions = ()=>{
    let options = [];
    for(let i = 1; i <= 60; i++)options.push({
        id: i,
        label: `${i} minute${i > 1 ? "s" : ""}`,
        value: i
    });
    for(let i = 2; i <= 24; i++)options.push({
        id: i + 60,
        label: `${i} hour${i > 1 ? "s" : ""}`,
        value: i * 60
    });
    return options;
};
const $3261502f45869153$var$classNames = (...classes)=>classes.filter(Boolean).join(" ");
const $3261502f45869153$var$TimeDropdown = (props)=>{
    const [selected, setSelected] = (0, $acw62.useState)(props.selected);
    const timeOptions = $3261502f45869153$var$generateTimeOptions();
    if (!selected) setSelected(timeOptions[0]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative border border-gray-500 rounded px-3 py-2 shadow-sm focus-within:ring-1  focus-within:ring-cyan-400 focus-within:border-cyan-400",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: "Key",
                className: "z-5 absolute -top-2 left-2 -mt-px inline-block px-1 bg-gray-700 rounded-md text-xs font-medium text-gray-100",
                children: "Cadence"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659), {
                value: selected,
                onChange: setSelected,
                children: ({ open: open })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mr-3 whitespace-nowrap relative z-50",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $df20442161b20eb0$export$8bad31ff872c7659).Button, {
                                className: "bg-gray-800 text-gray-100 align-middle relative w-full border border-gray-600 rounded shadow-sm pl-3 pr-12 py-2 text-left text-sm cursor-default focus:outline-none focus:ring-1 focus:ring-cyan-300 focus:border-cyan-300",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "block truncate",
                                        children: selected?.label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2480a97a23319a50$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-gray-400",
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                                show: open,
                                as: (0, $acw62.Fragment),
                                leave: "transition ease-in duration-100",
                                leaveFrom: "opacity-100",
                                leaveTo: "opacity-0",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659).Options, {
                                    className: "align-middle w-full bg-gray-800 text-gray-200 absolute shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                                    children: timeOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659).Option, {
                                            className: ({ active: active })=>$3261502f45869153$var$classNames(active ? "text-white bg-cyan-600" : "text-gray-200", "cursor-default select-none relative py-2 pl-3 pr-9"),
                                            value: option,
                                            onClick: ()=>props.selectHandler(option),
                                            children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: $3261502f45869153$var$classNames(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                            children: option.label
                                                        }),
                                                        selected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: $3261502f45869153$var$classNames(active ? "text-white" : "text-cyan-400", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef03f1e36d447ce4$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    ]
                                                })
                                        }, option.id))
                                })
                            })
                        ]
                    })
            })
        ]
    });
};
var $3261502f45869153$export$2e2bcd8739ae039 = $3261502f45869153$var$TimeDropdown;


function $7f94bdab36ba6efd$export$2e2bcd8739ae039({ isOpen: isOpen, workflow: workflow, closeModal: closeModal, onChangeHost: onChangeHost, onChangePath: onChangePath, onChangePort: onChangePort, onChangeUsername: onChangeUsername, onChangeCadence: onChangeCadence, onChangeCert: onChangeCert, onChangeKey: onChangeKey }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Root, {
        show: isOpen,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-40 inset-0 overflow-y-auto",
            onClose: closeModal,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "inline-block align-bottom animate-color-change-2x rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "animate-color-change-2x px-4 pt-5 pb-4 sm:p-6 sm:pb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "sm:flex sm:items-start",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full animate-color-change-2x sm:mx-0 sm:h-10 sm:w-10",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c310f2872bff579$export$2e2bcd8739ae039), {
                                                        className: "h-9 w-9 text-gray-100",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Title, {
                                                        as: "h3",
                                                        className: "mt-2 text-2xl leading-6 font-medium text-gray-100",
                                                        children: "SFTP Configuration"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mt-5 space-y-5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                    name: "Host",
                                                    onChange: onChangeHost,
                                                    defaultValue: workflow?.trigger?.host,
                                                    placeholder: "sftp://example.com"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                    name: "Port",
                                                    onChange: onChangePort,
                                                    defaultValue: workflow?.trigger?.port,
                                                    placeholder: "22"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                    name: "Path",
                                                    onChange: onChangePath,
                                                    defaultValue: workflow?.trigger?.path,
                                                    placeholder: "/path/to/files"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3261502f45869153$export$2e2bcd8739ae039), {
                                                    selected: workflow.trigger.cadence,
                                                    selectHandler: onChangeCadence
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                    name: "Username",
                                                    onChange: onChangeUsername,
                                                    defaultValue: workflow?.trigger?.username,
                                                    placeholder: "username"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "relative border border-gray-500 rounded px-3 py-2 shadow-sm focus-within:ring-1  focus-within:ring-cyan-400 focus-within:border-cyan-400",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "Key",
                                                            className: "z-5 absolute -top-2 left-2 -mt-px inline-block px-1 bg-gray-700 rounded-md text-xs font-medium text-gray-100",
                                                            children: "Key"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                            className: "block  bg-transparent w-full border-0 p-0 h-auto text-cyan-400 placeholder-cyan-200 focus:ring-0 sm:text-sm",
                                                            id: "key-trigger",
                                                            name: "key-trigger",
                                                            rows: 2,
                                                            defaultValue: workflow?.trigger?.key,
                                                            onChange: async (event)=>onChangeKey(event)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "relative border border-gray-500 rounded px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-cyan-400 focus-within:border-cyan-400",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "Certificate",
                                                            className: "z-5 absolute -top-2 left-2 -mt-px inline-block px-1 bg-gray-700 rounded-md text-xs font-medium text-gray-100",
                                                            children: "Certificate"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                            className: "block bg-transparent w-full border-0 p-0 h-auto text-cyan-400 placeholder-cyan-200 focus:ring-0 sm:text-sm",
                                                            id: "cert-trigger",
                                                            name: "cert-trigger",
                                                            rows: 2,
                                                            defaultValue: workflow?.trigger?.cert,
                                                            onChange: async (event)=>onChangeCert(event)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "animate-color-change-2x px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-cyan-600 text-base font-medium text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 sm:ml-3 sm:w-auto sm:text-sm",
                                            onClick: closeModal,
                                            children: "Save"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-transparent text-base font-medium text-gray-100 hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm",
                                            onClick: closeModal,
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


function $793a563f84b44f86$export$2e2bcd8739ae039(props) {
    const selectedEnvironment = props.selectedEnvironment ? props.selectedEnvironment : null;
    const [eventTriggerGrid, setEventTriggerGrid] = (0, $acw62.useState)(props.eventTriggerGrid);
    const [showMessageIdInfo, setShowMessageIdInfo] = (0, $acw62.useState)(false);
    const [SFTPTriggerModal, setSFTPTriggerModal] = (0, $acw62.useState)(false);
    const closeModal = ()=>{
        setSFTPTriggerModal(false);
    };
    (0, $acw62.useEffect)(()=>{
        setEventTriggerGrid(props.eventTriggerGrid);
    }, [
        props.eventTriggerGrid
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "py-4",
        children: [
            props.error == "SaveInAnotherAccountException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7487cac41146e5bd$export$2e2bcd8739ae039), {
                closeAlert: ()=>props.clearError()
            }),
            props.error == "UserPermissionsException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $594d3d8da33b1e4a$export$2e2bcd8739ae039), {
                closeAlert: ()=>props.clearError()
            }),
            showMessageIdInfo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9cf77d15414ee3ef$export$2e2bcd8739ae039), {
                closeAlert: ()=>setShowMessageIdInfo(false)
            }),
            SFTPTriggerModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f94bdab36ba6efd$export$2e2bcd8739ae039), {
                isOpen: SFTPTriggerModal,
                onChangeHost: props.onChangeHost,
                onChangeUsername: props.onChangeUsername,
                onChangePassword: props.onChangePassword,
                onChangePort: props.onChangePort,
                onChangePath: props.onChangePath,
                onChangeCadence: props.onChangeCadence,
                workflow: props.workflow,
                closeModal: closeModal,
                onChangeCert: props.onChangeCert,
                onChangeKey: props.onChangeKey,
                onChangePrivateKey: props.onChangePrivateKey
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "inline",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "px-2 md:mt-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sm:rounded-md sm:overflow-hidden",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-gray-800 rounded-md space-y-4 px-6 pt-6 mx-6 pb-6 border-solid border-2 shadow border-cyan-300",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "inline-flex w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ac22d1c86af11cc$export$2e2bcd8739ae039), {
                                            title: `${props.workflow?.flowName} Extract Event`
                                        }),
                                        (props.workflow.trigger.type.substring(0, 4) == "MLLP" || props.workflow.trigger.type.substring(0, 4) == "SFTP") && props.workflow.next.type == "HTTPS FHIR R4" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "px-auto",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7cda6ed8c253ed7$export$2e2bcd8739ae039), {
                                                selectHandler: (event)=>props.updateTriggerMethod(event),
                                                selected: props.workflow?.next?.method,
                                                Types: props.hl7v2EventTofhirr4MethodMap
                                            })
                                        }),
                                        props.workflow.trigger.type.substring(0, 4) == "SFTP" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            onClick: ()=>{
                                                setSFTPTriggerModal(!SFTPTriggerModal);
                                            },
                                            className: "inline-flex items-center mx-2 border-2 rounded-md px-2 border-gray-200 cursor-pointer hover:bg-cyan-500",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c310f2872bff579$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-gray-200 inline"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    className: "button text-sm text-gray-200 px-2 py-1",
                                                    children: "SFTP"
                                                })
                                            ]
                                        }),
                                        (props.workflow.trigger.type.substring(0, 4) == "MLLP" || props.workflow.trigger.type.substring(0, 4) == "SFTP") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "inline-flex items-center px-2 py-1 mx-1 mr-2 border-2 border-cyan-400 text-gray-100 rounded-md shadow-sm text-xs bg-gray-800 focus:outline-none",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm",
                                                    children: "Selected\xa0\xa0"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f536349c6e0164e5$export$2e2bcd8739ae039), {
                                                    enabled: props.sampleFilter,
                                                    setEnabled: ()=>props.enableSampleFilter()
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm",
                                                    children: "\xa0\xa0All"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "border border-top border-cyan-300 mx-2"
                                }),
                                (props.workflow.trigger.type.substring(0, 4) == "MLLP" || props.workflow.trigger.type.substring(0, 4) == "SFTP") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                        className: "min-w-full divide-y divide-cyan-400 border-2 border-cyan-400 shadow",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                className: "bg-gray-900",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            scope: "col",
                                                            className: "pl-4 pr-2 py-2 text-left text-s font-medium text-cyan-300 uppercase tracking-wider",
                                                            children: "Field"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            scope: "col",
                                                            className: "px-2 py-2 text-left text-s font-medium text-cyan-300 uppercase tracking-wider",
                                                            children: "Specification"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            scope: "col",
                                                            className: "px-2 py-2 text-left text-m font-medium text-cyan-300 tracking-wider",
                                                            children: "SAMPLE"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                            scope: "col",
                                                            className: "px-2 py-2 text-left text-m font-medium text-cyan-300 tracking-wider",
                                                            children: [
                                                                "FILTER",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e8b85dad31c9fca$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5 pb-1 inline align-middle text-pink-300 rounded cursor-pointer hover:text-pink-500",
                                                                    onClick: ()=>{
                                                                        setShowMessageIdInfo(true);
                                                                    },
                                                                    closeAlert: ()=>{
                                                                        setShowMessageIdInfo(false);
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                children: [
                                                    props.triggerSample == props.selectedWorkspace.hash.value && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "bg-gray-800 border-2 border-solid border-green-400 hover:bg-cyan-500",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "pl-4 pr-2 py-2 whitespace-nowrap text-sm text-gray-200",
                                                                children: props.selectedWorkspace.hash.location
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-2 py-2 whitespace-wrap text-xs font-light text-gray-200",
                                                                children: "Unique Message Identifier"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-2 py-2 whitespace-wrap text-xs text-gray-100",
                                                                children: props.triggerSample
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-2 py-2 whitespace-wrap text-xs text-gray-200",
                                                                children: props.selectedWorkspace.hash.value
                                                            })
                                                        ]
                                                    }, "unique-message-id"),
                                                    props.triggerSample != props.selectedWorkspace.hash.value && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: "bg-gray-800 border-2 border-solid border-pink-400 hover:bg-pink-500",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "pl-4 pr-2 py-2 whitespace-nowrap text-sm text-gray-200",
                                                                children: props.selectedWorkspace.hash.location
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-2 py-2 whitespace-wrap text-xs font-light text-gray-200",
                                                                children: "Unique Message Identifier"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-2 py-2 whitespace-wrap text-xs text-gray-100",
                                                                children: props.triggerSample
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "px-2 py-2 whitespace-wrap text-xs text-gray-200",
                                                                children: props.selectedWorkspace.hash.value
                                                            })
                                                        ]
                                                    }, "unique-message-id"),
                                                    eventTriggerGrid.map((map, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            className: idx % 2 === 0 ? "bg-gray-700 hover:bg-cyan-500" : "bg-gray-800 hover:bg-cyan-500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "pl-4 pr-2 py-2 whitespace-nowrap text-sm text-gray-200",
                                                                    children: map[1].field
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-2 py-2 whitespace-wrap text-xs font-light text-gray-200",
                                                                    children: map[0].definition
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "px-2 py-2 whitespace-wrap text-sm text-gray-100",
                                                                    children: map[2].sample
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                    className: "px-2 py-2 whitespace-wrap inline flex text-sm text-gray-100",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                            type: "text",
                                                                            name: "filter",
                                                                            id: map[1].field,
                                                                            defaultValue: map[3].filter,
                                                                            onChange: (event)=>props.updateTrigger(event),
                                                                            className: "shadow-sm flex focus:ring-cyan-300 focus:border-cyan-300 block w-full sm:text-sm border-cyan-300 border-2 rounded bg-gray-800"
                                                                        }),
                                                                        !props.sampleFilter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "pl-2 pt-1 inline rounded-md",
                                                                            onClick: ()=>{
                                                                                props.removeTriggerMapRow(map);
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $beefe28644f6e8ce$export$2e2bcd8739ae039), {
                                                                                className: "h-8 w-8 inline cursor-pointer text-gray-400 hover:text-pink-400"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, map[1].field + "-" + map[2].sample + idx))
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






function $eff657b575a4eac4$export$2e2bcd8739ae039(props) {
    const [fieldMapGrid, setFieldMapGrid] = (0, $acw62.useState)(props.fieldMapGrid);
    const [fhirMap, setFhirMap] = (0, $acw62.useState)(props.fhirMap);
    const [fhirLoading, setFhirLoading] = (0, $acw62.useState)(props.fhirLoading);
    const [fhirProgress, setFhirProgress] = (0, $acw62.useState)(props.fhirProgress);
    (0, $acw62.useEffect)(()=>{
        setFieldMapGrid(props.fieldMapGrid);
        setFhirMap(props.fhirMap);
        setFhirLoading(props.fhirLoading);
        setFhirProgress(props.fhirProgress);
    }, [
        props.fieldMapGrid,
        props.fhirMap,
        props.fhirLoading,
        props.fhirProgress
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "py-4",
        children: [
            props.error == "SaveInAnotherAccountException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7487cac41146e5bd$export$2e2bcd8739ae039), {
                closeAlert: ()=>props.clearError()
            }),
            props.error == "UserPermissionsException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $594d3d8da33b1e4a$export$2e2bcd8739ae039), {
                closeAlert: ()=>props.clearError()
            }),
            props.workflow.next != "FHIRR4" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-2 md:mt-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "sm:rounded-md sm:overflow-hidden",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gray-800 rounded space-y-6 p-6 mx-6 border-solid border shadow border-cyan-300",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "inline-flex w-full",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ac22d1c86af11cc$export$2e2bcd8739ae039), {
                                        title: `${props.workflow?.flowName} Transform`
                                    }),
                                    (props.workflow.next.type == "S3 FHIR R4" || props.workflow.next.type == "HTTPS FHIR R4") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "inline-flex items-center mx-1 mr-2 text-gray-500 hover:text-gray-200",
                                        children: fhirLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "relative px-2 py-1 border-2 border-pink-500 rounded-md shadow-sm animate-wiggle focus:outline-none cursor-pointer",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "absolute bottom-0 left-0 w-full bg-pink-500/80",
                                                    style: {
                                                        height: `${fhirProgress}%`
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1405939c84d0e6$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-8 inline cursor-pointer text-gray-200"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "px-2 py-1 border-2 border-cyan-500 hover:bg-cyan-400 rounded-md shadow-sm bg-transparent focus:outline-none cursor-pointer",
                                            onClick: ()=>props.fetchFHIRR4Map(),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc1405939c84d0e6$export$2e2bcd8739ae039), {
                                                className: "h-6 w-8 inline cursor-pointer text-gray-200"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "inline-flex items-center px-2 py-1 mx-1 mr-2 border-2 border-cyan-600 text-gray-200 rounded-md shadow-sm text-xs bg-gray-900 focus:outline-none",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm",
                                                children: "Selected\xa0\xa0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f536349c6e0164e5$export$2e2bcd8739ae039), {
                                                enabled: props.sampleFilter,
                                                setEnabled: ()=>props.enableSampleFilter()
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm",
                                                children: "\xa0\xa0All"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "border border-top border-cyan-300 mx-2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                className: "min-w-full divide-y divide-cyan-400 border-2 border-cyan-400 shadow",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                        className: "bg-gray-900",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    scope: "col",
                                                    className: "px-4 py-2 text-left text-s font-medium text-cyan-300 uppercase tracking-wider",
                                                    children: "Field"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    scope: "col",
                                                    className: "px-2 py-2 text-left text-s font-medium text-cyan-300 uppercase tracking-wider",
                                                    children: "Specification"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    scope: "col",
                                                    className: "px-2 py-2 text-left text-m font-medium text-gray-500 uppercase tracking-wider",
                                                    children: "SAMPLE"
                                                }),
                                                props.workflow.next.type == "S3 FHIR R4" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    scope: "col",
                                                    className: "px-2 py-2 text-left text-m font-medium text-cyan-300 uppercase tracking-wider",
                                                    children: "TARGET PATH"
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    scope: "col",
                                                    className: "px-2 py-2 text-left text-m font-medium text-cyan-300 uppercase tracking-wider",
                                                    children: "TARGET KEY"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                        children: fieldMapGrid.map((map, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                className: idx % 2 === 0 ? "bg-gray-800 hover:bg-cyan-500 w-full" : "bg-gray-900 hover:bg-cyan-500 w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "pl-4 pr-2 pt-1 whitespace-nowrap text-sm text-gray-200",
                                                        children: map[1].field
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-2 pb-2 pt-1 whitespace-wrap text-xs truncate font-light text-gray-200",
                                                        children: map[0].definition
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-2 pb-2 pt-1 whitespace-wrap text-sm text-gray-200",
                                                        children: map[2].sample
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                        className: "px-2 pb-2 pt-2 whitespace-wrap inline-flex w-full text-sm text-gray-100",
                                                        children: [
                                                            props.workflow.trigger.type.substring(0, 4) == "MLLP" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                className: "shadow-sm bg-gray-900 inline focus:ring-cyan-300 focus:border-cyan-300 w-full sm:text-sm border-cyan-300 border-2 rounded",
                                                                type: "text",
                                                                name: "target",
                                                                id: map[1].field,
                                                                defaultValue: map[3].target ? map[3].target : null,
                                                                onChange: (event)=>{
                                                                    props.updateFieldMap(event);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "pl-2 mt-1 inline rounded-md",
                                                                onClick: ()=>props.toggleLookUpModal(map),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c310f2872bff579$export$2e2bcd8739ae039), {
                                                                    className: "h-8 w-8 inline cursor-pointer text-gray-500 hover:text-cyan-400"
                                                                })
                                                            }),
                                                            !props.sampleFilter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "pl-0 ml-1 pl-1 pt-1 inline rounded-md",
                                                                onClick: ()=>{
                                                                    props.removeFieldMapRow(map);
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $beefe28644f6e8ce$export$2e2bcd8739ae039), {
                                                                    className: "h-8 w-8 inline cursor-pointer text-gray-500 rounded hover:text-pink-400"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, map[1].field + "-" + map[2].sample + idx))
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            props.loading == true && !props.workflow.fields.length && fhirLoading == false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-2 md:mt-0 md:col-span-7",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "sm:rounded-md sm:overflow-hidden",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gray-800 rounded-md space-y-6 p-6 mx-6 border-solid border shadow border-cyan-300",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "inline-flex w-full",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ac22d1c86af11cc$export$2e2bcd8739ae039), {
                                        title: "Workflow Mappings & Transformations"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "inline-flex items-center px-2 py-1 mx-1 mr-2 border border-cyan-400 text-gray-200 rounded-md shadow-sm text-xs bg-gray-800 focus:outline-none",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm",
                                                children: "Selected\xa0\xa0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f536349c6e0164e5$export$2e2bcd8739ae039), {
                                                enabled: props.sampleFilter,
                                                setEnabled: ()=>props.enableSampleFilter()
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-sm",
                                                children: "\xa0\xa0All"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "border border-top border-cyan-300 mx-2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "items-center animate-pulse py-48 sm:py-24 md:py-32 lg:py-48",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "h-24 mx-auto w-auto",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                        alt: "Logo"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                        className: "mt-0 text-center text-2xl font-bold text-gray-200",
                                        children: [
                                            "Retrohook",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}







function $941dd6bed9823287$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex rounded-md shadow-sm relative",
        children: [
            props.leftInput && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "inline-flex items-center px-3 rounded-l-md border border-r-0 border-cyan-300 bg-gray-800 text-gray-200 sm:text-sm",
                children: props.leftInput
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: "url",
                className: "absolute -top-2 left-2 -mt-px inline-block rounded px-1 bg-gray-800 text-xs font-medium text-gray-200",
                children: props.url
            }),
            props.leftInput && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                name: "url",
                onChange: props.onChange,
                value: props.value,
                className: "flex-1 bg-gray-800 block w-full focus:ring-cyan-500 focus:border-cyan-500 min-w-0 rounded-none rounded-r-md sm:text-sm text-cyan-400 border-cyan-300"
            }),
            !props.leftInput && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                name: "url",
                onChange: props.onChange,
                value: props.value,
                className: "flex-1 bg-gray-800 block w-full focus:ring-cyan-500 focus:border-cyan-500 min-w-0 rounded-md sm:text-sm text-cyan-400 border-cyan-300"
            })
        ]
    });
}



var $d0fb1c35ad92a815$exports = {};
"use strict";
var $58ad65a0a6d6101f$exports = {};
"use strict";
function $58ad65a0a6d6101f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $58ad65a0a6d6101f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $58ad65a0a6d6101f$var$_typeof(obj);
}
Object.defineProperty($58ad65a0a6d6101f$exports, "__esModule", {
    value: true
});
$58ad65a0a6d6101f$exports.CopyToClipboard = void 0;

var $58ad65a0a6d6101f$var$_react = $58ad65a0a6d6101f$var$_interopRequireDefault((parcelRequire("acw62")));

var $58ad65a0a6d6101f$var$_copyToClipboard = $58ad65a0a6d6101f$var$_interopRequireDefault((parcelRequire("jIrAL")));
var $58ad65a0a6d6101f$var$_excluded = [
    "text",
    "onCopy",
    "options",
    "children"
];
function $58ad65a0a6d6101f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $58ad65a0a6d6101f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $58ad65a0a6d6101f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $58ad65a0a6d6101f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $58ad65a0a6d6101f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $58ad65a0a6d6101f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $58ad65a0a6d6101f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $58ad65a0a6d6101f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $58ad65a0a6d6101f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $58ad65a0a6d6101f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $58ad65a0a6d6101f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $58ad65a0a6d6101f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $58ad65a0a6d6101f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $58ad65a0a6d6101f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $58ad65a0a6d6101f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $58ad65a0a6d6101f$var$_setPrototypeOf(subClass, superClass);
}
function $58ad65a0a6d6101f$var$_setPrototypeOf(o, p) {
    $58ad65a0a6d6101f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $58ad65a0a6d6101f$var$_setPrototypeOf(o, p);
}
function $58ad65a0a6d6101f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $58ad65a0a6d6101f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $58ad65a0a6d6101f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $58ad65a0a6d6101f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $58ad65a0a6d6101f$var$_possibleConstructorReturn(this, result);
    };
}
function $58ad65a0a6d6101f$var$_possibleConstructorReturn(self, call) {
    if (call && ($58ad65a0a6d6101f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $58ad65a0a6d6101f$var$_assertThisInitialized(self);
}
function $58ad65a0a6d6101f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $58ad65a0a6d6101f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $58ad65a0a6d6101f$var$_getPrototypeOf(o) {
    $58ad65a0a6d6101f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $58ad65a0a6d6101f$var$_getPrototypeOf(o);
}
function $58ad65a0a6d6101f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $58ad65a0a6d6101f$var$CopyToClipboard = /*#__PURE__*/ function(_React$PureComponent) {
    $58ad65a0a6d6101f$var$_inherits(CopyToClipboard, _React$PureComponent);
    var _super = $58ad65a0a6d6101f$var$_createSuper(CopyToClipboard);
    function CopyToClipboard() {
        var _this;
        $58ad65a0a6d6101f$var$_classCallCheck(this, CopyToClipboard);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $58ad65a0a6d6101f$var$_defineProperty($58ad65a0a6d6101f$var$_assertThisInitialized(_this), "onClick", function(event) {
            var _this$props = _this.props, text = _this$props.text, onCopy = _this$props.onCopy, children = _this$props.children, options = _this$props.options;
            var elem = $58ad65a0a6d6101f$var$_react["default"].Children.only(children);
            var result = (0, $58ad65a0a6d6101f$var$_copyToClipboard["default"])(text, options);
            if (onCopy) onCopy(text, result);
             // Bypass onClick if it was present
            if (elem && elem.props && typeof elem.props.onClick === "function") elem.props.onClick(event);
        });
        return _this;
    }
    $58ad65a0a6d6101f$var$_createClass(CopyToClipboard, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, _text = _this$props2.text, _onCopy = _this$props2.onCopy, _options = _this$props2.options, children = _this$props2.children, props = $58ad65a0a6d6101f$var$_objectWithoutProperties(_this$props2, $58ad65a0a6d6101f$var$_excluded);
                var elem = $58ad65a0a6d6101f$var$_react["default"].Children.only(children);
                return /*#__PURE__*/ $58ad65a0a6d6101f$var$_react["default"].cloneElement(elem, $58ad65a0a6d6101f$var$_objectSpread($58ad65a0a6d6101f$var$_objectSpread({}, props), {}, {
                    onClick: this.onClick
                }));
            }
        }
    ]);
    return CopyToClipboard;
}($58ad65a0a6d6101f$var$_react["default"].PureComponent);
$58ad65a0a6d6101f$exports.CopyToClipboard = $58ad65a0a6d6101f$var$CopyToClipboard;
$58ad65a0a6d6101f$var$_defineProperty($58ad65a0a6d6101f$var$CopyToClipboard, "defaultProps", {
    onCopy: undefined,
    options: undefined
});


var $d0fb1c35ad92a815$var$CopyToClipboard = $58ad65a0a6d6101f$exports.CopyToClipboard;
$d0fb1c35ad92a815$var$CopyToClipboard.CopyToClipboard = $d0fb1c35ad92a815$var$CopyToClipboard;
$d0fb1c35ad92a815$exports = $d0fb1c35ad92a815$var$CopyToClipboard;


function $8aa13104b69f518c$export$2e2bcd8739ae039(props) {
    const selectedEnvironment = props.selectedEnvironment ? props.selectedEnvironment : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "py-4",
        children: [
            props.error == "SaveInAnotherAccountException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7487cac41146e5bd$export$2e2bcd8739ae039), {
                closeAlert: ()=>props.clearError()
            }),
            props.error == "UserPermissionsException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $594d3d8da33b1e4a$export$2e2bcd8739ae039), {
                closeAlert: ()=>props.clearError()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-2 md:mt-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "sm:rounded-md sm:overflow-hidden",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-gray-800 rounded space-y-6 p-6 mx-6 border-solid border shadow border-cyan-300",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "inline-flex w-full",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ac22d1c86af11cc$export$2e2bcd8739ae039), {
                                    title: `${props.workflow?.flowName} Load Action`
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "border border-top border-cyan-300 mx-2"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "py-2 w-full",
                                children: [
                                    props.workflow.trigger.type.substring(0, 4) == "MLLP" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pb-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "relative border border-cyan-300 rounded-md px-2 py-2 w-full shadow-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "env-info",
                                                    className: "absolute -top-2 left-2 -mt-px inline-block px-1 bg-gray-800 text-xs font-medium text-gray-200",
                                                    children: "Entry"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "mt-1 flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            id: "env-info",
                                                            className: " text-xl text-cyan-400 flex-1 inline w-full",
                                                            children: [
                                                                selectedEnvironment.accountId === "587677186137" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-sm p-4 text-cyan-400",
                                                                    children: [
                                                                        "mllp.retrohook.com:2575 ",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "text-sm text-red-400",
                                                                            children: [
                                                                                "MLLP Only",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "text-red-400",
                                                                            children: [
                                                                                " ",
                                                                                "(IPSec required)"
                                                                            ]
                                                                        }),
                                                                        ".",
                                                                        " "
                                                                    ]
                                                                }) : ``,
                                                                selectedEnvironment.network && selectedEnvironment.accountId === "411790770360" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-sm p-4 text-cyan-400",
                                                                    children: [
                                                                        selectedEnvironment.network.nlb.DNSName.toLowerCase(),
                                                                        ":2575",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "text-sm text-gray-200",
                                                                            children: [
                                                                                "\xa0MLLP Only",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "text-red-400",
                                                                            children: [
                                                                                " ",
                                                                                "(No PII Allowed)"
                                                                            ]
                                                                        }),
                                                                        ".",
                                                                        " "
                                                                    ]
                                                                }) : ``,
                                                                selectedEnvironment.network && selectedEnvironment.accountId !== "411790770360" && selectedEnvironment.accountId !== "587677186137" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "text-sm p-4 text-cyan-400",
                                                                    children: [
                                                                        selectedEnvironment.network.nlb.DNSName.toLowerCase(),
                                                                        " :2575",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "text-sm text-gray-600",
                                                                            children: [
                                                                                "\xa0MLLP Only",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                            className: "text-red-400",
                                                                            children: [
                                                                                " ",
                                                                                "(IPSec required)"
                                                                            ]
                                                                        }),
                                                                        ".",
                                                                        " "
                                                                    ]
                                                                }) : ``
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0fb1c35ad92a815$exports))), {
                                                            text: selectedEnvironment.accountId !== "587677186137" ? `${selectedEnvironment.network.nlb.DNSName.toLowerCase()}:2575` : "mllp.retrohook.com:2575",
                                                            onCopy: ()=>props.setCopiedHandler(),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                className: "text-xs text-gray-200 border-cyan-500 hover:text-cyan-300 hover:border-red-300 border rounded px-2",
                                                                children: [
                                                                    "Copy To Clipboard ",
                                                                    props.copied ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef03f1e36d447ce4$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4 pt-0 mt-0 text-cyan-300 inline"
                                                                    }) : null
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    props.workflow.trigger.type == "HTTPS JSON" && props.workflow.flowId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pb-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "relative border border-gray-300 rounded px-2 py-2 mb-4 w-full shadow-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    htmlFor: "env-info",
                                                    className: "absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-gray-500",
                                                    children: "Workflow Entry"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "mt-1 flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            id: "env-info",
                                                            className: "text-xl text-gray-500 flex-1 inline w-full",
                                                            children: selectedEnvironment.accountId === "587677186137" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "text-sm p-4 text-cyan-400",
                                                                children: [
                                                                    "https://hooks.dev.retrohook.com/messages/",
                                                                    props.workflow.flowId,
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-sm text-gray-600"
                                                                    })
                                                                ]
                                                            }) : ``
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0fb1c35ad92a815$exports))), {
                                                            text: selectedEnvironment.accountId !== "587677186137" ? `${selectedEnvironment.network.nlb.DNSName.toLowerCase()}:2575` : "mllp.retrohook.com:2575",
                                                            onCopy: ()=>props.setCopiedHandler(),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                                className: "text-xs text-gray-500 border-gray-500 hover:text-cyan-300 hover:border-cyan-300 border rounded px-2",
                                                                children: [
                                                                    "Copy To Clipboard ",
                                                                    props.copied ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef03f1e36d447ce4$export$2e2bcd8739ae039), {
                                                                        className: "h-4 w-4 pt-0 mt-0 text-cyan-300 inline"
                                                                    }) : null
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    props.workflow.trigger.type == "HTTPS JSON" && !props.workflow.flowId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pb-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xl text-gray-600 px-4 mx-1 py-6 my-4 border-4 border-orange-200 rounded",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca6349d0f67ac97f$export$2e2bcd8739ae039), {
                                                    className: "h-12 w-12 inline text-orange-300 rounded"
                                                }),
                                                "The workflow must be saved in order to generate the HTTPS entry point."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "w-full mt-4",
                                        children: [
                                            props?.workflow?.next?.type == "HTTPS JSON" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $941dd6bed9823287$export$2e2bcd8739ae039), {
                                                leftInput: "->",
                                                url: "Destination",
                                                onChange: (event)=>props.handleNextUrl(event),
                                                value: props.workflow.next.url
                                            }),
                                            props?.workflow?.next?.type.substring(0, 2) == "S3" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex items-center space-x-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex-grow space-y-8",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $941dd6bed9823287$export$2e2bcd8739ae039), {
                                                            url: "S3 Bucket Name",
                                                            onChange: (event)=>{
                                                                props.handleNextS3BucketName(event);
                                                            },
                                                            value: props.workflow.next.bucket
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $941dd6bed9823287$export$2e2bcd8739ae039), {
                                                            url: "SubFolder (Optional)",
                                                            onChange: (event)=>{
                                                                props.handleNextS3Key(event);
                                                            },
                                                            value: props.workflow.next.key
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            props?.workflow?.next?.type.split(" ")[1] == "JSON" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative border border-cyan-300 col-span-2 rounded px-3 mt-4 w-full shadow-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "payload-info",
                                        className: "absolute -top-2 left-2 -mt-px inline-block px-1 bg-gray-800 text-xs font-medium text-gray-200",
                                        children: "Sample Payload"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-1 flex",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                            className: "text-sm text-cyan-400 p-2",
                                            children: JSON.stringify(props.sampleMap, null, 2)
                                        })
                                    })
                                ]
                            }),
                            props?.workflow?.next?.type.split(" ")[1] == "FHIR" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative border border-cyan-300 col-span-2 rounded px-3 mt-4 w-full shadow-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "payload-info",
                                        className: "absolute -top-2 left-2 -mt-px inline-block px-1 bg-gray-800 text-xs font-medium text-gray-200",
                                        children: "Sample Bundle Resource"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mt-1 flex",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                            className: "text-sm text-cyan-400 p-2",
                                            children: JSON.stringify(props.fhirSampleMap, null, 2)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $b194aa8e8d5fdf2d$var$ArrowUpOnSquareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15"
    }));
}
const $b194aa8e8d5fdf2d$var$ForwardRef = $acw62.forwardRef($b194aa8e8d5fdf2d$var$ArrowUpOnSquareIcon);
var $b194aa8e8d5fdf2d$export$2e2bcd8739ae039 = $b194aa8e8d5fdf2d$var$ForwardRef;





function $cb6a650d57088714$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative border flex border-cyan-300 rounded-md px-4 py-2 shadow-sm  focus-within:ring-1 focus-within:ring-cyan-600 focus-within:border-pink-600",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: props.name,
                className: "absolute -top-2 left-2 -mt-px inline-block px-1 bg-gray-800 text-xs font-medium text-gray-200",
                children: props.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                name: props.name,
                disabled: props.disabled,
                id: props.name,
                onChange: props.onChange,
                defaultValue: props.value,
                className: "block w-full border-0 p-0 text-cyan-200 placeholder-gray-200 bg-gray-800 focus:ring-0 sm:text-sm"
            })
        ]
    });
}




const $44fcfa68fa0fab58$var$defaultEventTypes = [
    {
        id: 1,
        type: "MLLP HL7v2",
        label: "MLLP",
        description: "HL7v2 Messages over MLLP",
        disabled: false
    },
    {
        id: 4,
        type: "SFTP HL7v2",
        label: "SFTP (Pro)",
        description: "HL7v2 Messages over SFTP",
        disabled: true
    },
    {
        id: 3,
        type: "HTTPS FHIR R4",
        label: "FHIR R4 (Pro)",
        description: "FHIR subscription listener",
        disabled: true
    },
    {
        id: 2,
        type: "HTTPS JSON",
        label: "HTTPS JSON (Pro)",
        description: "Consume JSON over HTTP POST requests",
        disabled: true
    }
];
const $44fcfa68fa0fab58$var$defaultActionTypes = [
    {
        id: 1,
        type: "HTTPS JSON",
        label: "HTTPS JSON",
        description: "POST JSON Over HTTPS",
        disabled: false
    },
    {
        id: 2,
        type: "S3 JSON",
        label: "S3 JSON (Pro)",
        description: "Write JSON to S3",
        disabled: false
    },
    {
        id: 3,
        type: "S3 FHIR R4",
        label: "S3 FHIR R4 (Pro)",
        description: "Send Bundles to a FHIR Server",
        disabled: false
    },
    {
        id: 4,
        type: "MLLP HL7v2",
        label: "MLLP HL7v2 (Pro)",
        description: "Send MLLP Events To An IP & Port",
        disabled: true
    },
    {
        id: 5,
        type: "HTTPS FHIR R4",
        label: "HTTPS FHIR R4 (Pro)",
        description: "Send Bundle Transactions",
        disabled: true
    }
];
const $44fcfa68fa0fab58$var$freshEventTypes = JSON.parse(JSON.stringify($44fcfa68fa0fab58$var$defaultEventTypes));
const $44fcfa68fa0fab58$var$freshActionTypes = JSON.parse(JSON.stringify($44fcfa68fa0fab58$var$defaultActionTypes));
function $44fcfa68fa0fab58$export$2e2bcd8739ae039(props) {
    const [eventTypes, setEventTypes] = (0, $acw62.useState)($44fcfa68fa0fab58$var$defaultEventTypes);
    const [actionTypes, setActionTypes] = (0, $acw62.useState)($44fcfa68fa0fab58$var$defaultActionTypes);
    (0, $acw62.useEffect)(()=>{
        if (props.selectedEnvironment.name.substring(0, 6) === "\uD83E\uDDEA Dev") {
            const eventTypesUpdated = $44fcfa68fa0fab58$var$freshEventTypes.map((eventType)=>{
                if (eventType.type.substring(0, 4) === "HTTP" || eventType.type.substring(0, 4) === "SFTP") eventType.disabled = true;
                return eventType;
            });
            const actionTypesUpdated = $44fcfa68fa0fab58$var$freshActionTypes.map((actionType)=>{
                if (actionType.type === "MLLP HL7v2" || actionType.type.substring(0, 2) === "S3" || actionType.type === "HTTPS FHIR R4") actionType.disabled = true;
                return actionType;
            });
            setEventTypes(eventTypesUpdated);
            setActionTypes(actionTypesUpdated);
        } else {
            setEventTypes($44fcfa68fa0fab58$var$freshEventTypes);
            setActionTypes($44fcfa68fa0fab58$var$freshActionTypes);
        }
    }, [
        props.selectedEnvironment
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "py-4",
        children: [
            props.error == "SaveInAnotherAccountException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7487cac41146e5bd$export$2e2bcd8739ae039), {
                closeAlert: ()=>props.clearError()
            }),
            props.error == "UserPermissionsException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $594d3d8da33b1e4a$export$2e2bcd8739ae039), {
                closeAlert: ()=>props.clearError()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "inline",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "px-2 md:mt-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sm:rounded-md sm:overflow-hidden",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-gray-800 rounded h-full space-y-4 p-6 pb-4 mx-4 border-solid border shadow border-cyan-300",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ac22d1c86af11cc$export$2e2bcd8739ae039), {
                                    icon: (0, $9e73f507bb05d0c8$export$2e2bcd8739ae039),
                                    title: `${props.workflow?.flowName} Details`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "border border-top border-cyan-400 mx-2"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb6a650d57088714$export$2e2bcd8739ae039), {
                                    name: "Name",
                                    onChange: props.handleFlowNameChange,
                                    value: props.workflow?.flowName,
                                    placeholder: props.placeholder.flowName
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-gray-200",
                                    children: "Select the desired event type to initiate your workflow and the corresponding action you would like to take place as a result of the event."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "pl-3 inline w-1/2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    className: "text-lg leading-6 font-medium text-gray-100",
                                                    children: "Event"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7cda6ed8c253ed7$export$2e2bcd8739ae039), {
                                                    selectHandler: props.updateEventTrigger,
                                                    selected: props.workflow?.trigger,
                                                    Types: eventTypes
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "inline w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    className: "text-lg leading-6 font-medium text-gray-100",
                                                    children: "Action"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "inline w-full",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7cda6ed8c253ed7$export$2e2bcd8739ae039), {
                                                        selectHandler: (event)=>props.updateActionTrigger(event),
                                                        selected: props.workflow?.next,
                                                        Types: actionTypes
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-1",
                                    children: (props.workflow?.trigger.type.substring(0, 4) == "MLLP" || props.workflow?.trigger.type.substring(0, 4) == "SFTP") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "inline-flex w-full pb-2",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ac22d1c86af11cc$export$2e2bcd8739ae039), {
                                                    icon: (0, $b194aa8e8d5fdf2d$export$2e2bcd8739ae039),
                                                    title: "Sample Message"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "relative border border-cyan-300 rounded px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-cyan-400 focus-within:border-cyan-400",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "mt-1",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                        className: "block w-full border-0 p-0 h-auto bg-gray-800 text-cyan-400 placeholder-cyan-200 focus:ring-0 sm:text-sm",
                                                        id: "sample-message-hl7v2",
                                                        name: "sample-message",
                                                        rows: 15,
                                                        defaultValue: props.workflow?.sampleMessage,
                                                        onChange: async (event)=>props.handleSampleMessageChange(event)
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



function $e51cd5242ab596a9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        id: "csv-form",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "inline-flex w-full items-center px-2.5 py-1.5 border border-transparent text-sm font-medium rounded shadow-sm text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500",
                type: "file",
                accept: ".csv",
                id: "csvFile",
                onChange: (e)=>{
                    props.setCsvFile(e.target.files[0]);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {})
        ]
    });
}


function $d83bdd072adf5d72$export$2e2bcd8739ae039(props) {
    const [field, setField] = (0, $acw62.useState)({
        lookups: {}
    });
    const LookUpCallbackHandler = (0, $acw62.useCallback)(()=>{
        if (JSON.stringify(props.workflow.lookups) != JSON.stringify(field)) setField(props.workflow.lookups);
    }, []);
    (0, $acw62.useEffect)(()=>{
        LookUpCallbackHandler();
    }, [
        props.workflow.lookups
    ]);
    if (props.selectedField && typeof props.selectedFieldMap.map === "object") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-10 inset-0 overflow-y-auto",
            onClose: props.toggleLookUpModal,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-1 pb-6 inline-flex",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "absolute top-4 left-4 px-1 inline",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c310f2872bff579$export$2e2bcd8739ae039), {
                                                className: "h-10 w-10 text-gray-500 bg-white rounded-md inline"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Title, {
                                                as: "h3",
                                                className: "text-xl font-medium text-gray-500 inline",
                                                children: [
                                                    "\xa0 ",
                                                    props.selectedField[1] ? props.selectedField[1].field : ""
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Title, {
                                                as: "h3",
                                                className: "text-xs leading-6 ml-2 text-gray-500",
                                                children: props.selectedField[0] ? props.selectedField[0].definition : ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-2 sm:mt-6 border border-gray-300 bg-white p-4 rounded-md shadow-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            className: "shadow-sm focus:ring-cyan-500 focus:border-cyan-500 block w-full sm:text-sm border-gray-300  rounded-md col-span-2",
                                            type: "text",
                                            name: "defaultValue",
                                            onChange: props.handleLookupDefaultValueChange,
                                            placeholder: "Default Value",
                                            id: ("default-" + props.selectedField[1], props.selectedField[1].field),
                                            defaultValue: props.selectedDefaultValue
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "relative py-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "absolute inset-0 flex items-center",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "w-full border-t border-gray-300"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "relative flex justify-center",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "px-2 bg-white text-sm text-gray-500",
                                                        children: "CSV Lookup"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e51cd5242ab596a9$export$2e2bcd8739ae039), {
                                            setCsvFile: props.setCsvFile,
                                            csvFile: props.csvFile
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "relative py-4",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "absolute inset-0 flex items-center",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "w-full border-t border-gray-300"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "relative flex justify-center",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "px-2 bg-white text-sm text-gray-500",
                                                        children: "Quick Lookup"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: " sm:grid sm:grid-cols-6 sm:gap-2 sm:grid-flow-row-dense bg-white p-2",
                                            children: props.selectedFieldMap.map.map((lookup, idx)=>{
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            className: "shadow-sm focus:ring-cyan-500 focus:border-cyan-500 block w-full sm:text-sm border-gray-300 rounded-md col-span-2",
                                                            type: "text",
                                                            id: "match-" + lookup.field + "-" + idx,
                                                            name: "matchValue",
                                                            onChange: props.updateFieldMapKey,
                                                            placeholder: "Source Value",
                                                            defaultValue: lookup.key
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            className: "shadow-sm focus:ring-cyan-500 focus:border-cyan-500 block w-full sm:text-sm border-gray-300 rounded-md col-span-2",
                                                            type: "text",
                                                            id: "replace-" + lookup.field + "-" + idx,
                                                            name: "matchOverride",
                                                            onChange: props.updateFieldMapValue,
                                                            placeholder: "Replacement",
                                                            defaultValue: lookup.value
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "inline justify-center rounded-md border border-transparent shadow-sm bg-gray-600 text-base font-medium text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 sm:col-start-5 sm:text-lg",
                                                            onClick: ()=>props.removeRow(lookup.id),
                                                            children: " -"
                                                        }),
                                                        idx === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "inline justify-center rounded-md border border-transparent shadow-sm bg-gray-600 text-base font-medium text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 sm:col-start-6 sm:text-lg",
                                                            onClick: ()=>props.addRowToLookupsHandler(),
                                                            children: " +"
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mt-5 sm:mt-6 sm:grid sm:grid-cols-3 sm:gap-2 sm:grid-flow-row-dense",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                                            onClick: ()=>props.toggleLookUpModal(),
                                            children: "Close"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "mt-3 w-full inline-flex justify-center rounded-md border border-orange-400 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:mt-0 sm:col-start-2 sm:text-sm",
                                            onClick: ()=>props.clearToggle(props.selectedField[1].field),
                                            children: "Clear"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $00023a56675d4591$var$ClipboardDocumentListIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
    }));
}
const $00023a56675d4591$var$ForwardRef = $acw62.forwardRef($00023a56675d4591$var$ClipboardDocumentListIcon);
var $00023a56675d4591$export$2e2bcd8739ae039 = $00023a56675d4591$var$ForwardRef;


function $61170548eb542737$export$2e2bcd8739ae039({ isOpen: isOpen, templates: templates, closeModal: closeModal, applyTemplate: applyTemplate }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Root, {
        show: isOpen,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-40 inset-0 overflow-y-auto",
            onClose: closeModal,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "inline-block w-3/4 h-3/4 align-bottom animate-color-change-2x border-cyan-400 border-2 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "animate-color-change-2x px-4 pt-5 pb-4 sm:p-6 sm:pb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "sm:flex sm:items-start",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full animate-color-change-2x sm:mx-0 sm:h-10 sm:w-10",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00023a56675d4591$export$2e2bcd8739ae039), {
                                                        className: "h-9 w-9 text-gray-100",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "mt-3 text-center sm:mt-0 sm:ml-2 sm:text-left",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Title, {
                                                        as: "h3",
                                                        className: "mt-2 text-2xl leading-6 font-medium text-gray-100",
                                                        children: "Templates"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-5 space-y-5"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "animate-color-change-2x px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-cyan-600 text-base font-medium text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 sm:ml-3 sm:w-auto sm:text-sm",
                                            onClick: closeModal,
                                            children: "Apply"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-transparent text-base font-medium text-gray-100 hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm",
                                            onClick: closeModal,
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}





const $88038a8a6abae7c6$export$ba5d8ec873883835 = (data, prefix)=>{
    const flattenedData = [];
    const flattenObject = (obj, parentKey)=>{
        for (const [key, value] of Object.entries(obj)){
            let newKey = key;
            if (key.length < 5) newKey = `${parentKey}`;
            if (typeof value === "object" && !Array.isArray(value) && !key.includes("^")) flattenObject(value, newKey);
            else if (Array.isArray(value)) for(let i = 0; i < value.length; i++){
                const repeatedKey = `${newKey}`;
                if (typeof value[i] === "object") flattenObject(value[i], repeatedKey);
                else if (typeof value[i] === "string" && (value[i].includes("^") || value[i].includes("~"))) splitValue(value[i], repeatedKey);
                else flattenedData.push([
                    repeatedKey,
                    value[i]
                ]);
            }
            else if (typeof value === "string") splitValue(value, newKey);
            else flattenedData.push([
                newKey,
                value
            ]);
        }
    };
    const splitValue = (value, key)=>{
        const splitSymbols = [
            "^",
            "~"
        ];
        let subValues = [
            value
        ];
        splitSymbols.forEach((symbol)=>{
            let tempSubValues = [];
            subValues.forEach((subValue)=>{
                tempSubValues.push(...subValue.split(symbol));
            });
            subValues = tempSubValues;
        });
        subValues.forEach((subValue, i)=>{
            const subValueKey = `${key}`;
            flattenedData.push([
                subValueKey,
                subValue
            ]);
        });
    };
    flattenObject(data, prefix);
    return flattenedData;
};
const $88038a8a6abae7c6$export$e4c0ff609fc1bf0d = (data, prefix)=>{
    const flattenedData = [];
    const flattenObject = (obj, parentKey)=>{
        for (const [key, value] of Object.entries(obj)){
            let newKey = key;
            if (key.length < 5) newKey = `${parentKey}`;
            if (typeof value === "object" && !Array.isArray(value) && !key.includes("^")) flattenObject(value, newKey);
            else if (Array.isArray(value)) for(let i = 0; i < value.length; i++){
                const repeatedKey = `${newKey}.${i + 1}`;
                if (typeof value[i] === "object") flattenObject(value[i], repeatedKey);
                else if (typeof value[i] === "string" && (value[i].includes("^") || value[i].includes("~"))) splitValue(value[i], repeatedKey);
                else flattenedData.push([
                    repeatedKey,
                    value[i]
                ]);
            }
            else if (typeof value === "string") splitValue(value, newKey);
            else flattenedData.push([
                newKey,
                value
            ]);
        }
    };
    const splitValue = (value, key)=>{
        const splitSymbols = [
            "^",
            "~"
        ];
        let subValues = [
            value
        ];
        splitSymbols.forEach((symbol)=>{
            let tempSubValues = [];
            subValues.forEach((subValue)=>{
                tempSubValues.push(...subValue.split(symbol));
            });
            subValues = tempSubValues;
        });
        subValues.forEach((subValue, i)=>{
            const subValueKey = `${key}`;
            flattenedData.push([
                subValueKey,
                subValue
            ]);
        });
    };
    flattenObject(data, prefix);
    return flattenedData;
};
const $88038a8a6abae7c6$export$b74c33566721f70f = (s, p)=>{
    const dp = Array(p.length + 1).fill(0).map((_)=>({}));
    return $88038a8a6abae7c6$var$match(s, p, 0, 0, dp);
};
const $88038a8a6abae7c6$var$match = (s, p, sIndex, pIndex, dp)=>{
    if (dp[pIndex][sIndex] !== undefined) return dp[pIndex][sIndex];
    const sNow = s[sIndex];
    const pNow = p[pIndex];
    let res = false;
    if (pNow === undefined) return sNow === undefined;
    if (sNow === undefined) {
        for(let i = pIndex; i < p.length; i++){
            if (p[i] !== "*") return false;
        }
        return true;
    }
    if (sNow === pNow || pNow === "?") res = $88038a8a6abae7c6$var$match(s, p, sIndex + 1, pIndex + 1, dp);
    else if (pNow === "*") res = $88038a8a6abae7c6$var$match(s, p, sIndex, pIndex + 1, dp) || $88038a8a6abae7c6$var$match(s, p, sIndex + 1, pIndex + 1, dp) || $88038a8a6abae7c6$var$match(s, p, sIndex + 1, pIndex, dp);
    dp[pIndex][sIndex] = res;
    return res;
};
const $88038a8a6abae7c6$export$bf963ad3d79ab10a = async (hl7, lookups)=>{
    for(let i = 0; i < Object.entries(lookups).length; i++){
        const lookup = Object.entries(lookups)[i][1];
        if (lookup.field) {
            const messageValue = hl7.get(lookup.field);
            if (!messageValue && lookup?.default) hl7.set(lookup.field, lookup.default);
            else if (lookup.map) for(let j = 0; j < Object.entries(lookup.map).length; j++){
                const { value: value, key: key } = lookup.map[j];
                if (key && value) {
                    if ($88038a8a6abae7c6$export$b74c33566721f70f(messageValue, key)) hl7.set(lookup.field, value);
                }
            }
        }
    }
    return hl7.build();
};
const $88038a8a6abae7c6$var$swapWithUserKeys = (obj, oldKey, newKey)=>{
    const updatedObj = {};
    for (const [key, value] of Object.entries(obj))if (typeof value === "object" && !Array.isArray(value)) updatedObj[key] = $88038a8a6abae7c6$var$swapWithUserKeys(value, oldKey, newKey);
    else updatedObj[key === oldKey ? newKey : key] = value;
    return updatedObj;
};
const $88038a8a6abae7c6$var$detectSegmentShape = (segmentData, segmentField, field, segmentCount)=>{
    if (segmentCount < 2) {
        if (typeof segmentData.data[field] === "string") return "field";
        if (typeof segmentData.data[segmentField] === "string") return "subfield";
        if (Array.isArray(segmentData.data[segmentField])) return "complex";
    }
    if (segmentCount > 1) {
        if (Array.isArray(segmentData.data[segmentField])) return "complex-repeat";
        if (typeof segmentData.data[field] === "string") return "repeat-simp";
    }
    if (typeof segmentData.data == "object") {
        if (segmentData?.data[segmentField] && Object.entries(segmentData.data[segmentField]).length < 2) return "repeat";
        if (segmentData?.data[segmentField] && Object.entries(segmentData.data[segmentField]).length > 1) return "no-repeat";
    }
    return "unknown";
};
const $88038a8a6abae7c6$var$flattenShortKeys = (payload)=>{
    const updatedPayload = {};
    for (const [key, value] of Object.entries(payload)){
        if (typeof key === "string" && key.length < 3 && typeof value === "object" && !Array.isArray(value)) Object.assign(updatedPayload, $88038a8a6abae7c6$var$flattenShortKeys(value)); // Flatten the object into the parent
        else if (typeof value === "object" && !Array.isArray(value)) updatedPayload[key] = $88038a8a6abae7c6$var$flattenShortKeys(value); // Recursive call for nested objects
        else updatedPayload[key] = value; // Simply assign the value if none of the above conditions are met
    }
    return updatedPayload;
};
const $88038a8a6abae7c6$export$4955ad71ca9c898e = (payload)=>{
    const updatedPayload = {};
    for (const [key, value] of Object.entries(payload)){
        if (Array.isArray(value) && value.length === 0) continue;
        else if (typeof value === "object" && !Array.isArray(value)) {
            updatedPayload[key] = $88038a8a6abae7c6$export$4955ad71ca9c898e(value);
            if (Object.keys(updatedPayload[key]).length === 0) delete updatedPayload[key];
        } else updatedPayload[key] = value;
    }
    return updatedPayload;
};
const $88038a8a6abae7c6$var$expandSegment = (segmentData, segment, segmentField, field, innerReplacements)=>{
    const repeatingPayloads = [];
    segmentData.data[segmentField].forEach((repeatingData)=>{
        const repeatingPayload = {};
        if (Object.keys(repeatingData).length > 1) Object.keys(repeatingData).forEach((repeatingField)=>{
            const replacementKey = innerReplacements[repeatingField] || repeatingField;
            repeatingPayload[replacementKey] = repeatingData[repeatingField];
        });
        else Object.assign(repeatingPayload, repeatingData);
        if (Object.keys(repeatingPayload).length > 0) repeatingPayloads.push(repeatingPayload);
    });
    return repeatingPayloads;
};
const $88038a8a6abae7c6$var$orderSegment = (segmentData, fieldMapping)=>{
    const newSegmentData = {};
    for (let [oldKey, newKey] of Object.entries(fieldMapping))if (segmentData[oldKey]) newSegmentData[newKey] = segmentData[oldKey];
    return newSegmentData;
};
const $88038a8a6abae7c6$export$200c619e846540a2 = (workflowFields, sampleMessage)=>{
    let payload = {};
    const fieldMap = Object.entries(workflowFields);
    fieldMap.forEach(([key, value])=>{
        const segment = key.split(".")[0];
        const field = `${segment}.${key.split(".")[1]}`;
        const seg = key.substring(0, key.length - 2);
        sampleMessage.getSegments(segment).forEach((segmentObject, idx)=>{
            let segmentPayload;
            const segmentCount = sampleMessage.getSegments(segment).length; // Number of segments of this type in the message
            const dataType = $88038a8a6abae7c6$var$detectSegmentShape(segmentObject, field, key, segmentCount);
            if (!payload[segment] && segmentCount < 2) payload[segment] = {};
            if (!payload[segment] && segmentCount > 1) payload[segment] = [];
            // console.info(`${value}, ${key}, ${dataType}, ${segmentCount}`);
            const segments = sampleMessage.getSegments(segment);
            switch(dataType){
                case "field":
                    payload[segment][value] = sampleMessage.get(key);
                    break;
                case "subfield":
                    payload[segment][value] = segmentObject.data[field][key];
                    break;
                case "complex":
                    const pay = $88038a8a6abae7c6$var$expandSegment(segmentObject, segment, field, key, value);
                    segmentPayload = pay.map((subPayload)=>$88038a8a6abae7c6$var$orderSegment(subPayload, workflowFields));
                    if (!payload[segment][seg]) payload[segment][seg] = {};
                    payload[segment][seg] = segmentPayload;
                    break;
                case "repeat":
                    payload[segment][value] = segmentObject.data[field][key];
                    break;
                case "no-repeat":
                    if (!payload[segment][idx]) payload[segment][idx] = {};
                    payload[segment][idx][value] = segmentObject.data[field][key];
                    break;
                case "complex-repeat":
                    const array = segmentObject.data[field];
                    array.forEach((subArray)=>{
                        if (!payload[segment][idx]) payload[segment][idx] = {};
                        if (!payload[segment][idx][value]) payload[segment][idx][value] = [];
                        payload[segment][idx][value].push(subArray[key]);
                    });
                    break;
                case "repeat-simp":
                    Object.entries(segments).forEach((Segment, i = 0)=>{
                        if (i == idx) {
                            if (!payload[segment][idx]) payload[segment][idx] = {};
                            payload[segment][idx][value] = Segment[1].data[field];
                        }
                        i++;
                    });
                    break;
                default:
                    console.dir(`Unknown data type`);
                    break;
            }
            idx++;
        });
    });
    return $88038a8a6abae7c6$export$4955ad71ca9c898e($88038a8a6abae7c6$var$flattenShortKeys(payload));
};
const $88038a8a6abae7c6$var$createFullUrl = (resourceType)=>{
    return `urn:uuid:${resourceType}-${(0, (/*@__PURE__*/$parcel$interopDefault($92d8b824f9c60d69$exports)))()}`;
};
const $88038a8a6abae7c6$var$capitalizeFirstLetter = (string)=>{
    string.charAt(0).toUpperCase(), string.slice(1);
};
const $88038a8a6abae7c6$var$addDataToResource = (resource, dots, sampleValue)=>{
    const pathParts = dots.split(".");
    let currentPart = resource;
    pathParts.forEach((part, index)=>{
        if (index === pathParts.length - 1) {
            if (part.includes("[")) {
                const match = part.match(/(\w+)\[(\d+)\]/);
                const arrName = match[1];
                const arrIndex = parseInt(match[2], 10);
                currentPart[arrName] = currentPart[arrName] || [];
                currentPart[arrName][arrIndex] = currentPart[arrName][arrIndex] || {};
                currentPart[arrName][arrIndex] = sampleValue;
            } else currentPart[part] = sampleValue;
        } else {
            if (!currentPart[part]) currentPart[part] = {};
            currentPart = currentPart[part];
        }
    });
    return resource;
};
const $88038a8a6abae7c6$var$createFHIRResource = (fields, sampleMessage)=>{
    const resources = {};
    const sampleHL7 = new (0, (/*@__PURE__*/$parcel$interopDefault($6e5adace1676779e$exports)))(sampleMessage);
    sampleHL7.transform(async (err)=>{
        if (err) console.log(err);
    });
    for (const [key, dotNotationPath] of Object.entries(fields)){
        const resourceType = $88038a8a6abae7c6$var$capitalizeFirstLetter(dotNotationPath.split(".")[0]); // Get the resource type from the dot notation
        const sampleValue = key ? sampleHL7.get(key) : "";
        if (!resources[resourceType]) resources[resourceType] = {
            resourceType: resourceType
        };
        $88038a8a6abae7c6$var$addDataToResource(resources[resourceType], dotNotationPath.substring(resourceType.length + 1), sampleValue);
    }
    return Object.values(resources).map((resource)=>({
            fullUrl: $88038a8a6abae7c6$var$createFullUrl(resource.resourceType),
            resource: resource
        }));
};
const $88038a8a6abae7c6$export$f0c2af32e7047853 = (fields, sampleMessage)=>{
    const entries = $88038a8a6abae7c6$var$createFHIRResource(fields, sampleMessage);
    return {
        resourceType: "Bundle",
        type: "transaction",
        entry: entries.map((entry)=>({
                Resource: entry
            }))
    };
};



const $a4fc57cf391e3576$var$hl7v2EventTofhirr4MethodMap = [
    {
        "id": 1,
        "hl7v2": "A01",
        "label": "A01 -> Create",
        "method": "CREATE"
    },
    {
        "id": 2,
        "hl7v2": "A08",
        "label": "A08 -> Update",
        "method": "UPDATE"
    },
    {
        "id": 3,
        "hl7v2": "A02",
        "label": "A02 -> Update",
        "method": "UPDATE"
    },
    {
        "id": 4,
        "hl7v2": "A04",
        "label": "A04 -> Create",
        "method": "CREATE"
    },
    {
        "id": 5,
        "hl7v2": "A05",
        "label": "A05 -> Create",
        "method": "CREATE"
    },
    {
        "id": 6,
        "hl7v2": "A11",
        "label": "A11 -> Update",
        "method": "UPDATE"
    },
    {
        "id": 7,
        "hl7v2": "A12",
        "label": "A12 -> Update",
        "method": "UPDATE"
    },
    {
        "id": 8,
        "hl7v2": "A13",
        "label": "A13 -> Update",
        "method": "UPDATE"
    },
    {
        "id": 9,
        "hl7v2": "A31",
        "label": "A31 -> Update",
        "method": "UPDATE"
    },
    {
        "id": 10,
        "hl7v2": "A40",
        "label": "A40 -> Update",
        "method": "UPDATE"
    },
    {
        "id": 11,
        "hl7v2": "A03",
        "label": "A03 -> Update",
        "method": "UPDATE"
    }
];
function $a4fc57cf391e3576$export$2e2bcd8739ae039(props) {
    const { post: post, response: response, loading: loading } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)((0, $15f24a665de742b6$export$2e2bcd8739ae039).url);
    const placeholder = {
        SK: "",
        PK: "",
        flowName: "",
        icon: "",
        sampleMessage: "",
        trigger: {
            type: "MLLP",
            formula: "",
            key: "",
            custom: {},
            host: "",
            port: 22,
            username: "",
            password: "",
            path: ""
        },
        next: {
            type: "HTTPS JSON",
            url: "",
            ip: "",
            port: "",
            action: "",
            key: "",
            bucket: "",
            method: ""
        },
        fields: {},
        lookups: [],
        events: [],
        environment: props.selectedEnvironment,
        workspace: props.selectedWorkspace,
        owner: props.user,
        workspaceId: props.selectedWorkspace.SK,
        environmentId: props?.selectedEnvironment?.SK
    };
    const [ux, setUx] = (0, $acw62.useState)("list");
    const [error, setError] = (0, $acw62.useState)("");
    const [copied, setCopied] = (0, $acw62.useState)(false);
    const [pending, setPending] = (0, $acw62.useState)(false);
    const [lookUpModal, setLookUpModal] = (0, $acw62.useState)(false);
    const [segmentFields, setSegmentFields] = (0, $acw62.useState)(null);
    const [selectedField, setSelectedField] = (0, $acw62.useState)([
        {
            field: null
        }
    ]);
    const [selectedFieldMap, setSelectedFieldMap] = (0, $acw62.useState)([]);
    const [selectedDefaultValue, setSelectedDefaultValue] = (0, $acw62.useState)("");
    const [triggerSample, setTriggerSample] = (0, $acw62.useState)("");
    const [triggerMap, setTriggerMap] = (0, $acw62.useState)(false);
    const [showEnvironmentDropdown, setShowEnvironmentDropdown] = (0, $acw62.useState)(false);
    const [trigger, setTrigger] = (0, $acw62.useState)(null);
    const [next, setNext] = (0, $acw62.useState)(null);
    const [sampleMap, setSampleMap] = (0, $acw62.useState)({});
    const [sampleMessageInput, setSampleMessageInput] = (0, $acw62.useState)(true);
    const [targets, setTargets] = (0, $acw62.useState)(null);
    const [fieldMapGrid, setFieldMapGrid] = (0, $acw62.useState)([]);
    const [eventTriggerGrid, setEventTriggerGrid] = (0, $acw62.useState)([]);
    const [sampleFilter, setSampleFilter] = (0, $acw62.useState)(true);
    const [definitions, setDefinitions] = (0, $acw62.useState)([]);
    const [workflow, setWorkflow] = (0, $acw62.useState)(placeholder);
    const [currentLookups, setCurrentLookups] = (0, $acw62.useState)({});
    const [unchanged, setUnchanged] = (0, $acw62.useState)(props.workflow);
    const [showConfirmModal, setShowConfirmModal] = (0, $acw62.useState)(false);
    const [showMessageIDModal, setShowMessageIDModal] = (0, $acw62.useState)(false);
    const [messageEvent, setMessageEvent] = (0, $acw62.useState)("");
    const [fhirMap, setFhirMap] = (0, $acw62.useState)();
    const [fhirLoading, setFhirLoading] = (0, $acw62.useState)(false);
    const [fhirSampleMap, setFHIRSampleMap] = (0, $acw62.useState)({});
    const [showTemplatesModal, setShowTemplatesModal] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!definitions.length) bootstrapDefinitions();
    }, [
        JSON.stringify(props.selectedEnvironment)
    ]);
    (0, $acw62.useEffect)(()=>{
        if (workflow.SK) loadWorkflow(workflow);
        if (workflow.fields && workflow.sampleMessage) validatePayload();
    }, [
        workflow?.SK,
        workflow?.sampleMessage
    ]);
    (0, $acw62.useEffect)(()=>{
        if (workflow.trigger.type.substring(0, 4) == "MLLP") hydrateMappingGrids();
    }, [
        sampleFilter
    ]);
    const bootstrapDefinitions = async ()=>{
        const PK = props.user.account.PK ? props.user.account.PK : "";
        const definitions = await post(`workflow/get-definitions/`);
        if (response.ok && definitions) {
            const defs = Object.entries(definitions.definitions[0].definition);
            setDefinitions(defs);
        }
    };
    const hydrateMappingGrids = async ()=>{
        if (definitions.length > 0 && workflow.sampleMessage) {
            const newFieldMapGrid = [];
            const newTriggerMapGrid = [];
            let triggerSampleData = [];
            const sampleHL7 = new (0, (/*@__PURE__*/$parcel$interopDefault($6e5adace1676779e$exports)))(workflow.sampleMessage);
            sampleHL7.transform(async (err)=>{
                if (err) console.log(err);
            });
            const segments = sampleHL7.getSegments();
            const sampleData = [];
            for(let i = 0; i < segments.length; i++){
                const segment = Object.entries(segments[i].data);
                segment.forEach((entry)=>{
                    const [key, value] = entry;
                    if (typeof value === "object") {
                        const subfieldEntries = Object.entries(value);
                        subfieldEntries.forEach(([subfieldKey, subfieldValue])=>{
                            let newSubfieldKey = subfieldKey;
                            if (typeof subfieldValue === "object") {
                                const flattenedSubfieldData = (0, $88038a8a6abae7c6$export$ba5d8ec873883835)(subfieldValue, newSubfieldKey);
                                sampleData.push(...flattenedSubfieldData);
                            } else {
                                const flattenedSubfieldData = (0, $88038a8a6abae7c6$export$e4c0ff609fc1bf0d)(value, newSubfieldKey);
                                sampleData.push(...flattenedSubfieldData);
                            }
                        });
                    } else sampleData.push([
                        key,
                        value
                    ]);
                });
            }
            const fields = Object.entries(workflow.fields);
            const triggerObject = workflow.trigger.custom ? workflow.trigger.custom : {};
            sampleData.map((entry)=>{
                let specificationKey = null;
                let specificationValue = null;
                const [entryKey, entryValue] = entry;
                const specificationMap = definitions.filter((Map)=>{
                    if (Map[0] === entryKey) return Map;
                });
                if (specificationMap[0]) {
                    specificationKey = specificationMap[0][0];
                    specificationValue = specificationMap[0][1];
                }
                fields.map((field)=>{
                    const [fieldKey, fieldValue] = field;
                    const duplicateFields = newFieldMapGrid.filter((row)=>row[1].field === fieldKey);
                    if (entryKey === fieldKey && fieldValue && duplicateFields.length === 0) newFieldMapGrid.push([
                        {
                            definition: specificationValue ? specificationValue : "CUSTOM"
                        },
                        {
                            field: entryKey
                        },
                        {
                            sample: entryValue ? entryValue : ""
                        },
                        {
                            target: fieldValue
                        }
                    ]);
                });
                for(let index = 0; index < Object.entries(triggerObject).length; index++){
                    const filter = Object.entries(triggerObject)[index];
                    if (entryKey === filter[0] && filter[1] && props.selectedWorkspace.hash.location !== entryKey) newTriggerMapGrid.push([
                        {
                            definition: specificationValue ? specificationValue : "CUSTOM"
                        },
                        {
                            field: entryKey
                        },
                        {
                            sample: entryValue ? entryValue : ""
                        },
                        {
                            filter: filter[1]
                        }
                    ]);
                }
                const duplicateTriggerFields = newTriggerMapGrid.filter((row)=>row[1].field === entryKey);
                const duplicateFields = newFieldMapGrid.filter((row)=>row[1].field === entryKey);
                if (props.selectedWorkspace && props.selectedWorkspace.hash.location === entryKey) triggerSampleData = entryValue ? entryValue : "";
                if (duplicateTriggerFields.length < 1 && sampleFilter) {
                    if (!specificationValue && entryValue.length > 0 && props.selectedWorkspace.hash.location !== entryKey || specificationValue && props.selectedWorkspace.hash.location !== entryKey) newTriggerMapGrid.push([
                        {
                            definition: specificationValue ? specificationValue : "CUSTOM"
                        },
                        {
                            field: entryKey
                        },
                        {
                            sample: entryValue ? entryValue : ""
                        },
                        {
                            filter: ""
                        }
                    ]);
                }
                if (duplicateFields.length < 1 && sampleFilter) {
                    if (!specificationValue && entryValue.length > 0 || specificationValue) newFieldMapGrid.push([
                        {
                            definition: specificationValue ? specificationValue : "CUSTOM"
                        },
                        {
                            field: entryKey
                        },
                        {
                            sample: entryValue ? entryValue : ""
                        },
                        {
                            target: ""
                        }
                    ]);
                }
            });
            const messageEventFromMessage = sampleHL7.get("MSH.9.2");
            let mappedEvent;
            if (workflow.next.type == "S3 FHIR R4" || workflow.next.type == "HTTPS FHIR R4") {
                mappedEvent = $a4fc57cf391e3576$var$hl7v2EventTofhirr4MethodMap.filter((event)=>event.hl7v2 === messageEventFromMessage);
                mappedEvent[0] && updateTriggerMethod(mappedEvent[0]);
            }
            setTriggerSample(triggerSampleData);
            setEventTriggerGrid(newTriggerMapGrid);
            setFieldMapGrid(newFieldMapGrid);
        }
    };
    const updateFieldMap = async (event)=>{
        event.preventDefault();
        if (workflow.trigger.type.substring(0, 4) == "MLLP") {
            if (event.target.value.length < 1) removeFieldMapRow(workflow.fields[event.target.id]);
            else workflow.fields[event.target.id] = event.target.value;
        }
        if (workflow.trigger.type.substring(0, 4) == "HTTP") {
            if (event.target.length < 1) removeFieldMapRow(workflow.fields[event.key]);
            else workflow.fields[event.key] = event.target;
        }
        setWorkflow(workflow);
        hydrateMappingGrids();
    };
    const canCreate = ()=>{
        const hasUpdateWorkflowInSelectedWorkspace = props.selectedWorkspace.accounts.filter((account)=>{
            if (account.PK && account.permissions.workflows.create) return account;
        });
        const isWorkspaceOwner = props.selectedWorkspace.owner.email === props.user.account.email;
        if (props.admin === true || hasUpdateWorkflowInSelectedWorkspace.length || isWorkspaceOwner) return true;
        return false;
    };
    const canUpdate = ()=>{
        const hasUpdateWorkflowInSelectedWorkspace = props.selectedWorkspace.accounts.filter((account)=>{
            if (account.PK && account.permissions.workflows.update) return account;
        });
        const isWorkspaceOwner = props.selectedWorkspace.owner.email === props.user.account.email;
        if (props.admin === true || hasUpdateWorkflowInSelectedWorkspace.length || isWorkspaceOwner) return true;
        return false;
    };
    const loadWorkflow = async (flow)=>{
        setWorkflow(flow);
        setUnchanged(flow);
        hydrateMappingGrids();
        setNext(flow.next);
        setTrigger(flow.trigger);
        setUx("adapters");
        setCurrentLookups(workflow.lookups);
        if (flow.sampleMessage && flow.fields) validatePayload();
    };
    const saveWorkflow = async ()=>{
        setPending(true);
        if (triggerSample != props.selectedWorkspace.hash.value) setShowMessageIDModal(true);
        saveFlow();
        setPending(false);
    };
    const saveTemplate = async ()=>{
        const { selectedEnvironment: selectedEnvironment, selectedWorkspace: selectedWorkspace } = props;
        if (workflow.PK.length) {
            if (selectedWorkspace.SK != workflow.workspaceId && selectedEnvironment.SK == workflow.environmentId) {
                setPending(false);
                setError("SaveInAnotherAccountException");
            }
            if (selectedWorkspace.SK == workflow.workspaceId && selectedEnvironment.SK != workflow.environmentId) {
                if (canUpdate()) {
                    if (!workflow.SK) workflow.SK = "WFTEMPLATEID#" + (0, (/*@__PURE__*/$parcel$interopDefault($92d8b824f9c60d69$exports)))();
                    const template = {
                        name: workflow.flowName,
                        fields: workflow.fields,
                        next: workflow.next,
                        trigger: workflow.trigger,
                        lookups: workflow.lookups,
                        Entity: "WFTEMPLATE"
                    };
                    const body = {
                        template: template,
                        selectedEnvironment: selectedEnvironment
                    };
                    const PK = workflow.owner.attributes ? workflow.owner.attributes.id : workflow.owner.external_id;
                    const newTemplate = await post(`workflow/save-template/${PK}`, body);
                    setPending(false);
                } else {
                    setPending(false);
                    setError("UserPermissionsException");
                }
            }
        }
        if (!workflow.flowName) workflow.flowName = "My Template";
        if (workflow.PK && canUpdate() || !workflow.PK && canCreate()) {
            if (!workflow.SK) workflow.SK = "WFTEMPLATEID#" + (0, (/*@__PURE__*/$parcel$interopDefault($92d8b824f9c60d69$exports)))();
            const template = {
                name: workflow.flowName,
                fields: workflow.fields,
                next: workflow.next,
                trigger: workflow.trigger,
                lookups: workflow.lookups,
                Entity: "WFTEMPLATE"
            };
            const body = {
                template: template,
                selectedEnvironment: selectedEnvironment
            };
            const PK = workflow.owner.attributes ? workflow.owner.attributes.id : workflow.owner.external_id;
            const newTemplate = await post(`workflow/save-template/${PK}`, body);
            if (response.ok && newTemplate) console.dir(newTemplate);
        }
    };
    const saveFlow = async ()=>{
        const { selectedEnvironment: selectedEnvironment, selectedWorkspace: selectedWorkspace } = props;
        if (workflow.PK.length) {
            if (selectedWorkspace.SK != workflow.workspaceId && selectedEnvironment.SK == workflow.environmentId) {
                setPending(false);
                setError("SaveInAnotherAccountException");
            }
        }
        if (!workflow.flowName) workflow.flowName = "My Workflow";
        if (selectedEnvironment.name.substring(0, 3) != "Dev") workflow.trigger.custom[selectedWorkspace.hash.location] = selectedWorkspace.hash.value;
        else delete workflow.trigger.custom[selectedWorkspace.hash.location];
        if (workflow.PK && canUpdate() || !workflow.PK && canCreate()) {
            if (!workflow.SK) workflow.SK = "WORKFLOWID#" + (0, (/*@__PURE__*/$parcel$interopDefault($92d8b824f9c60d69$exports)))();
            const body = {
                workflow: workflow,
                environment: selectedEnvironment,
                workspace: selectedWorkspace
            };
            const PK = workflow.owner.attributes ? workflow.owner.attributes.id : workflow.owner.external_id;
            workflow.PK = PK;
            const newFlow = await post(`workflow/save-workflow/${PK}`, body);
            if (response.ok && newFlow) {
                loadWorkflow(newFlow.wf);
                setUnchanged(newFlow.wf);
                setPending(false);
                setLookUpModal(false);
            }
        }
    };
    const isStarted = ()=>{
        if (workflow?.flowName != placeholder.flowName || workflow?.sampleMessage != placeholder.sampleMessage) return true;
        return false;
    };
    const handleFlowNameChange = (event)=>{
        const updated = {
            ...workflow,
            flowName: event.target.value
        };
        setWorkflow(updated);
    };
    const handleSampleMessageChange = (event)=>{
        workflow.sampleMessage = event.target.value;
        const updated = {
            ...workflow,
            sampleMessage: event.target.value
        };
        setWorkflow(updated);
        if (event.target.id == "sample-message-hl7v2") hydrateMappingGrids();
    };
    const handleNextS3BucketName = (event)=>{
        const updated = {
            ...workflow,
            next: {
                ...workflow.next,
                bucket: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const handleNextS3Key = (event)=>{
        const updated = {
            ...workflow,
            next: {
                ...workflow.next,
                key: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const createS3Bucket = async ()=>{
        const bucketName = workflow.next.bucket;
        const { selectedEnvironment: selectedEnvironment, selectedWorkspace: selectedWorkspace } = props;
        const body = {
            environment: selectedEnvironment,
            workspace: selectedWorkspace,
            account: props.user.account,
            bucketName: bucketName
        };
        const bucket = await post(`environment/create-s3-bucket/${props.user.attributes.id}`, body);
        if (bucket && response.ok) {
            console.dir(bucket);
            setPending(false);
        }
    };
    const handleNextUrl = (event)=>{
        const updated = {
            ...workflow,
            next: {
                ...workflow.next,
                url: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const handleNextIP = (event)=>{
        const updated = {
            ...workflow,
            next: {
                ...workflow.next,
                ip: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const handleNextPort = (event)=>{
        const updated = {
            ...workflow,
            next: {
                ...workflow.next,
                port: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const validatePayload = async ()=>{
        if (workflow.trigger.type.substring(0, 4) == "MLLP" && workflow.sampleMessage) {
            const sample = new (0, (/*@__PURE__*/$parcel$interopDefault($6e5adace1676779e$exports)))(workflow.sampleMessage);
            sample.transform(async (err)=>{
                if (err) console.log(err);
            });
            if (workflow.lookups.length > 0) {
                const transformed = await (0, $88038a8a6abae7c6$export$bf963ad3d79ab10a)(sample, workflow.lookups);
                const hl7 = new (0, (/*@__PURE__*/$parcel$interopDefault($6e5adace1676779e$exports)))(transformed);
                hl7.transform((err)=>{
                    if (err) throw err;
                });
                const payload = await (0, $88038a8a6abae7c6$export$200c619e846540a2)(workflow.fields, hl7);
                setSampleMap(payload);
            } else {
                const payload = await (0, $88038a8a6abae7c6$export$200c619e846540a2)(workflow.fields, sample);
                setSampleMap(payload);
            }
        }
    };
    const updateFieldMapKey = (event)=>{
        for(let index = 0; index < workflow.lookups.length; index++){
            const lookup = workflow.lookups[index];
            // We have lookups for this field
            if (lookup.field && lookup.field == selectedField[1].field) {
                const maps = lookup.map;
                for(let index2 = 0; index2 < maps.length; index2++){
                    const map = maps[index2];
                    const id = event.target.id.split("-")[2] + 1;
                    if (map.id == id) map.key = event.target.value;
                }
            }
        }
        setWorkflow(workflow);
        validatePayload();
    };
    const updateFieldMapValue = (event)=>{
        for(let index = 0; index < workflow.lookups.length; index++){
            const lookup = workflow.lookups[index];
            // We have lookups for this field
            if (lookup.field == selectedField[1].field) {
                const maps = lookup.map;
                for(let index2 = 0; index2 < maps.length; index2++){
                    const map = maps[index2];
                    const id = event.target.id.split("-")[2] + 1;
                    if (map.id == id) {
                        if (event.target.value.length > 0) map.value = event.target.value;
                        else removeRow(index2);
                    }
                }
            }
        }
        setWorkflow(workflow);
        validatePayload();
    };
    const updateWorkflowEnvironment = async (selectedEnvironment, selectedWorkspace, workflow)=>{
        setPending(true);
        workflow.PK = workflow.owner.attributes.id;
        const body = {
            previousEnvironment: workflow.environment,
            selectedEnvironment: selectedEnvironment,
            selectedWorkspace: selectedWorkspace,
            workflow: workflow
        };
        await post(`workflow/move-workflow/${props.user.attributes.id}`, body);
        if (response.ok) {
            setLookUpModal(false);
            setPending(false);
        }
    };
    const handleLookupDefaultValueChange = (event)=>{
        event.preventDefault();
        for(let index = 0; index < workflow.lookups.length; index++){
            const lookup = workflow.lookups[index];
            if (lookup.field == selectedField[1].field) lookup.default = event.target.value;
        }
        setWorkflow(workflow);
        setSelectedDefaultValue(event.target.value);
    };
    const toggleLookUpModal = (fieldMap)=>{
        if (fieldMap) {
            let found = false;
            const { lookups: lookups } = workflow;
            if (lookups?.length > 0) {
                for(let a = 0; a < lookups.length; a++){
                    const lookup = lookups[a];
                    if (lookup.field == fieldMap[1].field) {
                        found = true;
                        if (!lookup.default) setWorkflow(workflow);
                        setSelectedDefaultValue(lookup.default);
                        setSelectedField(fieldMap);
                        setSelectedFieldMap(lookup);
                    }
                }
                if (found == false) {
                    const lookup = {
                        field: fieldMap[1].field,
                        map: [
                            {
                                id: 1,
                                key: "",
                                value: ""
                            }
                        ],
                        default: ""
                    };
                    workflow.lookups.push(lookup);
                    for(let a = 0; a < workflow.lookups.length; a++){
                        const lookup = workflow.lookups[a];
                        if (lookup.field == fieldMap[1].field) {
                            found = true;
                            if (!lookup.default) setWorkflow(workflow);
                            setSelectedDefaultValue(lookup.default);
                            setSelectedField(fieldMap);
                            setSelectedFieldMap(lookup);
                        }
                    }
                }
                setLookUpModal(true);
            } else {
                workflow.lookups = [
                    {
                        field: fieldMap[1].field,
                        map: [
                            {
                                id: 1,
                                key: "",
                                value: ""
                            }
                        ],
                        default: ""
                    }
                ];
                const selectedFieldMap = workflow.lookups[0];
                setSelectedDefaultValue("");
                setSelectedField(fieldMap);
                setSelectedFieldMap(selectedFieldMap);
                setLookUpModal(true);
                setWorkflow(workflow);
            }
        } else setLookUpModal(false);
    };
    const addRowToLookupsHandler = ()=>{
        workflow.lookups.map((lookup)=>{
            if (lookup.field == selectedField[1].field) lookup.map.push({
                id: lookup.map.length + 1,
                key: "",
                value: ""
            });
        });
        setWorkflow(workflow);
        setCurrentLookups(workflow.lookups);
        toggleLookUpModal(selectedField);
    };
    const removeRow = (id)=>{
        workflow.lookups.map((lookup)=>{
            if (lookup.field == selectedField[1].field) lookup.map.splice(lookup.map.indexOf(lookup.map[id]), 1);
        });
        setWorkflow(workflow);
    };
    const removeFieldMapRow = (rowArray)=>{
        if (rowArray[1]?.field) {
            const row = {
                definition: rowArray[0].definition,
                field: rowArray[1]?.field,
                sample: rowArray[2].sample,
                target: rowArray[3].target
            };
            delete workflow.fields[row.field];
        }
        setWorkflow(workflow);
        hydrateMappingGrids();
    };
    const updateTrigger = (event)=>{
        if (event.target.value.length > 0) {
            workflow.trigger.custom[event.target.id] = event.target.value;
            const triggerArray = Object.entries(workflow.trigger.custom);
            workflow.trigger.key = triggerArray.map((row)=>{
                return row[1];
            }).join(".");
            workflow.trigger.formula = triggerArray.map((row)=>{
                return row[0];
            }).join("-");
            setWorkflow(workflow);
        } else {
            delete workflow.trigger.custom[event.target.id];
            const triggerArray = Object.entries(workflow.trigger.custom);
            workflow.trigger.key = triggerArray.map((row)=>{
                return row[1];
            }).join(".");
            workflow.trigger.formula = triggerArray.map((row)=>{
                return row[0];
            }).join("-");
            setWorkflow(workflow);
        }
    };
    const removeTriggerMapRow = (rowArray)=>{
        const row = {
            definition: rowArray[0].definition,
            field: rowArray[1].field,
            sample: rowArray[2].sample,
            target: rowArray[3].target
        };
        delete workflow.trigger.custom[row.field];
        setWorkflow(workflow);
        hydrateMappingGrids();
    };
    const setCsvFileHandler = (file)=>{
        const reader = new FileReader();
        reader.onload = (e)=>{
            const csv = reader.result;
            const lines = csv.split("\n");
            const headers = lines[0].split(",");
            const data = [];
            for(let i = 0; i < lines.length; i++){
                let obj = {};
                const currentline = lines[i].split(",");
                for(let j = 0; j < headers.length; j++)obj = {
                    id: i,
                    key: currentline[0],
                    value: currentline[1].replace(/[\n\r]+/g, "")
                };
                data.push(obj);
            }
            if (workflow.lookups.length > 0) for(let index = 0; index < workflow.lookups.length; index++){
                const lookup = workflow.lookups[index];
                if (lookup.field == selectedField[1].field) lookup.map = data;
            }
            setWorkflow(workflow);
        };
        reader.readAsText(file);
    };
    const clearToggle = (field)=>{
        if (workflow.lookups.length > 0) {
            for(let index = 0; index < workflow.lookups.length; index++)if (workflow.lookups[index].field === field) workflow.lookups[index] = {
                field: field,
                map: [
                    {
                        id: 1,
                        key: "",
                        value: ""
                    }
                ],
                default: ""
            };
        }
        setWorkflow(workflow);
        setLookUpModal(false);
    };
    const newWorkflowClickHandler = ()=>{
        setUx("adapters");
    };
    const backToListClickHandler = ()=>{
        if (isStarted()) setShowConfirmModal(true);
        else setUx("list");
    };
    const eventTriggerClickHandler = ()=>{
        setUx("e-layer");
    };
    const adapterClickHandler = ()=>{
        setUx("adapters");
    };
    const mapClickHandler = async ()=>{
        await hydrateMappingGrids();
        setUx("t-layer");
    };
    const loadClickHandler = async ()=>{
        if (workflow.next.type == "HTTPS JSON") await validatePayload();
        setUx("l-layer");
    };
    const enableSampleFilter = async ()=>{
        setSampleFilter(!sampleFilter);
        hydrateMappingGrids();
    };
    const updateEventTrigger = (event)=>{
        const trigger = event;
        workflow.trigger = {
            ...workflow.trigger,
            ...trigger
        };
        setWorkflow(workflow);
        setTrigger(trigger);
    };
    const updateActionTrigger = (event)=>{
        const next = event;
        workflow.next = {
            ...workflow.next,
            ...next
        };
        setWorkflow(workflow);
        setNext(next);
    };
    const fetchHL7v2Map = async ()=>{
        const body = {
            selectedAction: workflow.next.action
        };
        const segmentRequest = await post(`workflow/list-segments/json-hl7v2`, body);
        return segmentRequest.segments;
    };
    const fetchFHIRR4Map = async ()=>{
        setFhirLoading(true);
        const sampleMessageLines = workflow.sampleMessage.split(/\r?\n/);
        let fhirMapsCombined = {};
        for(let i = 0; i < sampleMessageLines.length; i++){
            if (sampleMessageLines[i].length <= 1) continue;
            const body = {
                sampleMessageSegment: sampleMessageLines[i]
            };
            try {
                const fhirMapRequest = await post(`workflow/hl7v2-to-fhir/`, body);
                const reqObj = Object.entries(fhirMapRequest);
                if (fhirMapRequest && reqObj.length > 0) Object.assign(fhirMapsCombined, fhirMapRequest);
            } catch (error) {
                console.error(`Error posting line ${i}:`, error);
            }
        }
        setFhirLoading(false);
        if (fhirMapsCombined) {
            setFhirMap(fhirMapsCombined);
            workflow.fields = fhirMapsCombined;
            setWorkflow(workflow);
            hydrateMappingGrids();
            const payload = (0, $88038a8a6abae7c6$export$f0c2af32e7047853)(fhirMapsCombined, workflow.sampleMessage);
            setFHIRSampleMap(payload);
        }
    };
    const getHL7SegmentFields = async (segments)=>{
        const body = {
            segments: segments
        };
        const segmentRequest = await post(`workflow/list-sample-segment-fields/${props.user.attributes.id}`, body);
        return segmentRequest.segmentRequest;
    };
    const updateHL7ActionTrigger = async (event)=>{
        const next = event;
        workflow.next.action = next.label;
        const segmentLists = await fetchHL7v2Map();
        const segmentFields = await getHL7SegmentFields(segmentLists);
        setSegmentFields(segmentFields);
        parseJSONSampleIntoGrid();
    };
    const parseJSONSampleIntoGrid = async ()=>{
        const fieldMapGrid = [];
        const segFields = segmentFields || await getHL7SegmentFields(workflow.next.action);
        segFields.map((row)=>{
            if (Object.entries(workflow.fields).length > 0) Object.entries(workflow.fields).map((field)=>{
                const [fieldKey, fieldValue] = field;
                if (row[0] === fieldKey && fieldValue) fieldMapGrid.push([
                    {
                        definition: row[1] ? row[1] : "CUSTOM"
                    },
                    {
                        field: row[0]
                    },
                    {
                        sample: fieldValue.value
                    },
                    {
                        target: fieldValue.key ? fieldValue.key : ""
                    }
                ]);
            });
            const duplicateFields = fieldMapGrid.filter((gridRow)=>{
                if (gridRow[1].field == row[0]) return gridRow;
            });
            if (duplicateFields.length === 0 && sampleFilter) fieldMapGrid.push([
                {
                    definition: row[1] ? row[1] : "CUSTOM"
                },
                {
                    field: row[0]
                },
                {
                    sample: ""
                },
                {
                    target: ""
                }
            ]);
        });
        setWorkflow(workflow);
        setFieldMapGrid(fieldMapGrid);
    };
    const parseJSONSampleMessage = (message)=>{
        const sample = Object.entries(message);
        const targets = [];
        sample.map((sampleRow)=>{
            const isPatient = sampleRow[0] == "patient";
            if (isPatient) {
                const patient = Object.entries(sampleRow[1]);
                patient.map((patientRow)=>{
                    if (typeof patientRow[1] === "string") targets.push({
                        key: patientRow[0],
                        value: patientRow[1],
                        label: patientRow[0]
                    });
                    if (typeof patientRow[1] === "object" && typeof patientRow[1][0] !== "object") targets.push({
                        key: patientRow[0],
                        value: patientRow[1][0],
                        label: patientRow[0]
                    });
                    if (typeof patientRow[1] === "object" && typeof patientRow[1][0] === "object") {
                        const position = Object.entries(patientRow[1][0])[0][1];
                        targets.push({
                            key: patientRow[0],
                            value: Object.entries(patientRow[1][0])[1][1],
                            label: patientRow[0]
                        });
                    }
                });
            }
        });
        setTargets(targets);
    };
    const setCopiedHandler = ()=>{
        setCopied(true);
    };
    const clearError = ()=>{
        setError("");
    };
    const showEnvironmentDropdownHandler = ()=>{
        setShowEnvironmentDropdown(!showEnvironmentDropdown);
    };
    const showSampleMessageInput = ()=>{
        setSampleMessageInput(!sampleMessageInput);
        setTriggerMap(!triggerMap);
    };
    const updateTriggerMethod = async (event)=>{
        const method = event.method;
        workflow.next.method = method;
        setWorkflow(workflow);
    };
    const onChangeHost = (event)=>{
        const updated = {
            ...workflow,
            trigger: {
                ...workflow.trigger,
                host: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const onChangeUsername = (event)=>{
        const updated = {
            ...workflow,
            trigger: {
                ...workflow.trigger,
                username: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const onChangePort = (event)=>{
        const updated = {
            ...workflow,
            trigger: {
                ...workflow.trigger,
                port: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const onChangePath = (event)=>{
        const updated = {
            ...workflow,
            trigger: {
                ...workflow.trigger,
                path: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const onChangeCadence = (option)=>{
        const updated = {
            ...workflow,
            cadence: option
        };
        setWorkflow(updated);
    };
    const onChangeCert = (event)=>{
        const updated = {
            ...workflow,
            trigger: {
                ...workflow.trigger,
                cert: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const onChangePrivateKey = (event)=>{
        const updated = {
            ...workflow,
            trigger: {
                ...workflow.trigger,
                privateKey: event.target.value
            }
        };
        setWorkflow(updated);
    };
    const showTemplates = ()=>{
        setShowTemplatesModal(!showTemplatesModal);
    };
    if (!props.selectedWorkspace || !props.selectedEnvironment) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "card",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "card-body text-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "display-4",
                                    children: "No Workspace Selected"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "lead",
                                    children: "Please select a workspace from the dropdown above."
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
    if (ux === "list") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60b9d21ed85a25dc$export$2e2bcd8739ae039), {
        user: props.user,
        account: props.account,
        accounts: props.accounts,
        environments: props.environments,
        setShowEnvironmentDropdown: showEnvironmentDropdownHandler,
        selectedEnvironment: props.selectedEnvironment,
        selectedWorkspace: props.selectedWorkspace,
        setSelectedEnvironment: props.setSelectedEnvironment,
        newWorkflowClickHandler: newWorkflowClickHandler,
        loadWorkflow: loadWorkflow,
        logout: props.logout,
        showEnvironmentDropdownHandler: showEnvironmentDropdownHandler,
        showEnvironmentDropdown: showEnvironmentDropdown,
        admin: props.admin,
        updateBillingCustomer: props.updateBillingCustomer
    });
    else if (ux != "list") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            showConfirmModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53dccccfeb3e8d8d$export$2e2bcd8739ae039), {
                isOpen: showConfirmModal,
                message: "You have unsaved changes. Are you sure you want to go back?",
                title: "Go Back?",
                onConfirm: ()=>{
                    setWorkflow(placeholder);
                    setUx("list");
                },
                onClose: ()=>setShowConfirmModal(false)
            }),
            showMessageIDModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53dccccfeb3e8d8d$export$2e2bcd8739ae039), {
                isOpen: showMessageIDModal,
                message: "Your sample message doesn't contain your workspace's unique message identifier. Are you sure you want to save?",
                title: "Unique Message Identifier",
                onConfirm: ()=>{
                    saveWorkflow();
                    setShowMessageIDModal(false);
                },
                onClose: ()=>setShowMessageIDModal(false)
            }),
            showTemplatesModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61170548eb542737$export$2e2bcd8739ae039), {
                isOpen: showTemplatesModal,
                templates: props.templates,
                applyTemplate: saveTemplate,
                closeModal: ()=>setShowTemplatesModal(false)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b57ad665d45a6002$export$2e2bcd8739ae039), {
                isStarted: isStarted,
                workflow: workflow,
                backToListClickHandler: backToListClickHandler,
                saveWorkflow: saveWorkflow,
                pending: pending,
                environments: props.environments,
                setShowEnvironmentDropdown: showEnvironmentDropdownHandler,
                showEnvironmentDropdownHandler: showEnvironmentDropdownHandler,
                showEnvironmentDropdown: showEnvironmentDropdown,
                user: props.user,
                accounts: props.accounts,
                selectedEnvironment: props.selectedEnvironment,
                account: props.account,
                selectedWorkspace: props.selectedWorkspace,
                setSelectedEnvironment: props.setSelectedEnvironment,
                loadClickHandler: loadClickHandler,
                mapClickHandler: mapClickHandler,
                adapterClickHandler: adapterClickHandler,
                eventTriggerClickHandler: eventTriggerClickHandler,
                handleFlowNameChange: handleFlowNameChange,
                placeholder: placeholder,
                loading: loading,
                fhirLoading: fhirLoading,
                ux: ux,
                saveTemplate: saveTemplate
            }),
            ux === "adapters" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44fcfa68fa0fab58$export$2e2bcd8739ae039), {
                workflow: workflow,
                setWorkflow: setWorkflow,
                placeholder: placeholder,
                selectedEnvironment: props.selectedEnvironment,
                adapterClickHandler: adapterClickHandler,
                updateEventTrigger: updateEventTrigger,
                sampleMessageInput: sampleMessageInput,
                handleSampleMessageChange: handleSampleMessageChange,
                selectedWorkspace: props.selectedWorkspace,
                updateActionTrigger: updateActionTrigger,
                updateHL7ActionTrigger: updateHL7ActionTrigger,
                parseJSONSampleMessage: parseJSONSampleMessage,
                error: error,
                handleFlowNameChange: handleFlowNameChange,
                clearError: clearError,
                showTemplates: showTemplates
            }),
            ux === "e-layer" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $793a563f84b44f86$export$2e2bcd8739ae039), {
                workflow: workflow,
                clearError: clearError,
                environments: props.environments,
                error: error,
                triggerMap: triggerMap,
                enableSampleFilter: enableSampleFilter,
                sampleFilter: sampleFilter,
                messageEvent: messageEvent,
                hl7v2EventTofhirr4MethodMap: $a4fc57cf391e3576$var$hl7v2EventTofhirr4MethodMap,
                updateTriggerMethod: updateTriggerMethod,
                showSampleMessageInput: showSampleMessageInput,
                selectedEnvironment: props.selectedEnvironment,
                selectedWorkspace: props.selectedWorkspace,
                triggerSample: triggerSample,
                eventTriggerGrid: eventTriggerGrid,
                trigger: trigger,
                updateEventTrigger: updateEventTrigger,
                showSampleTriggerGrid: showSampleMessageInput,
                updateTrigger: updateTrigger,
                loading: loading,
                removeTriggerMapRow: removeTriggerMapRow,
                onChangeHost: onChangeHost,
                onChangeUsername: onChangeUsername,
                onChangePort: onChangePort,
                onChangePath: onChangePath,
                onChangeCadence: onChangeCadence,
                onChangeCert: onChangeCert,
                onChangePrivateKey: onChangePrivateKey
            }),
            ux === "t-layer" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eff657b575a4eac4$export$2e2bcd8739ae039), {
                error: error,
                clearError: clearError,
                workflow: workflow,
                loading: loading,
                sampleFilter: sampleFilter,
                enableSampleFilter: enableSampleFilter,
                selectedWorkspace: props.selectedWorkspace,
                fieldMapGrid: fieldMapGrid,
                fhirMap: fhirMap,
                removeFieldMapRow: removeFieldMapRow,
                updateFieldMap: updateFieldMap,
                toggleLookUpModal: toggleLookUpModal,
                hydrateMappingGrids: hydrateMappingGrids,
                validatePayload: validatePayload,
                targets: targets,
                fetchFHIRR4Map: fetchFHIRR4Map,
                fhirLoading: fhirLoading
            }),
            ux === "t-layer" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d83bdd072adf5d72$export$2e2bcd8739ae039), {
                workflow: workflow,
                toggleLookUpModal: toggleLookUpModal,
                selectedField: selectedField,
                handleLookupDefaultValueChange: handleLookupDefaultValueChange,
                selectedFieldMap: selectedFieldMap,
                addRowToLookupsHandler: addRowToLookupsHandler,
                setCsvFile: setCsvFileHandler,
                selectedDefaultValue: selectedDefaultValue,
                selectedWorkspace: props.selectedWorkspace,
                removeRow: removeRow,
                clearToggle: clearToggle,
                updateFieldMapKey: updateFieldMapKey,
                updateFieldMapValue: updateFieldMapValue,
                open: lookUpModal,
                validatePayload: validatePayload,
                saveWorkflow: saveWorkflow,
                currentLookups: currentLookups
            }),
            ux === "l-layer" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8aa13104b69f518c$export$2e2bcd8739ae039), {
                error: error,
                clearError: clearError,
                updateActionTrigger: updateActionTrigger,
                workflow: workflow,
                next: next,
                handleNextUrl: handleNextUrl,
                sampleMap: sampleMap,
                handleNextIP: handleNextIP,
                handleNextPort: handleNextPort,
                selectedEnvironment: props.selectedEnvironment,
                selectedWorkspace: props.selectedWorkspace,
                setCopiedHandler: setCopiedHandler,
                copied: copied,
                createS3Bucket: createS3Bucket,
                handleNextS3BucketName: handleNextS3BucketName,
                handleNextS3Key: handleNextS3Key,
                fhirSampleMap: fhirSampleMap
            })
        ]
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "items-center animate-pulse py-48 sm:py-24 md:py-32 lg:py-48",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "h-24 mx-auto w-auto",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                alt: "Logo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                className: "mt-0 text-center text-2xl font-bold text-gray-200",
                children: [
                    "Retrohook",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1"
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $a08ef469b8107069$var$ArrowPathIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
    }));
}
const $a08ef469b8107069$var$ForwardRef = $acw62.forwardRef($a08ef469b8107069$var$ArrowPathIcon);
var $a08ef469b8107069$export$2e2bcd8739ae039 = $a08ef469b8107069$var$ForwardRef;





var $acw62 = parcelRequire("acw62");



function $d65cd349b6091089$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $d65cd349b6091089$export$2e2bcd8739ae039(props) {
    let enabled = null;
    if (props.enabled === "IKEV1" || props.enabled === false) enabled = false;
    else enabled = true;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8bce35f563baeffd$export$b5d5cf8927ab7262), {
        checked: enabled,
        onChange: ()=>{
            props.setEnabled();
        },
        className: $d65cd349b6091089$var$classNames(enabled ? "bg-cyan-400" : "bg-gray-200", "relative inline-flex flex-shrink-0 h-3 w-7 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: props.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "aria-hidden": "true",
                className: $d65cd349b6091089$var$classNames(enabled ? "translate-x-4" : "translate-x-0", "pointer-events-none inline-block h-2 w-2 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200")
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


function $0045246058a14f4a$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $0045246058a14f4a$export$2e2bcd8739ae039(props) {
    const [selected, setSelected] = (0, $acw62.useState)(props.devices[3]);
    const handleSelect = (0, $acw62.useCallback)(()=>{
        props.selectHandler(selected);
    }, [
        selected
    ]);
    (0, $acw62.useEffect)(()=>{
        handleSelect();
    }, [
        handleSelect
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659), {
        value: selected,
        onChange: setSelected,
        children: ({ open: open })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-1 relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $df20442161b20eb0$export$8bad31ff872c7659).Button, {
                            className: " bg-white align-middle relative w-full border border-cyan-600 rounded-md shadow-sm pl-3 pr-5 py-2 text-left  cursor-default focus:outline-none focus:ring-1 focus:ring-cyan-500 focus:border-cyan-500 sm:text-sm",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "block align-middle text-md",
                                    children: String(selected.Vendor + " " + selected.Platform + ": " + selected.Software)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2480a97a23319a50$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-gray-400",
                                        "aria-hidden": "true"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                            show: open,
                            as: (0, $acw62.Fragment),
                            leave: "transition ease-in duration-100",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659).Options, {
                                className: "align-middle w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                                children: props.devices.map((device)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df20442161b20eb0$export$8bad31ff872c7659).Option, {
                                        onClick: ()=>{
                                            props.selectHandler(selected);
                                        },
                                        className: ({ active: active })=>$0045246058a14f4a$var$classNames(active ? "text-white bg-cyan-600" : "text-gray-600", "cursor-default select-none relative py-2 pl-3 pr-9"),
                                        value: device,
                                        children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: $0045246058a14f4a$var$classNames(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                        children: device.Vendor.slice(0, 12) + " " + device.Platform + " " + device.Software
                                                    }),
                                                    selected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: $0045246058a14f4a$var$classNames(active ? "text-white" : "text-cyan-600", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef03f1e36d447ce4$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5",
                                                            "aria-hidden": "true"
                                                        })
                                                    }) : null
                                                ]
                                            })
                                    }, device.VpnConnectionDeviceTypeId))
                            })
                        })
                    ]
                })
            })
    });
}



function $0480de8a8001f223$export$2e2bcd8739ae039(props) {
    const { post: post, response: response } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)((0, $15f24a665de742b6$export$2e2bcd8739ae039).url);
    const [devices, setDevices] = (0, $acw62.useState)([]);
    const [ikeVersion, setIkeVersion] = (0, $acw62.useState)("IKEv2");
    const [device, setDevice] = (0, $acw62.useState)({
        VpnConnectionDeviceTypeId: "",
        VpnConnectionDeviceTypeName: ""
    });
    const [showAdvancedTunnelConfig, setShowadvancedTunnelConfig] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        getDeviceList();
    }, []);
    const getDeviceList = async ()=>{
        const body = {
            environment: props.selectedEnvironment
        };
        const devices = await post(`ipsec/devices/${props.user.attributes.id}`, body);
        if (response.ok && devices) {
            console.dir(devices);
            setDevices(devices);
        }
    };
    const toggleIkeVersion = ()=>{
        setIkeVersion(props.tunnel.ikeVersion === "IKEV1" ? "IKEV2" : "IKEV1");
    };
    const selectHandler = (device)=>{
        setDevice(device);
    };
    const downloadML7Config = async (tunnel)=>{
        const body = {
            left: tunnel.SK.split("#")[1],
            leftSubnet: tunnel.Routes[0].DestinationCidrBlock,
            leftIp: tunnel.SK.split("#")[1],
            right: tunnel.tunnel1_ip,
            rightSubnet: tunnel.Options.RemoteIpv4NetworkCidr,
            rightSecondary: tunnel.tunnel2_ip,
            rightSubnetSecondary: tunnel.Options.RemoteIpv4NetworkCidr,
            psk: tunnel.tunnel1_psk,
            pskSecondary: tunnel.tunnel2_psk,
            selected: props.selectedEnvironment,
            leftSubnetSecondary: tunnel?.Routes[1]?.DestinationCidrBlock ? tunnel.Routes[1].DestinationCidrBlock : ""
        };
        const config = await post(`ipsec/generate-custom-config/${props.user.attributes.id}`, body);
        if (response.ok && config) {
            const element = document.createElement("a");
            const file = new Blob([
                config.customConfig
            ], {
                type: "text/plain"
            });
            element.href = URL.createObjectURL(file);
            element.download = "quick-connect.sh";
            document.body.appendChild(element);
            element.click();
        }
    };
    const downloadTunnelConfig = async (tunnel)=>{
        const body = {
            VpnConnectionDeviceTypeId: device.VpnConnectionDeviceTypeId,
            VpnConnectionId: tunnel.vpnConnectionId,
            ikeVersion: ikeVersion,
            environment: props.selectedEnvironment
        };
        const downloadRequest = await post(`ipsec/get-config/${props.user.attributes.id}`, body);
        console.dir(downloadRequest);
        if (downloadRequest?.configRequest.VpnConnectionDeviceSampleConfiguration) {
            const element = document.createElement("a");
            const file = new Blob([
                downloadRequest.configRequest.VpnConnectionDeviceSampleConfiguration
            ], {
                type: "text/plain"
            });
            element.href = URL.createObjectURL(file);
            element.download = "sample-config.txt";
            document.body.appendChild(element);
            element.click();
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "divide-y divide-solid",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "py-2 text-center text-md font-medium text-gray-200",
                children: [
                    "Quick\xa0\xa0",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d65cd349b6091089$export$2e2bcd8739ae039), {
                        enabled: showAdvancedTunnelConfig,
                        name: showAdvancedTunnelConfig,
                        setEnabled: ()=>setShowadvancedTunnelConfig(!showAdvancedTunnelConfig)
                    }),
                    "\xa0\xa0Advanced"
                ]
            }),
            showAdvancedTunnelConfig ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pb-5 pt-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: " text-center text-lg font-medium",
                        children: "Advanced Setup"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pb-2",
                        children: [
                            "IKEv1\xa0\xa0",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d65cd349b6091089$export$2e2bcd8739ae039), {
                                enabled: ikeVersion,
                                name: ikeVersion,
                                setEnabled: toggleIkeVersion
                            }),
                            "\xa0\xa0IKEv2"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0045246058a14f4a$export$2e2bcd8739ae039), {
                        className: "w-full",
                        selectHandler: selectHandler,
                        devices: devices
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>{
                            downloadTunnelConfig(props.tunnel);
                        },
                        className: "mt-2 w-full bg-cyan-500 hover:bg-cyan-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
                        type: "button",
                        children: "Download"
                    }),
                    props.tunnel.showDownloadTunnelConfig ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "mt-2 w-full bg-gray-500 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
                        type: "button",
                        onClick: ()=>{
                            props.showDownloadTunnelConfigClickHandler(props.tunnel);
                        },
                        children: "Done"
                    }) : ""
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pb-5 pt-2 text-gray-200",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: " text-center text-lg font-medium",
                        children: "Quick Setup"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm pt-1",
                        children: "Quick setup installs open source IPsec tools onto your kernel to facilitate a policy-based, subnet-to-subnet tunnel securing traffic from you to the Retrohook platform."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-md pt-4 text-gray-300",
                        children: [
                            "Step 1:\xa0",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm pt-1 text-cyan-400",
                                children: "Download the install script below to setup the connection to the Retrohook platform."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>{
                            downloadML7Config(props.tunnel);
                        },
                        className: "mt-2 w-full bg-gray-500 hover:bg-cyan-400 text-white font-bold py-2 px-4  rounded focus:outline-none focus:shadow-outline",
                        type: "button",
                        children: "Download Script"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-md pt-4 text-gray-300",
                        children: [
                            "Step 2:\xa0",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm pt-1 text-cyan-400",
                                children: "This script can be run from anywhere just cd into the directory where it is located."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-md pt-4 text-gray-300",
                        children: [
                            "Step 3:\xa0",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm pt-1 text-cyan-400",
                                children: "Then execute the shell script using sudo ./quicksetup.sh"
                            })
                        ]
                    }),
                    props.tunnel.showDownloadTunnelConfig ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "mt-2 w-full bg-gray-500 hover:bg-gray-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
                        type: "button",
                        onClick: ()=>{
                            props.showDownloadTunnelConfigClickHandler(props.tunnel);
                        },
                        children: "Done"
                    }) : ""
                ]
            })
        ]
    });
}



/* This example requires Tailwind CSS v2.0+ */ 

function $e0e17317929f44ac$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-md bg-yellow-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba60e8ad9fe6a73$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-yellow-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-medium text-yellow-800",
                        children: "Sorry, this feature is only allowed in production environments, please upgrade your account to access this feature."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mx-1.5 -my-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: ()=>{
                                props.closeProdRequiredAlert();
                            },
                            type: "button",
                            className: "inline-flex bg-yellow-50 rounded-md p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Dismiss"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}




/* This example requires Tailwind CSS v2.0+ */ 

function $4ca47eb51df4ace8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-md bg-yellow-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba60e8ad9fe6a73$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-yellow-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm font-medium text-yellow-800",
                        children: [
                            "You are missing the following field(s): ",
                            props.fields,
                            "."
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mx-1.5 -my-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: ()=>{
                                props.closeMissingFieldsAlert();
                            },
                            type: "button",
                            className: "inline-flex bg-yellow-50 rounded-md p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Dismiss"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}



function $8cb9766ac198673c$export$2e2bcd8739ae039(props) {
    const { post: post, response: response, loading: loading } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)();
    const form = {
        PK: props.user.id,
        deviceName: "",
        bgp: false,
        deviceNamePlaceholder: String.raw`Your MLLP HL7 Server`,
        type: String.raw`ipsec.1`,
        LocalIpv4AddressPlaceholder: String.raw`Your Server's Private IPv4 Address`,
        LocalIpv4Address: String.raw``,
        PublicIpv4Address: String.raw``,
        PublicIpv4AddressPlaceholder: String.raw`Your Server's Public IPv4 Address`,
        RemoteIpv4Address: String.raw`172.31.0.0`,
        ikeVersion: String.raw`ikev2`,
        owner: props.user
    };
    const [ikeToggle, setIkeToggle] = (0, $acw62.useState)("");
    const [showEnvironmentDropdown, setShowEnvironmentDropdown] = (0, $acw62.useState)(false);
    const [tunnels, setTunnels] = (0, $acw62.useState)([]);
    const [updatedConnectClickHandler, setUpdatedConnectClickHandler] = (0, $acw62.useState)(false);
    const [advanced, setAdvanced] = (0, $acw62.useState)(false);
    const [showAccessAlert, setShowAccessAlert] = (0, $acw62.useState)(false);
    const [tunnel, setTunnel] = (0, $acw62.useState)(form);
    const [missingFieldsAlert, setMissingFieldsAlert] = (0, $acw62.useState)(false);
    const [missingFields, setMissingFields] = (0, $acw62.useState)([]);
    const [currentTunnel, setCurrentTunnel] = (0, $acw62.useState)({
        name: "New Tunnel"
    });
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        getTunnels();
    }, [
        props.selectedEnvironment,
        props.selectedAccount
    ]);
    const getTunnels = async ()=>{
        setShowAccessAlert(false);
        if (props?.selectedEnvironment?.name?.substring(3, 6) == "Dev") setShowAccessAlert(true);
        const body = {
            selectedWorkspace: props.selectedWorkspace,
            selectedEnvironment: props.selectedEnvironment
        };
        const tunnels = await post(`ipsec/list/${props.user.attributes.id}`, body);
        if (response.ok && tunnels.length > 0) {
            tunnels.map(async (element)=>{
                if (!element.showDownloadTunnelConfig || element.showDownloadTunnelConfig === "undefined") {
                    element.showDownloadTunnelConfig = false;
                    element.showPsk = false;
                }
            });
            setTunnels(tunnels ? tunnels : []);
        } else setTunnels([]);
    };
    const canCreate = ()=>{
        const hasUpdateWorkflowInSelectedWorkspace = props.selectedWorkspace.accounts.filter((workspace)=>{
            if (workspace.permissions?.tunnels.create) return workspace;
        });
        const isOwner = props.selectedWorkspace?.PK == props.account?.PK ? true : false;
        if (props.admin === true || hasUpdateWorkflowInSelectedWorkspace.length || isOwner) return true;
        else return false;
    };
    const canDelete = ()=>{
        const hasUpdateWorkflowInSelectedWorkspace = props.selectedWorkspace.accounts.filter((workspace)=>{
            if (workspace.permissions?.tunnels.delete) return workspace;
        });
        const isOwner = props.selectedWorkspace.owner.email === props.account.owner.email;
        if (props.admin === true || hasUpdateWorkflowInSelectedWorkspace.length || isOwner) return true;
        else return false;
    };
    const saveTunnel = async ()=>{
        if (props?.selectedEnvironment?.name.substring(3, 6) == "Dev") setShowAccessAlert(true);
        if (!tunnel.deviceName || !tunnel.PublicIpv4Address || !tunnel.LocalIpv4Address) {
            const missingFields = [];
            if (!tunnel.deviceName) missingFields.push("Device Name");
            if (!tunnel.PublicIpv4Address) missingFields.push("Public IP Address");
            if (!tunnel.LocalIpv4Address) missingFields.push("Local IP Address");
            setMissingFields(missingFields);
            setMissingFieldsAlert(true);
            return;
        }
        if (canCreate()) {
            const newTunnel = {
                DeviceName: tunnel.deviceName,
                StaticRoutesOnly: !tunnel.bgp,
                PublicIpv4Address: tunnel.PublicIpv4Address,
                RemoteIpv4Address: tunnel.RemoteIpv4Address,
                LocalIpv4Address: tunnel.LocalIpv4Address,
                Type: tunnel.type,
                owner: props.user,
                BgpAsn: 65000
            };
            const body = {
                tunnel: newTunnel,
                selectedAccount: props.selectedAccount,
                selectedEnvironment: props.selectedEnvironment
            };
            const tunnelResponse = await post(`ipsec/create/${props.user.attributes.id}`, body);
            if (response.ok && tunnelResponse) {
                await getTunnels();
                setTunnel({
                    PK: props.user.id,
                    deviceName: "",
                    bgp: false,
                    deviceNamePlaceholder: String.raw`Your MLLP HL7 Server`,
                    type: String.raw`ipsec.1`,
                    LocalIpv4AddressPlaceholder: String.raw`Your Server's Private IPv4 Address`,
                    LocalIpv4Address: String.raw``,
                    PublicIpv4Address: String.raw``,
                    PublicIpv4AddressPlaceholder: String.raw`Your Server's Public IPv4 Address`,
                    RemoteIpv4Address: String.raw`172.31.0.0`,
                    ikeVersion: String.raw`ikev2`,
                    owner: props.user
                });
            }
        }
    };
    const deleteTunnel = async (tunnel)=>{
        if (canDelete()) {
            const body = {
                selectedEnvironment: props.selectedEnvironment,
                selectedAccount: props.selectedAccount,
                tunnel: tunnel
            };
            await post(`ipsec/delete/${props.user.attributes.id}`, body);
            if (response.ok) getTunnels();
        }
    };
    const toggleIkeVersion = ()=>{
        setIkeToggle(tunnel.ikeVersion === "IKEV1" ? "IKEV2" : "IKEV1");
    };
    const handleIPChange = (event)=>{
        const updated = {
            ...tunnel,
            PublicIpv4Address: event.target.value
        };
        setTunnel(updated);
    };
    const handleTunnelNameChange = (event)=>{
        const updated = {
            ...tunnel,
            deviceName: event.target.value
        };
        setTunnel(updated);
    };
    const handleInternalIPChange = (event)=>{
        const updated = {
            ...tunnel,
            LocalIpv4Address: event.target.value
        };
        setTunnel(updated);
    };
    const toggleBGP = (event)=>{
        const updated = {
            ...tunnel,
            bgp: event.target.value
        };
        setTunnel(updated);
    };
    const showDownloadTunnelConfigClickHandler = async (tunnel)=>{
        let shouldReRender = false;
        tunnels.forEach((element)=>{
            if (element.id === tunnel.id) {
                if (element.showDownloadTunnelConfig === "undefined") element.showDownloadTunnelConfig = false;
                if (!element.showDownloadTunnelConfig || element.showDownloadTunnelConfig === false) {
                    element.showDownloadTunnelConfig = true;
                    shouldReRender = true;
                } else element.showDownloadTunnelConfig = false;
            }
        });
        setUpdatedConnectClickHandler(shouldReRender);
        setTunnels(tunnels);
    };
    const openModal = (tunnel)=>{
        setCurrentTunnel(tunnel);
        setIsModalOpen(true);
    };
    const closeModal = ()=>{
        setIsModalOpen(false);
    };
    const confirmDelete = ()=>{
        deleteTunnel(currentTunnel);
        closeModal();
    };
    if (!props.selectedWorkspace || !props.selectedEnvironment) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "col-12",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "card",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "card-body text-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "display-4",
                                    children: "No Workspace Selected"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "lead",
                                    children: "Please select a workspace from the dropdown above."
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-full animate-color-change-2x",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "shadow-sm bg-gray-800 pr-2 min-w-0 md:flex md:items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b43d88f90a4a45e7$export$2e2bcd8739ae039), {
                        className: "inline",
                        title: "Tunnels"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "",
                        children: props?.selectedWorkspace.environments.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26918d270ead469d$export$2e2bcd8739ae039), {
                            user: props.user,
                            account: props.account,
                            admin: props.admin,
                            setShowEnvironmentDropdown: setShowEnvironmentDropdown,
                            environments: props.environments,
                            selectedWorkspace: props.selectedWorkspace,
                            updateBillingCustomer: props.updateBillingCustomer,
                            selectedEnvironment: props.selectedEnvironment,
                            selectedAccount: props.selectedAccount,
                            setSelectedEnvironment: props.setSelectedEnvironment,
                            logout: props.logout
                        })
                    }),
                    !loading && props?.selectedEnvironment?.name?.substring(1, 3) != "Dev" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: ()=>getTunnels(),
                        className: "ml-1 flex h-8 w-8 justify-end cursor-pointer py-0.5 text-gray-50 bg-cyan-400 rounded border-2 border-cyan-400  hover:bg-cyan-300 focus:outline-none",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a08ef469b8107069$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            showAccessAlert && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0e17317929f44ac$export$2e2bcd8739ae039), {
                closeProdRequiredAlert: ()=>{
                    setShowAccessAlert(false);
                }
            }),
            missingFieldsAlert && missingFields.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ca47eb51df4ace8$export$2e2bcd8739ae039), {
                closeMissingFieldsAlert: ()=>{
                    setMissingFieldsAlert(false);
                },
                fields: missingFields
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53dccccfeb3e8d8d$export$2e2bcd8739ae039), {
                isOpen: isModalOpen,
                onClose: closeModal,
                onConfirm: ()=>confirmDelete(),
                title: "Confirm Delete Tunnel",
                message: `Are you sure you want to delete ${currentTunnel.name}? This cannot be undone.`
            }),
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "items-center animate-pulse py-48 sm:py-24 md:py-32 lg:py-48",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "h-24 mx-auto w-auto",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                        alt: "Logo"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "mt-0 text-center text-2xl font-bold text-gray-200",
                        children: [
                            "Retrohook",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1"
                            })
                        ]
                    })
                ]
            }),
            !props.selectedWorkspace && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "container-fluid",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "card",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "card-body text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "display-4",
                                            children: "No Workspace Selected"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "lead",
                                            children: "Please select a workspace from the dropdown above."
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            !props.selectedEnvironment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "container-fluid",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "card",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "card-body text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "display-4",
                                            children: "No Environment Selected"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "lead",
                                            children: "Please select a production enabled environment from the dropdown above."
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                className: "p-4 grid grid-cols-4 gap-2 sm:grid-cols-2 lg:grid-cols-4",
                children: [
                    !loading && props.selectedWorkspace.PK && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative bg-gray-800 pt-5 px-4 pb-2 sm:pt-6 sm:px-6 rounded-lg overflow-hidden border-gray-700 hover:border-cyan-300 border-2 border-dashed",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-center text-2xl font-semibold text-cyan-400 truncate",
                                                children: "New Tunnel"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "divide-y divide-solid pt-8",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "py-4",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                        name: "Name",
                                                        onChange: handleTunnelNameChange,
                                                        defaultValue: tunnel.deviceName,
                                                        placeholder: tunnel.deviceNamePlaceholder
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "pb-2 pt-4",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                                name: "Public IPv4 Address",
                                                                onChange: handleIPChange,
                                                                defaultValue: tunnel.PublicIpv4Address,
                                                                placeholder: tunnel.PublicIpv4AddressPlaceholder
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "pb-2 pt-4",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                                name: "Private IPV4 Address",
                                                                onChange: handleInternalIPChange,
                                                                defaultValue: tunnel.LocalIpv4Address,
                                                                placeholder: tunnel.LocalIpv4AddressPlaceholder
                                                            })
                                                        }),
                                                        advanced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex pt-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex-auto",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs",
                                                                            children: "IKEv1\xa0\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d65cd349b6091089$export$2e2bcd8739ae039), {
                                                                            enabled: ikeToggle,
                                                                            name: ikeToggle,
                                                                            setEnabled: toggleIkeVersion
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs",
                                                                            children: "\xa0\xa0IKEv2 Only"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex-auto",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs",
                                                                            children: "Static\xa0\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d65cd349b6091089$export$2e2bcd8739ae039), {
                                                                            enabled: tunnel.bgp,
                                                                            name: tunnel.bgp,
                                                                            setEnabled: toggleBGP
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs",
                                                                            children: "\xa0\xa0Dynamic (BGP)"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }) : "",
                                                        " "
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "pt-2 mt-2 pb-4 sm:px-6",
                                    children: [
                                        advanced ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "mt-2 w-full hover:bg-gray-500 bg-orange-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
                                            type: "button",
                                            onClick: ()=>setAdvanced(!advanced),
                                            children: "Standard"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "w-full bg-gray-500 hover:bg-orange-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
                                            type: "button",
                                            onClick: ()=>setAdvanced(!advanced),
                                            children: "Advanced"
                                        }),
                                        canCreate() === true && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "mt-2 w-full bg-cyan-300 hover:bg-cyan-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
                                            type: "button",
                                            onClick: saveTunnel,
                                            children: "Generate"
                                        }),
                                        canCreate() === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            className: "mt-2 w-full bg-gray-500 hover:bg-cyan-100 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
                                            type: "button",
                                            onClick: ()=>setShowAccessAlert(true),
                                            children: loading ? "Generating..." : "Generate"
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    !loading && tunnels?.map((tunnel)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative bg-gray-800 pt-5 px-4 pb-4 sm:pt-6 sm:px-6 rounded-lg overflow-hidden hover:border-cyan-300 border-2 border-gray-700",
                            children: [
                                !tunnel.showDownloadTunnelConfig ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dt", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "absolute rounded-md p-1"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-center text-lg font-semibold text-gray-100 truncate",
                                                    children: tunnel.name ? tunnel.name.slice(0, 14) : tunnel.Tags[0].Value.slice(0, 14)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "absolute top-0 right-0 m-2 border-gray-500 border hover:bg-orange-500 hover:text-white hover:border-orange-500 text-gray-500 font-bold text-xs py-1 px-2 rounded focus:outline-none focus:shadow-outline",
                                                    onClick: ()=>{
                                                        openModal(tunnel);
                                                    },
                                                    children: "X"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-center text-sm pb-2 text-cyan-500",
                                                    children: tunnel.state.toUpperCase()
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-xs text-center text-gray-100",
                                                    children: [
                                                        tunnel.Tags[0].Value.slice(0, 8),
                                                        "...IPv4 (Left):",
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: " text-gray-200 text-sm",
                                                            children: tunnel.customer_ip
                                                        })
                                                    ]
                                                }),
                                                tunnel.Routes ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-xs text-center text-gray-100",
                                                    children: [
                                                        tunnel.Tags[0].Value.slice(0, 6),
                                                        "...Subnet (Left):",
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: " text-gray-200 text-sm",
                                                            children: tunnel.Routes[0].DestinationCidrBlock
                                                        })
                                                    ]
                                                }) : null,
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "divide-y divide-solid",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "py-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-cyan-400",
                                                            children: "Primary"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-gray-100",
                                                            children: [
                                                                "Retrohook IPv4 (Right):",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: " text-gray-200 text-sm",
                                                                    children: [
                                                                        " ",
                                                                        tunnel.tunnel1_ip,
                                                                        " "
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        tunnel.Options ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-gray-100",
                                                            children: [
                                                                "Retrohook Subnet (Right):",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: " text-gray-200 text-sm",
                                                                    children: tunnel.Options.RemoteIpv4NetworkCidr
                                                                })
                                                            ]
                                                        }) : null,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-gray-100",
                                                            children: [
                                                                "IKE:",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: " text-gray-200 text-sm",
                                                                    children: tunnel.ike_auth_protocol + " | " + tunnel.ike_encryption_protocol + " | " + tunnel.ike_diffie_helm_group
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-gray-100",
                                                            children: [
                                                                "IPSec:",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: " text-gray-200 text-sm",
                                                                    children: [
                                                                        tunnel.tunnel1_psk ? "psk" : "",
                                                                        "| ",
                                                                        " ",
                                                                        tunnel.ipsec_auth_protocol
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        tunnel.showPsk ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-white bg-red-800",
                                                            children: [
                                                                "PSK:",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-white text-xs",
                                                                    children: tunnel.tunnel1_psk
                                                                })
                                                            ]
                                                        }) : "",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "pb-5 pt-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-cyan-400",
                                                            children: "Secondary"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-gray-100",
                                                            children: [
                                                                "Retrohook IPv4 (Right):",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: " text-gray-200 text-sm",
                                                                    children: [
                                                                        " ",
                                                                        tunnel.tunnel2_ip,
                                                                        " "
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        tunnel.Options ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-gray-100",
                                                            children: [
                                                                "Retrohook Subnet (Right):",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: " text-gray-200 text-sm",
                                                                    children: tunnel.Options.RemoteIpv4NetworkCidr
                                                                })
                                                            ]
                                                        }) : null,
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-gray-100",
                                                            children: [
                                                                "IKE:",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: " text-gray-200 text-sm",
                                                                    children: tunnel.ike_auth_protocol + " | " + tunnel.ike_encryption_protocol + " | " + tunnel.ike_diffie_helm_group
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-gray-100",
                                                            children: [
                                                                "IPSec:",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: " text-gray-200 text-sm",
                                                                    children: [
                                                                        tunnel.tunnel2_psk ? "psk" : "",
                                                                        "|",
                                                                        " ",
                                                                        tunnel.ipsec_auth_protocol
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        tunnel.showPsk ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "text-xs text-white bg-red-800",
                                                            children: [
                                                                "PSK:",
                                                                " ",
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "text-white text-xs",
                                                                    children: tunnel.tunnel2_psk
                                                                })
                                                            ]
                                                        }) : "",
                                                        " "
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : "",
                                !tunnel.showDownloadTunnelConfig && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "my-2 w-full bg-gray-500 hover:bg-cyan-400 text-white font-bold py-2 px-4 rounded focus:outline-none  focus:shadow-outline",
                                    type: "button",
                                    onClick: ()=>{
                                        showDownloadTunnelConfigClickHandler(tunnel);
                                    },
                                    children: "Get Connected"
                                }),
                                tunnel.showDownloadTunnelConfig && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0480de8a8001f223$export$2e2bcd8739ae039), {
                                    tunnel: tunnel,
                                    user: props.user,
                                    accounts: props.accounts,
                                    account: props.account,
                                    environments: props.environments,
                                    selectedEnvironment: props.selectedEnvironment,
                                    selectedAccount: props.selectedAccount,
                                    showDownloadTunnelConfigClickHandler: showDownloadTunnelConfigClickHandler,
                                    logout: props.logout
                                })
                            ]
                        }, tunnel.vpnConnectionId);
                    })
                ]
            })
        ]
    });
}


/**
 * Workspace component handles rendering workspace settings and subscription details.
 *
 * Allows editing of general settings like organization name and message ID values.
 * Renders team settings to manage workspace users.
 * Shows subscription details and handles purchasing additional seats.
 * Handles inviting and removing users, updating permissions.
 * Fetches product info from Stripe to display pricing.
 */ 

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $52a5ad4e9e45ae5f$var$AdjustmentsVerticalIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5"
    }));
}
const $52a5ad4e9e45ae5f$var$ForwardRef = $acw62.forwardRef($52a5ad4e9e45ae5f$var$AdjustmentsVerticalIcon);
var $52a5ad4e9e45ae5f$export$2e2bcd8739ae039 = $52a5ad4e9e45ae5f$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $0c6ba30950984529$var$CalendarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
    }));
}
const $0c6ba30950984529$var$ForwardRef = $acw62.forwardRef($0c6ba30950984529$var$CalendarIcon);
var $0c6ba30950984529$export$2e2bcd8739ae039 = $0c6ba30950984529$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $3a4947f8c0c2fcf7$var$ShieldCheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
    }));
}
const $3a4947f8c0c2fcf7$var$ForwardRef = $acw62.forwardRef($3a4947f8c0c2fcf7$var$ShieldCheckIcon);
var $3a4947f8c0c2fcf7$export$2e2bcd8739ae039 = $3a4947f8c0c2fcf7$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $4295805cb2bcb89a$var$UserGroupIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
    }));
}
const $4295805cb2bcb89a$var$ForwardRef = $acw62.forwardRef($4295805cb2bcb89a$var$UserGroupIcon);
var $4295805cb2bcb89a$export$2e2bcd8739ae039 = $4295805cb2bcb89a$var$ForwardRef;





/* This example requires Tailwind CSS v2.0+ */ 

function $150d1375c9f14622$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-md bg-yellow-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba60e8ad9fe6a73$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-yellow-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-medium text-yellow-800",
                        children: "Sorry, this user already exists."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mx-1.5 -my-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: ()=>{
                                props.closeAlert();
                            },
                            type: "button",
                            className: "inline-flex bg-yellow-50 rounded-md p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Dismiss"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/* This example requires Tailwind CSS v2.0+ */ 

function $7e61a371f7755339$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-md bg-yellow-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba60e8ad9fe6a73$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-yellow-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-medium text-yellow-800",
                        children: "Sorry, you are at the user limit for this account."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mx-1.5 -my-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: ()=>{
                                props.closeAlert();
                            },
                            type: "button",
                            className: "inline-flex bg-yellow-50 rounded-md p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Dismiss"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/* This example requires Tailwind CSS v2.0+ */ 

function $c0d642fad3c697a7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-md bg-yellow-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba60e8ad9fe6a73$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-yellow-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-medium text-yellow-800",
                        children: "Sorry, the password doesn't meet the requirements (Min:8, SpecialChar:1, Number:1, UpperCase:1)."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mx-1.5 -my-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: ()=>{
                                props.closeAlert();
                            },
                            type: "button",
                            className: "inline-flex bg-yellow-50 rounded-md p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Dismiss"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/* This example requires Tailwind CSS v2.0+ */ 

function $348033d0f84652f0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rounded-md bg-yellow-50 p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aba60e8ad9fe6a73$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-yellow-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm font-medium text-yellow-800",
                        children: "Sorry, the email address is missing or doesn't match the appropriate format."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ml-auto pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "-mx-1.5 -my-1.5",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: ()=>{
                                props.closeAlert();
                            },
                            type: "button",
                            className: "inline-flex bg-yellow-50 rounded-md p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Dismiss"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");




function $7b6847c785790ab4$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $7b6847c785790ab4$export$2e2bcd8739ae039(props) {
    let enabled = null;
    enabled = props.enabled;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8bce35f563baeffd$export$b5d5cf8927ab7262), {
        checked: enabled,
        onChange: ()=>{
            props.onChange();
        },
        className: $7b6847c785790ab4$var$classNames(enabled ? "bg-cyan-500" : "bg-gray-200", "relative inline-flex flex-shrink-0 h-3 w-7 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "sr-only",
                children: props.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "aria-hidden": "true",
                className: $7b6847c785790ab4$var$classNames(enabled ? "translate-x-4" : "translate-x-0", "pointer-events-none inline-block h-2 w-2 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200")
            })
        ]
    });
}


function $fb911cc5b03afdb5$export$2e2bcd8739ae039(props) {
    if (props.selectedUser) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-10 inset-0 overflow-y-auto",
            onClose: props.close,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative inline-block align-bottom bg-white rounded-lg px-2 pt-2 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-1 pb-6 inline-flex",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "absolute top-4 left-4 px-1 inline",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c310f2872bff579$export$2e2bcd8739ae039), {
                                                className: "h-10 w-10 text-gray-500 bg-white rounded-md inline"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Title, {
                                                as: "h3",
                                                className: "text-xl font-medium text-gray-500 inline",
                                                children: [
                                                    " \xa0 ",
                                                    props.selectedUser ? props.selectedUser.email : "",
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-2 sm:mt-6 border border-gray-300 bg-white p-1 rounded-md shadow-sm",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "sm:grid sm:grid-cols-12 sm:gap-1 bg-white p-1",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "col-span-3 text-md",
                                                children: "Workspace"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "col-span-9 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b6847c785790ab4$export$2e2bcd8739ae039), {
                                                        name: "admin-set",
                                                        enabled: JSON.parse(props.selectedUser.permissions.workspace.admin),
                                                        onChange: ()=>props.updatePermissions("workspace", "admin", props.selectedUser)
                                                    }),
                                                    "\xa0\xa0Admin "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "col-span-3 text-md",
                                                children: "Dashboard"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "col-span-9 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b6847c785790ab4$export$2e2bcd8739ae039), {
                                                        name: "dashboard-view",
                                                        enabled: JSON.parse(props.selectedUser.permissions.dashboard.read),
                                                        onChange: ()=>props.updatePermissions("dashboard", "read", props.selectedUser)
                                                    }),
                                                    "\xa0View "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "col-span-3 text-md",
                                                children: "Workflows"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "col-span-2 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b6847c785790ab4$export$2e2bcd8739ae039), {
                                                        name: "workflows-view",
                                                        enabled: JSON.parse(props.selectedUser.permissions.workflows.read),
                                                        onChange: ()=>props.updatePermissions("workflows", "read", props.selectedUser)
                                                    }),
                                                    "\xa0View "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "col-span-2 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b6847c785790ab4$export$2e2bcd8739ae039), {
                                                        name: "workflows-create",
                                                        enabled: JSON.parse(props.selectedUser.permissions.workflows.create),
                                                        onChange: ()=>props.updatePermissions("workflows", "create", props.selectedUser.id)
                                                    }),
                                                    "\xa0Create "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "col-span-2 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b6847c785790ab4$export$2e2bcd8739ae039), {
                                                        name: "workflows-update",
                                                        enabled: JSON.parse(props.selectedUser.permissions.workflows.update),
                                                        onChange: ()=>props.updatePermissions("workflows", "update", props.selectedUser.id)
                                                    }),
                                                    "\xa0Modify "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "col-span-2 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b6847c785790ab4$export$2e2bcd8739ae039), {
                                                        name: "workflows-delete",
                                                        enabled: JSON.parse(props.selectedUser.permissions.workflows.delete),
                                                        onChange: ()=>props.updatePermissions("workflows", "delete", props.selectedUser.id)
                                                    }),
                                                    "\xa0Delete "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "col-span-3 text-md",
                                                children: "Tunnels"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "col-span-2 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b6847c785790ab4$export$2e2bcd8739ae039), {
                                                        name: "tunnels-view",
                                                        enabled: JSON.parse(props.selectedUser.permissions.tunnels.read),
                                                        onChange: ()=>props.updatePermissions("tunnels", "read", props.selectedUser.id)
                                                    }),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "col-span-2 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b6847c785790ab4$export$2e2bcd8739ae039), {
                                                        name: "tunnels-create",
                                                        enabled: JSON.parse(props.selectedUser.permissions.tunnels.create),
                                                        onChange: ()=>props.updatePermissions("tunnels", "create", props.selectedUser.id)
                                                    }),
                                                    "\xa0Create "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "col-span-2 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b6847c785790ab4$export$2e2bcd8739ae039), {
                                                        name: "tunnels-delete",
                                                        enabled: JSON.parse(props.selectedUser.permissions.tunnels.delete),
                                                        onChange: ()=>props.updatePermissions("tunnels", "delete", props.selectedUser.id)
                                                    }),
                                                    "\xa0Delete "
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-5 sm:mt-6",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "mt-3 w-full inline-flex justify-center rounded-md border border-cyan-300 shadow-sm px-4 py-2 bg-cyan-400 text-base font-medium text-white  hover:bg-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                                        onClick: ()=>props.close(),
                                        children: "Done"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
}


/**
 * The PricingBox component is a React component that displays pricing information and allows users to
 * select different plans.
 * @param {any} props - The `props` parameter is an object that contains the following properties:
 * @returns The PricingBox component is returning a JSX element.
 */ 

var $acw62 = parcelRequire("acw62");
function $de133166822b59c9$var$InformationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z",
        clipRule: "evenodd"
    }));
}
const $de133166822b59c9$var$ForwardRef = $acw62.forwardRef($de133166822b59c9$var$InformationCircleIcon);
var $de133166822b59c9$export$2e2bcd8739ae039 = $de133166822b59c9$var$ForwardRef;



var $acw62 = parcelRequire("acw62");
var $a3db974f37add572$exports = {};
$a3db974f37add572$exports = new URL("aws-mkt.d9293f27.png", import.meta.url).toString();


function $22801410010c8d66$export$2e2bcd8739ae039(props) {
    const [environmentCount, setEnvironmentCount] = (0, $acw62.useState)(props.account?.quantityPurchased ? props.account.quantityPurchased : 1);
    const products = props.products.filter((product)=>product.recurring.interval === "month").sort((a, b)=>a.product[0].name.localeCompare(b.name));
    const productType = props?.account ? props?.account?.label?.name?.substring(0, 3) : "";
    const activePlan = "mx-6 border border-cyan-400 rounded shadow-sm divide-y divide-cyan-400 bg-gray-700 animate-color-change-2x ring-2 ring-cyan-500 hover:ring-pink-400 cursor-pointer";
    const inactivePlan = "mx-6 border border-gray-400 rounded shadow-sm divide-y divide-cyan-400 bg-gray-700 hover:animate-color-change-2x ring-2 ring-cyan-500 hover:ring-pink-400 cursor-pointer";
    const prodPrice = 100000;
    const incrementEnvironment = ()=>setEnvironmentCount(environmentCount + 1);
    const decrementEnvironment = ()=>setEnvironmentCount(()=>Math.max(1, environmentCount - 1));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pb-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "sm:flex sm:flex-col sm:align-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "my-5 text-4xl font-bold text-gray-200 sm:text-center",
                        children: "Start building for free, upgrade when you're ready."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mt-2 space-y-4 sm:mt-2 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-2 lg:max-w-7xl lg:mx-auto xl:max-w-none xl:mx-0 xl:grid-cols-2",
                    children: [
                        props.account && products.map((product)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: productType == product.product[0].name.substring(0, 3) ? activePlan : inactivePlan,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "p-6 bg-gray-700 border rounded-t",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-2xl leading-6 text-center font-medium text-pink-400",
                                            children: product.product[0].name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-14 pt-2 w-full items-center pb-4",
                                        children: [
                                            props.account.type == "aws" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "inline px-6",
                                                children: "\xa0"
                                            }),
                                            product.product[0].name != "Developer Plan" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-2 pl-4 text-center inline",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-4xl font-extrabold text-center align-baseline text-cyan-400",
                                                        children: [
                                                            "$",
                                                            `${prodPrice / 100 * environmentCount}`
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-md font-medium text-cyan-400",
                                                        children: [
                                                            "/",
                                                            product.recurring.interval
                                                        ]
                                                    })
                                                ]
                                            }),
                                            product.product[0].name != "Developer Plan" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "inline text-xs font-medium environment-controls justify-center items-center mt-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: `${environmentCount !== props.account.quantityPurchased ? "text-pink-500" : "text-gray-200"}`,
                                                        children: [
                                                            "/environment (x",
                                                            environmentCount,
                                                            ")"
                                                        ]
                                                    }),
                                                    props.account.type == "stripe" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "border ml-2 p-2 rounded border-cyan-400",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: decrementEnvironment,
                                                                className: "text-gray-200 text-lg px-2",
                                                                children: "-"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: incrementEnvironment,
                                                                className: "text-cyan-400 text-lg px-2",
                                                                children: "+"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            product.product[0].name == "Developer Plan" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                className: "mt-5 mb-5 block w-full py-2 text-4xl font-semibold text-gray-200 text-center",
                                                children: "Free Account"
                                            }),
                                            product.product[0].name != "Developer Plan" && props.account.customerIdentifier && props.account.type == "stripe" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: "#",
                                                onClick: ()=>props.account.customerIdentifier ? props.getCustomerPortal(props.account.customerIdentifier) : props.selectProduct(product),
                                                className: "mt-4 block w-full bg-gray-600 border border-cyan-500 rounded py-2 text-sm font-semibold text-white text-center hover:bg-cyan-400",
                                                children: "Manage"
                                            }),
                                            product.product[0].name != "Developer Plan" && props.account.type == "aws" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                href: props.awsProductURL,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "mt-4 block w-full bg-gray-600 border border-gray-500 rounded py-2 text-sm font-semibold text-white text-center hover:bg-pink-400",
                                                children: [
                                                    "Manage with",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a3db974f37add572$exports))),
                                                        alt: "AWS Marketplace",
                                                        className: "inline h-12 py-2 ml-2"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "py-4 px-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-xs font-medium text-cyan-600 tracking-wide uppercase",
                                                children: "What's included"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                role: "list",
                                                className: "mt-6 space-y-4",
                                                children: product.features.map((feature)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                        className: "flex space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1045181073ad00d2$export$2e2bcd8739ae039), {
                                                                className: "flex-shrink-0 h-5 w-5 text-cyan-400",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-sm text-gray-300",
                                                                children: feature
                                                            })
                                                        ]
                                                    }, feature))
                                            })
                                        ]
                                    })
                                ]
                            }, product.product[0].name)),
                        !props.account && products.sort((a, b)=>a.product[0].name.localeCompare(b.name)).map((product)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: inactivePlan,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "p-6 bg-gray-700 rounded-t hover:rounded-t",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-2xl leading-6 text-center font-medium text-red-400",
                                            children: product.product[0].name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "px-6 pb-6",
                                        children: product.product[0].name != "Developer Plan" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "mt-8 text-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-4xl font-extrabold text-center text-cyan-400",
                                                        children: [
                                                            "$",
                                                            `${prodPrice / 100}`
                                                        ]
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        className: "text-base font-medium text-gray-500",
                                                        children: [
                                                            "/",
                                                            product.recurring.interval
                                                        ]
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                props.setRegisterModal(true);
                                            },
                                            className: "cursor-pointer pt-6 block w-full py-2 text-4xl font-semibold text-gray-200 text-center hover:animate-pulse hover:text-pink-300",
                                            children: "Free"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "pt-2 pb-8 px-6",
                                        children: [
                                            product.product[0].name != "Developer Plan" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                href: "https://docs.retrohook.com/docs/costs",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-sm font-medium text-gray-200 hover:animate-pulse hover:text-rose-300",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de133166822b59c9$export$2e2bcd8739ae039), {
                                                        className: "h-8 w-8 pb-1 inline align-middle text-cyan-300 rounded cursor-pointer hover:text-cyan-500"
                                                    }),
                                                    "Cost of Ownership Calculator"
                                                ]
                                            }) : "",
                                            product.product[0].name == "Developer Plan" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-sm mt-8 font-medium text-cyan-600 tracking-wide uppercase",
                                                children: "What's included"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-sm font-medium text-cyan-600 tracking-wide uppercase",
                                                children: "What's included"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                role: "list",
                                                className: "mt-6 space-y-4",
                                                children: product.features.map((feature)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                        className: "flex space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1045181073ad00d2$export$2e2bcd8739ae039), {
                                                                className: "flex-shrink-0 h-5 w-5 text-cyan-400",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-sm text-gray-300",
                                                                children: feature
                                                            })
                                                        ]
                                                    }, feature))
                                            })
                                        ]
                                    })
                                ]
                            }, product.product[0].name))
                    ]
                })
            ]
        })
    });
}



var $7400f1aab4e6dc27$exports = {};
$7400f1aab4e6dc27$exports = new URL("screenshot.0b48a42e.png", import.meta.url).toString();





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $1184c7e96eec4b29$var$ServerIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21.75 17.25v-.228a4.5 4.5 0 00-.12-1.03l-2.268-9.64a3.375 3.375 0 00-3.285-2.602H7.923a3.375 3.375 0 00-3.285 2.602l-2.268 9.64a4.5 4.5 0 00-.12 1.03v.228m19.5 0a3 3 0 01-3 3H5.25a3 3 0 01-3-3m19.5 0a3 3 0 00-3-3H5.25a3 3 0 00-3 3m16.5 0h.008v.008h-.008v-.008zm-3 0h.008v.008h-.008v-.008z"
    }));
}
const $1184c7e96eec4b29$var$ForwardRef = $acw62.forwardRef($1184c7e96eec4b29$var$ServerIcon);
var $1184c7e96eec4b29$export$2e2bcd8739ae039 = $1184c7e96eec4b29$var$ForwardRef;





const $b3dd31184b8ba511$var$defaultNewEnvironment = {
    name: "",
    awsAccountID: "",
    awsRegion: "",
    awsUserClientId: "",
    awsUserSecret: "",
    storage: {
        version: "latest"
    },
    network: {
        version: "latest"
    },
    compute: {
        version: "latest"
    },
    stackery: {
        version: "latest"
    }
};
const $b3dd31184b8ba511$var$placeholders = {
    awsRegion: "Enter AWS Region",
    awsUserClientId: "Enter AWS User Client ID",
    awsAccountID: "Enter AWS Account ID",
    awsUserSecret: "Enter AWS User Client Secret",
    name: "Enter Environment Name"
};
function $b3dd31184b8ba511$export$2e2bcd8739ae039(props) {
    const { post: post, get: get, response: response, loading: loading } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)((0, $15f24a665de742b6$export$2e2bcd8739ae039).url);
    const [environment, setEnvironment] = (0, $acw62.useState)($b3dd31184b8ba511$var$defaultNewEnvironment);
    const [availableRegions, setAvailableRegions] = (0, $acw62.useState)([]);
    const [userCF, setUserCF] = (0, $acw62.useState)("");
    const [loadingType, setLoadingType] = (0, $acw62.useState)("");
    const handleInputChange = (event, input)=>{
        setEnvironment({
            ...environment,
            [input]: event.target.value
        });
    };
    const saveEnvironment = async ()=>{
        setLoadingType("save");
        if (environment.name === "") return alert("Please enter a name for your environment.");
        if (environment.awsAccountID === "") return alert("Please enter your AWS account ID.");
        if (environment.awsRegion === "") return alert("Please select an AWS region.");
        if (environment.awsUserClientId === "") return alert("Please enter your AWS client ID.");
        if (environment.awsUserSecret === "") return alert("Please enter your AWS client secret.");
        if (!props.account.quantityPurchased || props.account.quantityPurchased <= props.selectedWorkspace.environments.length + 1) return alert("You have reached your environment limit.");
        const params = {
            environment: environment,
            workspace: props.selectedWorkspace,
            account: props.account
        };
        const request = await post(`environment/create/${props.user.attributes.id}`, params);
        if (request && response.ok) {
            props.setAccount(request.account);
            props.setSelectedWorkspace(request.workspace);
            setEnvironment($b3dd31184b8ba511$var$defaultNewEnvironment);
        }
        setLoadingType("");
    };
    const getUserCF = async ()=>{
        const userCFRequest = await get(`environment/setup-user/`);
        if (response.ok) setUserCF(userCFRequest.json);
    };
    const getRegions = async ()=>{
        const regions = await get(`environment/get-regions/`);
        if (response.ok) setAvailableRegions(regions.regions.Regions);
    };
    const downloadUserCF = async ()=>{
        const element = document.createElement("a");
        console.dir(JSON.stringify(userCF));
        const file = new Blob([
            JSON.stringify(userCF)
        ], {
            type: "text/plain"
        });
        element.href = URL.createObjectURL(file);
        element.download = "retrohook-user.json";
        document.body.appendChild(element);
        element.click();
    };
    (0, $acw62.useEffect)(()=>{
        getUserCF();
        getRegions();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "col-span-2",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "min-h-full bg-gray-800 p-4 shadow rounded-lg overflow-hidden hover:border-cyan-300 border-2 border-dashed",
            children: loadingType === "save" && loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col justify-center items-center min-h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "items-center animate-pulse",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: "h-24 mx-auto w-auto",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                            alt: "Logo"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            className: "mt-0 text-center text-2xl font-bold text-gray-200",
                            children: [
                                "Retrohook",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1",
                                    children: "beta"
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "absolute rounded-md p-1 pb-4 mb-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1184c7e96eec4b29$export$2e2bcd8739ae039), {
                                    className: "h-7 w-7 text-gray-50 bg-cyan-300 rounded-sm p-0.5 ring ring-cyan-400 ring-offset-2 ring-offset-cyan-300"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pl-12 mb-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                    name: "Name",
                                    onChange: (event)=>{
                                        handleInputChange(event, "name");
                                    },
                                    defaultValue: environment.name,
                                    placeholder: $b3dd31184b8ba511$var$placeholders.name
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-gray-400 text-center mt-6 mb-1",
                                children: [
                                    "1. ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        onClick: ()=>{
                                            downloadUserCF();
                                        },
                                        className: "text-cyan-300 py-0.5 border-2 border-red-400 hover:border-orange-600 rounded-sm p-1 mx-1 my-1 cursor-pointer",
                                        children: "Download"
                                    }),
                                    "Retrohook's Role Template and run it in your AWS CloudFormation."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-gray-400 text-center",
                                children: "2. Use IAM to generate a client id and secret from the user generated."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pb-2 pt-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                            name: "AWS Account ID",
                                            onChange: (event)=>{
                                                handleInputChange(event, "awsAccountID");
                                            },
                                            defaultValue: environment.awsAccountID,
                                            placeholder: $b3dd31184b8ba511$var$placeholders.awsAccountID
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pb-2 pt-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                            name: "AWS Client ID",
                                            onChange: (event)=>{
                                                handleInputChange(event, "awsUserClientId");
                                            },
                                            defaultValue: environment.awsUserClientId,
                                            placeholder: $b3dd31184b8ba511$var$placeholders.awsUserClientId
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pb-2 pt-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                            name: "AWS Client Secret",
                                            onChange: (event)=>{
                                                handleInputChange(event, "awsUserSecret");
                                            },
                                            defaultValue: environment.awsUserSecret,
                                            placeholder: $b3dd31184b8ba511$var$placeholders.awsUserSecret
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "pb-2 pt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "block text-gray-200 text-sm font-bold mb-2",
                                                children: "AWS Region"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                className: "shadow appearance-none border rounded w-full py-2 px-3 bg-transparent border-cyan-300 text-cyan-300 leading-tight focus:outline-none focus:shadow-outline",
                                                value: environment.awsRegion,
                                                onChange: (event)=>{
                                                    setEnvironment({
                                                        ...environment,
                                                        awsRegion: event.target.value
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "",
                                                        disabled: true,
                                                        children: "Select AWS Region"
                                                    }),
                                                    availableRegions && availableRegions.map((region, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                            value: region?.RegionName,
                                                            children: region?.RegionName
                                                        }, index))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "mt-2 w-full bg-cyan-300 hover:bg-cyan-400 text-white font-bold py-2 px-4 rounded  focus:outline-none focus:shadow-outline",
                                        onClick: saveEnvironment,
                                        children: "Create Environment"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/**
 * EnvironmentList renders a list of environments for a workspace.
 * It fetches environment resources from the API and displays the name, region, and stack status.
 * Allows creating, updating, deleting environments and stacks.
 */ /**
 * Component to display a list of environments for a workspace.
 * Fetches environment resources and renders name, region, stacks.
 * Allows creating, updating, deleting environments and stacks.
 */ 

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $627bea4b1d6d91cc$var$RocketLaunchIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
    }));
}
const $627bea4b1d6d91cc$var$ForwardRef = $acw62.forwardRef($627bea4b1d6d91cc$var$RocketLaunchIcon);
var $627bea4b1d6d91cc$export$2e2bcd8739ae039 = $627bea4b1d6d91cc$var$ForwardRef;






const $7f642807dbe73021$var$stacks = [
    "storage",
    "network",
    "compute"
];
const $7f642807dbe73021$var$stackStatusMap = {
    "CREATE_IN_PROGRESS": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-cyan-400 text-xs overflow-hidden",
        children: "Creating..."
    }),
    "CREATE_FAILED": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-red-400 text-xs overflow-hidden",
        children: "Failed"
    }),
    "CREATE_COMPLETE": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-green-400 text-xs overflow-hidden",
        children: "Ready"
    }),
    "ROLLBACK_IN_PROGRESS": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-cyan-400 text-xs overflow-hidden",
        children: "Rolling back..."
    }),
    "ROLLBACK_FAILED": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-red-400 text-xs overflow-hidden",
        children: "Rollback failed"
    }),
    "ROLLBACK_COMPLETE": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-green-400 text-xs overflow-hidden",
        children: "Rolled back"
    }),
    "DELETE_IN_PROGRESS": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-cyan-400 text-xs overflow-hidden",
        children: "Deleting..."
    }),
    "DELETE_FAILED": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-red-400 text-xs overflow-hidden",
        children: "Delete failed"
    }),
    "DELETE_COMPLETE": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-green-400 text-xs overflow-hidden",
        children: "Deleted"
    }),
    "UPDATE_IN_PROGRESS": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-cyan-400 text-xs overflow-hidden",
        children: "Updating..."
    }),
    "UPDATE_COMPLETE_CLEANUP_IN_PROGRESS": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-cyan-400 text-xs overflow-hidden",
        children: "Updating..."
    }),
    "UPDATE_COMPLETE": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-green-400 text-xs overflow-hidden",
        children: "Updated"
    }),
    "UPDATE_ROLLBACK_IN_PROGRESS": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-cyan-400 text-xs overflow-hidden",
        children: "Rolling back..."
    }),
    "UPDATE_ROLLBACK_FAILED": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-red-400 text-xs overflow-hidden",
        children: "Rollback failed"
    }),
    "UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-cyan-400 text-xs overflow-hidden",
        children: "Rolling back..."
    }),
    "UPDATE_ROLLBACK_COMPLETE": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-green-400 text-xs overflow-hidden",
        children: "Rolled back"
    }),
    "REVIEW_IN_PROGRESS": /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "text-cyan-400 text-xs overflow-hidden",
        children: "Reviewing..."
    })
};
function $7f642807dbe73021$export$2e2bcd8739ae039(props) {
    const { post: post, put: put, response: response, loading: loading } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)((0, $15f24a665de742b6$export$2e2bcd8739ae039).url);
    const [environments, setEnvironments] = (0, $acw62.useState)(props.selectedWorkspace.environments.filter((environment)=>environment.name !== "\uD83D\uDE80 Production" && environment.name !== "\uD83E\uDDEA Development"));
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const [currentEnvironment, setCurrentEnvironment] = (0, $acw62.useState)();
    const [currentStack, setCurrentStack] = (0, $acw62.useState)();
    const [isEnvModalOpen, setIsEnvModalOpen] = (0, $acw62.useState)(false);
    const hydrateStacks = async ()=>{
        const promises = props.selectedWorkspace.environments.map(async (environment)=>{
            await getStackResources(environment);
        });
        Promise.all(promises).then(()=>{
            setEnvironments(props.selectedWorkspace.environments.filter((environment)=>environment.name !== "\uD83D\uDE80 Production" && environment.name !== "\uD83E\uDDEA Development"));
        }).catch((error)=>{
            console.log(error);
        });
    };
    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, the
  effect is triggered whenever the `props.selectedWorkspace.environments` array changes. */ (0, $acw62.useEffect)(()=>{
        hydrateStacks();
    }, [
        JSON.stringify(props.selectedWorkspace.environments)
    ]);
    /* The above code is a useEffect hook in a TypeScript React component. It is used to update the state
 variable "environments" based on the "selectedWorkspace" prop. */ (0, $acw62.useEffect)(()=>{
        setEnvironments(props.selectedWorkspace.environments.filter((environment)=>environment.name !== "\uD83D\uDE80 Production" && environment.name !== "\uD83E\uDDEA Development"));
        hydrateStacks();
    }, [
        JSON.stringify(props.selectedWorkspace)
    ]);
    /**
   * The function `getStackResources` is an asynchronous function that retrieves environment resources
   * and updates the list of environments.
   * @param {any} environment - The `environment` parameter is an object that represents the
   * environment for which we want to get stack resources. It can contain any properties that are
   * necessary to identify the environment, such as an ID or a name.
   */ const getStackResources = async (environment)=>{
        let newEnvs = environments ? environments : props.selectedWorkspace.environments;
        const environmentRequest = await post(`environment/get/${props.user.attributes.id}`, environment);
        if (response.ok && environmentRequest) {
            newEnvs = newEnvs.filter((env)=>env.SK !== environmentRequest.environment.SK);
            newEnvs.push(environmentRequest.environment);
            setEnvironments(newEnvs.filter((environment)=>environment.name !== "\uD83D\uDE80 Production" && environment.name !== "\uD83E\uDDEA Development"));
            props.setupEnvironmentsHandler(newEnvs);
        }
    };
    /**
   * The function `saveEnvironment` is an asynchronous function that takes in an `environment` and
   * `workspace` parameter, and it makes a POST request to create a new environment using the provided
   * parameters and the `props.account` value.
   * @param {any} environment - The `environment` parameter is an object that represents the
   * environment you want to update. It could contain properties such as the environment name,
   * description, configuration settings, or any other relevant information about the environment.
   * @param {any} workspace - The `workspace` parameter is an object that represents the workspace
   * where the environment will be created. It likely contains information such as the workspace ID,
   * name, and any other relevant details about the workspace.
   */ const saveEnvironment = async (environment, workspace)=>{
        const params = {
            environment: environment,
            workspace: workspace,
            account: props.account
        };
        return await post(`environment/create/${props.user.attributes.id}`, params);
    };
    /**
   * The function handles the change of an environment name and updates the environment and selected
   * workspace.
   * @param {any} event - The `event` parameter is an object that represents the event that triggered
   * the function. It contains information about the event, such as the target element and the value of
   * the input field that triggered the event.
   * @param {any} environment - The `environment` parameter is an object that represents an
   * environment. It likely has properties such as `name`, `id`, and other attributes that describe the
   * environment.
   */ const handleEnvironmentNameChange = (event, environment)=>{
        environment.name = event.target.value;
        saveEnvironment(environment, props.selectedWorkspace);
    };
    /**
   * The function `deployStack` deploys a stack in a specific environment using the provided
   * parameters.
   * @param {any} environment - The `environment` parameter is an object that represents the
   * environment in which the stack will be deployed. It could contain properties such as the
   * environment name, configuration settings, and other relevant information.
   * @param {string} stack - The `stack` parameter is a string that represents the type of stack to be
   * deployed. It could be something like "frontend", "backend", or any other specific stack name.
   */ const deployStack = async (environment, stack)=>{
        const params = {
            environment: environment,
            workspace: props.selectedWorkspace,
            account: props.account
        };
        const deployRequest = await post(`environment/deploy-${stack}/${props.user.attributes.id}`, params);
        if (deployRequest && response.ok) {
            getStackResources(environment);
            props.setSelectedWorkspace(deployRequest.workspace);
            props.setAccount(deployRequest.account);
        }
    };
    /**
   * The function `reDeployStack` is an asynchronous function that takes in an environment and stack as
   * parameters, and it sends a POST request to redeploy the specified stack in the given environment.
   * @param {any} environment - The `environment` parameter is a variable that represents the
   * environment in which the stack will be redeployed. It could be a string or an object containing
   * information about the environment.
   * @param {string} stack - The `stack` parameter is a string that represents the name or identifier
   * of the stack that needs to be redeployed.
   */ const reDeployStack = async (environment, stack)=>{
        const params = {
            environment: environment,
            workspace: props.selectedWorkspace,
            account: props.account
        };
        const deployRequest = await post(`environment/redeploy-${stack}/${props.user.attributes.id}`, params);
        if (deployRequest && response.ok) {
            getStackResources(environment);
            props.setSelectedWorkspace(deployRequest.workspace);
            props.setAccount(deployRequest.account);
        }
    };
    /**
   * The function `updateStack` updates a stack in a given environment using the provided parameters.
   * @param {any} environment - The `environment` parameter is a variable that represents the
   * environment in which the stack is being updated. It could be a string or an object containing
   * information about the environment.
   * @param {string} stack - The `stack` parameter is a string that represents the name or identifier
   * of the stack that you want to update.
   */ const updateStack = async (environment, stack)=>{
        const params = {
            environment: environment,
            workspace: props.selectedWorkspace,
            account: props.account
        };
        await put(`environment/update-${stack}/${props.user.attributes.id}`, params);
    };
    /**
   * The function `deleteStack` is an asynchronous function that takes in an environment and a stack as
   * parameters, and sends a delete request to the server to delete the specified stack in the
   * specified environment.
   * @param {any} environment - The `environment` parameter is a variable that represents the
   * environment in which the stack is located. It could be a string or an object that contains
   * information about the environment, such as its name or ID.
   * @param {string} stack - The `stack` parameter is a string that represents the name or identifier
   * of the stack that you want to delete.
   */ const deleteStack = async (environment, stack)=>{
        const params = {
            environment: environment,
            workspace: props.selectedWorkspace,
            account: props.account
        };
        const deleteRequest = await post(`environment/delete-${stack}/${props.user.attributes.id}`, params);
        if (deleteRequest && response.ok) {
            props.setSelectedWorkspace(deleteRequest.workspace);
            props.setAccount(deleteRequest.account);
        }
    };
    /**
   * The function `deleteEnvironment` is an asynchronous function that deletes an environment and
   * updates the account and selected workspace if the deletion is successful.
   * @param {any} environment - The `environment` parameter is an object that represents the
   * environment to be deleted. It can contain any properties or data that are relevant to the
   * environment being deleted.
   */ const deleteEnvironment = async (environment)=>{
        const params = {
            environment: environment,
            workspace: props.selectedWorkspace,
            account: props.account
        };
        const deleteRequest = await post(`environment/delete-environment/${props.user.attributes.id}`, params);
        if (deleteRequest && response.ok) {
            props.setAccount(deleteRequest.account);
            props.setSelectedWorkspace(deleteRequest.workspace);
            setEnvironments(deleteRequest.workspace.environments.filter((env)=>env !== environment));
        }
    };
    /**
   * The above code defines functions for opening and closing a modal, and confirming a delete action.
   * @param {any} environment - The "environment" parameter is a variable that represents the current
   * environment or context in which the modal is being opened. It could be a string, object, or any
   * other data type that represents the environment.
   * @param {string} stack - The "stack" parameter is a string that represents the stack to be deleted.
   */ const openModal = (environment, stack)=>{
        setCurrentEnvironment(environment);
        setCurrentStack(stack);
        setIsModalOpen(true);
    };
    /**
  * The closeModal function sets the state variable isModalOpen to false.
  */ const closeModal = ()=>{
        setIsModalOpen(false);
    };
    /**
   * The function `confirmDelete` deletes a stack in the current environment and closes a modal.
   */ const confirmDelete = ()=>{
        deleteStack(currentEnvironment, currentStack);
        closeModal();
    };
    const openEnvModal = (environment)=>{
        setCurrentEnvironment(environment);
        setIsEnvModalOpen(true);
    };
    /**
  * The closeModal function sets the state variable isModalOpen to false.
  */ const closeEnvModal = ()=>{
        setIsEnvModalOpen(false);
    };
    /**
   * The function `confirmDelete` deletes a stack in the current environment and closes a modal.
   */ const confirmEnvDelete = ()=>{
        deleteEnvironment(currentEnvironment);
        closeEnvModal();
    };
    /**
   * The following code renders the EnvironmentList component.
   */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53dccccfeb3e8d8d$export$2e2bcd8739ae039), {
                isOpen: isModalOpen,
                onClose: closeModal,
                onConfirm: ()=>confirmDelete(),
                title: "Confirm Delete Stack",
                message: `Are you sure you want to delete ${currentStack} for ${currentEnvironment?.name}?`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53dccccfeb3e8d8d$export$2e2bcd8739ae039), {
                isOpen: isEnvModalOpen,
                onClose: closeEnvModal,
                onConfirm: ()=>confirmEnvDelete(),
                title: "Confirm Delete Environment",
                message: `Are you sure you want to delete ${currentEnvironment?.name}?`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "col-span-5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                    className: "grid grid-cols-1 gap-2 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2",
                    children: environments.map((environment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "relative bg-gray-800 p-4 shadow rounded-lg overflow-hidden hover:border-cyan-300 border-2 border-solid",
                            children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "items-center animate-pulse",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "h-14 mx-auto w-auto",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                        alt: "Logo"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                        className: "mt-0 text-center text-xl font-bold text-gray-200",
                                        children: [
                                            "Retrohook",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1",
                                                children: "beta"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1184c7e96eec4b29$export$2e2bcd8739ae039), {
                                                className: "h-7 w-7 mr-4 text-gray-50 bg-cyan-300 rounded-sm px-0.5 ring ring-cyan-400 ring-offset-2 ring-offset-cyan-300"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                name: "Name",
                                                onChange: (event)=>{
                                                    handleEnvironmentNameChange(event, environment);
                                                },
                                                defaultValue: environment.name,
                                                placeholder: environment.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "px-2 text-center text-xs text-pink-400",
                                                children: `${environment.region}@${environment.accountId}`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex justify-end space-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "text-xs bg-gray-700 hover:bg-pink-500 text-white font-bold px-2 py-1 rounded focus:outline-none focus:shadow-outline",
                                                        onClick: ()=>getStackResources(environment),
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a08ef469b8107069$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        })
                                                    }),
                                                    !environment["storage"].status?.includes("DELETE_COMPLETE") || !environment["storage"].stackID ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "text-xs bg-gray-700 hover:bg-pink-500 text-white font-bold px-2 py-1 rounded focus:outline-none focus:shadow-outline",
                                                        onClick: ()=>openEnvModal(environment),
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $beefe28644f6e8ce$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "grid grid-cols-3 gap-6 pt-4",
                                        children: $7f642807dbe73021$var$stacks.map((stack)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-lg text-gray-400 capitalize",
                                                        children: stack
                                                    }),
                                                    environment[stack]?.status ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs text-cyan-400 overflow-hidden",
                                                            children: environment[stack]?.status.length ? $7f642807dbe73021$var$stackStatusMap[environment[stack].status] : "Deployed"
                                                        })
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-cyan-400",
                                                        children: "Deployable"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex mt-1 items-center text-md text-white font-bold focus:outline-none focus:shadow-outline",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "w-full items-center mx-2",
                                                            children: !environment[stack].status?.includes("PROGRESS") && !environment[stack].status?.includes("DELETE_COMPLETE") || stack == "storage" && !environment["storage"].status?.includes("PROGRESS") && !environment["storage"].status?.includes("DELETE_COMPLETE") && environment["compute"].status?.includes("DELETE_COMPLETE") && environment["network"].status?.includes("DELETE_COMPLETE") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "px-2 py-1 bg-gray-700 hover:bg-pink-500 rounded",
                                                                onClick: ()=>openModal(environment, stack),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $beefe28644f6e8ce$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5 text-pink-400"
                                                                })
                                                            }) : !environment[stack]?.status?.includes("PROGRESS") && stack != "storage" && !environment["storage"]?.status?.includes("FAIL") && stack != "storage" && !environment["storage"]?.status?.includes("PROGRESS") && environment["storage"]?.status?.includes("CREATE_COMPLETE") && stack != "storage" && !environment[stack]?.status?.includes("CREATE_COMPLETE") || stack == "storage" && !environment[stack]?.status?.includes("PROGRESS") && !environment[stack]?.status?.includes("CREATE_COMPLETE") ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                className: "px-2 py-1 bg-gray-700 hover:bg-cyan-500 rounded",
                                                                onClick: ()=>environment[stack].stackID ? reDeployStack(environment, stack) : deployStack(environment, stack),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $627bea4b1d6d91cc$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5 text-cyan-400"
                                                                })
                                                            }) : null
                                                        })
                                                    })
                                                ]
                                            }, stack))
                                    })
                                ]
                            })
                        }, environment.SK))
                })
            })
        ]
    });
}


function $bcd5426e01c10e75$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "p-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "grid grid-cols-7 gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3dd31184b8ba511$export$2e2bcd8739ae039), {
                    user: props.user,
                    account: props.account,
                    setAccount: props.setAccount,
                    selectedWorkspace: props.selectedWorkspace,
                    setSelectedWorkspace: props.setSelectedWorkspace,
                    setupEnvironmentsHandler: props.setupEnvironmentsHandler
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f642807dbe73021$export$2e2bcd8739ae039), {
                    user: props.user,
                    account: props.account,
                    setAccount: props.setAccount,
                    selectedWorkspace: props.selectedWorkspace,
                    setSelectedWorkspace: props.setSelectedWorkspace,
                    setupEnvironmentsHandler: props.setupEnvironmentsHandler
                })
            ]
        })
    });
}



const $33cc5aa81380ea1d$var$awsProductURL = "https://aws.amazon.com/marketplace/pp/prodview-boo4ccgoad3ae";
const $33cc5aa81380ea1d$var$basePermissions = {
    dashboard: {
        read: Boolean(true)
    },
    workflows: {
        create: false,
        read: false,
        update: false,
        delete: false
    },
    tunnels: {
        create: false,
        read: false,
        delete: false
    },
    workspace: {
        admin: false
    }
};
const $33cc5aa81380ea1d$var$newInvite = {
    firstName: "",
    lastName: "",
    email: "",
    tempPass: "",
    permissions: $33cc5aa81380ea1d$var$basePermissions
};
function $33cc5aa81380ea1d$export$2e2bcd8739ae039(props) {
    const { post: post, get: get, response: response, loading: loading } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)();
    const [subUx, setSubUx] = (0, $acw62.useState)("Settings");
    const [error, setError] = (0, $acw62.useState)(null);
    const [products, setProducts] = (0, $acw62.useState)([]);
    const [contactModal, setContactModal] = (0, $acw62.useState)(false);
    const [paymentModal, setPaymentModal] = (0, $acw62.useState)(false);
    const [selectedProduct, setSelectedProduct] = (0, $acw62.useState)(null);
    const [togglePermissions, setTogglePermissions] = (0, $acw62.useState)(false);
    const [selectedUser, setSelectedUser] = (0, $acw62.useState)({
        permissions: $33cc5aa81380ea1d$var$basePermissions,
        email: "",
        name: "",
        id: ""
    });
    const [invite, setInvite] = (0, $acw62.useState)($33cc5aa81380ea1d$var$newInvite);
    const [customer, setCustomer] = (0, $acw62.useState)({});
    const [billingUX, setBillingUX] = (0, $acw62.useState)("");
    const [loadingType, setLoadingType] = (0, $acw62.useState)("");
    const [quantityPurchased, setQuantityPurchased] = (0, $acw62.useState)(0);
    const [workspace, setWorkspace] = (0, $acw62.useState)(props.selectedWorkspace);
    (0, $acw62.useEffect)(()=>{
        getProducts();
        setWorkspace(props.selectedWorkspace);
    }, [
        props.selectedWorkspace
    ]);
    const getProducts = async ()=>{
        const productItems = await get(`account/get-stripe-products/${props.user.account.PK}`);
        if (productItems?.data) {
            const items = productItems.data;
            const promises = items.map((product)=>{
                if (product.product[0].name == "Production Plan" && product.product[0].active) product.features = [
                    "Everything in Developer Plan +",
                    "Create unlimited workflows for streamlined legacy healthcare events.",
                    "Invite unlimited team members to collaborate in a shared, efficient workspace.",
                    "Simple AWS Deployment: Deploy Retrohook into your AWS account with ease.",
                    "Production Environment: Create a single production environment for your organization. (more can be purchased)",
                    "Secure Connectivity: Generate and establish up to 5 IPSEC VPN Tunnels for robust and secure remote connections."
                ];
                else if (product.product[0].name == "Developer Plan" && product.product[0].active) product.features = [
                    "Effortless Serverless Healthcare Messaging: Experience seamless hl7v2 communication without the complexities of server management",
                    "Test Workflows: Design and test up to 5 non-PHI workflows, perfect for experimentation and learning.",
                    "Developer Workspace: Collaborate effectively with a 3-seat workspace designed for dynamic development teams.",
                    "Message Allocation: Benefit from 100 messages per month, allowing for ample testing and development.",
                    "Community Support: Gain insights and assistance from a community that understands your development needs."
                ];
                return product;
            });
            const products = await Promise.all(promises).then((res)=>{
                return res;
            }).catch((error)=>{
                console.error(error);
            });
            const filtered = products.filter((product)=>product.product[0].active != false && product.active != false);
            console.dir(filtered);
            setProducts(filtered.sort((a, b)=>a.unit_amount > b.unit_amount ? 1 : -1));
        }
    };
    const selectProduct = async (product, quantityPurchased)=>{
        if (product.product[0].name != "Enterprise Plan" && product.product[0].name != "Developer Plan") {
            if (props.account.type != "aws") {
                await checkoutStripe(product.id, quantityPurchased);
                setSelectedProduct(product);
                setPaymentModal(!paymentModal);
            } else window.location.replace($33cc5aa81380ea1d$var$awsProductURL);
        }
        if (product.product[0].name == "Enterprise Plan") {
            setSelectedProduct(product);
            setContactModal(!contactModal);
        }
    };
    const getStripeCustomer = async ()=>{
        const customer = await get(`account/get-stripe-customer/${props.account.customerId}`);
        if (response.ok) return customer.customer;
    };
    const getCustomerPortal = async ()=>{
        if (props.account.customerIdentifier) {
            if (props.account.type == "stripe") {
                const customerPortal = await get(`account/generate-stripe-customer-portal-session/${props.account.customerIdentifier}`);
                if (response.ok) window.location.replace(customerPortal.portalSession.url);
            }
            if (props.account.type == "aws") window.location.replace($33cc5aa81380ea1d$var$awsProductURL);
        }
    };
    const createStripeCustomer = async ()=>{
        const body = {
            email: props.selectedWorkspace.email
        };
        const newCustomer = await post(`account/create-stripe-customer/${props.user.attributes.id}`, body);
        if (response.ok) return newCustomer.customer;
    };
    const checkoutStripe = async (priceId, quantityPurchased)=>{
        let customerId = props.account.customerId;
        if (props.account.customerId) {
            const customer = await getStripeCustomer();
            customerId = customer.id;
            setCustomer(customer);
        } else {
            const customer = await createStripeCustomer();
            customerId = customer.id;
            setCustomer(customer);
        }
        const body = {
            priceId: priceId,
            quantityPurchased: quantityPurchased,
            customerId: customerId,
            account: props.account
        };
        const checkout = await post(`account/generate-stripe-checkout-session/${props.user.attributes.id}`, body);
        if (response.ok) window.location.replace(checkout.session.url);
    };
    const handleNewUserFirstNameChange = (event)=>{
        const updated = {
            ...invite,
            firstName: event.target.value
        };
        setInvite(updated);
    };
    const handleNewUserLastNameChange = (event)=>{
        const updated = {
            ...invite,
            lastName: event.target.value
        };
        setInvite(updated);
    };
    const handleNewUserEmailChange = (event)=>{
        const updated = {
            ...invite,
            email: event.target.value
        };
        setInvite(updated);
    };
    const handleMessageIDValueChange = (event)=>{
        const updated = {
            ...workspace,
            hash: {
                ...workspace.hash,
                value: event.target.value
            }
        };
        setWorkspace(updated);
    };
    const handleMessageIDChange = (event)=>{
        const updated = {
            ...workspace,
            hash: {
                ...workspace.hash,
                location: event.target.value
            }
        };
        setWorkspace(updated);
    };
    const handleOrganizationValueChange = (event)=>{
        console.dir(event.target.value);
        const updated = {
            ...workspace,
            organization: event.target.value,
            name: event.target.value
        };
        setWorkspace(updated);
    };
    const openPermissions = (user)=>{
        setSelectedUser(user);
        setTogglePermissions(true);
    };
    const closePermissions = ()=>{
        setTogglePermissions(false);
        setSelectedUser({
            permissions: $33cc5aa81380ea1d$var$basePermissions,
            email: "",
            name: "",
            id: ""
        });
    };
    const clearInvite = ()=>{
        const invite = {
            firstName: "",
            lastName: "",
            email: "",
            tempPass: "",
            permissions: $33cc5aa81380ea1d$var$basePermissions
        };
        setInvite(invite);
    };
    const addUserToWorkspace = async (slug)=>{
        if (!invite.firstName || !invite.lastName || !invite.email) {
            const error = "MissingInviteFields";
            setError(error);
            return;
        }
        invite.tempPass = `${(Math.random() + 1).toString(36).substring(6)}-HL7!`;
        const body = {
            workspace: workspace,
            invite: invite,
            account: props.account
        };
        let usersMax;
        if (workspace.quantityPurchased < 1) usersMax = 5;
        else usersMax = workspace.quantityPurchased * 10;
        if (workspace.accounts.length >= usersMax) {
            const error = "AccountUserLimitAlert";
            setError(error);
        } else {
            const newAccount = await post(`account/workspace-invite/${slug}`, body);
            if (newAccount) {
                setWorkspace(newAccount.workspace);
                props.setAccount(newAccount.account);
            }
        }
        setLoadingType("");
        clearInvite();
    };
    const removeUserFromWorkspace = async (selectedUser)=>{
        const params = {
            selectedUser: selectedUser,
            workspaceParams: workspace,
            account: props.account
        };
        const response = await post(`account/workspace-remove/${props.user.attributes.id}`, params);
        if (response) {
            props.setSelectedWorkspace(response.data);
            setWorkspace(response.data);
        }
    };
    const updatePermissions = (resource, permission)=>{
        selectedUser.permissions[resource][permission] = !JSON.parse(selectedUser.permissions[resource][permission]);
        const accounts = workspace.accounts.map((account)=>{
            if (account.email == selectedUser.email) {
                if (account.permissions[resource][permission] == true || account.permissions[resource][permission] == "true") account.permissions[resource][permission] = true;
                else account.permissions[resource][permission] = false;
            }
            return account;
        });
        setWorkspace({
            ...workspace,
            accounts: accounts
        });
    };
    const savePermissions = async ()=>{
        const response = await post(`account/update-workspace/${props.selectedWorkspace.PK}`, {
            account: props.account,
            workspace: props.selectedWorkspace
        });
        if (response.ok) props.getWorkspace();
        closePermissions();
    };
    const saveWorkspace = async (workspace)=>{
        const response = await post(`account/update-workspace/${props.user.attributes.id}`, {
            account: props.account,
            workspace: workspace
        });
        if (response.ok && response.data) setWorkspace(response.data);
    };
    if (!loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-gray-800 flex-1 min-w-0 flex items-center justify-between px-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-full mx-auto py-4 px-6 flex grow",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "text-lg leading-6 font-semibold text-gray-100 pr-2",
                                children: [
                                    "Workspace ",
                                    props.selectedWorkspace ? `${subUx}` : subUx
                                ]
                            })
                        }),
                        subUx == "Settings" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e3f88f35ab51eb8$export$2e2bcd8739ae039), {
                            icon: (0, $52a5ad4e9e45ae5f$export$2e2bcd8739ae039),
                            title: "General",
                            clickHandler: ()=>setSubUx("Settings")
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa6002d268f58925$export$2e2bcd8739ae039), {
                            icon: (0, $52a5ad4e9e45ae5f$export$2e2bcd8739ae039),
                            title: "General",
                            clickHandler: ()=>setSubUx("Settings")
                        }),
                        subUx == "Team Settings" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e3f88f35ab51eb8$export$2e2bcd8739ae039), {
                            icon: (0, $4295805cb2bcb89a$export$2e2bcd8739ae039),
                            title: "Team",
                            clickHandler: ()=>setSubUx("Team Settings")
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa6002d268f58925$export$2e2bcd8739ae039), {
                            icon: (0, $4295805cb2bcb89a$export$2e2bcd8739ae039),
                            title: "Team",
                            clickHandler: ()=>setSubUx("Team Settings")
                        }),
                        subUx == "Environments" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e3f88f35ab51eb8$export$2e2bcd8739ae039), {
                            icon: (0, $0c6ba30950984529$export$2e2bcd8739ae039),
                            title: "Environments",
                            clickHandler: ()=>setSubUx("Environments")
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa6002d268f58925$export$2e2bcd8739ae039), {
                            icon: (0, $0c6ba30950984529$export$2e2bcd8739ae039),
                            title: "Environments",
                            clickHandler: ()=>setSubUx("Environments")
                        }),
                        subUx == "Subscription" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e3f88f35ab51eb8$export$2e2bcd8739ae039), {
                            icon: (0, $0c6ba30950984529$export$2e2bcd8739ae039),
                            title: "Subscription",
                            clickHandler: ()=>setSubUx("Subscription")
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa6002d268f58925$export$2e2bcd8739ae039), {
                            icon: (0, $0c6ba30950984529$export$2e2bcd8739ae039),
                            title: "Subscription",
                            clickHandler: ()=>setSubUx("Subscription")
                        })
                    ]
                })
            }),
            error == "UsernameExistsException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $150d1375c9f14622$export$2e2bcd8739ae039), {
                closeAlert: setError(null)
            }),
            error == "PasswordNotComplexException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0d642fad3c697a7$export$2e2bcd8739ae039), {
                closeAlert: setError(null)
            }),
            error == "AccountUserLimitAlert" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7e61a371f7755339$export$2e2bcd8739ae039), {
                closeAlert: setError(null)
            }),
            error == "EmailFormatException" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $348033d0f84652f0$export$2e2bcd8739ae039), {
                closeAlert: setError(null)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                children: props.selectedWorkspace && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-gray-800 border-2 min-h-full mt-4 rounded border-cyan-300 mx-4 overflow-hidden",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            subUx == "Settings" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mb-6 sm:flex sm:flex-col sm:align-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-xl w-full p-5 text-gray-200",
                                                children: "General Settings"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "p-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e3f88f35ab51eb8$export$2e2bcd8739ae039), {
                                                    icon: (0, $3a4947f8c0c2fcf7$export$2e2bcd8739ae039),
                                                    title: "Save",
                                                    clickHandler: ()=>saveWorkspace(workspace)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mx-6 border border-top border-cyan-300 mb-6"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: " grid grid-cols-12 gap-2 px-4 pb-6",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "col-span-11 text-gray-200",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                name: "Team Name",
                                                onChange: (event)=>{
                                                    event.preventDefault();
                                                    handleOrganizationValueChange(event);
                                                },
                                                placeholder: workspace ? workspace : "",
                                                defaultValue: workspace ? workspace.name : ""
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mx-6 border border-top border-cyan-300 mb-6"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "mx-4 my-5 text-s text-gray-600 border-4 px-2 py-2 border-red-300 rounded",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca6349d0f67ac97f$export$2e2bcd8739ae039), {
                                                className: "h-6 w-6 inline text-pink-500 rounded"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "pl-3 text-pink-500",
                                                children: "You must include the Workflow Message ID Value below in the stated Workflow Message ID Location of your HL7 Messages for security."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: " grid grid-cols-12 gap-2 px-4 pb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "col-span-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                    name: "Workflow Message ID Location",
                                                    onChange: handleMessageIDChange,
                                                    placeholder: workspace ? workspace.hash.location : "",
                                                    defaultValue: workspace ? workspace.hash.location : ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "col-span-7",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                    name: "Workflow Message ID Value",
                                                    onChange: handleMessageIDValueChange,
                                                    placeholder: workspace ? workspace.hash.value : "",
                                                    defaultValue: workspace ? workspace.hash.value : ""
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            subUx == "Team Settings" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "sm:flex sm:flex-col sm:align-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                        className: "w-full text-xl p-4 text-gray-200 bg-gray-800",
                                        children: [
                                            "Owner | ",
                                            props.account?.email
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "w-full text-xl p-4 text-cyan-300 bg-gray-800",
                                        children: "Members"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb911cc5b03afdb5$export$2e2bcd8739ae039), {
                                        open: togglePermissions,
                                        close: savePermissions,
                                        updatePermissions: updatePermissions,
                                        selectedUser: selectedUser
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                        className: "mb-6 mx-2",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                            children: [
                                                workspace?.accounts?.filter((account)=>{
                                                    if (account.email != workspace?.owner?.email) return account;
                                                }).map((user, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                        className: index % 2 === 0 ? "border-gray-400 border-2 text-gray-200 hover:border-4 hover:border-cyan-600" : "border-gray-400 border-2 text-gray-200 hover:border-4 hover:border-cyan-600",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                className: "px-4 py-4 whitespace-wrap text-md font-light text-gray-200",
                                                                children: [
                                                                    " ",
                                                                    user.email ? user.email : ""
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "whitespace-wrap px-2 text-sm text-gray-800",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "w-full  bg-gray-500 py-2 hover:bg-cyan-400 text-white rounded focus:outline-none focus:shadow-outline",
                                                                    type: "button",
                                                                    onClick: ()=>{
                                                                        openPermissions(user);
                                                                    },
                                                                    children: "Permissions"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                className: "whitespace-wrap px-2 text-sm text-gray-800",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    className: "w-full bg-gray-500 py-2 hover:bg-pink-500 text-white rounded focus:outline-none focus:shadow-outline",
                                                                    type: "button",
                                                                    onClick: ()=>{
                                                                        removeUserFromWorkspace(user);
                                                                        setLoadingType("remove");
                                                                    },
                                                                    children: "X"
                                                                })
                                                            })
                                                        ]
                                                    }, user.email + index)),
                                                " "
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mx-6 border border-top border-gray-300"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "w-full text-xl p-4 text-pink-500 bg-gray-800",
                                        children: "Invite"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
                                        className: "min-w-full",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-2 py-4 whitespace-nowrap text-md text-gray-200",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                            name: "First Name",
                                                            onChange: handleNewUserFirstNameChange,
                                                            defaultValue: invite.firstName
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-2 py-4 whitespace-nowrap text-md text-gray-200",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                            name: "Last Name",
                                                            onChange: handleNewUserLastNameChange,
                                                            defaultValue: invite.lastName
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-2 py-4 whitespace-nowrap text-md text-gray-200",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                                            name: "Email",
                                                            onChange: handleNewUserEmailChange,
                                                            defaultValue: invite.email
                                                        })
                                                    }),
                                                    !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-2 py-3 whitespace-nowrap text-md text-gray-200",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "w-full bg-cyan-500 hover:bg-cyan-400 py-2 px-1 text-white rounded focus:outline-none focus:shadow-outline",
                                                            type: "button",
                                                            onClick: ()=>{
                                                                addUserToWorkspace(props.user.attributes.id);
                                                                setLoadingType("invite");
                                                            },
                                                            children: "Send Invite"
                                                        })
                                                    }),
                                                    loading && loadingType == "invite" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "px-2 py-3 whitespace-nowrap text-md text-gray-200",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            className: "w-full bg-gray-500 hover:bg-gray-400 py-2 px-1 text-white rounded focus:outline-none focus:shadow-outline animate-bounce",
                                                            type: "button",
                                                            children: "Sending..."
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            subUx == "Environments" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcd5426e01c10e75$export$2e2bcd8739ae039), {
                                user: props.user,
                                account: props.account,
                                setAccount: props.setAccount,
                                selectedWorkspace: props.selectedWorkspace,
                                setSelectedWorkspace: props.setSelectedWorkspace,
                                setupEnvironmentsHandler: props.setupEnvironmentsHandler
                            }),
                            subUx == "Subscription" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $22801410010c8d66$export$2e2bcd8739ae039), {
                                    account: props.account,
                                    products: products,
                                    selectProduct: selectProduct,
                                    getAccount: props.getAccount,
                                    awsProductURL: $33cc5aa81380ea1d$var$awsProductURL,
                                    quantityPurchased: quantityPurchased,
                                    setQuantityPurchased: setQuantityPurchased,
                                    selectedProduct: selectedProduct,
                                    getCustomerPortal: getCustomerPortal,
                                    selectedWorkspace: props.selectedWorkspace,
                                    ux: billingUX
                                })
                            }),
                            subUx == "Release Notes" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "px-4 sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "relative mx-auto max-w-[37.5rem] pt-20 text-center pb-20",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                    className: "text-4xl font-extrabold tracking-tight text-gray-300 sm:text-5xl",
                                                    children: "Changelog"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "mt-4 text-base leading-7 text-cyan-400",
                                                    children: "Stay up to date with all of the latest additions and improvements we've made to Retrohook. We'll be updating this page regularly with all of the latest changes and will provide a way to subscribe soon."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                        id: "2022-12-15",
                                        "aria-labelledby": "2022-12-15-heading",
                                        className: "md:flex",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                id: "2022-12-15-heading",
                                                className: "pl-7 text-md leading-6 text-slate-500 md:w-1/4 md:pl-0 md:pr-6 md:text-right",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    href: "#2023-06-01",
                                                    className: "text-cyan-400",
                                                    children: "June 1st, 2023"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "relative py-4 mx-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-300",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "relative flex space-x-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "min-w-0 flex-1 flex justify-between space-x-1"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "max-w-none prose-h3:mb-4 pl-12 prose-h3:text-base prose-h3:leading-6 prose-sm prose prose-slate prose-a:font-semibold prose-a:text-pink-500 hover:prose-a:text-purple-600",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                                        className: "text-red-400 text-2xl",
                                                                        children: "Beta Release \uD83C\uDF89"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "py-4 text-gray-200",
                                                                        children: "Today we're happy to announce the launch of our baseline HL7v2 tool. We've been working hard to build a platform that will help you work with HL7 messages quickly and easily. We're excited to share this with you and we hope you enjoy it! Check out our documentation or just start building with our workflow builder."
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                        href: "/workflows",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                            className: "rounded-xl ring-1 ring-offset-[-1px] ring-slate-700/10",
                                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7400f1aab4e6dc27$exports))),
                                                                            alt: "Workflow Builder"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "items-center animate-pulse py-48 sm:py-24 md:py-32 lg:py-48",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "h-24 mx-auto w-auto",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                alt: "Logo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                className: "mt-0 text-center text-2xl font-bold text-gray-200",
                children: [
                    "Retrohook",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1"
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");



function $e514edb69a85f2e1$export$2e2bcd8739ae039(props) {
    const { post: post } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)();
    const [subUx, setSubUx] = (0, $acw62.useState)("Settings");
    const [account, setAccount] = (0, $acw62.useState)(props.selectedAccount);
    const handleFirstNameChange = (event)=>{
        setAccount({
            ...account,
            firstName: event.target.value
        });
    };
    const saveAccount = async (accountParams)=>{
        if (!accountParams.hash.value) {
            accountParams.hash.value = (0, (/*@__PURE__*/$parcel$interopDefault($92d8b824f9c60d69$exports)))();
            accountParams.hash.location = "MSH.8";
        }
        const response = await post(`account/update-account/${props.user.attributes.id}`, {
            accountParams: accountParams
        });
        if (response.ok && response.data) {
            props.setAccountHandler(response.data);
            if (account.SK == props.selectedAccount.SK) props.setSelectedAccount(response.data);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-gray-900 flex-1 min-w-0 flex items-center justify-between px-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-full max-w-7xl mx-auto py-4 px-6 flex grow",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            className: "text-lg leading-6 font-semibold text-gray-100 pr-2",
                            children: [
                                "Account ",
                                props.selectedAccount ? `${subUx}` : subUx
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dl", {
                children: props.selectedEnvironment && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "relative bg-gray-800 border-2 mt-4 rounded border-cyan-300 pb-5 mx-4 overflow-hidden cursor-pointer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mb-6 sm:flex sm:flex-col sm:align-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-xl p-5 text-gray-200",
                                    children: "General Settings"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mx-6 border border-top border-cyan-300 mb-6"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: " grid grid-cols-12 gap-2 px-4 pb-6",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "col-span-11 text-gray-200",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1d8e6d8020609c6$export$2e2bcd8739ae039), {
                                            name: "First Name",
                                            onChange: handleFirstNameChange,
                                            placeholder: account ? account.firstName : "",
                                            defaultValue: account ? account.firstName : ""
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}





function $ba590a2d22430a0d$export$2e2bcd8739ae039() {
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const redirectToURL = (page)=>{
        const url = "/" + page;
        history.push(url);
    };
    const currentYear = new Date().getFullYear();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-gray-800 w-full mx-auto py-4 px-4 overflow-hidden sm:px-6 lg:px-8",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "mt-8",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "text-center text-base leading-6 text-gray-100",
                children: [
                    "\xa9 ",
                    currentYear,
                    " \u26F3 \uD83C\uDFCC1PuttHealth LLC - All rights reserved."
                ]
            })
        })
    });
}


function $726c1cdb0a261306$export$2e2bcd8739ae039(props) {
    const auth = (0, $cb5b9529b8ae0bf0$export$1d39dc5b47e56ff0)();
    const user = auth.user;
    if (user && user?.account) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                className: "animate-color-change-2x flex-grow",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $750b0a195ad2ddc2$export$ce9a57d0e5a7c4f5), {
                            exact: true,
                            path: "/",
                            render: (routeProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2929016173b1249e$export$2e2bcd8739ae039), {
                                    ...routeProps,
                                    user: user,
                                    account: props.account,
                                    setAccount: props.setAccount,
                                    environments: props.environments,
                                    selectedAccount: props.selectedAccount,
                                    selectedWorkspace: props.selectedWorkspace,
                                    updateBillingCustomer: props.updateBillingCustomer,
                                    selectedEnvironment: props.selectedEnvironment,
                                    setSelectedEnvironment: props.setSelectedEnvironment,
                                    logout: props.logout
                                })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $750b0a195ad2ddc2$export$ce9a57d0e5a7c4f5), {
                            path: "/workflows",
                            render: (routeProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4fc57cf391e3576$export$2e2bcd8739ae039), {
                                    ...routeProps,
                                    user: user,
                                    account: props.account,
                                    setAccount: props.setAccount,
                                    environments: props.environments,
                                    selectedAccount: props.selectedAccount,
                                    selectedWorkspace: props.selectedWorkspace,
                                    selectedEnvironment: props.selectedEnvironment,
                                    setSelectedEnvironment: props.setSelectedEnvironment,
                                    logout: props.logout
                                })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $750b0a195ad2ddc2$export$ce9a57d0e5a7c4f5), {
                            path: "/tunnels",
                            render: (routeProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cb9766ac198673c$export$2e2bcd8739ae039), {
                                    ...routeProps,
                                    user: user,
                                    account: props.account,
                                    setAccount: props.setAccount,
                                    environments: props.environments,
                                    selectedAccount: props.selectedAccount,
                                    selectedEnvironment: props.selectedEnvironment,
                                    selectedWorkspace: props.selectedWorkspace,
                                    setSelectedEnvironment: props.setSelectedEnvironment,
                                    logout: props.logout
                                })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $750b0a195ad2ddc2$export$ce9a57d0e5a7c4f5), {
                            path: "/workspace",
                            render: (routeProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33cc5aa81380ea1d$export$2e2bcd8739ae039), {
                                    ...routeProps,
                                    user: user,
                                    account: props.account,
                                    setAccount: props.setAccount,
                                    getAccount: props.getAccount,
                                    environments: props.environments,
                                    selectedAccount: props.selectedAccount,
                                    setSelectedAccount: props.setSelectedAccount,
                                    selectedWorkspace: props.account?.workspaces[0],
                                    selectedEnvironment: props.selectedEnvironment,
                                    setSelectedEnvironment: props.setSelectedEnvironment,
                                    setupEnvironmentsHandler: props.setupEnvironmentsHandler,
                                    redirectToURL: props.redirectToURL,
                                    logout: props.logout
                                })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $750b0a195ad2ddc2$export$ce9a57d0e5a7c4f5), {
                            path: "/account",
                            render: (routeProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e514edb69a85f2e1$export$2e2bcd8739ae039), {
                                    ...routeProps,
                                    user: user,
                                    account: props.account,
                                    setAccount: props.setAccount,
                                    environments: props.environments,
                                    selectedAccount: props.selectedAccount,
                                    setSelectedAccount: props.setSelectedAccount,
                                    selectedEnvironment: props.selectedEnvironment,
                                    setSelectedEnvironment: props.setSelectedEnvironment,
                                    history: props.history,
                                    logout: props.logout
                                })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba590a2d22430a0d$export$2e2bcd8739ae039), {})
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
}




var $acw62 = parcelRequire("acw62");


var $e0fe5e773e096a67$exports = {};
$e0fe5e773e096a67$exports = new URL("hospital.f1725d5e.png", import.meta.url).toString();


var $af288c014d25d798$exports = {};
$af288c014d25d798$exports = new URL("happy.d98d43fc.png", import.meta.url).toString();


var $d1ab0352bc5145b7$exports = {};
$d1ab0352bc5145b7$exports = new URL("teams.fabd4140.png", import.meta.url).toString();


var $b80bc1d71ae8787f$exports = {};
$b80bc1d71ae8787f$exports = new URL("secure-tunnel.6ac8e6a7.png", import.meta.url).toString();


var $cf8b327b06735390$exports = {};
$cf8b327b06735390$exports = new URL("cool.e8edaa37.png", import.meta.url).toString();


var $39f7e02dc70086a1$exports = {};
$39f7e02dc70086a1$exports = new URL("help.aef75b23.png", import.meta.url).toString();


var $7a1c1a7556c35434$exports = {};
$7a1c1a7556c35434$exports = new URL("cloud-patient.4df6c278.svg", import.meta.url).toString();





var $acw62 = parcelRequire("acw62");




const $5aa1aa8b217417ec$var$LoginButton = (props)=>{
    if (props.loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: props.handleLogin,
        className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-400 hover:bg-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: " flex justify-center items-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "animate-spin rounded-full h-6 w-6 border-t-4 border-b-4 border-cyan-300"
            })
        })
    });
    if (props.forgotPassword) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: props.handleForgotPassword,
        className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-400 hover:bg-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute left-0 inset-y-0 flex items-center pl-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                    className: "h-5 w-5 text-cyan-300 group-hover:text-cyan-400",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                        clipRule: "evenodd"
                    })
                })
            }),
            "Send Reset Code"
        ]
    });
    else if (props.verifyCodeModal) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: props.handleVerifyCode,
        className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-400 hover:bg-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute left-0 inset-y-0 flex items-center pl-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                    className: "h-5 w-5 text-cyan-300 group-hover:text-cyan-400",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                        clipRule: "evenodd"
                    })
                })
            }),
            "Verify Code"
        ]
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            type: "button",
            onClick: props.handleLogin,
            className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-400 hover:bg-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "absolute left-0 inset-y-0 flex items-center pl-3",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                        className: "h-5 w-5 text-cyan-300 group-hover:text-cyan-400",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                            clipRule: "evenodd"
                        })
                    })
                }),
                "Sign in"
            ]
        })
    });
};
function $5aa1aa8b217417ec$export$2e2bcd8739ae039(props) {
    const auth = (0, $cb5b9529b8ae0bf0$export$1d39dc5b47e56ff0)();
    let history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [email, setEmail] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [newPassword, setNewPassword] = (0, $acw62.useState)("");
    const [shouldSetNewPassword, setShouldSetNewPassword] = (0, $acw62.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [forgotPassword, setForgotPassword] = (0, $acw62.useState)(false);
    const [verifyCodeModal, setVerifyCodeModal] = (0, $acw62.useState)(false);
    const [verifyCode, setVerifyCode] = (0, $acw62.useState)();
    const handleLogin = async ()=>{
        clearErrorMessage();
        try {
            setLoading(true);
            if (shouldSetNewPassword) {
                const session = await auth.newPasswordChange({
                    username: email,
                    password: password,
                    newPassword: newPassword
                });
                console.log(session);
            }
            const loginResult = await auth.login(email, password);
            if (loginResult.FORCE_PASSWORD_CHANGE) {
                setLoading(false);
                return setShouldSetNewPassword(true);
            }
            setLoading(false);
            history.push("/");
            props.setNavHighlight("Dashboard");
        } catch (e) {
            setLoading(false);
            setErrorMessage(e.message);
        }
    };
    const handleForgotPassword = async ()=>{
        clearErrorMessage();
        try {
            setLoading(true);
            await auth.forgotPassword(email);
            setLoading(false);
            setForgotPassword(false);
            setVerifyCodeModal(true);
        } catch (e) {
            setLoading(false);
            setErrorMessage(e.message);
        }
    };
    const handleVerifyCode = async ()=>{
        clearErrorMessage();
        try {
            setLoading(true);
            const verifyCodeResult = await auth.confirmPasswordReset(email, verifyCode, newPassword);
            console.dir(verifyCodeResult);
            setLoading(false);
            setVerifyCodeModal(false);
        } catch (e) {
            setLoading(false);
            setErrorMessage(e.message);
        }
    };
    const clearErrorMessage = ()=>{
        setErrorMessage("");
    };
    const renderFormFields = ()=>{
        if (shouldSetNewPassword) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "rounded-md shadow-sm -space-y-px",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-gray-600 text-md",
                    children: "Since this is your first time logging in"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-gray-600 text-md pb-2",
                    children: "please set a new password."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-orange-700 text-xs mb-0",
                    children: "Your new password must be at least 8 characters,"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-orange-700 text-xs mb-0",
                    children: "contain an Uppercase, lowercase, number,"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-orange-700 text-xs mb-4",
                    children: "and special character."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        errorMessage.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-red-500 text-sm py-2",
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                            htmlFor: "new-password",
                            className: "sr-only",
                            children: "New password"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "new-password",
                            name: "new-password",
                            type: "password",
                            required: true,
                            onKeyDown: (e)=>{
                                if (e.key === "Enter") setNewPassword(e.target.value);
                            },
                            className: "appearance-none mt-4 rounded-none relative block w-full px-3 py-2 border border-gray-300  placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                            placeholder: "New password",
                            value: newPassword,
                            onChange: (e)=>{
                                setNewPassword(e.target.value);
                                setLoading(false);
                            }
                        })
                    ]
                })
            ]
        });
        else {
            if (forgotPassword) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "hidden",
                        name: "remember",
                        value: "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-md shadow-sm -space-y-px",
                        children: [
                            errorMessage.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-red-500 text-sm pb-2",
                                children: errorMessage
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "px-0 mx-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "email-address",
                                        className: "sr-only",
                                        children: "Email address"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "email-address",
                                        name: "email",
                                        type: "email",
                                        autoComplete: "email",
                                        required: true,
                                        onKeyDown: (e)=>{
                                            if (e.key === "Enter") handleLogin();
                                        },
                                        className: "appearance-none rounded-md relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                        placeholder: "Email address",
                                        value: email,
                                        onChange: (e)=>{
                                            setEmail(e.target.value);
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
            else if (verifyCodeModal) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "hidden",
                        name: "remember",
                        value: "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-md shadow-sm -space-y-px",
                        children: [
                            errorMessage.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-red-500 text-sm pb-2",
                                children: errorMessage
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-cyan-400 text-md",
                                children: "Since this is your first time logging in"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-cyan-400 text-md pb-2",
                                children: "please set a new password."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-orange-700 text-xs mb-0",
                                children: "Your new password must be at least 8 characters,"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-orange-700 text-xs mb-0",
                                children: "contain an Uppercase, lowercase, number,"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-orange-700 text-xs mb-4",
                                children: "and special character."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "px-0 mx-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "new-password",
                                        className: "sr-only",
                                        children: "New Password"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "appearance-none mt-4 rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-200 focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                        id: "new-password",
                                        name: "new-password",
                                        type: "password",
                                        required: true,
                                        placeholder: "New password",
                                        value: newPassword,
                                        onKeyDown: (e)=>{
                                            if (e.key === "Enter") setNewPassword(e.target.value);
                                        },
                                        onChange: (e)=>{
                                            setNewPassword(e.target.value);
                                            setLoading(false);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "px-0 mx-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "verify-code",
                                        className: "sr-only",
                                        children: "Verification Code"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "appearance-none rounded-md relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                        placeholder: "Verification Code",
                                        id: "verify-code",
                                        name: "verify-code",
                                        type: "text",
                                        required: true,
                                        value: verifyCode,
                                        onKeyDown: (e)=>{
                                            if (e.key === "Enter") setVerifyCode(e.target.value);
                                        },
                                        onChange: (e)=>{
                                            setVerifyCode(e.target.value);
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "hidden",
                        name: "remember",
                        value: "true"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "rounded-md shadow-sm -space-y-px",
                        children: [
                            errorMessage.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-red-500 text-sm pb-2",
                                children: errorMessage
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "px-0 mx-0 w-full",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "email-address",
                                        className: "sr-only",
                                        children: "Email address"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "email-address",
                                        name: "email",
                                        type: "email",
                                        autoComplete: "email",
                                        required: true,
                                        onKeyDown: (e)=>{
                                            if (e.key === "Enter") handleLogin();
                                        },
                                        className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-t-md focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                        placeholder: "Email address",
                                        value: email,
                                        onChange: (e)=>{
                                            setEmail(e.target.value);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "px-0 mx-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        htmlFor: "password",
                                        className: "sr-only",
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        id: "password",
                                        name: "password",
                                        type: "password",
                                        autoComplete: "current-password",
                                        required: true,
                                        onKeyDown: (e)=>{
                                            if (e.key === "Enter") handleLogin();
                                        },
                                        className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-b-md focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                        placeholder: "Password",
                                        value: password,
                                        onChange: (e)=>{
                                            setPassword(e.target.value);
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex mt-1 mx-auto items-center justify-between w-full",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-xs items-center mx-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                onClick: ()=>{
                                    setForgotPassword(true);
                                },
                                className: "font-medium text-cyan-400 hover:text-cyan-300",
                                children: "Forgot your password?"
                            })
                        })
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-10 inset-0 overflow-y-auto",
            onClose: ()=>{
                props.closeModal;
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative inline-block align-bottom  items-center w-auto bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-middle sm:p-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "absolute right-2 top-2 border-2 border-gray-500 rounded shadow px-2 py-1 text-base text-pink-400 bg-gray-600 outline-none hover:ring-1 hover:ring-pink-500",
                                    onClick: ()=>{
                                        props.closeModal();
                                    },
                                    children: "X"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-1 items-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-gray-700 px-6 pb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        className: "h-24 mx-auto w-auto",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                                        alt: "Logo"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                                        className: "mt-0 text-center text-2xl font-bold text-gray-100",
                                                        children: [
                                                            "Retrohook",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "inline align-middle text-xs tracking-tight text-cyan-400 pl-1",
                                                                children: "beta"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                                                className: "mt-2",
                                                action: "#",
                                                method: "POST",
                                                children: renderFormFields()
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "py-2 px-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5aa1aa8b217417ec$var$LoginButton, {
                                        handleLogin: handleLogin,
                                        loading: loading,
                                        forgotPassword: forgotPassword,
                                        handleForgotPassword: handleForgotPassword,
                                        handleVerifyCode: handleVerifyCode,
                                        verifyCodeModal: verifyCodeModal,
                                        email: email
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-4 text-xs items-center my-4 mx-auto",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        onClick: ()=>{
                                            props.setRegisterModal();
                                        },
                                        className: "font-medium text-cyan-400 hover:text-cyan-300",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-medium text-pink-600 hover:text-pink-500",
                                                children: "Don't have an account?"
                                            }),
                                            "\xa0 ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "bg-pink-500 border rounded py-2 px-4 text-white hover:ring-2 hover: ring-pink-400",
                                                children: "Sign Up Free"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");




const $ecd4b6963d82864a$var$RegisterButton = (props)=>{
    if (props.loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: props.handleRegister,
        className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-400 hover:bg-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: " flex justify-center items-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "animate-spin rounded-full h-6 w-6 border-t-4 border-b-4 border-cyan-300"
            })
        })
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: props.handleRegister,
        className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-400 hover:bg-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute left-0 inset-y-0 flex items-center pl-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                    className: "h-5 w-5 text-cyan-300 group-hover:text-cyan-300",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                        clipRule: "evenodd"
                    })
                })
            }),
            "Sign Up Free"
        ]
    });
};
function $ecd4b6963d82864a$export$2e2bcd8739ae039(props) {
    const auth = (0, $cb5b9529b8ae0bf0$export$1d39dc5b47e56ff0)();
    const [organization, setOrganization] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const [email, setEmail] = (0, $acw62.useState)("");
    const [firstName, setFirstName] = (0, $acw62.useState)("");
    const [lastName, setLastName] = (0, $acw62.useState)("");
    const [confirm, setConfirm] = (0, $acw62.useState)("");
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const handleRegister = async ()=>{
        clearErrorMessage();
        try {
            setLoading(true);
            if (password !== confirm) {
                setErrorMessage("Passwords do not match.");
                return;
            }
            const registerResult = await auth.register(email, organization, firstName, lastName, password, confirm);
            console.dir(registerResult);
            if (registerResult) {
                props.setEmail(email);
                setLoading(false);
                props.closeModal();
                props.closeRegisterModal();
                props.setVerificationCodeModel();
            }
        } catch (e) {
            setLoading(false);
            setErrorMessage(e.message);
        }
    };
    const clearErrorMessage = ()=>{
        setErrorMessage("");
    };
    const renderFormFields = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "hidden",
                    name: "remember",
                    value: "true"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "rounded-md shadow-sm -space-y-px",
                    children: [
                        errorMessage.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-red-500 text-sm pb-2",
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0 pt-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "email-address",
                                    className: "sr-only",
                                    children: "Email address"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "email-address",
                                    name: "email",
                                    type: "email",
                                    autoComplete: "email",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-t-md  focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "Email Address",
                                    value: email,
                                    onChange: (e)=>{
                                        setEmail(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "username",
                                    className: "sr-only",
                                    children: "Organization"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "username",
                                    name: "username",
                                    type: "text",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900  focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "Organization (Optional)",
                                    value: organization,
                                    onChange: (e)=>{
                                        setOrganization(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "first-name",
                                    className: "sr-only",
                                    children: "First Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "first-name",
                                    name: "firstName",
                                    type: "text",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900  focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "First Name",
                                    value: firstName,
                                    onChange: (e)=>{
                                        setFirstName(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "last-name",
                                    className: "sr-only",
                                    children: "Last Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "last-name",
                                    name: "lastName",
                                    type: "text",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-b-md  focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "Last Name",
                                    value: lastName,
                                    onChange: (e)=>{
                                        setLastName(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-200 text-xs pt-4 mb-0",
                            children: "Passwords must be at least 8 characters,"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-200 text-xs mb-0",
                            children: "contain an Uppercase, lowercase, number,"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-200 text-xs pb-4",
                            children: "and special character."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "password",
                                    className: "sr-only",
                                    children: "Set Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    autoComplete: "current-password",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-t-md focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "Password",
                                    value: password,
                                    onChange: (e)=>{
                                        setPassword(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "confirm",
                                    className: "sr-only",
                                    children: "Confirm Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "confirm",
                                    name: "confirm",
                                    type: "password",
                                    autoComplete: "current-password",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-b-md  focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "Confirm Password",
                                    value: confirm,
                                    onChange: (e)=>{
                                        setConfirm(e.target.value);
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    if (auth.user) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e), {
        to: "/"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-10 inset-0 overflow-y-auto",
            onClose: ()=>{
                props.closeModal;
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative inline-block align-bottom items-center w-auto bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-middle sm:p-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "absolute right-2 top-2 border-2 border-gray-500 rounded shadow px-2 py-1 text-base text-pink-400 bg-gray-600 outline-none hover:ring-1 hover:ring-pink-500",
                                    onClick: ()=>{
                                        props.closeModal();
                                    },
                                    children: "X"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-1 inline-flex items-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-gray-700 px-6 pb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        className: "h-24 mx-auto w-auto",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                                        alt: "Logo"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                                        className: "mt-0 text-center text-2xl font-bold text-gray-200",
                                                        children: [
                                                            "Retrohook",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1",
                                                                children: "beta"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                                                className: "mt-2",
                                                action: "#",
                                                method: "POST",
                                                children: renderFormFields()
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "py-2 px-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ecd4b6963d82864a$var$RegisterButton, {
                                        handleRegister: handleRegister,
                                        loading: loading
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex mx-auto items-center my-4 justify-between w-full",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-xs items-center mx-auto",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            onClick: ()=>{
                                                props.setSignInModal(true);
                                            },
                                            className: "font-medium text-cyan-400 hover:text-cyan-300",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "font-medium text-pink-600 hover:text-pink-500",
                                                    children: "Already have an account?"
                                                }),
                                                "\xa0",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    className: "bg-pink-500 border rounded py-2 px-4 text-white hover:ring-2 hover: ring-pink-400",
                                                    children: "Sign In here"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");





const $35cddad02587b26d$var$RegisterButton = (props)=>{
    if (props.loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: props.handleRegister,
        className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-400 hover:bg-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: " flex justify-center items-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "animate-spin rounded-full h-6 w-6 border-t-4 border-b-4 border-cyan-300"
            })
        })
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: props.handleRegister,
        className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-400 hover:bg-cyan-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-300",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute left-0 inset-y-0 flex items-center pl-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                    className: "h-5 w-5 text-cyan-300 group-hover:text-cyan-300",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                        clipRule: "evenodd"
                    })
                })
            }),
            "Finalize AWS Registration"
        ]
    });
};
function $35cddad02587b26d$export$2e2bcd8739ae039(props) {
    const auth = (0, $cb5b9529b8ae0bf0$export$1d39dc5b47e56ff0)();
    const { post: post, response: response, loading: loading } = (0, $b91bde21b94476b1$export$2e2bcd8739ae039)("https://subscriptions.api.retrohook.com");
    const [organization, setOrganization] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const [email, setEmail] = (0, $acw62.useState)("");
    const [firstName, setFirstName] = (0, $acw62.useState)("");
    const [lastName, setLastName] = (0, $acw62.useState)("");
    const [confirm, setConfirm] = (0, $acw62.useState)("");
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const [awsTokenData, setAwsTokenData] = (0, $acw62.useState)({});
    const [quantityPurchased, setQuantityPurchased] = (0, $acw62.useState)(0);
    const [productCode, setProductCode] = (0, $acw62.useState)("");
    const [customerIdentifier, setCustomerIdentifier] = (0, $acw62.useState)("");
    const [productExpiration, setProductExpiration] = (0, $acw62.useState)("");
    const [rawToken, setRawToken] = (0, $acw62.useState)(props.mktplaceToken);
    const getTokenData = async (mktplaceToken)=>{
        const tokenRequest = await post(`/marketplace/aws-token`, {
            token: mktplaceToken
        });
        if (tokenRequest) {
            setAwsTokenData(tokenRequest);
            setCustomerIdentifier(tokenRequest.customerEntitlements.Entitlements[0].CustomerIdentifier);
            setProductExpiration(tokenRequest.customerEntitlements.Entitlements[0].ExpirationDate);
            setProductCode(tokenRequest.customerEntitlements.Entitlements[0].ProductCode);
            setQuantityPurchased(tokenRequest.customerEntitlements.Entitlements[0].Value.IntegerValue);
            setRawToken(props.regToken);
        }
    };
    const renderFormFields = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "hidden",
                    name: "remember",
                    value: "true"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "rounded-md shadow-sm -space-y-px",
                    children: [
                        errorMessage.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-red-500 text-sm pb-2",
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-gray-200 text-xs mb-0",
                            children: [
                                "Thanks for purchasing Retrohook with ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-cyan-400",
                                    children: quantityPurchased
                                }),
                                " production environment(s)."
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0 pt-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "email-address",
                                    className: "sr-only",
                                    children: "Email address"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "email-address",
                                    name: "email",
                                    type: "email",
                                    autoComplete: "email",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-t-md  focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "Email Address",
                                    value: email,
                                    onChange: (e)=>{
                                        setEmail(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "username",
                                    className: "sr-only",
                                    children: "Organization"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "username",
                                    name: "username",
                                    type: "text",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900  focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "Organization (Optional)",
                                    value: organization,
                                    onChange: (e)=>{
                                        setOrganization(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "first-name",
                                    className: "sr-only",
                                    children: "First Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "first-name",
                                    name: "firstName",
                                    type: "text",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900  focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "First Name",
                                    value: firstName,
                                    onChange: (e)=>{
                                        setFirstName(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "last-name",
                                    className: "sr-only",
                                    children: "Last Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "last-name",
                                    name: "lastName",
                                    type: "text",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-b-md  focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "Last Name",
                                    value: lastName,
                                    onChange: (e)=>{
                                        setLastName(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-200 text-xs pt-4 mb-0",
                            children: "Passwords must be at least 8 characters,"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-200 text-xs mb-0",
                            children: "contain an Uppercase, lowercase, number,"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-200 text-xs pb-4",
                            children: "and special character."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "password",
                                    className: "sr-only",
                                    children: "Set Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "password",
                                    name: "password",
                                    type: "password",
                                    autoComplete: "current-password",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-t-md focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "Password",
                                    value: password,
                                    onChange: (e)=>{
                                        setPassword(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "confirm",
                                    className: "sr-only",
                                    children: "Confirm Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "confirm",
                                    name: "confirm",
                                    type: "password",
                                    autoComplete: "current-password",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleRegister();
                                    },
                                    className: "appearance-none rounded-none relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-b-md  focus:outline-none focus:ring-cyan-300 focus:border-cyan-300 focus:z-10 sm:text-sm",
                                    placeholder: "Confirm Password",
                                    value: confirm,
                                    onChange: (e)=>{
                                        setConfirm(e.target.value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            hidden: true,
                            disabled: true,
                            id: "awsCustomerId",
                            name: "awsCustomerId",
                            type: "text",
                            required: true,
                            value: customerIdentifier
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            hidden: true,
                            disabled: true,
                            id: "productCode",
                            name: "productCode",
                            type: "text",
                            required: true,
                            value: productCode
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            hidden: true,
                            disabled: true,
                            id: "productExpiration",
                            name: "productExpiration",
                            type: "text",
                            required: true,
                            value: productExpiration
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            hidden: true,
                            disabled: true,
                            id: "rawToken",
                            name: "rawToken",
                            type: "text",
                            required: true,
                            value: props.regToken
                        })
                    ]
                })
            ]
        });
    };
    const handleRegister = async ()=>{
        setErrorMessage("");
        try {
            if (password !== confirm) {
                setErrorMessage("Passwords do not match.");
                return;
            }
            const token = props.mktplaceToken;
            const registerResult = await auth.registerAWS(email, organization, firstName, lastName, password, confirm, customerIdentifier, productCode, quantityPurchased, productExpiration, token);
            if (registerResult) {
                props.setEmail(email);
                props.setVerificationCodeModel();
                props.closeModal();
            }
        } catch (e) {
            setErrorMessage(e.message);
        }
    };
    if (auth.user) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e), {
        to: "/"
    });
    (0, $acw62.useEffect)(()=>{
        getTokenData(props.mktplaceToken);
        setRawToken(JSON.stringify(props.mktplaceToken));
    }, [
        JSON.stringify(props.mktplaceToken)
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-10 inset-0 overflow-y-auto",
            onClose: ()=>{
                props.closeModal;
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative inline-block align-bottom items-center w-auto bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-middle sm:p-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "absolute right-2 top-2 border-2 border-gray-500 rounded shadow px-2 py-1 text-base text-pink-400 bg-gray-600 outline-none hover:ring-1 hover:ring-pink-500",
                                    onClick: ()=>{
                                        props.closeModal();
                                    },
                                    children: "X"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-1 inline-flex items-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-gray-700 px-6 pb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        className: "h-24 mx-auto w-auto",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                                        alt: "Logo"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                                        className: "mt-0 text-center text-2xl font-semibold text-gray-200",
                                                        children: [
                                                            "Retrohook",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                                                className: "mt-2",
                                                action: "#",
                                                method: "POST",
                                                children: renderFormFields()
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "py-2 px-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($35cddad02587b26d$var$RegisterButton, {
                                        handleRegister: handleRegister,
                                        loading: loading
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");




const $7953e84a4dda08f3$var$VerifyButton = (props)=>{
    if (props.loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: props.handleVerifyCode,
        className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: " flex justify-center items-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "animate-spin rounded-full h-6 w-6 border-t-4 border-b-4 border-cyan-500"
            })
        })
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: props.handleVerifyCode,
        className: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute left-0 inset-y-0 flex items-center pl-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                    className: "h-5 w-5 text-cyan-500 group-hover:text-cyan-400",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
                        clipRule: "evenodd"
                    })
                })
            }),
            "Submit Code"
        ]
    });
};
function $7953e84a4dda08f3$export$2e2bcd8739ae039(props) {
    const auth = (0, $cb5b9529b8ae0bf0$export$1d39dc5b47e56ff0)();
    const [verificationCode, setVerificationCode] = (0, $acw62.useState)("");
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)("");
    const handleVerifyCode = async ()=>{
        clearErrorMessage();
        try {
            setLoading(true);
            const result = await auth.verify(props.email, verificationCode);
            console.dir(result);
            if (result === "SUCCESS") {
                setLoading(false);
                props.setSignInModal();
            }
        } catch (e) {
            setLoading(false);
            setErrorMessage(e.message);
        }
    };
    const resendCode = async ()=>{
        clearErrorMessage();
        try {
            setLoading(true);
            await auth.sendCode(props.email);
            setLoading(false);
        } catch (e) {
            setErrorMessage(e.message);
        }
    };
    const clearErrorMessage = ()=>{
        setErrorMessage("");
    };
    const renderFormFields = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "hidden",
                    name: "remember",
                    value: "true"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "rounded-md shadow-sm -space-y-px",
                    children: [
                        errorMessage.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "text-red-500 text-sm pb-2",
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "px-0 mx-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    htmlFor: "verification",
                                    className: "sr-only",
                                    children: "Verification Code"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "verification",
                                    name: "verification",
                                    type: "text",
                                    autoComplete: "email",
                                    required: true,
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter") handleVerifyCode();
                                    },
                                    className: "appearance-none rounded-md relative block w-full py-2 border border-gray-300 placeholder-gray-400 text-gray-900  focus:outline-none focus:ring-cyan-500 focus:border-cyan-500 focus:z-10 sm:text-sm",
                                    placeholder: "Verification Code",
                                    value: verificationCode,
                                    onChange: (e)=>{
                                        setVerificationCode(e.target.value);
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex mt-1 mx-auto items-center justify-between w-full",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-xs items-center mx-auto",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            onClick: ()=>{
                                resendCode();
                            },
                            className: "font-medium text-cyan-600 hover:text-cyan-500",
                            children: "Resend Code"
                        })
                    })
                })
            ]
        });
    };
    if (auth.user) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e), {
        to: "/"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-10 inset-0 overflow-y-auto",
            onClose: ()=>{
                props.closeModal;
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative inline-block align-bottom items-center w-auto bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-middle sm:p-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "absolute right-2 top-2 border-2 border-gray-500 rounded shadow px-2 py-1 text-base text-pink-400 bg-gray-600 outline-none hover:ring-1 hover:ring-pink-500",
                                    onClick: ()=>{
                                        props.closeModal();
                                    },
                                    children: "X"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-1 inline-flex items-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-6 pb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        className: "h-24 mx-auto w-auto",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                                        alt: "Logo"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                        className: "mt-0 text-center text-2xl font-bold text-gray-600",
                                                        children: "Retrohook"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "mt-2 text-center text-sm text-gray-600",
                                                        children: "Please enter the verification code sent to your email address."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                                                className: "mt-2",
                                                action: "#",
                                                method: "POST",
                                                children: renderFormFields()
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "py-2 px-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7953e84a4dda08f3$var$VerifyButton, {
                                        handleVerifyCode: handleVerifyCode,
                                        loading: loading
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");


const $4f65f877ad4a4ee3$var$TermsOfService = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-xs text-cyan-300 border-2 border-pink-400 bg-gray-600 rounded-sm px-6 py-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xl font-bold",
                children: "Terms of Service"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-md mt-2",
                children: "Last Updated: 10/20/23"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: 'Welcome to Retrohook! These Terms of Service ("Terms") govern your use of the Retrohook platform ("Service"), provided by 1PuttHealth LLC ("Company", "we", "us", "our").'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xl mt-2",
                children: "Acceptance of Terms"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "By accessing or using the Service, you agree to comply with and be bound by these Terms. If you do not agree to these Terms, please do not use the Service."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-lg mt-2",
                children: "Changes to Terms"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "We reserve the right to modify these Terms at any time. Your continued use of the Service constitutes your acceptance of any changes."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-lg mt-2",
                children: "Privacy Policy"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Your use of the Service is also governed by our Privacy Policy, which can be found at [Privacy Policy URL]."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-lg mt-2",
                children: "User Responsibilities"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "You are responsible for all activities that occur under your account. You agree not to engage in any illegal or prohibited conduct."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-lg mt-2",
                children: "Limitation of Liability"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "To the fullest extent permitted by law, the Company shall not be liable for any indirect, incidental, or consequential damages."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-lg mt-2",
                children: "Governing Law"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "These Terms are governed by the laws of the State of Delaware, without regard to its conflict of laws principles."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-lg mt-2",
                children: "Contact Information"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "mb-6",
                children: [
                    "For any questions about these Terms, please contact us at\xa0",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: "mailto:support@retrohook.com",
                        children: "support@retrohook.com "
                    })
                ]
            })
        ]
    });
};
function $4f65f877ad4a4ee3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Root, {
        show: props.open,
        as: (0, $acw62.Fragment),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-10 inset-0 overflow-y-auto",
            onClose: ()=>{
                props.closeModal;
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd89a26ac969b4f3$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4).Child, {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "relative inline-block align-bottom items-center w-1/2 max-h-1/3 bg-gray-700 rounded-lg text-left  shadow-xl transform transition-all sm:align-middle sm:p-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-1 inline-flex items-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-gray-700 px-6 pb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        className: "h-24 mx-auto w-auto",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                                        alt: "Logo"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                                        className: "mt-0 text-center text-5xl font-bold text-gray-200",
                                                        children: [
                                                            "Retrohook",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1",
                                                                children: "beta"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4f65f877ad4a4ee3$var$TermsOfService, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "px-4 pb-2",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "mt-6 w-full inline-flex justify-center rounded-sm border border-red-300 shadow-sm py-2 bg-red-400 text-base font-medium text-gray-100 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-300 sm:mt-0 sm:col-start-1 sm:text-sm",
                                        onClick: ()=>{
                                            props.closeModal();
                                        },
                                        children: "Close"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}



var $acw62 = parcelRequire("acw62");
function $0902542cd17ebe75$var$DocumentTextIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
    }));
}
const $0902542cd17ebe75$var$ForwardRef = $acw62.forwardRef($0902542cd17ebe75$var$DocumentTextIcon);
var $0902542cd17ebe75$export$2e2bcd8739ae039 = $0902542cd17ebe75$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $aa3403b0959b0e21$var$EnvelopeIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
    }));
}
const $aa3403b0959b0e21$var$ForwardRef = $acw62.forwardRef($aa3403b0959b0e21$var$EnvelopeIcon);
var $aa3403b0959b0e21$export$2e2bcd8739ae039 = $aa3403b0959b0e21$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $3ee9e3fb202168dd$var$PlayCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z"
    }));
}
const $3ee9e3fb202168dd$var$ForwardRef = $acw62.forwardRef($3ee9e3fb202168dd$var$PlayCircleIcon);
var $3ee9e3fb202168dd$export$2e2bcd8739ae039 = $3ee9e3fb202168dd$var$ForwardRef;



var $acw62 = parcelRequire("acw62");













var $77da6324ebaeb061$var$ve = ((f)=>(f[f.Open = 0] = "Open", f[f.Closed = 1] = "Closed", f))($77da6324ebaeb061$var$ve || {}), $77da6324ebaeb061$var$ce = ((l)=>(l[l.TogglePopover = 0] = "TogglePopover", l[l.ClosePopover = 1] = "ClosePopover", l[l.SetButton = 2] = "SetButton", l[l.SetButtonId = 3] = "SetButtonId", l[l.SetPanel = 4] = "SetPanel", l[l.SetPanelId = 5] = "SetPanelId", l))($77da6324ebaeb061$var$ce || {});
let $77da6324ebaeb061$var$de = {
    [0]: (a)=>({
            ...a,
            popoverState: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(a.popoverState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1] (a) {
        return a.popoverState === 1 ? a : {
            ...a,
            popoverState: 1
        };
    },
    [2] (a, o) {
        return a.button === o.button ? a : {
            ...a,
            button: o.button
        };
    },
    [3] (a, o) {
        return a.buttonId === o.buttonId ? a : {
            ...a,
            buttonId: o.buttonId
        };
    },
    [4] (a, o) {
        return a.panel === o.panel ? a : {
            ...a,
            panel: o.panel
        };
    },
    [5] (a, o) {
        return a.panelId === o.panelId ? a : {
            ...a,
            panelId: o.panelId
        };
    }
}, $77da6324ebaeb061$var$z = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$z.displayName = "PopoverContext";
function $77da6324ebaeb061$var$N(a) {
    let o = (0, $acw62.useContext)($77da6324ebaeb061$var$z);
    if (o === null) {
        let f = new Error(`<${a} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(f, $77da6324ebaeb061$var$N), f;
    }
    return o;
}
let $77da6324ebaeb061$var$J = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$J.displayName = "PopoverAPIContext";
function $77da6324ebaeb061$var$oe(a) {
    let o = (0, $acw62.useContext)($77da6324ebaeb061$var$J);
    if (o === null) {
        let f = new Error(`<${a} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(f, $77da6324ebaeb061$var$oe), f;
    }
    return o;
}
let $77da6324ebaeb061$var$Q = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$Q.displayName = "PopoverGroupContext";
function $77da6324ebaeb061$var$re() {
    return (0, $acw62.useContext)($77da6324ebaeb061$var$Q);
}
let $77da6324ebaeb061$var$X = (0, $acw62.createContext)(null);
$77da6324ebaeb061$var$X.displayName = "PopoverPanelContext";
function $77da6324ebaeb061$var$ye() {
    return (0, $acw62.useContext)($77da6324ebaeb061$var$X);
}
function $77da6324ebaeb061$var$Te(a, o) {
    return (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(o.type, $77da6324ebaeb061$var$de, a, o);
}
let $77da6324ebaeb061$var$Ee = "div", $77da6324ebaeb061$var$Se = (0, $a54bdd13402af126$export$e43f39796049410c)(function(o, f) {
    let e = `headlessui-popover-button-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, P = `headlessui-popover-panel-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, n = (0, $acw62.useRef)(null), l = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(f, n), i = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(n), s = (0, $acw62.useReducer)($77da6324ebaeb061$var$Te, {
        popoverState: 1,
        button: null,
        buttonId: e,
        panel: null,
        panelId: P
    }), [{ popoverState: v, button: t, panel: E }, u] = s;
    (0, $acw62.useEffect)(()=>u({
            type: 3,
            buttonId: e
        }), [
        e,
        u
    ]), (0, $acw62.useEffect)(()=>u({
            type: 5,
            panelId: P
        }), [
        P,
        u
    ]);
    let S = (0, $acw62.useMemo)(()=>({
            buttonId: e,
            panelId: P,
            close: ()=>u({
                    type: 1
                })
        }), [
        e,
        P,
        u
    ]), c = $77da6324ebaeb061$var$re(), d = c == null ? void 0 : c.registerPopover, p = (0, $acw62.useCallback)(()=>{
        var r;
        return (r = c == null ? void 0 : c.isFocusWithinPopoverGroup()) != null ? r : (i == null ? void 0 : i.activeElement) && ((t == null ? void 0 : t.contains(i.activeElement)) || (E == null ? void 0 : E.contains(i.activeElement)));
    }, [
        c,
        t,
        E
    ]);
    (0, $acw62.useEffect)(()=>d == null ? void 0 : d(S), [
        d,
        S
    ]), (0, $faafded37f338b1b$export$7080b3e976bc91ab)(i == null ? void 0 : i.defaultView, "focus", ()=>{
        v === 0 && (p() || !t || !E || u({
            type: 1
        }));
    }, !0), (0, $17eff26b89e4b024$export$71b2224f1ce5e08e)([
        t,
        E
    ], (r, T)=>{
        v === 0 && (u({
            type: 1
        }), (0, $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5)(T, (0, $cb6dceb64e6c0606$export$27112a34f2f8402d).Loose) || (r.preventDefault(), t == null || t.focus()));
    });
    let y = (0, $acw62.useCallback)((r)=>{
        u({
            type: 1
        });
        let T = (()=>r ? r instanceof HTMLElement ? r : r.current instanceof HTMLElement ? r.current : t : t)();
        T == null || T.focus();
    }, [
        u,
        t
    ]), b = (0, $acw62.useMemo)(()=>({
            close: y
        }), [
        y
    ]), g = (0, $acw62.useMemo)(()=>({
            open: v === 0,
            close: y
        }), [
        v,
        y
    ]), C = o, h = {
        ref: l
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$z.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$J.Provider, {
        value: b
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7a3499b4b3c6f184$export$2a0ed818b175f558), {
        value: (0, $4f240e1aafd2c298$export$4659b591c19bdf3d)(v, {
            [0]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open,
            [1]: (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Closed
        })
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: h,
        theirProps: C,
        slot: g,
        defaultTag: $77da6324ebaeb061$var$Ee,
        name: "Popover"
    }))));
}), $77da6324ebaeb061$var$be = "button", $77da6324ebaeb061$var$me = (0, $a54bdd13402af126$export$e43f39796049410c)(function(o, f) {
    let [e, P] = $77da6324ebaeb061$var$N("Popover.Button"), n = (0, $acw62.useRef)(null), l = $77da6324ebaeb061$var$re(), i = l == null ? void 0 : l.closeOthers, s = $77da6324ebaeb061$var$ye(), v = s === null ? !1 : s === e.panelId, t = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(n, f, v ? null : (r)=>P({
            type: 2,
            button: r
        })), E = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(n, f), u = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(n), S = (0, $acw62.useRef)(null), c = (0, $acw62.useRef)(null);
    (0, $faafded37f338b1b$export$7080b3e976bc91ab)(u == null ? void 0 : u.defaultView, "focus", ()=>{
        c.current = S.current, S.current = u == null ? void 0 : u.activeElement;
    }, !0);
    let d = (0, $acw62.useCallback)((r)=>{
        var T, R, k, V;
        if (v) {
            if (e.popoverState === 1) return;
            switch(r.key){
                case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
                case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                    r.preventDefault(), (R = (T = r.target).click) == null || R.call(T), P({
                        type: 1
                    }), (k = e.button) == null || k.focus();
                    break;
            }
        } else switch(r.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space:
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Enter:
                r.preventDefault(), r.stopPropagation(), e.popoverState === 1 && (i == null || i(e.buttonId)), P({
                    type: 0
                });
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape:
                if (e.popoverState !== 0) return i == null ? void 0 : i(e.buttonId);
                if (!n.current || (u == null ? void 0 : u.activeElement) && !n.current.contains(u.activeElement)) return;
                r.preventDefault(), r.stopPropagation(), P({
                    type: 1
                });
                break;
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Tab:
                if (e.popoverState !== 0 || !e.panel || !e.button) return;
                if (r.shiftKey) {
                    if (!c.current || (V = e.button) != null && V.contains(c.current) || e.panel.contains(c.current)) return;
                    let Z = (0, $cb6dceb64e6c0606$export$433aaa1f216cf32d)(u == null ? void 0 : u.body), ne = Z.indexOf(c.current);
                    if (Z.indexOf(e.button) > ne) return;
                    r.preventDefault(), r.stopPropagation(), (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(e.panel, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Last);
                } else r.preventDefault(), r.stopPropagation(), (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(e.panel, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First);
                break;
        }
    }, [
        P,
        e.popoverState,
        e.buttonId,
        e.button,
        e.panel,
        n,
        i,
        v
    ]), p = (0, $acw62.useCallback)((r)=>{
        var T;
        if (!v && (r.key === (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Space && r.preventDefault(), e.popoverState === 0 && !!e.panel && !!e.button)) switch(r.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Tab:
                if (!c.current || (T = e.button) != null && T.contains(c.current) || e.panel.contains(c.current)) return;
                let R = (0, $cb6dceb64e6c0606$export$433aaa1f216cf32d)(u == null ? void 0 : u.body), k = R.indexOf(c.current);
                if (R.indexOf(e.button) > k) return;
                r.preventDefault(), r.stopPropagation(), (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(e.panel, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Last);
                break;
        }
    }, [
        e.popoverState,
        e.panel,
        e.button,
        v
    ]), y = (0, $acw62.useCallback)((r)=>{
        var T, R;
        (0, $3d3d670dbe2ceed6$export$db61f031a278447c)(r.currentTarget) || o.disabled || (v ? (P({
            type: 1
        }), (T = e.button) == null || T.focus()) : (r.preventDefault(), r.stopPropagation(), e.popoverState === 1 && (i == null || i(e.buttonId)), (R = e.button) == null || R.focus(), P({
            type: 0
        })));
    }, [
        P,
        e.button,
        e.popoverState,
        e.buttonId,
        o.disabled,
        i,
        v
    ]), b = (0, $acw62.useMemo)(()=>({
            open: e.popoverState === 0
        }), [
        e
    ]), g = (0, $be828d8bf9bb25ca$export$53652b2b272efe9c)(o, n), C = o, h = v ? {
        ref: E,
        type: g,
        onKeyDown: d,
        onClick: y
    } : {
        ref: t,
        id: e.buttonId,
        type: g,
        "aria-expanded": o.disabled ? void 0 : e.popoverState === 0,
        "aria-controls": e.panel ? e.panelId : void 0,
        onKeyDown: d,
        onKeyUp: p,
        onClick: y
    };
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: h,
        theirProps: C,
        slot: b,
        defaultTag: $77da6324ebaeb061$var$be,
        name: "Popover.Button"
    });
}), $77da6324ebaeb061$var$ge = "div", $77da6324ebaeb061$var$Ae = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static, $77da6324ebaeb061$var$Ce = (0, $a54bdd13402af126$export$e43f39796049410c)(function(o, f) {
    let [{ popoverState: e }, P] = $77da6324ebaeb061$var$N("Popover.Overlay"), n = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(f), l = `headlessui-popover-overlay-${(0, $f2a0dea4caee12c6$export$f680877a34711e37)()}`, i = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), s = (()=>i !== null ? i === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : e === 0)(), v = (0, $acw62.useCallback)((S)=>{
        if ((0, $3d3d670dbe2ceed6$export$db61f031a278447c)(S.currentTarget)) return S.preventDefault();
        P({
            type: 1
        });
    }, [
        P
    ]), t = (0, $acw62.useMemo)(()=>({
            open: e === 0
        }), [
        e
    ]);
    return (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: n,
            id: l,
            "aria-hidden": !0,
            onClick: v
        },
        theirProps: o,
        slot: t,
        defaultTag: $77da6324ebaeb061$var$ge,
        features: $77da6324ebaeb061$var$Ae,
        visible: s,
        name: "Popover.Overlay"
    });
}), $77da6324ebaeb061$var$Re = "div", $77da6324ebaeb061$var$Oe = (0, $a54bdd13402af126$export$617d79dae526d2cf).RenderStrategy | (0, $a54bdd13402af126$export$617d79dae526d2cf).Static, $77da6324ebaeb061$var$Ie = (0, $a54bdd13402af126$export$e43f39796049410c)(function(o, f) {
    let { focus: e = !1, ...P } = o, [n, l] = $77da6324ebaeb061$var$N("Popover.Panel"), { close: i } = $77da6324ebaeb061$var$oe("Popover.Panel"), s = (0, $acw62.useRef)(null), v = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(s, f, (p)=>{
        l({
            type: 4,
            panel: p
        });
    }), t = (0, $42a08b28a285ca8e$export$dd9fbcea3de0ae36)(s), E = (0, $7a3499b4b3c6f184$export$fc6fdf0ecf360e)(), u = (()=>E !== null ? E === (0, $7a3499b4b3c6f184$export$7254cc27399e90bd).Open : n.popoverState === 0)(), S = (0, $acw62.useCallback)((p)=>{
        var y;
        switch(p.key){
            case (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Escape:
                if (n.popoverState !== 0 || !s.current || (t == null ? void 0 : t.activeElement) && !s.current.contains(t.activeElement)) return;
                p.preventDefault(), p.stopPropagation(), l({
                    type: 1
                }), (y = n.button) == null || y.focus();
                break;
        }
    }, [
        n,
        s,
        l
    ]);
    (0, $acw62.useEffect)(()=>()=>l({
                type: 4,
                panel: null
            }), [
        l
    ]), (0, $acw62.useEffect)(()=>{
        var p;
        o.static || n.popoverState === 1 && ((p = o.unmount) != null ? p : !0) && l({
            type: 4,
            panel: null
        });
    }, [
        n.popoverState,
        o.unmount,
        o.static,
        l
    ]), (0, $acw62.useEffect)(()=>{
        if (!e || n.popoverState !== 0 || !s.current) return;
        let p = t == null ? void 0 : t.activeElement;
        s.current.contains(p) || (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(s.current, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First);
    }, [
        e,
        s,
        n.popoverState
    ]), (0, $faafded37f338b1b$export$7080b3e976bc91ab)(t == null ? void 0 : t.defaultView, "keydown", (p)=>{
        var b;
        if (n.popoverState !== 0 || !s.current || p.key !== (0, $4cca0dbc68b0507a$export$4b0075e5ea5e1f26).Tab || !(t != null && t.activeElement) || !s.current || !s.current.contains(t.activeElement)) return;
        p.preventDefault();
        let y = (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(s.current, p.shiftKey ? (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Previous : (0, $cb6dceb64e6c0606$export$807a7eae502106e7).Next);
        if (y === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Underflow) return (b = n.button) == null ? void 0 : b.focus();
        if (y === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Overflow) {
            if (!n.button) return;
            let g = (0, $cb6dceb64e6c0606$export$433aaa1f216cf32d)(t.body), C = g.indexOf(n.button), h = g.splice(C + 1).filter((r)=>{
                var T;
                return !((T = s.current) != null && T.contains(r));
            });
            (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(h, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First) === (0, $cb6dceb64e6c0606$export$abf286375dfa6dbd).Error && (0, $cb6dceb64e6c0606$export$82e1f4f412218a1d)(t.body, (0, $cb6dceb64e6c0606$export$807a7eae502106e7).First);
        }
    }), (0, $faafded37f338b1b$export$7080b3e976bc91ab)(t == null ? void 0 : t.defaultView, "focus", ()=>{
        var p;
        !e || n.popoverState === 0 && (!s.current || (t == null ? void 0 : t.activeElement) && ((p = s.current) == null ? void 0 : p.contains(t.activeElement)) || l({
            type: 1
        }));
    }, !0);
    let c = (0, $acw62.useMemo)(()=>({
            open: n.popoverState === 0,
            close: i
        }), [
        n,
        i
    ]), d = {
        ref: v,
        id: n.panelId,
        onKeyDown: S
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$X.Provider, {
        value: n.panelId
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: d,
        theirProps: P,
        slot: c,
        defaultTag: $77da6324ebaeb061$var$Re,
        features: $77da6324ebaeb061$var$Oe,
        visible: u,
        name: "Popover.Panel"
    }));
}), $77da6324ebaeb061$var$Le = "div", $77da6324ebaeb061$var$xe = (0, $a54bdd13402af126$export$e43f39796049410c)(function(o, f) {
    let e = (0, $acw62.useRef)(null), P = (0, $4a1854c6a3ad5196$export$f6a25a78204acc7e)(e, f), [n, l] = (0, $acw62.useState)([]), i = (0, $acw62.useCallback)((d)=>{
        l((p)=>{
            let y = p.indexOf(d);
            if (y !== -1) {
                let b = p.slice();
                return b.splice(y, 1), b;
            }
            return p;
        });
    }, [
        l
    ]), s = (0, $acw62.useCallback)((d)=>(l((p)=>[
                ...p,
                d
            ]), ()=>i(d)), [
        l,
        i
    ]), v = (0, $acw62.useCallback)(()=>{
        var y;
        let d = (0, $c0a913ecfa4bf5e5$export$b204af158042fbac)(e);
        if (!d) return !1;
        let p = d.activeElement;
        return (y = e.current) != null && y.contains(p) ? !0 : n.some((b)=>{
            var g, C;
            return ((g = d.getElementById(b.buttonId)) == null ? void 0 : g.contains(p)) || ((C = d.getElementById(b.panelId)) == null ? void 0 : C.contains(p));
        });
    }, [
        e,
        n
    ]), t = (0, $acw62.useCallback)((d)=>{
        for (let p of n)p.buttonId !== d && p.close();
    }, [
        n
    ]), E = (0, $acw62.useMemo)(()=>({
            registerPopover: s,
            unregisterPopover: i,
            isFocusWithinPopoverGroup: v,
            closeOthers: t
        }), [
        s,
        i,
        v,
        t
    ]), u = (0, $acw62.useMemo)(()=>({}), []), S = o, c = {
        ref: P
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($77da6324ebaeb061$var$Q.Provider, {
        value: E
    }, (0, $a54bdd13402af126$export$b3890eb0ae9dca99)({
        ourProps: c,
        theirProps: S,
        slot: u,
        defaultTag: $77da6324ebaeb061$var$Le,
        name: "Popover.Group"
    }));
}), $77da6324ebaeb061$export$5b6b19405a83ff9d = Object.assign($77da6324ebaeb061$var$Se, {
    Button: $77da6324ebaeb061$var$me,
    Overlay: $77da6324ebaeb061$var$Ce,
    Panel: $77da6324ebaeb061$var$Ie,
    Group: $77da6324ebaeb061$var$xe
});




var $acw62 = parcelRequire("acw62");
const $66647bc97c1cf933$var$MatrixOfHL7 = ()=>{
    const canvasRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let width = canvas.width = window.innerWidth;
        let height = canvas.height = window.innerHeight;
        let columns = Math.floor(width / 20); // Number of columns based on character width
        const characters = `MSH|^~&|HL7\u{2764}\u{FE0F}||LOVE|REMY||\u{2695}\u{FE0F}ORM^O01\u{2764}\u{FE0F}|0001|1|\u{2764}\u{FE0F}2.5.\u{26A1}\u{FE0F}\u{2764}\u{FE0F}||THANKS~DAD||\u{2764}\u{FE0F}UMOM|8859/1|3THINGS|TRYFREE|`;
        const charArray = characters.split("");
        let drops = [];
        for(let i = 0; i < columns; i++)drops[i] = Math.floor(Math.random() * (height / 20));
        let frameRate = 30;
        let lastFrameTime = Date.now();
        const draw = ()=>{
            ctx.fillStyle = "rgba(45, 55, 72, 0.5)";
            ctx.fillRect(0, 0, width, height);
            ctx.fillStyle = "rgba(103, 232, 249, 0.9)";
            ctx.font = "16px monospace";
            for(let i = 0; i < drops.length; i++){
                let group = "";
                for(let j = 0; j < 11; j++)group += charArray[Math.floor(Math.random() * charArray.length)];
                ctx.fillText(group, i * 20, drops[i] * 20);
                if (drops[i] * 20 > height && Math.random() > 0.975) drops[i] = 0;
                drops[i]++;
            }
        };
        const animate = ()=>{
            const currentTime = Date.now();
            const elapsedTime = currentTime - lastFrameTime;
            if (elapsedTime > 1000 / frameRate) {
                draw();
                lastFrameTime = currentTime;
            }
            requestAnimationFrame(animate);
        };
        animate();
        const handleResize = ()=>{
            width = canvas.width = window.innerWidth;
            height = canvas.height = window.innerHeight;
            columns = Math.floor(width / 20);
            drops = [];
            for(let i = 0; i < columns; i++)drops[i] = 1;
        };
        // Check if the user is on a mobile device before handling resize and scroll events
        const isMobileDevice = /Mobi/i.test(window.navigator.userAgent);
        if (!isMobileDevice) window.addEventListener("resize", handleResize);
        return ()=>{
            if (!isMobileDevice) window.removeEventListener("resize", handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("canvas", {
        className: "matrix-canvas animate-pulse fixed top-0 left-0 z-[-1]",
        ref: canvasRef
    });
};
var $66647bc97c1cf933$export$2e2bcd8739ae039 = $66647bc97c1cf933$var$MatrixOfHL7;



var $acw62 = parcelRequire("acw62");
class $3008932907218197$var$ChatwootWidget extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    componentDidMount() {
        // Add Chatwoot Settings
        window.chatwootSettings = {
            hideMessageBubble: false,
            position: "right",
            // This can be left or right
            locale: "en",
            // Language to be set
            type: "standard" // [standard, expanded_bubble]
        };
        // Paste the script from inbox settings except the <script> tag
        (function(d, t) {
            var BASE_URL = "https://app.chatwoot.com";
            var g = d.createElement(t), s = d.getElementsByTagName(t)[0];
            g.src = BASE_URL + "/packs/js/sdk.js";
            g.defer = true;
            g.async = true;
            s.parentNode.insertBefore(g, s);
            g.onload = function() {
                window.chatwootSDK.run({
                    websiteToken: "Fr3rB9YpDJYBGs5yGoGdgEFi",
                    baseUrl: BASE_URL
                });
            };
        })(document, "script");
    }
    render() {
        return null;
    }
}
var $3008932907218197$export$2e2bcd8739ae039 = $3008932907218197$var$ChatwootWidget;



const $7dc95c65789a6373$var$nav = [
    {
        name: "Home",
        href: "#home",
        current: true
    },
    {
        name: "Features",
        href: "#features"
    },
    {
        name: "Beta Pricing",
        href: "#pricing"
    },
    {
        name: "Docs",
        href: "https://docs.retrohook.com/"
    },
    {
        name: "Releases",
        href: "https://docs.retrohook.com/blog/"
    },
    {
        name: "Discord",
        href: "https://discord.gg/yKxwrQrwew"
    },
    {
        name: "Youtube",
        href: "https://www.youtube.com/channel/UCsgby_S_K27scdBlvvOJK8A"
    },
    {
        name: "Contact",
        href: "#contact"
    }
];
const $7dc95c65789a6373$var$mainFeatures = [
    {
        id: 1,
        title: "No-Code Integrations",
        href: "https://docs.retrohook.com/docs/workflows",
        category: {
            name: "Built for Everyone",
            href: "https://docs.retrohook.com/docs/workflows"
        },
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($e0fe5e773e096a67$exports))),
        preview: "Retrohook's workflow engine allow you to route and map legacy hl7v2 data into useful HTTPS requests (webhooks), or AWS services."
    },
    {
        id: 2,
        title: "Simple Secure Tunnels",
        href: "https://docs.retrohook.com/docs/tunnels",
        category: {
            name: "IPSec IKEv2 VPN",
            href: "https://docs.retrohook.com/docs/tunnels"
        },
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($b80bc1d71ae8787f$exports))),
        preview: "Retrohook ensures secure interfaces by supporting both old and new security tech. Easily create safe MLLP tunnels with its user-friendly UI and connection agent."
    },
    {
        id: 3,
        title: "Private Cloud Deployments",
        href: "https://docs.retrohook.com/docs/workspaces",
        category: {
            name: "Leverage Your AWS",
            href: "https://docs.retrohook.com/docs/workspaces"
        },
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($af288c014d25d798$exports))),
        preview: "Deploy a Retrohook instance into your own AWS environment for enhanced compliance and security controls."
    },
    {
        id: 4,
        title: "Team Mode",
        href: "https://docs.retrohook.com/docs/intro#workspaces--environments",
        category: {
            name: "Shared Workspaces",
            href: "https://docs.retrohook.com/docs/intro#workspaces--environments"
        },
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($d1ab0352bc5145b7$exports))),
        preview: "Share your workspace and collaborate with others. Team mode also provides granular controls for managing access."
    }
];
function $7dc95c65789a6373$export$2e2bcd8739ae039(props) {
    const [loginModal, setLoginModal] = (0, $acw62.useState)(false);
    const [registerModal, setRegisterModal] = (0, $acw62.useState)(false);
    const [verificationCodeModal, setVerificationCodeModal] = (0, $acw62.useState)(false);
    const [email, setEmail] = (0, $acw62.useState)("");
    const [showTermsOfService, setShowTermsOfService] = (0, $acw62.useState)(false);
    const [products, setProducts] = (0, $acw62.useState)([]);
    const [showAWSRegistrationModal, setShowAWSRegistrationModal] = (0, $acw62.useState)(false);
    const [matrix, setMatrix] = (0, $acw62.useState)(false);
    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }
    (0, $acw62.useEffect)(()=>{
        getProducts();
    }, []);
    (0, $acw62.useEffect)(()=>{
        props.mktplaceToken ? setShowAWSRegistrationModal(true) : setShowAWSRegistrationModal(false);
    }, [
        props.mktplaceToken
    ]);
    const addPackageDetails = (product)=>{
        switch(product.product[0].name){
            case "Production Plan":
                return {
                    ...product,
                    features: [
                        "Everything in Developer +",
                        "Unlimited workflows for leveraging legacy healthcare events.",
                        "Unlimited team members to collaborate.",
                        "Deploy Retrohook instances into your cloud infrastructure.",
                        "IPSEC Tunnels for robust and secure EHR connections.",
                        "Production Features - S3 Actions, FHIR R4 and more..."
                    ]
                };
            case "Developer Plan":
                return {
                    ...product,
                    features: [
                        "Effortless Serverless Healthcare Messaging: Experience seamless hl7v2 communication without the complexities of server management",
                        "Test Workflows: Design and test up to 5 non-PHI workflows, perfect for experimentation and learning.",
                        "Shared Developer Workspace: Collaborate effectively with a 3-seat workspace designed for dynamic development teams.",
                        "Message Allocation: Benefit from 100 messages per month, allowing for ample testing and development.",
                        "Community Support: Gain insights and assistance from a community that understands your development needs."
                    ]
                };
            default:
                return {};
        }
    };
    const getProductsJSON = async ()=>{
        return {
            "data": [
                {
                    "id": "price_1LOCsQKCFwpQCzl3J5KmLZN7",
                    "object": "price",
                    "active": true,
                    "billing_scheme": "per_unit",
                    "created": 1658461810,
                    "currency": "usd",
                    "custom_unit_amount": null,
                    "livemode": false,
                    "lookup_key": null,
                    "metadata": {},
                    "nickname": null,
                    "product": [
                        {
                            "id": "prod_M60OTkntKj1Nxq",
                            "object": "product",
                            "active": true,
                            "attributes": [],
                            "created": 1658367664,
                            "default_price": "price_1LNoNxKCFwpQCzl3CLSELQcS",
                            "description": null,
                            "features": [],
                            "images": [],
                            "livemode": false,
                            "metadata": {},
                            "name": "Developer Plan",
                            "package_dimensions": null,
                            "shippable": null,
                            "statement_descriptor": null,
                            "tax_code": "txcd_10103001",
                            "type": "service",
                            "unit_label": null,
                            "updated": 1658461811,
                            "url": null
                        }
                    ],
                    "recurring": {
                        "aggregate_usage": null,
                        "interval": "year",
                        "interval_count": 1,
                        "trial_period_days": null,
                        "usage_type": "licensed"
                    },
                    "tax_behavior": "exclusive",
                    "tiers_mode": null,
                    "transform_quantity": null,
                    "type": "recurring",
                    "unit_amount": 0,
                    "unit_amount_decimal": "0"
                },
                {
                    "id": "price_1LOC37KCFwpQCzl3fkBFnwll",
                    "object": "price",
                    "active": true,
                    "billing_scheme": "per_unit",
                    "created": 1658458629,
                    "currency": "usd",
                    "custom_unit_amount": null,
                    "livemode": false,
                    "lookup_key": null,
                    "metadata": {},
                    "nickname": null,
                    "product": [
                        {
                            "id": "prod_M60PZr5qZsMtCZ",
                            "object": "product",
                            "active": true,
                            "attributes": [],
                            "created": 1658367710,
                            "default_price": "price_1LNoOhKCFwpQCzl3UttinsyD",
                            "description": null,
                            "features": [],
                            "images": [],
                            "livemode": false,
                            "metadata": {},
                            "name": "Production Plan",
                            "package_dimensions": null,
                            "shippable": null,
                            "statement_descriptor": null,
                            "tax_code": "txcd_10103001",
                            "type": "service",
                            "unit_label": null,
                            "updated": 1658458630,
                            "url": null
                        }
                    ],
                    "recurring": {
                        "aggregate_usage": null,
                        "interval": "year",
                        "interval_count": 1,
                        "trial_period_days": null,
                        "usage_type": "licensed"
                    },
                    "tax_behavior": "exclusive",
                    "tiers_mode": null,
                    "transform_quantity": null,
                    "type": "recurring",
                    "unit_amount": 10900000,
                    "unit_amount_decimal": "10900000"
                },
                {
                    "id": "price_1LNoOhKCFwpQCzl3UttinsyD",
                    "object": "price",
                    "active": true,
                    "billing_scheme": "per_unit",
                    "created": 1658367711,
                    "currency": "usd",
                    "custom_unit_amount": null,
                    "livemode": false,
                    "lookup_key": null,
                    "metadata": {},
                    "nickname": null,
                    "product": [
                        {
                            "id": "prod_M60PZr5qZsMtCZ",
                            "object": "product",
                            "active": true,
                            "attributes": [],
                            "created": 1658367710,
                            "default_price": "price_1LNoOhKCFwpQCzl3UttinsyD",
                            "description": null,
                            "features": [],
                            "images": [],
                            "livemode": false,
                            "metadata": {},
                            "name": "Production Plan",
                            "package_dimensions": null,
                            "shippable": null,
                            "statement_descriptor": null,
                            "tax_code": "txcd_10103001",
                            "type": "service",
                            "unit_label": null,
                            "updated": 1658458630,
                            "url": null
                        }
                    ],
                    "recurring": {
                        "aggregate_usage": null,
                        "interval": "month",
                        "interval_count": 1,
                        "trial_period_days": null,
                        "usage_type": "licensed"
                    },
                    "tax_behavior": "exclusive",
                    "tiers_mode": null,
                    "transform_quantity": null,
                    "type": "recurring",
                    "unit_amount": 500000,
                    "unit_amount_decimal": "1000000"
                },
                {
                    "id": "price_1LNoNxKCFwpQCzl3CLSELQcS",
                    "object": "price",
                    "active": true,
                    "billing_scheme": "per_unit",
                    "created": 1658367665,
                    "currency": "usd",
                    "custom_unit_amount": null,
                    "livemode": false,
                    "lookup_key": null,
                    "metadata": {},
                    "nickname": null,
                    "product": [
                        {
                            "id": "prod_M60OTkntKj1Nxq",
                            "object": "product",
                            "active": true,
                            "attributes": [],
                            "created": 1658367664,
                            "default_price": "price_1LNoNxKCFwpQCzl3CLSELQcS",
                            "description": null,
                            "features": [],
                            "images": [],
                            "livemode": false,
                            "metadata": {},
                            "name": "Developer Plan",
                            "package_dimensions": null,
                            "shippable": null,
                            "statement_descriptor": null,
                            "tax_code": "txcd_10103001",
                            "type": "service",
                            "unit_label": null,
                            "updated": 1658461811,
                            "url": null
                        }
                    ],
                    "recurring": {
                        "aggregate_usage": null,
                        "interval": "month",
                        "interval_count": 1,
                        "trial_period_days": null,
                        "usage_type": "licensed"
                    },
                    "tax_behavior": "exclusive",
                    "tiers_mode": null,
                    "transform_quantity": null,
                    "type": "recurring",
                    "unit_amount": 0,
                    "unit_amount_decimal": "0"
                }
            ]
        };
    };
    const getProducts = async ()=>{
        try {
            const productItems = await getProductsJSON();
            if (productItems?.data) {
                const products = productItems.data.map((product)=>addPackageDetails(product));
                setProducts(products.sort((a, b)=>a.unit_amount > b.unit_amount ? 1 : -1));
            }
        } catch (error) {
            console.error("Failed to fetch products:", error);
        }
    };
    const matrixCSS = "";
    if (props?.user) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-col justify-center items-center animate-color-change-2x h-screen",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "items-center animate-pulse",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "h-24 mx-auto w-auto",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                    alt: "Logo"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    className: "mt-0 text-center text-2xl font-bold text-gray-200",
                    children: [
                        "Retrohook",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "inline align-middle text-xs tracking-tight text-cyan-300 pl-1"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3008932907218197$export$2e2bcd8739ae039), {}),
            showAWSRegistrationModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35cddad02587b26d$export$2e2bcd8739ae039), {
                mktplaceToken: props.mktplaceToken,
                setNavHighlight: props.setNavHighlight,
                setEmail: setEmail,
                open: showAWSRegistrationModal,
                setVerificationCodeModel: ()=>{
                    setVerificationCodeModal(true);
                },
                closeModal: ()=>{
                    setShowAWSRegistrationModal(false);
                    setMatrix(!matrix);
                }
            }),
            showTermsOfService && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f65f877ad4a4ee3$export$2e2bcd8739ae039), {
                open: showTermsOfService,
                closeModal: ()=>{
                    setShowTermsOfService(false);
                    setMatrix(!matrix);
                }
            }),
            loginModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5aa1aa8b217417ec$export$2e2bcd8739ae039), {
                setNavHighlight: props.setNavHighlight,
                open: loginModal,
                setRegisterModal: ()=>{
                    setLoginModal(false);
                    setRegisterModal(true);
                },
                closeModal: ()=>{
                    setLoginModal(false);
                    setMatrix(!matrix);
                }
            }),
            registerModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecd4b6963d82864a$export$2e2bcd8739ae039), {
                open: registerModal,
                setSignInModal: ()=>{
                    setRegisterModal(false);
                    setLoginModal(true);
                },
                closeRegisterModal: ()=>{
                    setRegisterModal(false);
                },
                setEmail: setEmail,
                setVerificationCodeModel: ()=>{
                    setVerificationCodeModal(true);
                },
                closeModal: ()=>{
                    setRegisterModal(false);
                    setMatrix(!matrix);
                }
            }),
            verificationCodeModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7953e84a4dda08f3$export$2e2bcd8739ae039), {
                open: verificationCodeModal,
                email: email,
                setSignInModal: ()=>{
                    setVerificationCodeModal(false);
                    setLoginModal(true);
                },
                closeModal: ()=>{
                    setVerificationCodeModal(false);
                    setMatrix(!matrix);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $77da6324ebaeb061$export$5b6b19405a83ff9d), {
                as: "header",
                className: "sticky animate-color-change-2x top-0 z-10 border-b-2 border-cyan-400 shadow-2xl",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "animate-color-change-2x py-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                            className: "mx-auto flex items-center justify-between sm:pl-3",
                            "aria-label": "Global",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center flex-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-center justify-between w-full md:w-auto",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                            className: "h-8 inline px-1",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                                            alt: "logo"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "inline align-middle text-xl font-semibold text-gray-200 pl-1",
                                                            children: "Retrohook"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "inline text-xs text-cyan-300 pl-2"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "mr-4 flex items-center md:hidden",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $77da6324ebaeb061$export$5b6b19405a83ff9d).Button, {
                                                        className: "bg-gray-700 rounded-md p-2 inline-flex items-center justify-center text-gray-100 hover:bg-cyan-800 focus:outline-none focus:ring-2 focus-ring-inset focus:ring-white",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "sr-only",
                                                                children: "Open main menu"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ba5c4ec0e202528$export$2e2bcd8739ae039), {
                                                                className: "h-6 w-6",
                                                                "aria-hidden": "true"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "hidden space-x-8 md:flex md:ml-10",
                                            children: $7dc95c65789a6373$var$nav.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                    className: "text-base font-medium text-white hover:text-gray-300",
                                                    href: item.href,
                                                    children: item.name
                                                }, item.name))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "hidden md:flex pr-4",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        onClick: ()=>{
                                            setLoginModal(true);
                                            setMatrix(!matrix);
                                        },
                                        className: "px-2 py-1 cursor-pointer border border-solid border-cyan-300 hover:border-gray-50 text-sm font-medium rounded-md text-cyan-600 bg-gray-100 hover:bg-gray-100",
                                        children: "Log in"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $030a82c6b2bb6f00$export$be58926105124dd4), {
                        as: (0, $acw62.Fragment),
                        enter: "duration-150 ease-out",
                        enterFrom: "opacity-0 scale-95",
                        enterTo: "opacity-100 scale-100",
                        leave: "duration-100 ease-in",
                        leaveFrom: "opacity-100 scale-100",
                        leaveTo: "opacity-0 scale-95",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77da6324ebaeb061$export$5b6b19405a83ff9d).Panel, {
                            focus: true,
                            className: "absolute animate-color-change-2x top-0 inset-x-0 p-2 transition transform origin-top md:hidden",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "rounded-lg px-6 shadow-md animate-color-change-2x ring-1 ring-black ring-opacity-5 overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "px-5 pt-4 flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                            className: "h-10 inline px-1 shadow-sm",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($77f2a9faf1eb3211$exports))),
                                                            alt: "logo"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "inline align-middle text-2xl tracking-tight font-bold text-gray-100 shadow- pl-1",
                                                            children: "Retrohook"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "-mr-2",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $77da6324ebaeb061$export$5b6b19405a83ff9d).Button, {
                                                    className: " rounded-md p-2 inline-flex items-center justify-center text-gray-50 hover:bg-pink-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-600",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "Close menu"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                                            className: "h-6 w-6",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "pt-5 pb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "px-2 space-y-1",
                                                children: $7dc95c65789a6373$var$nav.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                        href: item.href,
                                                        className: "block px-3 py-2 rounded-md text-base font-medium text-gray-50 hover:bg-gray-500",
                                                        children: item.name
                                                    }, item.name))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-6 px-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>{
                                                            setRegisterModal(true);
                                                            setMatrix(!matrix);
                                                        },
                                                        className: "text-center w-full py-3 px-4 rounded-md shadow bg-gradient-to-r from-cyan-400 to-cyan-500 text-white cursor-pointer font-medium hover:from-cyan-500 hover:to-cyan-600",
                                                        children: "Sign Up Free!"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>{
                                                            setRegisterModal(true);
                                                            setMatrix(!matrix);
                                                        },
                                                        className: "text-center w-full py-3 px-4 mt-2 rounded-md shadow bg-gradient-to-r from-pink-400 to-pink-500 text-white cursor-pointer font-medium hover:from-pink-500 hover:to-pink-600",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                            className: "inline h-6",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a3db974f37add572$exports))),
                                                            alt: "AWS Marketplace"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-6 px-5",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    className: "text-center text-base font-medium text-gray-500",
                                                    children: [
                                                        "Existing customer?",
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                            onClick: ()=>{
                                                                setLoginModal(true);
                                                                setMatrix(!matrix);
                                                            },
                                                            className: "text-pink-400 cursor-pointer hover:underline",
                                                            children: "Login"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: "home",
                className: "pt-10 sm:pt-16 lg:pt-8 lg:pb-14 lg:overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "mx-auto px-8",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mx-auto px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "lg:py-24",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                            className: classNames(matrix ? matrixCSS : "", "mt-4 text-4xl tracking-tight font-bold text-white sm:mt-5 sm:text-xl sm:tracking-tight lg:mt-6 md:text-4xl lg:text-5xl xl:text-5xl xl:tracking-tight"),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "block",
                                                    children: "Instant Integration"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "bg-clip-text text-transparent bg-gradient-to-r from-gray-200 to-pink-600",
                                                    children: "Infinite Innovation"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: classNames(matrix ? matrixCSS : "", "text-base text-gray-300 sm:text-xl lg:text-lg xl:text-xl"),
                                            children: "Empower your product with seamless, secure hl7 exchange."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-4",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                                action: "#",
                                                className: "sm:max-w-2xl sm:mx-auto lg:mx-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "w-full",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "sm:mt-0 sm:ml-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                    type: "button",
                                                                    href: "#",
                                                                    onClick: ()=>{
                                                                        setRegisterModal(true);
                                                                        setMatrix(!matrix);
                                                                    },
                                                                    className: "inline py-1.5 px-2 rounded-md shadow bg-cyan-400  text-white font-medium hover:bg-cyan-500 border-2 border-cyan-500",
                                                                    children: "Create Free Account!"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                    type: "button",
                                                                    href: "https://aws.amazon.com/marketplace/pp/prodview-efbfzy3xjgx5s",
                                                                    className: "inline ml-4 py-2 px-4 rounded-md text-sm border-2 border-transparent text-white font-medium hover:border-pink-500",
                                                                    children: [
                                                                        "Find us on",
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                            className: "inline h-5 pl-2",
                                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a3db974f37add572$exports))),
                                                                            alt: "AWS Marketplace"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "mt-6 text-sm text-gray-300 sm:mt-4",
                                                        children: [
                                                            "Get your free account, no credit card necessary. By signing up, you agree to our",
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                onClick: ()=>{
                                                                    setShowTermsOfService(!showTermsOfService);
                                                                    setMatrix(!matrix);
                                                                },
                                                                className: "font-medium text-white",
                                                                children: "terms of service"
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-12 -mb-16 lg:m-0 lg:relative",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mx-auto px-4 sm:max-w-2xl sm:px-6 lg:max-w-none lg:px-0",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        className: "w-full cursor-pointer lg:absolute lg:inset-y-0 lg:left-0 lg:h-full lg:w-auto lg:max-w-none",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7a1c1a7556c35434$exports))),
                                        alt: "data UP UP"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: "overview",
                className: "relative pt-6 bg-gradient-to-b from-transparent to-gray-800",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "mx-auto max-w-md px-4 text-center  sm:px-6 sm:max-w-3xl lg:px-8 lg:max-w-7xl",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: classNames(matrix ? matrixCSS : "", "mx-auto"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-xl font-semibold text-cyan-300",
                                    children: "\u26A1\uFE0F Power Up Your AWS With EHR Data \u26A1\uFE0F"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-2 text-3xl font-bold text-gray-200 tracking-tight sm:text-4xl sm:tracking-tight",
                                    children: "\uD83D\uDD25 Reignite HL7v2.x With Clicks, Not Code."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mt-2 max-w-prose mx-auto text-xl text-gray-400",
                                    children: "Quickly and securely connect EHR data to modern technologies you \u2764\uFE0F. Retrohook provides a no-code experience for HL7 v2.x messaging, allowing you to focus on your product and not the plumbing."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mt-12 -mb-10 sm:-mb-24 lg:-mb-80",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "rounded-lg shadow-xl ring-1 ring-black ring-opacity-5",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7400f1aab4e6dc27$exports))),
                                alt: "A view of Retrohook"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                id: "features",
                className: "relative bg-gradient-to-b from-gray-800 to-gray-700",
                children: [
                    matrix ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66647bc97c1cf933$export$2e2bcd8739ae039), {}) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: " py-8 mb-16",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "text-center mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "text-lg font-semibold text-cyan-600",
                                                children: "Learn more about how"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "mt-2 text-3xl font-bold text-gray-200 tracking-tight sm:text-4xl sm:tracking-tight",
                                                children: "Retrohook Accelerates HL7v2 Integration"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "my-5 mx-auto max-w-prose text-xl text-gray-500",
                                                children: "Retrohook takes care of the heavy lifting by providing a no-code experience for working with HL7v2.x based integrations, the modules below work together to provide a seamless experience for your team and customers."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "mx-auto px-4 grid gap-8 sm:px-6 lg:px-8 sm:grid-cols-1 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 max-w-7xl",
                                        children: $7dc95c65789a6373$var$mainFeatures.map((post)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-col rounded-lg shadow-lg overflow-hidden hover:animate-pulse hover:ring-2 hover:ring-cyan-300 cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex-shrink-0",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                            className: "h-48 w-full object-cover",
                                                            src: post.imageUrl,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex-1 p-6 flex flex-col justify-between",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-sm font-medium text-cyan-400",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                        href: post.category.href,
                                                                        className: "hover:underline",
                                                                        children: post.category.name
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                                    href: post.href,
                                                                    className: "block mt-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-xl font-semibold text-gray-200",
                                                                            children: post.title
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "mt-3 text-base text-gray-400",
                                                                            children: post.preview
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, post.id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "bg-cyan-500 bg-gradient-to-r from-cyan-300 lg:z-10",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "lg:mx-auto lg:max-w-7xl lg:px-8 grid grid-cols-3 lg:grid lg:grid-cols-3 lg:gap-8",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:-mt-28 md:-mt-14 mt-32",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:p-0 lg:h-full",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "aspect-w-10 aspect-h-10 rounded-xl overflow-hidden sm:aspect-w-7 sm:aspect-h-7 lg:aspect-none lg:h-full",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        className: "max-h-96 sm:max-h-84 md:max-h-84",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cf8b327b06735390$exports))),
                                                        alt: ""
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "lg:m-0 col-span-2 lg:pl-8",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:px-0 mt-8 lg:max-w-none",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("blockquote", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                                className: "h-6 w-6 text-white opacity-25",
                                                                fill: "currentColor",
                                                                viewBox: "0 0 32 32",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                    d: "M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "mt-4 sm:text-sm md:text-lg lg:text-2xl xl:text-2xl font-medium text-white",
                                                                children: "Taking advantage of the immense power of HL7 v2.x's event driven messaging does not have to be difficult.  With Retrohook, our abstractions provide your team and customers rapid time to value."
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: "pricing",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "relative items-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: " py-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "text-center mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-lg font-semibold text-cyan-600",
                                    children: "Simple Pricing"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $22801410010c8d66$export$2e2bcd8739ae039), {
                                    setRegisterModal: setRegisterModal,
                                    products: products
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                id: "contact",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative md:absolute md:left-0 md:w-1/2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: " object-cover",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($39f7e02dc70086a1$exports))),
                                alt: "Retrohook takes you back in time"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                "aria-hidden": "true",
                                className: "absolute inset-0 bg-gradient-to-r from-gray-300 to-gray-400 mix-blend-multiply"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "relative mx-auto max-w-md px-4 pt-6 sm:max-w-7xl sm:px-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "md:ml-auto md:w-1/2 md:pl-10",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: classNames(matrix ? "px-12 py-4 m-2 bg-gray-700 border-2 border-gray-600 shadow-xl rounded" : "", "cursor-pointer"),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "text-lg font-semibold text-cyan-300",
                                        children: "Visit Our Product Guide"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-2 text-white text-3xl font-bold tracking-tight sm:text-4xl sm:tracking-tight",
                                        children: "Get started with Retrohook today"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mt-3 text-lg text-gray-300",
                                        children: "Check out our documentation to learn how to get started with Retrohook. When you are ready we are here to help."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "inline-flex rounded-md shadow",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                    href: "https://docs.retrohook.com/",
                                                    className: "inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-100 bg-pink-400 hover:bg-pink-500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0902542cd17ebe75$export$2e2bcd8739ae039), {
                                                            className: "-ml-1 mr-1 h-5 w-5 text-gray-100",
                                                            "aria-hidden": "true"
                                                        }),
                                                        "Docs"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "inline-flex rounded-md shadow pl-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                    href: "https://www.youtube.com/channel/UCsgby_S_K27scdBlvvOJK8A",
                                                    className: "inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-100 bg-cyan-400 hover:bg-cyan-500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ee9e3fb202168dd$export$2e2bcd8739ae039), {
                                                            className: "-ml-1 mr-1 h-5 w-5 text-gray-100",
                                                            "aria-hidden": "true"
                                                        }),
                                                        "Youtube"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "inline-flex ml-4 rounded-md shadow",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                    href: "mailto:sales@retrohook.com",
                                                    className: "inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-100 bg-gray-400 hover:bg-gray-500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa3403b0959b0e21$export$2e2bcd8739ae039), {
                                                            className: "-ml-1 mr-1 h-5 w-5 text-gray-100",
                                                            "aria-hidden": "true"
                                                        }),
                                                        "Request Info"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}



function $cd93687958c8007e$export$2e2bcd8739ae039() {
    const history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const auth = (0, $cb5b9529b8ae0bf0$export$1d39dc5b47e56ff0)();
    const user = auth.user;
    const [nav, setNav] = (0, $acw62.useState)((0, $15f24a665de742b6$export$2e2bcd8739ae039).nav);
    const [account, setAccount] = (0, $acw62.useState)(user?.account);
    const [environments, setEnvironments] = (0, $acw62.useState)([]);
    const [selectedAccount, setSelectedAccount] = (0, $acw62.useState)([]);
    const [selectedWorkspaceModal, setSelectedWorkspaceModal] = (0, $acw62.useState)(false);
    const [updateBillingCustomer, setUpdateBillingCustomer] = (0, $acw62.useState)(false);
    const [selectedEnvironment, setSelectedEnvironment] = (0, $acw62.useState)(user?.account?.workspaces[0].environments[0]);
    const [selectedWorkspace, setSelectedWorkspace] = (0, $396aba8b73bd6dda$export$2e2bcd8739ae039)("selectedWorkspace", [
        user?.account?.workspaces[0]
    ]);
    const [mktplaceToken, setMktplaceToken] = (0, $396aba8b73bd6dda$export$2e2bcd8739ae039)("mktplaceToken", "");
    const [isAmazonAccount, setIsAmazonAccount] = (0, $396aba8b73bd6dda$export$2e2bcd8739ae039)("isAmazonAccount", false);
    const setUpdateBilling = (0, $acw62.useCallback)(async (selected)=>{
        setUpdateBillingCustomer(selected);
    }, [
        setSelectedAccount
    ]);
    const setAccountCallback = (0, $acw62.useCallback)(async (selected)=>{
        setAccount(selected);
    }, [
        setAccount
    ]);
    const setSelectedEnvironmentCallback = (0, $acw62.useCallback)(async (selected)=>{
        setSelectedEnvironment(selected);
    }, [
        setSelectedEnvironment
    ]);
    const updateNav = (href)=>{
        const newNav = nav.map((item)=>{
            if (item.href === href) return {
                ...item,
                current: true
            };
            return {
                ...item,
                current: false
            };
        });
        setNav(newNav);
    };
    const redirectToURL = (page)=>{
        history.push(`/${page}`);
        updateNav(page);
    };
    const handleLogout = ()=>{
        auth.logout();
        history.push("/");
    };
    const setNavHighlight = (pageName)=>{
        const newNav = nav.map((item)=>{
            if (item.name === pageName) return {
                ...item,
                current: true
            };
            return {
                ...item,
                current: false
            };
        });
        setNav(newNav);
    };
    const getUrlParameter = (name, history)=>{
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
        const results = regex.exec(history.location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    };
    const syncAccountData = async ()=>{
        if (auth.user && auth.user.tokens) {
            const response = await fetch(`${(0, $15f24a665de742b6$export$2e2bcd8739ae039).url}/account/get-account/${auth.user.attributes.id}`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${auth.user.tokens.AccessToken}`
                }
            });
            if (response.ok && response.status === 200 && response.body !== null) {
                const data = await response.json();
                setAccount(data.account);
                setSelectedAccount(data.account);
                setSelectedWorkspace(selectedWorkspace.SK ? selectedWorkspace : data?.account?.workspaces[0]);
                setEnvironments(selectedWorkspace.environments ? selectedWorkspace.environments : data?.account?.workspaces[0]?.environments.sort().reverse());
                setSelectedEnvironmentCallback(selectedEnvironment ? selectedEnvironment : data.account.workspaces[0].environments[0]);
            }
        }
    };
    (0, $acw62.useEffect)(()=>{
        const mktplaceToken = getUrlParameter("x-amzn-marketplace-token", history);
        const canceled = (0, (/*@__PURE__*/$parcel$interopDefault($1c66380376aa2c89$exports))).parse(history.location.search, {
            ignoreQueryPrefix: true
        }).canceled ? true : false;
        if (canceled) {
            setUpdateBilling(true);
            history.replace({
                search: ""
            });
        }
        if (mktplaceToken.length > 0) {
            setMktplaceToken(mktplaceToken);
            setIsAmazonAccount(true);
        }
    }, [
        auth.user?.account,
        history.location.search,
        mktplaceToken
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!user) handleLogout();
        const currentPath = location.pathname.substring(1);
        if (currentPath) redirectToURL(currentPath);
        setNav(nav.map((item)=>{
            if (item.href === `/${currentPath}`) return {
                ...item,
                current: true
            };
            return {
                ...item,
                current: false
            };
        }));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (auth.user && auth.user.account) {
            setAccountCallback(auth.user.account);
            setSelectedAccount(auth.user.account);
            setSelectedWorkspace(selectedWorkspace.length > 1 ? selectedWorkspace : auth.user.account.workspaces[0]);
            setEnvironments(selectedWorkspace?.environments ? selectedWorkspace?.environments : auth.user.account.workspaces[0].environments.sort().reverse());
            setSelectedEnvironmentCallback(selectedEnvironment ? selectedEnvironment : auth.user.account.workspaces[0].environments[0]);
        }
        if (auth.user && auth.user.tokens && !auth.user.account) syncAccountData().catch(console.error);
    }, [
        auth.user
    ]);
    let options;
    if (user?.account) options = {
        headers: {
            Authorization: `Bearer ${user.tokens.AccessToken}`
        },
        cacheLife: 100,
        interceptors: {
            response: ({ response: response })=>{
                if (response.status === 401) handleLogout();
                return response;
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: user && user.account ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col animate-color-change-2x h-screen",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3008932907218197$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $53dbc123c10664bd$export$2881499e37b75b9a), {
                    url: (0, $15f24a665de742b6$export$2e2bcd8739ae039).url,
                    options: options,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db8c54ee37aae428$export$2e2bcd8739ae039), {
                            user: user,
                            account: account,
                            selectedWorkspace: selectedWorkspace,
                            setSelectedWorkspaceModal: setSelectedWorkspaceModal,
                            logout: ()=>handleLogout(),
                            nav: nav,
                            history: history,
                            updateNav: updateNav,
                            redirectToURL: (url)=>redirectToURL(url)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50a5d3792f6b8312$export$2e2bcd8739ae039), {
                            user: user,
                            selectedWorkspace: selectedWorkspace,
                            setSelectedWorkspaceHandler: setSelectedWorkspace,
                            closeSelectModal: ()=>setSelectedWorkspaceModal(false),
                            open: selectedWorkspaceModal,
                            logout: ()=>handleLogout()
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $726c1cdb0a261306$export$2e2bcd8739ae039), {
                            account: account,
                            setAccount: setAccountCallback,
                            environments: environments,
                            history: history,
                            updateBillingCustomer: updateBillingCustomer,
                            selectedEnvironment: selectedEnvironment,
                            setupEnvironmentsHandler: setEnvironments,
                            setSelectedEnvironment: setSelectedEnvironmentCallback,
                            selectedAccount: selectedAccount,
                            selectedWorkspace: selectedWorkspace,
                            setSelectedWorkspace: setSelectedWorkspace,
                            setSelectedAccount: setSelectedAccount,
                            logout: ()=>handleLogout(),
                            redirectToURL: (url)=>redirectToURL(url)
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7dc95c65789a6373$export$2e2bcd8739ae039), {
            user: user,
            isAmazonAccount: isAmazonAccount,
            mktplaceToken: mktplaceToken,
            setNavHighlight: setNavHighlight
        })
    });
}





var $8x56E = parcelRequire("8x56E");
var $NU9Qs = parcelRequire("NU9Qs");
var $8x56E = parcelRequire("8x56E");

var $4g0Ct = parcelRequire("4g0Ct");
var $51cfcbefde61ff20$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * @private
 */ function $51cfcbefde61ff20$var$filterDuplicates(integrations) {
    return integrations.reduce((acc, integrations)=>{
        if (acc.every((accIntegration)=>integrations.name !== accIntegration.name)) acc.push(integrations);
        return acc;
    }, []);
}
/** Gets integration to install */ function $51cfcbefde61ff20$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && [
        ...options.defaultIntegrations
    ] || [];
    var userIntegrations = options.integrations;
    let integrations = [
        ...$51cfcbefde61ff20$var$filterDuplicates(defaultIntegrations)
    ];
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = [
        ...integrations.filter((integrations)=>userIntegrations.every((userIntegration)=>userIntegration.name !== integrations.name)),
        // And filter out duplicated user options integrations
        ...$51cfcbefde61ff20$var$filterDuplicates(userIntegrations)
    ];
    else if (typeof userIntegrations === "function") {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map((i)=>i.name);
    var alwaysLastToRun = "Debug";
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push(...integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1));
    return integrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $51cfcbefde61ff20$export$51abed9797baa598(integrations) {
    var integrationIndex = {};
    integrations.forEach((integration)=>{
        integrationIndex[integration.name] = integration;
        if ($51cfcbefde61ff20$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
            integration.setupOnce((0, $NU9Qs.addGlobalEventProcessor), (0, $8x56E.getCurrentHub));
            $51cfcbefde61ff20$export$b14a8888f80a0b3e.push(integration.name);
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`Integration installed: ${integration.name}`);
        }
    });
    return integrationIndex;
}

/** An error emitted by Sentry SDKs and related utilities. */ class $890c53ca2f6b4a7a$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}


/** Regular expression used to parse a Dsn. */ var $f7133678d936cd5e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f7133678d936cd5e$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $f7133678d936cd5e$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */ function $f7133678d936cd5e$export$b892860177f70a30(str) {
    var match = $f7133678d936cd5e$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Invalid Sentry Dsn: ${str}`);
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    var split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f7133678d936cd5e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f7133678d936cd5e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $f7133678d936cd5e$var$validateDsn(dsn) {
    if (!(typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__)) return;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    var requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    requiredComponents.forEach((component)=>{
        if (!dsn[component]) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Invalid Sentry Dsn: ${component} missing`);
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    if (!$f7133678d936cd5e$var$isValidProtocol(protocol)) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Invalid Sentry Dsn: Invalid port ${port}`);
    return true;
}
/** The Sentry Dsn, identifying a Sentry instance and project. */ function $f7133678d936cd5e$export$128827c3562ec0cb(from) {
    var components = typeof from === "string" ? $f7133678d936cd5e$export$b892860177f70a30(from) : $f7133678d936cd5e$var$dsnFromComponents(from);
    $f7133678d936cd5e$var$validateDsn(components);
    return components;
}


var $jL8lq = parcelRequire("jL8lq");
var $d91612272370ed71$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $d91612272370ed71$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    var port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $d91612272370ed71$var$_getIngestEndpoint(dsn) {
    return `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $d91612272370ed71$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $jL8lq.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $d91612272370ed71$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $d91612272370ed71$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    var tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    var sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$d91612272370ed71$var$_getIngestEndpoint(dsn)}?${$d91612272370ed71$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $d91612272370ed71$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $f7133678d936cd5e$export$128827c3562ec0cb)(dsnLike);
    var endpoint = `${$d91612272370ed71$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)}`;
    for(var key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "user") {
            var user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


var $8x56E = parcelRequire("8x56E");

var $4g0Ct = parcelRequire("4g0Ct");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $93002778f3923c52$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) (0, $4g0Ct.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
    }
    var hub = (0, $8x56E.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

var $d410fde205ba0588$exports = {};

$parcel$export($d410fde205ba0588$exports, "FunctionToString", () => $ceb328f2f449885f$export$da4704525c20ae79);
$parcel$export($d410fde205ba0588$exports, "InboundFilters", () => $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4);

var $jL8lq = parcelRequire("jL8lq");
let $ceb328f2f449885f$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ class $ceb328f2f449885f$export$da4704525c20ae79 {
    constructor(){
        $ceb328f2f449885f$export$da4704525c20ae79.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "FunctionToString";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $ceb328f2f449885f$export$da4704525c20ae79.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        $ceb328f2f449885f$var$originalFunctionToString = Function.prototype.toString;
        Function.prototype.toString = function(...args) {
            var context = (0, $jL8lq.getOriginalFunction)(this) || this;
            return $ceb328f2f449885f$var$originalFunctionToString.apply(context, args);
        };
    }
}
$ceb328f2f449885f$export$da4704525c20ae79.__initStatic();



var $b1E2c = parcelRequire("b1E2c");
var $91U3U = parcelRequire("91U3U");
var $4g0Ct = parcelRequire("4g0Ct");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Options for the InboundFilters integration */ /** Inbound filters configurable by the user */ class $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "InboundFilters";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4.id;
    }
    constructor(_options = {}){
        this._options = _options;
        $499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        var eventProcess = (event)=>{
            var hub = getCurrentHub();
            if (hub) {
                var self = hub.getIntegration($499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4);
                if (self) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $499a1b6c2e7bd9e9$export$6620a151868b99aa(self._options, clientOptions);
                    return $499a1b6c2e7bd9e9$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        };
        eventProcess.id = this.name;
        addGlobalEventProcessor(eventProcess);
    }
}
$499a1b6c2e7bd9e9$export$2ffbb5359dcc6be4.__initStatic();
/** JSDoc */ function $499a1b6c2e7bd9e9$export$6620a151868b99aa(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...$499a1b6c2e7bd9e9$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
/** JSDoc */ function $499a1b6c2e7bd9e9$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $499a1b6c2e7bd9e9$var$_isSentryError(event)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isIgnoredError(event, options.ignoreErrors)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}`);
        return true;
    }
    if ($499a1b6c2e7bd9e9$var$_isDeniedUrl(event, options.denyUrls)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$499a1b6c2e7bd9e9$var$_isAllowedUrl(event, options.allowUrls)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $b1E2c.getEventDescription)(event)}.\nUrl: ${$499a1b6c2e7bd9e9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event).some((message)=>ignoreErrors.some((pattern)=>(0, $91U3U.isMatchingPattern)(message, pattern)));
}
function $499a1b6c2e7bd9e9$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some((pattern)=>(0, $91U3U.isMatchingPattern)(url, pattern));
}
function $499a1b6c2e7bd9e9$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some((pattern)=>(0, $91U3U.isMatchingPattern)(url, pattern));
}
function $499a1b6c2e7bd9e9$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        const { type: type = "", value: value = "" } = event.exception.values && event.exception.values[0] || {};
        return [
            `${value}`,
            `${type}: ${value}`
        ];
    } catch (oO) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error(`Cannot extract message for event ${(0, $b1E2c.getEventDescription)(event)}`);
        return [];
    }
    return [];
}
function $499a1b6c2e7bd9e9$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $499a1b6c2e7bd9e9$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $499a1b6c2e7bd9e9$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error(`Cannot extract url for event ${(0, $b1E2c.getEventDescription)(event)}`);
        return null;
    }
}





var $js14m = parcelRequire("js14m");
var $42ap3 = parcelRequire("42ap3");
var $4g0Ct = parcelRequire("4g0Ct");
var $j3a3y = parcelRequire("j3a3y");
var $16dZf = parcelRequire("16dZf");
var $esO9h = parcelRequire("esO9h");

var $NU9Qs = parcelRequire("NU9Qs");
var $lvhwF = parcelRequire("lvhwF");

var $jL8lq = parcelRequire("jL8lq");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2cae643f899492f0$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 */ function $2cae643f899492f0$export$c56c55acf0136fd3(envelope, callback) {
    var envelopeItems = envelope[1];
    envelopeItems.forEach((envelopeItem)=>{
        var envelopeItemType = envelopeItem[0].type;
        callback(envelopeItem, envelopeItemType);
    });
}
function $2cae643f899492f0$var$encodeUTF8(input, textEncoder) {
    var utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $2cae643f899492f0$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $2cae643f899492f0$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $2cae643f899492f0$var$encodeUTF8(next, textEncoder) : next);
    }
    for (var item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        append(typeof payload === "string" || payload instanceof Uint8Array ? payload : JSON.stringify(payload));
    }
    return typeof parts === "string" ? parts : $2cae643f899492f0$var$concatBuffers(parts);
}
function $2cae643f899492f0$var$concatBuffers(buffers) {
    var totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    var merged = new Uint8Array(totalLength);
    let offset = 0;
    for (var buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Creates attachment envelope items
 */ function $2cae643f899492f0$export$d8fc80952cc31fa4(attachment, textEncoder) {
    var buffer = typeof attachment.data === "string" ? $2cae643f899492f0$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $jL8lq.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
var $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $2cae643f899492f0$export$b11169581eeaf237(type) {
    return $2cae643f899492f0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}


var $b1E2c = parcelRequire("b1E2c");
var $cvSY8 = parcelRequire("cvSY8");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $2zW56 = parcelRequire("2zW56");
/**
 * Helper to decycle json objects
 */ function $2a06788518a26cc6$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === "function";
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        for(let i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



var $jL8lq = parcelRequire("jL8lq");

var $16dZf = parcelRequire("16dZf");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ function $9ca32e18a091d955$export$a3295358bff77e(input, depth = Infinity, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $9ca32e18a091d955$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $9ca32e18a091d955$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    var normalized = $9ca32e18a091d955$export$a3295358bff77e(object, depth);
    if ($9ca32e18a091d955$var$jsonSize(normalized) > maxSize) return $9ca32e18a091d955$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $9ca32e18a091d955$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $2a06788518a26cc6$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value === null || [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $2zW56.isNaN)(value)) return value;
    var stringified = $9ca32e18a091d955$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        var jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $9ca32e18a091d955$export$588732934346abbf("", jsonValue, depth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $jL8lq.convertToPlainObject)(value);
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $9ca32e18a091d955$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $9ca32e18a091d955$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        if (typeof window !== "undefined" && value === window) return "[Window]";
        if (typeof document !== "undefined" && value === document) return "[Document]";
        // React's SyntheticEvent thingy
        if ((0, $2zW56.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return "[undefined]";
        if (typeof value === "function") return `[Function: ${(0, $16dZf.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return `[object ${Object.getPrototypeOf(value).constructor.name}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/** Calculates bytes size of input string */ function $9ca32e18a091d955$var$utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $9ca32e18a091d955$var$jsonSize(value) {
    return $9ca32e18a091d955$var$utf8Length(JSON.stringify(value));
}


var $j3a3y = parcelRequire("j3a3y");
var $91U3U = parcelRequire("91U3U");


var $jL8lq = parcelRequire("jL8lq");
var $dzA7g = parcelRequire("dzA7g");
/** Extract sdk info from from the API metadata */ function $9b6c4c62dbf66cae$var$getSdkMetadataForEnvelopeHeader(metadata) {
    if (!metadata || !metadata.sdk) return;
    const { name: name, version: version } = metadata.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $9b6c4c62dbf66cae$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    var sdkInfo = $9b6c4c62dbf66cae$var$getSdkMetadataForEnvelopeHeader(metadata);
    var envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        }
    };
    var envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $9b6c4c62dbf66cae$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    var sdkInfo = $9b6c4c62dbf66cae$var$getSdkMetadataForEnvelopeHeader(metadata);
    var eventType = event.type || "event";
    const { transactionSampling: transactionSampling } = event.sdkProcessingMetadata || {};
    const { method: samplingMethod, rate: sampleRate } = transactionSampling || {};
    $9b6c4c62dbf66cae$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    var envelopeHeaders = $9b6c4c62dbf66cae$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $9b6c4c62dbf66cae$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
    var baggage = event.sdkProcessingMetadata && event.sdkProcessingMetadata.baggage;
    var dynamicSamplingContext = baggage && (0, $dzA7g.getSentryBaggageItems)(baggage);
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $f7133678d936cd5e$export$44d472fbb931a776)(dsn)
        },
        ...event.type === "transaction" && dynamicSamplingContext && {
            trace: (0, $jL8lq.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}



var $5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $5d4a5f71b683f78e$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ __init() {
        this._integrations = {};
    }
    /** Indicates whether this client's integrations have been set up. */ __init2() {
        this._integrationsInitialized = false;
    }
    /** Number of calls being processed */ __init3() {
        this._numProcessing = 0;
    }
    /** Holds flushable  */ __init4() {
        this._outcomes = {};
    }
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        $5d4a5f71b683f78e$export$4f22f74eddb7716a.prototype.__init.call(this);
        $5d4a5f71b683f78e$export$4f22f74eddb7716a.prototype.__init2.call(this);
        $5d4a5f71b683f78e$export$4f22f74eddb7716a.prototype.__init3.call(this);
        $5d4a5f71b683f78e$export$4f22f74eddb7716a.prototype.__init4.call(this);
        this._options = options;
        if (options.dsn) {
            this._dsn = (0, $f7133678d936cd5e$export$128827c3562ec0cb)(options.dsn);
            var url = (0, $d91612272370ed71$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("No DSN provided, client will not do anything.");
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $b1E2c.checkOrSetAlreadyCaught)(exception)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, scope) {
        let eventId = hint && hint.event_id;
        var promisedEvent = (0, $2zW56.isPrimitive)(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $b1E2c.checkOrSetAlreadyCaught)(hint.originalException)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log($5d4a5f71b683f78e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("SDK not enabled, will not capture session.");
            return;
        }
        if (!(typeof session.release === "string")) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $lvhwF.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        var transport = this._transport;
        if (transport) return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
            return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
        });
        else return (0, $j3a3y.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            return result;
        });
    }
    /**
   * Sets up the integrations
   */ setupIntegrations() {
        if (this._isEnabled() && !this._integrationsInitialized) {
            this._integrations = (0, $51cfcbefde61ff20$export$51abed9797baa598)(this._options.integrations);
            this._integrationsInitialized = true;
        }
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */ getIntegrationById(integrationId) {
        return this._integrations[integrationId];
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        if (this._dsn) {
            let env = (0, $9b6c4c62dbf66cae$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
            for (var attachment of hint.attachments || [])env = (0, $2cae643f899492f0$export$d650323442802f6f)(env, (0, $2cae643f899492f0$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
            this._sendEnvelope(env);
        }
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        if (this._dsn) {
            var env = (0, $9b6c4c62dbf66cae$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
            this._sendEnvelope(env);
        }
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            var key = `${reason}:${category}`;
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (var ex of exceptions){
                var mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === "ok";
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $lvhwF.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $j3a3y.SyncPromise)((resolve)=>{
            let ticked = 0;
            var tick = 1;
            var interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope) {
        const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = this.getOptions();
        var prepared = {
            ...event,
            event_id: event.event_id || hint.event_id || (0, $b1E2c.uuid4)(),
            timestamp: event.timestamp || (0, $cvSY8.dateTimestampInSeconds)()
        };
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        let finalScope = scope;
        if (hint.captureContext) finalScope = (0, $NU9Qs.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        let result = (0, $j3a3y.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // Collect attachments from the hint and scope
            var attachments = [
                ...hint.attachments || [],
                ...finalScope.getAttachments()
            ];
            if (attachments.length) hint.attachments = attachments;
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then((evt)=>{
            if (typeof normalizeDepth === "number" && normalizeDepth > 0) return this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    }
    /**
   * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
   * Normalized keys:
   * - `breadcrumbs.data`
   * - `user`
   * - `contexts`
   * - `extra`
   * @param event Event
   * @returns Normalized event
   */ _normalizeEvent(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = {
            ...event,
            ...event.breadcrumbs && {
                breadcrumbs: event.breadcrumbs.map((b)=>({
                        ...b,
                        ...b.data && {
                            data: (0, $9ca32e18a091d955$export$a3295358bff77e)(b.data, depth, maxBreadth)
                        }
                    }))
            },
            ...event.user && {
                user: (0, $9ca32e18a091d955$export$a3295358bff77e)(event.user, depth, maxBreadth)
            },
            ...event.contexts && {
                contexts: (0, $9ca32e18a091d955$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
            },
            ...event.extra && {
                extra: (0, $9ca32e18a091d955$export$a3295358bff77e)(event.extra, depth, maxBreadth)
            }
        };
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace && normalized.contexts) {
            normalized.contexts.trace = event.contexts.trace;
            // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
            if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $9ca32e18a091d955$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
        }
        // event.spans[].data may contain circular/dangerous data so we need to normalize it
        if (event.spans) normalized.spans = event.spans.map((span)=>{
            // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
            if (span.data) span.data = (0, $9ca32e18a091d955$export$a3295358bff77e)(span.data, depth, maxBreadth);
            return span;
        });
        return normalized;
    }
    /**
   *  Enhances event using the client configuration.
   *  It takes care of all "static" values like environment, release and `dist`,
   *  as well as truncating overly long values.
   * @param event event instance to be enhanced
   */ _applyClientOptions(event) {
        var options = this.getOptions();
        const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
        if (!("environment" in event)) event.environment = "environment" in options ? environment : "production";
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $91U3U.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $91U3U.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $91U3U.truncate)(request.url, maxValueLength);
    }
    /**
   * This function adds all used integrations to the SDK info in the event.
   * @param event The event that will be filled with all integrations.
   */ _applyIntegrationsMetadata(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = [
                ...event.sdk.integrations || [],
                ...integrationsArray
            ];
        }
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(reason);
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const { beforeSend: beforeSend, sampleRate: sampleRate } = this.getOptions();
        if (!this._isEnabled()) return (0, $j3a3y.rejectedSyncPromise)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)("SDK not enabled, will not capture event."));
        var isTransaction = event.type === "transaction";
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return (0, $j3a3y.rejectedSyncPromise)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        return this._prepareEvent(event, hint, scope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", event.type || "error");
                throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)("An event processor returned null, will not send event.");
            }
            var isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $5d4a5f71b683f78e$var$_ensureBeforeSendRv(beforeSendResult);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", event.type || "error");
                throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)("`beforeSend` returned `null`, will not send event.");
            }
            var session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing += 1;
        promise.then((value)=>{
            this._numProcessing -= 1;
            return value;
        }, (reason)=>{
            this._numProcessing -= 1;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        if (this._transport && this._dsn) this._transport.send(envelope).then(null, (reason)=>{
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error("Error while sending event:", reason);
        });
        else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        var outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $5d4a5f71b683f78e$var$_ensureBeforeSendRv(rv) {
    var nullErr = "`beforeSend` method has to return `null` or a valid event.";
    if ((0, $2zW56.isThenable)(rv)) return rv.then((event)=>{
        if (!((0, $2zW56.isPlainObject)(event) || event === null)) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(nullErr);
        return event;
    }, (e)=>{
        throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(`beforeSend rejected with ${e}`);
    });
    else if (!((0, $2zW56.isPlainObject)(rv) || rv === null)) throw new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)(nullErr);
    return rv;
}


var $8x56E = parcelRequire("8x56E");var $725570364ca356d5$export$31499a9cd224b78c = "7.9.0";




var $cvSY8 = parcelRequire("cvSY8");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $d90c5d9ac5d72442$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $cvSY8.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2cae643f899492f0$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $b1E2c = parcelRequire("b1E2c");
var $42ap3 = parcelRequire("42ap3");
var $4g0Ct = parcelRequire("4g0Ct");

var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");
var $2zW56 = parcelRequire("2zW56");
var $j3a3y = parcelRequire("j3a3y");
/**
 * This function creates an exception from a JavaScript Error
 */ function $230372ac01587541$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex);
    var exception = {
        type: ex && ex.name,
        value: $230372ac01587541$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $230372ac01587541$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $2zW56.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: `Non-Error ${isUnhandledRejection ? "promise rejection" : "exception"} captured with keys: ${(0, $jL8lq.extractExceptionKeysForMessage)(exception)}`
                }
            ]
        },
        extra: {
            __serialized__: (0, $9ca32e18a091d955$export$23fbbb20bed71033)(exception)
        }
    };
    if (syntheticException) {
        var frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $230372ac01587541$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $230372ac01587541$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || "";
    var popSize = $230372ac01587541$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $230372ac01587541$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $230372ac01587541$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($230372ac01587541$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $230372ac01587541$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $230372ac01587541$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b1E2c.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $j3a3y.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $230372ac01587541$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $j3a3y.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $230372ac01587541$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $2zW56.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $230372ac01587541$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $2zW56.isDOMError)(exception) || (0, $2zW56.isDOMException)(exception)) {
        var domException = exception;
        if ("stack" in exception) event = $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
        else {
            var name = domException.name || ((0, $2zW56.isDOMError)(domException) ? "DOMError" : "DOMException");
            var message = domException.message ? `${name}: ${domException.message}` : name;
            event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $b1E2c.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $2zW56.isError)(exception)) // we have a real Error object, do nothing
    return $230372ac01587541$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $2zW56.isPlainObject)(exception) || (0, $2zW56.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $230372ac01587541$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $b1E2c.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $230372ac01587541$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b1E2c.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $b1E2c.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $230372ac01587541$export$47d86ae4b3c9994(stackParser, input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames = $230372ac01587541$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: input,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    return event;
}



var $8x56E = parcelRequire("8x56E");

var $js14m = parcelRequire("js14m");
var $42ap3 = parcelRequire("42ap3");
var $ibKgU = parcelRequire("ibKgU");/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $25257edadcf16f49$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $25257edadcf16f49$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $25257edadcf16f49$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}


var $91U3U = parcelRequire("91U3U");// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
var $7f06244a5e0d22e8$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $7f06244a5e0d22e8$export$e01cef29b4327697(level) {
    return $7f06244a5e0d22e8$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $7f06244a5e0d22e8$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $7f06244a5e0d22e8$export$411d0ffdba845b6c.includes(level) ? level : "log";
}


/** JSDoc */ var $b50dad0732e7f682$export$6d0f6df16bece7bf = "Breadcrumbs";
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ class $b50dad0732e7f682$export$2dc68d50d56fbbd {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = $b50dad0732e7f682$export$6d0f6df16bece7bf;
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $b50dad0732e7f682$export$2dc68d50d56fbbd.id;
    }
    /**
   * Options of the breadcrumbs integration.
   */ // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
    /**
   * @inheritDoc
   */ constructor(options){
        $b50dad0732e7f682$export$2dc68d50d56fbbd.prototype.__init.call(this);
        this.options = {
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true,
            ...options
        };
    }
    /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */ setupOnce() {
        if (this.options.console) (0, $js14m.addInstrumentationHandler)("console", $b50dad0732e7f682$var$_consoleBreadcrumb);
        if (this.options.dom) (0, $js14m.addInstrumentationHandler)("dom", $b50dad0732e7f682$var$_domBreadcrumb(this.options.dom));
        if (this.options.xhr) (0, $js14m.addInstrumentationHandler)("xhr", $b50dad0732e7f682$var$_xhrBreadcrumb);
        if (this.options.fetch) (0, $js14m.addInstrumentationHandler)("fetch", $b50dad0732e7f682$var$_fetchBreadcrumb);
        if (this.options.history) (0, $js14m.addInstrumentationHandler)("history", $b50dad0732e7f682$var$_historyBreadcrumb);
    }
}
$b50dad0732e7f682$export$2dc68d50d56fbbd.__initStatic();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $b50dad0732e7f682$var$_domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
        let target;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $ibKgU.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $ibKgU.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        (0, $8x56E.getCurrentHub)().addBreadcrumb({
            category: `ui.${handlerData.name}`,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ function $b50dad0732e7f682$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: "console",
        data: {
            arguments: handlerData.args,
            logger: "console"
        },
        level: (0, $7f06244a5e0d22e8$export$d771ef054122c30a)(handlerData.level),
        message: (0, $91U3U.safeJoin)(handlerData.args, " ")
    };
    if (handlerData.level === "assert") {
        if (handlerData.args[0] === false) {
            breadcrumb.message = `Assertion failed: ${(0, $91U3U.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $8x56E.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $b50dad0732e7f682$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        const { method: method, url: url, status_code: status_code, body: body } = handlerData.xhr.__sentry_xhr__ || {};
        (0, $8x56E.getCurrentHub)().addBreadcrumb({
            category: "xhr",
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: "http"
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $b50dad0732e7f682$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $8x56E.getCurrentHub)().addBreadcrumb({
        category: "fetch",
        data: handlerData.fetchData,
        level: "error",
        type: "http"
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $8x56E.getCurrentHub)().addBreadcrumb({
        category: "fetch",
        data: {
            ...handlerData.fetchData,
            status_code: handlerData.response.status
        },
        type: "http"
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ function $b50dad0732e7f682$var$_historyBreadcrumb(handlerData) {
    var global = (0, $42ap3.getGlobalObject)();
    let from = handlerData.from;
    let to = handlerData.to;
    var parsedLoc = (0, $25257edadcf16f49$export$7a5253c0f62e0150)(global.location.href);
    let parsedFrom = (0, $25257edadcf16f49$export$7a5253c0f62e0150)(from);
    var parsedTo = (0, $25257edadcf16f49$export$7a5253c0f62e0150)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $8x56E.getCurrentHub)().addBreadcrumb({
        category: "navigation",
        data: {
            from: from,
            to: to
        }
    });
}



var $42ap3 = parcelRequire("42ap3");
var $esO9h = parcelRequire("esO9h");
var $4g0Ct = parcelRequire("4g0Ct");
var $7d25350de9c66b8e$var$global = (0, $42ap3.getGlobalObject)();
let $7d25350de9c66b8e$var$cachedFetchImpl;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * var f = window.fetch;
 * window.fetch = function () {
 *   var p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $7d25350de9c66b8e$export$8be2119ce08e3379() {
    if ($7d25350de9c66b8e$var$cachedFetchImpl) return $7d25350de9c66b8e$var$cachedFetchImpl;
    // Fast path to avoid DOM I/O
    if ((0, $esO9h.isNativeFetch)($7d25350de9c66b8e$var$global.fetch)) return $7d25350de9c66b8e$var$cachedFetchImpl = $7d25350de9c66b8e$var$global.fetch.bind($7d25350de9c66b8e$var$global);
    var document = $7d25350de9c66b8e$var$global.document;
    let fetchImpl = $7d25350de9c66b8e$var$global.fetch;
    if (document && typeof document.createElement === "function") try {
        var sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $7d25350de9c66b8e$var$cachedFetchImpl = fetchImpl.bind($7d25350de9c66b8e$var$global);
}
/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */ function $7d25350de9c66b8e$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($7d25350de9c66b8e$var$global && $7d25350de9c66b8e$var$global.navigator) === "[object Navigator]";
    var hasSendBeacon = isRealNavigator && typeof $7d25350de9c66b8e$var$global.navigator.sendBeacon === "function";
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $7d25350de9c66b8e$var$global.navigator.sendBeacon.bind($7d25350de9c66b8e$var$global.navigator);
        sendBeacon(url, body);
    } else if ((0, $esO9h.supportsFetch)()) {
        var fetch = $7d25350de9c66b8e$export$8be2119ce08e3379();
        fetch(url, {
            body: body,
            method: "POST",
            credentials: "omit",
            keepalive: true
        }).then(null, (error)=>{
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error(error);
        });
    }
}


var $c55795097f9daeb0$var$globalObject = (0, $42ap3.getGlobalObject)();
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $c55795097f9daeb0$export$1df9218a526d318d extends (0, $5d4a5f71b683f78e$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: "sentry.javascript.browser",
            packages: [
                {
                    name: "npm:@sentry/browser",
                    version: (0, $725570364ca356d5$export$31499a9cd224b78c)
                }
            ],
            version: (0, $725570364ca356d5$export$31499a9cd224b78c)
        };
        super(options);
        if (options.sendClientReports && $c55795097f9daeb0$var$globalObject.document) $c55795097f9daeb0$var$globalObject.document.addEventListener("visibilitychange", ()=>{
            if ($c55795097f9daeb0$var$globalObject.document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $230372ac01587541$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $230372ac01587541$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint) {
        // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
        // activated its `sentry` option.
        // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
        // bundles, if it is not used by the SDK.
        // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
        // way for now.
        var breadcrumbIntegration = this.getIntegrationById((0, $b50dad0732e7f682$export$6d0f6df16bece7bf));
        if (breadcrumbIntegration && // We check for definedness of `options`, even though it is not strictly necessary, because that access to
        // `.sentry` below does not throw, in case users provided their own integration with id "Breadcrumbs" that does
        // not have an`options` field
        breadcrumbIntegration.options && breadcrumbIntegration.options.sentry) (0, $8x56E.getCurrentHub)().addBreadcrumb({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $b1E2c.getEventDescription)(event)
        }, {
            event: event
        });
        super.sendEvent(event, hint);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        var outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("Sending outcomes:", outcomes);
        var url = (0, $d91612272370ed71$export$9964600bfe84e6a3)(this._dsn, this._options);
        var envelope = (0, $d90c5d9ac5d72442$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $f7133678d936cd5e$export$44d472fbb931a776)(this._dsn));
        try {
            (0, $7d25350de9c66b8e$export$84bb63b2c17ec44d)(url, (0, $2cae643f899492f0$export$32f9b428425aac85)(envelope));
        } catch (e) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error(e);
        }
    }
}



var $8x56E = parcelRequire("8x56E");
// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */ function $9b3452bcc13daa20$export$f5282963edea4a68(exception, captureContext) {
    return (0, $8x56E.getCurrentHub)().captureException(exception, {
        captureContext: captureContext
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ function $9b3452bcc13daa20$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === "string" ? captureContext : undefined;
    var context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $8x56E.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ function $9b3452bcc13daa20$export$1462b974fdcf6ba2(event, hint) {
    return (0, $8x56E.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ function $9b3452bcc13daa20$export$99d44f04437e9cb8(callback) {
    (0, $8x56E.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $9b3452bcc13daa20$export$efda9a273d7a036d(breadcrumb) {
    (0, $8x56E.getCurrentHub)().addBreadcrumb(breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $9b3452bcc13daa20$export$2f04de43fe27971a(name, context) {
    (0, $8x56E.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $9b3452bcc13daa20$export$bb4922da0dd51b92(extras) {
    (0, $8x56E.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $9b3452bcc13daa20$export$8e8e7789d42ed61d(key, extra) {
    (0, $8x56E.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $9b3452bcc13daa20$export$74a8fb34822092e6(tags) {
    (0, $8x56E.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $9b3452bcc13daa20$export$a37d07ee78eb4569(key, value) {
    (0, $8x56E.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $9b3452bcc13daa20$export$8b6bb3dd62a01be2(user) {
    (0, $8x56E.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ function $9b3452bcc13daa20$export$ec58d9285c204497(callback) {
    (0, $8x56E.getCurrentHub)().withScope(callback);
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ function $9b3452bcc13daa20$export$e262da7ae6480481(context, customSamplingContext) {
    return (0, $8x56E.getCurrentHub)().startTransaction({
        metadata: {
            source: "custom"
        },
        ...context
    }, customSamplingContext);
}



var $b1E2c = parcelRequire("b1E2c");
var $jL8lq = parcelRequire("jL8lq");
let $4e817323ced6d78c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $4e817323ced6d78c$export$b79738ab10c590b2() {
    return $4e817323ced6d78c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $4e817323ced6d78c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $4e817323ced6d78c$var$ignoreOnError += 1;
    setTimeout(()=>{
        $4e817323ced6d78c$var$ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $4e817323ced6d78c$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $jL8lq.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            var wrappedArguments = args.map((arg)=>$4e817323ced6d78c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $4e817323ced6d78c$export$1265a142ff5ba165();
            (0, $9b3452bcc13daa20$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $b1E2c.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $b1E2c.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $9b3452bcc13daa20$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {}
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $jL8lq.markFunctionWrapped)(sentryWrapped, fn);
    (0, $jL8lq.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch (_oO) {}
    return sentryWrapped;
}




var $16dZf = parcelRequire("16dZf");
// global reference to slice
var $6fa852429033a8df$var$UNKNOWN_FUNCTION = "?";
var $6fa852429033a8df$var$OPERA10_PRIORITY = 10;
var $6fa852429033a8df$var$OPERA11_PRIORITY = 20;
var $6fa852429033a8df$var$CHROME_PRIORITY = 30;
var $6fa852429033a8df$var$WINJS_PRIORITY = 40;
var $6fa852429033a8df$var$GECKO_PRIORITY = 50;
function $6fa852429033a8df$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $6fa852429033a8df$var$chromeRegex = /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $6fa852429033a8df$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $6fa852429033a8df$var$chrome = (line)=>{
    var parts = $6fa852429033a8df$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            var subMatch = $6fa852429033a8df$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, parts[2]);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $6fa852429033a8df$export$263a749fff749872 = [
    $6fa852429033a8df$var$CHROME_PRIORITY,
    $6fa852429033a8df$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $6fa852429033a8df$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $6fa852429033a8df$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $6fa852429033a8df$var$gecko = (line)=>{
    var parts = $6fa852429033a8df$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            var subMatch = $6fa852429033a8df$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION;
        [func, filename] = $6fa852429033a8df$var$extractSafariExtensionDetails(func, filename);
        return $6fa852429033a8df$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $6fa852429033a8df$export$cdba47a5dd2804d = [
    $6fa852429033a8df$var$GECKO_PRIORITY,
    $6fa852429033a8df$var$gecko
];
var $6fa852429033a8df$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $6fa852429033a8df$var$winjs = (line)=>{
    var parts = $6fa852429033a8df$var$winjsRegex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[1] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $6fa852429033a8df$export$179460296da408e8 = [
    $6fa852429033a8df$var$WINJS_PRIORITY,
    $6fa852429033a8df$var$winjs
];
var $6fa852429033a8df$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $6fa852429033a8df$var$opera10 = (line)=>{
    var parts = $6fa852429033a8df$var$opera10Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[2], parts[3] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $6fa852429033a8df$export$f892b52c880ffc7a = [
    $6fa852429033a8df$var$OPERA10_PRIORITY,
    $6fa852429033a8df$var$opera10
];
var $6fa852429033a8df$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $6fa852429033a8df$var$opera11 = (line)=>{
    var parts = $6fa852429033a8df$var$opera11Regex.exec(line);
    return parts ? $6fa852429033a8df$var$createFrame(parts[5], parts[3] || parts[4] || $6fa852429033a8df$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $6fa852429033a8df$export$af11af13f09fb0dc = [
    $6fa852429033a8df$var$OPERA11_PRIORITY,
    $6fa852429033a8df$var$opera11
];
var $6fa852429033a8df$export$7197c0fe6554c079 = [
    $6fa852429033a8df$export$263a749fff749872,
    $6fa852429033a8df$export$cdba47a5dd2804d,
    $6fa852429033a8df$export$179460296da408e8
];
var $6fa852429033a8df$export$2b2b997d81bf3907 = (0, $16dZf.createStackParser)(...$6fa852429033a8df$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $6fa852429033a8df$var$extractSafariExtensionDetails = (func, filename)=>{
    var isSafariExtension = func.indexOf("safari-extension") !== -1;
    var isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $6fa852429033a8df$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




var $jL8lq = parcelRequire("jL8lq");
var $16dZf = parcelRequire("16dZf");
var $42ap3 = parcelRequire("42ap3");

var $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ class $f8ac3caec1ed9186$export$f1a018517668e6d3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "TryCatch";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $f8ac3caec1ed9186$export$f1a018517668e6d3.id;
    }
    /** JSDoc */ /**
   * @inheritDoc
   */ constructor(options){
        $f8ac3caec1ed9186$export$f1a018517668e6d3.prototype.__init.call(this);
        this._options = {
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true,
            ...options
        };
    }
    /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */ setupOnce() {
        var global = (0, $42ap3.getGlobalObject)();
        if (this._options.setTimeout) (0, $jL8lq.fill)(global, "setTimeout", $f8ac3caec1ed9186$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $jL8lq.fill)(global, "setInterval", $f8ac3caec1ed9186$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $jL8lq.fill)(global, "requestAnimationFrame", $f8ac3caec1ed9186$var$_wrapRAF);
        if (this._options.XMLHttpRequest && "XMLHttpRequest" in global) (0, $jL8lq.fill)(XMLHttpRequest.prototype, "send", $f8ac3caec1ed9186$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $f8ac3caec1ed9186$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($f8ac3caec1ed9186$var$_wrapEventTarget);
        }
    }
}
$f8ac3caec1ed9186$export$f1a018517668e6d3.__initStatic();
/** JSDoc */ function $f8ac3caec1ed9186$var$_wrapTimeFunction(original) {
    return function(...args) {
        var originalCallback = args[0];
        args[0] = (0, $4e817323ced6d78c$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $16dZf.getFunctionName)(original)
                },
                handled: true,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ function $f8ac3caec1ed9186$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $4e817323ced6d78c$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $16dZf.getFunctionName)(original)
                    },
                    handled: true,
                    type: "instrument"
                }
            })
        ]);
    };
}
/** JSDoc */ function $f8ac3caec1ed9186$var$_wrapXHR(originalSend) {
    return function(...args) {
        var xhr = this;
        var xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $jL8lq.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $16dZf.getFunctionName)(original)
                        },
                        handled: true,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $jL8lq.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $16dZf.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $4e817323ced6d78c$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $f8ac3caec1ed9186$var$_wrapEventTarget(target) {
    var global = (0, $42ap3.getGlobalObject)();
    var proto = global[target] && global[target].prototype;
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $jL8lq.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                fn.handleEvent = (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $16dZf.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $16dZf.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $jL8lq.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}




var $8x56E = parcelRequire("8x56E");

var $b1E2c = parcelRequire("b1E2c");
var $js14m = parcelRequire("js14m");
var $ibKgU = parcelRequire("ibKgU");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");


/** Global handlers */ class $9d72a78ef45a7c39$export$204155decbc90e5a {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "GlobalHandlers";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $9d72a78ef45a7c39$export$204155decbc90e5a.id;
    }
    /** JSDoc */ /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */ __init2() {
        this._installFunc = {
            onerror: $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler
        };
    }
    /** JSDoc */ constructor(options){
        $9d72a78ef45a7c39$export$204155decbc90e5a.prototype.__init.call(this);
        $9d72a78ef45a7c39$export$204155decbc90e5a.prototype.__init2.call(this);
        this._options = {
            onerror: true,
            onunhandledrejection: true,
            ...options
        };
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $9d72a78ef45a7c39$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    }
}
$9d72a78ef45a7c39$export$204155decbc90e5a.__initStatic();
/** JSDoc */ function $9d72a78ef45a7c39$var$_installGlobalOnErrorHandler() {
    (0, $js14m.addInstrumentationHandler)("error", (data)=>{
        const [hub, stackParser, attachStacktrace] = $9d72a78ef45a7c39$var$getHubAndOptions();
        if (!hub.getIntegration($9d72a78ef45a7c39$export$204155decbc90e5a)) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        if ((0, $4e817323ced6d78c$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $2zW56.isString)(msg) ? $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) : $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame((0, $230372ac01587541$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        $9d72a78ef45a7c39$var$addMechanismAndCapture(hub, error, event, "onerror");
    });
}
/** JSDoc */ function $9d72a78ef45a7c39$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $js14m.addInstrumentationHandler)("unhandledrejection", (e)=>{
        const [hub, stackParser, attachStacktrace] = $9d72a78ef45a7c39$var$getHubAndOptions();
        if (!hub.getIntegration($9d72a78ef45a7c39$export$204155decbc90e5a)) return;
        let error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ("reason" in e) error = e.reason;
            else if ("detail" in e && "reason" in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $4e817323ced6d78c$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return true;
        var event = (0, $2zW56.isPrimitive)(error) ? $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(error) : (0, $230372ac01587541$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        $9d72a78ef45a7c39$var$addMechanismAndCapture(hub, error, event, "onunhandledrejection");
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9d72a78ef45a7c39$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ function $9d72a78ef45a7c39$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $2zW56.isErrorEvent)(msg) ? msg.message : msg;
    let name = "Error";
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ function $9d72a78ef45a7c39$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $2zW56.isString)(url) && url.length > 0 ? url : (0, $ibKgU.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $9d72a78ef45a7c39$var$globalHandlerLog(type) {
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`Global Handler attached: ${type}`);
}
function $9d72a78ef45a7c39$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $b1E2c.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $9d72a78ef45a7c39$var$getHubAndOptions() {
    var hub = (0, $8x56E.getCurrentHub)();
    var client = hub.getClient();
    var options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return [
        hub,
        options.stackParser,
        options.attachStacktrace
    ];
}



var $NU9Qs = parcelRequire("NU9Qs");
var $8x56E = parcelRequire("8x56E");

var $2zW56 = parcelRequire("2zW56");

var $732232d08e00e18c$var$DEFAULT_KEY = "cause";
var $732232d08e00e18c$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ class $732232d08e00e18c$export$8d1e60aaf616fb4f {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "LinkedErrors";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $732232d08e00e18c$export$8d1e60aaf616fb4f.id;
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        $732232d08e00e18c$export$8d1e60aaf616fb4f.prototype.__init.call(this);
        this._key = options.key || $732232d08e00e18c$var$DEFAULT_KEY;
        this._limit = options.limit || $732232d08e00e18c$var$DEFAULT_LIMIT;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        var client = (0, $8x56E.getCurrentHub)().getClient();
        if (!client) return;
        (0, $NU9Qs.addGlobalEventProcessor)((event, hint)=>{
            var self = (0, $8x56E.getCurrentHub)().getIntegration($732232d08e00e18c$export$8d1e60aaf616fb4f);
            return self ? $732232d08e00e18c$export$7bd713d0612d8839(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
        });
    }
}
$732232d08e00e18c$export$8d1e60aaf616fb4f.__initStatic();
/**
 * @inheritDoc
 */ function $732232d08e00e18c$export$7bd713d0612d8839(parser, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $2zW56.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $732232d08e00e18c$export$e4e3ecf6f8f76c75(parser, limit, hint.originalException, key);
    event.exception.values = [
        ...linkedErrors,
        ...event.exception.values
    ];
    return event;
}
/**
 * JSDOC
 */ function $732232d08e00e18c$export$e4e3ecf6f8f76c75(parser, limit, error, key, stack = []) {
    if (!(0, $2zW56.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $230372ac01587541$export$a6c2d27607295951)(parser, error[key]);
    return $732232d08e00e18c$export$e4e3ecf6f8f76c75(parser, limit, error[key], key, [
        exception,
        ...stack
    ]);
}



var $4g0Ct = parcelRequire("4g0Ct");
/** Deduplication filter */ class $893f0ce260470ef7$export$688d98c249d31ad3 {
    constructor(){
        $893f0ce260470ef7$export$688d98c249d31ad3.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Dedupe";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $893f0ce260470ef7$export$688d98c249d31ad3.id;
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        var eventProcessor = (currentEvent)=>{
            var self = getCurrentHub().getIntegration($893f0ce260470ef7$export$688d98c249d31ad3);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($893f0ce260470ef7$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        };
        eventProcessor.id = this.name;
        addGlobalEventProcessor(eventProcessor);
    }
}
$893f0ce260470ef7$export$688d98c249d31ad3.__initStatic();
/** JSDoc */ function $893f0ce260470ef7$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $893f0ce260470ef7$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $893f0ce260470ef7$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $893f0ce260470ef7$var$_getExceptionFromEvent(previousEvent);
    var currentException = $893f0ce260470ef7$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $893f0ce260470ef7$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $893f0ce260470ef7$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $893f0ce260470ef7$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $893f0ce260470ef7$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $893f0ce260470ef7$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $893f0ce260470ef7$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



var $NU9Qs = parcelRequire("NU9Qs");
var $8x56E = parcelRequire("8x56E");

var $42ap3 = parcelRequire("42ap3");
var $a609b75c449d57c1$var$global = (0, $42ap3.getGlobalObject)();
/** HttpContext integration collects information about HTTP request headers */ class $a609b75c449d57c1$export$5d2ee9a544b09a94 {
    constructor(){
        $a609b75c449d57c1$export$5d2ee9a544b09a94.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "HttpContext";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $a609b75c449d57c1$export$5d2ee9a544b09a94.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        (0, $NU9Qs.addGlobalEventProcessor)((event)=>{
            if ((0, $8x56E.getCurrentHub)().getIntegration($a609b75c449d57c1$export$5d2ee9a544b09a94)) {
                // if none of the information we want exists, don't bother
                if (!$a609b75c449d57c1$var$global.navigator && !$a609b75c449d57c1$var$global.location && !$a609b75c449d57c1$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $a609b75c449d57c1$var$global.location && $a609b75c449d57c1$var$global.location.href;
                const { referrer: referrer } = $a609b75c449d57c1$var$global.document || {};
                const { userAgent: userAgent } = $a609b75c449d57c1$var$global.navigator || {};
                var headers = {
                    ...event.request && event.request.headers,
                    ...referrer && {
                        Referer: referrer
                    },
                    ...userAgent && {
                        "User-Agent": userAgent
                    }
                };
                var request = {
                    ...url && {
                        url: url
                    },
                    headers: headers
                };
                return {
                    ...event,
                    request: request
                };
            }
            return event;
        });
    }
}
$a609b75c449d57c1$export$5d2ee9a544b09a94.__initStatic();


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
var $e02662e4aa308398$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $e02662e4aa308398$export$615352e17ed7741(header, now = Date.now()) {
    var headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $e02662e4aa308398$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that given category is disabled until for rate limiting
 */ function $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $e02662e4aa308398$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $e02662e4aa308398$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */ function $e02662e4aa308398$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    var updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    var retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (var limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories] = limit.split(":", 2);
        var headerDelay = parseInt(retryAfter, 10);
        var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (var category of categories.split(";"))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $e02662e4aa308398$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


var $4g0Ct = parcelRequire("4g0Ct");

var $j3a3y = parcelRequire("j3a3y");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $e21a1e6dd57da767$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $j3a3y.rejectedSyncPromise)(new (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)("Not adding Promise due to buffer limit reached."));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $j3a3y.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


var $j3a3y = parcelRequire("j3a3y");
var $551fd97e865f07d3$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $551fd97e865f07d3$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $e21a1e6dd57da767$export$85a4f67f852183e6)(options.bufferSize || $551fd97e865f07d3$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    var flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        var filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $2cae643f899492f0$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            var envelopeItemDataCategory = (0, $2cae643f899492f0$export$b11169581eeaf237)(type);
            if ((0, $e02662e4aa308398$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $j3a3y.resolvedSyncPromise)();
        var filteredEnvelope = (0, $2cae643f899492f0$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        var recordEnvelopeLoss = (reason)=>{
            (0, $2cae643f899492f0$export$c56c55acf0136fd3)(filteredEnvelope, (_, type)=>{
                options.recordDroppedEvent(reason, (0, $2cae643f899492f0$export$b11169581eeaf237)(type));
            });
        };
        var requestTask = ()=>makeRequest({
                body: (0, $2cae643f899492f0$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $e02662e4aa308398$export$699aff705e0d49d4)(rateLimits, response);
            }, (error)=>{
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error("Failed while sending event:", error);
                recordEnvelopeLoss("network_error");
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $890c53ca2f6b4a7a$export$5949942ba2a7c0e2)) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error("Skipped sending event due to full buffer");
                recordEnvelopeLoss("queue_overflow");
                return (0, $j3a3y.resolvedSyncPromise)();
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9237c8bb75383bbf$export$b2311068c46d7cc8(options, nativeFetch = (0, $7d25350de9c66b8e$export$8be2119ce08e3379)()) {
    function makeRequest(request) {
        var requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            ...options.fetchOptions
        };
        return nativeFetch(options.url, requestOptions).then((response)=>({
                statusCode: response.status,
                headers: {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                }
            }));
    }
    return (0, $551fd97e865f07d3$export$d09f50d9ab7f7b69)(options, makeRequest);
}




var $j3a3y = parcelRequire("j3a3y");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $8be23756f879b8e4$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $8be23756f879b8e4$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
            var xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $8be23756f879b8e4$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $551fd97e865f07d3$export$d09f50d9ab7f7b69)(options, makeRequest);
}


var $4c87801c815e53f1$export$5ef831fccfce35e5 = [
    new (0, $d410fde205ba0588$exports).InboundFilters(),
    new (0, $d410fde205ba0588$exports).FunctionToString(),
    new (0, $f8ac3caec1ed9186$export$f1a018517668e6d3)(),
    new (0, $b50dad0732e7f682$export$2dc68d50d56fbbd)(),
    new (0, $9d72a78ef45a7c39$export$204155decbc90e5a)(),
    new (0, $732232d08e00e18c$export$8d1e60aaf616fb4f)(),
    new (0, $893f0ce260470ef7$export$688d98c249d31ad3)(),
    new (0, $a609b75c449d57c1$export$5d2ee9a544b09a94)()
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $4c87801c815e53f1$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $4c87801c815e53f1$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window = (0, $42ap3.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window.SENTRY_RELEASE && window.SENTRY_RELEASE.id) options.release = window.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    var clientOptions = {
        ...options,
        stackParser: (0, $16dZf.stackParserFromStackParserOptions)(options.stackParser || (0, $6fa852429033a8df$export$2b2b997d81bf3907)),
        integrations: (0, $51cfcbefde61ff20$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $esO9h.supportsFetch)() ? (0, $9237c8bb75383bbf$export$b2311068c46d7cc8) : (0, $8be23756f879b8e4$export$5e1441cee30d5a39))
    };
    (0, $93002778f3923c52$export$5333c3f1c58d9bc1)((0, $c55795097f9daeb0$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $4c87801c815e53f1$var$startSessionTracking();
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $4c87801c815e53f1$export$3a8fd680da42627b(options = {}, hub = (0, $8x56E.getCurrentHub)()) {
    // doesn't work without a document (React Native)
    var global = (0, $42ap3.getGlobalObject)();
    if (!global.document) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    const { client: client, scope: scope } = hub.getStackTop();
    var dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) options.eventId = hub.lastEventId();
    var script = global.document.createElement("script");
    script.async = true;
    script.src = (0, $d91612272370ed71$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    var injectionPoint = global.document.head || global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $4c87801c815e53f1$export$5d4e9fd7fac8e617() {
    return (0, $8x56E.getCurrentHub)().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4c87801c815e53f1$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $4c87801c815e53f1$export$4909b86c8034bf73(timeout) {
    var client = (0, $8x56E.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Cannot flush events. No client defined.");
    return (0, $j3a3y.resolvedSyncPromise)(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $4c87801c815e53f1$export$8360e631d277ea4d(timeout) {
    var client = (0, $8x56E.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return (0, $j3a3y.resolvedSyncPromise)(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ function $4c87801c815e53f1$export$4997ffc0176396a6(fn) {
    return (0, $4e817323ced6d78c$export$4997ffc0176396a6)(fn)();
}
function $4c87801c815e53f1$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4c87801c815e53f1$var$startSessionTracking() {
    var window = (0, $42ap3.getGlobalObject)();
    var document = window.document;
    if (typeof document === "undefined") {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    var hub = (0, $8x56E.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $4c87801c815e53f1$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $js14m.addInstrumentationHandler)("history", ({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $4c87801c815e53f1$var$startSessionOnHub((0, $8x56E.getCurrentHub)());
    });
}


/**
 * Inits the React SDK
 */ function $795a7664e1a3c052$export$2cd8252107eb640b(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
        name: "sentry.javascript.react",
        packages: [
            {
                name: "npm:@sentry/react",
                version: (0, $725570364ca356d5$export$31499a9cd224b78c)
            }
        ],
        version: (0, $725570364ca356d5$export$31499a9cd224b78c)
    };
    (0, $4c87801c815e53f1$export$2cd8252107eb640b)(options);
}



var $b0Nlg = parcelRequire("b0Nlg");







var $46f5220cb64aa700$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $46f5220cb64aa700$export$8e9a29865c0a1226(traceparent) {
    var matches = traceparent.match($46f5220cb64aa700$export$394a210812ba3012);
    if (matches) {
        let parentSampled;
        if (matches[3] === "1") parentSampled = true;
        else if (matches[3] === "0") parentSampled = false;
        return {
            traceId: matches[1],
            parentSampled: parentSampled,
            parentSpanId: matches[2]
        };
    }
    return undefined;
}


var $42ap3 = parcelRequire("42ap3");
var $4g0Ct = parcelRequire("4g0Ct");
var $dzA7g = parcelRequire("dzA7g");

var $b0Nlg = parcelRequire("b0Nlg");

var $7pcHN = parcelRequire("7pcHN");


var $42ap3 = parcelRequire("42ap3");
var $4g0Ct = parcelRequire("4g0Ct");

var $iwSqi = parcelRequire("iwSqi");
var $1bdfc504500d5bf8$var$global = (0, $42ap3.getGlobalObject)();
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $1bdfc504500d5bf8$export$6f18f55521af71a1() {
    if ($1bdfc504500d5bf8$var$global && $1bdfc504500d5bf8$var$global.document) $1bdfc504500d5bf8$var$global.document.addEventListener("visibilitychange", ()=>{
        var activeTransaction = (0, $iwSqi.getActiveTransaction)();
        if ($1bdfc504500d5bf8$var$global.document.hidden && activeTransaction) {
            var statusType = "cancelled";
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.finish();
        }
    });
    else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}



var $8bvs9 = parcelRequire("8bvs9");

var $cvSY8 = parcelRequire("cvSY8");
var $42ap3 = parcelRequire("42ap3");
var $ibKgU = parcelRequire("ibKgU");
var $4g0Ct = parcelRequire("4g0Ct");

var $iwSqi = parcelRequire("iwSqi");
var $f73c874baed83380$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                metric.delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (metric.delta || prevValue === undefined) {
                    prevValue = metric.value;
                    callback(metric);
                }
            }
        }
    };
};



var $8bvs9 = parcelRequire("8bvs9");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ var $5eb7264b11338139$export$407ea409d1f3b539 = ()=>{
    return `v2-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


var $229f5d3619b09815$export$3c29b44508a0612b = (name, value)=>{
    return {
        name: name,
        value: (0, $8bvs9._nullishCoalesce)(value, ()=>-1),
        delta: 0,
        entries: [],
        id: (0, $5eb7264b11338139$export$407ea409d1f3b539)()
    };
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ var $cb14aaa7d289e9ce$export$d1203567a167490e = (type, callback)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            // More extensive feature detect needed for Firefox due to:
            // https://github.com/GoogleChrome/web-vitals/issues/142
            if (type === "first-input" && !("PerformanceEventTiming" in self)) return;
            var po = new PerformanceObserver((l)=>l.getEntries().map(callback));
            po.observe({
                type: type,
                buffered: true
            });
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



var $42ap3 = parcelRequire("42ap3");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $763e21056f4ce7da$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    var onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $42ap3.getGlobalObject)().document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener("visibilitychange", onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener("pagehide", onHiddenOrPageHide, true);
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // https://wicg.github.io/layout-instability/#sec-layout-shift
var $ff1b3be6250147a9$export$fc6227831ee7c7 = (onReport, reportAllChanges)=>{
    var metric = (0, $229f5d3619b09815$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    var entryHandler = (entry)=>{
        // Only count layout shifts without recent user input.
        // TODO: Figure out why entry can be undefined
        if (entry && !entry.hadRecentInput) {
            var firstSessionEntry = sessionEntries[0];
            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
            // If the entry occurred less than 1 second after the previous entry and
            // less than 5 seconds after the first entry in the session, include the
            // entry in the current session. Otherwise, start a new session.
            if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                sessionValue += entry.value;
                sessionEntries.push(entry);
            } else {
                sessionValue = entry.value;
                sessionEntries = [
                    entry
                ];
            }
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                if (report) report();
            }
        }
    };
    var po = (0, $cb14aaa7d289e9ce$export$d1203567a167490e)("layout-shift", entryHandler);
    if (po) {
        report = (0, $f73c874baed83380$export$17679dccdd551979)(onReport, metric, reportAllChanges);
        (0, $763e21056f4ce7da$export$91ec2be6fdd8f1b4)(()=>{
            po.takeRecords().map(entryHandler);
            report(true);
        });
    }
};




var $42ap3 = parcelRequire("42ap3");

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $3572153d6a9c1fc0$var$firstHiddenTime = -1;
var $3572153d6a9c1fc0$var$initHiddenTime = ()=>{
    return (0, $42ap3.getGlobalObject)().document.visibilityState === "hidden" ? 0 : Infinity;
};
var $3572153d6a9c1fc0$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $763e21056f4ce7da$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $3572153d6a9c1fc0$var$firstHiddenTime = timeStamp;
    }, true);
};
var $3572153d6a9c1fc0$export$443f86b2c77012c4 = ()=>{
    if ($3572153d6a9c1fc0$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $3572153d6a9c1fc0$var$firstHiddenTime = $3572153d6a9c1fc0$var$initHiddenTime();
        $3572153d6a9c1fc0$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $3572153d6a9c1fc0$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $30f14c7a8c71d49e$export$134ed2977d320dfd = (onReport, reportAllChanges)=>{
    var visibilityWatcher = (0, $3572153d6a9c1fc0$export$443f86b2c77012c4)();
    var metric = (0, $229f5d3619b09815$export$3c29b44508a0612b)("FID");
    let report;
    var entryHandler = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var po = (0, $cb14aaa7d289e9ce$export$d1203567a167490e)("first-input", entryHandler);
    if (po) {
        report = (0, $f73c874baed83380$export$17679dccdd551979)(onReport, metric, reportAllChanges);
        (0, $763e21056f4ce7da$export$91ec2be6fdd8f1b4)(()=>{
            po.takeRecords().map(entryHandler);
            po.disconnect();
        }, true);
    }
};







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // https://wicg.github.io/largest-contentful-paint/#sec-largest-contentful-paint-interface
var $a3fb8e1af6467934$var$reportedMetricIDs = {};
var $a3fb8e1af6467934$export$da982ced0ff8a670 = (onReport, reportAllChanges)=>{
    var visibilityWatcher = (0, $3572153d6a9c1fc0$export$443f86b2c77012c4)();
    var metric = (0, $229f5d3619b09815$export$3c29b44508a0612b)("LCP");
    let report;
    var entryHandler = (entry)=>{
        // The startTime attribute returns the value of the renderTime if it is not 0,
        // and the value of the loadTime otherwise.
        var value = entry.startTime;
        // If the page was hidden prior to paint time of the entry,
        // ignore it and mark the metric as final, otherwise add the entry.
        if (value < visibilityWatcher.firstHiddenTime) {
            metric.value = value;
            metric.entries.push(entry);
        }
        if (report) report();
    };
    var po = (0, $cb14aaa7d289e9ce$export$d1203567a167490e)("largest-contentful-paint", entryHandler);
    if (po) {
        report = (0, $f73c874baed83380$export$17679dccdd551979)(onReport, metric, reportAllChanges);
        var stopListening = ()=>{
            if (!$a3fb8e1af6467934$var$reportedMetricIDs[metric.id]) {
                po.takeRecords().map(entryHandler);
                po.disconnect();
                $a3fb8e1af6467934$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $763e21056f4ce7da$export$91ec2be6fdd8f1b4)(stopListening, true);
    }
};



/**
 * Checks if a given value is a valid measurement value.
 */ function $4b1ecb3c5662bc64$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $4b1ecb3c5662bc64$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}


var $8c00402f7684b758$var$global = (0, $42ap3.getGlobalObject)();
function $8c00402f7684b758$var$getBrowserPerformanceAPI() {
    return $8c00402f7684b758$var$global && $8c00402f7684b758$var$global.addEventListener && $8c00402f7684b758$var$global.performance;
}
let $8c00402f7684b758$var$_performanceCursor = 0;
let $8c00402f7684b758$var$_measurements = {};
let $8c00402f7684b758$var$_lcpEntry;
let $8c00402f7684b758$var$_clsEntry;
/**
 * Start tracking web vitals
 */ function $8c00402f7684b758$export$7c69f0412d101b88(reportAllChanges = false) {
    var performance = $8c00402f7684b758$var$getBrowserPerformanceAPI();
    if (performance && (0, $cvSY8.browserPerformanceTimeOrigin)) {
        if (performance.mark) $8c00402f7684b758$var$global.performance.mark("sentry-tracing-init");
        $8c00402f7684b758$var$_trackCLS();
        $8c00402f7684b758$var$_trackLCP(reportAllChanges);
        $8c00402f7684b758$var$_trackFID();
    }
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $8c00402f7684b758$var$_trackCLS() {
    // See:
    // https://web.dev/evolving-cls/
    // https://web.dev/cls-web-tooling/
    (0, $ff1b3be6250147a9$export$fc6227831ee7c7)((metric)=>{
        var entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Measurements] Adding CLS");
        $8c00402f7684b758$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $8c00402f7684b758$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $8c00402f7684b758$var$_trackLCP(reportAllChanges) {
    (0, $a3fb8e1af6467934$export$da982ced0ff8a670)((metric)=>{
        var entry = metric.entries.pop();
        if (!entry) return;
        var timeOrigin = (0, $iwSqi.msToSec)((0, $cvSY8.browserPerformanceTimeOrigin));
        var startTime = (0, $iwSqi.msToSec)(entry.startTime);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Measurements] Adding LCP");
        $8c00402f7684b758$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $8c00402f7684b758$var$_measurements["mark.lcp"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
        $8c00402f7684b758$var$_lcpEntry = entry;
    }, reportAllChanges);
}
/** Starts tracking the First Input Delay on the current page. */ function $8c00402f7684b758$var$_trackFID() {
    (0, $30f14c7a8c71d49e$export$134ed2977d320dfd)((metric)=>{
        var entry = metric.entries.pop();
        if (!entry) return;
        var timeOrigin = (0, $iwSqi.msToSec)((0, $cvSY8.browserPerformanceTimeOrigin));
        var startTime = (0, $iwSqi.msToSec)(entry.startTime);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Measurements] Adding FID");
        $8c00402f7684b758$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $8c00402f7684b758$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
/** Add performance related spans to a transaction */ function $8c00402f7684b758$export$5f8fa6b3467a7443(transaction) {
    var performance = $8c00402f7684b758$var$getBrowserPerformanceAPI();
    if (!performance || !$8c00402f7684b758$var$global.performance.getEntries || !(0, $cvSY8.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] Adding & adjusting spans using Performance API");
    var timeOrigin = (0, $iwSqi.msToSec)((0, $cvSY8.browserPerformanceTimeOrigin));
    var performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    performanceEntries.slice($8c00402f7684b758$var$_performanceCursor).forEach((entry)=>{
        var startTime = (0, $iwSqi.msToSec)(entry.startTime);
        var duration = (0, $iwSqi.msToSec)(entry.duration);
        if (transaction.op === "navigation" && timeOrigin + startTime < transaction.startTimestamp) return;
        switch(entry.entryType){
            case "navigation":
                $8c00402f7684b758$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + (0, $iwSqi.msToSec)(entry.responseStart);
                requestStartTimestamp = timeOrigin + (0, $iwSqi.msToSec)(entry.requestStart);
                break;
            case "mark":
            case "paint":
            case "measure":
                var startTimestamp = $8c00402f7684b758$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                // capture web vitals
                var firstHidden = (0, $3572153d6a9c1fc0$export$443f86b2c77012c4)();
                // Only report if the page wasn't hidden prior to the web vital.
                var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                if (entry.name === "first-paint" && shouldRecord) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Measurements] Adding FP");
                    $8c00402f7684b758$var$_measurements["fp"] = {
                        value: entry.startTime,
                        unit: "millisecond"
                    };
                    $8c00402f7684b758$var$_measurements["mark.fp"] = {
                        value: startTimestamp,
                        unit: "second"
                    };
                }
                if (entry.name === "first-contentful-paint" && shouldRecord) {
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Measurements] Adding FCP");
                    $8c00402f7684b758$var$_measurements["fcp"] = {
                        value: entry.startTime,
                        unit: "millisecond"
                    };
                    $8c00402f7684b758$var$_measurements["mark.fcp"] = {
                        value: startTimestamp,
                        unit: "second"
                    };
                }
                break;
            case "resource":
                var resourceName = entry.name.replace($8c00402f7684b758$var$global.location.origin, "");
                $8c00402f7684b758$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin);
                break;
            default:
        }
    });
    $8c00402f7684b758$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $8c00402f7684b758$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (transaction.op === "pageload") {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === "number") {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Measurements] Adding TTFB");
            $8c00402f7684b758$var$_measurements["ttfb"] = {
                value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
                unit: "millisecond"
            };
            if (typeof requestStartTimestamp === "number" && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $8c00402f7684b758$var$_measurements["ttfb.requestTime"] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: "millisecond"
            };
        }
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$8c00402f7684b758$var$_measurements[name] || timeOrigin >= transaction.startTimestamp) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            var oldValue = $8c00402f7684b758$var$_measurements[name].value;
            var measurementTimestamp = timeOrigin + (0, $iwSqi.msToSec)(oldValue);
            // normalizedValue should be in milliseconds
            var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
            var delta = normalizedValue - oldValue;
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $8c00402f7684b758$var$_measurements[name].value = normalizedValue;
        });
        if ($8c00402f7684b758$var$_measurements["mark.fid"] && $8c00402f7684b758$var$_measurements["fid"]) // create span for FID
        (0, $4b1ecb3c5662bc64$export$8bd469e1f37aa721)(transaction, {
            description: "first input delay",
            endTimestamp: $8c00402f7684b758$var$_measurements["mark.fid"].value + (0, $iwSqi.msToSec)($8c00402f7684b758$var$_measurements["fid"].value),
            op: "web.vitals",
            startTimestamp: $8c00402f7684b758$var$_measurements["mark.fid"].value
        });
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $8c00402f7684b758$var$_measurements)) delete $8c00402f7684b758$var$_measurements.cls;
        Object.keys($8c00402f7684b758$var$_measurements).forEach((measurementName)=>{
            transaction.setMeasurement(measurementName, $8c00402f7684b758$var$_measurements[measurementName].value, $8c00402f7684b758$var$_measurements[measurementName].unit);
        });
        $8c00402f7684b758$var$_tagMetricInfo(transaction);
    }
    $8c00402f7684b758$var$_lcpEntry = undefined;
    $8c00402f7684b758$var$_clsEntry = undefined;
    $8c00402f7684b758$var$_measurements = {};
}
/** Create measure related spans */ function $8c00402f7684b758$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    (0, $4b1ecb3c5662bc64$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ function $8c00402f7684b758$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $8c00402f7684b758$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $8c00402f7684b758$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $8c00402f7684b758$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $8c00402f7684b758$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $8c00402f7684b758$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $8c00402f7684b758$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    var start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $4b1ecb3c5662bc64$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        description: (0, $8bvs9._nullishCoalesce)(description, ()=>event),
        startTimestamp: timeOrigin + (0, $iwSqi.msToSec)(start),
        endTimestamp: timeOrigin + (0, $iwSqi.msToSec)(end)
    });
}
/** Create request and response related spans */ function $8c00402f7684b758$var$_addRequest(transaction, entry, timeOrigin) {
    (0, $4b1ecb3c5662bc64$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        description: "request",
        startTimestamp: timeOrigin + (0, $iwSqi.msToSec)(entry.requestStart),
        endTimestamp: timeOrigin + (0, $iwSqi.msToSec)(entry.responseEnd)
    });
    (0, $4b1ecb3c5662bc64$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        description: "response",
        startTimestamp: timeOrigin + (0, $iwSqi.msToSec)(entry.responseStart),
        endTimestamp: timeOrigin + (0, $iwSqi.msToSec)(entry.responseEnd)
    });
}
/** Create resource-related spans */ function $8c00402f7684b758$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    var data = {};
    if ("transferSize" in entry) data["Transfer Size"] = entry.transferSize;
    if ("encodedBodySize" in entry) data["Encoded Body Size"] = entry.encodedBodySize;
    if ("decodedBodySize" in entry) data["Decoded Body Size"] = entry.decodedBodySize;
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    (0, $4b1ecb3c5662bc64$export$8bd469e1f37aa721)(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $8c00402f7684b758$var$_trackNavigator(transaction) {
    var navigator = $8c00402f7684b758$var$global.navigator;
    if (!navigator) return;
    // track network connectivity
    var connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) transaction.setTag("connectionType", connection.type);
        if ((0, $4b1ecb3c5662bc64$export$27169ccae1b439e3)(connection.rtt)) $8c00402f7684b758$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
        if ((0, $4b1ecb3c5662bc64$export$27169ccae1b439e3)(connection.downlink)) $8c00402f7684b758$var$_measurements["connection.downlink"] = {
            value: connection.downlink,
            unit: ""
        }; // unit is empty string for now, while relay doesn't support download speed units
    }
    if ((0, $4b1ecb3c5662bc64$export$27169ccae1b439e3)(navigator.deviceMemory)) transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $4b1ecb3c5662bc64$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $8c00402f7684b758$var$_tagMetricInfo(transaction) {
    if ($8c00402f7684b758$var$_lcpEntry) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($8c00402f7684b758$var$_lcpEntry.element) transaction.setTag("lcp.element", (0, $ibKgU.htmlTreeAsString)($8c00402f7684b758$var$_lcpEntry.element));
        if ($8c00402f7684b758$var$_lcpEntry.id) transaction.setTag("lcp.id", $8c00402f7684b758$var$_lcpEntry.id);
        if ($8c00402f7684b758$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag("lcp.url", $8c00402f7684b758$var$_lcpEntry.url.trim().slice(0, 200));
        transaction.setTag("lcp.size", $8c00402f7684b758$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($8c00402f7684b758$var$_clsEntry && $8c00402f7684b758$var$_clsEntry.sources) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Measurements] Adding CLS Data");
        $8c00402f7684b758$var$_clsEntry.sources.forEach((source, index)=>transaction.setTag(`cls.source.${index + 1}`, (0, $ibKgU.htmlTreeAsString)(source.node)));
    }
}



var $js14m = parcelRequire("js14m");
var $dzA7g = parcelRequire("dzA7g");
var $2zW56 = parcelRequire("2zW56");
var $91U3U = parcelRequire("91U3U");

var $iwSqi = parcelRequire("iwSqi");
var $f362657be5e96333$export$55480f254af1dbc1 = [
    "localhost",
    /^\//
];
/** Options for Request Instrumentation */ var $f362657be5e96333$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    tracingOrigins: $f362657be5e96333$export$55480f254af1dbc1
};
/** Registers span creators for xhr and fetch requests  */ function $f362657be5e96333$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest } = {
        ...$f362657be5e96333$export$cc17fb3c0bc95cd7,
        ..._options
    };
    // We should cache url -> decision so that we don't have to compute
    // regexp everytime we create a request.
    var urlMap = {};
    var defaultShouldCreateSpan = (url)=>{
        if (urlMap[url]) return urlMap[url];
        var origins = tracingOrigins;
        urlMap[url] = origins.some((origin)=>(0, $91U3U.isMatchingPattern)(url, origin)) && !(0, $91U3U.isMatchingPattern)(url, "sentry_key");
        return urlMap[url];
    };
    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
    // That's why we filter out already unwanted Spans from tracingOrigins
    let shouldCreateSpan = defaultShouldCreateSpan;
    if (typeof shouldCreateSpanForRequest === "function") shouldCreateSpan = (url)=>{
        return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
    };
    var spans = {};
    if (traceFetch) (0, $js14m.addInstrumentationHandler)("fetch", (handlerData)=>{
        $f362657be5e96333$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, spans);
    });
    if (traceXHR) (0, $js14m.addInstrumentationHandler)("xhr", (handlerData)=>{
        $f362657be5e96333$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, spans);
    });
}
/**
 * Create and track fetch request spans
 */ function $f362657be5e96333$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, spans) {
    if (!(0, $iwSqi.hasTracingEnabled)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) return;
    if (handlerData.endTimestamp) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            if (handlerData.response) // TODO (kmclb) remove this once types PR goes through
            span.setHttpStatus(handlerData.response.status);
            else if (handlerData.error) span.setStatus("internal_error");
            span.finish();
            delete spans[spanId];
        }
        return;
    }
    var activeTransaction = (0, $iwSqi.getActiveTransaction)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: {
                ...handlerData.fetchData,
                type: "fetch"
            },
            description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
            op: "http.client"
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        var request = handlerData.args[0] = handlerData.args[0];
        var options = handlerData.args[1] = handlerData.args[1] || {};
        options.headers = $f362657be5e96333$var$addTracingHeaders(request, activeTransaction.getBaggage(), span, options);
    }
}
function $f362657be5e96333$var$addTracingHeaders(request, incomingBaggage, span, options) {
    let headers = options.headers;
    if ((0, $2zW56.isInstanceOf)(request, Request)) headers = request.headers;
    if (headers) {
        if (typeof headers.append === "function") {
            headers.append("sentry-trace", span.toTraceparent());
            headers.append((0, $dzA7g.BAGGAGE_HEADER_NAME), (0, $dzA7g.mergeAndSerializeBaggage)(incomingBaggage, headers.get((0, $dzA7g.BAGGAGE_HEADER_NAME))));
        } else if (Array.isArray(headers)) {
            const [, headerBaggageString] = headers.find(([key, _])=>key === (0, $dzA7g.BAGGAGE_HEADER_NAME));
            headers = [
                ...headers,
                [
                    "sentry-trace",
                    span.toTraceparent()
                ],
                [
                    (0, $dzA7g.BAGGAGE_HEADER_NAME),
                    (0, $dzA7g.mergeAndSerializeBaggage)(incomingBaggage, headerBaggageString)
                ]
            ];
        } else headers = {
            ...headers,
            "sentry-trace": span.toTraceparent(),
            baggage: (0, $dzA7g.mergeAndSerializeBaggage)(incomingBaggage, headers.baggage)
        };
    } else headers = {
        "sentry-trace": span.toTraceparent(),
        baggage: (0, $dzA7g.mergeAndSerializeBaggage)(incomingBaggage)
    };
    return headers;
}
/**
 * Create and track xhr request spans
 */ function $f362657be5e96333$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, spans) {
    if (!(0, $iwSqi.hasTracingEnabled)() || handlerData.xhr && handlerData.xhr.__sentry_own_request__ || !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) return;
    var xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        var spanId = handlerData.xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            delete spans[spanId];
        }
        return;
    }
    // if not, create a new span to track it
    var activeTransaction = (0, $iwSqi.getActiveTransaction)();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: {
                ...xhr.data,
                type: "xhr",
                method: xhr.method,
                url: xhr.url
            },
            description: `${xhr.method} ${xhr.url}`,
            op: "http.client"
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader) try {
            handlerData.xhr.setRequestHeader("sentry-trace", span.toTraceparent());
            var headerBaggageString = handlerData.xhr.getRequestHeader && handlerData.xhr.getRequestHeader((0, $dzA7g.BAGGAGE_HEADER_NAME));
            handlerData.xhr.setRequestHeader((0, $dzA7g.BAGGAGE_HEADER_NAME), (0, $dzA7g.mergeAndSerializeBaggage)(activeTransaction.getBaggage(), headerBaggageString));
        } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
        }
    }
}



var $js14m = parcelRequire("js14m");
var $42ap3 = parcelRequire("42ap3");
var $4g0Ct = parcelRequire("4g0Ct");
var $3776fa30ee0dee8f$var$global = (0, $42ap3.getGlobalObject)();
/**
 * Default function implementing pageload and navigation transactions
 */ function $3776fa30ee0dee8f$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!$3776fa30ee0dee8f$var$global || !$3776fa30ee0dee8f$var$global.location) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = $3776fa30ee0dee8f$var$global.location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: $3776fa30ee0dee8f$var$global.location.pathname,
        op: "pageload",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $js14m.addInstrumentationHandler)("history", ({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: $3776fa30ee0dee8f$var$global.location.pathname,
                op: "navigation",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}


var $5b4a41e22e33b2f6$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ var $5b4a41e22e33b2f6$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    idleTimeout: (0, $7pcHN.DEFAULT_IDLE_TIMEOUT),
    finalTimeout: (0, $7pcHN.DEFAULT_FINAL_TIMEOUT),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $3776fa30ee0dee8f$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    ...(0, $f362657be5e96333$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ class $5b4a41e22e33b2f6$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ __init() {
        this.name = $5b4a41e22e33b2f6$export$bbd2089f30bd3708;
    }
    constructor(_options){
        $5b4a41e22e33b2f6$export$46d3bbd0375f5fa4.prototype.__init.call(this);
        let tracingOrigins = (0, $f362657be5e96333$export$cc17fb3c0bc95cd7).tracingOrigins;
        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
        if (_options) {
            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) tracingOrigins = _options.tracingOrigins;
            else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (this._emitOptionsWarning = true);
        }
        this.options = {
            ...$5b4a41e22e33b2f6$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options,
            tracingOrigins: tracingOrigins
        };
        const { _metricOptions: _metricOptions } = this.options;
        (0, $8c00402f7684b758$export$7c69f0412d101b88)(_metricOptions && _metricOptions._reportAllChanges);
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        if (this._emitOptionsWarning) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.");
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`[Tracing] We added a reasonable default for you: ${(0, $f362657be5e96333$export$cc17fb3c0bc95cd7).tracingOrigins}`);
        }
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest } = this.options;
        instrumentRouting((context)=>this._createRouteTransaction(context), startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $1bdfc504500d5bf8$export$6f18f55521af71a1)();
        (0, $f362657be5e96333$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracingOrigins: tracingOrigins,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout } = this.options;
        var parentContextFromHeader = context.op === "pageload" ? $5b4a41e22e33b2f6$export$af108ca5b537d138() : undefined;
        var expandedContext = {
            ...context,
            ...parentContextFromHeader,
            ...parentContextFromHeader && {
                metadata: {
                    ...context.metadata,
                    ...parentContextFromHeader.metadata
                }
            },
            trimEnd: true
        };
        var modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        var finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        if (finalContext.sampled === false) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        var hub = this._getCurrentHub();
        const { location: location } = (0, $42ap3.getGlobalObject)();
        var idleTransaction = (0, $b0Nlg.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        });
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            (0, $8c00402f7684b758$export$5f8fa6b3467a7443)(transaction);
            transaction.setTag("sentry_reportAllChanges", Boolean(this.options._metricOptions && this.options._metricOptions._reportAllChanges));
        });
        return idleTransaction;
    }
}
/**
 * Gets transaction context data from `sentry-trace` and `baggage` <meta> tags.
 * @returns Transaction context data or undefined neither tag exists or has valid data
 */ function $5b4a41e22e33b2f6$export$af108ca5b537d138() {
    var sentrytraceValue = $5b4a41e22e33b2f6$export$f147b32b03c9cf11("sentry-trace");
    var baggageValue = $5b4a41e22e33b2f6$export$f147b32b03c9cf11("baggage");
    var sentrytraceData = sentrytraceValue ? (0, $46f5220cb64aa700$export$8e9a29865c0a1226)(sentrytraceValue) : undefined;
    var baggage = (0, $dzA7g.parseBaggageSetMutability)(baggageValue, sentrytraceValue);
    // TODO more extensive checks for baggage validity/emptyness?
    if (sentrytraceData || baggage) return {
        ...sentrytraceData && sentrytraceData,
        ...baggage && {
            metadata: {
                baggage: baggage
            }
        }
    };
    return undefined;
}
/** Returns the value of a meta tag */ function $5b4a41e22e33b2f6$export$f147b32b03c9cf11(metaName) {
    var globalObject = (0, $42ap3.getGlobalObject)();
    // DOM/querySelector is not available in all environments
    if (globalObject.document && globalObject.document.querySelector) {
        var el = globalObject.document.querySelector(`meta[name=${metaName}]`);
        return el ? el.getAttribute("content") : null;
    } else return null;
}




// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === "undefined" || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $b0Nlg.addExtensionMethods)();


const $047acab1874804c9$export$a009cc8378589fbe = ()=>{};


$795a7664e1a3c052$export$2cd8252107eb640b({
    dsn: "https://fdcf8918ff754c49abaea4ce8fb0a3db@o1350334.ingest.sentry.io/6630105",
    integrations: [
        new (0, $5b4a41e22e33b2f6$export$46d3bbd0375f5fa4)()
    ],
    environment: "production",
    tracesSampleRate: 0.1
});
(0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cb5b9529b8ae0bf0$export$30f4dc2f64d6c9c4), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                path: "/"
            })
        ]
    })
}), document.getElementById("root"));
(0, $047acab1874804c9$export$a009cc8378589fbe)();


//# sourceMappingURL=index.30d5c9a9.js.map
